// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27%3e%3cpath fill=%27none%27 stroke=%27%2332325d%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%272%27 d=%27M2 5l6 6 6-6%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 20 20%27%3e%3cpath fill=%27none%27 stroke=%27%23ffffff%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%273%27 d=%27M6 10l3 3l6-6%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%272%27 fill=%27%23ffffff%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 20 20%27%3e%3cpath fill=%27none%27 stroke=%27%23ffffff%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%273%27 d=%27M6 10h8%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27rgba%280, 0, 0, 0.25%29%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27rgba%2850, 151, 211, 0.25%29%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27%23ffffff%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 8 8%27%3e%3cpath fill=%27%2368869a%27 d=%27M2.3 6.73L.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 12 12%27 width=%2712%27 height=%2712%27 fill=%27none%27 stroke=%27%230c4160%27%3e%3ccircle cx=%276%27 cy=%276%27 r=%274.5%27/%3e%3cpath stroke-linejoin=%27round%27 d=%27M5.8 3.6h.4L6 6.5z%27/%3e%3ccircle cx=%276%27 cy=%278.2%27 r=%27.6%27 fill=%27%230c4160%27 stroke=%27none%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("data:image/svg+xml %21default;charset=utf8,%3Csvg viewBox=%270 0 30 30%27 xmlns=%27http://www.w3.org/2000/svg%27%3E%3Cpath stroke=%27rgba%280, 0, 0, 0.5%29%27 stroke-width=%272%27 stroke-linecap=%27round%27 stroke-miterlimit=%2710%27 d=%27M4 7h22M4 15h22M4 23h22%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 30 30%27%3e%3cpath stroke=%27rgba%28255, 255, 255, 0.95%29%27 stroke-linecap=%27round%27 stroke-miterlimit=%2710%27 stroke-width=%272%27 d=%27M4 7h22M4 15h22M4 23h22%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%23000000%27%3e%3cpath d=%27M.293.293a1 1 0 011.414 0L8 6.586 14.293.293a1 1 0 111.414 1.414L9.414 8l6.293 6.293a1 1 0 01-1.414 1.414L8 9.414l-6.293 6.293a1 1 0 01-1.414-1.414L6.586 8 .293 1.707a1 1 0 010-1.414z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%23ffffff%27%3e%3cpath d=%27M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_13___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%23ffffff%27%3e%3cpath d=%27M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
var ___CSS_LOADER_URL_REPLACEMENT_13___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_13___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/*
 =========================================================
 * Black Dashboard React v1.2.0 based on Black Dashboard - v1.2.0
 =========================================================

 * Product Page: https://www.creative-tim.com/product/black-dashboard-react
 * Copyright 2023 Creative Tim (https://www.creative-tim.com)
 * Licensed under MIT (https://github.com/creativetimofficial/black-dashboard-react/blob/master/LICENSE.md)

 * Coded by Creative Tim

 =========================================================

 * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

 */
/*
\$default:       #d7e0eb !default;
\$primary:       #011e31 !default;
\$secondary:     #68869a !default;
\$success:       #0c4160 !default;
\$info:          #dad9d6 !default;
\$warning:       #68869a !default;
*/
/*
\$default:       #344675 !default;
\$primary:       #e14eca !default;
\$secondary:     #f4f5f7 !default;
\$success:       #00f2c3 !default;
\$info:          #1d8cf8 !default;
\$warning:       #ff8d72 !default;
\$danger:        #fd5d93 !default;
\$black:         #222a42 !default;*/
/*     brand Colors              */
/* navbar color */
:root {
  --bs-blue: #5e72e4;
  --bs-indigo: #5603ad;
  --bs-purple: #8965e0;
  --bs-pink: #f3a4b5;
  --bs-red: #f5365c;
  --bs-orange: #fb6340;
  --bs-yellow: #ffd600;
  --bs-green: #2dce89;
  --bs-teal: #11cdef;
  --bs-cyan: #2bffc6;
  --bs-white: #ffffff;
  --bs-gray: #6c757d;
  --bs-light: #ced4da;
  --bs-lighter: #e9ecef;
  --bs-gray-dark: #32325d;
  --bs-capri: #00BFFF;
  --bs-chinese-silver: #CCCCCC;
  --bs-ghost-white: #d7e0eb;
  --bs-tea-green: #DCF8C6;
  --bs-light-moss-green: #B2D8B2;
  --bs-lavender-blue: #C8D8FA;
  --bs-light-steel-blue: #A8B8DA;
  --bs-davy-grey: #555555;
  --bs-chinese-white: #e0e0e0;
  --bs-azure: #007bff;
  --bs-purple-pizzazz: #e14eca;
  --bs-black: #000000;
  --bs-bright-gray: #EEEEEE;
  --bs-anti-flash-white: #F0F0F0;
  --bs-slate-gray: #68869a;
  --bs-dark-gray: #AAAAAA;
  --bs-azureish-white: #d7e0eb;
  --bs-dark-charcoal: #333333;
  --bs-apple: #4CAF50;
  --bs-may-green: #45a049;
  --bs-crayola: #0056b3;
  --bs-default: #011e31;
  --bs-primary: #68869a;
  --bs-secondary: #d7e0eb;
  --bs-success: #68869a;
  --bs-info: #0c4160;
  --bs-warning: #0c4160;
  --bs-danger: #0c4160;
  --bs-white: #ffffff;
  --bs-neutral: #ffffff;
  --bs-dark: #212529;
  --bs-darker: black;
  --bs-font-sans-serif: system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", "Liberation Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
  --bs-font-monospace: SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
  --bs-gradient: linear-gradient(180deg, rgba(255, 255, 255, 0.15), rgba(255, 255, 255, 0));
}

*,
*::before,
*::after {
  box-sizing: border-box;
}

@media (prefers-reduced-motion: no-preference) {
  :root {
    scroll-behavior: smooth;
  }
}

body {
  margin: 0;
  font-family: "Poppins", sans-serif;
  font-size: 0.875rem;
  font-weight: 400;
  line-height: 1.5;
  color: #525f7f;
  background-color: #1e1e24;
  -webkit-text-size-adjust: 100%;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}

hr {
  margin: 2rem 0;
  color: inherit;
  background-color: currentColor;
  border: 0;
  opacity: 0.25;
}

hr:not([size]) {
  height: 0.0625rem;
}

h6, .h6, h5, .h5, h4, .h4, h3, .h3, h2, .h2, h1, .h1 {
  margin-top: 0;
  margin-bottom: 0.5rem;
  font-family: inherit;
  font-weight: 400;
  line-height: 1.2;
  color: #32325d;
}

h1, .h1 {
  font-size: calc(1.3312499994rem + 0.9749999925vw);
}
@media (min-width: 1200px) {
  h1, .h1 {
    font-size: 2.0624999938rem;
  }
}

h2, .h2 {
  font-size: calc(1.2937499975rem + 0.52499997vw);
}
@media (min-width: 1200px) {
  h2, .h2 {
    font-size: 1.687499975rem;
  }
}

h3, .h3 {
  font-size: calc(1.2687499875rem + 0.22499985vw);
}
@media (min-width: 1200px) {
  h3, .h3 {
    font-size: 1.437499875rem;
  }
}

h4, .h4 {
  font-size: 1.0624999875rem;
}

h5, .h5 {
  font-size: 0.812499975rem;
}

h6, .h6 {
  font-size: 0.74999995rem;
}

p {
  margin-top: 0;
  margin-bottom: 1rem;
}

abbr[title],
abbr[data-bs-original-title] {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
  cursor: help;
  -webkit-text-decoration-skip-ink: none;
          text-decoration-skip-ink: none;
}

address {
  margin-bottom: 1rem;
  font-style: normal;
  line-height: inherit;
}

ol,
ul {
  padding-left: 2rem;
}

ol,
ul,
dl {
  margin-top: 0;
  margin-bottom: 1rem;
}

ol ol,
ul ul,
ol ul,
ul ol {
  margin-bottom: 0;
}

dt {
  font-weight: 600;
}

dd {
  margin-bottom: 0.5rem;
  margin-left: 0;
}

blockquote {
  margin: 0 0 1rem;
}

b,
strong {
  font-weight: bolder;
}

small, .small {
  font-size: 80%;
}

mark, .mark {
  padding: 0.2em;
  background-color: #fcf8e3;
}

sub,
sup {
  position: relative;
  font-size: 0.75em;
  line-height: 0;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

a {
  color: #68869a;
  text-decoration: none;
}
a:hover {
  color: #495e6d;
  text-decoration: none;
}

a:not([href]):not([class]), a:not([href]):not([class]):hover {
  color: inherit;
  text-decoration: none;
}

pre,
code,
kbd,
samp {
  font-family: SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
  font-family: var(--bs-font-monospace);
  font-size: 1em;
  direction: ltr /* rtl:ignore */;
  unicode-bidi: bidi-override;
}

pre {
  display: block;
  margin-top: 0;
  margin-bottom: 1rem;
  overflow: auto;
  font-size: 80%;
}
pre code {
  font-size: inherit;
  color: inherit;
  word-break: normal;
}

code {
  font-size: 80%;
  color: #f3a4b5;
  word-wrap: break-word;
}
a > code {
  color: inherit;
}

kbd {
  padding: 0.2rem 0.4rem;
  font-size: 80%;
  color: #ffffff;
  background-color: #212529;
  border-radius: 0.2857rem;
}
kbd kbd {
  padding: 0;
  font-size: 1em;
  font-weight: 600;
}

figure {
  margin: 0 0 1rem;
}

img,
svg {
  vertical-align: middle;
}

table {
  caption-side: bottom;
  border-collapse: collapse;
}

caption {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  color: #6c757d;
  text-align: left;
}

th {
  text-align: inherit;
  text-align: -webkit-match-parent;
}

thead,
tbody,
tfoot,
tr,
td,
th {
  border-color: inherit;
  border-style: solid;
  border-width: 0;
}

label {
  display: inline-block;
}

button {
  border-radius: 0;
}

button:focus:not(:focus-visible) {
  outline: 0;
}

input,
button,
select,
optgroup,
textarea {
  margin: 0;
  font-family: inherit;
  font-size: inherit;
  line-height: inherit;
}

button,
select {
  text-transform: none;
}

[role=button] {
  cursor: pointer;
}

select {
  word-wrap: normal;
}
select:disabled {
  opacity: 1;
}

[list]::-webkit-calendar-picker-indicator {
  display: none;
}

button,
[type=button],
[type=reset],
[type=submit] {
  -webkit-appearance: button;
}
button:not(:disabled),
[type=button]:not(:disabled),
[type=reset]:not(:disabled),
[type=submit]:not(:disabled) {
  cursor: pointer;
}

::-moz-focus-inner {
  padding: 0;
  border-style: none;
}

textarea {
  resize: vertical;
}

fieldset {
  min-width: 0;
  padding: 0;
  margin: 0;
  border: 0;
}

legend {
  float: left;
  width: 100%;
  padding: 0;
  margin-bottom: 0.5rem;
  font-size: calc(1.275rem + 0.3vw);
  line-height: inherit;
}
@media (min-width: 1200px) {
  legend {
    font-size: 1.5rem;
  }
}
legend + * {
  clear: left;
}

::-webkit-datetime-edit-fields-wrapper,
::-webkit-datetime-edit-text,
::-webkit-datetime-edit-minute,
::-webkit-datetime-edit-hour-field,
::-webkit-datetime-edit-day-field,
::-webkit-datetime-edit-month-field,
::-webkit-datetime-edit-year-field {
  padding: 0;
}

::-webkit-inner-spin-button {
  height: auto;
}

[type=search] {
  outline-offset: -2px;
  -webkit-appearance: textfield;
}

/* rtl:raw:
[type="tel"],
[type="url"],
[type="email"],
[type="number"] {
  direction: ltr;
}
*/
::-webkit-search-decoration {
  -webkit-appearance: none;
}

::-webkit-color-swatch-wrapper {
  padding: 0;
}

::file-selector-button {
  font: inherit;
}

::-webkit-file-upload-button {
  font: inherit;
  -webkit-appearance: button;
}

output {
  display: inline-block;
}

iframe {
  border: 0;
}

summary {
  display: list-item;
  cursor: pointer;
}

progress {
  vertical-align: baseline;
}

[hidden] {
  display: none !important;
}

.lead {
  font-size: 0.78125rem;
  font-weight: 300;
}

.display-1 {
  font-size: calc(1.625rem + 4.5vw);
  font-weight: 300;
  line-height: 1.2;
}
@media (min-width: 1200px) {
  .display-1 {
    font-size: 5rem;
  }
}

.display-2 {
  font-size: calc(1.575rem + 3.9vw);
  font-weight: 300;
  line-height: 1.2;
}
@media (min-width: 1200px) {
  .display-2 {
    font-size: 4.5rem;
  }
}

.display-3 {
  font-size: calc(1.525rem + 3.3vw);
  font-weight: 300;
  line-height: 1.2;
}
@media (min-width: 1200px) {
  .display-3 {
    font-size: 4rem;
  }
}

.display-4 {
  font-size: calc(1.475rem + 2.7vw);
  font-weight: 300;
  line-height: 1.2;
}
@media (min-width: 1200px) {
  .display-4 {
    font-size: 3.5rem;
  }
}

.display-5 {
  font-size: calc(1.425rem + 2.1vw);
  font-weight: 300;
  line-height: 1.2;
}
@media (min-width: 1200px) {
  .display-5 {
    font-size: 3rem;
  }
}

.display-6 {
  font-size: calc(1.375rem + 1.5vw);
  font-weight: 300;
  line-height: 1.2;
}
@media (min-width: 1200px) {
  .display-6 {
    font-size: 2.5rem;
  }
}

.list-unstyled {
  padding-left: 0;
  list-style: none;
}

.list-inline {
  padding-left: 0;
  list-style: none;
}

.list-inline-item {
  display: inline-block;
}
.list-inline-item:not(:last-child) {
  margin-right: 0.5rem;
}

.initialism {
  font-size: 80%;
  text-transform: uppercase;
}

.blockquote {
  margin-bottom: 1rem;
  font-size: 0.9625rem;
}
.blockquote > :last-child {
  margin-bottom: 0;
}

.blockquote-footer {
  margin-top: -1rem;
  margin-bottom: 1rem;
  font-size: 80%;
  color: #6c757d;
}
.blockquote-footer::before {
  content: "— ";
}

.img-fluid {
  max-width: 100%;
  height: auto;
}

.img-thumbnail {
  padding: 0.25rem;
  background-color: #1e1e24;
  border: 0.0625rem solid #e3e3e3;
  border-radius: 0.25rem;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075);
  max-width: 100%;
  height: auto;
}

.figure {
  display: inline-block;
}

.figure-img {
  margin-bottom: 0.5rem;
  line-height: 1;
}

.figure-caption {
  font-size: 80%;
  color: #6c757d;
}

.row {
  --bs-gutter-x: 1.5rem;
  --bs-gutter-y: 0;
  display: flex;
  flex-wrap: wrap;
  margin-top: calc(var(--bs-gutter-y) * -1);
  margin-right: calc(var(--bs-gutter-x) * -0.5);
  margin-left: calc(var(--bs-gutter-x) * -0.5);
}
.row > * {
  flex-shrink: 0;
  width: 100%;
  max-width: 100%;
  padding-right: calc(var(--bs-gutter-x) * 0.5);
  padding-left: calc(var(--bs-gutter-x) * 0.5);
  margin-top: var(--bs-gutter-y);
}

.col {
  flex: 1 0;
}

.row-cols-auto > * {
  flex: 0 0 auto;
  width: auto;
}

.row-cols-1 > * {
  flex: 0 0 auto;
  width: 100%;
}

.row-cols-2 > * {
  flex: 0 0 auto;
  width: 50%;
}

.row-cols-3 > * {
  flex: 0 0 auto;
  width: 33.3333333333%;
}

.row-cols-4 > * {
  flex: 0 0 auto;
  width: 25%;
}

.row-cols-5 > * {
  flex: 0 0 auto;
  width: 20%;
}

.row-cols-6 > * {
  flex: 0 0 auto;
  width: 16.6666666667%;
}

@media (min-width: 576px) {
  .col-sm {
    flex: 1 0;
  }
  .row-cols-sm-auto > * {
    flex: 0 0 auto;
    width: auto;
  }
  .row-cols-sm-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }
  .row-cols-sm-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }
  .row-cols-sm-3 > * {
    flex: 0 0 auto;
    width: 33.3333333333%;
  }
  .row-cols-sm-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }
  .row-cols-sm-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }
  .row-cols-sm-6 > * {
    flex: 0 0 auto;
    width: 16.6666666667%;
  }
}
@media (min-width: 768px) {
  .col-md {
    flex: 1 0;
  }
  .row-cols-md-auto > * {
    flex: 0 0 auto;
    width: auto;
  }
  .row-cols-md-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }
  .row-cols-md-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }
  .row-cols-md-3 > * {
    flex: 0 0 auto;
    width: 33.3333333333%;
  }
  .row-cols-md-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }
  .row-cols-md-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }
  .row-cols-md-6 > * {
    flex: 0 0 auto;
    width: 16.6666666667%;
  }
}
@media (min-width: 992px) {
  .col-lg {
    flex: 1 0;
  }
  .row-cols-lg-auto > * {
    flex: 0 0 auto;
    width: auto;
  }
  .row-cols-lg-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }
  .row-cols-lg-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }
  .row-cols-lg-3 > * {
    flex: 0 0 auto;
    width: 33.3333333333%;
  }
  .row-cols-lg-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }
  .row-cols-lg-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }
  .row-cols-lg-6 > * {
    flex: 0 0 auto;
    width: 16.6666666667%;
  }
}
@media (min-width: 1200px) {
  .col-xl {
    flex: 1 0;
  }
  .row-cols-xl-auto > * {
    flex: 0 0 auto;
    width: auto;
  }
  .row-cols-xl-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }
  .row-cols-xl-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }
  .row-cols-xl-3 > * {
    flex: 0 0 auto;
    width: 33.3333333333%;
  }
  .row-cols-xl-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }
  .row-cols-xl-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }
  .row-cols-xl-6 > * {
    flex: 0 0 auto;
    width: 16.6666666667%;
  }
}
.col-auto {
  flex: 0 0 auto;
  width: auto;
}

.col-1 {
  flex: 0 0 auto;
  width: 8.33333333%;
}

.col-2 {
  flex: 0 0 auto;
  width: 16.66666667%;
}

.col-3 {
  flex: 0 0 auto;
  width: 25%;
}

.col-4 {
  flex: 0 0 auto;
  width: 33.33333333%;
}

.col-5 {
  flex: 0 0 auto;
  width: 41.66666667%;
}

.col-6 {
  flex: 0 0 auto;
  width: 50%;
}

.col-7 {
  flex: 0 0 auto;
  width: 58.33333333%;
}

.col-8 {
  flex: 0 0 auto;
  width: 66.66666667%;
}

.col-9 {
  flex: 0 0 auto;
  width: 75%;
}

.col-10 {
  flex: 0 0 auto;
  width: 83.33333333%;
}

.col-11 {
  flex: 0 0 auto;
  width: 91.66666667%;
}

.col-12 {
  flex: 0 0 auto;
  width: 100%;
}

.offset-1 {
  margin-left: 8.33333333%;
}

.offset-2 {
  margin-left: 16.66666667%;
}

.offset-3 {
  margin-left: 25%;
}

.offset-4 {
  margin-left: 33.33333333%;
}

.offset-5 {
  margin-left: 41.66666667%;
}

.offset-6 {
  margin-left: 50%;
}

.offset-7 {
  margin-left: 58.33333333%;
}

.offset-8 {
  margin-left: 66.66666667%;
}

.offset-9 {
  margin-left: 75%;
}

.offset-10 {
  margin-left: 83.33333333%;
}

.offset-11 {
  margin-left: 91.66666667%;
}

.g-0,
.gx-0 {
  --bs-gutter-x: 0;
}

.g-0,
.gy-0 {
  --bs-gutter-y: 0;
}

.g-1,
.gx-1 {
  --bs-gutter-x: 0.25rem;
}

.g-1,
.gy-1 {
  --bs-gutter-y: 0.25rem;
}

.g-2,
.gx-2 {
  --bs-gutter-x: 0.5rem;
}

.g-2,
.gy-2 {
  --bs-gutter-y: 0.5rem;
}

.g-3,
.gx-3 {
  --bs-gutter-x: 1rem;
}

.g-3,
.gy-3 {
  --bs-gutter-y: 1rem;
}

.g-4,
.gx-4 {
  --bs-gutter-x: 1.5rem;
}

.g-4,
.gy-4 {
  --bs-gutter-y: 1.5rem;
}

.g-5,
.gx-5 {
  --bs-gutter-x: 3rem;
}

.g-5,
.gy-5 {
  --bs-gutter-y: 3rem;
}

.g-sm,
.gx-sm {
  --bs-gutter-x: 2rem;
}

.g-sm,
.gy-sm {
  --bs-gutter-y: 2rem;
}

.g-md,
.gx-md {
  --bs-gutter-x: 4rem;
}

.g-md,
.gy-md {
  --bs-gutter-y: 4rem;
}

.g-lg,
.gx-lg {
  --bs-gutter-x: 6rem;
}

.g-lg,
.gy-lg {
  --bs-gutter-y: 6rem;
}

.g-xl,
.gx-xl {
  --bs-gutter-x: 8rem;
}

.g-xl,
.gy-xl {
  --bs-gutter-y: 8rem;
}

@media (min-width: 576px) {
  .col-sm-auto {
    flex: 0 0 auto;
    width: auto;
  }
  .col-sm-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }
  .col-sm-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-sm-3 {
    flex: 0 0 auto;
    width: 25%;
  }
  .col-sm-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .col-sm-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }
  .col-sm-6 {
    flex: 0 0 auto;
    width: 50%;
  }
  .col-sm-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }
  .col-sm-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }
  .col-sm-9 {
    flex: 0 0 auto;
    width: 75%;
  }
  .col-sm-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }
  .col-sm-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }
  .col-sm-12 {
    flex: 0 0 auto;
    width: 100%;
  }
  .offset-sm-0 {
    margin-left: 0;
  }
  .offset-sm-1 {
    margin-left: 8.33333333%;
  }
  .offset-sm-2 {
    margin-left: 16.66666667%;
  }
  .offset-sm-3 {
    margin-left: 25%;
  }
  .offset-sm-4 {
    margin-left: 33.33333333%;
  }
  .offset-sm-5 {
    margin-left: 41.66666667%;
  }
  .offset-sm-6 {
    margin-left: 50%;
  }
  .offset-sm-7 {
    margin-left: 58.33333333%;
  }
  .offset-sm-8 {
    margin-left: 66.66666667%;
  }
  .offset-sm-9 {
    margin-left: 75%;
  }
  .offset-sm-10 {
    margin-left: 83.33333333%;
  }
  .offset-sm-11 {
    margin-left: 91.66666667%;
  }
  .g-sm-0,
  .gx-sm-0 {
    --bs-gutter-x: 0;
  }
  .g-sm-0,
  .gy-sm-0 {
    --bs-gutter-y: 0;
  }
  .g-sm-1,
  .gx-sm-1 {
    --bs-gutter-x: 0.25rem;
  }
  .g-sm-1,
  .gy-sm-1 {
    --bs-gutter-y: 0.25rem;
  }
  .g-sm-2,
  .gx-sm-2 {
    --bs-gutter-x: 0.5rem;
  }
  .g-sm-2,
  .gy-sm-2 {
    --bs-gutter-y: 0.5rem;
  }
  .g-sm-3,
  .gx-sm-3 {
    --bs-gutter-x: 1rem;
  }
  .g-sm-3,
  .gy-sm-3 {
    --bs-gutter-y: 1rem;
  }
  .g-sm-4,
  .gx-sm-4 {
    --bs-gutter-x: 1.5rem;
  }
  .g-sm-4,
  .gy-sm-4 {
    --bs-gutter-y: 1.5rem;
  }
  .g-sm-5,
  .gx-sm-5 {
    --bs-gutter-x: 3rem;
  }
  .g-sm-5,
  .gy-sm-5 {
    --bs-gutter-y: 3rem;
  }
  .g-sm-sm,
  .gx-sm-sm {
    --bs-gutter-x: 2rem;
  }
  .g-sm-sm,
  .gy-sm-sm {
    --bs-gutter-y: 2rem;
  }
  .g-sm-md,
  .gx-sm-md {
    --bs-gutter-x: 4rem;
  }
  .g-sm-md,
  .gy-sm-md {
    --bs-gutter-y: 4rem;
  }
  .g-sm-lg,
  .gx-sm-lg {
    --bs-gutter-x: 6rem;
  }
  .g-sm-lg,
  .gy-sm-lg {
    --bs-gutter-y: 6rem;
  }
  .g-sm-xl,
  .gx-sm-xl {
    --bs-gutter-x: 8rem;
  }
  .g-sm-xl,
  .gy-sm-xl {
    --bs-gutter-y: 8rem;
  }
}
@media (min-width: 768px) {
  .col-md-auto {
    flex: 0 0 auto;
    width: auto;
  }
  .col-md-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }
  .col-md-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-md-3 {
    flex: 0 0 auto;
    width: 25%;
  }
  .col-md-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .col-md-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }
  .col-md-6 {
    flex: 0 0 auto;
    width: 50%;
  }
  .col-md-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }
  .col-md-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }
  .col-md-9 {
    flex: 0 0 auto;
    width: 75%;
  }
  .col-md-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }
  .col-md-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }
  .col-md-12 {
    flex: 0 0 auto;
    width: 100%;
  }
  .offset-md-0 {
    margin-left: 0;
  }
  .offset-md-1 {
    margin-left: 8.33333333%;
  }
  .offset-md-2 {
    margin-left: 16.66666667%;
  }
  .offset-md-3 {
    margin-left: 25%;
  }
  .offset-md-4 {
    margin-left: 33.33333333%;
  }
  .offset-md-5 {
    margin-left: 41.66666667%;
  }
  .offset-md-6 {
    margin-left: 50%;
  }
  .offset-md-7 {
    margin-left: 58.33333333%;
  }
  .offset-md-8 {
    margin-left: 66.66666667%;
  }
  .offset-md-9 {
    margin-left: 75%;
  }
  .offset-md-10 {
    margin-left: 83.33333333%;
  }
  .offset-md-11 {
    margin-left: 91.66666667%;
  }
  .g-md-0,
  .gx-md-0 {
    --bs-gutter-x: 0;
  }
  .g-md-0,
  .gy-md-0 {
    --bs-gutter-y: 0;
  }
  .g-md-1,
  .gx-md-1 {
    --bs-gutter-x: 0.25rem;
  }
  .g-md-1,
  .gy-md-1 {
    --bs-gutter-y: 0.25rem;
  }
  .g-md-2,
  .gx-md-2 {
    --bs-gutter-x: 0.5rem;
  }
  .g-md-2,
  .gy-md-2 {
    --bs-gutter-y: 0.5rem;
  }
  .g-md-3,
  .gx-md-3 {
    --bs-gutter-x: 1rem;
  }
  .g-md-3,
  .gy-md-3 {
    --bs-gutter-y: 1rem;
  }
  .g-md-4,
  .gx-md-4 {
    --bs-gutter-x: 1.5rem;
  }
  .g-md-4,
  .gy-md-4 {
    --bs-gutter-y: 1.5rem;
  }
  .g-md-5,
  .gx-md-5 {
    --bs-gutter-x: 3rem;
  }
  .g-md-5,
  .gy-md-5 {
    --bs-gutter-y: 3rem;
  }
  .g-md-sm,
  .gx-md-sm {
    --bs-gutter-x: 2rem;
  }
  .g-md-sm,
  .gy-md-sm {
    --bs-gutter-y: 2rem;
  }
  .g-md-md,
  .gx-md-md {
    --bs-gutter-x: 4rem;
  }
  .g-md-md,
  .gy-md-md {
    --bs-gutter-y: 4rem;
  }
  .g-md-lg,
  .gx-md-lg {
    --bs-gutter-x: 6rem;
  }
  .g-md-lg,
  .gy-md-lg {
    --bs-gutter-y: 6rem;
  }
  .g-md-xl,
  .gx-md-xl {
    --bs-gutter-x: 8rem;
  }
  .g-md-xl,
  .gy-md-xl {
    --bs-gutter-y: 8rem;
  }
}
@media (min-width: 992px) {
  .col-lg-auto {
    flex: 0 0 auto;
    width: auto;
  }
  .col-lg-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }
  .col-lg-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-lg-3 {
    flex: 0 0 auto;
    width: 25%;
  }
  .col-lg-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .col-lg-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }
  .col-lg-6 {
    flex: 0 0 auto;
    width: 50%;
  }
  .col-lg-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }
  .col-lg-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }
  .col-lg-9 {
    flex: 0 0 auto;
    width: 75%;
  }
  .col-lg-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }
  .col-lg-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }
  .col-lg-12 {
    flex: 0 0 auto;
    width: 100%;
  }
  .offset-lg-0 {
    margin-left: 0;
  }
  .offset-lg-1 {
    margin-left: 8.33333333%;
  }
  .offset-lg-2 {
    margin-left: 16.66666667%;
  }
  .offset-lg-3 {
    margin-left: 25%;
  }
  .offset-lg-4 {
    margin-left: 33.33333333%;
  }
  .offset-lg-5 {
    margin-left: 41.66666667%;
  }
  .offset-lg-6 {
    margin-left: 50%;
  }
  .offset-lg-7 {
    margin-left: 58.33333333%;
  }
  .offset-lg-8 {
    margin-left: 66.66666667%;
  }
  .offset-lg-9 {
    margin-left: 75%;
  }
  .offset-lg-10 {
    margin-left: 83.33333333%;
  }
  .offset-lg-11 {
    margin-left: 91.66666667%;
  }
  .g-lg-0,
  .gx-lg-0 {
    --bs-gutter-x: 0;
  }
  .g-lg-0,
  .gy-lg-0 {
    --bs-gutter-y: 0;
  }
  .g-lg-1,
  .gx-lg-1 {
    --bs-gutter-x: 0.25rem;
  }
  .g-lg-1,
  .gy-lg-1 {
    --bs-gutter-y: 0.25rem;
  }
  .g-lg-2,
  .gx-lg-2 {
    --bs-gutter-x: 0.5rem;
  }
  .g-lg-2,
  .gy-lg-2 {
    --bs-gutter-y: 0.5rem;
  }
  .g-lg-3,
  .gx-lg-3 {
    --bs-gutter-x: 1rem;
  }
  .g-lg-3,
  .gy-lg-3 {
    --bs-gutter-y: 1rem;
  }
  .g-lg-4,
  .gx-lg-4 {
    --bs-gutter-x: 1.5rem;
  }
  .g-lg-4,
  .gy-lg-4 {
    --bs-gutter-y: 1.5rem;
  }
  .g-lg-5,
  .gx-lg-5 {
    --bs-gutter-x: 3rem;
  }
  .g-lg-5,
  .gy-lg-5 {
    --bs-gutter-y: 3rem;
  }
  .g-lg-sm,
  .gx-lg-sm {
    --bs-gutter-x: 2rem;
  }
  .g-lg-sm,
  .gy-lg-sm {
    --bs-gutter-y: 2rem;
  }
  .g-lg-md,
  .gx-lg-md {
    --bs-gutter-x: 4rem;
  }
  .g-lg-md,
  .gy-lg-md {
    --bs-gutter-y: 4rem;
  }
  .g-lg-lg,
  .gx-lg-lg {
    --bs-gutter-x: 6rem;
  }
  .g-lg-lg,
  .gy-lg-lg {
    --bs-gutter-y: 6rem;
  }
  .g-lg-xl,
  .gx-lg-xl {
    --bs-gutter-x: 8rem;
  }
  .g-lg-xl,
  .gy-lg-xl {
    --bs-gutter-y: 8rem;
  }
}
@media (min-width: 1200px) {
  .col-xl-auto {
    flex: 0 0 auto;
    width: auto;
  }
  .col-xl-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }
  .col-xl-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-xl-3 {
    flex: 0 0 auto;
    width: 25%;
  }
  .col-xl-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .col-xl-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }
  .col-xl-6 {
    flex: 0 0 auto;
    width: 50%;
  }
  .col-xl-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }
  .col-xl-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }
  .col-xl-9 {
    flex: 0 0 auto;
    width: 75%;
  }
  .col-xl-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }
  .col-xl-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }
  .col-xl-12 {
    flex: 0 0 auto;
    width: 100%;
  }
  .offset-xl-0 {
    margin-left: 0;
  }
  .offset-xl-1 {
    margin-left: 8.33333333%;
  }
  .offset-xl-2 {
    margin-left: 16.66666667%;
  }
  .offset-xl-3 {
    margin-left: 25%;
  }
  .offset-xl-4 {
    margin-left: 33.33333333%;
  }
  .offset-xl-5 {
    margin-left: 41.66666667%;
  }
  .offset-xl-6 {
    margin-left: 50%;
  }
  .offset-xl-7 {
    margin-left: 58.33333333%;
  }
  .offset-xl-8 {
    margin-left: 66.66666667%;
  }
  .offset-xl-9 {
    margin-left: 75%;
  }
  .offset-xl-10 {
    margin-left: 83.33333333%;
  }
  .offset-xl-11 {
    margin-left: 91.66666667%;
  }
  .g-xl-0,
  .gx-xl-0 {
    --bs-gutter-x: 0;
  }
  .g-xl-0,
  .gy-xl-0 {
    --bs-gutter-y: 0;
  }
  .g-xl-1,
  .gx-xl-1 {
    --bs-gutter-x: 0.25rem;
  }
  .g-xl-1,
  .gy-xl-1 {
    --bs-gutter-y: 0.25rem;
  }
  .g-xl-2,
  .gx-xl-2 {
    --bs-gutter-x: 0.5rem;
  }
  .g-xl-2,
  .gy-xl-2 {
    --bs-gutter-y: 0.5rem;
  }
  .g-xl-3,
  .gx-xl-3 {
    --bs-gutter-x: 1rem;
  }
  .g-xl-3,
  .gy-xl-3 {
    --bs-gutter-y: 1rem;
  }
  .g-xl-4,
  .gx-xl-4 {
    --bs-gutter-x: 1.5rem;
  }
  .g-xl-4,
  .gy-xl-4 {
    --bs-gutter-y: 1.5rem;
  }
  .g-xl-5,
  .gx-xl-5 {
    --bs-gutter-x: 3rem;
  }
  .g-xl-5,
  .gy-xl-5 {
    --bs-gutter-y: 3rem;
  }
  .g-xl-sm,
  .gx-xl-sm {
    --bs-gutter-x: 2rem;
  }
  .g-xl-sm,
  .gy-xl-sm {
    --bs-gutter-y: 2rem;
  }
  .g-xl-md,
  .gx-xl-md {
    --bs-gutter-x: 4rem;
  }
  .g-xl-md,
  .gy-xl-md {
    --bs-gutter-y: 4rem;
  }
  .g-xl-lg,
  .gx-xl-lg {
    --bs-gutter-x: 6rem;
  }
  .g-xl-lg,
  .gy-xl-lg {
    --bs-gutter-y: 6rem;
  }
  .g-xl-xl,
  .gx-xl-xl {
    --bs-gutter-x: 8rem;
  }
  .g-xl-xl,
  .gy-xl-xl {
    --bs-gutter-y: 8rem;
  }
}
.table {
  --bs-table-bg: transparent;
  --bs-table-accent-bg: transparent;
  --bs-table-striped-color: #525f7f;
  --bs-table-striped-bg: rgba(0, 0, 0, 0.05);
  --bs-table-active-color: #525f7f;
  --bs-table-active-bg: rgba(0, 0, 0, 0.075);
  --bs-table-hover-color: #525f7f;
  --bs-table-hover-bg: rgba(0, 0, 0, 0.075);
  width: 100%;
  margin-bottom: 1rem;
  color: #525f7f;
  vertical-align: top;
  border-color: #e3e3e3;
}
.table > :not(caption) > * > * {
  padding: 0.5rem 0.5rem;
  background-color: var(--bs-table-bg);
  border-bottom-width: 0.0625rem;
  box-shadow: inset 0 0 0 9999px var(--bs-table-accent-bg);
}
.table > tbody {
  vertical-align: inherit;
}
.table > thead {
  vertical-align: bottom;
}
.table > :not(:last-child) > :last-child > * {
  border-bottom-color: currentColor;
}

.caption-top {
  caption-side: top;
}

.table-sm > :not(caption) > * > * {
  padding: 0.25rem 0.25rem;
}

.table-bordered > :not(caption) > * {
  border-width: 0.0625rem 0;
}
.table-bordered > :not(caption) > * > * {
  border-width: 0 0.0625rem;
}

.table-borderless > :not(caption) > * > * {
  border-bottom-width: 0;
}

.table-striped > tbody > tr:nth-of-type(odd) {
  --bs-table-accent-bg: var(--bs-table-striped-bg);
  color: var(--bs-table-striped-color);
}

.table-active {
  --bs-table-accent-bg: var(--bs-table-active-bg);
  color: var(--bs-table-active-color);
}

.table-hover > tbody > tr:hover {
  --bs-table-accent-bg: var(--bs-table-hover-bg);
  color: var(--bs-table-hover-color);
}

.table-primary {
  --bs-table-bg: #e1e7eb;
  --bs-table-striped-bg: #d6dbdf;
  --bs-table-striped-color: #000000;
  --bs-table-active-bg: #cbd0d4;
  --bs-table-active-color: #000000;
  --bs-table-hover-bg: #d0d6d9;
  --bs-table-hover-color: #000000;
  color: #000000;
  border-color: #cbd0d4;
}

.table-secondary {
  --bs-table-bg: #f7f9fb;
  --bs-table-striped-bg: #ebedee;
  --bs-table-striped-color: #000000;
  --bs-table-active-bg: #dee0e2;
  --bs-table-active-color: #000000;
  --bs-table-hover-bg: #e4e6e8;
  --bs-table-hover-color: #000000;
  color: #000000;
  border-color: #dee0e2;
}

.table-success {
  --bs-table-bg: #e1e7eb;
  --bs-table-striped-bg: #d6dbdf;
  --bs-table-striped-color: #000000;
  --bs-table-active-bg: #cbd0d4;
  --bs-table-active-color: #000000;
  --bs-table-hover-bg: #d0d6d9;
  --bs-table-hover-color: #000000;
  color: #000000;
  border-color: #cbd0d4;
}

.table-info {
  --bs-table-bg: #ced9df;
  --bs-table-striped-bg: #c4ced4;
  --bs-table-striped-color: #000000;
  --bs-table-active-bg: #b9c3c9;
  --bs-table-active-color: #000000;
  --bs-table-hover-bg: #bfc9ce;
  --bs-table-hover-color: #000000;
  color: #000000;
  border-color: #b9c3c9;
}

.table-warning {
  --bs-table-bg: #ced9df;
  --bs-table-striped-bg: #c4ced4;
  --bs-table-striped-color: #000000;
  --bs-table-active-bg: #b9c3c9;
  --bs-table-active-color: #000000;
  --bs-table-hover-bg: #bfc9ce;
  --bs-table-hover-color: #000000;
  color: #000000;
  border-color: #b9c3c9;
}

.table-danger {
  --bs-table-bg: #ced9df;
  --bs-table-striped-bg: #c4ced4;
  --bs-table-striped-color: #000000;
  --bs-table-active-bg: #b9c3c9;
  --bs-table-active-color: #000000;
  --bs-table-hover-bg: #bfc9ce;
  --bs-table-hover-color: #000000;
  color: #000000;
  border-color: #b9c3c9;
}

.table-light {
  --bs-table-bg: #adb5bd;
  --bs-table-striped-bg: #a4acb4;
  --bs-table-striped-color: #000000;
  --bs-table-active-bg: #9ca3aa;
  --bs-table-active-color: #000000;
  --bs-table-hover-bg: #a0a7af;
  --bs-table-hover-color: #000000;
  color: #000000;
  border-color: #9ca3aa;
}

.table-dark {
  --bs-table-bg: #212529;
  --bs-table-striped-bg: #2c3034;
  --bs-table-striped-color: #ffffff;
  --bs-table-active-bg: #373b3e;
  --bs-table-active-color: #ffffff;
  --bs-table-hover-bg: #323539;
  --bs-table-hover-color: #ffffff;
  color: #ffffff;
  border-color: #373b3e;
}

.table-responsive {
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}

@media (max-width: 575.98px) {
  .table-responsive-sm {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}
@media (max-width: 767.98px) {
  .table-responsive-md {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}
@media (max-width: 991.98px) {
  .table-responsive-lg {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}
@media (max-width: 1199.98px) {
  .table-responsive-xl {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}
.form-label {
  margin-bottom: 0.5rem;
}

.col-form-label {
  padding-top: calc(0.5rem + 1px);
  padding-bottom: calc(0.5rem + 1px);
  margin-bottom: 0;
  font-size: inherit;
  line-height: 1.428571;
}

.col-form-label-lg {
  padding-top: calc(0.875rem + 1px);
  padding-bottom: calc(0.875rem + 1px);
  font-size: 0.875rem;
}

.col-form-label-sm {
  padding-top: calc(0.25rem + 1px);
  padding-bottom: calc(0.25rem + 1px);
  font-size: 0.75rem;
}

.form-text {
  margin-top: 0.25rem;
  font-size: 80%;
  color: #6c757d;
}

.form-control {
  display: block;
  width: 100%;
  padding: 0.5rem 0.7rem;
  font-size: 0.875rem;
  font-weight: 400;
  line-height: 1.428571;
  color: rgba(255, 255, 255, 0.8);
  background-color: transparent;
  background-clip: padding-box;
  border: 1px solid #cad1d7;
  -webkit-appearance: none;
          appearance: none;
  border-radius: 0.25rem;
  box-shadow: none;
  transition: all 0.2s cubic-bezier(0.68, -0.55, 0.265, 1.55);
}
@media (prefers-reduced-motion: reduce) {
  .form-control {
    transition: none;
  }
}
.form-control[type=file] {
  overflow: hidden;
}
.form-control[type=file]:not(:disabled):not([readonly]) {
  cursor: pointer;
}
.form-control:focus {
  color: rgba(255, 255, 255, 0.8);
  background-color: #ffffff;
  border-color: rgba(50, 151, 211, 0.25);
  outline: 0;
  box-shadow: none, none;
}
.form-control::-webkit-date-and-time-value {
  height: 1.428571em;
}
.form-control::placeholder {
  color: #adb5bd;
  opacity: 1;
}
.form-control:disabled, .form-control[readonly] {
  background-color: #e9ecef;
  opacity: 1;
}
.form-control::file-selector-button {
  padding: 0.5rem 0.7rem;
  margin: -0.5rem -0.7rem;
  margin-inline-end: 0.7rem;
  color: rgba(255, 255, 255, 0.8);
  background-color: transparent;
  pointer-events: none;
  border-color: inherit;
  border-style: solid;
  border-width: 0;
  border-inline-end-width: 1px;
  border-radius: 0;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-control::file-selector-button {
    transition: none;
  }
}
.form-control:hover:not(:disabled):not([readonly])::file-selector-button {
  background-color: rgba(0, 0, 0, 0.05);
}
.form-control::-webkit-file-upload-button {
  padding: 0.5rem 0.7rem;
  margin: -0.5rem -0.7rem;
  margin-inline-end: 0.7rem;
  color: rgba(255, 255, 255, 0.8);
  background-color: transparent;
  pointer-events: none;
  border-color: inherit;
  border-style: solid;
  border-width: 0;
  border-inline-end-width: 1px;
  border-radius: 0;
  -webkit-transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-control::-webkit-file-upload-button {
    -webkit-transition: none;
    transition: none;
  }
}
.form-control:hover:not(:disabled):not([readonly])::-webkit-file-upload-button {
  background-color: rgba(0, 0, 0, 0.05);
}

.form-control-plaintext {
  display: block;
  width: 100%;
  padding: 0.5rem 0;
  margin-bottom: 0;
  line-height: 1.428571;
  color: #525f7f;
  background-color: transparent;
  border: solid transparent;
  border-width: 1px 0;
}
.form-control-plaintext.form-control-sm, .form-control-plaintext.form-control-lg {
  padding-right: 0;
  padding-left: 0;
}

.form-control-sm {
  min-height: calc(1.428571em + (0.5rem + 2px));
  padding: 0.25rem 0.5rem;
  font-size: 0.75rem;
  border-radius: 0.2857rem;
}
.form-control-sm::file-selector-button {
  padding: 0.25rem 0.5rem;
  margin: -0.25rem -0.5rem;
  margin-inline-end: 0.5rem;
}
.form-control-sm::-webkit-file-upload-button {
  padding: 0.25rem 0.5rem;
  margin: -0.25rem -0.5rem;
  margin-inline-end: 0.5rem;
}

.form-control-lg {
  min-height: calc(1.428571em + (1.75rem + 2px));
  padding: 0.875rem 1rem;
  font-size: 0.875rem;
  border-radius: 0.4285rem;
}
.form-control-lg::file-selector-button {
  padding: 0.875rem 1rem;
  margin: -0.875rem -1rem;
  margin-inline-end: 1rem;
}
.form-control-lg::-webkit-file-upload-button {
  padding: 0.875rem 1rem;
  margin: -0.875rem -1rem;
  margin-inline-end: 1rem;
}

textarea.form-control {
  min-height: calc(2.249999625rem + 2px);
}
textarea.form-control-sm {
  min-height: calc(1.428571em + (0.5rem + 2px));
}
textarea.form-control-lg {
  min-height: calc(1.428571em + (1.75rem + 2px));
}

.form-control-color {
  max-width: 3rem;
  height: auto;
  padding: 0.5rem;
}
.form-control-color:not(:disabled):not([readonly]) {
  cursor: pointer;
}
.form-control-color::-moz-color-swatch {
  height: 1.428571em;
  border-radius: 0.25rem;
}
.form-control-color::-webkit-color-swatch {
  height: 1.428571em;
  border-radius: 0.25rem;
}

.form-select {
  display: block;
  width: 100%;
  padding: 0.5rem 2.1rem 0.5rem 0.7rem;
  -moz-padding-start: calc(0.7rem - 3px);
  font-size: 0.875rem;
  font-weight: 400;
  line-height: 1.428571;
  color: rgba(255, 255, 255, 0.8);
  background-color: transparent;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: right 0.7rem center;
  background-size: 16px 12px;
  border: 1px solid #cad1d7;
  border-radius: 0.25rem;
  box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.075);
  transition: all 0.2s cubic-bezier(0.68, -0.55, 0.265, 1.55);
  -webkit-appearance: none;
          appearance: none;
}
@media (prefers-reduced-motion: reduce) {
  .form-select {
    transition: none;
  }
}
.form-select:focus {
  border-color: rgba(50, 151, 211, 0.25);
  outline: 0;
  box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.075), 0 0 0 0 #68869a;
}
.form-select[multiple], .form-select[size]:not([size="1"]) {
  padding-right: 0.7rem;
  background-image: none;
}
.form-select:disabled {
  background-color: #e9ecef;
}
.form-select:-moz-focusring {
  color: transparent;
  text-shadow: 0 0 0 rgba(255, 255, 255, 0.8);
}

.form-select-sm {
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
  padding-left: 0.5rem;
  font-size: 0.75rem;
}

.form-select-lg {
  padding-top: 0.875rem;
  padding-bottom: 0.875rem;
  padding-left: 1rem;
  font-size: 0.875rem;
}

.form-check {
  display: block;
  min-height: 1.3125rem;
  padding-left: 1.5em;
  margin-bottom: 0.125rem;
}
.form-check .form-check-input {
  float: left;
  margin-left: -1.5em;
}

.form-check-input {
  width: 1em;
  height: 1em;
  margin-top: 0.25em;
  vertical-align: top;
  background-color: transparent;
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  border: 1px solid rgba(0, 0, 0, 0.25);
  -webkit-appearance: none;
          appearance: none;
  -webkit-print-color-adjust: exact;
          color-adjust: exact;
}
.form-check-input[type=checkbox] {
  border-radius: 0.25em;
}
.form-check-input[type=radio] {
  border-radius: 50%;
}
.form-check-input:active {
  filter: brightness(90%);
}
.form-check-input:focus {
  border-color: rgba(50, 151, 211, 0.25);
  outline: 0;
  box-shadow: none;
}
.form-check-input:checked {
  background-color: #68869a;
  border-color: #68869a;
}
.form-check-input:checked[type=checkbox] {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}
.form-check-input:checked[type=radio] {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
}
.form-check-input[type=checkbox]:indeterminate {
  background-color: #68869a;
  border-color: #68869a;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
}
.form-check-input:disabled {
  pointer-events: none;
  filter: none;
  opacity: 0.5;
}
.form-check-input[disabled] ~ .form-check-label, .form-check-input:disabled ~ .form-check-label {
  opacity: 0.5;
}

.form-switch {
  padding-left: 2.5em;
}
.form-switch .form-check-input {
  width: 2em;
  margin-left: -2.5em;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
  background-position: left center;
  border-radius: 2em;
  transition: background-position 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-switch .form-check-input {
    transition: none;
  }
}
.form-switch .form-check-input:focus {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
}
.form-switch .form-check-input:checked {
  background-position: right center;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
}

.form-check-inline {
  display: inline-block;
  margin-right: 1rem;
}

.btn-check {
  position: absolute;
  clip: rect(0, 0, 0, 0);
  pointer-events: none;
}
.btn-check[disabled] + .btn, .btn-check:disabled + .btn {
  pointer-events: none;
  filter: none;
  opacity: 0.65;
}

.form-range {
  width: 100%;
  height: 1rem;
  padding: 0;
  background-color: transparent;
  -webkit-appearance: none;
          appearance: none;
}
.form-range:focus {
  outline: 0;
}
.form-range:focus::-webkit-slider-thumb {
  box-shadow: 0 0 0 1px #1e1e24, none;
}
.form-range:focus::-moz-range-thumb {
  box-shadow: 0 0 0 1px #1e1e24, none;
}
.form-range::-moz-focus-outer {
  border: 0;
}
.form-range::-webkit-slider-thumb {
  width: 1rem;
  height: 1rem;
  margin-top: -0.25rem;
  background-color: #68869a;
  border: 0;
  border-radius: 1rem;
  box-shadow: 0 0.1rem 0.25rem rgba(0, 0, 0, 0.1);
  -webkit-transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  -webkit-appearance: none;
          appearance: none;
}
@media (prefers-reduced-motion: reduce) {
  .form-range::-webkit-slider-thumb {
    -webkit-transition: none;
    transition: none;
  }
}
.form-range::-webkit-slider-thumb:active {
  background-color: #d2dbe1;
}
.form-range::-webkit-slider-runnable-track {
  width: 100%;
  height: 0.5rem;
  color: transparent;
  cursor: pointer;
  background-color: #e3e3e3;
  border-color: transparent;
  border-radius: 1rem;
  box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.075);
}
.form-range::-moz-range-thumb {
  width: 1rem;
  height: 1rem;
  background-color: #68869a;
  border: 0;
  border-radius: 1rem;
  box-shadow: 0 0.1rem 0.25rem rgba(0, 0, 0, 0.1);
  -moz-transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  appearance: none;
}
@media (prefers-reduced-motion: reduce) {
  .form-range::-moz-range-thumb {
    -moz-transition: none;
    transition: none;
  }
}
.form-range::-moz-range-thumb:active {
  background-color: #d2dbe1;
}
.form-range::-moz-range-track {
  width: 100%;
  height: 0.5rem;
  color: transparent;
  cursor: pointer;
  background-color: #e3e3e3;
  border-color: transparent;
  border-radius: 1rem;
  box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.075);
}
.form-range:disabled {
  pointer-events: none;
}
.form-range:disabled::-webkit-slider-thumb {
  background-color: #adb5bd;
}
.form-range:disabled::-moz-range-thumb {
  background-color: #adb5bd;
}

.form-floating {
  position: relative;
}
.form-floating > .form-control,
.form-floating > .form-select {
  height: calc(3.5rem + 2px);
  line-height: 1.25;
}
.form-floating > label {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  padding: 1rem 0.7rem;
  pointer-events: none;
  border: 1px solid transparent;
  transform-origin: 0 0;
  transition: opacity 0.1s ease-in-out, transform 0.1s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-floating > label {
    transition: none;
  }
}
.form-floating > .form-control {
  padding: 1rem 0.7rem;
}
.form-floating > .form-control::placeholder {
  color: transparent;
}
.form-floating > .form-control:focus, .form-floating > .form-control:not(:placeholder-shown) {
  padding-top: 1.625rem;
  padding-bottom: 0.625rem;
}
.form-floating > .form-control:-webkit-autofill {
  padding-top: 1.625rem;
  padding-bottom: 0.625rem;
}
.form-floating > .form-select {
  padding-top: 1.625rem;
  padding-bottom: 0.625rem;
}
.form-floating > .form-control:focus ~ label,
.form-floating > .form-control:not(:placeholder-shown) ~ label,
.form-floating > .form-select ~ label {
  opacity: 0.65;
  transform: scale(0.85) translateY(-0.5rem) translateX(0.15rem);
}
.form-floating > .form-control:-webkit-autofill ~ label {
  opacity: 0.65;
  transform: scale(0.85) translateY(-0.5rem) translateX(0.15rem);
}

.input-group {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-items: stretch;
  width: 100%;
}
.input-group > .form-control,
.input-group > .form-select {
  position: relative;
  flex: 1 1 auto;
  width: 1%;
  min-width: 0;
}
.input-group > .form-control:focus,
.input-group > .form-select:focus {
  z-index: 3;
}
.input-group .btn {
  position: relative;
  z-index: 2;
}
.input-group .btn:focus {
  z-index: 3;
}

.input-group-text {
  display: flex;
  align-items: center;
  padding: 0.5rem 0.7rem;
  font-size: 0.875rem;
  font-weight: 400;
  line-height: 1.428571;
  color: #adb5bd;
  text-align: center;
  white-space: nowrap;
  background-color: transparent;
  border: 1px solid #cad1d7;
  border-radius: 0.25rem;
}

.input-group-lg > .form-control,
.input-group-lg > .form-select,
.input-group-lg > .input-group-text,
.input-group-lg > .btn {
  padding: 0.875rem 1rem;
  font-size: 0.875rem;
  border-radius: 0.4285rem;
}

.input-group-sm > .form-control,
.input-group-sm > .form-select,
.input-group-sm > .input-group-text,
.input-group-sm > .btn {
  padding: 0.25rem 0.5rem;
  font-size: 0.75rem;
  border-radius: 0.2857rem;
}

.input-group-lg > .form-select,
.input-group-sm > .form-select {
  padding-right: 2.8rem;
}

.input-group:not(.has-validation) > :not(:last-child):not(.dropdown-toggle):not(.dropdown-menu),
.input-group:not(.has-validation) > .dropdown-toggle:nth-last-child(n+3) {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.input-group.has-validation > :nth-last-child(n+3):not(.dropdown-toggle):not(.dropdown-menu),
.input-group.has-validation > .dropdown-toggle:nth-last-child(n+4) {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.input-group > :not(:first-child):not(.dropdown-menu):not(.valid-tooltip):not(.valid-feedback):not(.invalid-tooltip):not(.invalid-feedback) {
  margin-left: -1px;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.valid-feedback {
  display: none;
  width: 100%;
  margin-top: 0.25rem;
  font-size: 80%;
  color: #68869a;
}

.valid-tooltip {
  position: absolute;
  top: 100%;
  z-index: 5;
  display: none;
  max-width: 100%;
  padding: 0.25rem 0.5rem;
  margin-top: 0.1rem;
  font-size: 0.7500000025rem;
  color: #000000;
  background-color: rgba(104, 134, 154, 0.9);
  border-radius: 0.25rem;
}

.was-validated :valid ~ .valid-feedback,
.was-validated :valid ~ .valid-tooltip,
.is-valid ~ .valid-feedback,
.is-valid ~ .valid-tooltip {
  display: block;
}

.was-validated .form-control:valid, .form-control.is-valid {
  border-color: #68869a;
  padding-right: 2.249999625rem;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
  background-repeat: no-repeat;
  background-position: right calc(0.35714275em + 0.25rem) center;
  background-size: calc(0.7142855em + 0.5rem) calc(0.7142855em + 0.5rem);
}
.was-validated .form-control:valid:focus, .form-control.is-valid:focus {
  border-color: #68869a;
  box-shadow: 0 0 0 0 rgba(104, 134, 154, 0.25);
}

.was-validated textarea.form-control:valid, textarea.form-control.is-valid {
  padding-right: 2.249999625rem;
  background-position: top calc(0.35714275em + 0.25rem) right calc(0.35714275em + 0.25rem);
}

.was-validated .form-select:valid, .form-select.is-valid {
  border-color: #68869a;
}
.was-validated .form-select:valid:not([multiple]):not([size]), .was-validated .form-select:valid:not([multiple])[size="1"], .form-select.is-valid:not([multiple]):not([size]), .form-select.is-valid:not([multiple])[size="1"] {
  padding-right: 3.85rem;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___}), url(${___CSS_LOADER_URL_REPLACEMENT_7___});
  background-position: right 0.7rem center, center right 2.1rem;
  background-size: 16px 12px, calc(0.7142855em + 0.5rem) calc(0.7142855em + 0.5rem);
}
.was-validated .form-select:valid:focus, .form-select.is-valid:focus {
  border-color: #68869a;
  box-shadow: 0 0 0 0 rgba(104, 134, 154, 0.25);
}

.was-validated .form-check-input:valid, .form-check-input.is-valid {
  border-color: #68869a;
}
.was-validated .form-check-input:valid:checked, .form-check-input.is-valid:checked {
  background-color: #68869a;
}
.was-validated .form-check-input:valid:focus, .form-check-input.is-valid:focus {
  box-shadow: 0 0 0 0 rgba(104, 134, 154, 0.25);
}
.was-validated .form-check-input:valid ~ .form-check-label, .form-check-input.is-valid ~ .form-check-label {
  color: #68869a;
}

.form-check-inline .form-check-input ~ .valid-feedback {
  margin-left: 0.5em;
}

.was-validated .input-group .form-control:valid, .input-group .form-control.is-valid,
.was-validated .input-group .form-select:valid,
.input-group .form-select.is-valid {
  z-index: 1;
}
.was-validated .input-group .form-control:valid:focus, .input-group .form-control.is-valid:focus,
.was-validated .input-group .form-select:valid:focus,
.input-group .form-select.is-valid:focus {
  z-index: 3;
}

.invalid-feedback {
  display: none;
  width: 100%;
  margin-top: 0.25rem;
  font-size: 80%;
  color: #0c4160;
}

.invalid-tooltip {
  position: absolute;
  top: 100%;
  z-index: 5;
  display: none;
  max-width: 100%;
  padding: 0.25rem 0.5rem;
  margin-top: 0.1rem;
  font-size: 0.7500000025rem;
  color: #ffffff;
  background-color: rgba(12, 65, 96, 0.9);
  border-radius: 0.25rem;
}

.was-validated :invalid ~ .invalid-feedback,
.was-validated :invalid ~ .invalid-tooltip,
.is-invalid ~ .invalid-feedback,
.is-invalid ~ .invalid-tooltip {
  display: block;
}

.was-validated .form-control:invalid, .form-control.is-invalid {
  border-color: #0c4160;
  padding-right: 2.249999625rem;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
  background-repeat: no-repeat;
  background-position: right calc(0.35714275em + 0.25rem) center;
  background-size: calc(0.7142855em + 0.5rem) calc(0.7142855em + 0.5rem);
}
.was-validated .form-control:invalid:focus, .form-control.is-invalid:focus {
  border-color: #0c4160;
  box-shadow: 0 0 0 0 rgba(12, 65, 96, 0.25);
}

.was-validated textarea.form-control:invalid, textarea.form-control.is-invalid {
  padding-right: 2.249999625rem;
  background-position: top calc(0.35714275em + 0.25rem) right calc(0.35714275em + 0.25rem);
}

.was-validated .form-select:invalid, .form-select.is-invalid {
  border-color: #0c4160;
}
.was-validated .form-select:invalid:not([multiple]):not([size]), .was-validated .form-select:invalid:not([multiple])[size="1"], .form-select.is-invalid:not([multiple]):not([size]), .form-select.is-invalid:not([multiple])[size="1"] {
  padding-right: 3.85rem;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___}), url(${___CSS_LOADER_URL_REPLACEMENT_8___});
  background-position: right 0.7rem center, center right 2.1rem;
  background-size: 16px 12px, calc(0.7142855em + 0.5rem) calc(0.7142855em + 0.5rem);
}
.was-validated .form-select:invalid:focus, .form-select.is-invalid:focus {
  border-color: #0c4160;
  box-shadow: 0 0 0 0 rgba(12, 65, 96, 0.25);
}

.was-validated .form-check-input:invalid, .form-check-input.is-invalid {
  border-color: #0c4160;
}
.was-validated .form-check-input:invalid:checked, .form-check-input.is-invalid:checked {
  background-color: #0c4160;
}
.was-validated .form-check-input:invalid:focus, .form-check-input.is-invalid:focus {
  box-shadow: 0 0 0 0 rgba(12, 65, 96, 0.25);
}
.was-validated .form-check-input:invalid ~ .form-check-label, .form-check-input.is-invalid ~ .form-check-label {
  color: #0c4160;
}

.form-check-inline .form-check-input ~ .invalid-feedback {
  margin-left: 0.5em;
}

.was-validated .input-group .form-control:invalid, .input-group .form-control.is-invalid,
.was-validated .input-group .form-select:invalid,
.input-group .form-select.is-invalid {
  z-index: 2;
}
.was-validated .input-group .form-control:invalid:focus, .input-group .form-control.is-invalid:focus,
.was-validated .input-group .form-select:invalid:focus,
.input-group .form-select.is-invalid:focus {
  z-index: 3;
}

.btn {
  display: inline-block;
  font-weight: 600;
  line-height: 1.35em;
  color: #525f7f;
  text-align: center;
  vertical-align: middle;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  background-color: transparent;
  border: 1px solid transparent;
  padding: 11px 40px;
  font-size: 0.875rem;
  border-radius: 0.25rem;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .btn {
    transition: none;
  }
}
.btn:hover {
  color: #525f7f;
}
.btn-check:focus + .btn, .btn:focus {
  outline: 0;
  box-shadow: 0 7px 14px rgba(50, 50, 93, 0.1), 0 3px 6px rgba(0, 0, 0, 0.08);
}
.btn-check:checked + .btn, .btn-check:active + .btn, .btn:active, .btn.active {
  box-shadow: none;
}
.btn-check:checked + .btn:focus, .btn-check:active + .btn:focus, .btn:active:focus, .btn.active:focus {
  box-shadow: 0 7px 14px rgba(50, 50, 93, 0.1), 0 3px 6px rgba(0, 0, 0, 0.08), none;
}
.btn:disabled, .btn.disabled, fieldset:disabled .btn {
  pointer-events: none;
  opacity: 0.65;
  box-shadow: none;
}

.btn-default {
  color: #ffffff;
  background-color: #011e31;
  border-color: #011e31;
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);
}
.btn-default:hover {
  color: #ffffff;
  background-color: #011a2a;
  border-color: #011827;
}
.btn-check:focus + .btn-default, .btn-default:focus {
  color: #ffffff;
  background-color: #011a2a;
  border-color: #011827;
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08), 0 0 0 0 rgba(39, 64, 80, 0.5);
}
.btn-check:checked + .btn-default, .btn-check:active + .btn-default, .btn-default:active, .btn-default.active, .show > .btn-default.dropdown-toggle {
  color: #ffffff;
  background-color: #011827;
  border-color: #011725;
}
.btn-check:checked + .btn-default:focus, .btn-check:active + .btn-default:focus, .btn-default:active:focus, .btn-default.active:focus, .show > .btn-default.dropdown-toggle:focus {
  box-shadow: none, 0 0 0 0 rgba(39, 64, 80, 0.5);
}
.btn-default:disabled, .btn-default.disabled {
  color: #ffffff;
  background-color: #011e31;
  border-color: #011e31;
}

.btn-primary {
  color: #000000;
  background-color: #68869a;
  border-color: #68869a;
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);
}
.btn-primary:hover {
  color: #000000;
  background-color: #7f98a9;
  border-color: #7792a4;
}
.btn-check:focus + .btn-primary, .btn-primary:focus {
  color: #000000;
  background-color: #7f98a9;
  border-color: #7792a4;
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08), 0 0 0 0 rgba(88, 114, 131, 0.5);
}
.btn-check:checked + .btn-primary, .btn-check:active + .btn-primary, .btn-primary:active, .btn-primary.active, .show > .btn-primary.dropdown-toggle {
  color: #000000;
  background-color: #869eae;
  border-color: #7792a4;
}
.btn-check:checked + .btn-primary:focus, .btn-check:active + .btn-primary:focus, .btn-primary:active:focus, .btn-primary.active:focus, .show > .btn-primary.dropdown-toggle:focus {
  box-shadow: none, 0 0 0 0 rgba(88, 114, 131, 0.5);
}
.btn-primary:disabled, .btn-primary.disabled {
  color: #000000;
  background-color: #68869a;
  border-color: #68869a;
}

.btn-secondary {
  color: #000000;
  background-color: #d7e0eb;
  border-color: #d7e0eb;
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);
}
.btn-secondary:hover {
  color: #000000;
  background-color: #dde5ee;
  border-color: #dbe3ed;
}
.btn-check:focus + .btn-secondary, .btn-secondary:focus {
  color: #000000;
  background-color: #dde5ee;
  border-color: #dbe3ed;
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08), 0 0 0 0 rgba(183, 190, 200, 0.5);
}
.btn-check:checked + .btn-secondary, .btn-check:active + .btn-secondary, .btn-secondary:active, .btn-secondary.active, .show > .btn-secondary.dropdown-toggle {
  color: #000000;
  background-color: #dfe6ef;
  border-color: #dbe3ed;
}
.btn-check:checked + .btn-secondary:focus, .btn-check:active + .btn-secondary:focus, .btn-secondary:active:focus, .btn-secondary.active:focus, .show > .btn-secondary.dropdown-toggle:focus {
  box-shadow: none, 0 0 0 0 rgba(183, 190, 200, 0.5);
}
.btn-secondary:disabled, .btn-secondary.disabled {
  color: #000000;
  background-color: #d7e0eb;
  border-color: #d7e0eb;
}

.btn-success {
  color: #000000;
  background-color: #68869a;
  border-color: #68869a;
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);
}
.btn-success:hover {
  color: #000000;
  background-color: #7f98a9;
  border-color: #7792a4;
}
.btn-check:focus + .btn-success, .btn-success:focus {
  color: #000000;
  background-color: #7f98a9;
  border-color: #7792a4;
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08), 0 0 0 0 rgba(88, 114, 131, 0.5);
}
.btn-check:checked + .btn-success, .btn-check:active + .btn-success, .btn-success:active, .btn-success.active, .show > .btn-success.dropdown-toggle {
  color: #000000;
  background-color: #869eae;
  border-color: #7792a4;
}
.btn-check:checked + .btn-success:focus, .btn-check:active + .btn-success:focus, .btn-success:active:focus, .btn-success.active:focus, .show > .btn-success.dropdown-toggle:focus {
  box-shadow: none, 0 0 0 0 rgba(88, 114, 131, 0.5);
}
.btn-success:disabled, .btn-success.disabled {
  color: #000000;
  background-color: #68869a;
  border-color: #68869a;
}

.btn-info {
  color: #ffffff;
  background-color: #0c4160;
  border-color: #0c4160;
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);
}
.btn-info:hover {
  color: #ffffff;
  background-color: #0a3752;
  border-color: #0a344d;
}
.btn-check:focus + .btn-info, .btn-info:focus {
  color: #ffffff;
  background-color: #0a3752;
  border-color: #0a344d;
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08), 0 0 0 0 rgba(48, 94, 120, 0.5);
}
.btn-check:checked + .btn-info, .btn-check:active + .btn-info, .btn-info:active, .btn-info.active, .show > .btn-info.dropdown-toggle {
  color: #ffffff;
  background-color: #0a344d;
  border-color: #093148;
}
.btn-check:checked + .btn-info:focus, .btn-check:active + .btn-info:focus, .btn-info:active:focus, .btn-info.active:focus, .show > .btn-info.dropdown-toggle:focus {
  box-shadow: none, 0 0 0 0 rgba(48, 94, 120, 0.5);
}
.btn-info:disabled, .btn-info.disabled {
  color: #ffffff;
  background-color: #0c4160;
  border-color: #0c4160;
}

.btn-warning {
  color: #ffffff;
  background-color: #0c4160;
  border-color: #0c4160;
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);
}
.btn-warning:hover {
  color: #ffffff;
  background-color: #0a3752;
  border-color: #0a344d;
}
.btn-check:focus + .btn-warning, .btn-warning:focus {
  color: #ffffff;
  background-color: #0a3752;
  border-color: #0a344d;
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08), 0 0 0 0 rgba(48, 94, 120, 0.5);
}
.btn-check:checked + .btn-warning, .btn-check:active + .btn-warning, .btn-warning:active, .btn-warning.active, .show > .btn-warning.dropdown-toggle {
  color: #ffffff;
  background-color: #0a344d;
  border-color: #093148;
}
.btn-check:checked + .btn-warning:focus, .btn-check:active + .btn-warning:focus, .btn-warning:active:focus, .btn-warning.active:focus, .show > .btn-warning.dropdown-toggle:focus {
  box-shadow: none, 0 0 0 0 rgba(48, 94, 120, 0.5);
}
.btn-warning:disabled, .btn-warning.disabled {
  color: #ffffff;
  background-color: #0c4160;
  border-color: #0c4160;
}

.btn-danger {
  color: #ffffff;
  background-color: #0c4160;
  border-color: #0c4160;
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);
}
.btn-danger:hover {
  color: #ffffff;
  background-color: #0a3752;
  border-color: #0a344d;
}
.btn-check:focus + .btn-danger, .btn-danger:focus {
  color: #ffffff;
  background-color: #0a3752;
  border-color: #0a344d;
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08), 0 0 0 0 rgba(48, 94, 120, 0.5);
}
.btn-check:checked + .btn-danger, .btn-check:active + .btn-danger, .btn-danger:active, .btn-danger.active, .show > .btn-danger.dropdown-toggle {
  color: #ffffff;
  background-color: #0a344d;
  border-color: #093148;
}
.btn-check:checked + .btn-danger:focus, .btn-check:active + .btn-danger:focus, .btn-danger:active:focus, .btn-danger.active:focus, .show > .btn-danger.dropdown-toggle:focus {
  box-shadow: none, 0 0 0 0 rgba(48, 94, 120, 0.5);
}
.btn-danger:disabled, .btn-danger.disabled {
  color: #ffffff;
  background-color: #0c4160;
  border-color: #0c4160;
}

.btn-white {
  color: #000000;
  background-color: #ffffff;
  border-color: #ffffff;
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);
}
.btn-white:hover {
  color: #000000;
  background-color: white;
  border-color: white;
}
.btn-check:focus + .btn-white, .btn-white:focus {
  color: #000000;
  background-color: white;
  border-color: white;
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08), 0 0 0 0 rgba(217, 217, 217, 0.5);
}
.btn-check:checked + .btn-white, .btn-check:active + .btn-white, .btn-white:active, .btn-white.active, .show > .btn-white.dropdown-toggle {
  color: #000000;
  background-color: white;
  border-color: white;
}
.btn-check:checked + .btn-white:focus, .btn-check:active + .btn-white:focus, .btn-white:active:focus, .btn-white.active:focus, .show > .btn-white.dropdown-toggle:focus {
  box-shadow: none, 0 0 0 0 rgba(217, 217, 217, 0.5);
}
.btn-white:disabled, .btn-white.disabled {
  color: #000000;
  background-color: #ffffff;
  border-color: #ffffff;
}

.btn-neutral {
  color: #000000;
  background-color: #ffffff;
  border-color: #ffffff;
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);
}
.btn-neutral:hover {
  color: #000000;
  background-color: white;
  border-color: white;
}
.btn-check:focus + .btn-neutral, .btn-neutral:focus {
  color: #000000;
  background-color: white;
  border-color: white;
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08), 0 0 0 0 rgba(217, 217, 217, 0.5);
}
.btn-check:checked + .btn-neutral, .btn-check:active + .btn-neutral, .btn-neutral:active, .btn-neutral.active, .show > .btn-neutral.dropdown-toggle {
  color: #000000;
  background-color: white;
  border-color: white;
}
.btn-check:checked + .btn-neutral:focus, .btn-check:active + .btn-neutral:focus, .btn-neutral:active:focus, .btn-neutral.active:focus, .show > .btn-neutral.dropdown-toggle:focus {
  box-shadow: none, 0 0 0 0 rgba(217, 217, 217, 0.5);
}
.btn-neutral:disabled, .btn-neutral.disabled {
  color: #000000;
  background-color: #ffffff;
  border-color: #ffffff;
}

.btn-dark {
  color: #ffffff;
  background-color: #212529;
  border-color: #212529;
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);
}
.btn-dark:hover {
  color: #ffffff;
  background-color: #1c1f23;
  border-color: #1a1e21;
}
.btn-check:focus + .btn-dark, .btn-dark:focus {
  color: #ffffff;
  background-color: #1c1f23;
  border-color: #1a1e21;
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08), 0 0 0 0 rgba(66, 70, 73, 0.5);
}
.btn-check:checked + .btn-dark, .btn-check:active + .btn-dark, .btn-dark:active, .btn-dark.active, .show > .btn-dark.dropdown-toggle {
  color: #ffffff;
  background-color: #1a1e21;
  border-color: #191c1f;
}
.btn-check:checked + .btn-dark:focus, .btn-check:active + .btn-dark:focus, .btn-dark:active:focus, .btn-dark.active:focus, .show > .btn-dark.dropdown-toggle:focus {
  box-shadow: none, 0 0 0 0 rgba(66, 70, 73, 0.5);
}
.btn-dark:disabled, .btn-dark.disabled {
  color: #ffffff;
  background-color: #212529;
  border-color: #212529;
}

.btn-darker {
  color: #ffffff;
  background-color: black;
  border-color: black;
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);
}
.btn-darker:hover {
  color: #ffffff;
  background-color: black;
  border-color: black;
}
.btn-check:focus + .btn-darker, .btn-darker:focus {
  color: #ffffff;
  background-color: black;
  border-color: black;
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08), 0 0 0 0 rgba(38, 38, 38, 0.5);
}
.btn-check:checked + .btn-darker, .btn-check:active + .btn-darker, .btn-darker:active, .btn-darker.active, .show > .btn-darker.dropdown-toggle {
  color: #ffffff;
  background-color: black;
  border-color: black;
}
.btn-check:checked + .btn-darker:focus, .btn-check:active + .btn-darker:focus, .btn-darker:active:focus, .btn-darker.active:focus, .show > .btn-darker.dropdown-toggle:focus {
  box-shadow: none, 0 0 0 0 rgba(38, 38, 38, 0.5);
}
.btn-darker:disabled, .btn-darker.disabled {
  color: #ffffff;
  background-color: black;
  border-color: black;
}

.btn-outline-default {
  color: #011e31;
  border-color: #011e31;
}
.btn-outline-default:hover {
  color: #ffffff;
  background-color: #011e31;
  border-color: #011e31;
}
.btn-check:focus + .btn-outline-default, .btn-outline-default:focus {
  box-shadow: 0 0 0 0 rgba(1, 30, 49, 0.5);
}
.btn-check:checked + .btn-outline-default, .btn-check:active + .btn-outline-default, .btn-outline-default:active, .btn-outline-default.active, .btn-outline-default.dropdown-toggle.show {
  color: #ffffff;
  background-color: #011e31;
  border-color: #011e31;
}
.btn-check:checked + .btn-outline-default:focus, .btn-check:active + .btn-outline-default:focus, .btn-outline-default:active:focus, .btn-outline-default.active:focus, .btn-outline-default.dropdown-toggle.show:focus {
  box-shadow: none, 0 0 0 0 rgba(1, 30, 49, 0.5);
}
.btn-outline-default:disabled, .btn-outline-default.disabled {
  color: #011e31;
  background-color: transparent;
}

.btn-outline-primary {
  color: #68869a;
  border-color: #68869a;
}
.btn-outline-primary:hover {
  color: #000000;
  background-color: #68869a;
  border-color: #68869a;
}
.btn-check:focus + .btn-outline-primary, .btn-outline-primary:focus {
  box-shadow: 0 0 0 0 rgba(104, 134, 154, 0.5);
}
.btn-check:checked + .btn-outline-primary, .btn-check:active + .btn-outline-primary, .btn-outline-primary:active, .btn-outline-primary.active, .btn-outline-primary.dropdown-toggle.show {
  color: #000000;
  background-color: #68869a;
  border-color: #68869a;
}
.btn-check:checked + .btn-outline-primary:focus, .btn-check:active + .btn-outline-primary:focus, .btn-outline-primary:active:focus, .btn-outline-primary.active:focus, .btn-outline-primary.dropdown-toggle.show:focus {
  box-shadow: none, 0 0 0 0 rgba(104, 134, 154, 0.5);
}
.btn-outline-primary:disabled, .btn-outline-primary.disabled {
  color: #68869a;
  background-color: transparent;
}

.btn-outline-secondary {
  color: #d7e0eb;
  border-color: #d7e0eb;
}
.btn-outline-secondary:hover {
  color: #000000;
  background-color: #d7e0eb;
  border-color: #d7e0eb;
}
.btn-check:focus + .btn-outline-secondary, .btn-outline-secondary:focus {
  box-shadow: 0 0 0 0 rgba(215, 224, 235, 0.5);
}
.btn-check:checked + .btn-outline-secondary, .btn-check:active + .btn-outline-secondary, .btn-outline-secondary:active, .btn-outline-secondary.active, .btn-outline-secondary.dropdown-toggle.show {
  color: #000000;
  background-color: #d7e0eb;
  border-color: #d7e0eb;
}
.btn-check:checked + .btn-outline-secondary:focus, .btn-check:active + .btn-outline-secondary:focus, .btn-outline-secondary:active:focus, .btn-outline-secondary.active:focus, .btn-outline-secondary.dropdown-toggle.show:focus {
  box-shadow: none, 0 0 0 0 rgba(215, 224, 235, 0.5);
}
.btn-outline-secondary:disabled, .btn-outline-secondary.disabled {
  color: #d7e0eb;
  background-color: transparent;
}

.btn-outline-success {
  color: #68869a;
  border-color: #68869a;
}
.btn-outline-success:hover {
  color: #000000;
  background-color: #68869a;
  border-color: #68869a;
}
.btn-check:focus + .btn-outline-success, .btn-outline-success:focus {
  box-shadow: 0 0 0 0 rgba(104, 134, 154, 0.5);
}
.btn-check:checked + .btn-outline-success, .btn-check:active + .btn-outline-success, .btn-outline-success:active, .btn-outline-success.active, .btn-outline-success.dropdown-toggle.show {
  color: #000000;
  background-color: #68869a;
  border-color: #68869a;
}
.btn-check:checked + .btn-outline-success:focus, .btn-check:active + .btn-outline-success:focus, .btn-outline-success:active:focus, .btn-outline-success.active:focus, .btn-outline-success.dropdown-toggle.show:focus {
  box-shadow: none, 0 0 0 0 rgba(104, 134, 154, 0.5);
}
.btn-outline-success:disabled, .btn-outline-success.disabled {
  color: #68869a;
  background-color: transparent;
}

.btn-outline-info {
  color: #0c4160;
  border-color: #0c4160;
}
.btn-outline-info:hover {
  color: #ffffff;
  background-color: #0c4160;
  border-color: #0c4160;
}
.btn-check:focus + .btn-outline-info, .btn-outline-info:focus {
  box-shadow: 0 0 0 0 rgba(12, 65, 96, 0.5);
}
.btn-check:checked + .btn-outline-info, .btn-check:active + .btn-outline-info, .btn-outline-info:active, .btn-outline-info.active, .btn-outline-info.dropdown-toggle.show {
  color: #ffffff;
  background-color: #0c4160;
  border-color: #0c4160;
}
.btn-check:checked + .btn-outline-info:focus, .btn-check:active + .btn-outline-info:focus, .btn-outline-info:active:focus, .btn-outline-info.active:focus, .btn-outline-info.dropdown-toggle.show:focus {
  box-shadow: none, 0 0 0 0 rgba(12, 65, 96, 0.5);
}
.btn-outline-info:disabled, .btn-outline-info.disabled {
  color: #0c4160;
  background-color: transparent;
}

.btn-outline-warning {
  color: #0c4160;
  border-color: #0c4160;
}
.btn-outline-warning:hover {
  color: #ffffff;
  background-color: #0c4160;
  border-color: #0c4160;
}
.btn-check:focus + .btn-outline-warning, .btn-outline-warning:focus {
  box-shadow: 0 0 0 0 rgba(12, 65, 96, 0.5);
}
.btn-check:checked + .btn-outline-warning, .btn-check:active + .btn-outline-warning, .btn-outline-warning:active, .btn-outline-warning.active, .btn-outline-warning.dropdown-toggle.show {
  color: #ffffff;
  background-color: #0c4160;
  border-color: #0c4160;
}
.btn-check:checked + .btn-outline-warning:focus, .btn-check:active + .btn-outline-warning:focus, .btn-outline-warning:active:focus, .btn-outline-warning.active:focus, .btn-outline-warning.dropdown-toggle.show:focus {
  box-shadow: none, 0 0 0 0 rgba(12, 65, 96, 0.5);
}
.btn-outline-warning:disabled, .btn-outline-warning.disabled {
  color: #0c4160;
  background-color: transparent;
}

.btn-outline-danger {
  color: #0c4160;
  border-color: #0c4160;
}
.btn-outline-danger:hover {
  color: #ffffff;
  background-color: #0c4160;
  border-color: #0c4160;
}
.btn-check:focus + .btn-outline-danger, .btn-outline-danger:focus {
  box-shadow: 0 0 0 0 rgba(12, 65, 96, 0.5);
}
.btn-check:checked + .btn-outline-danger, .btn-check:active + .btn-outline-danger, .btn-outline-danger:active, .btn-outline-danger.active, .btn-outline-danger.dropdown-toggle.show {
  color: #ffffff;
  background-color: #0c4160;
  border-color: #0c4160;
}
.btn-check:checked + .btn-outline-danger:focus, .btn-check:active + .btn-outline-danger:focus, .btn-outline-danger:active:focus, .btn-outline-danger.active:focus, .btn-outline-danger.dropdown-toggle.show:focus {
  box-shadow: none, 0 0 0 0 rgba(12, 65, 96, 0.5);
}
.btn-outline-danger:disabled, .btn-outline-danger.disabled {
  color: #0c4160;
  background-color: transparent;
}

.btn-outline-white {
  color: #ffffff;
  border-color: #ffffff;
}
.btn-outline-white:hover {
  color: #000000;
  background-color: #ffffff;
  border-color: #ffffff;
}
.btn-check:focus + .btn-outline-white, .btn-outline-white:focus {
  box-shadow: 0 0 0 0 rgba(255, 255, 255, 0.5);
}
.btn-check:checked + .btn-outline-white, .btn-check:active + .btn-outline-white, .btn-outline-white:active, .btn-outline-white.active, .btn-outline-white.dropdown-toggle.show {
  color: #000000;
  background-color: #ffffff;
  border-color: #ffffff;
}
.btn-check:checked + .btn-outline-white:focus, .btn-check:active + .btn-outline-white:focus, .btn-outline-white:active:focus, .btn-outline-white.active:focus, .btn-outline-white.dropdown-toggle.show:focus {
  box-shadow: none, 0 0 0 0 rgba(255, 255, 255, 0.5);
}
.btn-outline-white:disabled, .btn-outline-white.disabled {
  color: #ffffff;
  background-color: transparent;
}

.btn-outline-neutral {
  color: #ffffff;
  border-color: #ffffff;
}
.btn-outline-neutral:hover {
  color: #000000;
  background-color: #ffffff;
  border-color: #ffffff;
}
.btn-check:focus + .btn-outline-neutral, .btn-outline-neutral:focus {
  box-shadow: 0 0 0 0 rgba(255, 255, 255, 0.5);
}
.btn-check:checked + .btn-outline-neutral, .btn-check:active + .btn-outline-neutral, .btn-outline-neutral:active, .btn-outline-neutral.active, .btn-outline-neutral.dropdown-toggle.show {
  color: #000000;
  background-color: #ffffff;
  border-color: #ffffff;
}
.btn-check:checked + .btn-outline-neutral:focus, .btn-check:active + .btn-outline-neutral:focus, .btn-outline-neutral:active:focus, .btn-outline-neutral.active:focus, .btn-outline-neutral.dropdown-toggle.show:focus {
  box-shadow: none, 0 0 0 0 rgba(255, 255, 255, 0.5);
}
.btn-outline-neutral:disabled, .btn-outline-neutral.disabled {
  color: #ffffff;
  background-color: transparent;
}

.btn-outline-dark {
  color: #212529;
  border-color: #212529;
}
.btn-outline-dark:hover {
  color: #ffffff;
  background-color: #212529;
  border-color: #212529;
}
.btn-check:focus + .btn-outline-dark, .btn-outline-dark:focus {
  box-shadow: 0 0 0 0 rgba(33, 37, 41, 0.5);
}
.btn-check:checked + .btn-outline-dark, .btn-check:active + .btn-outline-dark, .btn-outline-dark:active, .btn-outline-dark.active, .btn-outline-dark.dropdown-toggle.show {
  color: #ffffff;
  background-color: #212529;
  border-color: #212529;
}
.btn-check:checked + .btn-outline-dark:focus, .btn-check:active + .btn-outline-dark:focus, .btn-outline-dark:active:focus, .btn-outline-dark.active:focus, .btn-outline-dark.dropdown-toggle.show:focus {
  box-shadow: none, 0 0 0 0 rgba(33, 37, 41, 0.5);
}
.btn-outline-dark:disabled, .btn-outline-dark.disabled {
  color: #212529;
  background-color: transparent;
}

.btn-outline-darker {
  color: black;
  border-color: black;
}
.btn-outline-darker:hover {
  color: #ffffff;
  background-color: black;
  border-color: black;
}
.btn-check:focus + .btn-outline-darker, .btn-outline-darker:focus {
  box-shadow: 0 0 0 0 rgba(0, 0, 0, 0.5);
}
.btn-check:checked + .btn-outline-darker, .btn-check:active + .btn-outline-darker, .btn-outline-darker:active, .btn-outline-darker.active, .btn-outline-darker.dropdown-toggle.show {
  color: #ffffff;
  background-color: black;
  border-color: black;
}
.btn-check:checked + .btn-outline-darker:focus, .btn-check:active + .btn-outline-darker:focus, .btn-outline-darker:active:focus, .btn-outline-darker.active:focus, .btn-outline-darker.dropdown-toggle.show:focus {
  box-shadow: none, 0 0 0 0 rgba(0, 0, 0, 0.5);
}
.btn-outline-darker:disabled, .btn-outline-darker.disabled {
  color: black;
  background-color: transparent;
}

.btn-link {
  font-weight: 400;
  color: #68869a;
  text-decoration: none;
}
.btn-link:hover {
  color: #495e6d;
  text-decoration: none;
}
.btn-link:focus {
  text-decoration: none;
}
.btn-link:disabled, .btn-link.disabled {
  color: #6c757d;
}

.btn-lg, .btn-group-lg > .btn {
  padding: 15px 48px;
  font-size: 1em;
  border-radius: 0.4285rem;
}

.btn-sm, .btn-group-sm > .btn {
  padding: 5px 15px;
  font-size: 0.75rem;
  border-radius: 0.25rem;
}

.fade {
  transition: opacity 0.15s linear;
}
@media (prefers-reduced-motion: reduce) {
  .fade {
    transition: none;
  }
}
.fade:not(.show) {
  opacity: 0;
}

.collapse:not(.show) {
  display: none;
}

.collapsing {
  height: 0;
  overflow: hidden;
  transition: height 0.35s ease;
}
@media (prefers-reduced-motion: reduce) {
  .collapsing {
    transition: none;
  }
}

.dropup,
.dropend,
.dropdown,
.dropstart {
  position: relative;
}

.dropdown-toggle {
  white-space: nowrap;
}
.dropdown-toggle::after {
  display: inline-block;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0.3em solid;
  border-right: 0.3em solid transparent;
  border-bottom: 0;
  border-left: 0.3em solid transparent;
}
.dropdown-toggle:empty::after {
  margin-left: 0;
}

.dropdown-menu {
  position: absolute;
  z-index: 1000;
  display: none;
  min-width: 10rem;
  padding: 0.5rem 0;
  margin: 0;
  font-size: 0.875rem;
  color: #525f7f;
  text-align: left;
  list-style: none;
  background-color: #ffffff;
  background-clip: padding-box;
  border: 0 solid rgba(0, 0, 0, 0.15);
  border-radius: 0.1428rem;
  box-shadow: 0 50px 100px rgba(50, 50, 93, 0.1), 0 15px 35px rgba(50, 50, 93, 0.15), 0 5px 15px rgba(0, 0, 0, 0.1);
}
.dropdown-menu[data-bs-popper] {
  top: 100%;
  left: 0;
  margin-top: 0.125rem;
}

.dropdown-menu-start {
  --bs-position: start;
}
.dropdown-menu-start[data-bs-popper] {
  right: auto;
  left: 0;
}

.dropdown-menu-end {
  --bs-position: end;
}
.dropdown-menu-end[data-bs-popper] {
  right: 0;
  left: auto;
}

@media (min-width: 576px) {
  .dropdown-menu-sm-start {
    --bs-position: start;
  }
  .dropdown-menu-sm-start[data-bs-popper] {
    right: auto;
    left: 0;
  }
  .dropdown-menu-sm-end {
    --bs-position: end;
  }
  .dropdown-menu-sm-end[data-bs-popper] {
    right: 0;
    left: auto;
  }
}
@media (min-width: 768px) {
  .dropdown-menu-md-start {
    --bs-position: start;
  }
  .dropdown-menu-md-start[data-bs-popper] {
    right: auto;
    left: 0;
  }
  .dropdown-menu-md-end {
    --bs-position: end;
  }
  .dropdown-menu-md-end[data-bs-popper] {
    right: 0;
    left: auto;
  }
}
@media (min-width: 992px) {
  .dropdown-menu-lg-start {
    --bs-position: start;
  }
  .dropdown-menu-lg-start[data-bs-popper] {
    right: auto;
    left: 0;
  }
  .dropdown-menu-lg-end {
    --bs-position: end;
  }
  .dropdown-menu-lg-end[data-bs-popper] {
    right: 0;
    left: auto;
  }
}
@media (min-width: 1200px) {
  .dropdown-menu-xl-start {
    --bs-position: start;
  }
  .dropdown-menu-xl-start[data-bs-popper] {
    right: auto;
    left: 0;
  }
  .dropdown-menu-xl-end {
    --bs-position: end;
  }
  .dropdown-menu-xl-end[data-bs-popper] {
    right: 0;
    left: auto;
  }
}
.dropup .dropdown-menu[data-bs-popper] {
  top: auto;
  bottom: 100%;
  margin-top: 0;
  margin-bottom: 0.125rem;
}
.dropup .dropdown-toggle::after {
  display: inline-block;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0;
  border-right: 0.3em solid transparent;
  border-bottom: 0.3em solid;
  border-left: 0.3em solid transparent;
}
.dropup .dropdown-toggle:empty::after {
  margin-left: 0;
}

.dropend .dropdown-menu[data-bs-popper] {
  top: 0;
  right: auto;
  left: 100%;
  margin-top: 0;
  margin-left: 0.125rem;
}
.dropend .dropdown-toggle::after {
  display: inline-block;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0.3em solid transparent;
  border-right: 0;
  border-bottom: 0.3em solid transparent;
  border-left: 0.3em solid;
}
.dropend .dropdown-toggle:empty::after {
  margin-left: 0;
}
.dropend .dropdown-toggle::after {
  vertical-align: 0;
}

.dropstart .dropdown-menu[data-bs-popper] {
  top: 0;
  right: 100%;
  left: auto;
  margin-top: 0;
  margin-right: 0.125rem;
}
.dropstart .dropdown-toggle::after {
  display: inline-block;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: "";
}
.dropstart .dropdown-toggle::after {
  display: none;
}
.dropstart .dropdown-toggle::before {
  display: inline-block;
  margin-right: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0.3em solid transparent;
  border-right: 0.3em solid;
  border-bottom: 0.3em solid transparent;
}
.dropstart .dropdown-toggle:empty::after {
  margin-left: 0;
}
.dropstart .dropdown-toggle::before {
  vertical-align: 0;
}

.dropdown-divider {
  height: 0;
  margin: 0.5rem 0;
  overflow: hidden;
  border-top: 1px solid rgba(0, 0, 0, 0.15);
}

.dropdown-item {
  display: block;
  width: 100%;
  padding: 0.25rem 1rem;
  clear: both;
  font-weight: 400;
  color: #212529;
  text-align: inherit;
  white-space: nowrap;
  background-color: transparent;
  border: 0;
}
.dropdown-item:hover, .dropdown-item:focus {
  color: #1e2125;
  background-color: #e9ecef;
}
.dropdown-item.active, .dropdown-item:active {
  color: #ffffff;
  text-decoration: none;
  background-color: #68869a;
}
.dropdown-item.disabled, .dropdown-item:disabled {
  color: #adb5bd;
  pointer-events: none;
  background-color: transparent;
}

.dropdown-menu.show {
  display: block;
}

.dropdown-header {
  display: block;
  padding: 0.5rem 1rem;
  margin-bottom: 0;
  font-size: 0.7500000025rem;
  color: #6c757d;
  white-space: nowrap;
}

.dropdown-item-text {
  display: block;
  padding: 0.25rem 1rem;
  color: #212529;
}

.dropdown-menu-dark {
  color: #e3e3e3;
  background-color: #32325d;
  border-color: rgba(0, 0, 0, 0.15);
}
.dropdown-menu-dark .dropdown-item {
  color: #e3e3e3;
}
.dropdown-menu-dark .dropdown-item:hover, .dropdown-menu-dark .dropdown-item:focus {
  color: #ffffff;
  background-color: rgba(255, 255, 255, 0.15);
}
.dropdown-menu-dark .dropdown-item.active, .dropdown-menu-dark .dropdown-item:active {
  color: #ffffff;
  background-color: #68869a;
}
.dropdown-menu-dark .dropdown-item.disabled, .dropdown-menu-dark .dropdown-item:disabled {
  color: #adb5bd;
}
.dropdown-menu-dark .dropdown-divider {
  border-color: rgba(0, 0, 0, 0.15);
}
.dropdown-menu-dark .dropdown-item-text {
  color: #e3e3e3;
}
.dropdown-menu-dark .dropdown-header {
  color: #adb5bd;
}

.btn-group,
.btn-group-vertical {
  position: relative;
  display: inline-flex;
  vertical-align: middle;
}
.btn-group > .btn,
.btn-group-vertical > .btn {
  position: relative;
  flex: 1 1 auto;
}
.btn-group > .btn-check:checked + .btn,
.btn-group > .btn-check:focus + .btn,
.btn-group > .btn:hover,
.btn-group > .btn:focus,
.btn-group > .btn:active,
.btn-group > .btn.active,
.btn-group-vertical > .btn-check:checked + .btn,
.btn-group-vertical > .btn-check:focus + .btn,
.btn-group-vertical > .btn:hover,
.btn-group-vertical > .btn:focus,
.btn-group-vertical > .btn:active,
.btn-group-vertical > .btn.active {
  z-index: 1;
}

.btn-toolbar {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
}
.btn-toolbar .input-group {
  width: auto;
}

.btn-group > .btn:not(:first-child),
.btn-group > .btn-group:not(:first-child) {
  margin-left: -1px;
}
.btn-group > .btn:not(:last-child):not(.dropdown-toggle),
.btn-group > .btn-group:not(:last-child) > .btn {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.btn-group > .btn:nth-child(n+3),
.btn-group > :not(.btn-check) + .btn,
.btn-group > .btn-group:not(:first-child) > .btn {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.dropdown-toggle-split {
  padding-right: 30px;
  padding-left: 30px;
}
.dropdown-toggle-split::after, .dropup .dropdown-toggle-split::after, .dropend .dropdown-toggle-split::after {
  margin-left: 0;
}
.dropstart .dropdown-toggle-split::before {
  margin-right: 0;
}

.btn-sm + .dropdown-toggle-split, .btn-group-sm > .btn + .dropdown-toggle-split {
  padding-right: 11.25px;
  padding-left: 11.25px;
}

.btn-lg + .dropdown-toggle-split, .btn-group-lg > .btn + .dropdown-toggle-split {
  padding-right: 36px;
  padding-left: 36px;
}

.btn-group.show .dropdown-toggle {
  box-shadow: none;
}
.btn-group.show .dropdown-toggle.btn-link {
  box-shadow: none;
}

.btn-group-vertical {
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
}
.btn-group-vertical > .btn,
.btn-group-vertical > .btn-group {
  width: 100%;
}
.btn-group-vertical > .btn:not(:first-child),
.btn-group-vertical > .btn-group:not(:first-child) {
  margin-top: -1px;
}
.btn-group-vertical > .btn:not(:last-child):not(.dropdown-toggle),
.btn-group-vertical > .btn-group:not(:last-child) > .btn {
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
}
.btn-group-vertical > .btn ~ .btn,
.btn-group-vertical > .btn-group:not(:first-child) > .btn {
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}

.input-group {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-items: stretch;
  width: 100%;
}
.input-group > .form-control,
.input-group > .form-select {
  position: relative;
  flex: 1 1 auto;
  width: 1%;
  min-width: 0;
}
.input-group > .form-control:focus,
.input-group > .form-select:focus {
  z-index: 3;
}
.input-group .btn {
  position: relative;
  z-index: 2;
}
.input-group .btn:focus {
  z-index: 3;
}

.input-group-text {
  display: flex;
  align-items: center;
  padding: 0.5rem 0.7rem;
  font-size: 0.875rem;
  font-weight: 400;
  line-height: 1.428571;
  color: #adb5bd;
  text-align: center;
  white-space: nowrap;
  background-color: transparent;
  border: 1px solid #cad1d7;
  border-radius: 0.25rem;
}

.input-group-lg > .form-control,
.input-group-lg > .form-select,
.input-group-lg > .input-group-text,
.input-group-lg > .btn {
  padding: 0.875rem 1rem;
  font-size: 0.875rem;
  border-radius: 0.4285rem;
}

.input-group-sm > .form-control,
.input-group-sm > .form-select,
.input-group-sm > .input-group-text,
.input-group-sm > .btn {
  padding: 0.25rem 0.5rem;
  font-size: 0.75rem;
  border-radius: 0.2857rem;
}

.input-group-lg > .form-select,
.input-group-sm > .form-select {
  padding-right: 2.8rem;
}

.input-group:not(.has-validation) > :not(:last-child):not(.dropdown-toggle):not(.dropdown-menu),
.input-group:not(.has-validation) > .dropdown-toggle:nth-last-child(n+3) {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.input-group.has-validation > :nth-last-child(n+3):not(.dropdown-toggle):not(.dropdown-menu),
.input-group.has-validation > .dropdown-toggle:nth-last-child(n+4) {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.input-group > :not(:first-child):not(.dropdown-menu):not(.valid-tooltip):not(.valid-feedback):not(.invalid-tooltip):not(.invalid-feedback) {
  margin-left: -1px;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.nav {
  display: flex;
  flex-wrap: wrap;
  padding-left: 0;
  margin-bottom: 0;
  list-style: none;
}

.nav-link {
  display: block;
  padding: 0.5rem 1rem;
  color: #525f7f;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .nav-link {
    transition: none;
  }
}
.nav-link:hover, .nav-link:focus {
  color: #495e6d;
}
.nav-link.disabled {
  color: #6c757d;
  pointer-events: none;
  cursor: default;
}

.nav-tabs {
  border-bottom: 0.0625rem solid #e3e3e3;
}
.nav-tabs .nav-link {
  margin-bottom: -0.0625rem;
  background: none;
  border: 0.0625rem solid transparent;
  border-top-left-radius: 0.25rem;
  border-top-right-radius: 0.25rem;
}
.nav-tabs .nav-link:hover, .nav-tabs .nav-link:focus {
  border-color: #e9ecef #e9ecef #e3e3e3;
  isolation: isolate;
}
.nav-tabs .nav-link.disabled {
  color: #6c757d;
  background-color: transparent;
  border-color: transparent;
}
.nav-tabs .nav-link.active,
.nav-tabs .nav-item.show .nav-link {
  color: #525f7f;
  background-color: #1e1e24;
  border-color: #e3e3e3 #e3e3e3 #1e1e24;
}
.nav-tabs .dropdown-menu {
  margin-top: -0.0625rem;
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}

.nav-pills .nav-link {
  background: none;
  border: 0;
  border-radius: 0.25rem;
}
.nav-pills .nav-link.active,
.nav-pills .show > .nav-link {
  color: color-yiq(#68869a);
  background-color: #68869a;
}

.nav-fill > .nav-link,
.nav-fill .nav-item {
  flex: 1 1 auto;
  text-align: center;
}

.nav-justified > .nav-link,
.nav-justified .nav-item {
  flex-basis: 0;
  flex-grow: 1;
  text-align: center;
}

.nav-fill .nav-item .nav-link,
.nav-justified .nav-item .nav-link {
  width: 100%;
}

.tab-content > .tab-pane {
  display: none;
}
.tab-content > .active {
  display: block;
}

.navbar {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  padding-top: 0.625rem;
  padding-right: 0.9375rem;
  padding-bottom: 0.625rem;
  padding-left: 0.9375rem;
}
.navbar > .container-xxl, .navbar > .container-xl, .navbar > .container-lg, .navbar > .container-md, .navbar > .container-sm, .navbar > .container,
.navbar > .container-fluid {
  display: flex;
  flex-wrap: inherit;
  align-items: center;
  justify-content: space-between;
}
.navbar-brand {
  padding-top: 0.4068125rem;
  padding-bottom: 0.4068125rem;
  margin-right: 1rem;
  font-size: 0.99925rem;
  white-space: nowrap;
}
.navbar-nav {
  display: flex;
  flex-direction: column;
  padding-left: 0;
  margin-bottom: 0;
  list-style: none;
}
.navbar-nav .nav-link {
  padding-right: 0;
  padding-left: 0;
}
.navbar-nav .dropdown-menu {
  position: static;
}

.navbar-text {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}

.navbar-collapse {
  flex-basis: 100%;
  flex-grow: 1;
  align-items: center;
}

.navbar-toggler {
  padding: 0.25rem 0.75rem;
  font-size: 0.99925rem;
  line-height: 1;
  background-color: transparent;
  border: 0.0625rem solid transparent;
  border-radius: 0.25rem;
  transition: box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .navbar-toggler {
    transition: none;
  }
}
.navbar-toggler:hover {
  text-decoration: none;
}
.navbar-toggler:focus {
  text-decoration: none;
  outline: 0;
  box-shadow: 0 0 0 0;
}

.navbar-toggler-icon {
  display: inline-block;
  width: 1.5em;
  height: 1.5em;
  vertical-align: middle;
  background-repeat: no-repeat;
  background-position: center;
  background-size: 100%;
}

.navbar-nav-scroll {
  max-height: 75vh;
  max-height: var(--bs-scroll-height, 75vh);
  overflow-y: auto;
}

@media (min-width: 576px) {
  .navbar-expand-sm {
    flex-wrap: nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-sm .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-sm .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-sm .navbar-nav .nav-link {
    padding-right: 1rem;
    padding-left: 1rem;
  }
  .navbar-expand-sm .navbar-nav-scroll {
    overflow: visible;
  }
  .navbar-expand-sm .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-sm .navbar-toggler {
    display: none;
  }
}
@media (min-width: 768px) {
  .navbar-expand-md {
    flex-wrap: nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-md .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-md .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-md .navbar-nav .nav-link {
    padding-right: 1rem;
    padding-left: 1rem;
  }
  .navbar-expand-md .navbar-nav-scroll {
    overflow: visible;
  }
  .navbar-expand-md .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-md .navbar-toggler {
    display: none;
  }
}
@media (min-width: 992px) {
  .navbar-expand-lg {
    flex-wrap: nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-lg .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-lg .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-lg .navbar-nav .nav-link {
    padding-right: 1rem;
    padding-left: 1rem;
  }
  .navbar-expand-lg .navbar-nav-scroll {
    overflow: visible;
  }
  .navbar-expand-lg .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-lg .navbar-toggler {
    display: none;
  }
}
@media (min-width: 1200px) {
  .navbar-expand-xl {
    flex-wrap: nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-xl .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-xl .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-xl .navbar-nav .nav-link {
    padding-right: 1rem;
    padding-left: 1rem;
  }
  .navbar-expand-xl .navbar-nav-scroll {
    overflow: visible;
  }
  .navbar-expand-xl .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-xl .navbar-toggler {
    display: none;
  }
}
.navbar-expand {
  flex-wrap: nowrap;
  justify-content: flex-start;
}
.navbar-expand .navbar-nav {
  flex-direction: row;
}
.navbar-expand .navbar-nav .dropdown-menu {
  position: absolute;
}
.navbar-expand .navbar-nav .nav-link {
  padding-right: 1rem;
  padding-left: 1rem;
}
.navbar-expand .navbar-nav-scroll {
  overflow: visible;
}
.navbar-expand .navbar-collapse {
  display: flex !important;
  flex-basis: auto;
}
.navbar-expand .navbar-toggler {
  display: none;
}

.navbar-light .navbar-brand {
  color: rgba(0, 0, 0, 0.9);
}
.navbar-light .navbar-brand:hover, .navbar-light .navbar-brand:focus {
  color: rgba(0, 0, 0, 0.9);
}
.navbar-light .navbar-nav .nav-link {
  color: rgba(0, 0, 0, 0.5);
}
.navbar-light .navbar-nav .nav-link:hover, .navbar-light .navbar-nav .nav-link:focus {
  color: rgba(0, 0, 0, 0.7);
}
.navbar-light .navbar-nav .nav-link.disabled {
  color: rgba(0, 0, 0, 0.3);
}
.navbar-light .navbar-nav .show > .nav-link,
.navbar-light .navbar-nav .nav-link.active {
  color: rgba(0, 0, 0, 0.9);
}
.navbar-light .navbar-toggler {
  color: rgba(0, 0, 0, 0.5);
  border-color: transparent;
}
.navbar-light .navbar-toggler-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_9___});
}
.navbar-light .navbar-text {
  color: rgba(0, 0, 0, 0.5);
}
.navbar-light .navbar-text a,
.navbar-light .navbar-text a:hover,
.navbar-light .navbar-text a:focus {
  color: rgba(0, 0, 0, 0.9);
}

.navbar-dark .navbar-brand {
  color: rgba(255, 255, 255, 0.65);
}
.navbar-dark .navbar-brand:hover, .navbar-dark .navbar-brand:focus {
  color: rgba(255, 255, 255, 0.65);
}
.navbar-dark .navbar-nav .nav-link {
  color: rgba(255, 255, 255, 0.95);
}
.navbar-dark .navbar-nav .nav-link:hover, .navbar-dark .navbar-nav .nav-link:focus {
  color: rgba(255, 255, 255, 0.65);
}
.navbar-dark .navbar-nav .nav-link.disabled {
  color: rgba(255, 255, 255, 0.25);
}
.navbar-dark .navbar-nav .show > .nav-link,
.navbar-dark .navbar-nav .nav-link.active {
  color: rgba(255, 255, 255, 0.65);
}
.navbar-dark .navbar-toggler {
  color: rgba(255, 255, 255, 0.95);
  border-color: transparent;
}
.navbar-dark .navbar-toggler-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_10___});
}
.navbar-dark .navbar-text {
  color: rgba(255, 255, 255, 0.95);
}
.navbar-dark .navbar-text a,
.navbar-dark .navbar-text a:hover,
.navbar-dark .navbar-text a:focus {
  color: rgba(255, 255, 255, 0.65);
}

.card {
  position: relative;
  display: flex;
  flex-direction: column;
  min-width: 0;
  word-wrap: break-word;
  background-color: #ffffff;
  background-clip: border-box;
  border: 0.0625rem solid rgba(0, 0, 0, 0.05);
  border-radius: 0.2857rem;
}
.card > hr {
  margin-right: 0;
  margin-left: 0;
}
.card > .list-group {
  border-top: inherit;
  border-bottom: inherit;
}
.card > .list-group:first-child {
  border-top-width: 0;
  border-top-left-radius: calc(0.2857rem - 0.0625rem);
  border-top-right-radius: calc(0.2857rem - 0.0625rem);
}
.card > .list-group:last-child {
  border-bottom-width: 0;
  border-bottom-right-radius: calc(0.2857rem - 0.0625rem);
  border-bottom-left-radius: calc(0.2857rem - 0.0625rem);
}
.card > .card-header + .list-group,
.card > .list-group + .card-footer {
  border-top: 0;
}

.card-body {
  flex: 1 1 auto;
  padding: 1.25rem 1.5rem;
}

.card-title {
  margin-bottom: 0.5rem;
}

.card-subtitle {
  margin-top: -0.25rem;
  margin-bottom: 0;
}

.card-text:last-child {
  margin-bottom: 0;
}

.card-link:hover {
  text-decoration: none;
}
.card-link + .card-link {
  margin-left: 1.5rem;
}

.card-header {
  padding: 0.625rem 1.5rem;
  margin-bottom: 0;
  background-color: #f6f9fc;
  border-bottom: 0.0625rem solid rgba(0, 0, 0, 0.05);
}
.card-header:first-child {
  border-radius: calc(0.2857rem - 0.0625rem) calc(0.2857rem - 0.0625rem) 0 0;
}

.card-footer {
  padding: 0.625rem 1.5rem;
  background-color: #f6f9fc;
  border-top: 0.0625rem solid rgba(0, 0, 0, 0.05);
}
.card-footer:last-child {
  border-radius: 0 0 calc(0.2857rem - 0.0625rem) calc(0.2857rem - 0.0625rem);
}

.card-header-tabs {
  margin-right: -0.75rem;
  margin-bottom: -0.625rem;
  margin-left: -0.75rem;
  border-bottom: 0;
}
.card-header-tabs .nav-link.active {
  background-color: #ffffff;
  border-bottom-color: #ffffff;
}

.card-header-pills {
  margin-right: -0.75rem;
  margin-left: -0.75rem;
}

.card-img-overlay {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  padding: 1.25rem;
  border-radius: calc(0.2857rem - 0.0625rem);
}

.card-img,
.card-img-top,
.card-img-bottom {
  width: 100%;
}

.card-img,
.card-img-top {
  border-top-left-radius: calc(0.2857rem - 0.0625rem);
  border-top-right-radius: calc(0.2857rem - 0.0625rem);
}

.card-img,
.card-img-bottom {
  border-bottom-right-radius: calc(0.2857rem - 0.0625rem);
  border-bottom-left-radius: calc(0.2857rem - 0.0625rem);
}

.card-group > .card {
  margin-bottom: 0.75rem;
}
@media (min-width: 576px) {
  .card-group {
    display: flex;
    flex-flow: row wrap;
  }
  .card-group > .card {
    flex: 1 0;
    margin-bottom: 0;
  }
  .card-group > .card + .card {
    margin-left: 0;
    border-left: 0;
  }
  .card-group > .card:not(:last-child) {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }
  .card-group > .card:not(:last-child) .card-img-top,
  .card-group > .card:not(:last-child) .card-header {
    border-top-right-radius: 0;
  }
  .card-group > .card:not(:last-child) .card-img-bottom,
  .card-group > .card:not(:last-child) .card-footer {
    border-bottom-right-radius: 0;
  }
  .card-group > .card:not(:first-child) {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }
  .card-group > .card:not(:first-child) .card-img-top,
  .card-group > .card:not(:first-child) .card-header {
    border-top-left-radius: 0;
  }
  .card-group > .card:not(:first-child) .card-img-bottom,
  .card-group > .card:not(:first-child) .card-footer {
    border-bottom-left-radius: 0;
  }
}

.breadcrumb {
  display: flex;
  flex-wrap: wrap;
  padding: 0 0;
  margin-bottom: 1rem;
  list-style: none;
  background-color: #1d253b;
}

.breadcrumb-item + .breadcrumb-item {
  padding-left: 0.5rem;
}
.breadcrumb-item + .breadcrumb-item::before {
  float: left;
  padding-right: 0.5rem;
  color: #ffffff;
  content: "/" /* rtl: var(--bs-breadcrumb-divider, "/") */;
  content: var(--bs-breadcrumb-divider, "/") /* rtl: var(--bs-breadcrumb-divider, "/") */;
}
.breadcrumb-item.active {
  color: #ffffff;
}

.pagination {
  display: flex;
  padding-left: 0;
  list-style: none;
}

.page-link {
  position: relative;
  display: block;
  color: #ffffff;
  background-color: transparent;
  border: 0.0625rem solid #e3e3e3;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .page-link {
    transition: none;
  }
}
.page-link:hover {
  z-index: 2;
  color: #6c757d;
  background-color: #e3e3e3;
  border-color: #e3e3e3;
}
.page-link:focus {
  z-index: 3;
  color: #495e6d;
  background-color: #e9ecef;
  outline: 0;
  box-shadow: none;
}

.page-item:not(:first-child) .page-link {
  margin-left: -0.0625rem;
}
.page-item.active .page-link {
  z-index: 3;
  color: #ffffff;
  background-color: #68869a;
  border-color: #68869a;
}
.page-item.disabled .page-link {
  color: #6c757d;
  pointer-events: none;
  background-color: transparent;
  border-color: #e3e3e3;
}

.page-link {
  padding: 0 0.6875rem;
}

.page-item:first-child .page-link {
  border-top-left-radius: 0.25rem;
  border-bottom-left-radius: 0.25rem;
}
.page-item:last-child .page-link {
  border-top-right-radius: 0.25rem;
  border-bottom-right-radius: 0.25rem;
}

.pagination-lg .page-link {
  padding: 0.75rem 1.5rem;
  font-size: 0.99925rem;
}
.pagination-lg .page-item:first-child .page-link {
  border-top-left-radius: 0.4285rem;
  border-bottom-left-radius: 0.4285rem;
}
.pagination-lg .page-item:last-child .page-link {
  border-top-right-radius: 0.4285rem;
  border-bottom-right-radius: 0.4285rem;
}

.pagination-sm .page-link {
  padding: 0.25rem 0.5rem;
  font-size: 0.7500000025rem;
}
.pagination-sm .page-item:first-child .page-link {
  border-top-left-radius: 0.2857rem;
  border-bottom-left-radius: 0.2857rem;
}
.pagination-sm .page-item:last-child .page-link {
  border-top-right-radius: 0.2857rem;
  border-bottom-right-radius: 0.2857rem;
}

.badge {
  display: inline-block;
  padding: 0.25rem 0.5rem;
  font-size: 0.62475rem;
  font-weight: 700;
  line-height: 1;
  color: #ffffff;
  text-align: center;
  white-space: nowrap;
  vertical-align: baseline;
  border-radius: 0.25rem;
}
.badge:empty {
  display: none;
}

.btn .badge {
  position: relative;
  top: -1px;
}

.alert {
  position: relative;
  padding: 0.9rem 1.25rem;
  margin-bottom: 1rem;
  border: 0.0625rem solid transparent;
  border-radius: 0.2857rem;
}

.alert-heading {
  color: inherit;
}

.alert-link {
  font-weight: 600;
}

.alert-dismissible {
  padding-right: 3.75rem;
}
.alert-dismissible .btn-close {
  position: absolute;
  top: 0;
  right: 0;
  z-index: 2;
  padding: 1.125rem 1.25rem;
}

.alert-default {
  color: #01121d;
  background-color: #ccd2d6;
  border-color: #b3bcc1;
}
.alert-default .alert-link {
  color: #010e17;
}

.alert-primary {
  color: #3e505c;
  background-color: #e1e7eb;
  border-color: #d2dbe1;
}
.alert-primary .alert-link {
  color: #32404a;
}

.alert-secondary {
  color: #565a5e;
  background-color: #f7f9fb;
  border-color: #f3f6f9;
}
.alert-secondary .alert-link {
  color: #45484b;
}

.alert-success {
  color: #3e505c;
  background-color: #e1e7eb;
  border-color: #d2dbe1;
}
.alert-success .alert-link {
  color: #32404a;
}

.alert-info {
  color: #07273a;
  background-color: #ced9df;
  border-color: #b6c6cf;
}
.alert-info .alert-link {
  color: #061f2e;
}

.alert-warning {
  color: #07273a;
  background-color: #ced9df;
  border-color: #b6c6cf;
}
.alert-warning .alert-link {
  color: #061f2e;
}

.alert-danger {
  color: #07273a;
  background-color: #ced9df;
  border-color: #b6c6cf;
}
.alert-danger .alert-link {
  color: #061f2e;
}

.alert-white {
  color: #666666;
  background-color: white;
  border-color: white;
}
.alert-white .alert-link {
  color: #525252;
}

.alert-neutral {
  color: #666666;
  background-color: white;
  border-color: white;
}
.alert-neutral .alert-link {
  color: #525252;
}

.alert-dark {
  color: #141619;
  background-color: #d3d3d4;
  border-color: #bcbebf;
}
.alert-dark .alert-link {
  color: #101214;
}

.alert-darker {
  color: black;
  background-color: #cccccc;
  border-color: #b3b3b3;
}
.alert-darker .alert-link {
  color: black;
}

@keyframes progress-bar-stripes {
  0% {
    background-position-x: 0.5rem;
  }
}
.progress {
  display: flex;
  height: 0.5rem;
  overflow: hidden;
  font-size: 0.65625rem;
  background-color: rgba(0, 0, 0, 0.3);
  border-radius: 0.875rem;
  box-shadow: 0px 0px 0px 3px rgba(0, 0, 0, 0.3);
}

.progress-bar {
  display: flex;
  flex-direction: column;
  justify-content: center;
  overflow: hidden;
  color: #ffffff;
  text-align: center;
  white-space: nowrap;
  background-color: #68869a;
  transition: width 0.6s ease;
}
@media (prefers-reduced-motion: reduce) {
  .progress-bar {
    transition: none;
  }
}

.progress-bar-striped {
  background-image: linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);
  background-size: 0.5rem 0.5rem;
}

.progress-bar-animated {
  animation: 1s linear infinite progress-bar-stripes;
}
@media (prefers-reduced-motion: reduce) {
  .progress-bar-animated {
    animation: none;
  }
}

.list-group {
  display: flex;
  flex-direction: column;
  padding-left: 0;
  margin-bottom: 0;
  border-radius: 0.25rem;
}

.list-group-numbered {
  list-style-type: none;
  counter-reset: section;
}
.list-group-numbered > li::before {
  content: counters(section, ".") ". ";
  counter-increment: section;
}

.list-group-item-action {
  width: 100%;
  color: #525f7f;
  text-align: inherit;
}
.list-group-item-action:hover, .list-group-item-action:focus {
  z-index: 1;
  color: #525f7f;
  text-decoration: none;
  background-color: #f6f9fc;
}
.list-group-item-action:active {
  color: #525f7f;
  background-color: #e9ecef;
}

.list-group-item {
  position: relative;
  display: block;
  padding: 1rem 1rem;
  color: #212529;
  background-color: #ffffff;
  border: 0.0625rem solid #e9ecef;
}
.list-group-item:first-child {
  border-top-left-radius: inherit;
  border-top-right-radius: inherit;
}
.list-group-item:last-child {
  border-bottom-right-radius: inherit;
  border-bottom-left-radius: inherit;
}
.list-group-item.disabled, .list-group-item:disabled {
  color: #6c757d;
  pointer-events: none;
  background-color: #ffffff;
}
.list-group-item.active {
  z-index: 2;
  color: #ffffff;
  background-color: #68869a;
  border-color: #68869a;
}
.list-group-item + .list-group-item {
  border-top-width: 0;
}
.list-group-item + .list-group-item.active {
  margin-top: -0.0625rem;
  border-top-width: 0.0625rem;
}

.list-group-horizontal {
  flex-direction: row;
}
.list-group-horizontal > .list-group-item:first-child {
  border-bottom-left-radius: 0.25rem;
  border-top-right-radius: 0;
}
.list-group-horizontal > .list-group-item:last-child {
  border-top-right-radius: 0.25rem;
  border-bottom-left-radius: 0;
}
.list-group-horizontal > .list-group-item.active {
  margin-top: 0;
}
.list-group-horizontal > .list-group-item + .list-group-item {
  border-top-width: 0.0625rem;
  border-left-width: 0;
}
.list-group-horizontal > .list-group-item + .list-group-item.active {
  margin-left: -0.0625rem;
  border-left-width: 0.0625rem;
}

@media (min-width: 576px) {
  .list-group-horizontal-sm {
    flex-direction: row;
  }
  .list-group-horizontal-sm > .list-group-item:first-child {
    border-bottom-left-radius: 0.25rem;
    border-top-right-radius: 0;
  }
  .list-group-horizontal-sm > .list-group-item:last-child {
    border-top-right-radius: 0.25rem;
    border-bottom-left-radius: 0;
  }
  .list-group-horizontal-sm > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-sm > .list-group-item + .list-group-item {
    border-top-width: 0.0625rem;
    border-left-width: 0;
  }
  .list-group-horizontal-sm > .list-group-item + .list-group-item.active {
    margin-left: -0.0625rem;
    border-left-width: 0.0625rem;
  }
}
@media (min-width: 768px) {
  .list-group-horizontal-md {
    flex-direction: row;
  }
  .list-group-horizontal-md > .list-group-item:first-child {
    border-bottom-left-radius: 0.25rem;
    border-top-right-radius: 0;
  }
  .list-group-horizontal-md > .list-group-item:last-child {
    border-top-right-radius: 0.25rem;
    border-bottom-left-radius: 0;
  }
  .list-group-horizontal-md > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-md > .list-group-item + .list-group-item {
    border-top-width: 0.0625rem;
    border-left-width: 0;
  }
  .list-group-horizontal-md > .list-group-item + .list-group-item.active {
    margin-left: -0.0625rem;
    border-left-width: 0.0625rem;
  }
}
@media (min-width: 992px) {
  .list-group-horizontal-lg {
    flex-direction: row;
  }
  .list-group-horizontal-lg > .list-group-item:first-child {
    border-bottom-left-radius: 0.25rem;
    border-top-right-radius: 0;
  }
  .list-group-horizontal-lg > .list-group-item:last-child {
    border-top-right-radius: 0.25rem;
    border-bottom-left-radius: 0;
  }
  .list-group-horizontal-lg > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-lg > .list-group-item + .list-group-item {
    border-top-width: 0.0625rem;
    border-left-width: 0;
  }
  .list-group-horizontal-lg > .list-group-item + .list-group-item.active {
    margin-left: -0.0625rem;
    border-left-width: 0.0625rem;
  }
}
@media (min-width: 1200px) {
  .list-group-horizontal-xl {
    flex-direction: row;
  }
  .list-group-horizontal-xl > .list-group-item:first-child {
    border-bottom-left-radius: 0.25rem;
    border-top-right-radius: 0;
  }
  .list-group-horizontal-xl > .list-group-item:last-child {
    border-top-right-radius: 0.25rem;
    border-bottom-left-radius: 0;
  }
  .list-group-horizontal-xl > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-xl > .list-group-item + .list-group-item {
    border-top-width: 0.0625rem;
    border-left-width: 0;
  }
  .list-group-horizontal-xl > .list-group-item + .list-group-item.active {
    margin-left: -0.0625rem;
    border-left-width: 0.0625rem;
  }
}
.list-group-flush {
  border-radius: 0;
}
.list-group-flush > .list-group-item {
  border-width: 0 0 0.0625rem;
}
.list-group-flush > .list-group-item:last-child {
  border-bottom-width: 0;
}

.list-group-item-default {
  color: #01121d;
  background-color: #ccd2d6;
}
.list-group-item-default.list-group-item-action:hover, .list-group-item-default.list-group-item-action:focus {
  color: #01121d;
  background-color: #b8bdc1;
}
.list-group-item-default.list-group-item-action.active {
  color: #ffffff;
  background-color: #01121d;
  border-color: #01121d;
}

.list-group-item-primary {
  color: #3e505c;
  background-color: #e1e7eb;
}
.list-group-item-primary.list-group-item-action:hover, .list-group-item-primary.list-group-item-action:focus {
  color: #3e505c;
  background-color: #cbd0d4;
}
.list-group-item-primary.list-group-item-action.active {
  color: #ffffff;
  background-color: #3e505c;
  border-color: #3e505c;
}

.list-group-item-secondary {
  color: #565a5e;
  background-color: #f7f9fb;
}
.list-group-item-secondary.list-group-item-action:hover, .list-group-item-secondary.list-group-item-action:focus {
  color: #565a5e;
  background-color: #dee0e2;
}
.list-group-item-secondary.list-group-item-action.active {
  color: #ffffff;
  background-color: #565a5e;
  border-color: #565a5e;
}

.list-group-item-success {
  color: #3e505c;
  background-color: #e1e7eb;
}
.list-group-item-success.list-group-item-action:hover, .list-group-item-success.list-group-item-action:focus {
  color: #3e505c;
  background-color: #cbd0d4;
}
.list-group-item-success.list-group-item-action.active {
  color: #ffffff;
  background-color: #3e505c;
  border-color: #3e505c;
}

.list-group-item-info {
  color: #07273a;
  background-color: #ced9df;
}
.list-group-item-info.list-group-item-action:hover, .list-group-item-info.list-group-item-action:focus {
  color: #07273a;
  background-color: #b9c3c9;
}
.list-group-item-info.list-group-item-action.active {
  color: #ffffff;
  background-color: #07273a;
  border-color: #07273a;
}

.list-group-item-warning {
  color: #07273a;
  background-color: #ced9df;
}
.list-group-item-warning.list-group-item-action:hover, .list-group-item-warning.list-group-item-action:focus {
  color: #07273a;
  background-color: #b9c3c9;
}
.list-group-item-warning.list-group-item-action.active {
  color: #ffffff;
  background-color: #07273a;
  border-color: #07273a;
}

.list-group-item-danger {
  color: #07273a;
  background-color: #ced9df;
}
.list-group-item-danger.list-group-item-action:hover, .list-group-item-danger.list-group-item-action:focus {
  color: #07273a;
  background-color: #b9c3c9;
}
.list-group-item-danger.list-group-item-action.active {
  color: #ffffff;
  background-color: #07273a;
  border-color: #07273a;
}

.list-group-item-white {
  color: #666666;
  background-color: white;
}
.list-group-item-white.list-group-item-action:hover, .list-group-item-white.list-group-item-action:focus {
  color: #666666;
  background-color: #e6e6e6;
}
.list-group-item-white.list-group-item-action.active {
  color: #ffffff;
  background-color: #666666;
  border-color: #666666;
}

.list-group-item-neutral {
  color: #666666;
  background-color: white;
}
.list-group-item-neutral.list-group-item-action:hover, .list-group-item-neutral.list-group-item-action:focus {
  color: #666666;
  background-color: #e6e6e6;
}
.list-group-item-neutral.list-group-item-action.active {
  color: #ffffff;
  background-color: #666666;
  border-color: #666666;
}

.list-group-item-dark {
  color: #141619;
  background-color: #d3d3d4;
}
.list-group-item-dark.list-group-item-action:hover, .list-group-item-dark.list-group-item-action:focus {
  color: #141619;
  background-color: #bebebf;
}
.list-group-item-dark.list-group-item-action.active {
  color: #ffffff;
  background-color: #141619;
  border-color: #141619;
}

.list-group-item-darker {
  color: black;
  background-color: #cccccc;
}
.list-group-item-darker.list-group-item-action:hover, .list-group-item-darker.list-group-item-action:focus {
  color: black;
  background-color: #b8b8b8;
}
.list-group-item-darker.list-group-item-action.active {
  color: #ffffff;
  background-color: black;
  border-color: black;
}

.btn-close {
  box-sizing: content-box;
  width: 1em;
  height: 1em;
  padding: 0.25em 0.25em;
  color: #000000;
  background: transparent url(${___CSS_LOADER_URL_REPLACEMENT_11___}) center/1em auto no-repeat;
  border: 0;
  border-radius: 0.25rem;
  opacity: 0.5;
}
.btn-close:hover {
  color: #000000;
  text-decoration: none;
  opacity: 0.75;
}
.btn-close:focus {
  outline: 0;
  box-shadow: none;
  opacity: 1;
}
.btn-close:disabled, .btn-close.disabled {
  pointer-events: none;
  -webkit-user-select: none;
          user-select: none;
  opacity: 0.25;
}

.btn-close-white {
  filter: invert(1) grayscale(100%) brightness(200%);
}

.tooltip {
  position: absolute;
  z-index: 1080;
  display: block;
  margin: 0;
  font-family: "Poppins", sans-serif;
  font-style: normal;
  font-weight: 400;
  line-height: 1.5;
  text-align: left;
  text-align: start;
  text-decoration: none;
  text-shadow: none;
  text-transform: none;
  letter-spacing: normal;
  word-break: normal;
  word-spacing: normal;
  white-space: normal;
  line-break: auto;
  font-size: 0.7500000025rem;
  word-wrap: break-word;
  opacity: 0;
}
.tooltip.show {
  opacity: 0.9;
}
.tooltip .tooltip-arrow {
  position: absolute;
  display: block;
  width: 0.8rem;
  height: 0.4rem;
}
.tooltip .tooltip-arrow::before {
  position: absolute;
  content: "";
  border-color: transparent;
  border-style: solid;
}

.bs-tooltip-top, .bs-tooltip-auto[data-popper-placement^=top] {
  padding: 0.4rem 0;
}
.bs-tooltip-top .tooltip-arrow, .bs-tooltip-auto[data-popper-placement^=top] .tooltip-arrow {
  bottom: 0;
}
.bs-tooltip-top .tooltip-arrow::before, .bs-tooltip-auto[data-popper-placement^=top] .tooltip-arrow::before {
  top: -1px;
  border-width: 0.4rem 0.4rem 0;
  border-top-color: #ffffff;
}

.bs-tooltip-end, .bs-tooltip-auto[data-popper-placement^=right] {
  padding: 0 0.4rem;
}
.bs-tooltip-end .tooltip-arrow, .bs-tooltip-auto[data-popper-placement^=right] .tooltip-arrow {
  left: 0;
  width: 0.4rem;
  height: 0.8rem;
}
.bs-tooltip-end .tooltip-arrow::before, .bs-tooltip-auto[data-popper-placement^=right] .tooltip-arrow::before {
  right: -1px;
  border-width: 0.4rem 0.4rem 0.4rem 0;
  border-right-color: #ffffff;
}

.bs-tooltip-bottom, .bs-tooltip-auto[data-popper-placement^=bottom] {
  padding: 0.4rem 0;
}
.bs-tooltip-bottom .tooltip-arrow, .bs-tooltip-auto[data-popper-placement^=bottom] .tooltip-arrow {
  top: 0;
}
.bs-tooltip-bottom .tooltip-arrow::before, .bs-tooltip-auto[data-popper-placement^=bottom] .tooltip-arrow::before {
  bottom: -1px;
  border-width: 0 0.4rem 0.4rem;
  border-bottom-color: #ffffff;
}

.bs-tooltip-start, .bs-tooltip-auto[data-popper-placement^=left] {
  padding: 0 0.4rem;
}
.bs-tooltip-start .tooltip-arrow, .bs-tooltip-auto[data-popper-placement^=left] .tooltip-arrow {
  right: 0;
  width: 0.4rem;
  height: 0.8rem;
}
.bs-tooltip-start .tooltip-arrow::before, .bs-tooltip-auto[data-popper-placement^=left] .tooltip-arrow::before {
  left: -1px;
  border-width: 0.4rem 0 0.4rem 0.4rem;
  border-left-color: #ffffff;
}

.tooltip-inner {
  max-width: 200px;
  padding: 0.25rem 0.5rem;
  color: #000000;
  text-align: center;
  background-color: #ffffff;
  border-radius: 0.25rem;
}

.popover {
  position: absolute;
  top: 0;
  left: 0 /* rtl:ignore */;
  z-index: 1070;
  display: block;
  max-width: 276px;
  font-family: "Poppins", sans-serif;
  font-style: normal;
  font-weight: 400;
  line-height: 1.5;
  text-align: left;
  text-align: start;
  text-decoration: none;
  text-shadow: none;
  text-transform: none;
  letter-spacing: normal;
  word-break: normal;
  word-spacing: normal;
  white-space: normal;
  line-break: auto;
  font-size: 0.7500000025rem;
  word-wrap: break-word;
  background-color: #ffffff;
  background-clip: padding-box;
  border: 1px solid rgba(0, 0, 0, 0.05);
  border-radius: 0.4285rem;
  box-shadow: 0px 0.5rem 2rem 0px rgba(0, 0, 0, 0.2);
}
.popover .popover-arrow {
  position: absolute;
  display: block;
  width: 1.5rem;
  height: 0.75rem;
}
.popover .popover-arrow::before, .popover .popover-arrow::after {
  position: absolute;
  display: block;
  content: "";
  border-color: transparent;
  border-style: solid;
}

.bs-popover-top > .popover-arrow, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow {
  bottom: calc(-0.75rem - 1px);
}
.bs-popover-top > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow::before {
  bottom: 0;
  border-width: 0.75rem 0.75rem 0;
  border-top-color: transparent;
}
.bs-popover-top > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow::after {
  bottom: 1px;
  border-width: 0.75rem 0.75rem 0;
  border-top-color: #ffffff;
}

.bs-popover-end > .popover-arrow, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow {
  left: calc(-0.75rem - 1px);
  width: 0.75rem;
  height: 1.5rem;
}
.bs-popover-end > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow::before {
  left: 0;
  border-width: 0.75rem 0.75rem 0.75rem 0;
  border-right-color: transparent;
}
.bs-popover-end > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow::after {
  left: 1px;
  border-width: 0.75rem 0.75rem 0.75rem 0;
  border-right-color: #ffffff;
}

.bs-popover-bottom > .popover-arrow, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow {
  top: calc(-0.75rem - 1px);
}
.bs-popover-bottom > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::before {
  top: 0;
  border-width: 0 0.75rem 0.75rem 0.75rem;
  border-bottom-color: transparent;
}
.bs-popover-bottom > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::after {
  top: 1px;
  border-width: 0 0.75rem 0.75rem 0.75rem;
  border-bottom-color: #ffffff;
}
.bs-popover-bottom .popover-header::before, .bs-popover-auto[data-popper-placement^=bottom] .popover-header::before {
  position: absolute;
  top: 0;
  left: 50%;
  display: block;
  width: 1.5rem;
  margin-left: -0.75rem;
  content: "";
  border-bottom: 1px solid #ffffff;
}

.bs-popover-start > .popover-arrow, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow {
  right: calc(-0.75rem - 1px);
  width: 0.75rem;
  height: 1.5rem;
}
.bs-popover-start > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow::before {
  right: 0;
  border-width: 0.75rem 0 0.75rem 0.75rem;
  border-left-color: transparent;
}
.bs-popover-start > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow::after {
  right: 1px;
  border-width: 0.75rem 0 0.75rem 0.75rem;
  border-left-color: #ffffff;
}

.popover-header {
  padding: 0.75rem 0.75rem;
  margin-bottom: 0;
  font-size: 0.875rem;
  color: #32325d;
  background-color: #ffffff;
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
  border-top-left-radius: calc(0.4285rem - 1px);
  border-top-right-radius: calc(0.4285rem - 1px);
}
.popover-header:empty {
  display: none;
}

.popover-body {
  padding: 0.75rem 0.75rem;
  color: #525f7f;
}

.carousel {
  position: relative;
}

.carousel.pointer-event {
  touch-action: pan-y;
}

.carousel-inner {
  position: relative;
  width: 100%;
  overflow: hidden;
}
.carousel-inner::after {
  display: block;
  clear: both;
  content: "";
}

.carousel-item {
  position: relative;
  display: none;
  float: left;
  width: 100%;
  margin-right: -100%;
  backface-visibility: hidden;
  transition: transform 0.6s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .carousel-item {
    transition: none;
  }
}

.carousel-item.active,
.carousel-item-next,
.carousel-item-prev {
  display: block;
}

/* rtl:begin:ignore */
.carousel-item-next:not(.carousel-item-start),
.active.carousel-item-end {
  transform: translateX(100%);
}

.carousel-item-prev:not(.carousel-item-end),
.active.carousel-item-start {
  transform: translateX(-100%);
}

/* rtl:end:ignore */
.carousel-fade .carousel-item {
  opacity: 0;
  transition-property: opacity;
  transform: none;
}
.carousel-fade .carousel-item.active,
.carousel-fade .carousel-item-next.carousel-item-start,
.carousel-fade .carousel-item-prev.carousel-item-end {
  z-index: 1;
  opacity: 1;
}
.carousel-fade .active.carousel-item-start,
.carousel-fade .active.carousel-item-end {
  z-index: 0;
  opacity: 0;
  transition: opacity 0s 0.6s;
}
@media (prefers-reduced-motion: reduce) {
  .carousel-fade .active.carousel-item-start,
  .carousel-fade .active.carousel-item-end {
    transition: none;
  }
}

.carousel-control-prev,
.carousel-control-next {
  position: absolute;
  top: 0;
  bottom: 0;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 15%;
  padding: 0;
  color: #ffffff;
  text-align: center;
  background: none;
  border: 0;
  opacity: 0.5;
  transition: opacity 0.15s ease;
}
@media (prefers-reduced-motion: reduce) {
  .carousel-control-prev,
  .carousel-control-next {
    transition: none;
  }
}
.carousel-control-prev:hover, .carousel-control-prev:focus,
.carousel-control-next:hover,
.carousel-control-next:focus {
  color: #ffffff;
  text-decoration: none;
  outline: 0;
  opacity: 0.9;
}

.carousel-control-prev {
  left: 0;
}

.carousel-control-next {
  right: 0;
}

.carousel-control-prev-icon,
.carousel-control-next-icon {
  display: inline-block;
  width: 2rem;
  height: 2rem;
  background-repeat: no-repeat;
  background-position: 50%;
  background-size: 100% 100%;
}

/* rtl:options: {
  "autoRename": true,
  "stringMap":[ {
    "name"    : "prev-next",
    "search"  : "prev",
    "replace" : "next"
  } ]
} */
.carousel-control-prev-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_12___});
}

.carousel-control-next-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_13___});
}

.carousel-indicators {
  position: absolute;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 2;
  display: flex;
  justify-content: center;
  padding: 0;
  margin-right: 15%;
  margin-bottom: 1rem;
  margin-left: 15%;
  list-style: none;
}
.carousel-indicators [data-bs-target] {
  box-sizing: content-box;
  flex: 0 1 auto;
  width: 30px;
  height: 3px;
  padding: 0;
  margin-right: 3px;
  margin-left: 3px;
  text-indent: -999px;
  cursor: pointer;
  background-color: #ffffff;
  background-clip: padding-box;
  border: 0;
  border-top: 10px solid transparent;
  border-bottom: 10px solid transparent;
  opacity: 0.5;
  transition: opacity 0.6s ease;
}
@media (prefers-reduced-motion: reduce) {
  .carousel-indicators [data-bs-target] {
    transition: none;
  }
}
.carousel-indicators .active {
  opacity: 1;
}

.carousel-caption {
  position: absolute;
  right: 15%;
  bottom: 1.25rem;
  left: 15%;
  padding-top: 1.25rem;
  padding-bottom: 1.25rem;
  color: #ffffff;
  text-align: center;
}

.carousel-dark .carousel-control-prev-icon,
.carousel-dark .carousel-control-next-icon {
  filter: invert(1) grayscale(100);
}
.carousel-dark .carousel-indicators [data-bs-target] {
  background-color: #000000;
}
.carousel-dark .carousel-caption {
  color: #000000;
}

/*!
 * Bootstrap Utilities v5.0.2 (https://getbootstrap.com/)
 * Copyright 2011-2021 The Bootstrap Authors
 * Copyright 2011-2021 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 */
.clearfix::after {
  display: block;
  clear: both;
  content: "";
}

.link-default {
  color: #011e31;
}
.link-default:hover, .link-default:focus {
  color: #011827;
}

.link-primary {
  color: #68869a;
}
.link-primary:hover, .link-primary:focus {
  color: #869eae;
}

.link-secondary {
  color: #d7e0eb;
}
.link-secondary:hover, .link-secondary:focus {
  color: #dfe6ef;
}

.link-success {
  color: #68869a;
}
.link-success:hover, .link-success:focus {
  color: #869eae;
}

.link-info {
  color: #0c4160;
}
.link-info:hover, .link-info:focus {
  color: #0a344d;
}

.link-warning {
  color: #0c4160;
}
.link-warning:hover, .link-warning:focus {
  color: #0a344d;
}

.link-danger {
  color: #0c4160;
}
.link-danger:hover, .link-danger:focus {
  color: #0a344d;
}

.link-white {
  color: #ffffff;
}
.link-white:hover, .link-white:focus {
  color: white;
}

.link-neutral {
  color: #ffffff;
}
.link-neutral:hover, .link-neutral:focus {
  color: white;
}

.link-dark {
  color: #212529;
}
.link-dark:hover, .link-dark:focus {
  color: #1a1e21;
}

.link-darker {
  color: black;
}
.link-darker:hover, .link-darker:focus {
  color: black;
}

.ratio {
  position: relative;
  width: 100%;
}
.ratio::before {
  display: block;
  padding-top: var(--bs-aspect-ratio);
  content: "";
}
.ratio > * {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.ratio-1x1 {
  --bs-aspect-ratio: 100%;
}

.ratio-4x3 {
  --bs-aspect-ratio: 75%;
}

.ratio-16x9 {
  --bs-aspect-ratio: 56.25%;
}

.ratio-21x9 {
  --bs-aspect-ratio: 42.8571428571%;
}

.fixed-top {
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  z-index: 1030;
}

.fixed-bottom {
  position: fixed;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1030;
}

.sticky-top {
  position: sticky;
  top: 0;
  z-index: 1020;
}

@media (min-width: 576px) {
  .sticky-sm-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }
}
@media (min-width: 768px) {
  .sticky-md-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }
}
@media (min-width: 992px) {
  .sticky-lg-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }
}
@media (min-width: 1200px) {
  .sticky-xl-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }
}
.visually-hidden,
.visually-hidden-focusable:not(:focus):not(:focus-within) {
  position: absolute !important;
  width: 1px !important;
  height: 1px !important;
  padding: 0 !important;
  margin: -1px !important;
  overflow: hidden !important;
  clip: rect(0, 0, 0, 0) !important;
  white-space: nowrap !important;
  border: 0 !important;
}

.stretched-link::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1;
  content: "";
}

.text-truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.align-baseline {
  vertical-align: baseline !important;
}

.align-top {
  vertical-align: top !important;
}

.align-middle {
  vertical-align: middle !important;
}

.align-bottom {
  vertical-align: bottom !important;
}

.align-text-bottom {
  vertical-align: text-bottom !important;
}

.align-text-top {
  vertical-align: text-top !important;
}

.float-start {
  float: left !important;
}

.float-end {
  float: right !important;
}

.float-none {
  float: none !important;
}

.overflow-auto {
  overflow: auto !important;
}

.overflow-hidden {
  overflow: hidden !important;
}

.overflow-visible {
  overflow: visible !important;
}

.overflow-scroll {
  overflow: scroll !important;
}

.d-inline {
  display: inline !important;
}

.d-inline-block {
  display: inline-block !important;
}

.d-block {
  display: block !important;
}

.d-grid {
  display: grid !important;
}

.d-table {
  display: table !important;
}

.d-table-row {
  display: table-row !important;
}

.d-table-cell {
  display: table-cell !important;
}

.d-flex {
  display: flex !important;
}

.d-inline-flex {
  display: inline-flex !important;
}

.d-none {
  display: none !important;
}

.shadow {
  box-shadow: 0 1px 20px 0px rgba(0, 0, 0, 0.1) !important;
}

.shadow-sm {
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075) !important;
}

.shadow-lg {
  box-shadow: 0 1rem 3rem rgba(0, 0, 0, 0.175) !important;
}

.shadow-none {
  box-shadow: none !important;
}

.position-static {
  position: static !important;
}

.position-relative {
  position: relative !important;
}

.position-absolute {
  position: absolute !important;
}

.position-fixed {
  position: fixed !important;
}

.position-sticky {
  position: sticky !important;
}

.top-0 {
  top: 0 !important;
}

.top-50 {
  top: 50% !important;
}

.top-100 {
  top: 100% !important;
}

.bottom-0 {
  bottom: 0 !important;
}

.bottom-50 {
  bottom: 50% !important;
}

.bottom-100 {
  bottom: 100% !important;
}

.start-0 {
  left: 0 !important;
}

.start-50 {
  left: 50% !important;
}

.start-100 {
  left: 100% !important;
}

.end-0 {
  right: 0 !important;
}

.end-50 {
  right: 50% !important;
}

.end-100 {
  right: 100% !important;
}

.translate-middle {
  transform: translate(-50%, -50%) !important;
}

.translate-middle-x {
  transform: translateX(-50%) !important;
}

.translate-middle-y {
  transform: translateY(-50%) !important;
}

.border {
  border: 0.0625rem solid #e9ecef !important;
}

.border-0 {
  border: 0 !important;
}

.border-top {
  border-top: 0.0625rem solid #e9ecef !important;
}

.border-top-0 {
  border-top: 0 !important;
}

.border-end {
  border-right: 0.0625rem solid #e9ecef !important;
}

.border-end-0 {
  border-right: 0 !important;
}

.border-bottom {
  border-bottom: 0.0625rem solid #e9ecef !important;
}

.border-bottom-0 {
  border-bottom: 0 !important;
}

.border-start {
  border-left: 0.0625rem solid #e9ecef !important;
}

.border-start-0 {
  border-left: 0 !important;
}

.border-default {
  border-color: #011e31 !important;
}

.border-primary {
  border-color: #68869a !important;
}

.border-secondary {
  border-color: #d7e0eb !important;
}

.border-success {
  border-color: #68869a !important;
}

.border-info {
  border-color: #0c4160 !important;
}

.border-warning {
  border-color: #0c4160 !important;
}

.border-danger {
  border-color: #0c4160 !important;
}

.border-white {
  border-color: #ffffff !important;
}

.border-neutral {
  border-color: #ffffff !important;
}

.border-dark {
  border-color: #212529 !important;
}

.border-darker {
  border-color: black !important;
}

.border-1 {
  border-width: 1px !important;
}

.border-2 {
  border-width: 2px !important;
}

.border-3 {
  border-width: 3px !important;
}

.border-4 {
  border-width: 4px !important;
}

.border-5 {
  border-width: 5px !important;
}

.w-25 {
  width: 25% !important;
}

.w-50 {
  width: 50% !important;
}

.w-75 {
  width: 75% !important;
}

.w-100 {
  width: 100% !important;
}

.w-auto {
  width: auto !important;
}

.mw-100 {
  max-width: 100% !important;
}

.vw-100 {
  width: 100vw !important;
}

.min-vw-100 {
  min-width: 100vw !important;
}

.h-25 {
  height: 25% !important;
}

.h-50 {
  height: 50% !important;
}

.h-75 {
  height: 75% !important;
}

.h-100 {
  height: 100% !important;
}

.h-auto {
  height: auto !important;
}

.mh-100 {
  max-height: 100% !important;
}

.vh-100 {
  height: 100vh !important;
}

.min-vh-100 {
  min-height: 100vh !important;
}

.flex-fill {
  flex: 1 1 auto !important;
}

.flex-row {
  flex-direction: row !important;
}

.flex-column {
  flex-direction: column !important;
}

.flex-row-reverse {
  flex-direction: row-reverse !important;
}

.flex-column-reverse {
  flex-direction: column-reverse !important;
}

.flex-grow-0 {
  flex-grow: 0 !important;
}

.flex-grow-1 {
  flex-grow: 1 !important;
}

.flex-shrink-0 {
  flex-shrink: 0 !important;
}

.flex-shrink-1 {
  flex-shrink: 1 !important;
}

.flex-wrap {
  flex-wrap: wrap !important;
}

.flex-nowrap {
  flex-wrap: nowrap !important;
}

.flex-wrap-reverse {
  flex-wrap: wrap-reverse !important;
}

.gap-0 {
  gap: 0 !important;
}

.gap-1 {
  gap: 0.25rem !important;
}

.gap-2 {
  gap: 0.5rem !important;
}

.gap-3 {
  gap: 1rem !important;
}

.gap-4 {
  gap: 1.5rem !important;
}

.gap-5 {
  gap: 3rem !important;
}

.gap-sm {
  gap: 2rem !important;
}

.gap-md {
  gap: 4rem !important;
}

.gap-lg {
  gap: 6rem !important;
}

.gap-xl {
  gap: 8rem !important;
}

.justify-content-start {
  justify-content: flex-start !important;
}

.justify-content-end {
  justify-content: flex-end !important;
}

.justify-content-center {
  justify-content: center !important;
}

.justify-content-between {
  justify-content: space-between !important;
}

.justify-content-around {
  justify-content: space-around !important;
}

.justify-content-evenly {
  justify-content: space-evenly !important;
}

.align-items-start {
  align-items: flex-start !important;
}

.align-items-end {
  align-items: flex-end !important;
}

.align-items-center {
  align-items: center !important;
}

.align-items-baseline {
  align-items: baseline !important;
}

.align-items-stretch {
  align-items: stretch !important;
}

.align-content-start {
  align-content: flex-start !important;
}

.align-content-end {
  align-content: flex-end !important;
}

.align-content-center {
  align-content: center !important;
}

.align-content-between {
  align-content: space-between !important;
}

.align-content-around {
  align-content: space-around !important;
}

.align-content-stretch {
  align-content: stretch !important;
}

.align-self-auto {
  align-self: auto !important;
}

.align-self-start {
  align-self: flex-start !important;
}

.align-self-end {
  align-self: flex-end !important;
}

.align-self-center {
  align-self: center !important;
}

.align-self-baseline {
  align-self: baseline !important;
}

.align-self-stretch {
  align-self: stretch !important;
}

.order-first {
  order: -1 !important;
}

.order-0 {
  order: 0 !important;
}

.order-1 {
  order: 1 !important;
}

.order-2 {
  order: 2 !important;
}

.order-3 {
  order: 3 !important;
}

.order-4 {
  order: 4 !important;
}

.order-5 {
  order: 5 !important;
}

.order-last {
  order: 6 !important;
}

.m-0 {
  margin: 0 !important;
}

.m-1 {
  margin: 0.25rem !important;
}

.m-2 {
  margin: 0.5rem !important;
}

.m-3 {
  margin: 1rem !important;
}

.m-4 {
  margin: 1.5rem !important;
}

.m-5 {
  margin: 3rem !important;
}

.m-sm {
  margin: 2rem !important;
}

.m-md {
  margin: 4rem !important;
}

.m-lg {
  margin: 6rem !important;
}

.m-xl {
  margin: 8rem !important;
}

.m-auto {
  margin: auto !important;
}

.mx-0 {
  margin-right: 0 !important;
  margin-left: 0 !important;
}

.mx-1 {
  margin-right: 0.25rem !important;
  margin-left: 0.25rem !important;
}

.mx-2 {
  margin-right: 0.5rem !important;
  margin-left: 0.5rem !important;
}

.mx-3 {
  margin-right: 1rem !important;
  margin-left: 1rem !important;
}

.mx-4 {
  margin-right: 1.5rem !important;
  margin-left: 1.5rem !important;
}

.mx-5 {
  margin-right: 3rem !important;
  margin-left: 3rem !important;
}

.mx-sm {
  margin-right: 2rem !important;
  margin-left: 2rem !important;
}

.mx-md {
  margin-right: 4rem !important;
  margin-left: 4rem !important;
}

.mx-lg {
  margin-right: 6rem !important;
  margin-left: 6rem !important;
}

.mx-xl {
  margin-right: 8rem !important;
  margin-left: 8rem !important;
}

.mx-auto {
  margin-right: auto !important;
  margin-left: auto !important;
}

.my-0 {
  margin-top: 0 !important;
  margin-bottom: 0 !important;
}

.my-1 {
  margin-top: 0.25rem !important;
  margin-bottom: 0.25rem !important;
}

.my-2 {
  margin-top: 0.5rem !important;
  margin-bottom: 0.5rem !important;
}

.my-3 {
  margin-top: 1rem !important;
  margin-bottom: 1rem !important;
}

.my-4 {
  margin-top: 1.5rem !important;
  margin-bottom: 1.5rem !important;
}

.my-5 {
  margin-top: 3rem !important;
  margin-bottom: 3rem !important;
}

.my-sm {
  margin-top: 2rem !important;
  margin-bottom: 2rem !important;
}

.my-md {
  margin-top: 4rem !important;
  margin-bottom: 4rem !important;
}

.my-lg {
  margin-top: 6rem !important;
  margin-bottom: 6rem !important;
}

.my-xl {
  margin-top: 8rem !important;
  margin-bottom: 8rem !important;
}

.my-auto {
  margin-top: auto !important;
  margin-bottom: auto !important;
}

.mt-0 {
  margin-top: 0 !important;
}

.mt-1 {
  margin-top: 0.25rem !important;
}

.mt-2 {
  margin-top: 0.5rem !important;
}

.mt-3 {
  margin-top: 1rem !important;
}

.mt-4 {
  margin-top: 1.5rem !important;
}

.mt-5 {
  margin-top: 3rem !important;
}

.mt-sm {
  margin-top: 2rem !important;
}

.mt-md {
  margin-top: 4rem !important;
}

.mt-lg {
  margin-top: 6rem !important;
}

.mt-xl {
  margin-top: 8rem !important;
}

.mt-auto {
  margin-top: auto !important;
}

.me-0 {
  margin-right: 0 !important;
}

.me-1 {
  margin-right: 0.25rem !important;
}

.me-2 {
  margin-right: 0.5rem !important;
}

.me-3 {
  margin-right: 1rem !important;
}

.me-4 {
  margin-right: 1.5rem !important;
}

.me-5 {
  margin-right: 3rem !important;
}

.me-sm {
  margin-right: 2rem !important;
}

.me-md {
  margin-right: 4rem !important;
}

.me-lg {
  margin-right: 6rem !important;
}

.me-xl {
  margin-right: 8rem !important;
}

.me-auto {
  margin-right: auto !important;
}

.mb-0 {
  margin-bottom: 0 !important;
}

.mb-1 {
  margin-bottom: 0.25rem !important;
}

.mb-2 {
  margin-bottom: 0.5rem !important;
}

.mb-3 {
  margin-bottom: 1rem !important;
}

.mb-4 {
  margin-bottom: 1.5rem !important;
}

.mb-5 {
  margin-bottom: 3rem !important;
}

.mb-sm {
  margin-bottom: 2rem !important;
}

.mb-md {
  margin-bottom: 4rem !important;
}

.mb-lg {
  margin-bottom: 6rem !important;
}

.mb-xl {
  margin-bottom: 8rem !important;
}

.mb-auto {
  margin-bottom: auto !important;
}

.ms-0 {
  margin-left: 0 !important;
}

.ms-1 {
  margin-left: 0.25rem !important;
}

.ms-2 {
  margin-left: 0.5rem !important;
}

.ms-3 {
  margin-left: 1rem !important;
}

.ms-4 {
  margin-left: 1.5rem !important;
}

.ms-5 {
  margin-left: 3rem !important;
}

.ms-sm {
  margin-left: 2rem !important;
}

.ms-md {
  margin-left: 4rem !important;
}

.ms-lg {
  margin-left: 6rem !important;
}

.ms-xl {
  margin-left: 8rem !important;
}

.ms-auto {
  margin-left: auto !important;
}

.p-0 {
  padding: 0 !important;
}

.p-1 {
  padding: 0.25rem !important;
}

.p-2 {
  padding: 0.5rem !important;
}

.p-3 {
  padding: 1rem !important;
}

.p-4 {
  padding: 1.5rem !important;
}

.p-5 {
  padding: 3rem !important;
}

.p-sm {
  padding: 2rem !important;
}

.p-md {
  padding: 4rem !important;
}

.p-lg {
  padding: 6rem !important;
}

.p-xl {
  padding: 8rem !important;
}

.px-0 {
  padding-right: 0 !important;
  padding-left: 0 !important;
}

.px-1 {
  padding-right: 0.25rem !important;
  padding-left: 0.25rem !important;
}

.px-2 {
  padding-right: 0.5rem !important;
  padding-left: 0.5rem !important;
}

.px-3 {
  padding-right: 1rem !important;
  padding-left: 1rem !important;
}

.px-4 {
  padding-right: 1.5rem !important;
  padding-left: 1.5rem !important;
}

.px-5 {
  padding-right: 3rem !important;
  padding-left: 3rem !important;
}

.px-sm {
  padding-right: 2rem !important;
  padding-left: 2rem !important;
}

.px-md {
  padding-right: 4rem !important;
  padding-left: 4rem !important;
}

.px-lg {
  padding-right: 6rem !important;
  padding-left: 6rem !important;
}

.px-xl {
  padding-right: 8rem !important;
  padding-left: 8rem !important;
}

.py-0 {
  padding-top: 0 !important;
  padding-bottom: 0 !important;
}

.py-1 {
  padding-top: 0.25rem !important;
  padding-bottom: 0.25rem !important;
}

.py-2 {
  padding-top: 0.5rem !important;
  padding-bottom: 0.5rem !important;
}

.py-3 {
  padding-top: 1rem !important;
  padding-bottom: 1rem !important;
}

.py-4 {
  padding-top: 1.5rem !important;
  padding-bottom: 1.5rem !important;
}

.py-5 {
  padding-top: 3rem !important;
  padding-bottom: 3rem !important;
}

.py-sm {
  padding-top: 2rem !important;
  padding-bottom: 2rem !important;
}

.py-md {
  padding-top: 4rem !important;
  padding-bottom: 4rem !important;
}

.py-lg {
  padding-top: 6rem !important;
  padding-bottom: 6rem !important;
}

.py-xl {
  padding-top: 8rem !important;
  padding-bottom: 8rem !important;
}

.pt-0 {
  padding-top: 0 !important;
}

.pt-1 {
  padding-top: 0.25rem !important;
}

.pt-2 {
  padding-top: 0.5rem !important;
}

.pt-3 {
  padding-top: 1rem !important;
}

.pt-4 {
  padding-top: 1.5rem !important;
}

.pt-5 {
  padding-top: 3rem !important;
}

.pt-sm {
  padding-top: 2rem !important;
}

.pt-md {
  padding-top: 4rem !important;
}

.pt-lg {
  padding-top: 6rem !important;
}

.pt-xl {
  padding-top: 8rem !important;
}

.pe-0 {
  padding-right: 0 !important;
}

.pe-1 {
  padding-right: 0.25rem !important;
}

.pe-2 {
  padding-right: 0.5rem !important;
}

.pe-3 {
  padding-right: 1rem !important;
}

.pe-4 {
  padding-right: 1.5rem !important;
}

.pe-5 {
  padding-right: 3rem !important;
}

.pe-sm {
  padding-right: 2rem !important;
}

.pe-md {
  padding-right: 4rem !important;
}

.pe-lg {
  padding-right: 6rem !important;
}

.pe-xl {
  padding-right: 8rem !important;
}

.pb-0 {
  padding-bottom: 0 !important;
}

.pb-1 {
  padding-bottom: 0.25rem !important;
}

.pb-2 {
  padding-bottom: 0.5rem !important;
}

.pb-3 {
  padding-bottom: 1rem !important;
}

.pb-4 {
  padding-bottom: 1.5rem !important;
}

.pb-5 {
  padding-bottom: 3rem !important;
}

.pb-sm {
  padding-bottom: 2rem !important;
}

.pb-md {
  padding-bottom: 4rem !important;
}

.pb-lg {
  padding-bottom: 6rem !important;
}

.pb-xl {
  padding-bottom: 8rem !important;
}

.ps-0 {
  padding-left: 0 !important;
}

.ps-1 {
  padding-left: 0.25rem !important;
}

.ps-2 {
  padding-left: 0.5rem !important;
}

.ps-3 {
  padding-left: 1rem !important;
}

.ps-4 {
  padding-left: 1.5rem !important;
}

.ps-5 {
  padding-left: 3rem !important;
}

.ps-sm {
  padding-left: 2rem !important;
}

.ps-md {
  padding-left: 4rem !important;
}

.ps-lg {
  padding-left: 6rem !important;
}

.ps-xl {
  padding-left: 8rem !important;
}

.font-monospace {
  font-family: SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace !important;
  font-family: var(--bs-font-monospace) !important;
}

.fs-1 {
  font-size: calc(1.3312499994rem + 0.9749999925vw) !important;
}

.fs-2 {
  font-size: calc(1.2937499975rem + 0.52499997vw) !important;
}

.fs-3 {
  font-size: calc(1.2687499875rem + 0.22499985vw) !important;
}

.fs-4 {
  font-size: 1.0624999875rem !important;
}

.fs-5 {
  font-size: 0.812499975rem !important;
}

.fs-6 {
  font-size: 0.74999995rem !important;
}

.fst-italic {
  font-style: italic !important;
}

.fst-normal {
  font-style: normal !important;
}

.fw-light {
  font-weight: 300 !important;
}

.fw-lighter {
  font-weight: lighter !important;
}

.fw-normal {
  font-weight: 400 !important;
}

.fw-bold {
  font-weight: 600 !important;
}

.fw-bolder {
  font-weight: bolder !important;
}

.lh-1 {
  line-height: 1 !important;
}

.lh-sm {
  line-height: 1.5 !important;
}

.lh-base {
  line-height: 1.5 !important;
}

.lh-lg {
  line-height: 1.625rem !important;
}

.text-start {
  text-align: left !important;
}

.text-end {
  text-align: right !important;
}

.text-center {
  text-align: center !important;
}

.text-decoration-none {
  text-decoration: none !important;
}

.text-decoration-underline {
  text-decoration: underline !important;
}

.text-decoration-line-through {
  text-decoration: line-through !important;
}

.text-lowercase {
  text-transform: lowercase !important;
}

.text-uppercase {
  text-transform: uppercase !important;
}

.text-capitalize {
  text-transform: capitalize !important;
}

.text-wrap {
  white-space: normal !important;
}

.text-nowrap {
  white-space: nowrap !important;
}

/* rtl:begin:remove */
.text-break {
  word-wrap: break-word !important;
  word-break: break-word !important;
}

/* rtl:end:remove */
.text-default {
  color: #011e31 !important;
}

.text-primary {
  color: #68869a !important;
}

.text-secondary {
  color: #d7e0eb !important;
}

.text-success {
  color: #68869a !important;
}

.text-info {
  color: #0c4160 !important;
}

.text-warning {
  color: #0c4160 !important;
}

.text-danger {
  color: #0c4160 !important;
}

.text-white {
  color: #ffffff !important;
}

.text-neutral {
  color: #ffffff !important;
}

.text-dark {
  color: #212529 !important;
}

.text-darker {
  color: black !important;
}

.text-body {
  color: #525f7f !important;
}

.text-muted {
  color: #6c757d !important;
}

.text-black-50 {
  color: rgba(0, 0, 0, 0.5) !important;
}

.text-white-50 {
  color: rgba(255, 255, 255, 0.5) !important;
}

.text-reset {
  color: inherit !important;
}

.bg-default {
  background-color: #011e31 !important;
}

.bg-primary {
  background-color: #68869a !important;
}

.bg-secondary {
  background-color: #d7e0eb !important;
}

.bg-success {
  background-color: #68869a !important;
}

.bg-info {
  background-color: #0c4160 !important;
}

.bg-warning {
  background-color: #0c4160 !important;
}

.bg-danger {
  background-color: #0c4160 !important;
}

.bg-white {
  background-color: #ffffff !important;
}

.bg-neutral {
  background-color: #ffffff !important;
}

.bg-dark {
  background-color: #212529 !important;
}

.bg-darker {
  background-color: black !important;
}

.bg-body {
  background-color: #1e1e24 !important;
}

.bg-transparent {
  background-color: transparent !important;
}

.bg-gradient {
  background-image: linear-gradient(180deg, rgba(255, 255, 255, 0.15), rgba(255, 255, 255, 0)) !important;
  background-image: var(--bs-gradient) !important;
}

.user-select-all {
  -webkit-user-select: all !important;
          user-select: all !important;
}

.user-select-auto {
  -webkit-user-select: auto !important;
          user-select: auto !important;
}

.user-select-none {
  -webkit-user-select: none !important;
          user-select: none !important;
}

.pe-none {
  pointer-events: none !important;
}

.pe-auto {
  pointer-events: auto !important;
}

.rounded {
  border-radius: 0.25rem !important;
}

.rounded-0 {
  border-radius: 0 !important;
}

.rounded-1 {
  border-radius: 0.2857rem !important;
}

.rounded-2 {
  border-radius: 0.25rem !important;
}

.rounded-3 {
  border-radius: 0.4285rem !important;
}

.rounded-circle {
  border-radius: 50% !important;
}

.rounded-pill {
  border-radius: 50rem !important;
}

.rounded-top {
  border-top-left-radius: 0.25rem !important;
  border-top-right-radius: 0.25rem !important;
}

.rounded-end {
  border-top-right-radius: 0.25rem !important;
  border-bottom-right-radius: 0.25rem !important;
}

.rounded-bottom {
  border-bottom-right-radius: 0.25rem !important;
  border-bottom-left-radius: 0.25rem !important;
}

.rounded-start {
  border-bottom-left-radius: 0.25rem !important;
  border-top-left-radius: 0.25rem !important;
}

.visible {
  visibility: visible !important;
}

.invisible {
  visibility: hidden !important;
}

@media (min-width: 576px) {
  .float-sm-start {
    float: left !important;
  }
  .float-sm-end {
    float: right !important;
  }
  .float-sm-none {
    float: none !important;
  }
  .d-sm-inline {
    display: inline !important;
  }
  .d-sm-inline-block {
    display: inline-block !important;
  }
  .d-sm-block {
    display: block !important;
  }
  .d-sm-grid {
    display: grid !important;
  }
  .d-sm-table {
    display: table !important;
  }
  .d-sm-table-row {
    display: table-row !important;
  }
  .d-sm-table-cell {
    display: table-cell !important;
  }
  .d-sm-flex {
    display: flex !important;
  }
  .d-sm-inline-flex {
    display: inline-flex !important;
  }
  .d-sm-none {
    display: none !important;
  }
  .flex-sm-fill {
    flex: 1 1 auto !important;
  }
  .flex-sm-row {
    flex-direction: row !important;
  }
  .flex-sm-column {
    flex-direction: column !important;
  }
  .flex-sm-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-sm-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-sm-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-sm-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-sm-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-sm-shrink-1 {
    flex-shrink: 1 !important;
  }
  .flex-sm-wrap {
    flex-wrap: wrap !important;
  }
  .flex-sm-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-sm-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .gap-sm-0 {
    gap: 0 !important;
  }
  .gap-sm-1 {
    gap: 0.25rem !important;
  }
  .gap-sm-2 {
    gap: 0.5rem !important;
  }
  .gap-sm-3 {
    gap: 1rem !important;
  }
  .gap-sm-4 {
    gap: 1.5rem !important;
  }
  .gap-sm-5 {
    gap: 3rem !important;
  }
  .gap-sm-sm {
    gap: 2rem !important;
  }
  .gap-sm-md {
    gap: 4rem !important;
  }
  .gap-sm-lg {
    gap: 6rem !important;
  }
  .gap-sm-xl {
    gap: 8rem !important;
  }
  .justify-content-sm-start {
    justify-content: flex-start !important;
  }
  .justify-content-sm-end {
    justify-content: flex-end !important;
  }
  .justify-content-sm-center {
    justify-content: center !important;
  }
  .justify-content-sm-between {
    justify-content: space-between !important;
  }
  .justify-content-sm-around {
    justify-content: space-around !important;
  }
  .justify-content-sm-evenly {
    justify-content: space-evenly !important;
  }
  .align-items-sm-start {
    align-items: flex-start !important;
  }
  .align-items-sm-end {
    align-items: flex-end !important;
  }
  .align-items-sm-center {
    align-items: center !important;
  }
  .align-items-sm-baseline {
    align-items: baseline !important;
  }
  .align-items-sm-stretch {
    align-items: stretch !important;
  }
  .align-content-sm-start {
    align-content: flex-start !important;
  }
  .align-content-sm-end {
    align-content: flex-end !important;
  }
  .align-content-sm-center {
    align-content: center !important;
  }
  .align-content-sm-between {
    align-content: space-between !important;
  }
  .align-content-sm-around {
    align-content: space-around !important;
  }
  .align-content-sm-stretch {
    align-content: stretch !important;
  }
  .align-self-sm-auto {
    align-self: auto !important;
  }
  .align-self-sm-start {
    align-self: flex-start !important;
  }
  .align-self-sm-end {
    align-self: flex-end !important;
  }
  .align-self-sm-center {
    align-self: center !important;
  }
  .align-self-sm-baseline {
    align-self: baseline !important;
  }
  .align-self-sm-stretch {
    align-self: stretch !important;
  }
  .order-sm-first {
    order: -1 !important;
  }
  .order-sm-0 {
    order: 0 !important;
  }
  .order-sm-1 {
    order: 1 !important;
  }
  .order-sm-2 {
    order: 2 !important;
  }
  .order-sm-3 {
    order: 3 !important;
  }
  .order-sm-4 {
    order: 4 !important;
  }
  .order-sm-5 {
    order: 5 !important;
  }
  .order-sm-last {
    order: 6 !important;
  }
  .m-sm-0 {
    margin: 0 !important;
  }
  .m-sm-1 {
    margin: 0.25rem !important;
  }
  .m-sm-2 {
    margin: 0.5rem !important;
  }
  .m-sm-3 {
    margin: 1rem !important;
  }
  .m-sm-4 {
    margin: 1.5rem !important;
  }
  .m-sm-5 {
    margin: 3rem !important;
  }
  .m-sm-sm {
    margin: 2rem !important;
  }
  .m-sm-md {
    margin: 4rem !important;
  }
  .m-sm-lg {
    margin: 6rem !important;
  }
  .m-sm-xl {
    margin: 8rem !important;
  }
  .m-sm-auto {
    margin: auto !important;
  }
  .mx-sm-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
  .mx-sm-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important;
  }
  .mx-sm-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important;
  }
  .mx-sm-3 {
    margin-right: 1rem !important;
    margin-left: 1rem !important;
  }
  .mx-sm-4 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }
  .mx-sm-5 {
    margin-right: 3rem !important;
    margin-left: 3rem !important;
  }
  .mx-sm-sm {
    margin-right: 2rem !important;
    margin-left: 2rem !important;
  }
  .mx-sm-md {
    margin-right: 4rem !important;
    margin-left: 4rem !important;
  }
  .mx-sm-lg {
    margin-right: 6rem !important;
    margin-left: 6rem !important;
  }
  .mx-sm-xl {
    margin-right: 8rem !important;
    margin-left: 8rem !important;
  }
  .mx-sm-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
  .my-sm-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
  .my-sm-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }
  .my-sm-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }
  .my-sm-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }
  .my-sm-4 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }
  .my-sm-5 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }
  .my-sm-sm {
    margin-top: 2rem !important;
    margin-bottom: 2rem !important;
  }
  .my-sm-md {
    margin-top: 4rem !important;
    margin-bottom: 4rem !important;
  }
  .my-sm-lg {
    margin-top: 6rem !important;
    margin-bottom: 6rem !important;
  }
  .my-sm-xl {
    margin-top: 8rem !important;
    margin-bottom: 8rem !important;
  }
  .my-sm-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }
  .mt-sm-0 {
    margin-top: 0 !important;
  }
  .mt-sm-1 {
    margin-top: 0.25rem !important;
  }
  .mt-sm-2 {
    margin-top: 0.5rem !important;
  }
  .mt-sm-3 {
    margin-top: 1rem !important;
  }
  .mt-sm-4 {
    margin-top: 1.5rem !important;
  }
  .mt-sm-5 {
    margin-top: 3rem !important;
  }
  .mt-sm-sm {
    margin-top: 2rem !important;
  }
  .mt-sm-md {
    margin-top: 4rem !important;
  }
  .mt-sm-lg {
    margin-top: 6rem !important;
  }
  .mt-sm-xl {
    margin-top: 8rem !important;
  }
  .mt-sm-auto {
    margin-top: auto !important;
  }
  .me-sm-0 {
    margin-right: 0 !important;
  }
  .me-sm-1 {
    margin-right: 0.25rem !important;
  }
  .me-sm-2 {
    margin-right: 0.5rem !important;
  }
  .me-sm-3 {
    margin-right: 1rem !important;
  }
  .me-sm-4 {
    margin-right: 1.5rem !important;
  }
  .me-sm-5 {
    margin-right: 3rem !important;
  }
  .me-sm-sm {
    margin-right: 2rem !important;
  }
  .me-sm-md {
    margin-right: 4rem !important;
  }
  .me-sm-lg {
    margin-right: 6rem !important;
  }
  .me-sm-xl {
    margin-right: 8rem !important;
  }
  .me-sm-auto {
    margin-right: auto !important;
  }
  .mb-sm-0 {
    margin-bottom: 0 !important;
  }
  .mb-sm-1 {
    margin-bottom: 0.25rem !important;
  }
  .mb-sm-2 {
    margin-bottom: 0.5rem !important;
  }
  .mb-sm-3 {
    margin-bottom: 1rem !important;
  }
  .mb-sm-4 {
    margin-bottom: 1.5rem !important;
  }
  .mb-sm-5 {
    margin-bottom: 3rem !important;
  }
  .mb-sm-sm {
    margin-bottom: 2rem !important;
  }
  .mb-sm-md {
    margin-bottom: 4rem !important;
  }
  .mb-sm-lg {
    margin-bottom: 6rem !important;
  }
  .mb-sm-xl {
    margin-bottom: 8rem !important;
  }
  .mb-sm-auto {
    margin-bottom: auto !important;
  }
  .ms-sm-0 {
    margin-left: 0 !important;
  }
  .ms-sm-1 {
    margin-left: 0.25rem !important;
  }
  .ms-sm-2 {
    margin-left: 0.5rem !important;
  }
  .ms-sm-3 {
    margin-left: 1rem !important;
  }
  .ms-sm-4 {
    margin-left: 1.5rem !important;
  }
  .ms-sm-5 {
    margin-left: 3rem !important;
  }
  .ms-sm-sm {
    margin-left: 2rem !important;
  }
  .ms-sm-md {
    margin-left: 4rem !important;
  }
  .ms-sm-lg {
    margin-left: 6rem !important;
  }
  .ms-sm-xl {
    margin-left: 8rem !important;
  }
  .ms-sm-auto {
    margin-left: auto !important;
  }
  .p-sm-0 {
    padding: 0 !important;
  }
  .p-sm-1 {
    padding: 0.25rem !important;
  }
  .p-sm-2 {
    padding: 0.5rem !important;
  }
  .p-sm-3 {
    padding: 1rem !important;
  }
  .p-sm-4 {
    padding: 1.5rem !important;
  }
  .p-sm-5 {
    padding: 3rem !important;
  }
  .p-sm-sm {
    padding: 2rem !important;
  }
  .p-sm-md {
    padding: 4rem !important;
  }
  .p-sm-lg {
    padding: 6rem !important;
  }
  .p-sm-xl {
    padding: 8rem !important;
  }
  .px-sm-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
  .px-sm-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important;
  }
  .px-sm-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important;
  }
  .px-sm-3 {
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }
  .px-sm-4 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }
  .px-sm-5 {
    padding-right: 3rem !important;
    padding-left: 3rem !important;
  }
  .px-sm-sm {
    padding-right: 2rem !important;
    padding-left: 2rem !important;
  }
  .px-sm-md {
    padding-right: 4rem !important;
    padding-left: 4rem !important;
  }
  .px-sm-lg {
    padding-right: 6rem !important;
    padding-left: 6rem !important;
  }
  .px-sm-xl {
    padding-right: 8rem !important;
    padding-left: 8rem !important;
  }
  .py-sm-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  .py-sm-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }
  .py-sm-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }
  .py-sm-3 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }
  .py-sm-4 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }
  .py-sm-5 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }
  .py-sm-sm {
    padding-top: 2rem !important;
    padding-bottom: 2rem !important;
  }
  .py-sm-md {
    padding-top: 4rem !important;
    padding-bottom: 4rem !important;
  }
  .py-sm-lg {
    padding-top: 6rem !important;
    padding-bottom: 6rem !important;
  }
  .py-sm-xl {
    padding-top: 8rem !important;
    padding-bottom: 8rem !important;
  }
  .pt-sm-0 {
    padding-top: 0 !important;
  }
  .pt-sm-1 {
    padding-top: 0.25rem !important;
  }
  .pt-sm-2 {
    padding-top: 0.5rem !important;
  }
  .pt-sm-3 {
    padding-top: 1rem !important;
  }
  .pt-sm-4 {
    padding-top: 1.5rem !important;
  }
  .pt-sm-5 {
    padding-top: 3rem !important;
  }
  .pt-sm-sm {
    padding-top: 2rem !important;
  }
  .pt-sm-md {
    padding-top: 4rem !important;
  }
  .pt-sm-lg {
    padding-top: 6rem !important;
  }
  .pt-sm-xl {
    padding-top: 8rem !important;
  }
  .pe-sm-0 {
    padding-right: 0 !important;
  }
  .pe-sm-1 {
    padding-right: 0.25rem !important;
  }
  .pe-sm-2 {
    padding-right: 0.5rem !important;
  }
  .pe-sm-3 {
    padding-right: 1rem !important;
  }
  .pe-sm-4 {
    padding-right: 1.5rem !important;
  }
  .pe-sm-5 {
    padding-right: 3rem !important;
  }
  .pe-sm-sm {
    padding-right: 2rem !important;
  }
  .pe-sm-md {
    padding-right: 4rem !important;
  }
  .pe-sm-lg {
    padding-right: 6rem !important;
  }
  .pe-sm-xl {
    padding-right: 8rem !important;
  }
  .pb-sm-0 {
    padding-bottom: 0 !important;
  }
  .pb-sm-1 {
    padding-bottom: 0.25rem !important;
  }
  .pb-sm-2 {
    padding-bottom: 0.5rem !important;
  }
  .pb-sm-3 {
    padding-bottom: 1rem !important;
  }
  .pb-sm-4 {
    padding-bottom: 1.5rem !important;
  }
  .pb-sm-5 {
    padding-bottom: 3rem !important;
  }
  .pb-sm-sm {
    padding-bottom: 2rem !important;
  }
  .pb-sm-md {
    padding-bottom: 4rem !important;
  }
  .pb-sm-lg {
    padding-bottom: 6rem !important;
  }
  .pb-sm-xl {
    padding-bottom: 8rem !important;
  }
  .ps-sm-0 {
    padding-left: 0 !important;
  }
  .ps-sm-1 {
    padding-left: 0.25rem !important;
  }
  .ps-sm-2 {
    padding-left: 0.5rem !important;
  }
  .ps-sm-3 {
    padding-left: 1rem !important;
  }
  .ps-sm-4 {
    padding-left: 1.5rem !important;
  }
  .ps-sm-5 {
    padding-left: 3rem !important;
  }
  .ps-sm-sm {
    padding-left: 2rem !important;
  }
  .ps-sm-md {
    padding-left: 4rem !important;
  }
  .ps-sm-lg {
    padding-left: 6rem !important;
  }
  .ps-sm-xl {
    padding-left: 8rem !important;
  }
  .text-sm-start {
    text-align: left !important;
  }
  .text-sm-end {
    text-align: right !important;
  }
  .text-sm-center {
    text-align: center !important;
  }
}
@media (min-width: 768px) {
  .float-md-start {
    float: left !important;
  }
  .float-md-end {
    float: right !important;
  }
  .float-md-none {
    float: none !important;
  }
  .d-md-inline {
    display: inline !important;
  }
  .d-md-inline-block {
    display: inline-block !important;
  }
  .d-md-block {
    display: block !important;
  }
  .d-md-grid {
    display: grid !important;
  }
  .d-md-table {
    display: table !important;
  }
  .d-md-table-row {
    display: table-row !important;
  }
  .d-md-table-cell {
    display: table-cell !important;
  }
  .d-md-flex {
    display: flex !important;
  }
  .d-md-inline-flex {
    display: inline-flex !important;
  }
  .d-md-none {
    display: none !important;
  }
  .flex-md-fill {
    flex: 1 1 auto !important;
  }
  .flex-md-row {
    flex-direction: row !important;
  }
  .flex-md-column {
    flex-direction: column !important;
  }
  .flex-md-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-md-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-md-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-md-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-md-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-md-shrink-1 {
    flex-shrink: 1 !important;
  }
  .flex-md-wrap {
    flex-wrap: wrap !important;
  }
  .flex-md-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-md-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .gap-md-0 {
    gap: 0 !important;
  }
  .gap-md-1 {
    gap: 0.25rem !important;
  }
  .gap-md-2 {
    gap: 0.5rem !important;
  }
  .gap-md-3 {
    gap: 1rem !important;
  }
  .gap-md-4 {
    gap: 1.5rem !important;
  }
  .gap-md-5 {
    gap: 3rem !important;
  }
  .gap-md-sm {
    gap: 2rem !important;
  }
  .gap-md-md {
    gap: 4rem !important;
  }
  .gap-md-lg {
    gap: 6rem !important;
  }
  .gap-md-xl {
    gap: 8rem !important;
  }
  .justify-content-md-start {
    justify-content: flex-start !important;
  }
  .justify-content-md-end {
    justify-content: flex-end !important;
  }
  .justify-content-md-center {
    justify-content: center !important;
  }
  .justify-content-md-between {
    justify-content: space-between !important;
  }
  .justify-content-md-around {
    justify-content: space-around !important;
  }
  .justify-content-md-evenly {
    justify-content: space-evenly !important;
  }
  .align-items-md-start {
    align-items: flex-start !important;
  }
  .align-items-md-end {
    align-items: flex-end !important;
  }
  .align-items-md-center {
    align-items: center !important;
  }
  .align-items-md-baseline {
    align-items: baseline !important;
  }
  .align-items-md-stretch {
    align-items: stretch !important;
  }
  .align-content-md-start {
    align-content: flex-start !important;
  }
  .align-content-md-end {
    align-content: flex-end !important;
  }
  .align-content-md-center {
    align-content: center !important;
  }
  .align-content-md-between {
    align-content: space-between !important;
  }
  .align-content-md-around {
    align-content: space-around !important;
  }
  .align-content-md-stretch {
    align-content: stretch !important;
  }
  .align-self-md-auto {
    align-self: auto !important;
  }
  .align-self-md-start {
    align-self: flex-start !important;
  }
  .align-self-md-end {
    align-self: flex-end !important;
  }
  .align-self-md-center {
    align-self: center !important;
  }
  .align-self-md-baseline {
    align-self: baseline !important;
  }
  .align-self-md-stretch {
    align-self: stretch !important;
  }
  .order-md-first {
    order: -1 !important;
  }
  .order-md-0 {
    order: 0 !important;
  }
  .order-md-1 {
    order: 1 !important;
  }
  .order-md-2 {
    order: 2 !important;
  }
  .order-md-3 {
    order: 3 !important;
  }
  .order-md-4 {
    order: 4 !important;
  }
  .order-md-5 {
    order: 5 !important;
  }
  .order-md-last {
    order: 6 !important;
  }
  .m-md-0 {
    margin: 0 !important;
  }
  .m-md-1 {
    margin: 0.25rem !important;
  }
  .m-md-2 {
    margin: 0.5rem !important;
  }
  .m-md-3 {
    margin: 1rem !important;
  }
  .m-md-4 {
    margin: 1.5rem !important;
  }
  .m-md-5 {
    margin: 3rem !important;
  }
  .m-md-sm {
    margin: 2rem !important;
  }
  .m-md-md {
    margin: 4rem !important;
  }
  .m-md-lg {
    margin: 6rem !important;
  }
  .m-md-xl {
    margin: 8rem !important;
  }
  .m-md-auto {
    margin: auto !important;
  }
  .mx-md-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
  .mx-md-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important;
  }
  .mx-md-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important;
  }
  .mx-md-3 {
    margin-right: 1rem !important;
    margin-left: 1rem !important;
  }
  .mx-md-4 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }
  .mx-md-5 {
    margin-right: 3rem !important;
    margin-left: 3rem !important;
  }
  .mx-md-sm {
    margin-right: 2rem !important;
    margin-left: 2rem !important;
  }
  .mx-md-md {
    margin-right: 4rem !important;
    margin-left: 4rem !important;
  }
  .mx-md-lg {
    margin-right: 6rem !important;
    margin-left: 6rem !important;
  }
  .mx-md-xl {
    margin-right: 8rem !important;
    margin-left: 8rem !important;
  }
  .mx-md-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
  .my-md-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
  .my-md-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }
  .my-md-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }
  .my-md-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }
  .my-md-4 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }
  .my-md-5 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }
  .my-md-sm {
    margin-top: 2rem !important;
    margin-bottom: 2rem !important;
  }
  .my-md-md {
    margin-top: 4rem !important;
    margin-bottom: 4rem !important;
  }
  .my-md-lg {
    margin-top: 6rem !important;
    margin-bottom: 6rem !important;
  }
  .my-md-xl {
    margin-top: 8rem !important;
    margin-bottom: 8rem !important;
  }
  .my-md-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }
  .mt-md-0 {
    margin-top: 0 !important;
  }
  .mt-md-1 {
    margin-top: 0.25rem !important;
  }
  .mt-md-2 {
    margin-top: 0.5rem !important;
  }
  .mt-md-3 {
    margin-top: 1rem !important;
  }
  .mt-md-4 {
    margin-top: 1.5rem !important;
  }
  .mt-md-5 {
    margin-top: 3rem !important;
  }
  .mt-md-sm {
    margin-top: 2rem !important;
  }
  .mt-md-md {
    margin-top: 4rem !important;
  }
  .mt-md-lg {
    margin-top: 6rem !important;
  }
  .mt-md-xl {
    margin-top: 8rem !important;
  }
  .mt-md-auto {
    margin-top: auto !important;
  }
  .me-md-0 {
    margin-right: 0 !important;
  }
  .me-md-1 {
    margin-right: 0.25rem !important;
  }
  .me-md-2 {
    margin-right: 0.5rem !important;
  }
  .me-md-3 {
    margin-right: 1rem !important;
  }
  .me-md-4 {
    margin-right: 1.5rem !important;
  }
  .me-md-5 {
    margin-right: 3rem !important;
  }
  .me-md-sm {
    margin-right: 2rem !important;
  }
  .me-md-md {
    margin-right: 4rem !important;
  }
  .me-md-lg {
    margin-right: 6rem !important;
  }
  .me-md-xl {
    margin-right: 8rem !important;
  }
  .me-md-auto {
    margin-right: auto !important;
  }
  .mb-md-0 {
    margin-bottom: 0 !important;
  }
  .mb-md-1 {
    margin-bottom: 0.25rem !important;
  }
  .mb-md-2 {
    margin-bottom: 0.5rem !important;
  }
  .mb-md-3 {
    margin-bottom: 1rem !important;
  }
  .mb-md-4 {
    margin-bottom: 1.5rem !important;
  }
  .mb-md-5 {
    margin-bottom: 3rem !important;
  }
  .mb-md-sm {
    margin-bottom: 2rem !important;
  }
  .mb-md-md {
    margin-bottom: 4rem !important;
  }
  .mb-md-lg {
    margin-bottom: 6rem !important;
  }
  .mb-md-xl {
    margin-bottom: 8rem !important;
  }
  .mb-md-auto {
    margin-bottom: auto !important;
  }
  .ms-md-0 {
    margin-left: 0 !important;
  }
  .ms-md-1 {
    margin-left: 0.25rem !important;
  }
  .ms-md-2 {
    margin-left: 0.5rem !important;
  }
  .ms-md-3 {
    margin-left: 1rem !important;
  }
  .ms-md-4 {
    margin-left: 1.5rem !important;
  }
  .ms-md-5 {
    margin-left: 3rem !important;
  }
  .ms-md-sm {
    margin-left: 2rem !important;
  }
  .ms-md-md {
    margin-left: 4rem !important;
  }
  .ms-md-lg {
    margin-left: 6rem !important;
  }
  .ms-md-xl {
    margin-left: 8rem !important;
  }
  .ms-md-auto {
    margin-left: auto !important;
  }
  .p-md-0 {
    padding: 0 !important;
  }
  .p-md-1 {
    padding: 0.25rem !important;
  }
  .p-md-2 {
    padding: 0.5rem !important;
  }
  .p-md-3 {
    padding: 1rem !important;
  }
  .p-md-4 {
    padding: 1.5rem !important;
  }
  .p-md-5 {
    padding: 3rem !important;
  }
  .p-md-sm {
    padding: 2rem !important;
  }
  .p-md-md {
    padding: 4rem !important;
  }
  .p-md-lg {
    padding: 6rem !important;
  }
  .p-md-xl {
    padding: 8rem !important;
  }
  .px-md-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
  .px-md-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important;
  }
  .px-md-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important;
  }
  .px-md-3 {
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }
  .px-md-4 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }
  .px-md-5 {
    padding-right: 3rem !important;
    padding-left: 3rem !important;
  }
  .px-md-sm {
    padding-right: 2rem !important;
    padding-left: 2rem !important;
  }
  .px-md-md {
    padding-right: 4rem !important;
    padding-left: 4rem !important;
  }
  .px-md-lg {
    padding-right: 6rem !important;
    padding-left: 6rem !important;
  }
  .px-md-xl {
    padding-right: 8rem !important;
    padding-left: 8rem !important;
  }
  .py-md-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  .py-md-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }
  .py-md-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }
  .py-md-3 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }
  .py-md-4 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }
  .py-md-5 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }
  .py-md-sm {
    padding-top: 2rem !important;
    padding-bottom: 2rem !important;
  }
  .py-md-md {
    padding-top: 4rem !important;
    padding-bottom: 4rem !important;
  }
  .py-md-lg {
    padding-top: 6rem !important;
    padding-bottom: 6rem !important;
  }
  .py-md-xl {
    padding-top: 8rem !important;
    padding-bottom: 8rem !important;
  }
  .pt-md-0 {
    padding-top: 0 !important;
  }
  .pt-md-1 {
    padding-top: 0.25rem !important;
  }
  .pt-md-2 {
    padding-top: 0.5rem !important;
  }
  .pt-md-3 {
    padding-top: 1rem !important;
  }
  .pt-md-4 {
    padding-top: 1.5rem !important;
  }
  .pt-md-5 {
    padding-top: 3rem !important;
  }
  .pt-md-sm {
    padding-top: 2rem !important;
  }
  .pt-md-md {
    padding-top: 4rem !important;
  }
  .pt-md-lg {
    padding-top: 6rem !important;
  }
  .pt-md-xl {
    padding-top: 8rem !important;
  }
  .pe-md-0 {
    padding-right: 0 !important;
  }
  .pe-md-1 {
    padding-right: 0.25rem !important;
  }
  .pe-md-2 {
    padding-right: 0.5rem !important;
  }
  .pe-md-3 {
    padding-right: 1rem !important;
  }
  .pe-md-4 {
    padding-right: 1.5rem !important;
  }
  .pe-md-5 {
    padding-right: 3rem !important;
  }
  .pe-md-sm {
    padding-right: 2rem !important;
  }
  .pe-md-md {
    padding-right: 4rem !important;
  }
  .pe-md-lg {
    padding-right: 6rem !important;
  }
  .pe-md-xl {
    padding-right: 8rem !important;
  }
  .pb-md-0 {
    padding-bottom: 0 !important;
  }
  .pb-md-1 {
    padding-bottom: 0.25rem !important;
  }
  .pb-md-2 {
    padding-bottom: 0.5rem !important;
  }
  .pb-md-3 {
    padding-bottom: 1rem !important;
  }
  .pb-md-4 {
    padding-bottom: 1.5rem !important;
  }
  .pb-md-5 {
    padding-bottom: 3rem !important;
  }
  .pb-md-sm {
    padding-bottom: 2rem !important;
  }
  .pb-md-md {
    padding-bottom: 4rem !important;
  }
  .pb-md-lg {
    padding-bottom: 6rem !important;
  }
  .pb-md-xl {
    padding-bottom: 8rem !important;
  }
  .ps-md-0 {
    padding-left: 0 !important;
  }
  .ps-md-1 {
    padding-left: 0.25rem !important;
  }
  .ps-md-2 {
    padding-left: 0.5rem !important;
  }
  .ps-md-3 {
    padding-left: 1rem !important;
  }
  .ps-md-4 {
    padding-left: 1.5rem !important;
  }
  .ps-md-5 {
    padding-left: 3rem !important;
  }
  .ps-md-sm {
    padding-left: 2rem !important;
  }
  .ps-md-md {
    padding-left: 4rem !important;
  }
  .ps-md-lg {
    padding-left: 6rem !important;
  }
  .ps-md-xl {
    padding-left: 8rem !important;
  }
  .text-md-start {
    text-align: left !important;
  }
  .text-md-end {
    text-align: right !important;
  }
  .text-md-center {
    text-align: center !important;
  }
}
@media (min-width: 992px) {
  .float-lg-start {
    float: left !important;
  }
  .float-lg-end {
    float: right !important;
  }
  .float-lg-none {
    float: none !important;
  }
  .d-lg-inline {
    display: inline !important;
  }
  .d-lg-inline-block {
    display: inline-block !important;
  }
  .d-lg-block {
    display: block !important;
  }
  .d-lg-grid {
    display: grid !important;
  }
  .d-lg-table {
    display: table !important;
  }
  .d-lg-table-row {
    display: table-row !important;
  }
  .d-lg-table-cell {
    display: table-cell !important;
  }
  .d-lg-flex {
    display: flex !important;
  }
  .d-lg-inline-flex {
    display: inline-flex !important;
  }
  .d-lg-none {
    display: none !important;
  }
  .flex-lg-fill {
    flex: 1 1 auto !important;
  }
  .flex-lg-row {
    flex-direction: row !important;
  }
  .flex-lg-column {
    flex-direction: column !important;
  }
  .flex-lg-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-lg-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-lg-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-lg-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-lg-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-lg-shrink-1 {
    flex-shrink: 1 !important;
  }
  .flex-lg-wrap {
    flex-wrap: wrap !important;
  }
  .flex-lg-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-lg-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .gap-lg-0 {
    gap: 0 !important;
  }
  .gap-lg-1 {
    gap: 0.25rem !important;
  }
  .gap-lg-2 {
    gap: 0.5rem !important;
  }
  .gap-lg-3 {
    gap: 1rem !important;
  }
  .gap-lg-4 {
    gap: 1.5rem !important;
  }
  .gap-lg-5 {
    gap: 3rem !important;
  }
  .gap-lg-sm {
    gap: 2rem !important;
  }
  .gap-lg-md {
    gap: 4rem !important;
  }
  .gap-lg-lg {
    gap: 6rem !important;
  }
  .gap-lg-xl {
    gap: 8rem !important;
  }
  .justify-content-lg-start {
    justify-content: flex-start !important;
  }
  .justify-content-lg-end {
    justify-content: flex-end !important;
  }
  .justify-content-lg-center {
    justify-content: center !important;
  }
  .justify-content-lg-between {
    justify-content: space-between !important;
  }
  .justify-content-lg-around {
    justify-content: space-around !important;
  }
  .justify-content-lg-evenly {
    justify-content: space-evenly !important;
  }
  .align-items-lg-start {
    align-items: flex-start !important;
  }
  .align-items-lg-end {
    align-items: flex-end !important;
  }
  .align-items-lg-center {
    align-items: center !important;
  }
  .align-items-lg-baseline {
    align-items: baseline !important;
  }
  .align-items-lg-stretch {
    align-items: stretch !important;
  }
  .align-content-lg-start {
    align-content: flex-start !important;
  }
  .align-content-lg-end {
    align-content: flex-end !important;
  }
  .align-content-lg-center {
    align-content: center !important;
  }
  .align-content-lg-between {
    align-content: space-between !important;
  }
  .align-content-lg-around {
    align-content: space-around !important;
  }
  .align-content-lg-stretch {
    align-content: stretch !important;
  }
  .align-self-lg-auto {
    align-self: auto !important;
  }
  .align-self-lg-start {
    align-self: flex-start !important;
  }
  .align-self-lg-end {
    align-self: flex-end !important;
  }
  .align-self-lg-center {
    align-self: center !important;
  }
  .align-self-lg-baseline {
    align-self: baseline !important;
  }
  .align-self-lg-stretch {
    align-self: stretch !important;
  }
  .order-lg-first {
    order: -1 !important;
  }
  .order-lg-0 {
    order: 0 !important;
  }
  .order-lg-1 {
    order: 1 !important;
  }
  .order-lg-2 {
    order: 2 !important;
  }
  .order-lg-3 {
    order: 3 !important;
  }
  .order-lg-4 {
    order: 4 !important;
  }
  .order-lg-5 {
    order: 5 !important;
  }
  .order-lg-last {
    order: 6 !important;
  }
  .m-lg-0 {
    margin: 0 !important;
  }
  .m-lg-1 {
    margin: 0.25rem !important;
  }
  .m-lg-2 {
    margin: 0.5rem !important;
  }
  .m-lg-3 {
    margin: 1rem !important;
  }
  .m-lg-4 {
    margin: 1.5rem !important;
  }
  .m-lg-5 {
    margin: 3rem !important;
  }
  .m-lg-sm {
    margin: 2rem !important;
  }
  .m-lg-md {
    margin: 4rem !important;
  }
  .m-lg-lg {
    margin: 6rem !important;
  }
  .m-lg-xl {
    margin: 8rem !important;
  }
  .m-lg-auto {
    margin: auto !important;
  }
  .mx-lg-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
  .mx-lg-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important;
  }
  .mx-lg-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important;
  }
  .mx-lg-3 {
    margin-right: 1rem !important;
    margin-left: 1rem !important;
  }
  .mx-lg-4 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }
  .mx-lg-5 {
    margin-right: 3rem !important;
    margin-left: 3rem !important;
  }
  .mx-lg-sm {
    margin-right: 2rem !important;
    margin-left: 2rem !important;
  }
  .mx-lg-md {
    margin-right: 4rem !important;
    margin-left: 4rem !important;
  }
  .mx-lg-lg {
    margin-right: 6rem !important;
    margin-left: 6rem !important;
  }
  .mx-lg-xl {
    margin-right: 8rem !important;
    margin-left: 8rem !important;
  }
  .mx-lg-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
  .my-lg-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
  .my-lg-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }
  .my-lg-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }
  .my-lg-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }
  .my-lg-4 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }
  .my-lg-5 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }
  .my-lg-sm {
    margin-top: 2rem !important;
    margin-bottom: 2rem !important;
  }
  .my-lg-md {
    margin-top: 4rem !important;
    margin-bottom: 4rem !important;
  }
  .my-lg-lg {
    margin-top: 6rem !important;
    margin-bottom: 6rem !important;
  }
  .my-lg-xl {
    margin-top: 8rem !important;
    margin-bottom: 8rem !important;
  }
  .my-lg-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }
  .mt-lg-0 {
    margin-top: 0 !important;
  }
  .mt-lg-1 {
    margin-top: 0.25rem !important;
  }
  .mt-lg-2 {
    margin-top: 0.5rem !important;
  }
  .mt-lg-3 {
    margin-top: 1rem !important;
  }
  .mt-lg-4 {
    margin-top: 1.5rem !important;
  }
  .mt-lg-5 {
    margin-top: 3rem !important;
  }
  .mt-lg-sm {
    margin-top: 2rem !important;
  }
  .mt-lg-md {
    margin-top: 4rem !important;
  }
  .mt-lg-lg {
    margin-top: 6rem !important;
  }
  .mt-lg-xl {
    margin-top: 8rem !important;
  }
  .mt-lg-auto {
    margin-top: auto !important;
  }
  .me-lg-0 {
    margin-right: 0 !important;
  }
  .me-lg-1 {
    margin-right: 0.25rem !important;
  }
  .me-lg-2 {
    margin-right: 0.5rem !important;
  }
  .me-lg-3 {
    margin-right: 1rem !important;
  }
  .me-lg-4 {
    margin-right: 1.5rem !important;
  }
  .me-lg-5 {
    margin-right: 3rem !important;
  }
  .me-lg-sm {
    margin-right: 2rem !important;
  }
  .me-lg-md {
    margin-right: 4rem !important;
  }
  .me-lg-lg {
    margin-right: 6rem !important;
  }
  .me-lg-xl {
    margin-right: 8rem !important;
  }
  .me-lg-auto {
    margin-right: auto !important;
  }
  .mb-lg-0 {
    margin-bottom: 0 !important;
  }
  .mb-lg-1 {
    margin-bottom: 0.25rem !important;
  }
  .mb-lg-2 {
    margin-bottom: 0.5rem !important;
  }
  .mb-lg-3 {
    margin-bottom: 1rem !important;
  }
  .mb-lg-4 {
    margin-bottom: 1.5rem !important;
  }
  .mb-lg-5 {
    margin-bottom: 3rem !important;
  }
  .mb-lg-sm {
    margin-bottom: 2rem !important;
  }
  .mb-lg-md {
    margin-bottom: 4rem !important;
  }
  .mb-lg-lg {
    margin-bottom: 6rem !important;
  }
  .mb-lg-xl {
    margin-bottom: 8rem !important;
  }
  .mb-lg-auto {
    margin-bottom: auto !important;
  }
  .ms-lg-0 {
    margin-left: 0 !important;
  }
  .ms-lg-1 {
    margin-left: 0.25rem !important;
  }
  .ms-lg-2 {
    margin-left: 0.5rem !important;
  }
  .ms-lg-3 {
    margin-left: 1rem !important;
  }
  .ms-lg-4 {
    margin-left: 1.5rem !important;
  }
  .ms-lg-5 {
    margin-left: 3rem !important;
  }
  .ms-lg-sm {
    margin-left: 2rem !important;
  }
  .ms-lg-md {
    margin-left: 4rem !important;
  }
  .ms-lg-lg {
    margin-left: 6rem !important;
  }
  .ms-lg-xl {
    margin-left: 8rem !important;
  }
  .ms-lg-auto {
    margin-left: auto !important;
  }
  .p-lg-0 {
    padding: 0 !important;
  }
  .p-lg-1 {
    padding: 0.25rem !important;
  }
  .p-lg-2 {
    padding: 0.5rem !important;
  }
  .p-lg-3 {
    padding: 1rem !important;
  }
  .p-lg-4 {
    padding: 1.5rem !important;
  }
  .p-lg-5 {
    padding: 3rem !important;
  }
  .p-lg-sm {
    padding: 2rem !important;
  }
  .p-lg-md {
    padding: 4rem !important;
  }
  .p-lg-lg {
    padding: 6rem !important;
  }
  .p-lg-xl {
    padding: 8rem !important;
  }
  .px-lg-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
  .px-lg-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important;
  }
  .px-lg-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important;
  }
  .px-lg-3 {
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }
  .px-lg-4 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }
  .px-lg-5 {
    padding-right: 3rem !important;
    padding-left: 3rem !important;
  }
  .px-lg-sm {
    padding-right: 2rem !important;
    padding-left: 2rem !important;
  }
  .px-lg-md {
    padding-right: 4rem !important;
    padding-left: 4rem !important;
  }
  .px-lg-lg {
    padding-right: 6rem !important;
    padding-left: 6rem !important;
  }
  .px-lg-xl {
    padding-right: 8rem !important;
    padding-left: 8rem !important;
  }
  .py-lg-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  .py-lg-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }
  .py-lg-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }
  .py-lg-3 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }
  .py-lg-4 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }
  .py-lg-5 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }
  .py-lg-sm {
    padding-top: 2rem !important;
    padding-bottom: 2rem !important;
  }
  .py-lg-md {
    padding-top: 4rem !important;
    padding-bottom: 4rem !important;
  }
  .py-lg-lg {
    padding-top: 6rem !important;
    padding-bottom: 6rem !important;
  }
  .py-lg-xl {
    padding-top: 8rem !important;
    padding-bottom: 8rem !important;
  }
  .pt-lg-0 {
    padding-top: 0 !important;
  }
  .pt-lg-1 {
    padding-top: 0.25rem !important;
  }
  .pt-lg-2 {
    padding-top: 0.5rem !important;
  }
  .pt-lg-3 {
    padding-top: 1rem !important;
  }
  .pt-lg-4 {
    padding-top: 1.5rem !important;
  }
  .pt-lg-5 {
    padding-top: 3rem !important;
  }
  .pt-lg-sm {
    padding-top: 2rem !important;
  }
  .pt-lg-md {
    padding-top: 4rem !important;
  }
  .pt-lg-lg {
    padding-top: 6rem !important;
  }
  .pt-lg-xl {
    padding-top: 8rem !important;
  }
  .pe-lg-0 {
    padding-right: 0 !important;
  }
  .pe-lg-1 {
    padding-right: 0.25rem !important;
  }
  .pe-lg-2 {
    padding-right: 0.5rem !important;
  }
  .pe-lg-3 {
    padding-right: 1rem !important;
  }
  .pe-lg-4 {
    padding-right: 1.5rem !important;
  }
  .pe-lg-5 {
    padding-right: 3rem !important;
  }
  .pe-lg-sm {
    padding-right: 2rem !important;
  }
  .pe-lg-md {
    padding-right: 4rem !important;
  }
  .pe-lg-lg {
    padding-right: 6rem !important;
  }
  .pe-lg-xl {
    padding-right: 8rem !important;
  }
  .pb-lg-0 {
    padding-bottom: 0 !important;
  }
  .pb-lg-1 {
    padding-bottom: 0.25rem !important;
  }
  .pb-lg-2 {
    padding-bottom: 0.5rem !important;
  }
  .pb-lg-3 {
    padding-bottom: 1rem !important;
  }
  .pb-lg-4 {
    padding-bottom: 1.5rem !important;
  }
  .pb-lg-5 {
    padding-bottom: 3rem !important;
  }
  .pb-lg-sm {
    padding-bottom: 2rem !important;
  }
  .pb-lg-md {
    padding-bottom: 4rem !important;
  }
  .pb-lg-lg {
    padding-bottom: 6rem !important;
  }
  .pb-lg-xl {
    padding-bottom: 8rem !important;
  }
  .ps-lg-0 {
    padding-left: 0 !important;
  }
  .ps-lg-1 {
    padding-left: 0.25rem !important;
  }
  .ps-lg-2 {
    padding-left: 0.5rem !important;
  }
  .ps-lg-3 {
    padding-left: 1rem !important;
  }
  .ps-lg-4 {
    padding-left: 1.5rem !important;
  }
  .ps-lg-5 {
    padding-left: 3rem !important;
  }
  .ps-lg-sm {
    padding-left: 2rem !important;
  }
  .ps-lg-md {
    padding-left: 4rem !important;
  }
  .ps-lg-lg {
    padding-left: 6rem !important;
  }
  .ps-lg-xl {
    padding-left: 8rem !important;
  }
  .text-lg-start {
    text-align: left !important;
  }
  .text-lg-end {
    text-align: right !important;
  }
  .text-lg-center {
    text-align: center !important;
  }
}
@media (min-width: 1200px) {
  .float-xl-start {
    float: left !important;
  }
  .float-xl-end {
    float: right !important;
  }
  .float-xl-none {
    float: none !important;
  }
  .d-xl-inline {
    display: inline !important;
  }
  .d-xl-inline-block {
    display: inline-block !important;
  }
  .d-xl-block {
    display: block !important;
  }
  .d-xl-grid {
    display: grid !important;
  }
  .d-xl-table {
    display: table !important;
  }
  .d-xl-table-row {
    display: table-row !important;
  }
  .d-xl-table-cell {
    display: table-cell !important;
  }
  .d-xl-flex {
    display: flex !important;
  }
  .d-xl-inline-flex {
    display: inline-flex !important;
  }
  .d-xl-none {
    display: none !important;
  }
  .flex-xl-fill {
    flex: 1 1 auto !important;
  }
  .flex-xl-row {
    flex-direction: row !important;
  }
  .flex-xl-column {
    flex-direction: column !important;
  }
  .flex-xl-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-xl-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-xl-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-xl-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-xl-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-xl-shrink-1 {
    flex-shrink: 1 !important;
  }
  .flex-xl-wrap {
    flex-wrap: wrap !important;
  }
  .flex-xl-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-xl-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .gap-xl-0 {
    gap: 0 !important;
  }
  .gap-xl-1 {
    gap: 0.25rem !important;
  }
  .gap-xl-2 {
    gap: 0.5rem !important;
  }
  .gap-xl-3 {
    gap: 1rem !important;
  }
  .gap-xl-4 {
    gap: 1.5rem !important;
  }
  .gap-xl-5 {
    gap: 3rem !important;
  }
  .gap-xl-sm {
    gap: 2rem !important;
  }
  .gap-xl-md {
    gap: 4rem !important;
  }
  .gap-xl-lg {
    gap: 6rem !important;
  }
  .gap-xl-xl {
    gap: 8rem !important;
  }
  .justify-content-xl-start {
    justify-content: flex-start !important;
  }
  .justify-content-xl-end {
    justify-content: flex-end !important;
  }
  .justify-content-xl-center {
    justify-content: center !important;
  }
  .justify-content-xl-between {
    justify-content: space-between !important;
  }
  .justify-content-xl-around {
    justify-content: space-around !important;
  }
  .justify-content-xl-evenly {
    justify-content: space-evenly !important;
  }
  .align-items-xl-start {
    align-items: flex-start !important;
  }
  .align-items-xl-end {
    align-items: flex-end !important;
  }
  .align-items-xl-center {
    align-items: center !important;
  }
  .align-items-xl-baseline {
    align-items: baseline !important;
  }
  .align-items-xl-stretch {
    align-items: stretch !important;
  }
  .align-content-xl-start {
    align-content: flex-start !important;
  }
  .align-content-xl-end {
    align-content: flex-end !important;
  }
  .align-content-xl-center {
    align-content: center !important;
  }
  .align-content-xl-between {
    align-content: space-between !important;
  }
  .align-content-xl-around {
    align-content: space-around !important;
  }
  .align-content-xl-stretch {
    align-content: stretch !important;
  }
  .align-self-xl-auto {
    align-self: auto !important;
  }
  .align-self-xl-start {
    align-self: flex-start !important;
  }
  .align-self-xl-end {
    align-self: flex-end !important;
  }
  .align-self-xl-center {
    align-self: center !important;
  }
  .align-self-xl-baseline {
    align-self: baseline !important;
  }
  .align-self-xl-stretch {
    align-self: stretch !important;
  }
  .order-xl-first {
    order: -1 !important;
  }
  .order-xl-0 {
    order: 0 !important;
  }
  .order-xl-1 {
    order: 1 !important;
  }
  .order-xl-2 {
    order: 2 !important;
  }
  .order-xl-3 {
    order: 3 !important;
  }
  .order-xl-4 {
    order: 4 !important;
  }
  .order-xl-5 {
    order: 5 !important;
  }
  .order-xl-last {
    order: 6 !important;
  }
  .m-xl-0 {
    margin: 0 !important;
  }
  .m-xl-1 {
    margin: 0.25rem !important;
  }
  .m-xl-2 {
    margin: 0.5rem !important;
  }
  .m-xl-3 {
    margin: 1rem !important;
  }
  .m-xl-4 {
    margin: 1.5rem !important;
  }
  .m-xl-5 {
    margin: 3rem !important;
  }
  .m-xl-sm {
    margin: 2rem !important;
  }
  .m-xl-md {
    margin: 4rem !important;
  }
  .m-xl-lg {
    margin: 6rem !important;
  }
  .m-xl-xl {
    margin: 8rem !important;
  }
  .m-xl-auto {
    margin: auto !important;
  }
  .mx-xl-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
  .mx-xl-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important;
  }
  .mx-xl-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important;
  }
  .mx-xl-3 {
    margin-right: 1rem !important;
    margin-left: 1rem !important;
  }
  .mx-xl-4 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }
  .mx-xl-5 {
    margin-right: 3rem !important;
    margin-left: 3rem !important;
  }
  .mx-xl-sm {
    margin-right: 2rem !important;
    margin-left: 2rem !important;
  }
  .mx-xl-md {
    margin-right: 4rem !important;
    margin-left: 4rem !important;
  }
  .mx-xl-lg {
    margin-right: 6rem !important;
    margin-left: 6rem !important;
  }
  .mx-xl-xl {
    margin-right: 8rem !important;
    margin-left: 8rem !important;
  }
  .mx-xl-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
  .my-xl-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
  .my-xl-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }
  .my-xl-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }
  .my-xl-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }
  .my-xl-4 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }
  .my-xl-5 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }
  .my-xl-sm {
    margin-top: 2rem !important;
    margin-bottom: 2rem !important;
  }
  .my-xl-md {
    margin-top: 4rem !important;
    margin-bottom: 4rem !important;
  }
  .my-xl-lg {
    margin-top: 6rem !important;
    margin-bottom: 6rem !important;
  }
  .my-xl-xl {
    margin-top: 8rem !important;
    margin-bottom: 8rem !important;
  }
  .my-xl-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }
  .mt-xl-0 {
    margin-top: 0 !important;
  }
  .mt-xl-1 {
    margin-top: 0.25rem !important;
  }
  .mt-xl-2 {
    margin-top: 0.5rem !important;
  }
  .mt-xl-3 {
    margin-top: 1rem !important;
  }
  .mt-xl-4 {
    margin-top: 1.5rem !important;
  }
  .mt-xl-5 {
    margin-top: 3rem !important;
  }
  .mt-xl-sm {
    margin-top: 2rem !important;
  }
  .mt-xl-md {
    margin-top: 4rem !important;
  }
  .mt-xl-lg {
    margin-top: 6rem !important;
  }
  .mt-xl-xl {
    margin-top: 8rem !important;
  }
  .mt-xl-auto {
    margin-top: auto !important;
  }
  .me-xl-0 {
    margin-right: 0 !important;
  }
  .me-xl-1 {
    margin-right: 0.25rem !important;
  }
  .me-xl-2 {
    margin-right: 0.5rem !important;
  }
  .me-xl-3 {
    margin-right: 1rem !important;
  }
  .me-xl-4 {
    margin-right: 1.5rem !important;
  }
  .me-xl-5 {
    margin-right: 3rem !important;
  }
  .me-xl-sm {
    margin-right: 2rem !important;
  }
  .me-xl-md {
    margin-right: 4rem !important;
  }
  .me-xl-lg {
    margin-right: 6rem !important;
  }
  .me-xl-xl {
    margin-right: 8rem !important;
  }
  .me-xl-auto {
    margin-right: auto !important;
  }
  .mb-xl-0 {
    margin-bottom: 0 !important;
  }
  .mb-xl-1 {
    margin-bottom: 0.25rem !important;
  }
  .mb-xl-2 {
    margin-bottom: 0.5rem !important;
  }
  .mb-xl-3 {
    margin-bottom: 1rem !important;
  }
  .mb-xl-4 {
    margin-bottom: 1.5rem !important;
  }
  .mb-xl-5 {
    margin-bottom: 3rem !important;
  }
  .mb-xl-sm {
    margin-bottom: 2rem !important;
  }
  .mb-xl-md {
    margin-bottom: 4rem !important;
  }
  .mb-xl-lg {
    margin-bottom: 6rem !important;
  }
  .mb-xl-xl {
    margin-bottom: 8rem !important;
  }
  .mb-xl-auto {
    margin-bottom: auto !important;
  }
  .ms-xl-0 {
    margin-left: 0 !important;
  }
  .ms-xl-1 {
    margin-left: 0.25rem !important;
  }
  .ms-xl-2 {
    margin-left: 0.5rem !important;
  }
  .ms-xl-3 {
    margin-left: 1rem !important;
  }
  .ms-xl-4 {
    margin-left: 1.5rem !important;
  }
  .ms-xl-5 {
    margin-left: 3rem !important;
  }
  .ms-xl-sm {
    margin-left: 2rem !important;
  }
  .ms-xl-md {
    margin-left: 4rem !important;
  }
  .ms-xl-lg {
    margin-left: 6rem !important;
  }
  .ms-xl-xl {
    margin-left: 8rem !important;
  }
  .ms-xl-auto {
    margin-left: auto !important;
  }
  .p-xl-0 {
    padding: 0 !important;
  }
  .p-xl-1 {
    padding: 0.25rem !important;
  }
  .p-xl-2 {
    padding: 0.5rem !important;
  }
  .p-xl-3 {
    padding: 1rem !important;
  }
  .p-xl-4 {
    padding: 1.5rem !important;
  }
  .p-xl-5 {
    padding: 3rem !important;
  }
  .p-xl-sm {
    padding: 2rem !important;
  }
  .p-xl-md {
    padding: 4rem !important;
  }
  .p-xl-lg {
    padding: 6rem !important;
  }
  .p-xl-xl {
    padding: 8rem !important;
  }
  .px-xl-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
  .px-xl-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important;
  }
  .px-xl-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important;
  }
  .px-xl-3 {
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }
  .px-xl-4 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }
  .px-xl-5 {
    padding-right: 3rem !important;
    padding-left: 3rem !important;
  }
  .px-xl-sm {
    padding-right: 2rem !important;
    padding-left: 2rem !important;
  }
  .px-xl-md {
    padding-right: 4rem !important;
    padding-left: 4rem !important;
  }
  .px-xl-lg {
    padding-right: 6rem !important;
    padding-left: 6rem !important;
  }
  .px-xl-xl {
    padding-right: 8rem !important;
    padding-left: 8rem !important;
  }
  .py-xl-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  .py-xl-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }
  .py-xl-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }
  .py-xl-3 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }
  .py-xl-4 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }
  .py-xl-5 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }
  .py-xl-sm {
    padding-top: 2rem !important;
    padding-bottom: 2rem !important;
  }
  .py-xl-md {
    padding-top: 4rem !important;
    padding-bottom: 4rem !important;
  }
  .py-xl-lg {
    padding-top: 6rem !important;
    padding-bottom: 6rem !important;
  }
  .py-xl-xl {
    padding-top: 8rem !important;
    padding-bottom: 8rem !important;
  }
  .pt-xl-0 {
    padding-top: 0 !important;
  }
  .pt-xl-1 {
    padding-top: 0.25rem !important;
  }
  .pt-xl-2 {
    padding-top: 0.5rem !important;
  }
  .pt-xl-3 {
    padding-top: 1rem !important;
  }
  .pt-xl-4 {
    padding-top: 1.5rem !important;
  }
  .pt-xl-5 {
    padding-top: 3rem !important;
  }
  .pt-xl-sm {
    padding-top: 2rem !important;
  }
  .pt-xl-md {
    padding-top: 4rem !important;
  }
  .pt-xl-lg {
    padding-top: 6rem !important;
  }
  .pt-xl-xl {
    padding-top: 8rem !important;
  }
  .pe-xl-0 {
    padding-right: 0 !important;
  }
  .pe-xl-1 {
    padding-right: 0.25rem !important;
  }
  .pe-xl-2 {
    padding-right: 0.5rem !important;
  }
  .pe-xl-3 {
    padding-right: 1rem !important;
  }
  .pe-xl-4 {
    padding-right: 1.5rem !important;
  }
  .pe-xl-5 {
    padding-right: 3rem !important;
  }
  .pe-xl-sm {
    padding-right: 2rem !important;
  }
  .pe-xl-md {
    padding-right: 4rem !important;
  }
  .pe-xl-lg {
    padding-right: 6rem !important;
  }
  .pe-xl-xl {
    padding-right: 8rem !important;
  }
  .pb-xl-0 {
    padding-bottom: 0 !important;
  }
  .pb-xl-1 {
    padding-bottom: 0.25rem !important;
  }
  .pb-xl-2 {
    padding-bottom: 0.5rem !important;
  }
  .pb-xl-3 {
    padding-bottom: 1rem !important;
  }
  .pb-xl-4 {
    padding-bottom: 1.5rem !important;
  }
  .pb-xl-5 {
    padding-bottom: 3rem !important;
  }
  .pb-xl-sm {
    padding-bottom: 2rem !important;
  }
  .pb-xl-md {
    padding-bottom: 4rem !important;
  }
  .pb-xl-lg {
    padding-bottom: 6rem !important;
  }
  .pb-xl-xl {
    padding-bottom: 8rem !important;
  }
  .ps-xl-0 {
    padding-left: 0 !important;
  }
  .ps-xl-1 {
    padding-left: 0.25rem !important;
  }
  .ps-xl-2 {
    padding-left: 0.5rem !important;
  }
  .ps-xl-3 {
    padding-left: 1rem !important;
  }
  .ps-xl-4 {
    padding-left: 1.5rem !important;
  }
  .ps-xl-5 {
    padding-left: 3rem !important;
  }
  .ps-xl-sm {
    padding-left: 2rem !important;
  }
  .ps-xl-md {
    padding-left: 4rem !important;
  }
  .ps-xl-lg {
    padding-left: 6rem !important;
  }
  .ps-xl-xl {
    padding-left: 8rem !important;
  }
  .text-xl-start {
    text-align: left !important;
  }
  .text-xl-end {
    text-align: right !important;
  }
  .text-xl-center {
    text-align: center !important;
  }
}
@media (min-width: 1200px) {
  .fs-1 {
    font-size: 2.0624999938rem !important;
  }
  .fs-2 {
    font-size: 1.687499975rem !important;
  }
  .fs-3 {
    font-size: 1.437499875rem !important;
  }
}
@media print {
  .d-print-inline {
    display: inline !important;
  }
  .d-print-inline-block {
    display: inline-block !important;
  }
  .d-print-block {
    display: block !important;
  }
  .d-print-grid {
    display: grid !important;
  }
  .d-print-table {
    display: table !important;
  }
  .d-print-table-row {
    display: table-row !important;
  }
  .d-print-table-cell {
    display: table-cell !important;
  }
  .d-print-flex {
    display: flex !important;
  }
  .d-print-inline-flex {
    display: inline-flex !important;
  }
  .d-print-none {
    display: none !important;
  }
}
.alert {
  border: 0;
  color: #ffffff;
}
.alert .alert-link {
  color: #ffffff;
}
.alert.alert-success {
  background-color: #536c7c;
}
.alert i.fa,
.alert i.tim-icons {
  font-size: 1rem;
}
.alert .close {
  color: #ffffff;
  opacity: 0.9;
  text-shadow: none;
  line-height: 0;
  outline: 0;
}
.alert .close::after {
  display: inline-block;
  font: normal normal normal 1em/1 "Nucleo";
  vertical-align: middle;
  speak: none;
  text-transform: none;
  -webkit-font-smoothing: antialiased;
  font-size: 1rem;
  content: "\\ea48";
}
.alert .close span {
  display: none !important;
}
.alert span[data-notify=icon] {
  font-size: 22px;
  display: block;
  left: 19px;
  position: absolute;
  top: 50%;
  margin-top: -11px;
}
.alert button.close {
  position: absolute;
  right: 15px;
  top: 50%;
  margin-top: -13px;
  width: 25px;
  height: 25px;
  padding: 3px;
}
.alert .close ~ span {
  display: block;
  max-width: 89%;
}
.alert.alert-with-icon {
  padding-left: 65px;
}

.alert-dismissible {
  padding-right: 1.25rem;
}
.alert-dismissible .close {
  top: 1rem;
  right: 0.5rem;
}
.alert-dismissible .close:hover, .alert-dismissible .close:focus {
  color: rgba(255, 255, 255, 0.9);
  opacity: 1 !important;
}
.alert-dismissible .close > span:not(.sr-only) {
  font-size: 1.5rem;
  background-color: transparent;
  color: rgba(255, 255, 255, 0.6);
}
.alert-dismissible .close:hover > span:not(.sr-only), .alert-dismissible .close:focus > span:not(.sr-only) {
  background-color: transparent;
  color: rgba(255, 255, 255, 0.9);
}
.alert-dismissible.animated {
  z-index: 9999;
}
.alert-dismissible.animated .close {
  right: 10px;
}

.badge + .badge {
  margin-left: 5px;
}

.btn,
.navbar .navbar-nav > a.btn {
  border-width: 2px;
  border: none;
  position: relative;
  overflow: hidden;
  margin: 4px 1px;
  border-radius: 0.4285rem;
  cursor: pointer;
  background: #011e31;
  background-image: linear-gradient(to bottom left, #011e31, #263148, #011e31);
  background-size: 210% 210%;
  background-position: top right;
  background-color: #011e31;
  transition: all 0.15s ease;
  box-shadow: none;
  color: #ffffff;
}
.btn.animation-on-hover:hover,
.navbar .navbar-nav > a.btn.animation-on-hover:hover {
  background-position: bottom left;
  transition: 0.3s ease-in-out;
}
.btn:hover, .btn:focus, .btn:active, .btn.active, .btn:active:focus, .btn:active:hover, .btn.active:focus, .btn.active:hover,
.navbar .navbar-nav > a.btn:hover,
.navbar .navbar-nav > a.btn:focus,
.navbar .navbar-nav > a.btn:active,
.navbar .navbar-nav > a.btn.active,
.navbar .navbar-nav > a.btn:active:focus,
.navbar .navbar-nav > a.btn:active:hover,
.navbar .navbar-nav > a.btn.active:focus,
.navbar .navbar-nav > a.btn.active:hover {
  background-color: #263148 !important;
  background-image: linear-gradient(to bottom left, #011e31, #263148, #011e31) !important;
  background-image: -moz-linear-gradient(to bottom left, #011e31, #263148, #011e31) !important;
  color: #ffffff;
  box-shadow: none;
}
.btn:active,
.navbar .navbar-nav > a.btn:active {
  box-shadow: none !important;
  transform: translateY(1px) !important;
  transition: all 0.15s ease;
}
.btn:not([data-action]):hover,
.navbar .navbar-nav > a.btn:not([data-action]):hover {
  box-shadow: 2px 2px 6px rgba(0, 0, 0, 0.4);
  transform: translateY(-1px);
  -webkit-transform: translateY(-1px);
}
.btn.disabled, .btn.disabled:hover, .btn.disabled:focus, .btn.disabled.focus, .btn.disabled:active, .btn.disabled.active, .btn:disabled, .btn:disabled:hover, .btn:disabled:focus, .btn:disabled.focus, .btn:disabled:active, .btn:disabled.active, .btn[disabled], .btn[disabled]:hover, .btn[disabled]:focus, .btn[disabled].focus, .btn[disabled]:active, .btn[disabled].active, fieldset[disabled] .btn, fieldset[disabled] .btn:hover, fieldset[disabled] .btn:focus, fieldset[disabled] .btn.focus, fieldset[disabled] .btn:active, fieldset[disabled] .btn.active,
.navbar .navbar-nav > a.btn.disabled,
.navbar .navbar-nav > a.btn.disabled:hover,
.navbar .navbar-nav > a.btn.disabled:focus,
.navbar .navbar-nav > a.btn.disabled.focus,
.navbar .navbar-nav > a.btn.disabled:active,
.navbar .navbar-nav > a.btn.disabled.active,
.navbar .navbar-nav > a.btn:disabled,
.navbar .navbar-nav > a.btn:disabled:hover,
.navbar .navbar-nav > a.btn:disabled:focus,
.navbar .navbar-nav > a.btn:disabled.focus,
.navbar .navbar-nav > a.btn:disabled:active,
.navbar .navbar-nav > a.btn:disabled.active,
.navbar .navbar-nav > a.btn[disabled],
.navbar .navbar-nav > a.btn[disabled]:hover,
.navbar .navbar-nav > a.btn[disabled]:focus,
.navbar .navbar-nav > a.btn[disabled].focus,
.navbar .navbar-nav > a.btn[disabled]:active,
.navbar .navbar-nav > a.btn[disabled].active,
fieldset[disabled] .navbar .navbar-nav > a.btn,
fieldset[disabled] .navbar .navbar-nav > a.btn:hover,
fieldset[disabled] .navbar .navbar-nav > a.btn:focus,
fieldset[disabled] .navbar .navbar-nav > a.btn.focus,
fieldset[disabled] .navbar .navbar-nav > a.btn:active,
fieldset[disabled] .navbar .navbar-nav > a.btn.active {
  background-color: #011e31;
  border-color: #011e31;
}
.btn.btn-simple,
.navbar .navbar-nav > a.btn.btn-simple {
  color: #011e31;
  border-color: #011e31;
  background: transparent;
}
.btn.btn-simple:hover, .btn.btn-simple:focus, .btn.btn-simple:active, .btn.btn-simple:not(:disabled):not(.disabled):active,
.navbar .navbar-nav > a.btn.btn-simple:hover,
.navbar .navbar-nav > a.btn.btn-simple:focus,
.navbar .navbar-nav > a.btn.btn-simple:active,
.navbar .navbar-nav > a.btn.btn-simple:not(:disabled):not(.disabled):active {
  color: #011e31;
  border-color: #011e31;
  background-color: transparent !important;
  background-image: none !important;
  box-shadow: none;
}
.btn.btn-simple.active,
.navbar .navbar-nav > a.btn.btn-simple.active {
  border-color: #011e31 !important;
}
.btn.btn-simple.active:hover, .btn.btn-simple.active:focus, .btn.btn-simple.active:active, .btn.btn-simple.active:not(:disabled):not(.disabled):active,
.navbar .navbar-nav > a.btn.btn-simple.active:hover,
.navbar .navbar-nav > a.btn.btn-simple.active:focus,
.navbar .navbar-nav > a.btn.btn-simple.active:active,
.navbar .navbar-nav > a.btn.btn-simple.active:not(:disabled):not(.disabled):active {
  color: #ffffff;
  border-color: #011e31;
  background-image: linear-gradient(to bottom left, #011e31, #263148, #011e31) !important;
  background-image: -moz-linear-gradient(to bottom left, #011e31, #263148, #011e31) !important;
  background-color: #263148 !important;
  box-shadow: none;
}
.btn.btn-link,
.navbar .navbar-nav > a.btn.btn-link {
  color: #011e31;
}
.btn.btn-link:hover, .btn.btn-link:focus, .btn.btn-link:active,
.navbar .navbar-nav > a.btn.btn-link:hover,
.navbar .navbar-nav > a.btn.btn-link:focus,
.navbar .navbar-nav > a.btn.btn-link:active {
  background-color: transparent !important;
  background-image: none !important;
  color: #ffffff !important;
  text-decoration: none;
  box-shadow: none;
}
.btn:hover, .btn:focus,
.navbar .navbar-nav > a.btn:hover,
.navbar .navbar-nav > a.btn:focus {
  opacity: 1;
  filter: alpha(opacity=100);
  outline: 0 !important;
}
.btn:active, .btn.active, .open > .btn.dropdown-toggle,
.navbar .navbar-nav > a.btn:active,
.navbar .navbar-nav > a.btn.active,
.open > .navbar .navbar-nav > a.btn.dropdown-toggle {
  box-shadow: none;
  outline: 0 !important;
}
.btn .badge,
.navbar .navbar-nav > a.btn .badge {
  margin: 0;
}
.btn.btn-icon,
.navbar .navbar-nav > a.btn.btn-icon {
  height: 2.375rem;
  min-width: 2.375rem;
  width: 2.375rem;
  padding: 0;
  font-size: 0.9375rem;
  overflow: hidden;
  position: relative;
  line-height: normal;
}
.btn.btn-icon.btn-simple,
.navbar .navbar-nav > a.btn.btn-icon.btn-simple {
  padding: 0;
}
.btn.btn-icon.btn-sm, .btn-group-sm > .btn.btn-icon,
.navbar .navbar-nav > a.btn.btn-icon.btn-sm {
  height: 1.875rem;
  min-width: 1.875rem;
  width: 1.875rem;
}
.btn.btn-icon.btn-sm .fa, .btn-group-sm > .btn.btn-icon .fa,
.btn.btn-icon.btn-sm .far,
.btn-group-sm > .btn.btn-icon .far,
.btn.btn-icon.btn-sm .fas,
.btn-group-sm > .btn.btn-icon .fas,
.btn.btn-icon.btn-sm .tim-icons,
.btn-group-sm > .btn.btn-icon .tim-icons,
.navbar .navbar-nav > a.btn.btn-icon.btn-sm .fa,
.navbar .navbar-nav > a.btn.btn-icon.btn-sm .far,
.navbar .navbar-nav > a.btn.btn-icon.btn-sm .fas,
.navbar .navbar-nav > a.btn.btn-icon.btn-sm .tim-icons {
  font-size: 0.6875rem;
}
.btn.btn-icon.btn-lg, .btn-group-lg > .btn.btn-icon,
.navbar .navbar-nav > a.btn.btn-icon.btn-lg {
  height: 3.6rem;
  min-width: 3.6rem;
  width: 3.6rem;
}
.btn.btn-icon.btn-lg .fa, .btn-group-lg > .btn.btn-icon .fa,
.btn.btn-icon.btn-lg .far,
.btn-group-lg > .btn.btn-icon .far,
.btn.btn-icon.btn-lg .fas,
.btn-group-lg > .btn.btn-icon .fas,
.btn.btn-icon.btn-lg .tim-icons,
.btn-group-lg > .btn.btn-icon .tim-icons,
.navbar .navbar-nav > a.btn.btn-icon.btn-lg .fa,
.navbar .navbar-nav > a.btn.btn-icon.btn-lg .far,
.navbar .navbar-nav > a.btn.btn-icon.btn-lg .fas,
.navbar .navbar-nav > a.btn.btn-icon.btn-lg .tim-icons {
  font-size: 1.325rem;
}
.btn.btn-icon:not(.btn-footer) .tim-icons, .btn.btn-icon:not(.btn-footer) .fa, .btn.btn-icon:not(.btn-footer) .far, .btn.btn-icon:not(.btn-footer) .fas,
.navbar .navbar-nav > a.btn.btn-icon:not(.btn-footer) .tim-icons,
.navbar .navbar-nav > a.btn.btn-icon:not(.btn-footer) .fa,
.navbar .navbar-nav > a.btn.btn-icon:not(.btn-footer) .far,
.navbar .navbar-nav > a.btn.btn-icon:not(.btn-footer) .fas {
  position: absolute;
  font-size: 1em;
  top: 50%;
  left: 50%;
  transform: translate(-12px, -12px);
  line-height: 1.5626rem;
  width: 24px;
}
.btn:not(.btn-icon) .tim-icons,
.navbar .navbar-nav > a.btn:not(.btn-icon) .tim-icons {
  position: relative;
  top: 1px;
}
.btn span,
.navbar .navbar-nav > a.btn span {
  position: relative;
  display: block;
}
.btn.btn-link.dropdown-toggle,
.navbar .navbar-nav > a.btn.btn-link.dropdown-toggle {
  color: #AAAAAA;
}
.btn.dropdown-toggle:after,
.navbar .navbar-nav > a.btn.dropdown-toggle:after {
  margin-left: 30px !important;
}

.btn-primary {
  background: #68869a;
  background-image: linear-gradient(to bottom left, #68869a, #ba54f5, #68869a);
  background-size: 210% 210%;
  background-position: top right;
  background-color: #68869a;
  transition: all 0.15s ease;
  box-shadow: none;
  color: #ffffff;
}
.btn-primary.animation-on-hover:hover {
  background-position: bottom left;
  transition: 0.3s ease-in-out;
}
.btn-primary:hover, .btn-primary:focus, .btn-primary:active, .btn-primary.active, .btn-primary:active:focus, .btn-primary:active:hover, .btn-primary.active:focus, .btn-primary.active:hover {
  background-color: #ba54f5 !important;
  background-image: linear-gradient(to bottom left, #68869a, #ba54f5, #68869a) !important;
  background-image: -moz-linear-gradient(to bottom left, #68869a, #ba54f5, #68869a) !important;
  color: #ffffff;
  box-shadow: none;
}
.btn-primary:active {
  box-shadow: none !important;
  transform: translateY(1px) !important;
  transition: all 0.15s ease;
}
.btn-primary:not([data-action]):hover {
  box-shadow: 2px 2px 6px rgba(0, 0, 0, 0.4);
  transform: translateY(-1px);
  -webkit-transform: translateY(-1px);
}
.btn-primary.disabled, .btn-primary.disabled:hover, .btn-primary.disabled:focus, .btn-primary.disabled.focus, .btn-primary.disabled:active, .btn-primary.disabled.active, .btn-primary:disabled, .btn-primary:disabled:hover, .btn-primary:disabled:focus, .btn-primary:disabled.focus, .btn-primary:disabled:active, .btn-primary:disabled.active, .btn-primary[disabled], .btn-primary[disabled]:hover, .btn-primary[disabled]:focus, .btn-primary[disabled].focus, .btn-primary[disabled]:active, .btn-primary[disabled].active, fieldset[disabled] .btn-primary, fieldset[disabled] .btn-primary:hover, fieldset[disabled] .btn-primary:focus, fieldset[disabled] .btn-primary.focus, fieldset[disabled] .btn-primary:active, fieldset[disabled] .btn-primary.active {
  background-color: #68869a;
  border-color: #68869a;
}
.btn-primary.btn-simple {
  color: #68869a;
  border-color: #68869a;
  background: transparent;
}
.btn-primary.btn-simple:hover, .btn-primary.btn-simple:focus, .btn-primary.btn-simple:active, .btn-primary.btn-simple:not(:disabled):not(.disabled):active {
  color: #68869a;
  border-color: #68869a;
  background-color: transparent !important;
  background-image: none !important;
  box-shadow: none;
}
.btn-primary.btn-simple.active {
  border-color: #68869a !important;
}
.btn-primary.btn-simple.active:hover, .btn-primary.btn-simple.active:focus, .btn-primary.btn-simple.active:active, .btn-primary.btn-simple.active:not(:disabled):not(.disabled):active {
  color: #ffffff;
  border-color: #68869a;
  background-image: linear-gradient(to bottom left, #68869a, #ba54f5, #68869a) !important;
  background-image: -moz-linear-gradient(to bottom left, #68869a, #ba54f5, #68869a) !important;
  background-color: #ba54f5 !important;
  box-shadow: none;
}
.btn-primary.btn-link {
  color: #68869a;
}
.btn-primary.btn-link:hover, .btn-primary.btn-link:focus, .btn-primary.btn-link:active {
  background-color: transparent !important;
  background-image: none !important;
  color: #ffffff !important;
  text-decoration: none;
  box-shadow: none;
}

.btn-success {
  background: #68869a;
  background-image: linear-gradient(to bottom left, #68869a, #0098f0, #68869a);
  background-size: 210% 210%;
  background-position: top right;
  background-color: #68869a;
  transition: all 0.15s ease;
  box-shadow: none;
  color: #ffffff;
}
.btn-success.animation-on-hover:hover {
  background-position: bottom left;
  transition: 0.3s ease-in-out;
}
.btn-success:hover, .btn-success:focus, .btn-success:active, .btn-success.active, .btn-success:active:focus, .btn-success:active:hover, .btn-success.active:focus, .btn-success.active:hover {
  background-color: #0098f0 !important;
  background-image: linear-gradient(to bottom left, #68869a, #0098f0, #68869a) !important;
  background-image: -moz-linear-gradient(to bottom left, #68869a, #0098f0, #68869a) !important;
  color: #ffffff;
  box-shadow: none;
}
.btn-success:active {
  box-shadow: none !important;
  transform: translateY(1px) !important;
  transition: all 0.15s ease;
}
.btn-success:not([data-action]):hover {
  box-shadow: 2px 2px 6px rgba(0, 0, 0, 0.4);
  transform: translateY(-1px);
  -webkit-transform: translateY(-1px);
}
.btn-success.disabled, .btn-success.disabled:hover, .btn-success.disabled:focus, .btn-success.disabled.focus, .btn-success.disabled:active, .btn-success.disabled.active, .btn-success:disabled, .btn-success:disabled:hover, .btn-success:disabled:focus, .btn-success:disabled.focus, .btn-success:disabled:active, .btn-success:disabled.active, .btn-success[disabled], .btn-success[disabled]:hover, .btn-success[disabled]:focus, .btn-success[disabled].focus, .btn-success[disabled]:active, .btn-success[disabled].active, fieldset[disabled] .btn-success, fieldset[disabled] .btn-success:hover, fieldset[disabled] .btn-success:focus, fieldset[disabled] .btn-success.focus, fieldset[disabled] .btn-success:active, fieldset[disabled] .btn-success.active {
  background-color: #68869a;
  border-color: #68869a;
}
.btn-success.btn-simple {
  color: #68869a;
  border-color: #68869a;
  background: transparent;
}
.btn-success.btn-simple:hover, .btn-success.btn-simple:focus, .btn-success.btn-simple:active, .btn-success.btn-simple:not(:disabled):not(.disabled):active {
  color: #68869a;
  border-color: #68869a;
  background-color: transparent !important;
  background-image: none !important;
  box-shadow: none;
}
.btn-success.btn-simple.active {
  border-color: #68869a !important;
}
.btn-success.btn-simple.active:hover, .btn-success.btn-simple.active:focus, .btn-success.btn-simple.active:active, .btn-success.btn-simple.active:not(:disabled):not(.disabled):active {
  color: #ffffff;
  border-color: #68869a;
  background-image: linear-gradient(to bottom left, #68869a, #0098f0, #68869a) !important;
  background-image: -moz-linear-gradient(to bottom left, #68869a, #0098f0, #68869a) !important;
  background-color: #0098f0 !important;
  box-shadow: none;
}
.btn-success.btn-link {
  color: #68869a;
}
.btn-success.btn-link:hover, .btn-success.btn-link:focus, .btn-success.btn-link:active {
  background-color: transparent !important;
  background-image: none !important;
  color: #ffffff !important;
  text-decoration: none;
  box-shadow: none;
}

.btn-info {
  background: #0c4160;
  background-image: linear-gradient(to bottom left, #0c4160, #3358f4, #0c4160);
  background-size: 210% 210%;
  background-position: top right;
  background-color: #0c4160;
  transition: all 0.15s ease;
  box-shadow: none;
  color: #ffffff;
}
.btn-info.animation-on-hover:hover {
  background-position: bottom left;
  transition: 0.3s ease-in-out;
}
.btn-info:hover, .btn-info:focus, .btn-info:active, .btn-info.active, .btn-info:active:focus, .btn-info:active:hover, .btn-info.active:focus, .btn-info.active:hover {
  background-color: #3358f4 !important;
  background-image: linear-gradient(to bottom left, #0c4160, #3358f4, #0c4160) !important;
  background-image: -moz-linear-gradient(to bottom left, #0c4160, #3358f4, #0c4160) !important;
  color: #ffffff;
  box-shadow: none;
}
.btn-info:active {
  box-shadow: none !important;
  transform: translateY(1px) !important;
  transition: all 0.15s ease;
}
.btn-info:not([data-action]):hover {
  box-shadow: 2px 2px 6px rgba(0, 0, 0, 0.4);
  transform: translateY(-1px);
  -webkit-transform: translateY(-1px);
}
.btn-info.disabled, .btn-info.disabled:hover, .btn-info.disabled:focus, .btn-info.disabled.focus, .btn-info.disabled:active, .btn-info.disabled.active, .btn-info:disabled, .btn-info:disabled:hover, .btn-info:disabled:focus, .btn-info:disabled.focus, .btn-info:disabled:active, .btn-info:disabled.active, .btn-info[disabled], .btn-info[disabled]:hover, .btn-info[disabled]:focus, .btn-info[disabled].focus, .btn-info[disabled]:active, .btn-info[disabled].active, fieldset[disabled] .btn-info, fieldset[disabled] .btn-info:hover, fieldset[disabled] .btn-info:focus, fieldset[disabled] .btn-info.focus, fieldset[disabled] .btn-info:active, fieldset[disabled] .btn-info.active {
  background-color: #0c4160;
  border-color: #0c4160;
}
.btn-info.btn-simple {
  color: #0c4160;
  border-color: #0c4160;
  background: transparent;
}
.btn-info.btn-simple:hover, .btn-info.btn-simple:focus, .btn-info.btn-simple:active, .btn-info.btn-simple:not(:disabled):not(.disabled):active {
  color: #0c4160;
  border-color: #0c4160;
  background-color: transparent !important;
  background-image: none !important;
  box-shadow: none;
}
.btn-info.btn-simple.active {
  border-color: #0c4160 !important;
}
.btn-info.btn-simple.active:hover, .btn-info.btn-simple.active:focus, .btn-info.btn-simple.active:active, .btn-info.btn-simple.active:not(:disabled):not(.disabled):active {
  color: #ffffff;
  border-color: #0c4160;
  background-image: linear-gradient(to bottom left, #0c4160, #3358f4, #0c4160) !important;
  background-image: -moz-linear-gradient(to bottom left, #0c4160, #3358f4, #0c4160) !important;
  background-color: #3358f4 !important;
  box-shadow: none;
}
.btn-info.btn-link {
  color: #0c4160;
}
.btn-info.btn-link:hover, .btn-info.btn-link:focus, .btn-info.btn-link:active {
  background-color: transparent !important;
  background-image: none !important;
  color: #ffffff !important;
  text-decoration: none;
  box-shadow: none;
}

.btn-warning {
  background: #0c4160;
  background-image: linear-gradient(to bottom left, #0c4160, #ff6491, #0c4160);
  background-size: 210% 210%;
  background-position: top right;
  background-color: #0c4160;
  transition: all 0.15s ease;
  box-shadow: none;
  color: #ffffff;
}
.btn-warning.animation-on-hover:hover {
  background-position: bottom left;
  transition: 0.3s ease-in-out;
}
.btn-warning:hover, .btn-warning:focus, .btn-warning:active, .btn-warning.active, .btn-warning:active:focus, .btn-warning:active:hover, .btn-warning.active:focus, .btn-warning.active:hover {
  background-color: #ff6491 !important;
  background-image: linear-gradient(to bottom left, #0c4160, #ff6491, #0c4160) !important;
  background-image: -moz-linear-gradient(to bottom left, #0c4160, #ff6491, #0c4160) !important;
  color: #ffffff;
  box-shadow: none;
}
.btn-warning:active {
  box-shadow: none !important;
  transform: translateY(1px) !important;
  transition: all 0.15s ease;
}
.btn-warning:not([data-action]):hover {
  box-shadow: 2px 2px 6px rgba(0, 0, 0, 0.4);
  transform: translateY(-1px);
  -webkit-transform: translateY(-1px);
}
.btn-warning.disabled, .btn-warning.disabled:hover, .btn-warning.disabled:focus, .btn-warning.disabled.focus, .btn-warning.disabled:active, .btn-warning.disabled.active, .btn-warning:disabled, .btn-warning:disabled:hover, .btn-warning:disabled:focus, .btn-warning:disabled.focus, .btn-warning:disabled:active, .btn-warning:disabled.active, .btn-warning[disabled], .btn-warning[disabled]:hover, .btn-warning[disabled]:focus, .btn-warning[disabled].focus, .btn-warning[disabled]:active, .btn-warning[disabled].active, fieldset[disabled] .btn-warning, fieldset[disabled] .btn-warning:hover, fieldset[disabled] .btn-warning:focus, fieldset[disabled] .btn-warning.focus, fieldset[disabled] .btn-warning:active, fieldset[disabled] .btn-warning.active {
  background-color: #0c4160;
  border-color: #0c4160;
}
.btn-warning.btn-simple {
  color: #0c4160;
  border-color: #0c4160;
  background: transparent;
}
.btn-warning.btn-simple:hover, .btn-warning.btn-simple:focus, .btn-warning.btn-simple:active, .btn-warning.btn-simple:not(:disabled):not(.disabled):active {
  color: #0c4160;
  border-color: #0c4160;
  background-color: transparent !important;
  background-image: none !important;
  box-shadow: none;
}
.btn-warning.btn-simple.active {
  border-color: #0c4160 !important;
}
.btn-warning.btn-simple.active:hover, .btn-warning.btn-simple.active:focus, .btn-warning.btn-simple.active:active, .btn-warning.btn-simple.active:not(:disabled):not(.disabled):active {
  color: #ffffff;
  border-color: #0c4160;
  background-image: linear-gradient(to bottom left, #0c4160, #ff6491, #0c4160) !important;
  background-image: -moz-linear-gradient(to bottom left, #0c4160, #ff6491, #0c4160) !important;
  background-color: #ff6491 !important;
  box-shadow: none;
}
.btn-warning.btn-link {
  color: #0c4160;
}
.btn-warning.btn-link:hover, .btn-warning.btn-link:focus, .btn-warning.btn-link:active {
  background-color: transparent !important;
  background-image: none !important;
  color: #ffffff !important;
  text-decoration: none;
  box-shadow: none;
}
.btn-warning:not(:disabled):not(.disabled):active {
  color: #ffffff;
}

.btn-danger {
  background: #0c4160;
  background-image: linear-gradient(to bottom left, #0c4160, #ec250d, #0c4160);
  background-size: 210% 210%;
  background-position: top right;
  background-color: #0c4160;
  transition: all 0.15s ease;
  box-shadow: none;
  color: #ffffff;
}
.btn-danger.animation-on-hover:hover {
  background-position: bottom left;
  transition: 0.3s ease-in-out;
}
.btn-danger:hover, .btn-danger:focus, .btn-danger:active, .btn-danger.active, .btn-danger:active:focus, .btn-danger:active:hover, .btn-danger.active:focus, .btn-danger.active:hover {
  background-color: #ec250d !important;
  background-image: linear-gradient(to bottom left, #0c4160, #ec250d, #0c4160) !important;
  background-image: -moz-linear-gradient(to bottom left, #0c4160, #ec250d, #0c4160) !important;
  color: #ffffff;
  box-shadow: none;
}
.btn-danger:active {
  box-shadow: none !important;
  transform: translateY(1px) !important;
  transition: all 0.15s ease;
}
.btn-danger:not([data-action]):hover {
  box-shadow: 2px 2px 6px rgba(0, 0, 0, 0.4);
  transform: translateY(-1px);
  -webkit-transform: translateY(-1px);
}
.btn-danger.disabled, .btn-danger.disabled:hover, .btn-danger.disabled:focus, .btn-danger.disabled.focus, .btn-danger.disabled:active, .btn-danger.disabled.active, .btn-danger:disabled, .btn-danger:disabled:hover, .btn-danger:disabled:focus, .btn-danger:disabled.focus, .btn-danger:disabled:active, .btn-danger:disabled.active, .btn-danger[disabled], .btn-danger[disabled]:hover, .btn-danger[disabled]:focus, .btn-danger[disabled].focus, .btn-danger[disabled]:active, .btn-danger[disabled].active, fieldset[disabled] .btn-danger, fieldset[disabled] .btn-danger:hover, fieldset[disabled] .btn-danger:focus, fieldset[disabled] .btn-danger.focus, fieldset[disabled] .btn-danger:active, fieldset[disabled] .btn-danger.active {
  background-color: #0c4160;
  border-color: #0c4160;
}
.btn-danger.btn-simple {
  color: #0c4160;
  border-color: #0c4160;
  background: transparent;
}
.btn-danger.btn-simple:hover, .btn-danger.btn-simple:focus, .btn-danger.btn-simple:active, .btn-danger.btn-simple:not(:disabled):not(.disabled):active {
  color: #0c4160;
  border-color: #0c4160;
  background-color: transparent !important;
  background-image: none !important;
  box-shadow: none;
}
.btn-danger.btn-simple.active {
  border-color: #0c4160 !important;
}
.btn-danger.btn-simple.active:hover, .btn-danger.btn-simple.active:focus, .btn-danger.btn-simple.active:active, .btn-danger.btn-simple.active:not(:disabled):not(.disabled):active {
  color: #ffffff;
  border-color: #0c4160;
  background-image: linear-gradient(to bottom left, #0c4160, #ec250d, #0c4160) !important;
  background-image: -moz-linear-gradient(to bottom left, #0c4160, #ec250d, #0c4160) !important;
  background-color: #ec250d !important;
  box-shadow: none;
}
.btn-danger.btn-link {
  color: #0c4160;
}
.btn-danger.btn-link:hover, .btn-danger.btn-link:focus, .btn-danger.btn-link:active {
  background-color: transparent !important;
  background-image: none !important;
  color: #ffffff !important;
  text-decoration: none;
  box-shadow: none;
}

.btn-neutral {
  background: #ffffff;
  background-image: linear-gradient(to bottom left, #ffffff, #ffffff, #ffffff);
  background-size: 210% 210%;
  background-position: top right;
  background-color: #ffffff;
  transition: all 0.15s ease;
  box-shadow: none;
  color: #68869a;
}
.btn-neutral.animation-on-hover:hover {
  background-position: bottom left;
  transition: 0.3s ease-in-out;
}
.btn-neutral:hover, .btn-neutral:focus, .btn-neutral:active, .btn-neutral.active, .btn-neutral:active:focus, .btn-neutral:active:hover, .btn-neutral.active:focus, .btn-neutral.active:hover {
  background-color: #ffffff !important;
  background-image: linear-gradient(to bottom left, #ffffff, #ffffff, #ffffff) !important;
  background-image: -moz-linear-gradient(to bottom left, #ffffff, #ffffff, #ffffff) !important;
  color: #ffffff;
  box-shadow: none;
}
.btn-neutral:active {
  box-shadow: none !important;
  transform: translateY(1px) !important;
  transition: all 0.15s ease;
}
.btn-neutral:not([data-action]):hover {
  box-shadow: 2px 2px 6px rgba(0, 0, 0, 0.4);
  transform: translateY(-1px);
  -webkit-transform: translateY(-1px);
}
.btn-neutral.disabled, .btn-neutral.disabled:hover, .btn-neutral.disabled:focus, .btn-neutral.disabled.focus, .btn-neutral.disabled:active, .btn-neutral.disabled.active, .btn-neutral:disabled, .btn-neutral:disabled:hover, .btn-neutral:disabled:focus, .btn-neutral:disabled.focus, .btn-neutral:disabled:active, .btn-neutral:disabled.active, .btn-neutral[disabled], .btn-neutral[disabled]:hover, .btn-neutral[disabled]:focus, .btn-neutral[disabled].focus, .btn-neutral[disabled]:active, .btn-neutral[disabled].active, fieldset[disabled] .btn-neutral, fieldset[disabled] .btn-neutral:hover, fieldset[disabled] .btn-neutral:focus, fieldset[disabled] .btn-neutral.focus, fieldset[disabled] .btn-neutral:active, fieldset[disabled] .btn-neutral.active {
  background-color: #ffffff;
  border-color: #ffffff;
}
.btn-neutral.btn-danger {
  color: #0c4160;
}
.btn-neutral.btn-danger:hover, .btn-neutral.btn-danger:focus, .btn-neutral.btn-danger:active, .btn-neutral.btn-danger:active:focus {
  color: #ec250d;
}
.btn-neutral.btn-info {
  color: #0c4160;
}
.btn-neutral.btn-info:hover, .btn-neutral.btn-info:focus, .btn-neutral.btn-info:active, .btn-neutral.btn-info:active:focus {
  color: #3358f4;
}
.btn-neutral.btn-warning {
  color: #0c4160;
}
.btn-neutral.btn-warning:hover, .btn-neutral.btn-warning:focus, .btn-neutral.btn-warning:active, .btn-neutral.btn-warning:active:focus {
  color: #ff6491;
}
.btn-neutral.btn-success {
  color: #68869a;
}
.btn-neutral.btn-success:hover, .btn-neutral.btn-success:focus, .btn-neutral.btn-success:active, .btn-neutral.btn-success:active:focus {
  color: #0098f0;
}
.btn-neutral.btn-default {
  color: #011e31;
}
.btn-neutral.btn-default:hover, .btn-neutral.btn-default:focus, .btn-neutral.btn-default:active, .btn-neutral.btn-default:active:focus {
  color: #263148;
}
.btn-neutral.active, .btn-neutral:active, .btn-neutral:active:focus, .btn-neutral:active:hover, .btn-neutral.active:focus, .btn-neutral.active:hover, .show > .btn-neutral.dropdown-toggle, .show > .btn-neutral.dropdown-toggle:focus, .show > .btn-neutral.dropdown-toggle:hover {
  background-color: #ffffff;
  color: #ba54f5;
  box-shadow: none;
}
.btn-neutral:hover, .btn-neutral:focus {
  color: #ba54f5;
}
.btn-neutral:hover:not(.nav-link), .btn-neutral:focus:not(.nav-link) {
  box-shadow: none;
}
.btn-neutral.btn-simple {
  color: #ffffff;
  border-color: #ffffff;
  background: transparent;
}
.btn-neutral.btn-simple:hover, .btn-neutral.btn-simple:focus, .btn-neutral.btn-simple:active, .btn-neutral.btn-simple:not(:disabled):not(.disabled):active {
  color: #ffffff;
  border-color: #ffffff;
  background-color: transparent !important;
  background-image: none !important;
  box-shadow: none;
}
.btn-neutral.btn-simple.active {
  border-color: #ffffff !important;
}
.btn-neutral.btn-simple.active:hover, .btn-neutral.btn-simple.active:focus, .btn-neutral.btn-simple.active:active, .btn-neutral.btn-simple.active:not(:disabled):not(.disabled):active {
  color: #ffffff;
  border-color: #ffffff;
  background-image: linear-gradient(to bottom left, #ffffff, #ffffff, #ffffff) !important;
  background-image: -moz-linear-gradient(to bottom left, #ffffff, #ffffff, #ffffff) !important;
  background-color: #ffffff !important;
  box-shadow: none;
}
.btn-neutral.btn-link {
  color: #ffffff;
}
.btn-neutral.btn-link:hover, .btn-neutral.btn-link:focus, .btn-neutral.btn-link:active {
  background-color: transparent !important;
  background-image: none !important;
  color: #ffffff !important;
  text-decoration: none;
  box-shadow: none;
}

.btn:disabled, .btn[disabled], .btn.disabled {
  opacity: 0.5;
  filter: alpha(opacity=50);
  pointer-events: none;
}

.btn-simple {
  border: 1px solid;
  border-color: #011e31;
  box-shadow: none;
  padding: 10px 22px;
  background-color: transparent;
}

.btn-simple.disabled, .btn-simple.disabled:hover, .btn-simple.disabled:focus, .btn-simple.disabled.focus, .btn-simple.disabled:active, .btn-simple.disabled.active, .btn-simple:disabled, .btn-simple:disabled:hover, .btn-simple:disabled:focus, .btn-simple:disabled.focus, .btn-simple:disabled:active, .btn-simple:disabled.active, .btn-simple[disabled], .btn-simple[disabled]:hover, .btn-simple[disabled]:focus, .btn-simple[disabled].focus, .btn-simple[disabled]:active, .btn-simple[disabled].active, fieldset[disabled] .btn-simple, fieldset[disabled] .btn-simple:hover, fieldset[disabled] .btn-simple:focus, fieldset[disabled] .btn-simple.focus, fieldset[disabled] .btn-simple:active, fieldset[disabled] .btn-simple.active,
.btn-link.disabled,
.btn-link.disabled:hover,
.btn-link.disabled:focus,
.btn-link.disabled.focus,
.btn-link.disabled:active,
.btn-link.disabled.active,
.btn-link:disabled,
.btn-link:disabled:hover,
.btn-link:disabled:focus,
.btn-link:disabled.focus,
.btn-link:disabled:active,
.btn-link:disabled.active,
.btn-link[disabled],
.btn-link[disabled]:hover,
.btn-link[disabled]:focus,
.btn-link[disabled].focus,
.btn-link[disabled]:active,
.btn-link[disabled].active,
fieldset[disabled] .btn-link,
fieldset[disabled] .btn-link:hover,
fieldset[disabled] .btn-link:focus,
fieldset[disabled] .btn-link.focus,
fieldset[disabled] .btn-link:active,
fieldset[disabled] .btn-link.active {
  background: transparent;
}

.btn:not(:disabled):not(.disabled):active, .btn:not(:disabled):not(.disabled).active {
  box-shadow: 2px 2px 6px rgba(0, 0, 0, 0.4);
}

.btn-link {
  border: 0;
  box-shadow: none;
  padding: 0.5rem 0.7rem;
  background: transparent;
  color: #e3e3e3;
  font-weight: 600;
}
.btn-link:hover {
  box-shadow: none !important;
  transform: none !important;
}

.btn-lg, .btn-group-lg > .btn {
  font-size: 0.875rem;
  border-radius: 0.4285rem;
  padding: 15px 48px;
}
.btn-lg.btn-simple, .btn-group-lg > .btn-simple.btn {
  padding: 14px 47px;
}

.btn-sm, .btn-group-sm > .btn {
  font-size: 0.875rem;
  border-radius: 0.2857rem;
  padding: 5px 15px;
}
.btn-sm.btn-simple, .btn-group-sm > .btn-simple.btn {
  padding: 4px 14px;
}

.btn-wd {
  min-width: 140px;
}

.btn-group.select {
  width: 100%;
}

.btn-group .btn.active {
  box-shadow: 2px 2px 6px rgba(0, 0, 0, 0.4);
  transform: translateY(-1px);
  -webkit-transform: translateY(-1px);
}

.btn-group.select .btn {
  text-align: left;
}

.btn-group.select .caret {
  position: absolute;
  top: 50%;
  margin-top: -1px;
  right: 8px;
}

.btn-group .btn.active {
  box-shadow: 2px 2px 6px rgba(0, 0, 0, 0.4);
  transform: translateY(-1px);
  -webkit-transform: translateY(-1px);
}

.btn-round {
  border-width: 1px;
  border-radius: 30px;
}
.btn-round.btn-simple {
  padding: 10px 22px;
}

.no-caret.dropdown-toggle::after {
  display: none;
}

.btn-secondary:not(:disabled):not(.disabled):active,
.btn-secondary:not(:disabled):not(.disabled).active,
.show > .btn-secondary.dropdown-toggle {
  color: #ffffff;
}

.btn-group label.btn.active {
  transform: translateY(0);
  -webkit-transform: translateY(0);
}

.btn + .btn {
  margin-left: 5px;
}

.dropdown-menu {
  border: 0;
  box-shadow: 0px 10px 50px 0px rgba(0, 0, 0, 0.2);
  border-radius: 0.1428rem;
  transition: all 150ms linear;
}
.dropdown-menu.dropdown-menu-right:before, .dropdown-menu.dropdown-menu-right:after {
  left: auto;
  right: 10px;
}
.dropdown-menu.dropdown-black {
  background: linear-gradient(to bottom, #000000 0%, #1d253b 100%);
  border: 1px solid #011e31;
}
.dropdown-menu.dropdown-black .dropdown-item {
  color: rgba(255, 255, 255, 0.7);
}
.dropdown-menu.dropdown-black .dropdown-divider {
  border-color: #011e31;
}
.dropdown-menu.dropdown-black:before {
  color: #000000;
  z-index: 2;
}
.dropdown-menu.dropdown-black:after {
  display: inline-block;
  position: absolute;
  width: 0;
  height: 0;
  z-index: 1;
  vertical-align: middle;
  content: "";
  top: -6px;
  left: 10px;
  right: auto;
  color: #011e31;
  border-bottom: 0.4em solid;
  border-right: 0.4em solid transparent;
  border-left: 0.4em solid transparent;
}
.dropdown-menu.dropdown-black.dropdown-menu-right:after {
  left: auto;
  right: 10px;
}
.dropup .dropdown-menu.dropdown-black:after {
  color: #1d253b;
  z-index: 2;
}
.dropup .dropdown-menu.dropdown-black:before {
  display: inline-block;
  position: absolute;
  width: 0;
  height: 0;
  vertical-align: middle;
  content: "";
  top: auto;
  bottom: -6px;
  right: auto;
  left: 10px;
  color: #555555;
  border-top: 0.4em solid;
  border-right: 0.4em solid transparent;
  border-left: 0.4em solid transparent;
  border-bottom: none;
  z-index: 1;
}
.dropdown-menu i {
  margin-right: 5px;
  position: relative;
  top: 1px;
}
.dropdown-menu .tim-icons {
  margin-right: 10px;
  position: relative;
  top: 4px;
  font-size: 18px;
  margin-top: -5px;
  opacity: 0.5;
}
.dropdown-menu .dropdown-item.active, .dropdown-menu .dropdown-item:active {
  color: inherit;
}
.dropup .dropdown-menu:before {
  display: none;
}
.dropup .dropdown-menu:after {
  display: inline-block;
  position: absolute;
  width: 0;
  height: 0;
  vertical-align: middle;
  content: "";
  top: auto;
  bottom: -5px;
  right: auto;
  left: 10px;
  color: #ffffff;
  border-top: 0.4em solid;
  border-right: 0.4em solid transparent;
  border-left: 0.4em solid transparent;
  border-bottom: none;
}
.dropup .dropdown-menu.dropdown-menu-right:after, .dropup .dropdown-menu.dropdown-menu-right:before {
  right: 10px;
  left: auto;
}
.dropdown-menu:before {
  display: inline-block;
  position: absolute;
  width: 0;
  height: 0;
  vertical-align: middle;
  content: "";
  top: -5px;
  left: 10px;
  right: auto;
  color: #ffffff;
  border-bottom: 0.4em solid;
  border-right: 0.4em solid transparent;
  border-left: 0.4em solid transparent;
}
.dropdown-menu.dropdown-menu-right {
  right: 0 !important;
  left: auto !important;
}
.dropdown-menu .dropdown-item, .bootstrap-select .dropdown-menu.inner li a {
  font-size: 0.7500000025rem;
  padding-top: 0.6rem;
  padding-bottom: 0.6rem;
  margin-top: 5px;
  transition: all 150ms linear;
}
.dropdown-menu .dropdown-item:hover, .dropdown-menu .dropdown-item:focus, .bootstrap-select .dropdown-menu.inner li a:hover, .bootstrap-select .dropdown-menu.inner li a:focus {
  background-color: rgba(222, 222, 222, 0.3);
}
.dropdown-menu .dropdown-item.disabled, .dropdown-menu .dropdown-item:disabled, .bootstrap-select .dropdown-menu.inner li a.disabled, .bootstrap-select .dropdown-menu.inner li a:disabled {
  color: rgba(182, 182, 182, 0.6);
}
.dropdown-menu .dropdown-item.disabled:hover, .dropdown-menu .dropdown-item.disabled:focus, .dropdown-menu .dropdown-item:disabled:hover, .dropdown-menu .dropdown-item:disabled:focus, .bootstrap-select .dropdown-menu.inner li a.disabled:hover, .bootstrap-select .dropdown-menu.inner li a.disabled:focus, .bootstrap-select .dropdown-menu.inner li a:disabled:hover, .bootstrap-select .dropdown-menu.inner li a:disabled:focus {
  background-color: transparent;
  box-shadow: none;
}
.dropdown-menu .dropdown-divider {
  background-color: rgba(222, 222, 222, 0.5);
}
.dropdown-menu .dropdown-header:not([href]) {
  color: rgba(182, 182, 182, 0.6);
  font-size: 0.62475rem;
  text-transform: uppercase;
  font-weight: 600;
}
.dropdown-menu.dropdown-primary {
  background-color: #617e91;
}
.dropdown-menu.dropdown-primary:before {
  color: #617e91;
}
.dropdown-menu.dropdown-primary .dropdown-header:not([href]):not([tabindex]) {
  color: rgba(255, 255, 255, 0.8);
}
.dropdown-menu.dropdown-primary .dropdown-item {
  color: #ffffff;
}
.dropdown-menu.dropdown-primary .dropdown-item:hover, .dropdown-menu.dropdown-primary .dropdown-item:focus {
  background-color: rgba(255, 255, 255, 0.2);
}
.dropdown-menu.dropdown-primary .dropdown-divider {
  background-color: rgba(255, 255, 255, 0.2);
}
.dropdown-menu.dropdown-info {
  background-color: #0a3852;
}
.dropdown-menu.dropdown-info:before {
  color: #0a3852;
}
.dropdown-menu.dropdown-info .dropdown-header:not([href]):not([tabindex]) {
  color: rgba(255, 255, 255, 0.8);
}
.dropdown-menu.dropdown-info .dropdown-item {
  color: #ffffff;
}
.dropdown-menu.dropdown-info .dropdown-item:hover, .dropdown-menu.dropdown-info .dropdown-item:focus {
  background-color: rgba(255, 255, 255, 0.2);
}
.dropdown-menu.dropdown-info .dropdown-divider {
  background-color: rgba(255, 255, 255, 0.2);
}
.dropdown-menu.dropdown-danger {
  background-color: #0a3852;
}
.dropdown-menu.dropdown-danger:before {
  color: #0a3852;
}
.dropdown-menu.dropdown-danger .dropdown-header:not([href]):not([tabindex]) {
  color: rgba(255, 255, 255, 0.8);
}
.dropdown-menu.dropdown-danger .dropdown-item {
  color: #ffffff;
}
.dropdown-menu.dropdown-danger .dropdown-item:hover, .dropdown-menu.dropdown-danger .dropdown-item:focus {
  background-color: rgba(255, 255, 255, 0.2);
}
.dropdown-menu.dropdown-danger .dropdown-divider {
  background-color: rgba(255, 255, 255, 0.2);
}
.dropdown-menu.dropdown-success {
  background-color: #617e91;
}
.dropdown-menu.dropdown-success:before {
  color: #617e91;
}
.dropdown-menu.dropdown-success .dropdown-header:not([href]):not([tabindex]) {
  color: rgba(255, 255, 255, 0.8);
}
.dropdown-menu.dropdown-success .dropdown-item {
  color: #ffffff;
}
.dropdown-menu.dropdown-success .dropdown-item:hover, .dropdown-menu.dropdown-success .dropdown-item:focus {
  background-color: rgba(255, 255, 255, 0.2);
}
.dropdown-menu.dropdown-success .dropdown-divider {
  background-color: rgba(255, 255, 255, 0.2);
}
.dropdown-menu.dropdown-warning {
  background-color: #0a3852;
}
.dropdown-menu.dropdown-warning:before {
  color: #0a3852;
}
.dropdown-menu.dropdown-warning .dropdown-header:not([href]):not([tabindex]) {
  color: rgba(255, 255, 255, 0.8);
}
.dropdown-menu.dropdown-warning .dropdown-item {
  color: #ffffff;
}
.dropdown-menu.dropdown-warning .dropdown-item:hover, .dropdown-menu.dropdown-warning .dropdown-item:focus {
  background-color: rgba(255, 255, 255, 0.2);
}
.dropdown-menu.dropdown-warning .dropdown-divider {
  background-color: rgba(255, 255, 255, 0.2);
}
.dropdown .dropdown-menu, .dropup:not(.bootstrap-select) .dropdown-menu, .bootstrap-select .dropdown-menu:not(.inner), .dropdown-menu.bootstrap-datetimepicker-widget.bottom {
  transform: translate3d(0, -20px, 0) !important;
  visibility: hidden;
  display: block;
  opacity: 0;
  filter: alpha(opacity=0);
  top: 100% !important;
}
.dropdown-menu.bootstrap-datetimepicker-widget.top {
  transform: translate3d(0, -20px, 0) !important;
  visibility: hidden;
  display: block;
  opacity: 0;
  filter: alpha(opacity=0);
}
.dropdown-menu.bootstrap-datetimepicker-widget.top, .dropdown-menu.bootstrap-datetimepicker-widget.bottom {
  transform: translate3d(0, -20px, 0) !important;
}
.bootstrap-select.dropup .dropdown-menu:not(.inner) {
  transform: translate3d(0, 25px, 0) !important;
}
.dropup:not(.bootstrap-select) .dropdown-menu {
  transform: translate3d(0, 20px, 0) !important;
  top: auto !important;
  bottom: 100%;
}
.dropdown.show .dropdown-menu, .bootstrap-select.show .dropdown-menu:not(.inner), .dropdown-menu.bootstrap-datetimepicker-widget.top.open, .dropdown-menu.bootstrap-datetimepicker-widget.bottom.open, .dropup.show:not(.bootstrap-select) .dropdown-menu, .navbar .dropdown.show .dropdown-menu {
  opacity: 1;
  filter: alpha(opacity=100);
  visibility: visible;
  transform: translate3d(0, 1px, 0) !important;
}
.dropdown-menu.bootstrap-datetimepicker-widget.top.open, .dropdown-menu.bootstrap-datetimepicker-widget.bottom.open {
  transform: translate3d(0, 0px, 0) !important;
}
.dropup.show:not(.bootstrap-select) .dropdown-menu {
  transform: translate3d(0, -2px, 0) !important;
}
.dropdown-menu.dropdown-navbar {
  left: -80px;
}
.dropdown-menu.dropdown-navbar:before, .dropdown-menu.dropdown-navbar:after {
  left: auto;
  right: 17px;
}

.btn {
  cursor: pointer;
}
.btn.dropdown-toggle[data-toggle=dropdown] {
  padding: 10px;
  margin: 0;
  margin-bottom: 5px;
}
.btn.dropdown-toggle[data-toggle=dropdown]:after {
  content: "";
  margin-left: 5px;
}
.btn span.bs-caret {
  display: none;
}
.btn.btn-link.dropdown-toggle {
  height: 22px;
  padding: 0;
  margin-right: 5px;
}

.dropdown-toggle:after {
  content: normal;
  content: initial;
}

.btn:not(:disabled):not(.disabled).active:focus,
.btn:not(:disabled):not(.disabled):active:focus,
.show > .btn.dropdown-toggle:focus {
  box-shadow: none;
}

.dropdown-menu-sm {
  min-width: 100px;
  border: 0.4285rem;
}

.dropdown-menu-lg {
  min-width: 260px;
  border-radius: 0.4285rem;
}

.dropdown-menu-xl {
  min-width: 450px;
  border-radius: 0.4285rem;
}

@media screen and (max-width: 991px) {
  .dropdown-toggle:after {
    display: inline-block;
    width: 0;
    height: 0;
    margin-left: 0.255em;
    vertical-align: 0.255em;
    content: "";
    border-top: 0.3em solid;
    border-right: 0.3em solid transparent;
    border-bottom: 0;
    border-left: 0.3em solid transparent;
  }
}
@media screen and (min-width: 992px) {
  .dropdown-menu .dropdown-item {
    color: #AAAAAA;
  }
}
.footer {
  padding: 24px 0 24px 250px;
}
.footer [class*=container-] {
  padding: 0;
}
.footer .nav {
  display: inline-block;
  float: left;
  margin-bottom: 0;
  padding-left: 30px;
  list-style: none;
}
.footer .nav-item {
  display: inline-block;
}
.footer .nav-item:first-child a {
  padding-left: 0;
}
.footer .nav-link {
  color: #ffffff;
  padding: 0 0.5rem;
  font-size: 0.7500000025rem;
  text-transform: uppercase;
  text-decoration: none;
}
.footer .nav-link:hover {
  text-decoration: none;
}
.footer .copyright {
  font-size: 0.7500000025rem;
  line-height: 1.8;
  color: #ffffff;
}
.footer:after {
  display: table;
  clear: both;
  content: " ";
}

@media screen and (max-width: 991px) {
  .footer {
    padding-left: 0px;
  }
  .footer .copyright {
    text-align: right;
    margin-right: 15px;
  }
}
@media screen and (min-width: 992px) {
  .footer .copyright {
    float: right;
    padding-right: 30px;
  }
}
@media screen and (max-width: 768px) {
  .footer nav {
    display: block;
    margin-bottom: 5px;
    float: none;
  }
}
@media screen and (max-width: 576px) {
  .footer {
    text-align: center;
  }
  .footer .copyright {
    text-align: center;
  }
  .footer .nav {
    float: none;
    padding-left: 0;
  }
}
/* Form controls */
.form-control::-moz-placeholder {
  color: #6c757c;
  opacity: 1;
  filter: alpha(opacity=100);
}

.form-control:-moz-placeholder {
  color: #6c757c;
  opacity: 1;
  filter: alpha(opacity=100);
}

.form-control::-webkit-input-placeholder {
  color: #6c757c;
  opacity: 1;
  filter: alpha(opacity=100);
}

.form-control:-ms-input-placeholder {
  color: #6c757c;
  opacity: 1;
  filter: alpha(opacity=100);
}

.form-control {
  border-color: #0d0d0d;
  border-radius: 0.4285rem;
  font-size: 0.7500000025rem;
  transition: color 0.3s ease-in-out, border-color 0.3s ease-in-out, background-color 0.3s ease-in-out;
}
.form-control:focus {
  border-color: #68869a;
  background-color: transparent;
  box-shadow: none;
}
.form-control:focus + .input-group-append .input-group-text, .form-control:focus ~ .input-group-append .input-group-text, .form-control:focus + .input-group-prepend .input-group-text, .form-control:focus ~ .input-group-prepend .input-group-text {
  border: 1px solid #68869a;
  border-left: none;
  background-color: transparent;
}
.has-success .form-control, .has-error .form-control, .has-success .form-control:focus, .has-error .form-control:focus {
  box-shadow: none;
}
.has-danger .form-control.form-control-success, .has-danger .form-control.form-control-danger, .has-success .form-control.form-control-success, .has-success .form-control.form-control-danger {
  background-image: none;
}
.form-control + .form-control-feedback {
  border-radius: 0.4285rem;
  margin-top: -7px;
  position: absolute;
  right: 10px;
  top: 50%;
  vertical-align: middle;
}
.open .form-control {
  border-radius: 0.4285rem 0.4285rem 0 0;
  border-bottom-color: transparent;
}
.form-control + .input-group-append .input-group-text, .form-control + .input-group-prepend .input-group-text {
  background-color: #ffffff;
}

.has-success .input-group-append .input-group-text,
.has-success .input-group-prepend .input-group-text,
.has-success .form-control {
  border-color: #0d0d0d;
}

.has-success .form-control:focus,
.has-success.input-group-focus .input-group-append .input-group-text,
.has-success.input-group-focus .input-group-prepend .input-group-text {
  border-color: #536c7c;
}

.has-danger .form-control,
.has-danger .input-group-append .input-group-text,
.has-danger .input-group-prepend .input-group-text,
.has-danger.input-group-focus .input-group-prepend .input-group-text,
.has-danger.input-group-focus .input-group-append .input-group-text {
  border-color: #f33620;
  color: #ec250d;
  background-color: rgba(222, 222, 222, 0.1);
}
.has-danger .form-control:focus,
.has-danger .input-group-append .input-group-text:focus,
.has-danger .input-group-prepend .input-group-text:focus,
.has-danger.input-group-focus .input-group-prepend .input-group-text:focus,
.has-danger.input-group-focus .input-group-append .input-group-text:focus {
  background-color: transparent;
}

.has-success:after,
.has-danger:after {
  font-family: "nucleo";
  content: "\\ea1b";
  display: inline-block;
  position: absolute;
  right: 20px;
  top: 13px;
  color: #68869a;
  font-size: 11px;
}
.has-success.form-control-lg:after,
.has-danger.form-control-lg:after {
  font-size: 13px;
  top: 24px;
}
.has-success.has-label:after,
.has-danger.has-label:after {
  top: 37px;
}
.has-success.form-check:after,
.has-danger.form-check:after {
  display: none !important;
}
.has-success.form-check .form-check-label,
.has-danger.form-check .form-check-label {
  color: #68869a;
}

.has-danger:after {
  content: "\\ea48";
  color: #ec250d;
}
.has-danger.form-check .form-check-label {
  color: #ec250d;
}

img {
  max-width: 100%;
  border-radius: 0.2857rem;
}

.img-raised {
  box-shadow: 0px 10px 25px 0px rgba(0, 0, 0, 0.3);
}

.modal-content {
  border: 0;
}
.modal-content .modal-header {
  border-bottom: none;
}
.modal-content .modal-header button {
  position: absolute;
  right: 27px;
  top: 24px;
  outline: 0;
  padding: 1rem;
  margin: -1rem -1rem -1rem auto;
}
.modal-content .modal-header .title {
  color: #000000;
  margin-top: 5px;
  margin-bottom: 0;
}
.modal-content .modal-header .modal-title {
  color: #000000;
}
.modal-content .modal-header i.tim-icons {
  font-size: 16px;
}
.modal-content .modal-body {
  line-height: 1.9;
}
.modal-content .modal-body p {
  color: #000000;
}
.modal-content .modal-footer {
  border-top: 0; /* Safari 6.1+ */
  justify-content: space-between;
}
.modal-content .modal-footer button {
  margin: 0;
  padding-left: 16px;
  padding-right: 16px;
  width: auto;
}
.modal-content .modal-footer button.pull-left {
  padding-left: 5px;
  padding-right: 5px;
  position: relative;
  left: -5px;
}
.modal-content .modal-body + .modal-footer {
  padding-top: 0;
}

.modal-backdrop {
  background: rgba(0, 0, 0, 0.3);
}

.modal.modal-default .modal-content {
  background-color: #ffffff;
  color: #000000;
}
.modal.modal-default .modal-body p {
  color: rgba(255, 255, 255, 0.8);
}
.modal.modal-default .form-control::-moz-placeholder {
  color: rgba(255, 255, 255, 0.4);
  opacity: 1;
  filter: alpha(opacity=100);
}
.modal.modal-default .form-control:-moz-placeholder {
  color: rgba(255, 255, 255, 0.4);
  opacity: 1;
  filter: alpha(opacity=100);
}
.modal.modal-default .form-control::-webkit-input-placeholder {
  color: rgba(255, 255, 255, 0.4);
  opacity: 1;
  filter: alpha(opacity=100);
}
.modal.modal-default .form-control:-ms-input-placeholder {
  color: rgba(255, 255, 255, 0.4);
  opacity: 1;
  filter: alpha(opacity=100);
}
.modal.modal-default .form-control {
  border-color: rgba(255, 255, 255, 0.5);
  color: #ffffff;
}
.modal.modal-default .form-control:focus {
  border-color: #ffffff;
  background-color: transparent;
  color: #ffffff;
}
.modal.modal-default .has-success:after,
.modal.modal-default .has-danger:after {
  color: #ffffff;
}
.modal.modal-default .has-danger .form-control {
  background-color: transparent;
}
.modal.modal-default .input-group-prepend {
  margin-right: 0;
}
.modal.modal-default .input-group-prepend .input-group-text,
.modal.modal-default .input-group-append .input-group-text {
  background-color: rgba(30, 30, 36, 0.2);
  border-color: rgba(255, 255, 255, 0.5);
  color: #ffffff;
}
.modal.modal-default .input-group-focus .input-group-prepend .input-group-text,
.modal.modal-default .input-group-focus .input-group-append .input-group-text {
  background-color: rgba(30, 30, 36, 0.3);
  border-color: #ffffff;
  color: #ffffff;
}
.modal.modal-default .form-group.no-border .form-control,
.modal.modal-default .input-group.no-border .form-control {
  background-color: rgba(30, 30, 36, 0.2);
  color: #ffffff;
}
.modal.modal-default .form-group.no-border .form-control:focus, .modal.modal-default .form-group.no-border .form-control:active, .modal.modal-default .form-group.no-border .form-control:active,
.modal.modal-default .input-group.no-border .form-control:focus,
.modal.modal-default .input-group.no-border .form-control:active,
.modal.modal-default .input-group.no-border .form-control:active {
  background-color: rgba(30, 30, 36, 0.3);
  color: #ffffff;
}
.modal.modal-default .form-group.no-border .form-control + .input-group-prepend .input-group-text,
.modal.modal-default .form-group.no-border .form-control + .input-group-append .input-group-text,
.modal.modal-default .input-group.no-border .form-control + .input-group-prepend .input-group-text,
.modal.modal-default .input-group.no-border .form-control + .input-group-append .input-group-text {
  background-color: rgba(30, 30, 36, 0.2);
}
.modal.modal-default .form-group.no-border .form-control + .input-group-prepend .input-group-text:focus, .modal.modal-default .form-group.no-border .form-control + .input-group-prepend .input-group-text:active, .modal.modal-default .form-group.no-border .form-control + .input-group-prepend .input-group-text:active,
.modal.modal-default .form-group.no-border .form-control + .input-group-append .input-group-text:focus,
.modal.modal-default .form-group.no-border .form-control + .input-group-append .input-group-text:active,
.modal.modal-default .form-group.no-border .form-control + .input-group-append .input-group-text:active,
.modal.modal-default .input-group.no-border .form-control + .input-group-prepend .input-group-text:focus,
.modal.modal-default .input-group.no-border .form-control + .input-group-prepend .input-group-text:active,
.modal.modal-default .input-group.no-border .form-control + .input-group-prepend .input-group-text:active,
.modal.modal-default .input-group.no-border .form-control + .input-group-append .input-group-text:focus,
.modal.modal-default .input-group.no-border .form-control + .input-group-append .input-group-text:active,
.modal.modal-default .input-group.no-border .form-control + .input-group-append .input-group-text:active {
  background-color: rgba(30, 30, 36, 0.3);
  color: #ffffff;
}
.modal.modal-default .form-group.no-border .form-control:focus + .input-group-prepend .input-group-text, .modal.modal-default .form-group.no-border .form-control:focus + .input-group-append .input-group-text,
.modal.modal-default .input-group.no-border .form-control:focus + .input-group-prepend .input-group-text,
.modal.modal-default .input-group.no-border .form-control:focus + .input-group-append .input-group-text {
  background-color: rgba(30, 30, 36, 0.3);
  color: #ffffff;
}
.modal.modal-default .form-group.no-border .input-group-prepend .input-group-text,
.modal.modal-default .form-group.no-border .input-group-append .input-group-text,
.modal.modal-default .input-group.no-border .input-group-prepend .input-group-text,
.modal.modal-default .input-group.no-border .input-group-append .input-group-text {
  background-color: rgba(30, 30, 36, 0.2);
  border: none;
  color: #ffffff;
}
.modal.modal-default .form-group.no-border.input-group-focus .input-group-prepend .input-group-text,
.modal.modal-default .form-group.no-border.input-group-focus .input-group-append .input-group-text,
.modal.modal-default .input-group.no-border.input-group-focus .input-group-prepend .input-group-text,
.modal.modal-default .input-group.no-border.input-group-focus .input-group-append .input-group-text {
  background-color: rgba(30, 30, 36, 0.3);
  color: #ffffff;
}
.modal.modal-primary .modal-content {
  background-color: #68869a;
  color: #ffffff;
}
.modal.modal-primary .modal-body p {
  color: rgba(255, 255, 255, 0.8);
}
.modal.modal-primary .form-control::-moz-placeholder {
  color: rgba(255, 255, 255, 0.4);
  opacity: 1;
  filter: alpha(opacity=100);
}
.modal.modal-primary .form-control:-moz-placeholder {
  color: rgba(255, 255, 255, 0.4);
  opacity: 1;
  filter: alpha(opacity=100);
}
.modal.modal-primary .form-control::-webkit-input-placeholder {
  color: rgba(255, 255, 255, 0.4);
  opacity: 1;
  filter: alpha(opacity=100);
}
.modal.modal-primary .form-control:-ms-input-placeholder {
  color: rgba(255, 255, 255, 0.4);
  opacity: 1;
  filter: alpha(opacity=100);
}
.modal.modal-primary .form-control {
  border-color: rgba(255, 255, 255, 0.5);
  color: #ffffff;
}
.modal.modal-primary .form-control:focus {
  border-color: #ffffff;
  background-color: transparent;
  color: #ffffff;
}
.modal.modal-primary .has-success:after,
.modal.modal-primary .has-danger:after {
  color: #ffffff;
}
.modal.modal-primary .has-danger .form-control {
  background-color: transparent;
}
.modal.modal-primary .input-group-prepend {
  margin-right: 0;
}
.modal.modal-primary .input-group-prepend .input-group-text,
.modal.modal-primary .input-group-append .input-group-text {
  background-color: rgba(30, 30, 36, 0.2);
  border-color: rgba(255, 255, 255, 0.5);
  color: #ffffff;
}
.modal.modal-primary .input-group-focus .input-group-prepend .input-group-text,
.modal.modal-primary .input-group-focus .input-group-append .input-group-text {
  background-color: rgba(30, 30, 36, 0.3);
  border-color: #ffffff;
  color: #ffffff;
}
.modal.modal-primary .form-group.no-border .form-control,
.modal.modal-primary .input-group.no-border .form-control {
  background-color: rgba(30, 30, 36, 0.2);
  color: #ffffff;
}
.modal.modal-primary .form-group.no-border .form-control:focus, .modal.modal-primary .form-group.no-border .form-control:active, .modal.modal-primary .form-group.no-border .form-control:active,
.modal.modal-primary .input-group.no-border .form-control:focus,
.modal.modal-primary .input-group.no-border .form-control:active,
.modal.modal-primary .input-group.no-border .form-control:active {
  background-color: rgba(30, 30, 36, 0.3);
  color: #ffffff;
}
.modal.modal-primary .form-group.no-border .form-control + .input-group-prepend .input-group-text,
.modal.modal-primary .form-group.no-border .form-control + .input-group-append .input-group-text,
.modal.modal-primary .input-group.no-border .form-control + .input-group-prepend .input-group-text,
.modal.modal-primary .input-group.no-border .form-control + .input-group-append .input-group-text {
  background-color: rgba(30, 30, 36, 0.2);
}
.modal.modal-primary .form-group.no-border .form-control + .input-group-prepend .input-group-text:focus, .modal.modal-primary .form-group.no-border .form-control + .input-group-prepend .input-group-text:active, .modal.modal-primary .form-group.no-border .form-control + .input-group-prepend .input-group-text:active,
.modal.modal-primary .form-group.no-border .form-control + .input-group-append .input-group-text:focus,
.modal.modal-primary .form-group.no-border .form-control + .input-group-append .input-group-text:active,
.modal.modal-primary .form-group.no-border .form-control + .input-group-append .input-group-text:active,
.modal.modal-primary .input-group.no-border .form-control + .input-group-prepend .input-group-text:focus,
.modal.modal-primary .input-group.no-border .form-control + .input-group-prepend .input-group-text:active,
.modal.modal-primary .input-group.no-border .form-control + .input-group-prepend .input-group-text:active,
.modal.modal-primary .input-group.no-border .form-control + .input-group-append .input-group-text:focus,
.modal.modal-primary .input-group.no-border .form-control + .input-group-append .input-group-text:active,
.modal.modal-primary .input-group.no-border .form-control + .input-group-append .input-group-text:active {
  background-color: rgba(30, 30, 36, 0.3);
  color: #ffffff;
}
.modal.modal-primary .form-group.no-border .form-control:focus + .input-group-prepend .input-group-text, .modal.modal-primary .form-group.no-border .form-control:focus + .input-group-append .input-group-text,
.modal.modal-primary .input-group.no-border .form-control:focus + .input-group-prepend .input-group-text,
.modal.modal-primary .input-group.no-border .form-control:focus + .input-group-append .input-group-text {
  background-color: rgba(30, 30, 36, 0.3);
  color: #ffffff;
}
.modal.modal-primary .form-group.no-border .input-group-prepend .input-group-text,
.modal.modal-primary .form-group.no-border .input-group-append .input-group-text,
.modal.modal-primary .input-group.no-border .input-group-prepend .input-group-text,
.modal.modal-primary .input-group.no-border .input-group-append .input-group-text {
  background-color: rgba(30, 30, 36, 0.2);
  border: none;
  color: #ffffff;
}
.modal.modal-primary .form-group.no-border.input-group-focus .input-group-prepend .input-group-text,
.modal.modal-primary .form-group.no-border.input-group-focus .input-group-append .input-group-text,
.modal.modal-primary .input-group.no-border.input-group-focus .input-group-prepend .input-group-text,
.modal.modal-primary .input-group.no-border.input-group-focus .input-group-append .input-group-text {
  background-color: rgba(30, 30, 36, 0.3);
  color: #ffffff;
}
.modal.modal-danger .modal-content {
  background-color: #0c4160;
  color: #ffffff;
}
.modal.modal-danger .modal-body p {
  color: rgba(255, 255, 255, 0.8);
}
.modal.modal-danger .form-control::-moz-placeholder {
  color: rgba(255, 255, 255, 0.4);
  opacity: 1;
  filter: alpha(opacity=100);
}
.modal.modal-danger .form-control:-moz-placeholder {
  color: rgba(255, 255, 255, 0.4);
  opacity: 1;
  filter: alpha(opacity=100);
}
.modal.modal-danger .form-control::-webkit-input-placeholder {
  color: rgba(255, 255, 255, 0.4);
  opacity: 1;
  filter: alpha(opacity=100);
}
.modal.modal-danger .form-control:-ms-input-placeholder {
  color: rgba(255, 255, 255, 0.4);
  opacity: 1;
  filter: alpha(opacity=100);
}
.modal.modal-danger .form-control {
  border-color: rgba(255, 255, 255, 0.5);
  color: #ffffff;
}
.modal.modal-danger .form-control:focus {
  border-color: #ffffff;
  background-color: transparent;
  color: #ffffff;
}
.modal.modal-danger .has-success:after,
.modal.modal-danger .has-danger:after {
  color: #ffffff;
}
.modal.modal-danger .has-danger .form-control {
  background-color: transparent;
}
.modal.modal-danger .input-group-prepend {
  margin-right: 0;
}
.modal.modal-danger .input-group-prepend .input-group-text,
.modal.modal-danger .input-group-append .input-group-text {
  background-color: rgba(30, 30, 36, 0.2);
  border-color: rgba(255, 255, 255, 0.5);
  color: #ffffff;
}
.modal.modal-danger .input-group-focus .input-group-prepend .input-group-text,
.modal.modal-danger .input-group-focus .input-group-append .input-group-text {
  background-color: rgba(30, 30, 36, 0.3);
  border-color: #ffffff;
  color: #ffffff;
}
.modal.modal-danger .form-group.no-border .form-control,
.modal.modal-danger .input-group.no-border .form-control {
  background-color: rgba(30, 30, 36, 0.2);
  color: #ffffff;
}
.modal.modal-danger .form-group.no-border .form-control:focus, .modal.modal-danger .form-group.no-border .form-control:active, .modal.modal-danger .form-group.no-border .form-control:active,
.modal.modal-danger .input-group.no-border .form-control:focus,
.modal.modal-danger .input-group.no-border .form-control:active,
.modal.modal-danger .input-group.no-border .form-control:active {
  background-color: rgba(30, 30, 36, 0.3);
  color: #ffffff;
}
.modal.modal-danger .form-group.no-border .form-control + .input-group-prepend .input-group-text,
.modal.modal-danger .form-group.no-border .form-control + .input-group-append .input-group-text,
.modal.modal-danger .input-group.no-border .form-control + .input-group-prepend .input-group-text,
.modal.modal-danger .input-group.no-border .form-control + .input-group-append .input-group-text {
  background-color: rgba(30, 30, 36, 0.2);
}
.modal.modal-danger .form-group.no-border .form-control + .input-group-prepend .input-group-text:focus, .modal.modal-danger .form-group.no-border .form-control + .input-group-prepend .input-group-text:active, .modal.modal-danger .form-group.no-border .form-control + .input-group-prepend .input-group-text:active,
.modal.modal-danger .form-group.no-border .form-control + .input-group-append .input-group-text:focus,
.modal.modal-danger .form-group.no-border .form-control + .input-group-append .input-group-text:active,
.modal.modal-danger .form-group.no-border .form-control + .input-group-append .input-group-text:active,
.modal.modal-danger .input-group.no-border .form-control + .input-group-prepend .input-group-text:focus,
.modal.modal-danger .input-group.no-border .form-control + .input-group-prepend .input-group-text:active,
.modal.modal-danger .input-group.no-border .form-control + .input-group-prepend .input-group-text:active,
.modal.modal-danger .input-group.no-border .form-control + .input-group-append .input-group-text:focus,
.modal.modal-danger .input-group.no-border .form-control + .input-group-append .input-group-text:active,
.modal.modal-danger .input-group.no-border .form-control + .input-group-append .input-group-text:active {
  background-color: rgba(30, 30, 36, 0.3);
  color: #ffffff;
}
.modal.modal-danger .form-group.no-border .form-control:focus + .input-group-prepend .input-group-text, .modal.modal-danger .form-group.no-border .form-control:focus + .input-group-append .input-group-text,
.modal.modal-danger .input-group.no-border .form-control:focus + .input-group-prepend .input-group-text,
.modal.modal-danger .input-group.no-border .form-control:focus + .input-group-append .input-group-text {
  background-color: rgba(30, 30, 36, 0.3);
  color: #ffffff;
}
.modal.modal-danger .form-group.no-border .input-group-prepend .input-group-text,
.modal.modal-danger .form-group.no-border .input-group-append .input-group-text,
.modal.modal-danger .input-group.no-border .input-group-prepend .input-group-text,
.modal.modal-danger .input-group.no-border .input-group-append .input-group-text {
  background-color: rgba(30, 30, 36, 0.2);
  border: none;
  color: #ffffff;
}
.modal.modal-danger .form-group.no-border.input-group-focus .input-group-prepend .input-group-text,
.modal.modal-danger .form-group.no-border.input-group-focus .input-group-append .input-group-text,
.modal.modal-danger .input-group.no-border.input-group-focus .input-group-prepend .input-group-text,
.modal.modal-danger .input-group.no-border.input-group-focus .input-group-append .input-group-text {
  background-color: rgba(30, 30, 36, 0.3);
  color: #ffffff;
}
.modal.modal-warning .modal-content {
  background-color: #0c4160;
  color: #ffffff;
}
.modal.modal-warning .modal-body p {
  color: rgba(255, 255, 255, 0.8);
}
.modal.modal-warning .form-control::-moz-placeholder {
  color: rgba(255, 255, 255, 0.4);
  opacity: 1;
  filter: alpha(opacity=100);
}
.modal.modal-warning .form-control:-moz-placeholder {
  color: rgba(255, 255, 255, 0.4);
  opacity: 1;
  filter: alpha(opacity=100);
}
.modal.modal-warning .form-control::-webkit-input-placeholder {
  color: rgba(255, 255, 255, 0.4);
  opacity: 1;
  filter: alpha(opacity=100);
}
.modal.modal-warning .form-control:-ms-input-placeholder {
  color: rgba(255, 255, 255, 0.4);
  opacity: 1;
  filter: alpha(opacity=100);
}
.modal.modal-warning .form-control {
  border-color: rgba(255, 255, 255, 0.5);
  color: #ffffff;
}
.modal.modal-warning .form-control:focus {
  border-color: #ffffff;
  background-color: transparent;
  color: #ffffff;
}
.modal.modal-warning .has-success:after,
.modal.modal-warning .has-danger:after {
  color: #ffffff;
}
.modal.modal-warning .has-danger .form-control {
  background-color: transparent;
}
.modal.modal-warning .input-group-prepend {
  margin-right: 0;
}
.modal.modal-warning .input-group-prepend .input-group-text,
.modal.modal-warning .input-group-append .input-group-text {
  background-color: rgba(30, 30, 36, 0.2);
  border-color: rgba(255, 255, 255, 0.5);
  color: #ffffff;
}
.modal.modal-warning .input-group-focus .input-group-prepend .input-group-text,
.modal.modal-warning .input-group-focus .input-group-append .input-group-text {
  background-color: rgba(30, 30, 36, 0.3);
  border-color: #ffffff;
  color: #ffffff;
}
.modal.modal-warning .form-group.no-border .form-control,
.modal.modal-warning .input-group.no-border .form-control {
  background-color: rgba(30, 30, 36, 0.2);
  color: #ffffff;
}
.modal.modal-warning .form-group.no-border .form-control:focus, .modal.modal-warning .form-group.no-border .form-control:active, .modal.modal-warning .form-group.no-border .form-control:active,
.modal.modal-warning .input-group.no-border .form-control:focus,
.modal.modal-warning .input-group.no-border .form-control:active,
.modal.modal-warning .input-group.no-border .form-control:active {
  background-color: rgba(30, 30, 36, 0.3);
  color: #ffffff;
}
.modal.modal-warning .form-group.no-border .form-control + .input-group-prepend .input-group-text,
.modal.modal-warning .form-group.no-border .form-control + .input-group-append .input-group-text,
.modal.modal-warning .input-group.no-border .form-control + .input-group-prepend .input-group-text,
.modal.modal-warning .input-group.no-border .form-control + .input-group-append .input-group-text {
  background-color: rgba(30, 30, 36, 0.2);
}
.modal.modal-warning .form-group.no-border .form-control + .input-group-prepend .input-group-text:focus, .modal.modal-warning .form-group.no-border .form-control + .input-group-prepend .input-group-text:active, .modal.modal-warning .form-group.no-border .form-control + .input-group-prepend .input-group-text:active,
.modal.modal-warning .form-group.no-border .form-control + .input-group-append .input-group-text:focus,
.modal.modal-warning .form-group.no-border .form-control + .input-group-append .input-group-text:active,
.modal.modal-warning .form-group.no-border .form-control + .input-group-append .input-group-text:active,
.modal.modal-warning .input-group.no-border .form-control + .input-group-prepend .input-group-text:focus,
.modal.modal-warning .input-group.no-border .form-control + .input-group-prepend .input-group-text:active,
.modal.modal-warning .input-group.no-border .form-control + .input-group-prepend .input-group-text:active,
.modal.modal-warning .input-group.no-border .form-control + .input-group-append .input-group-text:focus,
.modal.modal-warning .input-group.no-border .form-control + .input-group-append .input-group-text:active,
.modal.modal-warning .input-group.no-border .form-control + .input-group-append .input-group-text:active {
  background-color: rgba(30, 30, 36, 0.3);
  color: #ffffff;
}
.modal.modal-warning .form-group.no-border .form-control:focus + .input-group-prepend .input-group-text, .modal.modal-warning .form-group.no-border .form-control:focus + .input-group-append .input-group-text,
.modal.modal-warning .input-group.no-border .form-control:focus + .input-group-prepend .input-group-text,
.modal.modal-warning .input-group.no-border .form-control:focus + .input-group-append .input-group-text {
  background-color: rgba(30, 30, 36, 0.3);
  color: #ffffff;
}
.modal.modal-warning .form-group.no-border .input-group-prepend .input-group-text,
.modal.modal-warning .form-group.no-border .input-group-append .input-group-text,
.modal.modal-warning .input-group.no-border .input-group-prepend .input-group-text,
.modal.modal-warning .input-group.no-border .input-group-append .input-group-text {
  background-color: rgba(30, 30, 36, 0.2);
  border: none;
  color: #ffffff;
}
.modal.modal-warning .form-group.no-border.input-group-focus .input-group-prepend .input-group-text,
.modal.modal-warning .form-group.no-border.input-group-focus .input-group-append .input-group-text,
.modal.modal-warning .input-group.no-border.input-group-focus .input-group-prepend .input-group-text,
.modal.modal-warning .input-group.no-border.input-group-focus .input-group-append .input-group-text {
  background-color: rgba(30, 30, 36, 0.3);
  color: #ffffff;
}
.modal.modal-success .modal-content {
  background-color: #68869a;
  color: #ffffff;
}
.modal.modal-success .modal-body p {
  color: rgba(255, 255, 255, 0.8);
}
.modal.modal-success .form-control::-moz-placeholder {
  color: rgba(255, 255, 255, 0.4);
  opacity: 1;
  filter: alpha(opacity=100);
}
.modal.modal-success .form-control:-moz-placeholder {
  color: rgba(255, 255, 255, 0.4);
  opacity: 1;
  filter: alpha(opacity=100);
}
.modal.modal-success .form-control::-webkit-input-placeholder {
  color: rgba(255, 255, 255, 0.4);
  opacity: 1;
  filter: alpha(opacity=100);
}
.modal.modal-success .form-control:-ms-input-placeholder {
  color: rgba(255, 255, 255, 0.4);
  opacity: 1;
  filter: alpha(opacity=100);
}
.modal.modal-success .form-control {
  border-color: rgba(255, 255, 255, 0.5);
  color: #ffffff;
}
.modal.modal-success .form-control:focus {
  border-color: #ffffff;
  background-color: transparent;
  color: #ffffff;
}
.modal.modal-success .has-success:after,
.modal.modal-success .has-danger:after {
  color: #ffffff;
}
.modal.modal-success .has-danger .form-control {
  background-color: transparent;
}
.modal.modal-success .input-group-prepend {
  margin-right: 0;
}
.modal.modal-success .input-group-prepend .input-group-text,
.modal.modal-success .input-group-append .input-group-text {
  background-color: rgba(30, 30, 36, 0.2);
  border-color: rgba(255, 255, 255, 0.5);
  color: #ffffff;
}
.modal.modal-success .input-group-focus .input-group-prepend .input-group-text,
.modal.modal-success .input-group-focus .input-group-append .input-group-text {
  background-color: rgba(30, 30, 36, 0.3);
  border-color: #ffffff;
  color: #ffffff;
}
.modal.modal-success .form-group.no-border .form-control,
.modal.modal-success .input-group.no-border .form-control {
  background-color: rgba(30, 30, 36, 0.2);
  color: #ffffff;
}
.modal.modal-success .form-group.no-border .form-control:focus, .modal.modal-success .form-group.no-border .form-control:active, .modal.modal-success .form-group.no-border .form-control:active,
.modal.modal-success .input-group.no-border .form-control:focus,
.modal.modal-success .input-group.no-border .form-control:active,
.modal.modal-success .input-group.no-border .form-control:active {
  background-color: rgba(30, 30, 36, 0.3);
  color: #ffffff;
}
.modal.modal-success .form-group.no-border .form-control + .input-group-prepend .input-group-text,
.modal.modal-success .form-group.no-border .form-control + .input-group-append .input-group-text,
.modal.modal-success .input-group.no-border .form-control + .input-group-prepend .input-group-text,
.modal.modal-success .input-group.no-border .form-control + .input-group-append .input-group-text {
  background-color: rgba(30, 30, 36, 0.2);
}
.modal.modal-success .form-group.no-border .form-control + .input-group-prepend .input-group-text:focus, .modal.modal-success .form-group.no-border .form-control + .input-group-prepend .input-group-text:active, .modal.modal-success .form-group.no-border .form-control + .input-group-prepend .input-group-text:active,
.modal.modal-success .form-group.no-border .form-control + .input-group-append .input-group-text:focus,
.modal.modal-success .form-group.no-border .form-control + .input-group-append .input-group-text:active,
.modal.modal-success .form-group.no-border .form-control + .input-group-append .input-group-text:active,
.modal.modal-success .input-group.no-border .form-control + .input-group-prepend .input-group-text:focus,
.modal.modal-success .input-group.no-border .form-control + .input-group-prepend .input-group-text:active,
.modal.modal-success .input-group.no-border .form-control + .input-group-prepend .input-group-text:active,
.modal.modal-success .input-group.no-border .form-control + .input-group-append .input-group-text:focus,
.modal.modal-success .input-group.no-border .form-control + .input-group-append .input-group-text:active,
.modal.modal-success .input-group.no-border .form-control + .input-group-append .input-group-text:active {
  background-color: rgba(30, 30, 36, 0.3);
  color: #ffffff;
}
.modal.modal-success .form-group.no-border .form-control:focus + .input-group-prepend .input-group-text, .modal.modal-success .form-group.no-border .form-control:focus + .input-group-append .input-group-text,
.modal.modal-success .input-group.no-border .form-control:focus + .input-group-prepend .input-group-text,
.modal.modal-success .input-group.no-border .form-control:focus + .input-group-append .input-group-text {
  background-color: rgba(30, 30, 36, 0.3);
  color: #ffffff;
}
.modal.modal-success .form-group.no-border .input-group-prepend .input-group-text,
.modal.modal-success .form-group.no-border .input-group-append .input-group-text,
.modal.modal-success .input-group.no-border .input-group-prepend .input-group-text,
.modal.modal-success .input-group.no-border .input-group-append .input-group-text {
  background-color: rgba(30, 30, 36, 0.2);
  border: none;
  color: #ffffff;
}
.modal.modal-success .form-group.no-border.input-group-focus .input-group-prepend .input-group-text,
.modal.modal-success .form-group.no-border.input-group-focus .input-group-append .input-group-text,
.modal.modal-success .input-group.no-border.input-group-focus .input-group-prepend .input-group-text,
.modal.modal-success .input-group.no-border.input-group-focus .input-group-append .input-group-text {
  background-color: rgba(30, 30, 36, 0.3);
  color: #ffffff;
}
.modal.modal-info .modal-content {
  background-color: #0c4160;
  color: #ffffff;
}
.modal.modal-info .modal-body p {
  color: rgba(255, 255, 255, 0.8);
}
.modal.modal-info .form-control::-moz-placeholder {
  color: rgba(255, 255, 255, 0.4);
  opacity: 1;
  filter: alpha(opacity=100);
}
.modal.modal-info .form-control:-moz-placeholder {
  color: rgba(255, 255, 255, 0.4);
  opacity: 1;
  filter: alpha(opacity=100);
}
.modal.modal-info .form-control::-webkit-input-placeholder {
  color: rgba(255, 255, 255, 0.4);
  opacity: 1;
  filter: alpha(opacity=100);
}
.modal.modal-info .form-control:-ms-input-placeholder {
  color: rgba(255, 255, 255, 0.4);
  opacity: 1;
  filter: alpha(opacity=100);
}
.modal.modal-info .form-control {
  border-color: rgba(255, 255, 255, 0.5);
  color: #ffffff;
}
.modal.modal-info .form-control:focus {
  border-color: #ffffff;
  background-color: transparent;
  color: #ffffff;
}
.modal.modal-info .has-success:after,
.modal.modal-info .has-danger:after {
  color: #ffffff;
}
.modal.modal-info .has-danger .form-control {
  background-color: transparent;
}
.modal.modal-info .input-group-prepend {
  margin-right: 0;
}
.modal.modal-info .input-group-prepend .input-group-text,
.modal.modal-info .input-group-append .input-group-text {
  background-color: rgba(30, 30, 36, 0.2);
  border-color: rgba(255, 255, 255, 0.5);
  color: #ffffff;
}
.modal.modal-info .input-group-focus .input-group-prepend .input-group-text,
.modal.modal-info .input-group-focus .input-group-append .input-group-text {
  background-color: rgba(30, 30, 36, 0.3);
  border-color: #ffffff;
  color: #ffffff;
}
.modal.modal-info .form-group.no-border .form-control,
.modal.modal-info .input-group.no-border .form-control {
  background-color: rgba(30, 30, 36, 0.2);
  color: #ffffff;
}
.modal.modal-info .form-group.no-border .form-control:focus, .modal.modal-info .form-group.no-border .form-control:active, .modal.modal-info .form-group.no-border .form-control:active,
.modal.modal-info .input-group.no-border .form-control:focus,
.modal.modal-info .input-group.no-border .form-control:active,
.modal.modal-info .input-group.no-border .form-control:active {
  background-color: rgba(30, 30, 36, 0.3);
  color: #ffffff;
}
.modal.modal-info .form-group.no-border .form-control + .input-group-prepend .input-group-text,
.modal.modal-info .form-group.no-border .form-control + .input-group-append .input-group-text,
.modal.modal-info .input-group.no-border .form-control + .input-group-prepend .input-group-text,
.modal.modal-info .input-group.no-border .form-control + .input-group-append .input-group-text {
  background-color: rgba(30, 30, 36, 0.2);
}
.modal.modal-info .form-group.no-border .form-control + .input-group-prepend .input-group-text:focus, .modal.modal-info .form-group.no-border .form-control + .input-group-prepend .input-group-text:active, .modal.modal-info .form-group.no-border .form-control + .input-group-prepend .input-group-text:active,
.modal.modal-info .form-group.no-border .form-control + .input-group-append .input-group-text:focus,
.modal.modal-info .form-group.no-border .form-control + .input-group-append .input-group-text:active,
.modal.modal-info .form-group.no-border .form-control + .input-group-append .input-group-text:active,
.modal.modal-info .input-group.no-border .form-control + .input-group-prepend .input-group-text:focus,
.modal.modal-info .input-group.no-border .form-control + .input-group-prepend .input-group-text:active,
.modal.modal-info .input-group.no-border .form-control + .input-group-prepend .input-group-text:active,
.modal.modal-info .input-group.no-border .form-control + .input-group-append .input-group-text:focus,
.modal.modal-info .input-group.no-border .form-control + .input-group-append .input-group-text:active,
.modal.modal-info .input-group.no-border .form-control + .input-group-append .input-group-text:active {
  background-color: rgba(30, 30, 36, 0.3);
  color: #ffffff;
}
.modal.modal-info .form-group.no-border .form-control:focus + .input-group-prepend .input-group-text, .modal.modal-info .form-group.no-border .form-control:focus + .input-group-append .input-group-text,
.modal.modal-info .input-group.no-border .form-control:focus + .input-group-prepend .input-group-text,
.modal.modal-info .input-group.no-border .form-control:focus + .input-group-append .input-group-text {
  background-color: rgba(30, 30, 36, 0.3);
  color: #ffffff;
}
.modal.modal-info .form-group.no-border .input-group-prepend .input-group-text,
.modal.modal-info .form-group.no-border .input-group-append .input-group-text,
.modal.modal-info .input-group.no-border .input-group-prepend .input-group-text,
.modal.modal-info .input-group.no-border .input-group-append .input-group-text {
  background-color: rgba(30, 30, 36, 0.2);
  border: none;
  color: #ffffff;
}
.modal.modal-info .form-group.no-border.input-group-focus .input-group-prepend .input-group-text,
.modal.modal-info .form-group.no-border.input-group-focus .input-group-append .input-group-text,
.modal.modal-info .input-group.no-border.input-group-focus .input-group-prepend .input-group-text,
.modal.modal-info .input-group.no-border.input-group-focus .input-group-append .input-group-text {
  background-color: rgba(30, 30, 36, 0.3);
  color: #ffffff;
}
.modal .modal-header .close {
  color: #0c4160;
  text-shadow: none;
}
.modal .modal-header .close:hover, .modal .modal-header .close:focus {
  opacity: 1;
}
.modal.modal-black .modal-content {
  background: linear-gradient(to bottom, #000000 0%, #1d253b 100%);
  color: rgba(255, 255, 255, 0.8);
}
.modal.modal-black .modal-content .modal-header .modal-title, .modal.modal-black .modal-content .modal-header .title {
  color: rgba(255, 255, 255, 0.9);
}
.modal.modal-black .modal-content .modal-body p {
  color: rgba(255, 255, 255, 0.8);
}
.modal.modal-black h1, .modal.modal-black .h1, .modal.modal-black h2, .modal.modal-black .h2, .modal.modal-black h3, .modal.modal-black .h3, .modal.modal-black h4, .modal.modal-black .h4, .modal.modal-black h5, .modal.modal-black .h5, .modal.modal-black h6, .modal.modal-black .h6, .modal.modal-black p {
  color: #ffffff;
}

.modal-search .modal-dialog {
  margin: 20px auto;
  max-width: 650px;
}
.modal-search .modal-dialog input {
  border: none;
  font-size: 17px;
  font-weight: 100;
}
.modal-search .modal-dialog span {
  font-size: 35px;
  color: #b7b7b7;
}
.modal-search .modal-content .modal-header {
  padding: 24px;
}
.modal-search .modal-header .close {
  color: #555555;
  top: 30px !important;
}
.modal-search .modal-footer {
  border-top: 2px solid #f9f9f9;
  margin: 0px 25px 20px;
}

.navbar {
  padding: 10px 30px 10px 15px;
  width: 100%;
  z-index: 1050;
  background: #1a1e34;
}
.navbar .photo {
  display: inline-block;
  height: 30px;
  width: 30px;
  border-radius: 50%;
  vertical-align: middle;
  overflow: hidden;
}
.navbar .photo img {
  width: 100%;
}
.navbar .navbar-wrapper {
  display: flex;
  align-items: center;
}
.navbar .navbar-text {
  color: #ffffff;
}
.navbar .btn {
  margin: 0 5px 0 10px;
}
.navbar.navbar-absolute {
  position: absolute;
  z-index: 1050;
}
.navbar.navbar-transparent {
  background: transparent !important;
}
.navbar.bg-white .navbar-nav .search-bar.input-group i {
  color: #000000;
}
.navbar.bg-white .navbar-nav .search-bar.input-group .form-control {
  background: rgba(0, 0, 0, 0.1);
  border-radius: 4px;
}
.navbar.bg-white .navbar-nav a.nav-link {
  color: #000000 !important;
}
.navbar.bg-white .navbar-nav a.nav-link p {
  color: #000000;
}
.navbar.bg-white .navbar-text, .navbar.bg-white .navbar-brand {
  color: #000000;
}
.navbar.bg-white .form-control {
  color: #000000 !important;
}
.navbar.bg-white .form-control::placeholder {
  color: #AAAAAA !important;
}
.navbar.bg-dark {
  background: #000000 !important;
}
.navbar.bg-primary {
  background-color: #68869a !important;
}
.navbar.bg-warning {
  background-color: #0c4160 !important;
}
.navbar.bg-info {
  background-color: #0c4160 !important;
}
.navbar.bg-success {
  background-color: #536c7c !important;
}
.navbar.bg-danger {
  background-color: #0c4160 !important;
}
.navbar .navbar-brand {
  position: fixed;
  padding-top: 0.3125rem;
  padding-bottom: 0.3125rem;
  color: #ffffff;
  margin-left: 17px;
  margin-top: 3px;
  text-transform: uppercase;
  font-size: 1rem;
}
.navbar .navbar-toggle button:focus, .navbar .navbar-toggler {
  outline: none;
}

.container-fluid {
  width: 100%;
}

.navbar-minimize-fixed {
  position: fixed;
  margin-left: 40px;
  margin-top: 14px;
  transition: 0.3s ease;
  color: white;
  z-index: 20;
  opacity: 0;
  transition: 0.2s ease;
}
.navbar-minimize-fixed button i {
  font-size: 20px;
}

.notification {
  background: #0c4160;
  color: #ffffff;
  border-radius: 0.875rem;
  height: 6px;
  width: 6px;
  position: absolute;
  text-align: center;
  font-size: 12px;
  font-weight: 800;
  top: 10px;
  right: 10px;
  border: 1px solid #0c4160;
}

.navbar-nav li {
  padding: 0 10px;
}
.navbar-nav li a {
  color: #ffffff;
}
.navbar-nav li i {
  vertical-align: middle;
  font-size: 20px;
}

@media screen and (max-width: 991px) {
  .navbar .container-fluid {
    padding-right: 15px;
    padding-left: 15px;
  }
  .navbar .navbar-collapse .input-group {
    margin: 0;
    margin-top: 5px;
  }
  .navbar .navbar-nav .btn {
    margin-left: -3px;
    display: flex;
  }
  .navbar .navbar-nav .btn i {
    margin-right: 12px;
  }
  .navbar .navbar-nav .btn span {
    margin: 0;
    text-transform: uppercase;
    font-weight: 300;
  }
  .navbar .navbar-nav .btn span, .navbar .navbar-nav .btn span:hover, .navbar .navbar-nav .btn span:focus, .navbar .navbar-nav .btn span:active, .navbar .navbar-nav .btn span:active:focus {
    color: #000000 !important;
  }
  .navbar .navbar-nav a.nav-link i {
    opacity: 1;
    margin-left: 4px;
    margin-right: 5px;
  }
  .navbar .navbar-nav a.nav-link p {
    display: inline-block;
    text-transform: uppercase;
    margin-left: 7px;
  }
  .navbar .navbar-nav .modal-search .modal-dialog {
    padding: 0 40px;
  }
  .navbar .navbar-nav .dropdown {
    margin: 5px 0;
  }
  .navbar .navbar-nav .dropdown .nav-link {
    padding-bottom: 0;
  }
  .navbar .navbar-nav .dropdown .dropdown-menu .dropdown-item {
    margin-top: 0;
    padding-left: 24px;
  }
  .navbar .dropdown.show .dropdown-menu {
    display: block;
  }
  .navbar .dropdown .dropdown-menu {
    display: none;
  }
  .navbar .dropdown .dropdown-menu li a {
    color: #000000;
  }
  .navbar .dropdown.show .dropdown-menu,
  .navbar .dropdown .dropdown-menu {
    background-color: transparent;
    border: 0;
    transition: none;
    box-shadow: none;
    width: auto;
    margin: 0px 1rem;
    margin-top: 0px;
  }
  .navbar .dropdown.show .dropdown-menu:before,
  .navbar .dropdown .dropdown-menu:before {
    display: none;
  }
  .navbar .dropdown-menu .dropdown-item:focus,
  .navbar .dropdown-menu .dropdown-item:hover {
    color: #ffffff;
  }
  .navbar.bg-white .dropdown-menu .dropdown-item:focus, .navbar.bg-white .dropdown-menu .dropdown-item:hover {
    color: #011e31;
  }
  .navbar button.navbar-toggler[data-target="#navigation"] {
    padding-top: 0;
  }
  .navbar .navbar-toggler-bar {
    display: block;
    position: relative;
    width: 22px;
    height: 1px;
    border-radius: 1px;
    background: #ffffff;
  }
  .navbar .navbar-toggler-bar.navbar-kebab {
    height: 4px;
    width: 4px;
    margin-bottom: 3px;
    border-radius: 50%;
  }
  .navbar .navbar-toggler-bar + .navbar-toggler-bar {
    margin-top: 7px;
  }
  .navbar .navbar-toggler-bar + .navbar-toggler-bar.navbar-kebab {
    margin-top: 0px;
  }
  .navbar .navbar-toggler-bar.bar2 {
    width: 17px;
    transition: width 0.2s linear;
  }
  .navbar.bg-white:not(.navbar-transparent) .navbar-toggler-bar {
    background-color: #011e31;
  }
  .navbar .toggled .navbar-toggler-bar {
    width: 24px;
  }
  .navbar .toggled .navbar-toggler-bar + .navbar-toggler-bar {
    margin-top: 5px;
  }
  .navbar .navbar-brand {
    margin-left: 20px;
    position: relative;
  }
  .navbar-nav .nav-link i.fa,
  .navbar-nav .nav-link i.tim-icons {
    opacity: 0.5;
  }
  .bar1,
  .bar2,
  .bar3 {
    outline: 1px solid transparent;
  }
  .bar1 {
    top: 0px;
    animation: topbar-back 500ms 0s;
    animation-fill-mode: forwards;
  }
  .bar2 {
    opacity: 1;
  }
  .bar3 {
    bottom: 0px;
    animation: bottombar-back 500ms 0s;
    animation-fill-mode: forwards;
  }
  .toggled .bar1 {
    top: 6px;
    animation: topbar-x 500ms 0s;
    animation-fill-mode: forwards;
  }
  .toggled .bar2 {
    opacity: 0;
  }
  .toggled .bar3 {
    bottom: 6px;
    animation: bottombar-x 500ms 0s;
    animation-fill-mode: forwards;
  }
  @keyframes topbar-x {
    0% {
      top: 0px;
      transform: rotate(0deg);
    }
    45% {
      top: 6px;
      transform: rotate(145deg);
    }
    75% {
      transform: rotate(130deg);
    }
    100% {
      transform: rotate(135deg);
    }
  }
  @keyframes topbar-back {
    0% {
      top: 6px;
      transform: rotate(135deg);
    }
    45% {
      transform: rotate(-10deg);
    }
    75% {
      transform: rotate(5deg);
    }
    100% {
      top: 0px;
      transform: rotate(0);
    }
  }
  @keyframes bottombar-x {
    0% {
      bottom: 0px;
      transform: rotate(0deg);
    }
    45% {
      bottom: 6px;
      transform: rotate(-145deg);
    }
    75% {
      transform: rotate(-130deg);
    }
    100% {
      transform: rotate(-135deg);
    }
  }
  @keyframes bottombar-back {
    0% {
      bottom: 6px;
      transform: rotate(-135deg);
    }
    45% {
      transform: rotate(10deg);
    }
    75% {
      transform: rotate(-5deg);
    }
    100% {
      bottom: 0px;
      transform: rotate(0);
    }
  }
  @keyframes fadeIn {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }
}
@media screen and (min-width: 992px) {
  .navbar-collapse {
    background: none !important;
  }
  .navbar .navbar-toggle {
    display: none;
  }
  .navbar-nav .nav-link.profile-photo {
    padding: 0;
    margin: 7px 0.7rem;
  }
  .navbar .caret {
    position: absolute;
    left: 80%;
    top: 55%;
    margin-left: 0;
  }
  .navbar-expand-lg .navbar-nav .nav-link {
    padding-right: 0.5rem;
    padding-left: 0.5rem;
  }
}
@media screen and (max-width: 576px) {
  .navbar[class*=navbar-toggleable-] .container {
    margin-left: 0;
    margin-right: 0;
  }
  .navbar .navbar-wrapper .navbar-toggle {
    transition: all 1s;
  }
  .navbar .navbar-wrapper .navbar-toggle.toggled {
    left: -20px;
    position: relative;
    right: auto;
    right: initial;
    transition: all 1s;
  }
  .rtl .navbar .navbar-wrapper .navbar-toggle.toggled {
    right: -35px;
    position: relative;
    left: auto;
    left: initial;
    transition: all 1s;
  }
}
body {
  -moz-osx-font-smoothing: grayscale;
  -webkit-font-smoothing: antialiased;
}

h1,
.h1, h2, .h2, h3, .h3, h4, .h4, h5, .h5, h6, .h6 {
  line-height: 1.2;
}

p {
  font-weight: 300;
}

button,
input,
optgroup,
select,
textarea {
  font-family: "Poppins", sans-serif;
}

.card h1, .card .h1, .card h2, .card .h2, .card h3, .card .h3, .card h4, .card .h4, .card h5, .card .h5, .card h6, .card .h6, .card p {
  color: rgba(255, 255, 255, 0.8);
}

h1, .h1, h2, .h2, h3, .h3, h4, .h4, h5, .h5, h6, .h6 {
  font-weight: 400;
  color: rgba(255, 255, 255, 0.8);
}

a {
  color: #ba54f5;
  font-weight: 300;
}
a:hover, a:focus {
  color: #68869a;
}

h1, .h1 {
  line-height: 1.05;
  margin-bottom: 30px;
}
h1 small, h1 .small, .h1 .small, .h1 small {
  font-weight: 600;
  text-transform: uppercase;
  opacity: 0.8;
}

h2, .h2 {
  margin-bottom: 30px;
  line-height: 1.2;
}

h3, .h3 {
  margin-bottom: 30px;
  line-height: 1.4em;
}

h4, .h4 {
  line-height: 1.45em;
  margin-bottom: 15px;
}
h4 + .category, h4.title + .category, .h4 + .category, .h4.title + .category {
  margin-top: -10px;
}

h5, .h5 {
  line-height: 1.4em;
  margin-bottom: 15px;
}

h6, .h6 {
  text-transform: uppercase;
  font-weight: 600;
}

p {
  color: rgba(255, 255, 255, 0.8);
  margin-bottom: 5px;
}
p.description {
  font-size: 1.14em;
}

.title {
  font-weight: 600;
  cursor: default;
}
.title.title-up {
  text-transform: uppercase;
}
.title.title-up a {
  color: #000000;
  text-decoration: none;
}
.title + .category {
  margin-top: -10px;
}

.description,
.card-description,
.footer-big p,
.card .footer .stats {
  color: #AAAAAA;
  font-weight: 300;
}

.category,
.card-category {
  text-transform: capitalize;
  font-weight: 400;
  color: rgba(255, 255, 255, 0.6);
  font-size: 0.7500000025rem;
}

.card-category {
  font-size: 0.7500000025rem;
}

.blockquote {
  border-left: none;
  border: 1px solid #011e31;
  padding: 20px;
  font-size: 0.9625rem;
  line-height: 1.8;
}
.blockquote small, .blockquote .small {
  color: #011e31;
  font-size: 0.7500000025rem;
  text-transform: uppercase;
}
.blockquote.blockquote-primary {
  border-color: #68869a;
  color: #68869a;
}
.blockquote.blockquote-primary small, .blockquote.blockquote-primary .small {
  color: #68869a;
}
.blockquote.blockquote-danger {
  border-color: #0c4160;
  color: #0c4160;
}
.blockquote.blockquote-danger small, .blockquote.blockquote-danger .small {
  color: #0c4160;
}
.blockquote.blockquote-white {
  border-color: rgba(255, 255, 255, 0.8);
  color: #ffffff;
}
.blockquote.blockquote-white small, .blockquote.blockquote-white .small {
  color: rgba(255, 255, 255, 0.8);
}

ul li, ol li {
  color: #ffffff;
}

pre {
  color: rgba(255, 255, 255, 0.8);
}

hr {
  border-top: 1px solid rgba(0, 0, 0, 0.1);
  margin-top: 1rem;
  margin-bottom: 1rem;
}

.table > tbody > tr > td {
  color: rgba(255, 255, 255, 0.7) !important;
}
.table > tbody > tr > td .photo {
  height: 30px;
  width: 30px;
  border-radius: 50%;
  overflow: hidden;
  margin: 0 auto;
}
.table > tbody > tr > td .photo img {
  width: 100%;
}
.table > tbody > tr.table-success > td {
  background-color: #536c7c;
}
.table > tbody > tr.table-info > td {
  background-color: #0c4160;
}
.table > tbody > tr.table-primary > td {
  background-color: #68869a;
}
.table > tbody > tr.table-warning > td {
  background-color: #0c4160;
}
.table > tbody > tr.table-danger > td {
  background-color: #0c4160;
}
.table .img-wrapper {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  overflow: hidden;
  margin: 0 auto;
}
.table .img-row {
  max-width: 60px;
  width: 60px;
}
.table .form-check {
  margin: 0;
  margin-top: 5px;
}
.table .form-check label .form-check-sign::before, .table .form-check label .form-check-sign::after {
  top: -17px;
  left: 4px;
}
.table .btn {
  margin: 0;
}
.table small, .table .small {
  font-weight: 300;
}
.card-tasks .card-body .table {
  margin-bottom: 0;
}
.card-tasks .card-body .table > thead > tr > th,
.card-tasks .card-body .table > tbody > tr > th,
.card-tasks .card-body .table > tfoot > tr > th,
.card-tasks .card-body .table > thead > tr > td,
.card-tasks .card-body .table > tbody > tr > td,
.card-tasks .card-body .table > tfoot > tr > td {
  padding-top: 5px;
  padding-bottom: 5px;
}
.table > thead > tr > th {
  border-bottom-width: 1px;
  font-size: 12px;
  text-transform: uppercase;
  font-weight: 700;
  border: 0;
  color: rgba(255, 255, 255, 0.7);
}
.table .radio,
.table .checkbox {
  margin-top: 0;
  margin-bottom: 0;
  padding: 0;
  width: 15px;
}
.table .radio .icons,
.table .checkbox .icons {
  position: relative;
}
.table .radio label:after, .table .radio label:before,
.table .checkbox label:after,
.table .checkbox label:before {
  top: -17px;
  left: -3px;
}
.table > thead > tr > th,
.table > tbody > tr > th,
.table > tfoot > tr > th,
.table > thead > tr > td,
.table > tbody > tr > td,
.table > tfoot > tr > td {
  border-color: rgba(255, 255, 255, 0.1);
  padding: 12px 7px;
  vertical-align: middle;
}
.table.table-shopping tbody tr:last-child td {
  border: none;
}
.table .th-description {
  max-width: 150px;
}
.table .td-price {
  font-size: 26px;
  font-weight: 300;
  margin-top: 5px;
  position: relative;
  top: 4px;
  text-align: right;
}
.table .td-total {
  font-weight: 600;
  font-size: 0.812499975rem;
  padding-top: 20px;
  text-align: right;
}
.table .td-actions .btn {
  margin: 0px;
}
.table > tbody > tr {
  position: relative;
}
.table > tfoot > tr {
  color: hsla(0, 0%, 100%, 0.7);
  text-transform: uppercase;
}

.table-responsive {
  overflow: auto;
  padding-bottom: 10px;
}

#tables .table-responsive {
  margin-bottom: 30px;
}

.form-check {
  margin-top: 0.5rem;
  padding-left: 0;
}

.form-check .form-check-label {
  display: inline-block;
  position: relative;
  cursor: pointer;
  padding-left: 25px;
  line-height: 18px;
  margin-bottom: 0;
  transition: color 0.3s linear;
}

.radio .form-check-sign {
  padding-left: 28px;
}

.form-check-radio.form-check-inline .form-check-label {
  padding-left: 5px;
  margin-right: 10px;
}

.form-check .form-check-sign::before,
.form-check .form-check-sign::after {
  content: " ";
  display: inline-block;
  position: absolute;
  width: 17px;
  height: 17px;
  left: 0;
  cursor: pointer;
  border-radius: 3px;
  top: 0;
  border: 1px solid #919191;
  transition: opacity 0.3s linear;
}

.form-check input[type=checkbox]:checked + .form-check-sign::before,
.form-check input[type=checkbox]:checked + .form-check-sign::before {
  border: none;
  background-color: #68869a;
}

.form-check .form-check-sign::after {
  font-family: "nucleo";
  content: "\\ea1b";
  top: 0px;
  text-align: center;
  font-size: 14px;
  opacity: 0;
  color: #ffffff;
  font-weight: 600;
  border: 0;
  background-color: inherit;
}

.form-check.disabled .form-check-label,
.form-check.disabled .form-check-label {
  color: #AAAAAA;
  opacity: 0.5;
  cursor: not-allowed;
}

.form-check input[type=checkbox],
.radio input[type=radio] {
  opacity: 0;
  position: absolute;
  visibility: hidden;
}

.form-check input[type=checkbox]:checked + .form-check-sign::after {
  opacity: 1;
  font-size: 10px;
  margin-top: 0;
}

.form-check input[type=checkbox] + .form-check-sign::after {
  opacity: 0;
  font-size: 10px;
  margin-top: 0;
}

.form-control input[type=checkbox]:disabled + .form-check-sign::before,
.checkbox input[type=checkbox]:disabled + .form-check-sign::after {
  cursor: not-allowed;
}

.form-check input[type=checkbox]:disabled + .form-check-sign,
.form-check input[type=radio]:disabled + .form-check-sign {
  pointer-events: none;
}

.form-check-radio .form-check-label {
  padding-top: 3px;
}

.form-check-radio .form-check-sign::before,
.form-check-radio .form-check-sign::after {
  content: " ";
  width: 18px;
  height: 18px;
  border-radius: 50%;
  border: 1px solid #919191;
  display: inline-block;
  position: absolute;
  left: 0px;
  top: 3px;
  padding: 1px;
  transition: opacity 0.3s linear;
}

.form-check-radio input[type=radio] + .form-check-sign:after,
.form-check-radio input[type=radio] {
  opacity: 0;
}

.form-check-radio input[type=radio]:checked + .form-check-sign::after {
  width: 6px;
  height: 6px;
  background-color: #68869a;
  border-color: #68869a;
  top: 9px;
  left: 6px;
  opacity: 1;
}

.form-check-radio input[type=radio]:checked + .form-check-sign::before {
  border-color: #68869a;
}

.form-check-radio input[type=radio]:checked + .form-check-sign::after {
  opacity: 1;
}

.form-check-radio input[type=radio]:disabled + .form-check-sign {
  color: #AAAAAA;
}

.form-check-radio input[type=radio]:disabled + .form-check-sign::before,
.form-check-radio input[type=radio]:disabled + .form-check-sign::after {
  color: #AAAAAA;
}

.fixed-plugin {
  position: fixed;
  right: 0;
  width: 64px;
  background: rgba(0, 0, 0, 0.3);
  z-index: 1031;
  border-radius: 8px 0 0 8px;
  text-align: center;
  top: 130px;
}
.fixed-plugin li > a,
.fixed-plugin .badge {
  transition: all 0.34s;
  -webkit-transition: all 0.34s;
  -moz-transition: all 0.34s;
}
.fixed-plugin .fa-cog {
  color: #ffffff;
  padding: 10px;
  border-radius: 0 0 6px 6px;
  width: auto;
}
.fixed-plugin .dropdown-menu {
  right: 80px;
  left: auto !important;
  top: -52px !important;
  width: 290px;
  border-radius: 0.1875rem;
  padding: 0 10px;
  background: linear-gradient(#000000, #1d253b);
}
.fixed-plugin .dropdown .dropdown-menu .tim-icons {
  top: 5px;
}
.fixed-plugin .dropdown-menu:after,
.fixed-plugin .dropdown-menu:before {
  right: 10px;
  margin-left: auto;
  left: auto;
}
.fixed-plugin .fa-circle-thin {
  color: #ffffff;
}
.fixed-plugin .active .fa-circle-thin {
  color: #00bbff;
}
.fixed-plugin .dropdown-menu > .active > a,
.fixed-plugin .dropdown-menu > .active > a:hover,
.fixed-plugin .dropdown-menu > .active > a:focus {
  color: #777777;
  text-align: center;
}
.fixed-plugin img {
  border-radius: 0;
  width: 100%;
  height: 100px;
  margin: 0 auto;
}
.fixed-plugin .dropdown-menu li > a:hover,
.fixed-plugin .dropdown-menu li > a:focus {
  box-shadow: none;
}
.fixed-plugin .badge {
  border: 2px solid #ffffff;
  border-radius: 50%;
  cursor: pointer;
  display: inline-block;
  height: 23px;
  margin-right: 5px;
  position: relative;
  width: 23px;
}
.fixed-plugin .badge.active,
.fixed-plugin .badge:hover {
  border-color: #1d253b;
}
.fixed-plugin .light-badge, .fixed-plugin .dark-badge {
  margin: 0;
  border: 1px solid #0c4160;
}
.fixed-plugin .light-badge:hover, .fixed-plugin .dark-badge:hover {
  border: 1px solid #0c4160;
}
.fixed-plugin .light-badge {
  background: #ffffff;
}
.fixed-plugin .light-badge:hover {
  background: #ffffff;
}
.fixed-plugin .dark-badge {
  background: #000000;
}
.fixed-plugin .dark-badge:hover {
  background: #000000;
}
.fixed-plugin h5, .fixed-plugin .h5 {
  margin: 10px;
}
.fixed-plugin .dropdown-menu li {
  display: block;
  padding: 18px 2px;
  width: 25%;
  float: left;
}
.fixed-plugin li.adjustments-line,
.fixed-plugin li.header-title,
.fixed-plugin li.button-container {
  width: 100%;
  height: 50px;
  min-height: inherit;
}
.fixed-plugin li.button-container {
  height: auto;
}
.fixed-plugin li.button-container div {
  margin-bottom: 5px;
}
.fixed-plugin #sharrreTitle {
  text-align: center;
  padding: 10px 0;
  height: 50px;
}
.fixed-plugin li.header-title {
  color: #ffffff;
  height: 30px;
  line-height: 25px;
  font-size: 12px;
  font-weight: 600;
  text-align: center;
  text-transform: uppercase;
}
.fixed-plugin .adjustments-line a {
  color: transparent;
}
.fixed-plugin .adjustments-line a .badge-colors {
  position: relative;
  top: -2px;
}
.fixed-plugin .adjustments-line a a:hover,
.fixed-plugin .adjustments-line a a:focus {
  color: transparent;
}
.fixed-plugin .adjustments-line .togglebutton {
  text-align: center;
}
.fixed-plugin .adjustments-line .togglebutton .label-switch {
  position: relative;
  left: -10px;
  font-size: 0.62475rem;
  color: #ffffff;
}
.fixed-plugin .adjustments-line .togglebutton .label-switch.label-right {
  left: 10px;
}
.fixed-plugin .adjustments-line .togglebutton .toggle {
  margin-right: 0;
}
.fixed-plugin .adjustments-line .color-label {
  position: relative;
  top: -7px;
  font-size: 0.62475rem;
  color: #ffffff;
}
.fixed-plugin .adjustments-line .dropdown-menu > li.adjustments-line > a {
  padding-right: 0;
  padding-left: 0;
  border-bottom: 1px solid #ddd;
  border-radius: 0;
  margin: 0;
}
.fixed-plugin .dropdown-menu > li > a.img-holder {
  font-size: 1rem;
  text-align: center;
  border-radius: 10px;
  background-color: #ffffff;
  border: 3px solid #ffffff;
  padding-left: 0;
  padding-right: 0;
  opacity: 1;
  cursor: pointer;
  display: block;
  max-height: 100px;
  overflow: hidden;
  padding: 0;
}
.fixed-plugin .dropdown-menu > li > a.img-holder img {
  margin-top: auto;
}
.fixed-plugin .dropdown-menu > li a.switch-trigger:hover, .fixed-plugin .dropdown-menu > li > a.switch-trigger:focus {
  background-color: transparent;
}
.fixed-plugin .dropdown-menu > li:hover > a.img-holder, .fixed-plugin .dropdown-menu > li:focus > a.img-holder {
  border-color: rgba(0, 187, 255, 0.53);
}
.fixed-plugin .dropdown-menu > .active > a.img-holder,
.fixed-plugin .dropdown-menu > .active > a.img-holder {
  border-color: #00bbff;
  background-color: #ffffff;
}
.fixed-plugin .btn-social {
  width: 50%;
  display: block;
  width: 48%;
  float: left;
  font-weight: 600;
}
.fixed-plugin .btn-social i {
  margin-right: 5px;
}
.fixed-plugin .btn-social:first-child {
  margin-right: 2%;
}
.fixed-plugin .dropdown .dropdown-menu {
  transform: translateY(-15%);
  top: 27px;
  opacity: 0;
  transform-origin: 0 0;
}
.fixed-plugin .dropdown .dropdown-menu:before {
  border-bottom: 0.4em solid rgba(0, 0, 0, 0);
  border-left: 0.4em solid rgba(0, 0, 0, 0.2);
  border-top: 0.4em solid rgba(0, 0, 0, 0);
  right: -16px;
  top: 46px;
}
.fixed-plugin .dropdown .dropdown-menu:after {
  border-bottom: 0.4em solid rgba(0, 0, 0, 0);
  border-left: 0.4em solid #000000;
  border-top: 0.4em solid rgba(0, 0, 0, 0);
  right: -16px;
}
.fixed-plugin .dropdown .dropdown-menu:before, .fixed-plugin .dropdown .dropdown-menu:after {
  content: "";
  display: inline-block;
  position: absolute;
  top: 74px;
  width: 16px;
  transform: translateY(-50%);
  -webkit-transform: translateY(-50%);
  -moz-transform: translateY(-50%);
}
.fixed-plugin .dropdown.show .dropdown-menu {
  opacity: 1;
  transform: translateY(-13%);
  transform-origin: 0 0;
}
.fixed-plugin .bootstrap-switch {
  margin: 0;
}

.wrapper {
  position: relative;
  top: 0;
  height: 100vh;
}
.wrapper.wrapper-full-page {
  min-height: 100vh;
  height: auto;
}

.sidebar-wrapper ul li div.collapse ul li div.collapse ul li a,
.sidebar-wrapper ul li div.collapse ul li div.collapsing ul li a,
.sidebar-wrapper ul li div.collapsing ul li div.collapse ul li a {
  margin-left: 25px;
}

.sidebar,
.off-canvas-sidebar {
  background: #ba54f5;
  background: linear-gradient(0deg, #ba54f5 0%, #68869a 100%);
  height: calc(100vh - 90px);
  width: 230px;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1;
  background-size: cover;
  background-position: center center;
  display: block;
  box-shadow: 0px 0px 45px 0px rgba(0, 0, 0, 0.6);
  margin-top: 80px;
  margin-left: 20px;
  border-radius: 5px;
  transition: 0.5s cubic-bezier(0.685, 0.0473, 0.346, 1);
}
.sidebar .sidebar-wrapper,
.off-canvas-sidebar .sidebar-wrapper {
  width: 100%;
  min-height: 100%;
  max-height: calc(100vh - 705px);
  z-index: 4;
  position: relative;
  overflow: auto;
}
.sidebar .sidebar-wrapper .dropdown .dropdown-backdrop,
.off-canvas-sidebar .sidebar-wrapper .dropdown .dropdown-backdrop {
  display: none !important;
}
.sidebar .sidebar-wrapper .navbar-form,
.off-canvas-sidebar .sidebar-wrapper .navbar-form {
  border: none;
}
.sidebar .sidebar-wrapper > .nav [data-toggle=collapse] ~ div > ul > li > a span,
.sidebar .sidebar-wrapper .user .info [data-toggle=collapse] ~ div > ul > li > a span,
.off-canvas-sidebar .sidebar-wrapper > .nav [data-toggle=collapse] ~ div > ul > li > a span,
.off-canvas-sidebar .sidebar-wrapper .user .info [data-toggle=collapse] ~ div > ul > li > a span {
  display: inline-block;
}
.sidebar .sidebar-wrapper > .nav [data-toggle=collapse] ~ div > ul > li > a .sidebar-normal,
.sidebar .sidebar-wrapper .user .info [data-toggle=collapse] ~ div > ul > li > a .sidebar-normal,
.off-canvas-sidebar .sidebar-wrapper > .nav [data-toggle=collapse] ~ div > ul > li > a .sidebar-normal,
.off-canvas-sidebar .sidebar-wrapper .user .info [data-toggle=collapse] ~ div > ul > li > a .sidebar-normal {
  margin: 0;
  position: relative;
  transform: translateX(0px);
  opacity: 1;
  white-space: nowrap;
  display: block;
  line-height: 23px;
  z-index: 1;
  color: rgba(255, 255, 255, 0.8);
}
.sidebar .sidebar-wrapper > .nav [data-toggle=collapse] ~ div > ul > li > a .sidebar-mini-icon,
.sidebar .sidebar-wrapper .user .info [data-toggle=collapse] ~ div > ul > li > a .sidebar-mini-icon,
.off-canvas-sidebar .sidebar-wrapper > .nav [data-toggle=collapse] ~ div > ul > li > a .sidebar-mini-icon,
.off-canvas-sidebar .sidebar-wrapper .user .info [data-toggle=collapse] ~ div > ul > li > a .sidebar-mini-icon {
  text-transform: uppercase;
  width: 34px;
  margin-right: 10px;
  margin-left: 0px;
  font-size: 12px;
  text-align: center;
  line-height: 25px;
  position: relative;
  float: left;
  z-index: 1;
  display: inherit;
  line-height: 24px;
  color: rgba(255, 255, 255, 0.8);
}
.sidebar .sidebar-wrapper > .nav [data-toggle=collapse] ~ div > ul > li > a i,
.sidebar .sidebar-wrapper .user .info [data-toggle=collapse] ~ div > ul > li > a i,
.off-canvas-sidebar .sidebar-wrapper > .nav [data-toggle=collapse] ~ div > ul > li > a i,
.off-canvas-sidebar .sidebar-wrapper .user .info [data-toggle=collapse] ~ div > ul > li > a i {
  font-size: 17px;
  line-height: 20px;
  width: 26px;
}
.sidebar .sidebar-wrapper [data-toggle=collapse] ~ div > ul > li:hover > a .sidebar-mini-icon, .sidebar .sidebar-wrapper [data-toggle=collapse] ~ div > ul > li:hover > a .sidebar-normal,
.off-canvas-sidebar .sidebar-wrapper [data-toggle=collapse] ~ div > ul > li:hover > a .sidebar-mini-icon,
.off-canvas-sidebar .sidebar-wrapper [data-toggle=collapse] ~ div > ul > li:hover > a .sidebar-normal {
  color: #ffffff;
}
.sidebar .sidebar-wrapper .nav [data-toggle=collapse] ~ div > ul > li > a .sidebar-mini-icon,
.off-canvas-sidebar .sidebar-wrapper .nav [data-toggle=collapse] ~ div > ul > li > a .sidebar-mini-icon {
  opacity: 0;
}
.sidebar .navbar-minimize,
.off-canvas-sidebar .navbar-minimize {
  position: absolute;
  right: 20px;
  top: 2px;
  opacity: 1;
}
.sidebar .logo-tim,
.off-canvas-sidebar .logo-tim {
  border-radius: 50%;
  border: 1px solid #333;
  display: block;
  height: 61px;
  width: 61px;
  float: left;
  overflow: hidden;
}
.sidebar .logo-tim img,
.off-canvas-sidebar .logo-tim img {
  width: 60px;
  height: 60px;
}
.sidebar .nav,
.off-canvas-sidebar .nav {
  margin-top: 20px;
  display: block;
}
.sidebar .nav .caret,
.off-canvas-sidebar .nav .caret {
  top: 14px;
  position: absolute;
  right: 10px;
}
.sidebar .nav li > a + div .nav,
.off-canvas-sidebar .nav li > a + div .nav {
  margin-top: 5px;
}
.sidebar .nav li > a + div .nav li > a,
.off-canvas-sidebar .nav li > a + div .nav li > a {
  margin-top: 0px;
  padding: 8px 8px;
}
.sidebar .nav li > a,
.off-canvas-sidebar .nav li > a {
  margin: 10px 15px 0;
  border-radius: 30px;
  color: #ffffff;
  display: block;
  text-decoration: none;
  position: relative;
  text-transform: uppercase;
  cursor: pointer;
  font-size: 0.62475rem;
  padding: 10px 8px;
  line-height: 1.625rem;
}
.sidebar .nav li:first-child > a,
.off-canvas-sidebar .nav li:first-child > a {
  margin: 0 15px;
}
.sidebar .nav li:hover:not(.active) > a p, .sidebar .nav li:hover:not(.active) > a i, .sidebar .nav li:focus:not(.active) > a p, .sidebar .nav li:focus:not(.active) > a i,
.off-canvas-sidebar .nav li:hover:not(.active) > a p,
.off-canvas-sidebar .nav li:hover:not(.active) > a i,
.off-canvas-sidebar .nav li:focus:not(.active) > a p,
.off-canvas-sidebar .nav li:focus:not(.active) > a i {
  color: #ffffff;
}
.sidebar .nav li:hover:not(.active) > a i, .sidebar .nav li:focus:not(.active) > a i,
.off-canvas-sidebar .nav li:hover:not(.active) > a i,
.off-canvas-sidebar .nav li:focus:not(.active) > a i {
  color: #ffffff;
}
.sidebar .nav li.active > a:not([data-toggle=collapse]),
.off-canvas-sidebar .nav li.active > a:not([data-toggle=collapse]) {
  background: transparent;
}
.sidebar .nav li.active > a:not([data-toggle=collapse]) i, .sidebar .nav li.active > a:not([data-toggle=collapse]) p,
.off-canvas-sidebar .nav li.active > a:not([data-toggle=collapse]) i,
.off-canvas-sidebar .nav li.active > a:not([data-toggle=collapse]) p {
  color: white;
}
.sidebar .nav li.active > a:not([data-toggle=collapse]):before,
.off-canvas-sidebar .nav li.active > a:not([data-toggle=collapse]):before {
  content: " ";
  position: absolute;
  height: 6px;
  width: 6px;
  top: 22px;
  left: -4px;
  background: #ffffff;
  border-radius: 50%;
}
.sidebar .nav li.active > a[data-toggle=collapse],
.off-canvas-sidebar .nav li.active > a[data-toggle=collapse] {
  background: transparent;
  box-shadow: none;
  color: #ffffff;
}
.sidebar .nav li.active > a[data-toggle=collapse] i,
.off-canvas-sidebar .nav li.active > a[data-toggle=collapse] i {
  color: #ffffff;
}
.sidebar .nav li.active > a[data-toggle=collapse] + div .nav .active a,
.off-canvas-sidebar .nav li.active > a[data-toggle=collapse] + div .nav .active a {
  box-shadow: none;
}
.sidebar .nav li.active > a[data-toggle=collapse] + div .nav .active a .sidebar-mini-icon, .sidebar .nav li.active > a[data-toggle=collapse] + div .nav .active a .sidebar-normal,
.off-canvas-sidebar .nav li.active > a[data-toggle=collapse] + div .nav .active a .sidebar-mini-icon,
.off-canvas-sidebar .nav li.active > a[data-toggle=collapse] + div .nav .active a .sidebar-normal {
  color: #ffffff;
  font-weight: 400;
}
.sidebar .nav li.active > a[data-toggle=collapse] + div .nav .active a:before,
.off-canvas-sidebar .nav li.active > a[data-toggle=collapse] + div .nav .active a:before {
  content: " ";
  position: absolute;
  height: 6px;
  width: 6px;
  top: 17px;
  left: -4px;
  background: #ffffff;
  border-radius: 50%;
}
.sidebar .nav li.active > a[data-toggle=collapse]:before,
.off-canvas-sidebar .nav li.active > a[data-toggle=collapse]:before {
  content: " ";
  position: absolute;
  height: 6px;
  width: 6px;
  top: 22px;
  left: -4px;
  background: rgba(255, 255, 255, 0.6);
  border-radius: 50%;
}
.sidebar .nav p,
.off-canvas-sidebar .nav p {
  margin: 0;
  line-height: 30px;
  position: relative;
  display: block;
  height: auto;
  white-space: nowrap;
}
.sidebar .nav i,
.off-canvas-sidebar .nav i {
  font-size: 20px;
  float: left;
  margin-right: 12px;
  line-height: 30px;
  width: 34px;
  text-align: center;
  color: rgba(255, 255, 255, 0.8);
  position: relative;
}
.sidebar .logo,
.off-canvas-sidebar .logo {
  position: relative;
  padding: 0.5rem 0.7rem;
  z-index: 4;
}
.sidebar .logo a.logo-mini,
.off-canvas-sidebar .logo a.logo-mini {
  opacity: 1;
  float: left;
  width: 34px;
  text-align: center;
  margin-left: 12px;
  margin-right: 12px;
}
.sidebar .logo a.logo-mini img,
.off-canvas-sidebar .logo a.logo-mini img {
  border-radius: 10%;
  width: 30px;
}
.sidebar .logo a.logo-normal,
.off-canvas-sidebar .logo a.logo-normal {
  display: block;
  opacity: 1;
  transform: translate3d(0px, 0, 0);
}
.sidebar .logo:after,
.off-canvas-sidebar .logo:after {
  content: "";
  position: absolute;
  bottom: 0;
  right: 15px;
  height: 1px;
  width: calc(100% - 30px);
  background: rgba(255, 255, 255, 0.5);
}
.sidebar .logo p,
.off-canvas-sidebar .logo p {
  float: left;
  font-size: 20px;
  margin: 10px 10px;
  color: #ffffff;
  line-height: 20px;
  font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
}
.sidebar .logo .simple-text,
.off-canvas-sidebar .logo .simple-text {
  text-transform: uppercase;
  padding: 0.5rem 0;
  display: block;
  white-space: nowrap;
  color: #ffffff;
  text-decoration: none;
  font-weight: 400;
  line-height: 30px;
  overflow: hidden;
}
.sidebar .logo-tim,
.off-canvas-sidebar .logo-tim {
  border-radius: 50%;
  border: 1px solid #333;
  display: block;
  height: 61px;
  width: 61px;
  float: left;
  overflow: hidden;
}
.sidebar .logo-tim img,
.off-canvas-sidebar .logo-tim img {
  width: 60px;
  height: 60px;
}
.sidebar[data=black],
.off-canvas-sidebar[data=black] {
  background: #1e1e6f;
  background: linear-gradient(0deg, #1e1e6f 0%, #1e1e24 100%);
}
.sidebar[data=blue],
.off-canvas-sidebar[data=blue] {
  background: #3358f4;
  background: linear-gradient(0deg, #3358f4 0%, #0c4160 100%);
}
.sidebar[data=green],
.off-canvas-sidebar[data=green] {
  background: #28a745;
  background: linear-gradient(0deg, #28a745 0%, #1c6430 100%);
}
.sidebar[data=red],
.off-canvas-sidebar[data=red] {
  background: #dc3545;
  background: linear-gradient(0deg, #dc3545 0%, #7f1f27 100%);
}
.sidebar[data=orange],
.off-canvas-sidebar[data=orange] {
  background: #fd7e14;
  background: linear-gradient(0deg, #fd7e14 0%, #a84b0a 100%);
}
.sidebar[data=purple],
.off-canvas-sidebar[data=purple] {
  background: #6f42c1;
  background: linear-gradient(0deg, #6f42c1 0%, #47278a 100%);
}
.sidebar[data=teal],
.off-canvas-sidebar[data=teal] {
  background: #20c997;
  background: linear-gradient(0deg, #20c997 0%, #147a62 100%);
}
.sidebar[data=black],
.off-canvas-sidebar[data=black] {
  background: #1e1e6f;
  background: linear-gradient(0deg, #1e1e6f 0%, #1e1e24 100%);
}
.sidebar .user,
.off-canvas-sidebar .user {
  padding-bottom: 20px;
  margin: 20px auto 0;
  position: relative;
}
.sidebar .user:after,
.off-canvas-sidebar .user:after {
  content: "";
  position: absolute;
  bottom: 0;
  right: 15px;
  height: 1px;
  width: calc(100% - 30px);
  background: rgba(255, 255, 255, 0.5);
}
.sidebar .user .photo,
.off-canvas-sidebar .user .photo {
  width: 34px;
  height: 34px;
  overflow: hidden;
  float: left;
  z-index: 5;
  margin-right: 10px;
  border-radius: 50%;
  margin-left: 23px;
  box-shadow: 0px 10px 25px 0px rgba(0, 0, 0, 0.3);
}
.sidebar .user .photo img,
.off-canvas-sidebar .user .photo img {
  width: 100%;
}
.sidebar .user a,
.off-canvas-sidebar .user a {
  color: #ffffff;
  text-decoration: none;
  padding: 0.5rem 15px;
  white-space: nowrap;
}
.sidebar .user .info > a,
.off-canvas-sidebar .user .info > a {
  display: block;
  line-height: 18px;
}
.sidebar .user .info > a > span,
.off-canvas-sidebar .user .info > a > span {
  display: block;
  position: relative;
  opacity: 1;
}
.sidebar .user .info .caret,
.off-canvas-sidebar .user .info .caret {
  position: absolute;
  top: 8px;
  right: 18px;
}

.visible-on-sidebar-regular {
  display: inline-block !important;
}

.visible-on-sidebar-mini {
  display: none !important;
}

.off-canvas-sidebar .nav > li > a,
.off-canvas-sidebar .nav > li > a:hover {
  color: #ffffff;
}
.off-canvas-sidebar .nav > li > a:focus {
  background: rgba(200, 200, 200, 0.2);
}

.main-panel {
  position: relative;
  float: right;
  width: 100%;
  min-height: 100vh;
  border-top: 2px solid #68869a;
  background: linear-gradient(#1e1e24, #1e1e6f);
  transition: all 0.5s cubic-bezier(0.685, 0.0473, 0.346, 1);
}
.main-panel[data=blue] {
  border-top: 2px solid #0c4160;
}
.main-panel[data=green] {
  border-top: 2px solid #68869a;
}
.main-panel[data=primary] {
  border-top: 2px solid #68869a;
}
.main-panel > .content {
  padding: 78px 30px 30px 280px;
  min-height: calc(100vh - 70px);
}
.main-panel > .navbar {
  margin-bottom: 0;
}
.main-panel .header {
  margin-bottom: 50px;
}

.perfect-scrollbar-on .main-panel {
  height: 100%;
  max-height: 100%;
}

.sidebar,
.main-panel,
.sidebar-wrapper {
  -webkit-overflow-scrolling: touch;
}

@media (min-width: 991px) {
  .sidebar,
  .main-panel,
  .sidebar-wrapper {
    transition-property: top, bottom, width;
    transition-duration: 0.2s, 0.2s, 0.35s;
    transition-timing-function: linear, linear, ease;
  }
  .sidebar-mini .visible-on-sidebar-regular {
    display: none !important;
  }
  .sidebar-mini .visible-on-sidebar-mini {
    display: inline-block !important;
  }
  .sidebar-mini .sidebar {
    width: 80px;
  }
  .sidebar-mini .sidebar .sidebar-wrapper {
    width: 100% !important;
  }
  .sidebar-mini .sidebar {
    display: block;
    z-index: 1030;
    box-shadow: 0px 2px 22px 0 rgba(0, 0, 0, 0.2), 0px 2px 30px 0 rgba(0, 0, 0, 0.35);
  }
  .sidebar-mini .sidebar .logo a.logo-normal {
    opacity: 0;
    transform: translate3d(-25px, 0, 0);
  }
  .sidebar-mini .sidebar .sidebar-wrapper > .nav [data-toggle=collapse] ~ div > ul > li > a .sidebar-normal,
  .sidebar-mini .sidebar .sidebar-wrapper .user .info [data-toggle=collapse] ~ div > ul > li > a .sidebar-normal,
  .sidebar-mini .sidebar .sidebar-wrapper .user .info > a > span,
  .sidebar-mini .sidebar .sidebar-wrapper > .nav li > a p {
    transform: translate3d(-25px, 0, 0);
    opacity: 0;
  }
  .sidebar-mini .sidebar .nav [data-toggle=collapse] ~ div > ul > li > a .sidebar-mini-icon {
    opacity: 1;
  }
  .sidebar-mini .sidebar:hover {
    width: 260px;
  }
  .sidebar-mini .sidebar:hover .logo a.logo-normal {
    opacity: 1;
    transform: translate3d(0, 0, 0);
  }
  .sidebar-mini .sidebar:hover .navbar-minimize {
    opacity: 1;
  }
  .sidebar-mini .sidebar:hover .sidebar-wrapper {
    width: 260px;
  }
  .sidebar-mini .sidebar:hover .sidebar-wrapper > .nav li > a p,
  .sidebar-mini .sidebar:hover .sidebar-wrapper > .nav [data-toggle=collapse] ~ div > ul > li > a .sidebar-normal,
  .sidebar-mini .sidebar:hover .sidebar-wrapper .user .info [data-toggle=collapse] ~ div > ul > li > a .sidebar-normal,
  .sidebar-mini .sidebar:hover .sidebar-wrapper .user .info > a > span {
    transform: translate3d(0px, 0, 0);
    opacity: 1;
  }
  .sidebar-mini .sidebar:hover .nav [data-toggle=collapse] ~ div > ul > li > a .sidebar-mini-icon {
    opacity: 0;
  }
  .sidebar-mini .main-panel > .content {
    padding-left: 130px;
  }
  .sidebar-mini footer {
    padding-left: 130px;
  }
  .navbar-minimize button {
    margin-left: 10px;
  }
  .navbar-minimize button i {
    color: #ffffff;
    font-size: 20px;
  }
}
.panel-header {
  height: 260px;
  padding-top: 80px;
  padding-bottom: 45px;
  background: #141E30; /* fallback for old browsers */
  background: linear-gradient(to right, #0c2646 0%, #204065 60%, #2a5788 100%);
  position: relative;
  overflow: hidden;
}
.panel-header .header .title {
  color: #ffffff;
}
.panel-header .header .category {
  max-width: 600px;
  color: rgba(255, 255, 255, 0.5);
  margin: 0 auto;
  font-size: 13px;
}
.panel-header .header .category a {
  color: #ffffff;
}

.panel-header-sm {
  height: 135px;
}

.panel-header-lg {
  height: 380px;
}

@media screen and (max-width: 991px) {
  .sidebar {
    position: fixed;
    display: block;
    top: 0;
    height: 100%;
    width: 260px;
    right: auto;
    left: 0;
    margin: 0;
    border-radius: 0;
    z-index: 1032;
    visibility: visible;
    overflow-y: visible;
    padding: 0;
    transition: 0.5s cubic-bezier(0.685, 0.0473, 0.346, 1);
    transform: translate3d(-260px, 0, 0);
  }
}
@media screen and (max-width: 991px) and (prefers-reduced-motion: reduce) {
  .sidebar {
    transition: none;
  }
}
@media screen and (max-width: 991px) {
  .wrapper {
    transition: 0.5s, cubic-bezier(0.685, 0.0473, 0.346, 1);
  }
}
@media screen and (max-width: 991px) and (prefers-reduced-motion: reduce) {
  .wrapper {
    transition: none;
  }
}
@media screen and (max-width: 991px) {
  .main-panel {
    width: 100%;
  }
  .main-panel .content {
    padding-left: 30px;
  }
  .nav-open .main-panel {
    right: 0;
    transform: translate3d(260px, 0, 0);
  }
  .nav-open .sidebar {
    transition: 0.5s cubic-bezier(0.685, 0.0473, 0.346, 1);
    transform: translate3d(0px, 0, 0);
  }
}
@media screen and (max-width: 991px) and (prefers-reduced-motion: reduce) {
  .nav-open .sidebar {
    transition: none;
  }
}
@media screen and (max-width: 991px) {
  .nav-open .sidebar:before {
    content: normal;
    content: initial;
  }
  .nav-open body {
    position: relative;
    overflow-x: hidden;
  }
  .nav-open .menu-on-right .main-panel {
    transform: translate3d(-260px, 0, 0);
  }
  .nav-open .menu-on-right .navbar-collapse,
  .nav-open .menu-on-right .sidebar {
    transform: translate3d(0px, 0, 0);
  }
  .nav-open .menu-on-right #bodyClick {
    right: 260px;
    left: auto;
  }
  .nav-open .fixed-plugin {
    display: none;
  }
  .menu-on-right .sidebar {
    left: auto;
    right: 0;
    transform: translate3d(260px, 0, 0);
  }
  #bodyClick {
    height: 100%;
    width: 100%;
    position: fixed;
    opacity: 1;
    top: 0;
    right: 0;
    left: 260px;
    content: "";
    z-index: 9999;
    overflow-x: hidden;
    background-color: transparent;
    transition: 0.5s, cubic-bezier(0.685, 0.0473, 0.346, 1);
  }
}
@media screen and (max-width: 991px) and (prefers-reduced-motion: reduce) {
  #bodyClick {
    transition: none;
  }
}
@media screen and (max-width: 991px) {
  .navbar .dropdown-menu {
    position: static !important;
  }
}
@media screen and (max-width: 768px) {
  .main-panel .content {
    padding-left: 15px;
    padding-right: 15px;
  }
}
/* Animations */
.nav-pills .nav-link,
.navbar,
.nav-tabs .nav-link,
.sidebar .nav a,
.sidebar .nav a i,
.sidebar .nav p,
.navbar-collapse .navbar-nav .nav-link,
.animation-transition-general,
.off-canvas-sidebar .nav p,
.sidebar .logo a.logo-mini,
.sidebar .logo a.logo-normal,
.off-canvas-sidebar .logo a.logo-mini,
.off-canvas-sidebar .logo a.logo-normal,
.sidebar .user .photo,
.off-canvas-sidebar .user .photo,
.sidebar .user a,
.off-canvas-sidebar .user a,
.sidebar .user .info > a > span,
.off-canvas-sidebar .user .info > a > span,
.tag,
.tag [data-role=remove],
.off-canvas-sidebar .nav p,
.off-canvas-sidebar .logo a.logo-normal,
.sidebar .user a,
.off-canvas-sidebar .user a,
.off-canvas-sidebar .user .info > a > span {
  transition: all 300ms ease 0s;
}

.bootstrap-switch-label:before,
.caret {
  transition: all 150ms ease 0s;
}

.dropdown-toggle[aria-expanded=true]:after,
a[data-toggle=collapse][aria-expanded=true] .caret,
.card-collapse .card a[data-toggle=collapse][aria-expanded=true] i,
.card-collapse .card a[data-toggle=collapse].expanded i {
  filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=2);
  transform: rotate(180deg);
}

.caret {
  width: 0;
  height: 0;
  vertical-align: middle;
  border-top: 4px dashed;
  border-right: 4px solid transparent;
  border-left: 4px solid transparent;
  margin-top: -5px;
  position: absolute;
  top: 30px;
  margin-left: 5px;
}

.pull-left {
  float: left;
}

.pull-right {
  float: right;
}

.card form label + .form-control {
  margin-bottom: 20px;
}

.card .map-title {
  color: #ffffff;
}
.card.card-chart .gmnoprint,
.card.card-chart .gm-style-cc {
  display: none !important;
}

.bd-docs h1, .bd-docs .h1, .bd-docs h2, .bd-docs .h2, .bd-docs h3, .bd-docs .h3, .bd-docs h4, .bd-docs .h4, .bd-docs h5, .bd-docs .h5, .bd-docs h6, .bd-docs .h6, .bd-docs p, .bd-docs ul li, .bd-docs ol li {
  color: #2c2c2c;
}
.bd-docs .bd-content > table > thead > tr > th {
  color: #000000;
}
.bd-docs .blockquote, .bd-docs .blockquote p, .bd-docs .card p {
  color: rgba(255, 255, 255, 0.8);
}
.bd-docs .bd-example {
  background: linear-gradient(#1e1e2f, #1e1e24);
}
.bd-docs .navbar {
  border-top: none;
}
.bd-docs .navbar .navbar-nav .nav-link {
  color: rgba(255, 255, 255, 0.8) !important;
}
.bd-docs .bd-example .btn {
  margin: 4px 0;
}
.bd-docs .bd-example .btn .badge {
  display: inline-block;
}
.bd-docs .bd-example .tim-icons {
  color: #ffffff;
}
.bd-docs .bd-example .popover .popover-header {
  color: hsla(0, 0%, 71%, 0.6);
}
.bd-docs .bd-example .popover-body p {
  color: #212529;
}
.bd-docs .bd-example.tooltip-demo p {
  color: rgba(255, 255, 255, 0.8);
}
.bd-docs .card.card-body,
.bd-docs .card .card-body {
  color: hsla(0, 0%, 100%, 0.8);
}
.bd-docs label,
.bd-docs .form-check {
  color: hsla(0, 0%, 100%, 0.8);
}
.bd-docs .form-check + .btn {
  margin-top: 20px;
}
.bd-docs .bd-example thead th,
.bd-docs table thead th {
  color: hsla(0, 0%, 100%, 0.8);
}
.bd-docs .bd-example h1, .bd-docs .bd-example h2, .bd-docs .bd-example h3, .bd-docs .bd-example h4, .bd-docs .bd-example h5, .bd-docs .bd-example h6,
.bd-docs .bd-example .h1, .bd-docs .bd-example .h2, .bd-docs .bd-example .h3, .bd-docs .bd-example .h4, .bd-docs .bd-example .h5, .bd-docs .bd-example .h6,
.bd-docs table h1,
.bd-docs table h2,
.bd-docs table h3,
.bd-docs table h4,
.bd-docs table h5,
.bd-docs table h6,
.bd-docs table .h1,
.bd-docs table .h2,
.bd-docs table .h3,
.bd-docs table .h4,
.bd-docs table .h5,
.bd-docs table .h6 {
  color: hsla(0, 0%, 100%, 0.8);
}
.bd-docs .bd-example .datepicker thead th, .bd-docs .bd-example .datepicker table thead th, .bd-docs .bd-example .datepicker .tim-icons,
.bd-docs table .datepicker thead th,
.bd-docs table .datepicker table thead th,
.bd-docs table .datepicker .tim-icons {
  color: #68869a;
}
.bd-docs .bd-example .picker-switch .tim-icons,
.bd-docs table .picker-switch .tim-icons {
  color: #68869a;
}
.bd-docs .footer .container-fluid > nav {
  display: inline-block;
}

.modal.show .modal-dialog {
  transform: translate(0, 30%);
}

code {
  color: #f3a4b5;
}

@media screen and (max-width: 991px) {
  .profile-photo .profile-photo-small {
    margin-left: -2px;
  }
  .button-dropdown {
    display: none;
  }
  #searchModal .modal-dialog {
    margin: 20px;
  }
  #minimizeSidebar {
    display: none;
  }
}
@media screen and (max-width: 768px) {
  .landing-page .section-story-overview .image-container:nth-child(2) {
    margin-left: 0;
    margin-bottom: 30px;
  }
}
@media screen and (max-width: 576px) {
  .page-header .container h6.category-absolute, .page-header .container .category-absolute.h6 {
    width: 90%;
  }
  .form-horizontal .col-form-label, .form-horizontal .label-on-right {
    text-align: inherit;
    padding-top: 0;
  }
  .form-horizontal .col-form-label code, .form-horizontal .label-on-right code {
    padding: 0 10px;
  }
}
.rtl .sidebar,
.rtl .bootstrap-navbar {
  right: 0;
  left: auto;
  margin-right: 20px;
  margin-left: 0;
}
.rtl .sidebar .nav i,
.rtl .bootstrap-navbar .nav i {
  float: right;
  margin-left: 15px;
  margin-right: 0;
}
.rtl .sidebar .nav p,
.rtl .bootstrap-navbar .nav p {
  margin-right: 45px;
  text-align: right;
}
.rtl .sidebar .nav .caret,
.rtl .bootstrap-navbar .nav .caret {
  left: 11px;
  right: auto;
}
.rtl .sidebar .logo a.logo-mini,
.rtl .bootstrap-navbar .logo a.logo-mini {
  float: right;
  margin-right: 20px;
  margin-left: 10px;
}
.rtl .sidebar .logo .simple-text,
.rtl .bootstrap-navbar .logo .simple-text {
  text-align: right;
}
.rtl .sidebar .sidebar-wrapper .nav [data-toggle=collapse] ~ div > ul > li > a .sidebar-mini-icon,
.rtl .sidebar .sidebar-wrapper .user .info [data-toggle=collapse] ~ div > ul > li > a .sidebar-mini-icon,
.rtl .bootstrap-navbar .sidebar-wrapper .nav [data-toggle=collapse] ~ div > ul > li > a .sidebar-mini-icon,
.rtl .bootstrap-navbar .sidebar-wrapper .user .info [data-toggle=collapse] ~ div > ul > li > a .sidebar-mini-icon {
  float: right;
  margin-left: 15px;
  margin-right: 0;
}
.rtl .sidebar .sidebar-wrapper > .nav [data-toggle=collapse] ~ div > ul > li > a .sidebar-normal,
.rtl .sidebar .sidebar-wrapper .user .info [data-toggle=collapse] ~ div > ul > li > a .sidebar-normal,
.rtl .bootstrap-navbar .sidebar-wrapper > .nav [data-toggle=collapse] ~ div > ul > li > a .sidebar-normal,
.rtl .bootstrap-navbar .sidebar-wrapper .user .info [data-toggle=collapse] ~ div > ul > li > a .sidebar-normal {
  text-align: right;
}
.rtl .sidebar:before,
.rtl .bootstrap-navbar:before {
  right: 30px;
  left: auto;
}
.rtl .main-panel .content {
  padding: 80px 280px 30px 30px;
}
.rtl .footer {
  padding: 24px 300px 24px 0;
}
.rtl .dropdown-toggle:after {
  margin-right: 0.255em;
  margin-left: 0;
}
.rtl .dropdown-menu.dropdown-menu-right.dropdown-navbar {
  right: -220px !important;
  left: auto;
}
.rtl .dropdown-menu.dropdown-menu-right.dropdown-navbar:before {
  right: auto;
  left: 35px;
}
.rtl .notification {
  left: 40px;
  right: auto;
}
.rtl .dropdown-menu {
  right: auto;
  left: 0;
}
.rtl .minimize-sidebar {
  float: right;
}
.rtl .alert {
  left: 0;
  margin-left: 0;
  margin-right: 0;
}
.rtl .alert button.close {
  left: 10px !important;
  right: auto !important;
}
.rtl .alert span[data-notify=icon] {
  right: 15px;
  left: auto;
}
.rtl .alert.alert-with-icon {
  padding-right: 65px;
  padding-left: 15px;
}
.rtl .alert.alert-with-icon i[data-notify=icon] {
  right: 15px;
  left: auto;
}
.rtl .search-bar {
  margin-left: 0;
}
.rtl .modal-search .modal-header .close {
  margin-right: auto;
  left: 10px;
}
@media (min-width: 991px) {
  .rtl.sidebar-mini .main-panel .content {
    padding-right: 130px;
    padding-left: 50px;
  }
  .rtl.sidebar-mini footer {
    padding-right: 130px;
    padding-left: 50px;
  }
  .rtl .navbar-minimize button {
    margin-right: -5px;
  }
}
@media screen and (max-width: 991px) {
  .rtl .sidebar {
    margin-right: 0;
  }
  .rtl .main-panel .content {
    padding-right: 50px;
  }
  .rtl #bodyClick {
    right: 260px;
    left: auto;
  }
  .rtl .footer {
    padding-right: 15px;
  }
}
.rtl .navbar .navbar-nav {
  padding-right: 0;
}
.rtl .navbar .navbar-nav a.nav-link {
  text-align: right;
}
.rtl .navbar .navbar-nav a.nav-link p {
  margin-right: 7px;
}
.rtl .navbar .navbar-nav .btn {
  margin-right: 0;
  padding: 0;
}
.rtl .navbar .navbar-nav .btn i {
  margin-left: 4px;
  margin-right: 5px;
}
.rtl .navbar .navbar-nav .search-bar span {
  margin-right: 10px;
}
.rtl .ps__rail-y {
  right: auto !important;
  left: 0;
}
.rtl .main-panel {
  position: fixed;
  height: 100%;
  overflow-y: scroll;
  overflow-x: hidden;
}
.rtl .fixed-plugin {
  border-radius: 0 8px 8px 0;
  left: 0;
  right: auto;
  right: initial;
}
.rtl .fixed-plugin .dropdown-menu {
  left: 80px !important;
  right: auto !important;
}
.rtl .fixed-plugin .dropdown-menu:before, .rtl .fixed-plugin .dropdown-menu:after {
  left: 10px;
  margin-right: auto;
  right: auto;
}
.rtl .fixed-plugin .dropdown-menu:before {
  right: auto;
  right: initial;
  left: -16px;
  border-left: 0;
  border-left: initial;
  border-right: 0.4em solid rgba(0, 0, 0, 0.2);
}
.rtl .fixed-plugin .dropdown-menu:after {
  right: auto;
  right: initial;
  left: -16px;
  border-left: 0;
  border-left: initial;
  border-right: 0.4em solid #000000;
}
.rtl .sidebar .nav li.active > a:not([data-toggle=collapse]):before, .rtl .off-canvas-sidebar .nav li.active > a:not([data-toggle=collapse]):before {
  left: auto;
  left: initial;
  right: -4px;
}

@media screen and (max-width: 768px) {
  .rtl .main-panel .content {
    padding-left: 15px;
    padding-right: 15px;
  }
}
.form-group.has-danger .error,
.input-group.has-danger .error {
  color: #ec250d;
}

.form-group.has-success .error,
.input-group.has-success .error {
  color: #68869a;
}

.form-group.no-border.form-control-lg .input-group-append .input-group-text,
.input-group.no-border.form-control-lg .input-group-append .input-group-text {
  padding: 15px 0 15px 19px;
}
.form-group.no-border.form-control-lg .form-control,
.input-group.no-border.form-control-lg .form-control {
  padding: 15px 19px;
}
.form-group.no-border.form-control-lg .form-control + .input-group-prepend .input-group-text, .form-group.no-border.form-control-lg .form-control + .input-group-append .input-group-text,
.input-group.no-border.form-control-lg .form-control + .input-group-prepend .input-group-text,
.input-group.no-border.form-control-lg .form-control + .input-group-append .input-group-text {
  padding: 15px 19px 15px 0;
}

.form-group.form-control-lg .form-control,
.input-group.form-control-lg .form-control {
  padding: 14px 18px;
  height: 100%;
}
.form-group.form-control-lg .form-control + .input-group-prepend .input-group-text, .form-group.form-control-lg .form-control + .input-group-append .input-group-text,
.input-group.form-control-lg .form-control + .input-group-prepend .input-group-text,
.input-group.form-control-lg .form-control + .input-group-append .input-group-text {
  padding: 14px 18px 14px 0;
}
.form-group.form-control-lg .input-group-prepend .input-group-text,
.form-group.form-control-lg .input-group-append .input-group-text,
.input-group.form-control-lg .input-group-prepend .input-group-text,
.input-group.form-control-lg .input-group-append .input-group-text {
  padding: 14px 0 15px 18px;
}
.form-group.form-control-lg .input-group-prepend .input-group-text + .form-control,
.form-group.form-control-lg .input-group-append .input-group-text + .form-control,
.input-group.form-control-lg .input-group-prepend .input-group-text + .form-control,
.input-group.form-control-lg .input-group-append .input-group-text + .form-control {
  padding: 15px 18px 15px 16px;
}

.form-group.no-border .form-control,
.input-group.no-border .form-control {
  padding: 11px 19px;
}
.form-group.no-border .form-control + .input-group-prepend .input-group-text, .form-group.no-border .form-control + .input-group-append .input-group-text,
.input-group.no-border .form-control + .input-group-prepend .input-group-text,
.input-group.no-border .form-control + .input-group-append .input-group-text {
  padding: 11px 19px 11px 0;
}
.form-group.no-border .input-group-prepend .input-group-text,
.form-group.no-border .input-group-append .input-group-text,
.input-group.no-border .input-group-prepend .input-group-text,
.input-group.no-border .input-group-append .input-group-text {
  padding: 11px 0 11px 19px;
}

.form-group .form-control,
.input-group .form-control {
  padding: 10px 18px 10px 18px;
}
.form-group .form-control + .input-group-prepend .input-group-text, .form-group .form-control + .input-group-append .input-group-text,
.input-group .form-control + .input-group-prepend .input-group-text,
.input-group .form-control + .input-group-append .input-group-text {
  padding: 10px 18px 10px 0;
}
.form-group .input-group-prepend .input-group-text,
.form-group .input-group-append .input-group-text,
.input-group .input-group-prepend .input-group-text,
.input-group .input-group-append .input-group-text {
  padding: 10px 0 10px 18px;
}
.form-group .input-group-prepend .input-group-text + .form-control, .form-group .input-group-prepend .input-group-text ~ .form-control,
.form-group .input-group-append .input-group-text + .form-control,
.form-group .input-group-append .input-group-text ~ .form-control,
.input-group .input-group-prepend .input-group-text + .form-control,
.input-group .input-group-prepend .input-group-text ~ .form-control,
.input-group .input-group-append .input-group-text + .form-control,
.input-group .input-group-append .input-group-text ~ .form-control {
  padding: 10px 19px 11px 16px;
}

.form-group.no-border .form-control,
.form-group.no-border .form-control + .input-group-prepend .input-group-text,
.form-group.no-border .form-control + .input-group-append .input-group-text,
.input-group.no-border .form-control,
.input-group.no-border .form-control + .input-group-prepend .input-group-text,
.input-group.no-border .form-control + .input-group-append .input-group-text {
  background-color: #030303;
  border: medium none;
}
.form-group.no-border .form-control:focus, .form-group.no-border .form-control:active, .form-group.no-border .form-control:active,
.form-group.no-border .form-control + .input-group-prepend .input-group-text:focus,
.form-group.no-border .form-control + .input-group-prepend .input-group-text:active,
.form-group.no-border .form-control + .input-group-prepend .input-group-text:active,
.form-group.no-border .form-control + .input-group-append .input-group-text:focus,
.form-group.no-border .form-control + .input-group-append .input-group-text:active,
.form-group.no-border .form-control + .input-group-append .input-group-text:active,
.input-group.no-border .form-control:focus,
.input-group.no-border .form-control:active,
.input-group.no-border .form-control:active,
.input-group.no-border .form-control + .input-group-prepend .input-group-text:focus,
.input-group.no-border .form-control + .input-group-prepend .input-group-text:active,
.input-group.no-border .form-control + .input-group-prepend .input-group-text:active,
.input-group.no-border .form-control + .input-group-append .input-group-text:focus,
.input-group.no-border .form-control + .input-group-append .input-group-text:active,
.input-group.no-border .form-control + .input-group-append .input-group-text:active {
  border: medium none;
  background-color: #050505;
}
.form-group.no-border .form-control:focus + .input-group-prepend .input-group-text, .form-group.no-border .form-control:focus + .input-group-append .input-group-text,
.input-group.no-border .form-control:focus + .input-group-prepend .input-group-text,
.input-group.no-border .form-control:focus + .input-group-append .input-group-text {
  background-color: #050505;
}
.form-group.no-border .input-group-prepend .input-group-text,
.form-group.no-border .input-group-append .input-group-text,
.input-group.no-border .input-group-prepend .input-group-text,
.input-group.no-border .input-group-append .input-group-text {
  background-color: #030303;
  border: none;
}

.has-error .form-control-feedback, .has-error .control-label {
  color: #ec250d;
}

.has-success .form-control-feedback, .has-success .control-label {
  color: #68869a;
}

.input-group-append .input-group-text,
.input-group-prepend .input-group-text {
  background-color: transparent;
  border: 1px solid #0d0d0d;
  border-radius: 0.4285rem;
  color: #ffffff;
  transition: color 0.3s ease-in-out, border-color 0.3s ease-in-out, background-color 0.3s ease-in-out;
}
.input-group-append .input-group-text i,
.input-group-prepend .input-group-text i {
  opacity: 0.5;
}
.has-danger.input-group-focus .input-group-append .input-group-text,
.has-danger.input-group-focus .input-group-prepend .input-group-text {
  background-color: transparent;
}
.has-success .input-group-append .input-group-text,
.has-success .input-group-prepend .input-group-text {
  background-color: transparent;
}
.has-danger .form-control:focus + .input-group-append .input-group-text,
.has-danger .form-control:focus + .input-group-prepend .input-group-text {
  color: #ec250d;
}
.has-success .form-control:focus + .input-group-append .input-group-text,
.has-success .form-control:focus + .input-group-prepend .input-group-text {
  color: #68869a;
}
.input-group-append .input-group-text + .form-control, .input-group-append .input-group-text ~ .form-control,
.input-group-prepend .input-group-text + .form-control,
.input-group-prepend .input-group-text ~ .form-control {
  padding: -0.5rem 0.7rem;
  padding-left: 18px;
}
.input-group-append .input-group-text i,
.input-group-prepend .input-group-text i {
  width: 17px;
}

.input-group-append,
.input-group-prepend .input-group-text,
.input-group-prepend .input-group-text {
  background-color: transparent;
  border: 1px solid #0d0d0d;
  border-radius: 0.4285rem;
  color: #ffffff;
  margin: 0;
}

.input-group-append .input-group-text {
  border-left: none;
}

.input-group-prepend .input-group-text {
  border-right: none;
}

.input-group-focus .input-group-prepend .input-group-text,
.input-group-focus .input-group-append .input-group-text {
  background-color: #ffffff;
  border-color: #68869a;
  background-color: transparent;
  border-color: #68869a;
}
.input-group-focus.no-border .input-group-prepend .input-group-text,
.input-group-focus.no-border .input-group-append .input-group-text {
  background-color: #050505;
}

.input-group,
.form-group {
  margin-bottom: 10px;
  position: relative;
}
.input-group .form-control-static,
.form-group .form-control-static {
  margin-top: 9px;
}

.input-group[disabled] .input-group-prepend .input-group-text,
.input-group[disabled] .input-group-append .input-group-text {
  background-color: #E3E3E3;
}

.input-group .form-control:not(:first-child):not(:last-child), .input-group-btn:not(:first-child):not(:last-child) {
  border-radius: 0.4285rem;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  border-left: 0 none;
}

.input-group .form-control:first-child,
.input-group-btn:first-child > .dropdown-toggle,
.input-group-btn:last-child > .btn:not(:last-child):not(.dropdown-toggle) {
  border-right: 0 none;
}

.input-group .form-control:last-child,
.input-group-btn:last-child > .dropdown-toggle,
.input-group-btn:first-child > .btn:not(:first-child) {
  border-left: 0 none;
}

.form-control[disabled], .form-control[readonly], fieldset[disabled] .form-control {
  background-color: #1d253b;
  color: #011e31;
  cursor: not-allowed;
}

.input-group-btn .btn {
  border-width: 1px;
  padding: 11px 0.7rem;
}

.input-group-btn .btn-default:not(.btn-fill) {
  border-color: #DDDDDD;
}

.input-group-btn:last-child > .btn {
  margin-left: 0;
}

textarea.form-control {
  max-width: 100%;
  max-height: 80px;
  padding: 10px 10px 0 0;
  resize: none;
  line-height: 2;
}

.has-success.form-group .form-control, .has-success.form-group.no-border .form-control,
.has-danger.form-group .form-control,
.has-danger.form-group.no-border .form-control {
  padding-right: 40px;
}

.form.form-newsletter .form-group {
  float: left;
  width: 78%;
  margin-right: 2%;
  margin-top: 9px;
}

.input-group .input-group-btn {
  padding: 0 12px;
}

.form-group input[type=file] {
  opacity: 0;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 100;
}

.form-text {
  font-size: 0.7500000025rem;
  color: rgba(255, 255, 255, 0.8);
}

.form-control-lg {
  padding: 0;
  font-size: inherit;
  line-height: 0;
  border-radius: 0;
}
.form-control-lg .form-control {
  height: calc(2.875rem + 2px);
}

.form-horizontal .col-form-label,
.form-horizontal .label-on-right {
  padding: 10px 5px 0 15px;
  text-align: right;
  max-width: 180px;
}
.form-horizontal .checkbox-radios {
  margin-bottom: 15px;
}
.form-horizontal .checkbox-radios .form-check:first-child {
  margin-top: 8px;
}
.form-horizontal .label-on-right {
  text-align: left;
  padding: 10px 15px 0 5px;
}
.form-horizontal .form-check-inline {
  margin-top: 6px;
}
.form-horizontal .form-check-inline .form-check-label {
  margin-right: 1.5rem;
}

.search-bar {
  margin-left: 30px;
}
.search-bar .btn {
  margin: 0;
}
.search-bar.input-group {
  border-radius: 25px;
  z-index: 4;
  margin-bottom: 0;
  height: 43px;
  padding-right: 5px;
}
.search-bar.input-group .input-group-addon {
  padding: 10px;
  background: transparent;
  border: none;
  color: rgba(255, 255, 255, 0.7);
}
.search-bar.input-group i {
  font-size: 20px;
  color: #ffffff;
  margin-top: 0 !important;
}
.search-bar.input-group input {
  background: transparent;
  border: none !important;
  border-radius: 0;
  padding: 12px !important;
  font-size: 12px;
  opacity: 0.5;
}
.search-bar.input-group input:focus {
  background: transparent;
}
.search-bar.input-group .form-control {
  opacity: 1;
  color: #ffffff;
}
.search-bar.input-group .form-control::placeholder {
  color: white;
}

.modal-search .modal-dialog {
  max-width: 1000px;
  margin: 20px auto;
}
.modal-search .modal-dialog .form-control {
  border: none;
  color: #000000;
}
.modal-search .modal-dialog .form-control::placeholder {
  color: #000000;
}

.input-group-prepend {
  margin-right: 0;
}

.input-group-prepend .tim-icons,
.input-group-append .tim-icons {
  font-size: 1rem;
}

/*
 * Container style
 */
.ps {
  overflow: hidden !important;
  overflow-anchor: none;
  -ms-overflow-style: none;
  touch-action: auto;
  -ms-touch-action: auto;
}

/*
 * Scrollbar rail styles
 */
.ps__rail-x {
  display: none;
  opacity: 0;
  transition: background-color 0.2s linear, opacity 0.2s linear;
  -webkit-transition: background-color 0.2s linear, opacity 0.2s linear;
  height: 15px;
  /* there must be 'bottom' or 'top' for ps__rail-x */
  bottom: 0px;
  /* please don't change 'position' */
  position: absolute;
}

.ps__rail-y {
  display: none;
  opacity: 0;
  transition: background-color 0.2s linear, opacity 0.2s linear;
  -webkit-transition: background-color 0.2s linear, opacity 0.2s linear;
  width: 15px;
  /* there must be 'right' or 'left' for ps__rail-y */
  right: 0;
  /* please don't change 'position' */
  position: absolute;
}

.ps--active-x > .ps__rail-x,
.ps--active-y > .ps__rail-y {
  display: block;
  background-color: transparent;
}

.ps:hover > .ps__rail-x,
.ps:hover > .ps__rail-y,
.ps--focus > .ps__rail-x,
.ps--focus > .ps__rail-y,
.ps--scrolling-x > .ps__rail-x,
.ps--scrolling-y > .ps__rail-y {
  opacity: 0.6;
}

.ps .ps__rail-x:hover,
.ps .ps__rail-y:hover,
.ps .ps__rail-x:focus,
.ps .ps__rail-y:focus,
.ps .ps__rail-x.ps--clicking,
.ps .ps__rail-y.ps--clicking {
  background-color: #eee;
  opacity: 0.9;
}

/*
 * Scrollbar thumb styles
 */
.ps__thumb-x {
  background-color: #aaa;
  border-radius: 6px;
  transition: background-color 0.2s linear, height 0.2s ease-in-out;
  -webkit-transition: background-color 0.2s linear, height 0.2s ease-in-out;
  height: 6px;
  /* there must be 'bottom' for ps__thumb-x */
  bottom: 2px;
  /* please don't change 'position' */
  position: absolute;
}

.ps__thumb-y {
  background-color: #aaa;
  border-radius: 6px;
  transition: background-color 0.2s linear, width 0.2s ease-in-out;
  -webkit-transition: background-color 0.2s linear, width 0.2s ease-in-out;
  width: 6px;
  /* there must be 'right' for ps__thumb-y */
  right: 2px;
  /* please don't change 'position' */
  position: absolute;
}

.ps__rail-x:hover > .ps__thumb-x,
.ps__rail-x:focus > .ps__thumb-x,
.ps__rail-x.ps--clicking .ps__thumb-x {
  background-color: #999;
  height: 11px;
}

.ps__rail-y:hover > .ps__thumb-y,
.ps__rail-y:focus > .ps__thumb-y,
.ps__rail-y.ps--clicking .ps__thumb-y {
  background-color: #999;
  width: 11px;
}

/* MS supports */
@supports (-ms-overflow-style: none) {
  .ps {
    overflow: auto !important;
  }
}
@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {
  .ps {
    overflow: auto !important;
  }
}
.react-notification-alert-container {
  z-index: 1051;
  position: fixed;
}

.white-content {
  background: #f5f6fa;
}
.white-content .navbar.navbar-transparent .navbar-brand {
  color: #1d253b;
}
.white-content .navbar.navbar-transparent .navbar-toggler-bar {
  background: #1d253b;
}
.white-content .navbar.navbar-transparent .navbar-nav li a:not(.dropdown-item) {
  color: #1d253b;
}
.white-content .navbar.navbar-transparent .navbar-nav li a:not(.dropdown-item) i {
  color: #1d253b;
}
.white-content .navbar.navbar-transparent .navbar-minimize button i {
  color: #1d253b;
}
.white-content .navbar.navbar-transparent .search-bar.input-group i {
  color: #1d253b;
}
.white-content .navbar.navbar-transparent .search-bar.input-group .form-control {
  color: #011e31;
}
.white-content .navbar.navbar-transparent .search-bar.input-group .form-control::placeholder {
  color: #AAAAAA;
}
.white-content .sidebar {
  box-shadow: 0 2px 22px 0 rgba(0, 0, 0, 0.1), 0 4px 20px 0 rgba(0, 0, 0, 0.15);
}
.white-content .sidebar p {
  color: rgba(255, 255, 255, 0.8);
}
.white-content .main-panel {
  background: #f5f6fa;
}
.white-content h1, .white-content .h1, .white-content h2, .white-content .h2, .white-content h3, .white-content .h3, .white-content h4, .white-content .h4, .white-content h5, .white-content .h5, .white-content h6, .white-content .h6, .white-content p, .white-content ol li, .white-content ul li, .white-content pre {
  color: #1d253b;
}
.white-content .font-icon-detail i {
  color: #000000;
}
.white-content .btn:not([data-action]):hover {
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);
}
.white-content .btn-neutral.btn-link {
  color: rgba(0, 0, 0, 0.7);
}
.white-content .form-control::-moz-placeholder {
  color: rgba(0, 0, 0, 0.4);
  opacity: 1;
  filter: alpha(opacity=100);
}
.white-content .form-control:-moz-placeholder {
  color: rgba(0, 0, 0, 0.4);
  opacity: 1;
  filter: alpha(opacity=100);
}
.white-content .form-control::-webkit-input-placeholder {
  color: rgba(0, 0, 0, 0.4);
  opacity: 1;
  filter: alpha(opacity=100);
}
.white-content .form-control:-ms-input-placeholder {
  color: rgba(0, 0, 0, 0.4);
  opacity: 1;
  filter: alpha(opacity=100);
}
.white-content .has-danger .form-control, .white-content .has-danger .input-group-prepend .input-group-text {
  border-color: #ec250d;
}
.white-content .input-group-prepend .input-group-text {
  border-color: rgba(29, 37, 59, 0.5);
  color: #1d253b;
}
.white-content .form-control {
  color: #000000;
  border-color: rgba(29, 37, 59, 0.5);
}
.white-content .form-control:focus {
  border-color: #68869a;
}
.white-content .form-group.no-border .form-control,
.white-content .form-group.no-border .form-control + .input-group-prepend .input-group-text,
.white-content .form-group.no-border .form-control + .input-group-append .input-group-text,
.white-content .form-group.no-border .input-group-prepend .input-group-text,
.white-content .form-group.no-border .input-group-append .input-group-text,
.white-content .input-group.no-border .form-control,
.white-content .input-group.no-border .form-control + .input-group-prepend .input-group-text,
.white-content .input-group.no-border .form-control + .input-group-append .input-group-text,
.white-content .input-group.no-border .input-group-prepend .input-group-text,
.white-content .input-group.no-border .input-group-append .input-group-text {
  background-color: rgba(222, 222, 222, 0.3);
}
.white-content .form-group.no-border .form-control:focus, .white-content .form-group.no-border .form-control:active, .white-content .form-group.no-border .form-control:active,
.white-content .form-group.no-border .form-control + .input-group-prepend .input-group-text:focus,
.white-content .form-group.no-border .form-control + .input-group-prepend .input-group-text:active,
.white-content .form-group.no-border .form-control + .input-group-prepend .input-group-text:active,
.white-content .form-group.no-border .form-control + .input-group-append .input-group-text:focus,
.white-content .form-group.no-border .form-control + .input-group-append .input-group-text:active,
.white-content .form-group.no-border .form-control + .input-group-append .input-group-text:active,
.white-content .form-group.no-border .input-group-prepend .input-group-text:focus,
.white-content .form-group.no-border .input-group-prepend .input-group-text:active,
.white-content .form-group.no-border .input-group-prepend .input-group-text:active,
.white-content .form-group.no-border .input-group-append .input-group-text:focus,
.white-content .form-group.no-border .input-group-append .input-group-text:active,
.white-content .form-group.no-border .input-group-append .input-group-text:active,
.white-content .input-group.no-border .form-control:focus,
.white-content .input-group.no-border .form-control:active,
.white-content .input-group.no-border .form-control:active,
.white-content .input-group.no-border .form-control + .input-group-prepend .input-group-text:focus,
.white-content .input-group.no-border .form-control + .input-group-prepend .input-group-text:active,
.white-content .input-group.no-border .form-control + .input-group-prepend .input-group-text:active,
.white-content .input-group.no-border .form-control + .input-group-append .input-group-text:focus,
.white-content .input-group.no-border .form-control + .input-group-append .input-group-text:active,
.white-content .input-group.no-border .form-control + .input-group-append .input-group-text:active,
.white-content .input-group.no-border .input-group-prepend .input-group-text:focus,
.white-content .input-group.no-border .input-group-prepend .input-group-text:active,
.white-content .input-group.no-border .input-group-prepend .input-group-text:active,
.white-content .input-group.no-border .input-group-append .input-group-text:focus,
.white-content .input-group.no-border .input-group-append .input-group-text:active,
.white-content .input-group.no-border .input-group-append .input-group-text:active {
  background-color: rgba(222, 222, 222, 0.5);
}
.white-content .form-group.no-border .form-control:focus + .input-group-prepend .input-group-text, .white-content .form-group.no-border .form-control:focus + .input-group-append .input-group-text,
.white-content .input-group.no-border .form-control:focus + .input-group-prepend .input-group-text,
.white-content .input-group.no-border .form-control:focus + .input-group-append .input-group-text {
  background-color: transparent;
}
.white-content .input-group[disabled] .input-group-prepend .input-group-text,
.white-content .input-group[disabled] .input-group-append .input-group-text {
  background-color: #000000;
}
.white-content .form-control[disabled], .white-content .form-control[readonly], .white-content fieldset[disabled] .form-control {
  background: #E3E3E3;
  border-color: rgba(29, 37, 59, 0.3);
}
.white-content .input-group-focus .input-group-prepend .input-group-text,
.white-content .input-group-focus .input-group-append .input-group-text,
.white-content .input-group-focus .form-control {
  border-color: #68869a;
}
.white-content .input-group-focus.no-border .input-group-prepend .input-group-text,
.white-content .input-group-focus.no-border .input-group-append .input-group-text {
  background-color: rgba(222, 222, 222, 0.5);
}
.white-content .input-group-prepend .input-group-text {
  border-right: none;
}
.white-content .input-group-append .input-group-text {
  border-left: none;
}
.white-content .has-danger .form-control:focus, .white-content .has-success.input-group-focus .input-group-append .input-group-text, .white-content .has-success.input-group-focus .input-group-prepend .input-group-text {
  border-color: #ec250d;
}
.white-content .has-success .form-control:focus, .white-content .has-success.input-group-focus .input-group-append .input-group-text, .white-content .has-success.input-group-focus .input-group-prepend .input-group-text {
  border-color: #536c7c;
}
.white-content .btn.btn-link:hover, .white-content .btn.btn-link:active, .white-content .btn.btn-link:focus {
  color: #AAAAAA !important;
}
.white-content .btn-group .btn.active {
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);
}
.white-content .card:not(.card-white) {
  background: #ffffff;
  box-shadow: 0 1px 15px 0 rgba(123, 123, 123, 0.05);
}
.white-content .card:not(.card-white) .card-header {
  color: #000000;
}
.white-content .card:not(.card-white) .card-header a[data-toggle=collapse] {
  color: #000000;
}
.white-content .card:not(.card-white) .card-header .card-title, .white-content .card:not(.card-white) .card-body .card-title {
  color: #1d253b;
}
.white-content .card:not(.card-white) .card-body .card-category, .white-content .card:not(.card-white) .card-body .card-description {
  color: #1d253b;
}
.white-content .card:not(.card-white) label:not(.btn) {
  color: #011e31;
}
.white-content .card:not(.card-white).nav-pills .nav-item .nav-link {
  color: #444444;
  background-color: hsla(0, 0%, 87%, 0.3);
}
.white-content .card:not(.card-white).nav-pills .nav-item .nav-link:not(.active):hover {
  background: hsla(0, 0%, 87%, 0.5);
}
.white-content .card:not(.card-white).nav-pills .nav-item .nav-link.active {
  color: #ffffff;
}
.white-content .card:not(.card-white) .tab-content .tab-pane {
  color: #444444;
}
.white-content .card:not(.card-white) .card {
  box-shadow: none;
}
.white-content .card:not(.card-white).card-plain {
  background: transparent;
  box-shadow: none;
}
.white-content .card:not(.card-white).card-tasks .card-body i {
  color: rgba(34, 42, 66, 0.7);
}
.white-content .card:not(.card-white).card-tasks .card-body i:hover {
  color: #000000;
}
.white-content .table > tbody > tr > td {
  color: rgba(0, 0, 0, 0.7) !important;
}
.white-content .table > thead > tr > th,
.white-content .table > tbody > tr > th,
.white-content .table > tfoot > tr > th,
.white-content .table > thead > tr > td,
.white-content .table > tbody > tr > td,
.white-content .table > tfoot > tr > td {
  border-color: rgba(0, 0, 0, 0.2);
  padding: 12px 7px;
  vertical-align: middle;
}
.white-content .table > thead > tr > th, .white-content .table button.btn-neutral.btn-link {
  color: rgba(0, 0, 0, 0.7);
}
.white-content .footer ul li a {
  color: #1d253b;
}
.white-content .footer .copyright {
  color: #1d253b;
}
.white-content .progress-container .progress, .white-content .progress-container.progress.sm .progress {
  background: rgba(0, 0, 0, 0.1);
  box-shadow: 0 0 0 3px rgba(0, 0, 0, 0.1);
}
.white-content .progress-container .progress .progress-value, .white-content .progress-container.progress.sm .progress .progress-value {
  color: #011e31;
}
.white-content .progress-container .progress-badge, .white-content .progress-container.progress.sm .progress-badge {
  color: #1d253b;
}
.white-content .full-page {
  background: #f5f6fa;
}
.white-content .full-page h1, .white-content .full-page .h1, .white-content .full-page h2, .white-content .full-page .h2, .white-content .full-page h3, .white-content .full-page .h3, .white-content .full-page h4, .white-content .full-page .h4, .white-content .full-page h5, .white-content .full-page .h5, .white-content .full-page h6, .white-content .full-page .h6, .white-content .full-page p, .white-content .full-page ol li, .white-content .full-page ul li, .white-content .full-page pre {
  color: #1d253b;
}
.white-content .full-page .description {
  color: #AAAAAA;
}
.white-content .full-page .footer ul li a {
  color: #1d253b;
}
.white-content .full-page .footer .copyright {
  color: #1d253b;
}
.white-content .nav-pills .nav-item .nav-link:not(.active) {
  background: #d3d7e9;
  color: #1d253b;
}
.white-content .nav-pills .nav-item .nav-link:not(.active):hover {
  background: #cccccc;
}

.card {
  background: #27293d;
  border: 0;
  position: relative;
  margin-bottom: 30px;
  box-shadow: 0 1px 20px 0px rgba(0, 0, 0, 0.1);
}
.card label {
  color: rgba(255, 255, 255, 0.6);
}
.card .card-title {
  margin-bottom: 0.75rem;
}
.card .card-body {
  padding: 15px;
}
.card .card-body.table-full-width {
  padding-left: 0;
  padding-right: 0;
}
.card .card-body .card-title {
  color: #ffffff;
  text-transform: inherit;
  font-weight: 300;
  margin-bottom: 0.75rem;
}
.card .card-body .card-description, .card .card-body .card-category {
  color: rgba(255, 255, 255, 0.6);
}
.card .card-header {
  padding: 15px 15px 0;
  border: 0;
  color: rgba(255, 255, 255, 0.8);
}
.card .card-header:not([data-background-color]) {
  background-color: transparent;
}
.card .card-header .card-title {
  color: #ffffff;
  font-weight: 100;
}
.card .card-header .card-category {
  color: #AAAAAA;
  margin-bottom: 5px;
  font-weight: 300;
}
.card .map {
  border-radius: 0.2857rem;
}
.card .map.map-big {
  height: 420px;
}
.card.card-white {
  background: #ffffff;
}
.card.card-white .card-title {
  color: #000000;
}
.card.card-white .card-category, .card.card-white .stats {
  color: #808080;
}
.card.card-white .form-control::-moz-placeholder {
  color: rgba(0, 0, 0, 0.4);
  opacity: 1;
  filter: alpha(opacity=100);
}
.card.card-white .form-control:-moz-placeholder {
  color: rgba(0, 0, 0, 0.4);
  opacity: 1;
  filter: alpha(opacity=100);
}
.card.card-white .form-control::-webkit-input-placeholder {
  color: rgba(0, 0, 0, 0.4);
  opacity: 1;
  filter: alpha(opacity=100);
}
.card.card-white .form-control:-ms-input-placeholder {
  color: rgba(0, 0, 0, 0.4);
  opacity: 1;
  filter: alpha(opacity=100);
}
.card.card-white .has-danger .form-control, .card.card-white .has-danger .input-group-prepend .input-group-text {
  border-color: #ec250d;
}
.card.card-white .input-group-prepend .input-group-text {
  border-color: rgba(29, 37, 59, 0.2);
  color: #1d253b;
}
.card.card-white .form-control {
  color: #000000;
  border-color: rgba(29, 37, 59, 0.2);
}
.card.card-white .form-control:focus {
  border-color: #68869a;
}
.card.card-white label:not(.btn) {
  color: #011e31;
}
.card.card-white .form-group.no-border .form-control,
.card.card-white .form-group.no-border .form-control + .input-group-prepend .input-group-text,
.card.card-white .form-group.no-border .form-control + .input-group-append .input-group-text,
.card.card-white .form-group.no-border .input-group-prepend .input-group-text,
.card.card-white .form-group.no-border .input-group-append .input-group-text,
.card.card-white .input-group.no-border .form-control,
.card.card-white .input-group.no-border .form-control + .input-group-prepend .input-group-text,
.card.card-white .input-group.no-border .form-control + .input-group-append .input-group-text,
.card.card-white .input-group.no-border .input-group-prepend .input-group-text,
.card.card-white .input-group.no-border .input-group-append .input-group-text {
  background-color: rgba(222, 222, 222, 0.3);
}
.card.card-white .form-group.no-border .form-control:focus, .card.card-white .form-group.no-border .form-control:active, .card.card-white .form-group.no-border .form-control:active,
.card.card-white .form-group.no-border .form-control + .input-group-prepend .input-group-text:focus,
.card.card-white .form-group.no-border .form-control + .input-group-prepend .input-group-text:active,
.card.card-white .form-group.no-border .form-control + .input-group-prepend .input-group-text:active,
.card.card-white .form-group.no-border .form-control + .input-group-append .input-group-text:focus,
.card.card-white .form-group.no-border .form-control + .input-group-append .input-group-text:active,
.card.card-white .form-group.no-border .form-control + .input-group-append .input-group-text:active,
.card.card-white .form-group.no-border .input-group-prepend .input-group-text:focus,
.card.card-white .form-group.no-border .input-group-prepend .input-group-text:active,
.card.card-white .form-group.no-border .input-group-prepend .input-group-text:active,
.card.card-white .form-group.no-border .input-group-append .input-group-text:focus,
.card.card-white .form-group.no-border .input-group-append .input-group-text:active,
.card.card-white .form-group.no-border .input-group-append .input-group-text:active,
.card.card-white .input-group.no-border .form-control:focus,
.card.card-white .input-group.no-border .form-control:active,
.card.card-white .input-group.no-border .form-control:active,
.card.card-white .input-group.no-border .form-control + .input-group-prepend .input-group-text:focus,
.card.card-white .input-group.no-border .form-control + .input-group-prepend .input-group-text:active,
.card.card-white .input-group.no-border .form-control + .input-group-prepend .input-group-text:active,
.card.card-white .input-group.no-border .form-control + .input-group-append .input-group-text:focus,
.card.card-white .input-group.no-border .form-control + .input-group-append .input-group-text:active,
.card.card-white .input-group.no-border .form-control + .input-group-append .input-group-text:active,
.card.card-white .input-group.no-border .input-group-prepend .input-group-text:focus,
.card.card-white .input-group.no-border .input-group-prepend .input-group-text:active,
.card.card-white .input-group.no-border .input-group-prepend .input-group-text:active,
.card.card-white .input-group.no-border .input-group-append .input-group-text:focus,
.card.card-white .input-group.no-border .input-group-append .input-group-text:active,
.card.card-white .input-group.no-border .input-group-append .input-group-text:active {
  background-color: rgba(222, 222, 222, 0.5);
}
.card.card-white .form-group.no-border .form-control:focus + .input-group-prepend .input-group-text, .card.card-white .form-group.no-border .form-control:focus + .input-group-append .input-group-text,
.card.card-white .input-group.no-border .form-control:focus + .input-group-prepend .input-group-text,
.card.card-white .input-group.no-border .form-control:focus + .input-group-append .input-group-text {
  background-color: transparent;
}
.card.card-white .input-group[disabled] .input-group-prepend .input-group-text,
.card.card-white .input-group[disabled] .input-group-append .input-group-text {
  background-color: #000000;
}
.card.card-white .form-control[disabled], .card.card-white .form-control[readonly], .card.card-white fieldset[disabled] .form-control {
  background: #E3E3E3;
  border-color: rgba(29, 37, 59, 0.3);
}
.card.card-white .input-group-focus .input-group-prepend .input-group-text,
.card.card-white .input-group-focus .input-group-append .input-group-text,
.card.card-white .input-group-focus .form-control {
  background-color: #ffffff;
  border-color: #68869a;
}
.card.card-white .input-group-focus.no-border .input-group-prepend .input-group-text,
.card.card-white .input-group-focus.no-border .input-group-append .input-group-text {
  background-color: rgba(222, 222, 222, 0.5);
}
.card.card-white .input-group-prepend .input-group-text {
  border-right: none;
}
.card.card-white .input-group-append .input-group-text {
  border-left: none;
}
.card.card-white .has-danger .form-control:focus, .card.card-white .has-success.input-group-focus .input-group-append .input-group-text, .card.card-white .has-success.input-group-focus .input-group-prepend .input-group-text {
  border-color: #ec250d;
}
.card.card-white .has-success .form-control:focus, .card.card-white .has-success.input-group-focus .input-group-append .input-group-text, .card.card-white .has-success.input-group-focus .input-group-prepend .input-group-text {
  border-color: #536c7c;
}
.card.card-plain {
  background: transparent;
  box-shadow: none;
}
.card .image {
  overflow: hidden;
  height: 200px;
  position: relative;
}
.card .avatar {
  width: 30px;
  height: 30px;
  overflow: hidden;
  border-radius: 50%;
  margin-bottom: 15px;
}
.card label {
  font-size: 0.7500000025rem;
  margin-bottom: 5px;
}
.card .card-footer {
  background-color: transparent;
  border: 0;
  padding: 15px;
}
.card .card-footer .stats i {
  margin-right: 5px;
  position: relative;
}
.card .card-footer h6, .card .card-footer .h6 {
  margin-bottom: 0;
  padding: 7px 0;
}

.card-body {
  padding: 1.25rem;
}

@media (max-width: 575.98px) {
  .card.card-chart .card-header .btn-group-toggle .tim-icons {
    font-size: 0.875rem;
    top: -1px;
  }
}
.card-chart {
  overflow: hidden;
}
.card-chart .card-header .card-title i {
  font-size: 16px;
  margin-right: 5px;
  margin-bottom: 3px;
}
.card-chart .card-header .card-category {
  margin-bottom: 5px;
}
.card-chart .card-body {
  padding-left: 5px;
  padding-right: 5px;
}
.card-chart .card-body .tab-space {
  padding: 0;
}
.card-chart .table {
  margin-bottom: 0;
}
.card-chart .table td {
  border-top: none;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}
.card-chart .card-progress {
  margin-top: 30px;
  padding: 0 10px;
}
.card-chart .chart-area {
  height: 220px;
  width: 100%;
}
.card-chart .card-footer {
  margin-top: 15px;
}
.card-chart .card-footer .stats {
  color: #AAAAAA;
}
.card-chart .dropdown {
  position: absolute;
  right: 20px;
  top: 20px;
}
.card-chart .dropdown .btn {
  margin: 0;
}
.card-chart.card-chart-pie .chart-area {
  padding: 10px 0 25px;
  height: auto;
}
.card-chart.card-chart-pie .card-title {
  margin-bottom: 10px;
}
.card-chart.card-chart-pie .card-title i {
  font-size: 1rem;
}

.map {
  height: 500px;
}

.card-user {
  overflow: hidden;
}
.card-user .image {
  height: 120px;
}
.card-user .author {
  text-align: center;
  text-transform: none;
  margin-top: 25px;
}
.card-user .author a + p.description {
  margin-top: -7px;
}
.card-user .author .block {
  position: absolute;
  height: 100px;
  width: 250px;
}
.card-user .author .block.block-one {
  background: rgba(104, 134, 154, 0.6);
  background: linear-gradient(to right, rgba(104, 134, 154, 0.6) 0%, rgba(104, 134, 154, 0) 100%);
  filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=10);
  transform: rotate(150deg);
  margin-top: -90px;
  margin-left: -50px;
}
.card-user .author .block.block-two {
  background: rgba(104, 134, 154, 0.6);
  background: linear-gradient(to right, rgba(104, 134, 154, 0.6) 0%, rgba(104, 134, 154, 0) 100%);
  filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=10);
  transform: rotate(30deg);
  margin-top: -40px;
  margin-left: -100px;
}
.card-user .author .block.block-three {
  background: rgba(104, 134, 154, 0.6);
  background: linear-gradient(to right, rgba(104, 134, 154, 0.6) 0%, rgba(104, 134, 154, 0) 100%);
  filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=10);
  transform: rotate(170deg);
  margin-top: -70px;
  right: -45px;
}
.card-user .author .block.block-four {
  background: rgba(104, 134, 154, 0.6);
  background: linear-gradient(to right, rgba(104, 134, 154, 0.6) 0%, rgba(104, 134, 154, 0) 100%);
  filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=10);
  transform: rotate(150deg);
  margin-top: -25px;
  right: -45px;
}
.card-user .avatar {
  width: 124px;
  height: 124px;
  border: 5px solid #0f5077;
  border-bottom-color: transparent;
  background-color: transparent;
  position: relative;
}
.card-user .card-body {
  min-height: 240px;
}
.card-user hr {
  margin: 5px 15px;
}
.card-user .button-container {
  margin-bottom: 6px;
  text-align: center;
}
.card-user .card-description {
  margin-top: 30px;
}

.card-tasks {
  height: 473px;
}
.card-tasks .table-full-width {
  max-height: 380px;
  position: relative;
}
.card-tasks .card-header .title {
  margin-right: 20px;
  font-weight: 400;
}
.card-tasks .card-header .dropdown {
  float: right;
  color: #cccccc;
}
.card-tasks .card-body i {
  color: #AAAAAA;
  font-size: 1.4em;
}
.card-tasks .card-body i:hover {
  color: #ffffff;
}

.card-plain {
  background: transparent;
  box-shadow: none;
}
.card-plain .card-header,
.card-plain .card-footer {
  margin-left: 0;
  margin-right: 0;
  background-color: transparent;
}
.card-plain:not(.card-subcategories).card-body {
  padding-left: 0;
  padding-right: 0;
}

select.form-control option {
  color: #888;
}`, "",{"version":3,"sources":["webpack://./src/assets/scss/black-dashboard-react.scss","webpack://./src/assets/scss/black-dashboard-react/custom/_variables.scss","webpack://./node_modules/bootstrap/scss/_root.scss","webpack://./node_modules/bootstrap/scss/_reboot.scss","webpack://./node_modules/bootstrap/scss/vendor/_rfs.scss","webpack://./node_modules/bootstrap/scss/_variables.scss","webpack://./node_modules/bootstrap/scss/mixins/_border-radius.scss","webpack://./node_modules/bootstrap/scss/_type.scss","webpack://./node_modules/bootstrap/scss/mixins/_lists.scss","webpack://./node_modules/bootstrap/scss/_images.scss","webpack://./node_modules/bootstrap/scss/mixins/_image.scss","webpack://./node_modules/bootstrap/scss/mixins/_box-shadow.scss","webpack://./node_modules/bootstrap/scss/_grid.scss","webpack://./node_modules/bootstrap/scss/mixins/_grid.scss","webpack://./node_modules/bootstrap/scss/mixins/_breakpoints.scss","webpack://./node_modules/bootstrap/scss/_tables.scss","webpack://./node_modules/bootstrap/scss/mixins/_table-variants.scss","webpack://./node_modules/bootstrap/scss/forms/_labels.scss","webpack://./node_modules/bootstrap/scss/forms/_form-text.scss","webpack://./node_modules/bootstrap/scss/forms/_form-control.scss","webpack://./node_modules/bootstrap/scss/mixins/_transition.scss","webpack://./node_modules/bootstrap/scss/mixins/_gradients.scss","webpack://./node_modules/bootstrap/scss/forms/_form-select.scss","webpack://./node_modules/bootstrap/scss/forms/_form-check.scss","webpack://./node_modules/bootstrap/scss/forms/_form-range.scss","webpack://./node_modules/bootstrap/scss/forms/_floating-labels.scss","webpack://./node_modules/bootstrap/scss/forms/_input-group.scss","webpack://./node_modules/bootstrap/scss/mixins/_forms.scss","webpack://./node_modules/bootstrap/scss/_buttons.scss","webpack://./node_modules/bootstrap/scss/mixins/_buttons.scss","webpack://./node_modules/bootstrap/scss/_transitions.scss","webpack://./node_modules/bootstrap/scss/_dropdown.scss","webpack://./node_modules/bootstrap/scss/mixins/_caret.scss","webpack://./node_modules/bootstrap/scss/_button-group.scss","webpack://./node_modules/bootstrap/scss/_nav.scss","webpack://./node_modules/bootstrap/scss/_navbar.scss","webpack://./node_modules/bootstrap/scss/_card.scss","webpack://./node_modules/bootstrap/scss/_breadcrumb.scss","webpack://./node_modules/bootstrap/scss/_pagination.scss","webpack://./node_modules/bootstrap/scss/mixins/_pagination.scss","webpack://./node_modules/bootstrap/scss/_badge.scss","webpack://./node_modules/bootstrap/scss/_alert.scss","webpack://./node_modules/bootstrap/scss/mixins/_alert.scss","webpack://./node_modules/bootstrap/scss/_progress.scss","webpack://./node_modules/bootstrap/scss/_list-group.scss","webpack://./node_modules/bootstrap/scss/mixins/_list-group.scss","webpack://./node_modules/bootstrap/scss/_close.scss","webpack://./node_modules/bootstrap/scss/_tooltip.scss","webpack://./node_modules/bootstrap/scss/mixins/_reset-text.scss","webpack://./node_modules/bootstrap/scss/_popover.scss","webpack://./node_modules/bootstrap/scss/_carousel.scss","webpack://./node_modules/bootstrap/scss/mixins/_clearfix.scss","webpack://./node_modules/bootstrap/scss/bootstrap-utilities.scss","webpack://./node_modules/bootstrap/scss/helpers/_colored-links.scss","webpack://./node_modules/bootstrap/scss/helpers/_ratio.scss","webpack://./node_modules/bootstrap/scss/helpers/_position.scss","webpack://./node_modules/bootstrap/scss/helpers/_visually-hidden.scss","webpack://./node_modules/bootstrap/scss/mixins/_visually-hidden.scss","webpack://./node_modules/bootstrap/scss/helpers/_stretched-link.scss","webpack://./node_modules/bootstrap/scss/helpers/_text-truncation.scss","webpack://./node_modules/bootstrap/scss/mixins/_text-truncate.scss","webpack://./node_modules/bootstrap/scss/mixins/_utilities.scss","webpack://./node_modules/bootstrap/scss/utilities/_api.scss","webpack://./src/assets/scss/black-dashboard-react/custom/_alerts.scss","webpack://./src/assets/scss/black-dashboard-react/custom/_badges.scss","webpack://./src/assets/scss/black-dashboard-react/custom/_buttons.scss","webpack://./src/assets/scss/black-dashboard-react/custom/mixins/_vendor-prefixes.scss","webpack://./src/assets/scss/black-dashboard-react/custom/mixins/_buttons.scss","webpack://./src/assets/scss/black-dashboard-react/custom/mixins/opacity.scss","webpack://./src/assets/scss/black-dashboard-react/custom/_dropdown.scss","webpack://./src/assets/scss/black-dashboard-react/custom/mixins/_dropdown.scss","webpack://./src/assets/scss/black-dashboard-react/custom/_footer.scss","webpack://./src/assets/scss/black-dashboard-react/custom/_forms.scss","webpack://./src/assets/scss/black-dashboard-react/custom/mixins/_inputs.scss","webpack://./src/assets/scss/black-dashboard-react/custom/_images.scss","webpack://./src/assets/scss/black-dashboard-react/custom/_modal.scss","webpack://./src/assets/scss/black-dashboard-react/custom/mixins/_modals.scss","webpack://./src/assets/scss/black-dashboard-react/custom/_navbar.scss","webpack://./src/assets/scss/black-dashboard-react/custom/_type.scss","webpack://./src/assets/scss/black-dashboard-react/custom/_tables.scss","webpack://./src/assets/scss/black-dashboard-react/custom/_checkboxes-radio.scss","webpack://./src/assets/scss/black-dashboard-react/custom/_fixed-plugin.scss","webpack://./src/assets/scss/black-dashboard-react/custom/_sidebar-and-main-panel.scss","webpack://./src/assets/scss/black-dashboard-react/custom/_misc.scss","webpack://./src/assets/scss/black-dashboard-react/custom/_rtl.scss","webpack://./src/assets/scss/black-dashboard-react/custom/_input-group.scss","webpack://./src/assets/scss/black-dashboard-react/custom/vendor/_plugin-perfect-scrollbar.scss","webpack://./src/assets/scss/black-dashboard-react/custom/vendor/_plugin-react-notification-alert.scss","webpack://./src/assets/scss/black-dashboard-react/custom/_white-content.scss","webpack://./src/assets/scss/black-dashboard-react/custom/_card.scss","webpack://./src/assets/scss/black-dashboard-react/custom/cards/_card-chart.scss","webpack://./src/assets/scss/black-dashboard-react/custom/cards/_card-map.scss","webpack://./src/assets/scss/black-dashboard-react/custom/cards/_card-user.scss","webpack://./src/assets/scss/black-dashboard-react/custom/cards/_card-task.scss","webpack://./src/assets/scss/black-dashboard-react/custom/cards/_card-plain.scss","webpack://./src/assets/scss/black-dashboard-react/react-differences/_inputs.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;;;;;;;;;;;;;;;EAAA;AC4IA;;;;;;;CAAA;AAiBA;;;;;;;;kCAAA;AAqHA,kCAAA;AA4hBA,iBAAA;AC9yBA;EAGI,kBAAA;EAAA,oBAAA;EAAA,oBAAA;EAAA,kBAAA;EAAA,iBAAA;EAAA,oBAAA;EAAA,oBAAA;EAAA,mBAAA;EAAA,kBAAA;EAAA,kBAAA;EAAA,mBAAA;EAAA,kBAAA;EAAA,mBAAA;EAAA,qBAAA;EAAA,uBAAA;EAAA,mBAAA;EAAA,4BAAA;EAAA,yBAAA;EAAA,uBAAA;EAAA,8BAAA;EAAA,2BAAA;EAAA,8BAAA;EAAA,uBAAA;EAAA,2BAAA;EAAA,mBAAA;EAAA,4BAAA;EAAA,mBAAA;EAAA,yBAAA;EAAA,8BAAA;EAAA,wBAAA;EAAA,uBAAA;EAAA,4BAAA;EAAA,2BAAA;EAAA,mBAAA;EAAA,uBAAA;EAAA,qBAAA;EAIA,qBAAA;EAAA,qBAAA;EAAA,uBAAA;EAAA,qBAAA;EAAA,kBAAA;EAAA,qBAAA;EAAA,oBAAA;EAAA,mBAAA;EAAA,qBAAA;EAAA,kBAAA;EAAA,kBAAA;EAKF,qNAAA;EACA,yGAAA;EACA,yFAAA;AFyEF;;AGxEA;;;EAGE,sBAAA;AH2EF;;AG9DI;EAJJ;IAKM,uBAAA;EHkEJ;AACF;;AGtDA;EACE,SAAA;EACA,kCFoZ4B;EG9JxB,mBALI;ED/OR,gBFqa4B;EEpa5B,gBEqY4B;EFpY5B,cF9BS;EEgCT,yBF8H2B;EE7H3B,8BAAA;EACA,6CAAA;AHwDF;;AG/CA;EACE,cAAA;EACA,cEqb4B;EFpb5B,8BAAA;EACA,SAAA;EACA,aEob4B;ALlY9B;;AG/CA;EACE,iBF2U4B;ADzR9B;;AGxCA;EACE,aAAA;EACA,qBF0Y4B;EEzY5B,oBF0Y4B;EExY5B,gBF8X4B;EE7X5B,gBFyY4B;EExY5B,cFpES;AD8GX;;AGvCA;EC4MQ,iDAAA;AJjKR;AIDI;ED1CJ;ICmNQ,0BAAA;EJpKN;AACF;;AG3CA;ECuMQ,+CAAA;AJxJR;AIVI;EDrCJ;IC8MQ,yBAAA;EJ3JN;AACF;;AG/CA;ECkMQ,+CAAA;AJ/IR;AInBI;EDhCJ;ICyMQ,yBAAA;EJlJN;AACF;;AGnDA;ECyLM,0BALI;AJ7HV;;AGlDA;ECoLM,yBALI;AJzHV;;AGjDA;EC+KM,wBALI;AJrHV;;AG1CA;EACE,aAAA;EACA,mBEyK0B;AL5H5B;;AGlCA;;EAEE,yCAAA;UAAA,iCAAA;EACA,YAAA;EACA,sCAAA;UAAA,8BAAA;AHqCF;;AG/BA;EACE,mBAAA;EACA,kBAAA;EACA,oBAAA;AHkCF;;AG5BA;;EAEE,kBAAA;AH+BF;;AG5BA;;;EAGE,aAAA;EACA,mBAAA;AH+BF;;AG5BA;;;;EAIE,gBAAA;AH+BF;;AG5BA;EACE,gBFkS4B;ADnQ9B;;AG1BA;EACE,qBAAA;EACA,cAAA;AH6BF;;AGvBA;EACE,gBAAA;AH0BF;;AGlBA;;EAEE,mBEsO4B;ALjN9B;;AGbA;ECgFM,cALI;AJ1DV;;AGVA;EACE,cFmT4B;EElT5B,yBFwT4B;AD3S9B;;AGJA;;EAEE,kBAAA;EC4DI,iBALI;EDrDR,cAAA;EACA,wBAAA;AHOF;;AGJA;EAAM,eAAA;AHQN;;AGPA;EAAM,WAAA;AHWN;;AGNA;EACE,cFhGc;EEiGd,qBFgF0B;ADvE5B;AGPE;EACE,cF8EwB;EE7ExB,qBF8EwB;ADrE5B;;AGCE;EAEE,cAAA;EACA,qBAAA;AHCJ;;AGMA;;;;EAIE,iGEmJ4B;EFnJ5B,qCEmJ4B;EDjIxB,cALI;EDXR,+BAAA;EACA,2BAAA;AHHF;;AGUA;EACE,cAAA;EACA,aAAA;EACA,mBAAA;EACA,cAAA;ECII,cALI;AJLV;AGWE;ECDI,kBALI;EDQN,cAAA;EACA,kBAAA;AHTJ;;AGaA;ECRM,cALI;EDeR,cFjQQ;EEkQR,qBAAA;AHVF;AGaE;EACE,cAAA;AHXJ;;AGeA;EACE,sBAAA;ECpBI,cALI;ED2BR,cF7SS;EE8ST,yBFrSS;EKJP,wBAAA;AN8RJ;AGcE;EACE,UAAA;EC3BE,cALI;EDkCN,gBFqJ0B;ADjK9B;;AGqBA;EACE,gBAAA;AHlBF;;AGwBA;;EAEE,sBAAA;AHrBF;;AG6BA;EACE,oBAAA;EACA,yBAAA;AH1BF;;AG6BA;EACE,mBE8K4B;EF7K5B,sBE6K4B;EF5K5B,cFhVS;EEiVT,gBAAA;AH1BF;;AGiCA;EAEE,mBAAA;EACA,gCAAA;AH/BF;;AGkCA;;;;;;EAME,qBAAA;EACA,mBAAA;EACA,eAAA;AH/BF;;AGuCA;EACE,qBAAA;AHpCF;;AG0CA;EAEE,gBAAA;AHxCF;;AGgDA;EACE,UAAA;AH7CF;;AGkDA;;;;;EAKE,SAAA;EACA,oBAAA;EC1HI,kBALI;EDiIR,oBAAA;AH/CF;;AGmDA;;EAEE,oBAAA;AHhDF;;AGqDA;EACE,eAAA;AHlDF;;AGqDA;EAGE,iBAAA;AHpDF;AGuDE;EACE,UAAA;AHrDJ;;AG4DA;EACE,aAAA;AHzDF;;AGiEA;;;;EAIE,0BAAA;AH9DF;AGiEI;;;;EACE,eAAA;AH5DN;;AGmEA;EACE,UAAA;EACA,kBAAA;AHhEF;;AGqEA;EACE,gBAAA;AHlEF;;AG4EA;EACE,YAAA;EACA,UAAA;EACA,SAAA;EACA,SAAA;AHzEF;;AGiFA;EACE,WAAA;EACA,WAAA;EACA,UAAA;EACA,qBEG4B;EDlNtB,iCAAA;EDkNN,oBAAA;AH/EF;AIrSI;ED6WJ;ICpMQ,iBAAA;EJgIN;AACF;AG4EE;EACE,WAAA;AH1EJ;;AGiFA;;;;;;;EAOE,UAAA;AH9EF;;AGiFA;EACE,YAAA;AH9EF;;AGuFA;EACE,oBAAA;EACA,6BAAA;AHpFF;;AG4FA;;;;;;;CAAA;AAWA;EACE,wBAAA;AH5FF;;AGiGA;EACE,UAAA;AH9FF;;AGoGA;EACE,aAAA;AHjGF;;AGuGA;EACE,aAAA;EACA,0BAAA;AHpGF;;AGyGA;EACE,qBAAA;AHtGF;;AG2GA;EACE,SAAA;AHxGF;;AG+GA;EACE,kBAAA;EACA,eAAA;AH5GF;;AGoHA;EACE,wBAAA;AHjHF;;AGyHA;EACE,wBAAA;AHtHF;;AOzdA;EHyQM,qBALI;EGlQR,gBNse4B;ADV9B;;AOvdE;EHsQM,iCAAA;EGpQJ,gBF4bkB;EE3blB,gBN4b0B;AD8B9B;AIzXI;EGpGF;IH6QM,eAAA;EJoNN;AACF;;AOleE;EHsQM,iCAAA;EGpQJ,gBF4bkB;EE3blB,gBN4b0B;ADyC9B;AIpYI;EGpGF;IH6QM,iBAAA;EJ+NN;AACF;;AO7eE;EHsQM,iCAAA;EGpQJ,gBF4bkB;EE3blB,gBN4b0B;ADoD9B;AI/YI;EGpGF;IH6QM,eAAA;EJ0ON;AACF;;AOxfE;EHsQM,iCAAA;EGpQJ,gBF4bkB;EE3blB,gBN4b0B;AD+D9B;AI1ZI;EGpGF;IH6QM,iBAAA;EJqPN;AACF;;AOngBE;EHsQM,iCAAA;EGpQJ,gBF4bkB;EE3blB,gBN4b0B;AD0E9B;AIraI;EGpGF;IH6QM,eAAA;EJgQN;AACF;;AO9gBE;EHsQM,iCAAA;EGpQJ,gBF4bkB;EE3blB,gBN4b0B;ADqF9B;AIhbI;EGpGF;IH6QM,iBAAA;EJ2QN;AACF;;AOngBA;ECrDE,eAAA;EACA,gBAAA;AR4jBF;;AOngBA;EC1DE,eAAA;EACA,gBAAA;ARikBF;;AOrgBA;EACE,qBAAA;APwgBF;AOtgBE;EACE,oBN+c0B;ADyD9B;;AO9fA;EHsNM,cALI;EG/MR,yBAAA;APigBF;;AO7fA;EACE,mBN0QO;EG3DH,oBALI;AJuTV;AO9fE;EACE,gBAAA;APggBJ;;AO5fA;EACE,iBAAA;EACA,mBNgQO;EG3DH,cALI;EG9LR,cN9ES;AD6kBX;AO7fE;EACE,aAAA;AP+fJ;;AS7lBA;ECIE,eAAA;EAGA,YAAA;AV2lBF;;AS5lBA;EACE,gBJ2yCkC;EI1yClC,yBRoK2B;EQnK3B,+BAAA;EHGE,sBAAA;EKLE,mDARW;EDKf,eAAA;EAGA,YAAA;AVqmBF;;ASvlBA;EAEE,qBAAA;ATylBF;;AStlBA;EACE,qBAAA;EACA,cAAA;ATylBF;;AStlBA;EL+PM,cALI;EKxPR,cRpBS;AD6mBX;;AY5nBE;ECAA,qBAAA;EACA,gBAAA;EACA,aAAA;EACA,eAAA;EACA,yCAAA;EACA,6CAAA;EACA,4CAAA;AbgoBF;AYnoBI;ECYF,cAAA;EACA,WAAA;EACA,eAAA;EACA,6CAAA;EACA,4CAAA;EACA,8BAAA;Ab0nBF;;Aa3kBM;EACE,SAAA;Ab8kBR;;Aa3kBM;EApCJ,cAAA;EACA,WAAA;AbmnBF;;AarmBE;EACE,cAAA;EACA,WAAA;AbwmBJ;;Aa1mBE;EACE,cAAA;EACA,UAAA;Ab6mBJ;;Aa/mBE;EACE,cAAA;EACA,qBAAA;AbknBJ;;AapnBE;EACE,cAAA;EACA,UAAA;AbunBJ;;AaznBE;EACE,cAAA;EACA,UAAA;Ab4nBJ;;Aa9nBE;EACE,cAAA;EACA,qBAAA;AbioBJ;;Ac3nBI;EDSE;IACE,SAAA;EbsnBN;EannBI;IApCJ,cAAA;IACA,WAAA;Eb0pBA;Ea5oBA;IACE,cAAA;IACA,WAAA;Eb8oBF;EahpBA;IACE,cAAA;IACA,UAAA;EbkpBF;EappBA;IACE,cAAA;IACA,qBAAA;EbspBF;EaxpBA;IACE,cAAA;IACA,UAAA;Eb0pBF;Ea5pBA;IACE,cAAA;IACA,UAAA;Eb8pBF;EahqBA;IACE,cAAA;IACA,qBAAA;EbkqBF;AACF;Ac7pBI;EDSE;IACE,SAAA;EbupBN;EappBI;IApCJ,cAAA;IACA,WAAA;Eb2rBA;Ea7qBA;IACE,cAAA;IACA,WAAA;Eb+qBF;EajrBA;IACE,cAAA;IACA,UAAA;EbmrBF;EarrBA;IACE,cAAA;IACA,qBAAA;EburBF;EazrBA;IACE,cAAA;IACA,UAAA;Eb2rBF;Ea7rBA;IACE,cAAA;IACA,UAAA;Eb+rBF;EajsBA;IACE,cAAA;IACA,qBAAA;EbmsBF;AACF;Ac9rBI;EDSE;IACE,SAAA;EbwrBN;EarrBI;IApCJ,cAAA;IACA,WAAA;Eb4tBA;Ea9sBA;IACE,cAAA;IACA,WAAA;EbgtBF;EaltBA;IACE,cAAA;IACA,UAAA;EbotBF;EattBA;IACE,cAAA;IACA,qBAAA;EbwtBF;Ea1tBA;IACE,cAAA;IACA,UAAA;Eb4tBF;Ea9tBA;IACE,cAAA;IACA,UAAA;EbguBF;EaluBA;IACE,cAAA;IACA,qBAAA;EbouBF;AACF;Ac/tBI;EDSE;IACE,SAAA;EbytBN;EattBI;IApCJ,cAAA;IACA,WAAA;Eb6vBA;Ea/uBA;IACE,cAAA;IACA,WAAA;EbivBF;EanvBA;IACE,cAAA;IACA,UAAA;EbqvBF;EavvBA;IACE,cAAA;IACA,qBAAA;EbyvBF;Ea3vBA;IACE,cAAA;IACA,UAAA;Eb6vBF;Ea/vBA;IACE,cAAA;IACA,UAAA;EbiwBF;EanwBA;IACE,cAAA;IACA,qBAAA;EbqwBF;AACF;AajuBM;EAtDJ,cAAA;EACA,WAAA;Ab0xBF;;Aa/tBU;EAtEN,cAAA;EACA,kBAAA;AbyyBJ;;AapuBU;EAtEN,cAAA;EACA,mBAAA;Ab8yBJ;;AazuBU;EAtEN,cAAA;EACA,UAAA;AbmzBJ;;Aa9uBU;EAtEN,cAAA;EACA,mBAAA;AbwzBJ;;AanvBU;EAtEN,cAAA;EACA,mBAAA;Ab6zBJ;;AaxvBU;EAtEN,cAAA;EACA,UAAA;Abk0BJ;;Aa7vBU;EAtEN,cAAA;EACA,mBAAA;Abu0BJ;;AalwBU;EAtEN,cAAA;EACA,mBAAA;Ab40BJ;;AavwBU;EAtEN,cAAA;EACA,UAAA;Abi1BJ;;Aa5wBU;EAtEN,cAAA;EACA,mBAAA;Abs1BJ;;AajxBU;EAtEN,cAAA;EACA,mBAAA;Ab21BJ;;AatxBU;EAtEN,cAAA;EACA,WAAA;Abg2BJ;;AanxBY;EA9DV,wBAAA;Abq1BF;;AavxBY;EA9DV,yBAAA;Aby1BF;;Aa3xBY;EA9DV,gBAAA;Ab61BF;;Aa/xBY;EA9DV,yBAAA;Abi2BF;;AanyBY;EA9DV,yBAAA;Abq2BF;;AavyBY;EA9DV,gBAAA;Aby2BF;;Aa3yBY;EA9DV,yBAAA;Ab62BF;;Aa/yBY;EA9DV,yBAAA;Abi3BF;;AanzBY;EA9DV,gBAAA;Abq3BF;;AavzBY;EA9DV,yBAAA;Aby3BF;;Aa3zBY;EA9DV,yBAAA;Ab63BF;;AapzBQ;;EAEE,gBAAA;AbuzBV;;AapzBQ;;EAEE,gBAAA;AbuzBV;;Aa9zBQ;;EAEE,sBAAA;Abi0BV;;Aa9zBQ;;EAEE,sBAAA;Abi0BV;;Aax0BQ;;EAEE,qBAAA;Ab20BV;;Aax0BQ;;EAEE,qBAAA;Ab20BV;;Aal1BQ;;EAEE,mBAAA;Abq1BV;;Aal1BQ;;EAEE,mBAAA;Abq1BV;;Aa51BQ;;EAEE,qBAAA;Ab+1BV;;Aa51BQ;;EAEE,qBAAA;Ab+1BV;;Aat2BQ;;EAEE,mBAAA;Aby2BV;;Aat2BQ;;EAEE,mBAAA;Aby2BV;;Aah3BQ;;EAEE,mBAAA;Abm3BV;;Aah3BQ;;EAEE,mBAAA;Abm3BV;;Aa13BQ;;EAEE,mBAAA;Ab63BV;;Aa13BQ;;EAEE,mBAAA;Ab63BV;;Aap4BQ;;EAEE,mBAAA;Abu4BV;;Aap4BQ;;EAEE,mBAAA;Abu4BV;;Aa94BQ;;EAEE,mBAAA;Abi5BV;;Aa94BQ;;EAEE,mBAAA;Abi5BV;;Ach9BI;ED+BE;IAtDJ,cAAA;IACA,WAAA;Eb4+BA;Eaj7BQ;IAtEN,cAAA;IACA,kBAAA;Eb0/BF;Ear7BQ;IAtEN,cAAA;IACA,mBAAA;Eb8/BF;Eaz7BQ;IAtEN,cAAA;IACA,UAAA;EbkgCF;Ea77BQ;IAtEN,cAAA;IACA,mBAAA;EbsgCF;Eaj8BQ;IAtEN,cAAA;IACA,mBAAA;Eb0gCF;Ear8BQ;IAtEN,cAAA;IACA,UAAA;Eb8gCF;Eaz8BQ;IAtEN,cAAA;IACA,mBAAA;EbkhCF;Ea78BQ;IAtEN,cAAA;IACA,mBAAA;EbshCF;Eaj9BQ;IAtEN,cAAA;IACA,UAAA;Eb0hCF;Ear9BQ;IAtEN,cAAA;IACA,mBAAA;Eb8hCF;Eaz9BQ;IAtEN,cAAA;IACA,mBAAA;EbkiCF;Ea79BQ;IAtEN,cAAA;IACA,WAAA;EbsiCF;Eaz9BU;IA9DV,cAAA;Eb0hCA;Ea59BU;IA9DV,wBAAA;Eb6hCA;Ea/9BU;IA9DV,yBAAA;EbgiCA;Eal+BU;IA9DV,gBAAA;EbmiCA;Ear+BU;IA9DV,yBAAA;EbsiCA;Eax+BU;IA9DV,yBAAA;EbyiCA;Ea3+BU;IA9DV,gBAAA;Eb4iCA;Ea9+BU;IA9DV,yBAAA;Eb+iCA;Eaj/BU;IA9DV,yBAAA;EbkjCA;Eap/BU;IA9DV,gBAAA;EbqjCA;Eav/BU;IA9DV,yBAAA;EbwjCA;Ea1/BU;IA9DV,yBAAA;Eb2jCA;Eal/BM;;IAEE,gBAAA;Ebo/BR;Eaj/BM;;IAEE,gBAAA;Ebm/BR;Ea1/BM;;IAEE,sBAAA;Eb4/BR;Eaz/BM;;IAEE,sBAAA;Eb2/BR;EalgCM;;IAEE,qBAAA;EbogCR;EajgCM;;IAEE,qBAAA;EbmgCR;Ea1gCM;;IAEE,mBAAA;Eb4gCR;EazgCM;;IAEE,mBAAA;Eb2gCR;EalhCM;;IAEE,qBAAA;EbohCR;EajhCM;;IAEE,qBAAA;EbmhCR;Ea1hCM;;IAEE,mBAAA;Eb4hCR;EazhCM;;IAEE,mBAAA;Eb2hCR;EaliCM;;IAEE,mBAAA;EboiCR;EajiCM;;IAEE,mBAAA;EbmiCR;Ea1iCM;;IAEE,mBAAA;Eb4iCR;EaziCM;;IAEE,mBAAA;Eb2iCR;EaljCM;;IAEE,mBAAA;EbojCR;EajjCM;;IAEE,mBAAA;EbmjCR;Ea1jCM;;IAEE,mBAAA;Eb4jCR;EazjCM;;IAEE,mBAAA;Eb2jCR;AACF;Ac3nCI;ED+BE;IAtDJ,cAAA;IACA,WAAA;EbspCA;Ea3lCQ;IAtEN,cAAA;IACA,kBAAA;EboqCF;Ea/lCQ;IAtEN,cAAA;IACA,mBAAA;EbwqCF;EanmCQ;IAtEN,cAAA;IACA,UAAA;Eb4qCF;EavmCQ;IAtEN,cAAA;IACA,mBAAA;EbgrCF;Ea3mCQ;IAtEN,cAAA;IACA,mBAAA;EborCF;Ea/mCQ;IAtEN,cAAA;IACA,UAAA;EbwrCF;EannCQ;IAtEN,cAAA;IACA,mBAAA;Eb4rCF;EavnCQ;IAtEN,cAAA;IACA,mBAAA;EbgsCF;Ea3nCQ;IAtEN,cAAA;IACA,UAAA;EbosCF;Ea/nCQ;IAtEN,cAAA;IACA,mBAAA;EbwsCF;EanoCQ;IAtEN,cAAA;IACA,mBAAA;Eb4sCF;EavoCQ;IAtEN,cAAA;IACA,WAAA;EbgtCF;EanoCU;IA9DV,cAAA;EbosCA;EatoCU;IA9DV,wBAAA;EbusCA;EazoCU;IA9DV,yBAAA;Eb0sCA;Ea5oCU;IA9DV,gBAAA;Eb6sCA;Ea/oCU;IA9DV,yBAAA;EbgtCA;EalpCU;IA9DV,yBAAA;EbmtCA;EarpCU;IA9DV,gBAAA;EbstCA;EaxpCU;IA9DV,yBAAA;EbytCA;Ea3pCU;IA9DV,yBAAA;Eb4tCA;Ea9pCU;IA9DV,gBAAA;Eb+tCA;EajqCU;IA9DV,yBAAA;EbkuCA;EapqCU;IA9DV,yBAAA;EbquCA;Ea5pCM;;IAEE,gBAAA;Eb8pCR;Ea3pCM;;IAEE,gBAAA;Eb6pCR;EapqCM;;IAEE,sBAAA;EbsqCR;EanqCM;;IAEE,sBAAA;EbqqCR;Ea5qCM;;IAEE,qBAAA;Eb8qCR;Ea3qCM;;IAEE,qBAAA;Eb6qCR;EaprCM;;IAEE,mBAAA;EbsrCR;EanrCM;;IAEE,mBAAA;EbqrCR;Ea5rCM;;IAEE,qBAAA;Eb8rCR;Ea3rCM;;IAEE,qBAAA;Eb6rCR;EapsCM;;IAEE,mBAAA;EbssCR;EansCM;;IAEE,mBAAA;EbqsCR;Ea5sCM;;IAEE,mBAAA;Eb8sCR;Ea3sCM;;IAEE,mBAAA;Eb6sCR;EaptCM;;IAEE,mBAAA;EbstCR;EantCM;;IAEE,mBAAA;EbqtCR;Ea5tCM;;IAEE,mBAAA;Eb8tCR;Ea3tCM;;IAEE,mBAAA;Eb6tCR;EapuCM;;IAEE,mBAAA;EbsuCR;EanuCM;;IAEE,mBAAA;EbquCR;AACF;AcryCI;ED+BE;IAtDJ,cAAA;IACA,WAAA;Ebg0CA;EarwCQ;IAtEN,cAAA;IACA,kBAAA;Eb80CF;EazwCQ;IAtEN,cAAA;IACA,mBAAA;Ebk1CF;Ea7wCQ;IAtEN,cAAA;IACA,UAAA;Ebs1CF;EajxCQ;IAtEN,cAAA;IACA,mBAAA;Eb01CF;EarxCQ;IAtEN,cAAA;IACA,mBAAA;Eb81CF;EazxCQ;IAtEN,cAAA;IACA,UAAA;Ebk2CF;Ea7xCQ;IAtEN,cAAA;IACA,mBAAA;Ebs2CF;EajyCQ;IAtEN,cAAA;IACA,mBAAA;Eb02CF;EaryCQ;IAtEN,cAAA;IACA,UAAA;Eb82CF;EazyCQ;IAtEN,cAAA;IACA,mBAAA;Ebk3CF;Ea7yCQ;IAtEN,cAAA;IACA,mBAAA;Ebs3CF;EajzCQ;IAtEN,cAAA;IACA,WAAA;Eb03CF;Ea7yCU;IA9DV,cAAA;Eb82CA;EahzCU;IA9DV,wBAAA;Ebi3CA;EanzCU;IA9DV,yBAAA;Ebo3CA;EatzCU;IA9DV,gBAAA;Ebu3CA;EazzCU;IA9DV,yBAAA;Eb03CA;Ea5zCU;IA9DV,yBAAA;Eb63CA;Ea/zCU;IA9DV,gBAAA;Ebg4CA;Eal0CU;IA9DV,yBAAA;Ebm4CA;Ear0CU;IA9DV,yBAAA;Ebs4CA;Eax0CU;IA9DV,gBAAA;Eby4CA;Ea30CU;IA9DV,yBAAA;Eb44CA;Ea90CU;IA9DV,yBAAA;Eb+4CA;Eat0CM;;IAEE,gBAAA;Ebw0CR;Ear0CM;;IAEE,gBAAA;Ebu0CR;Ea90CM;;IAEE,sBAAA;Ebg1CR;Ea70CM;;IAEE,sBAAA;Eb+0CR;Eat1CM;;IAEE,qBAAA;Ebw1CR;Ear1CM;;IAEE,qBAAA;Ebu1CR;Ea91CM;;IAEE,mBAAA;Ebg2CR;Ea71CM;;IAEE,mBAAA;Eb+1CR;Eat2CM;;IAEE,qBAAA;Ebw2CR;Ear2CM;;IAEE,qBAAA;Ebu2CR;Ea92CM;;IAEE,mBAAA;Ebg3CR;Ea72CM;;IAEE,mBAAA;Eb+2CR;Eat3CM;;IAEE,mBAAA;Ebw3CR;Ear3CM;;IAEE,mBAAA;Ebu3CR;Ea93CM;;IAEE,mBAAA;Ebg4CR;Ea73CM;;IAEE,mBAAA;Eb+3CR;Eat4CM;;IAEE,mBAAA;Ebw4CR;Ear4CM;;IAEE,mBAAA;Ebu4CR;Ea94CM;;IAEE,mBAAA;Ebg5CR;Ea74CM;;IAEE,mBAAA;Eb+4CR;AACF;Ac/8CI;ED+BE;IAtDJ,cAAA;IACA,WAAA;Eb0+CA;Ea/6CQ;IAtEN,cAAA;IACA,kBAAA;Ebw/CF;Ean7CQ;IAtEN,cAAA;IACA,mBAAA;Eb4/CF;Eav7CQ;IAtEN,cAAA;IACA,UAAA;EbggDF;Ea37CQ;IAtEN,cAAA;IACA,mBAAA;EbogDF;Ea/7CQ;IAtEN,cAAA;IACA,mBAAA;EbwgDF;Ean8CQ;IAtEN,cAAA;IACA,UAAA;Eb4gDF;Eav8CQ;IAtEN,cAAA;IACA,mBAAA;EbghDF;Ea38CQ;IAtEN,cAAA;IACA,mBAAA;EbohDF;Ea/8CQ;IAtEN,cAAA;IACA,UAAA;EbwhDF;Ean9CQ;IAtEN,cAAA;IACA,mBAAA;Eb4hDF;Eav9CQ;IAtEN,cAAA;IACA,mBAAA;EbgiDF;Ea39CQ;IAtEN,cAAA;IACA,WAAA;EboiDF;Eav9CU;IA9DV,cAAA;EbwhDA;Ea19CU;IA9DV,wBAAA;Eb2hDA;Ea79CU;IA9DV,yBAAA;Eb8hDA;Eah+CU;IA9DV,gBAAA;EbiiDA;Ean+CU;IA9DV,yBAAA;EboiDA;Eat+CU;IA9DV,yBAAA;EbuiDA;Eaz+CU;IA9DV,gBAAA;Eb0iDA;Ea5+CU;IA9DV,yBAAA;Eb6iDA;Ea/+CU;IA9DV,yBAAA;EbgjDA;Eal/CU;IA9DV,gBAAA;EbmjDA;Ear/CU;IA9DV,yBAAA;EbsjDA;Eax/CU;IA9DV,yBAAA;EbyjDA;Eah/CM;;IAEE,gBAAA;Ebk/CR;Ea/+CM;;IAEE,gBAAA;Ebi/CR;Eax/CM;;IAEE,sBAAA;Eb0/CR;Eav/CM;;IAEE,sBAAA;Eby/CR;EahgDM;;IAEE,qBAAA;EbkgDR;Ea//CM;;IAEE,qBAAA;EbigDR;EaxgDM;;IAEE,mBAAA;Eb0gDR;EavgDM;;IAEE,mBAAA;EbygDR;EahhDM;;IAEE,qBAAA;EbkhDR;Ea/gDM;;IAEE,qBAAA;EbihDR;EaxhDM;;IAEE,mBAAA;Eb0hDR;EavhDM;;IAEE,mBAAA;EbyhDR;EahiDM;;IAEE,mBAAA;EbkiDR;Ea/hDM;;IAEE,mBAAA;EbiiDR;EaxiDM;;IAEE,mBAAA;Eb0iDR;EaviDM;;IAEE,mBAAA;EbyiDR;EahjDM;;IAEE,mBAAA;EbkjDR;Ea/iDM;;IAEE,mBAAA;EbijDR;EaxjDM;;IAEE,mBAAA;Eb0jDR;EavjDM;;IAEE,mBAAA;EbyjDR;AACF;AeprDA;EACE,0BAAA;EACA,iCAAA;EACA,iCAAA;EACA,0CAAA;EACA,gCAAA;EACA,0CAAA;EACA,+BAAA;EACA,yCAAA;EAEA,WAAA;EACA,mBdiVO;EchVP,cdKS;EcJT,mBVogB4B;EUngB5B,qBdDS;ADsrDX;Ae9qDE;EACE,sBAAA;EACA,oCAAA;EACA,8BdwX0B;EcvX1B,wDAAA;AfgrDJ;Ae7qDE;EACE,uBAAA;Af+qDJ;Ae5qDE;EACE,sBAAA;Af8qDJ;Ae1qDE;EACE,iCVqgB0B;ALuqC9B;;AenqDA;EACE,iBAAA;AfsqDF;;Ae5pDE;EACE,wBAAA;Af+pDJ;;AehpDE;EACE,yBAAA;AfmpDJ;AehpDI;EACE,yBAAA;AfkpDN;;Ae3oDE;EACE,sBAAA;Af8oDJ;;AeroDE;EACE,gDAAA;EACA,oCAAA;AfwoDJ;;AehoDA;EACE,+CAAA;EACA,mCAAA;AfmoDF;;Ae3nDE;EACE,8CAAA;EACA,kCAAA;Af8nDJ;;AgBtvDE;EAME,sBAAA;EACA,8BAAA;EACA,iCAAA;EACA,6BAAA;EACA,gCAAA;EACA,4BAAA;EACA,+BAAA;EAEA,cAbQ;EAcR,qBAAA;AhBmvDJ;;AgBlwDE;EAME,sBAAA;EACA,8BAAA;EACA,iCAAA;EACA,6BAAA;EACA,gCAAA;EACA,4BAAA;EACA,+BAAA;EAEA,cAbQ;EAcR,qBAAA;AhB+vDJ;;AgB9wDE;EAME,sBAAA;EACA,8BAAA;EACA,iCAAA;EACA,6BAAA;EACA,gCAAA;EACA,4BAAA;EACA,+BAAA;EAEA,cAbQ;EAcR,qBAAA;AhB2wDJ;;AgB1xDE;EAME,sBAAA;EACA,8BAAA;EACA,iCAAA;EACA,6BAAA;EACA,gCAAA;EACA,4BAAA;EACA,+BAAA;EAEA,cAbQ;EAcR,qBAAA;AhBuxDJ;;AgBtyDE;EAME,sBAAA;EACA,8BAAA;EACA,iCAAA;EACA,6BAAA;EACA,gCAAA;EACA,4BAAA;EACA,+BAAA;EAEA,cAbQ;EAcR,qBAAA;AhBmyDJ;;AgBlzDE;EAME,sBAAA;EACA,8BAAA;EACA,iCAAA;EACA,6BAAA;EACA,gCAAA;EACA,4BAAA;EACA,+BAAA;EAEA,cAbQ;EAcR,qBAAA;AhB+yDJ;;AgB9zDE;EAME,sBAAA;EACA,8BAAA;EACA,iCAAA;EACA,6BAAA;EACA,gCAAA;EACA,4BAAA;EACA,+BAAA;EAEA,cAbQ;EAcR,qBAAA;AhB2zDJ;;AgB10DE;EAME,sBAAA;EACA,8BAAA;EACA,iCAAA;EACA,6BAAA;EACA,gCAAA;EACA,4BAAA;EACA,+BAAA;EAEA,cAbQ;EAcR,qBAAA;AhBu0DJ;;AevsDI;EACE,gBAAA;EACA,iCAAA;Af0sDN;;AcjxDI;ECqEA;IACE,gBAAA;IACA,iCAAA;EfgtDJ;AACF;AcxxDI;ECqEA;IACE,gBAAA;IACA,iCAAA;EfstDJ;AACF;Ac9xDI;ECqEA;IACE,gBAAA;IACA,iCAAA;Ef4tDJ;AACF;AcpyDI;ECqEA;IACE,gBAAA;IACA,iCAAA;EfkuDJ;AACF;AiBl3DA;EACE,qBZ0pBsC;AL0tCxC;;AiB32DA;EACE,+BAAA;EACA,kCAAA;EACA,gBAAA;EboRI,kBALI;Ea3QR,qBhBwc6B;ADo6C/B;;AiBx2DA;EACE,iCAAA;EACA,oCAAA;Eb0QI,mBALI;AJumDV;;AiBx2DA;EACE,gCAAA;EACA,mCAAA;EboQI,kBALI;AJ6mDV;;AkBz4DA;EACE,mBbkpBsC;EDlXlC,cALI;EcvRR,cjBWS;AD+3DX;;AmB/4DA;EACE,cAAA;EACA,WAAA;EACA,sBAAA;Ef8RI,mBALI;EetRR,gBlB4c4B;EkB3c5B,qBlBkd6B;EkBjd7B,+BlB2E2B;EkB1E3B,6BlBY2B;EkBX3B,4BAAA;EACA,yBAAA;EACA,wBAAA;UAAA,gBAAA;EbGE,sBAAA;EKLE,gBARW;ESUX,2DDMJ;AnB84DF;AoBh5DM;EDhBN;ICiBQ,gBAAA;EpBm5DN;AACF;AmBj5DE;EACE,gBAAA;AnBm5DJ;AmBj5DI;EACE,eAAA;AnBm5DN;AmB94DE;EACE,+BlBqDyB;EkBpDzB,yBlBrBO;EkBsBP,sClBsnBoC;EkBrnBpC,UAAA;ERvBE,sBARW;AXg7DjB;AmBr4DE;EAEE,kBAAA;AnBs4DJ;AmBl4DE;EACE,clBrCO;EkBuCP,UAAA;AnBm4DJ;AmB33DE;EAEE,yBlBpDO;EkBuDP,UAAA;AnB03DJ;AmBt3DE;EACE,sBAAA;EACA,uBAAA;EACA,yBlBmf0B;EkBlf1B,+BlBQyB;EoBnF3B,6BpBqB2B;EkBwDzB,oBAAA;EACA,qBAAA;EACA,mBAAA;EACA,eAAA;EACA,4BlB4f0B;EkB3f1B,gBAAA;ECtEE,qIDuEF;AnBw3DJ;AoB37DM;EDuDJ;ICtDM,gBAAA;EpB87DN;AACF;AmB13DE;EACE,qCd6vB8B;AL+nClC;AmBz3DE;EACE,sBAAA;EACA,uBAAA;EACA,yBlBge0B;EkB/d1B,+BlBXyB;EoBnF3B,6BpBqB2B;EkB2EzB,oBAAA;EACA,qBAAA;EACA,mBAAA;EACA,eAAA;EACA,4BlBye0B;EkBxe1B,gBAAA;ECzFE,6ID0FF;EC1FE,qID0FF;AnB23DJ;AoBj9DM;ED0EJ;ICzEM,wBAAA;IAAA,gBAAA;EpBo9DN;AACF;AmB73DE;EACE,qCd0uB8B;ALqpClC;;AmBt3DA;EACE,cAAA;EACA,WAAA;EACA,iBAAA;EACA,gBAAA;EACA,qBlBiW6B;EkBhW7B,clBxGS;EkByGT,6BAAA;EACA,yBAAA;EACA,mBAAA;AnBy3DF;AmBv3DE;EAEE,gBAAA;EACA,eAAA;AnBw3DJ;;AmB72DA;EACE,6CdkkBsC;EcjkBtC,uBAAA;EfmJI,kBALI;EE7QN,wBAAA;ANi/DJ;AmB92DE;EACE,uBAAA;EACA,wBAAA;EACA,yBlBib0B;AD+7C9B;AmB72DE;EACE,uBAAA;EACA,wBAAA;EACA,yBlB2a0B;ADo8C9B;;AmB32DA;EACE,8CdgjBsC;Ec/iBtC,sBAAA;EfgII,mBALI;EE7QN,wBAAA;ANkgEJ;AmB52DE;EACE,sBAAA;EACA,uBAAA;EACA,uBlBka0B;AD48C9B;AmB32DE;EACE,sBAAA;EACA,uBAAA;EACA,uBlB4Z0B;ADi9C9B;;AmBr2DE;EACE,sClByeoC;AD+3CxC;AmBr2DE;EACE,6CdohBoC;ALm1CxC;AmBp2DE;EACE,8CdihBoC;ALq1CxC;;AmBj2DA;EACE,eAAA;EACA,YAAA;EACA,elBqX4B;AD++C9B;AmBl2DE;EACE,eAAA;AnBo2DJ;AmBj2DE;EACE,kBAAA;Eb/LA,sBAAA;ANmiEJ;AmBh2DE;EACE,kBAAA;EbpMA,sBAAA;ANuiEJ;;AsBrjEA;EACE,cAAA;EACA,WAAA;EACA,oCAAA;EAEA,sCAAA;ElB2RI,mBALI;EkBnRR,gBrByc4B;EqBxc5B,qBrB+c6B;EqB9c7B,+BrBwE2B;EqBvE3B,6BrBS2B;EqBR3B,yDAAA;EACA,4BAAA;EACA,wCjBgxBkC;EiB/wBlC,0BjBgxBkC;EiB/wBlC,yBAAA;EhBFE,sBAAA;EKLE,gDARW;ESUX,2DEQJ;EACA,wBAAA;UAAA,gBAAA;AtBsjEF;AoB3jEM;EEfN;IFgBQ,gBAAA;EpB8jEN;AACF;AsBzjEE;EACE,sCrB8nBoC;EqB7nBpC,UAAA;EXfE,iEARW;AXmlEjB;AsBnjEE;EAEE,qBrByhB0B;EqBxhB1B,sBAAA;AtBojEJ;AsBjjEE;EAEE,yBrB9BO;ADglEX;AsB7iEE;EACE,kBAAA;EACA,2CAAA;AtB+iEJ;;AsB3iEA;EACE,oBrB+gB4B;EqB9gB5B,uBrB8gB4B;EqB7gB5B,oBrB8gB4B;EGrSxB,kBALI;AJ20DV;;AsB3iEA;EACE,qBrB4gB4B;EqB3gB5B,wBrB2gB4B;EqB1gB5B,kBrB2gB4B;EGzSxB,mBALI;AJk1DV;;AuB9mEA;EACE,cAAA;EACA,qBlBqtBwC;EkBptBxC,mBlBqtBwC;EkBptBxC,uBlBqtBwC;AL45C1C;AuB/mEE;EACE,WAAA;EACA,mBAAA;AvBinEJ;;AuB7mEA;EACE,UlBysBwC;EkBxsBxC,WlBwsBwC;EkBvsBxC,kBAAA;EACA,mBAAA;EACA,6BtBI2B;EsBH3B,4BAAA;EACA,2BAAA;EACA,wBAAA;EACA,qClB4sBwC;EkB3sBxC,wBAAA;UAAA,gBAAA;EACA,iCAAA;UAAA,mBAAA;AvBgnEF;AuB7mEE;EjBXE,qBAAA;AN2nEJ;AuB5mEE;EAEE,kBlBmsBsC;AL06C1C;AuB1mEE;EACE,uBlB0rBsC;ALk7C1C;AuBzmEE;EACE,sCtB8mBoC;EsB7mBpC,UAAA;EACA,gBtByhB0B;ADklD9B;AuBxmEE;EACE,yBtBoGY;EsBnGZ,qBtBmGY;ADugEhB;AuBxmEI;EAII,yDAAA;AvBumER;AuBnmEI;EAII,yDAAA;AvBkmER;AuB7lEE;EACE,yBtB+EY;EsB9EZ,qBtB8EY;EsBzEV,yDAAA;AvB2lEN;AuBvlEE;EACE,oBAAA;EACA,YAAA;EACA,YlBkqBuC;ALu7C3C;AuBllEI;EACE,YlB0pBqC;AL07C3C;;AuBtkEA;EACE,mBlBqpBgC;ALo7ClC;AuBvkEE;EACE,UlBipB8B;EkBhpB9B,mBAAA;EACA,yDAAA;EACA,gCAAA;EjB9FA,kBAAA;EcHE,iDGmGF;AvBykEJ;AoBxqEM;EGyFJ;IHxFM,gBAAA;EpB2qEN;AACF;AuB5kEI;EACE,yDAAA;AvB8kEN;AuB3kEI;EACE,iClBgpB4B;EkB3oB1B,yDAAA;AvBykER;;AuBnkEA;EACE,qBAAA;EACA,kBlBmnBgC;ALm9ClC;;AuBnkEA;EACE,kBAAA;EACA,sBAAA;EACA,oBAAA;AvBskEF;AuBlkEI;EACE,oBAAA;EACA,YAAA;EACA,alBuewB;AL6lD9B;;AwBltEA;EACE,WAAA;EACA,YAAA;EACA,UAAA;EACA,6BAAA;EACA,wBAAA;UAAA,gBAAA;AxBqtEF;AwBntEE;EACE,UAAA;AxBqtEJ;AwBjtEI;EAA0B,mCnB4zBa;ALw5C3C;AwBntEI;EAA0B,mCnB2zBa;AL25C3C;AwBntEE;EACE,SAAA;AxBqtEJ;AwBltEE;EACE,WnB6yBuC;EmB5yBvC,YnB4yBuC;EmB3yBvC,oBAAA;EHzBF,yBpBkJc;EuBvHZ,SnB4yBuC;ECxzBvC,mBAAA;EKLE,+CARW;ESUX,oHIkBF;EJlBE,4GIkBF;EACA,wBAAA;UAAA,gBAAA;AxBotEJ;AoBnuEM;EIMJ;IJLM,wBAAA;IAAA,gBAAA;EpBsuEN;AACF;AwBvtEI;EHjCF,yBhB40ByC;AL+6C3C;AwBrtEE;EACE,WnBsxB8B;EmBrxB9B,cnBsxB8B;EmBrxB9B,kBAAA;EACA,enBqxB8B;EmBpxB9B,yBvB9BO;EuB+BP,yBAAA;ElB7BA,mBAAA;EKLE,gDARW;AXmwEjB;AwBptEE;EACE,WnBkxBuC;EmBjxBvC,YnBixBuC;EgBp0BzC,yBpBkJc;EuB7FZ,SnBkxBuC;ECxzBvC,mBAAA;EKLE,+CARW;ESUX,iHI4CF;EJ5CE,4GI4CF;EACA,gBAAA;AxBstEJ;AoB/vEM;EIiCJ;IJhCM,qBAAA;IAAA,gBAAA;EpBkwEN;AACF;AwBztEI;EH3DF,yBhB40ByC;AL28C3C;AwBvtEE;EACE,WnB4vB8B;EmB3vB9B,cnB4vB8B;EmB3vB9B,kBAAA;EACA,enB2vB8B;EmB1vB9B,yBvBxDO;EuByDP,yBAAA;ElBvDA,mBAAA;EKLE,gDARW;AX+xEjB;AwBttEE;EACE,oBAAA;AxBwtEJ;AwBttEI;EACE,yBvBhEK;ADwxEX;AwBrtEI;EACE,yBvBpEK;AD2xEX;;AyB9yEA;EACE,kBAAA;AzBizEF;AyB/yEE;;EAEE,0BpBu1B8B;EoBt1B9B,iBpBu1B8B;AL09ClC;AyB9yEE;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,YAAA;EACA,oBAAA;EACA,oBAAA;EACA,6BAAA;EACA,qBAAA;ELDE,gEKEF;AzBgzEJ;AoB9yEM;EKXJ;ILYM,gBAAA;EpBizEN;AACF;AyBjzEE;EACE,oBAAA;AzBmzEJ;AyBjzEI;EACE,kBAAA;AzBmzEN;AyBhzEI;EAEE,qBpBi0B4B;EoBh0B5B,wBpBi0B4B;ALg/ClC;AyB9yEI;EACE,qBpB4zB4B;EoB3zB5B,wBpB4zB4B;ALo/ClC;AyB5yEE;EACE,qBpBszB8B;EoBrzB9B,wBpBszB8B;ALw/ClC;AyBxyEI;;;EACE,apBgzB4B;EoB/yB5B,8DpBgzB4B;AL4/ClC;AyBvyEI;EACE,apByyB4B;EoBxyB5B,8DpByyB4B;ALggDlC;;A0B/1EA;EACE,kBAAA;EACA,aAAA;EACA,eAAA;EACA,oBAAA;EACA,WAAA;A1Bk2EF;A0Bh2EE;;EAEE,kBAAA;EACA,cAAA;EACA,SAAA;EACA,YAAA;A1Bk2EJ;A0B91EE;;EAEE,UAAA;A1Bg2EJ;A0B11EE;EACE,kBAAA;EACA,UAAA;A1B41EJ;A0B11EI;EACE,UAAA;A1B41EN;;A0Bj1EA;EACE,aAAA;EACA,mBAAA;EACA,sBAAA;EtBsPI,mBALI;EsB/OR,gBzBqa4B;EyBpa5B,qBzB2a6B;EyB1a7B,czBhCS;EyBiCT,kBAAA;EACA,mBAAA;EACA,6BzB7B2B;EyB8B3B,yBAAA;EpBpCE,sBAAA;ANy3EJ;;A0B30EA;;;;EAIE,sBAAA;EtBgOI,mBALI;EE7QN,wBAAA;ANk4EJ;;A0B30EA;;;;EAIE,uBAAA;EtBuNI,kBALI;EE7QN,wBAAA;AN24EJ;;A0B30EA;;EAEE,qBAAA;A1B80EF;;A0Bj0EI;;EpB/DA,0BAAA;EACA,6BAAA;ANq4EJ;A0Bh0EI;;EpBtEA,0BAAA;EACA,6BAAA;AN04EJ;A0B1zEE;EACE,iBAAA;EpBpEA,yBAAA;EACA,4BAAA;ANi4EJ;;A2B15EE;EACE,aAAA;EACA,WAAA;EACA,mBtB2nBoC;EDlXlC,cALI;EuBjQN,ctBw1BqB;ALokDzB;;A2Bz5EE;EACE,kBAAA;EACA,SAAA;EACA,UAAA;EACA,aAAA;EACA,eAAA;EACA,uBAAA;EACA,kBAAA;EvB4PE,0BALI;EuBpPN,cAvBc;EAwBd,0CAvBiB;ErBHjB,sBAAA;ANs7EJ;;A2Bv5EI;;;;EAEE,cAAA;A3B45EN;;A2B18EI;EAoDE,qBtB6zBmB;EsB1zBjB,6B1BsmBgC;E0BrmBhC,yDAAA;EACA,4BAAA;EACA,8DAAA;EACA,sEAAA;A3Bw5ER;A2Br5EM;EACE,qBtBkzBiB;EsBjzBjB,6CA/Ca;A3Bs8ErB;;A2Bv9EI;EAyEI,6B1BolBgC;E0BnlBhC,wFAAA;A3Bk5ER;;A2B59EI;EAiFE,qBtBgyBmB;AL+mDzB;A2B54EQ;EAEE,sBtB4sB8B;EsB3sB9B,kGAAA;EACA,6DAAA;EACA,iFAAA;A3B64EV;A2Bz4EM;EACE,qBtBmxBiB;EsBlxBjB,6CA9Ea;A3By9ErB;;A2B1+EI;EAsGE,qBtB2wBmB;AL6nDzB;A2Bt4EM;EACE,yBtBwwBiB;ALgoDzB;A2Br4EM;EACE,6CA5Fa;A3Bm+ErB;A2Bp4EM;EACE,ctBgwBiB;ALsoDzB;;A2Bj4EI;EACE,kBAAA;A3Bo4EN;;A2B3/EI;;;EA+HI,UAAA;A3Bk4ER;A2B93EM;;;EACE,UAAA;A3Bk4ER;;A2Bn/EE;EACE,aAAA;EACA,WAAA;EACA,mBtB2nBoC;EDlXlC,cALI;EuBjQN,ctBw1BqB;AL6pDzB;;A2Bl/EE;EACE,kBAAA;EACA,SAAA;EACA,UAAA;EACA,aAAA;EACA,eAAA;EACA,uBAAA;EACA,kBAAA;EvB4PE,0BALI;EuBpPN,cAvBc;EAwBd,uCAvBiB;ErBHjB,sBAAA;AN+gFJ;;A2Bh/EI;;;;EAEE,cAAA;A3Bq/EN;;A2BniFI;EAoDE,qBtB6zBmB;EsB1zBjB,6B1BsmBgC;E0BrmBhC,yDAAA;EACA,4BAAA;EACA,8DAAA;EACA,sEAAA;A3Bi/ER;A2B9+EM;EACE,qBtBkzBiB;EsBjzBjB,0CA/Ca;A3B+hFrB;;A2BhjFI;EAyEI,6B1BolBgC;E0BnlBhC,wFAAA;A3B2+ER;;A2BrjFI;EAiFE,qBtBgyBmB;ALwsDzB;A2Br+EQ;EAEE,sBtB4sB8B;EsB3sB9B,kGAAA;EACA,6DAAA;EACA,iFAAA;A3Bs+EV;A2Bl+EM;EACE,qBtBmxBiB;EsBlxBjB,0CA9Ea;A3BkjFrB;;A2BnkFI;EAsGE,qBtB2wBmB;ALstDzB;A2B/9EM;EACE,yBtBwwBiB;ALytDzB;A2B99EM;EACE,0CA5Fa;A3B4jFrB;A2B79EM;EACE,ctBgwBiB;AL+tDzB;;A2B19EI;EACE,kBAAA;A3B69EN;;A2BplFI;;;EAiII,UAAA;A3By9ER;A2Bv9EM;;;EACE,UAAA;A3B29ER;;A4BjmFA;EACE,qBAAA;EAEA,gB3BomB4B;E2BnmB5B,mB3BqE4B;E2BpE5B,c3BYS;E2BXT,kBAAA;EAGA,sBAAA;EACA,eAAA;EACA,yBAAA;UAAA,iBAAA;EACA,6BAAA;EACA,6BAAA;EC8GA,kBAAA;EzBsKI,mBALI;EE7QN,sBAAA;EcHE,qIQGJ;A5BmmFF;AoBlmFM;EQhBN;IRiBQ,gBAAA;EpBqmFN;AACF;A4BtmFE;EACE,c3BDO;ADymFX;A4BpmFE;EAEE,UAAA;EACA,2E3BklB0B;ADmhE9B;A4BlmFE;EjBlBI,gBARW;AX+nFjB;A4B/lFI;EjBxBE,iFARW;AXkoFjB;A4B7lFE;EAGE,oBAAA;EACA,avB4kB0B;EM7mBxB,gBARW;AXuoFjB;;A4BllFE;ECvCA,cAXQ;ERLR,yBpB+Oa;E4B7Nb,qB5B6Na;EUrOT,2EARW;AX8oFjB;A6B3nFE;EACE,cAdY;ERRd,yBQMmB;EAkBjB,qBAjBa;A7B8oFjB;A6B1nFE;EAEE,cArBY;ERRd,yBQMmB;EAyBjB,qBAxBa;ElBGX,0GARW;AXypFjB;A6BnnFE;EAKE,cAlCa;EAmCb,yBArCkB;EAwClB,qBAvCc;A7BspFlB;A6B7mFI;ElBzCE,+CARW;AXiqFjB;A6BtmFE;EAEE,cAjDe;EAkDf,yB5B+KW;E4B5KX,qB5B4KW;ADy7Ef;;A4BjnFE;ECvCA,cAXQ;ERLR,yBpB+Oa;E4B7Nb,qB5B6Na;EUrOT,2EARW;AX6qFjB;A6B1pFE;EACE,cAdY;ERRd,yBQMmB;EAkBjB,qBAjBa;A7B6qFjB;A6BzpFE;EAEE,cArBY;ERRd,yBQMmB;EAyBjB,qBAxBa;ElBGX,4GARW;AXwrFjB;A6BlpFE;EAKE,cAlCa;EAmCb,yBArCkB;EAwClB,qBAvCc;A7BqrFlB;A6B5oFI;ElBzCE,iDARW;AXgsFjB;A6BroFE;EAEE,cAjDe;EAkDf,yB5B+KW;E4B5KX,qB5B4KW;ADw9Ef;;A4BhpFE;ECvCA,cAXQ;ERLR,yBpB+Oa;E4B7Nb,qB5B6Na;EUrOT,2EARW;AX4sFjB;A6BzrFE;EACE,cAdY;ERRd,yBQMmB;EAkBjB,qBAjBa;A7B4sFjB;A6BxrFE;EAEE,cArBY;ERRd,yBQMmB;EAyBjB,qBAxBa;ElBGX,6GARW;AXutFjB;A6BjrFE;EAKE,cAlCa;EAmCb,yBArCkB;EAwClB,qBAvCc;A7BotFlB;A6B3qFI;ElBzCE,kDARW;AX+tFjB;A6BpqFE;EAEE,cAjDe;EAkDf,yB5B+KW;E4B5KX,qB5B4KW;ADu/Ef;;A4B/qFE;ECvCA,cAXQ;ERLR,yBpB+Oa;E4B7Nb,qB5B6Na;EUrOT,2EARW;AX2uFjB;A6BxtFE;EACE,cAdY;ERRd,yBQMmB;EAkBjB,qBAjBa;A7B2uFjB;A6BvtFE;EAEE,cArBY;ERRd,yBQMmB;EAyBjB,qBAxBa;ElBGX,4GARW;AXsvFjB;A6BhtFE;EAKE,cAlCa;EAmCb,yBArCkB;EAwClB,qBAvCc;A7BmvFlB;A6B1sFI;ElBzCE,iDARW;AX8vFjB;A6BnsFE;EAEE,cAjDe;EAkDf,yB5B+KW;E4B5KX,qB5B4KW;ADshFf;;A4B9sFE;ECvCA,cAXQ;ERLR,yBpB+Oa;E4B7Nb,qB5B6Na;EUrOT,2EARW;AX0wFjB;A6BvvFE;EACE,cAdY;ERRd,yBQMmB;EAkBjB,qBAjBa;A7B0wFjB;A6BtvFE;EAEE,cArBY;ERRd,yBQMmB;EAyBjB,qBAxBa;ElBGX,2GARW;AXqxFjB;A6B/uFE;EAKE,cAlCa;EAmCb,yBArCkB;EAwClB,qBAvCc;A7BkxFlB;A6BzuFI;ElBzCE,gDARW;AX6xFjB;A6BluFE;EAEE,cAjDe;EAkDf,yB5B+KW;E4B5KX,qB5B4KW;ADqjFf;;A4B7uFE;ECvCA,cAXQ;ERLR,yBpB+Oa;E4B7Nb,qB5B6Na;EUrOT,2EARW;AXyyFjB;A6BtxFE;EACE,cAdY;ERRd,yBQMmB;EAkBjB,qBAjBa;A7ByyFjB;A6BrxFE;EAEE,cArBY;ERRd,yBQMmB;EAyBjB,qBAxBa;ElBGX,2GARW;AXozFjB;A6B9wFE;EAKE,cAlCa;EAmCb,yBArCkB;EAwClB,qBAvCc;A7BizFlB;A6BxwFI;ElBzCE,gDARW;AX4zFjB;A6BjwFE;EAEE,cAjDe;EAkDf,yB5B+KW;E4B5KX,qB5B4KW;ADolFf;;A4B5wFE;ECvCA,cAXQ;ERLR,yBpB+Oa;E4B7Nb,qB5B6Na;EUrOT,2EARW;AXw0FjB;A6BrzFE;EACE,cAdY;ERRd,yBQMmB;EAkBjB,qBAjBa;A7Bw0FjB;A6BpzFE;EAEE,cArBY;ERRd,yBQMmB;EAyBjB,qBAxBa;ElBGX,2GARW;AXm1FjB;A6B7yFE;EAKE,cAlCa;EAmCb,yBArCkB;EAwClB,qBAvCc;A7Bg1FlB;A6BvyFI;ElBzCE,gDARW;AX21FjB;A6BhyFE;EAEE,cAjDe;EAkDf,yB5B+KW;E4B5KX,qB5B4KW;ADmnFf;;A4B3yFE;ECvCA,cAXQ;ERLR,yBpB+Oa;E4B7Nb,qB5B6Na;EUrOT,2EARW;AXu2FjB;A6Bp1FE;EACE,cAdY;ERRd,uBQMmB;EAkBjB,mBAjBa;A7Bu2FjB;A6Bn1FE;EAEE,cArBY;ERRd,uBQMmB;EAyBjB,mBAxBa;ElBGX,6GARW;AXk3FjB;A6B50FE;EAKE,cAlCa;EAmCb,uBArCkB;EAwClB,mBAvCc;A7B+2FlB;A6Bt0FI;ElBzCE,kDARW;AX03FjB;A6B/zFE;EAEE,cAjDe;EAkDf,yB5B+KW;E4B5KX,qB5B4KW;ADkpFf;;A4B10FE;ECvCA,cAXQ;ERLR,yBpB+Oa;E4B7Nb,qB5B6Na;EUrOT,2EARW;AXs4FjB;A6Bn3FE;EACE,cAdY;ERRd,uBQMmB;EAkBjB,mBAjBa;A7Bs4FjB;A6Bl3FE;EAEE,cArBY;ERRd,uBQMmB;EAyBjB,mBAxBa;ElBGX,6GARW;AXi5FjB;A6B32FE;EAKE,cAlCa;EAmCb,uBArCkB;EAwClB,mBAvCc;A7B84FlB;A6Br2FI;ElBzCE,kDARW;AXy5FjB;A6B91FE;EAEE,cAjDe;EAkDf,yB5B+KW;E4B5KX,qB5B4KW;ADirFf;;A4Bz2FE;ECvCA,cAXQ;ERLR,yBpB+Oa;E4B7Nb,qB5B6Na;EUrOT,2EARW;AXq6FjB;A6Bl5FE;EACE,cAdY;ERRd,yBQMmB;EAkBjB,qBAjBa;A7Bq6FjB;A6Bj5FE;EAEE,cArBY;ERRd,yBQMmB;EAyBjB,qBAxBa;ElBGX,0GARW;AXg7FjB;A6B14FE;EAKE,cAlCa;EAmCb,yBArCkB;EAwClB,qBAvCc;A7B66FlB;A6Bp4FI;ElBzCE,+CARW;AXw7FjB;A6B73FE;EAEE,cAjDe;EAkDf,yB5B+KW;E4B5KX,qB5B4KW;ADgtFf;;A4Bx4FE;ECvCA,cAXQ;ERLR,uBpB+Oa;E4B7Nb,mB5B6Na;EUrOT,2EARW;AXo8FjB;A6Bj7FE;EACE,cAdY;ERRd,uBQMmB;EAkBjB,mBAjBa;A7Bo8FjB;A6Bh7FE;EAEE,cArBY;ERRd,uBQMmB;EAyBjB,mBAxBa;ElBGX,0GARW;AX+8FjB;A6Bz6FE;EAKE,cAlCa;EAmCb,uBArCkB;EAwClB,mBAvCc;A7B48FlB;A6Bn6FI;ElBzCE,+CARW;AXu9FjB;A6B55FE;EAEE,cAjDe;EAkDf,uB5B+KW;E4B5KX,mB5B4KW;AD+uFf;;A4Bj6FE;ECmBA,c5B+Ja;E4B9Jb,qB5B8Ja;ADovFf;A6Bh5FE;EACE,cATY;EAUZ,yB5B0JW;E4BzJX,qB5ByJW;ADyvFf;A6B/4FE;EAEE,wCAAA;A7Bg5FJ;A6B74FE;EAKE,cArBa;EAsBb,yB5B2IW;E4B1IX,qB5B0IW;ADiwFf;A6Bz4FI;ElB7FE,8CARW;AXi/FjB;A6Bl4FE;EAEE,c5B4HW;E4B3HX,6BAAA;A7Bm4FJ;;A4B17FE;ECmBA,c5B+Ja;E4B9Jb,qB5B8Ja;AD6wFf;A6Bz6FE;EACE,cATY;EAUZ,yB5B0JW;E4BzJX,qB5ByJW;ADkxFf;A6Bx6FE;EAEE,4CAAA;A7By6FJ;A6Bt6FE;EAKE,cArBa;EAsBb,yB5B2IW;E4B1IX,qB5B0IW;AD0xFf;A6Bl6FI;ElB7FE,kDARW;AX0gGjB;A6B35FE;EAEE,c5B4HW;E4B3HX,6BAAA;A7B45FJ;;A4Bn9FE;ECmBA,c5B+Ja;E4B9Jb,qB5B8Ja;ADsyFf;A6Bl8FE;EACE,cATY;EAUZ,yB5B0JW;E4BzJX,qB5ByJW;AD2yFf;A6Bj8FE;EAEE,4CAAA;A7Bk8FJ;A6B/7FE;EAKE,cArBa;EAsBb,yB5B2IW;E4B1IX,qB5B0IW;ADmzFf;A6B37FI;ElB7FE,kDARW;AXmiGjB;A6Bp7FE;EAEE,c5B4HW;E4B3HX,6BAAA;A7Bq7FJ;;A4B5+FE;ECmBA,c5B+Ja;E4B9Jb,qB5B8Ja;AD+zFf;A6B39FE;EACE,cATY;EAUZ,yB5B0JW;E4BzJX,qB5ByJW;ADo0Ff;A6B19FE;EAEE,4CAAA;A7B29FJ;A6Bx9FE;EAKE,cArBa;EAsBb,yB5B2IW;E4B1IX,qB5B0IW;AD40Ff;A6Bp9FI;ElB7FE,kDARW;AX4jGjB;A6B78FE;EAEE,c5B4HW;E4B3HX,6BAAA;A7B88FJ;;A4BrgGE;ECmBA,c5B+Ja;E4B9Jb,qB5B8Ja;ADw1Ff;A6Bp/FE;EACE,cATY;EAUZ,yB5B0JW;E4BzJX,qB5ByJW;AD61Ff;A6Bn/FE;EAEE,yCAAA;A7Bo/FJ;A6Bj/FE;EAKE,cArBa;EAsBb,yB5B2IW;E4B1IX,qB5B0IW;ADq2Ff;A6B7+FI;ElB7FE,+CARW;AXqlGjB;A6Bt+FE;EAEE,c5B4HW;E4B3HX,6BAAA;A7Bu+FJ;;A4B9hGE;ECmBA,c5B+Ja;E4B9Jb,qB5B8Ja;ADi3Ff;A6B7gGE;EACE,cATY;EAUZ,yB5B0JW;E4BzJX,qB5ByJW;ADs3Ff;A6B5gGE;EAEE,yCAAA;A7B6gGJ;A6B1gGE;EAKE,cArBa;EAsBb,yB5B2IW;E4B1IX,qB5B0IW;AD83Ff;A6BtgGI;ElB7FE,+CARW;AX8mGjB;A6B//FE;EAEE,c5B4HW;E4B3HX,6BAAA;A7BggGJ;;A4BvjGE;ECmBA,c5B+Ja;E4B9Jb,qB5B8Ja;AD04Ff;A6BtiGE;EACE,cATY;EAUZ,yB5B0JW;E4BzJX,qB5ByJW;AD+4Ff;A6BriGE;EAEE,yCAAA;A7BsiGJ;A6BniGE;EAKE,cArBa;EAsBb,yB5B2IW;E4B1IX,qB5B0IW;ADu5Ff;A6B/hGI;ElB7FE,+CARW;AXuoGjB;A6BxhGE;EAEE,c5B4HW;E4B3HX,6BAAA;A7ByhGJ;;A4BhlGE;ECmBA,c5B+Ja;E4B9Jb,qB5B8Ja;ADm6Ff;A6B/jGE;EACE,cATY;EAUZ,yB5B0JW;E4BzJX,qB5ByJW;ADw6Ff;A6B9jGE;EAEE,4CAAA;A7B+jGJ;A6B5jGE;EAKE,cArBa;EAsBb,yB5B2IW;E4B1IX,qB5B0IW;ADg7Ff;A6BxjGI;ElB7FE,kDARW;AXgqGjB;A6BjjGE;EAEE,c5B4HW;E4B3HX,6BAAA;A7BkjGJ;;A4BzmGE;ECmBA,c5B+Ja;E4B9Jb,qB5B8Ja;AD47Ff;A6BxlGE;EACE,cATY;EAUZ,yB5B0JW;E4BzJX,qB5ByJW;ADi8Ff;A6BvlGE;EAEE,4CAAA;A7BwlGJ;A6BrlGE;EAKE,cArBa;EAsBb,yB5B2IW;E4B1IX,qB5B0IW;ADy8Ff;A6BjlGI;ElB7FE,kDARW;AXyrGjB;A6B1kGE;EAEE,c5B4HW;E4B3HX,6BAAA;A7B2kGJ;;A4BloGE;ECmBA,c5B+Ja;E4B9Jb,qB5B8Ja;ADq9Ff;A6BjnGE;EACE,cATY;EAUZ,yB5B0JW;E4BzJX,qB5ByJW;AD09Ff;A6BhnGE;EAEE,yCAAA;A7BinGJ;A6B9mGE;EAKE,cArBa;EAsBb,yB5B2IW;E4B1IX,qB5B0IW;ADk+Ff;A6B1mGI;ElB7FE,+CARW;AXktGjB;A6BnmGE;EAEE,c5B4HW;E4B3HX,6BAAA;A7BomGJ;;A4B3pGE;ECmBA,Y5B+Ja;E4B9Jb,mB5B8Ja;AD8+Ff;A6B1oGE;EACE,cATY;EAUZ,uB5B0JW;E4BzJX,mB5ByJW;ADm/Ff;A6BzoGE;EAEE,sCAAA;A7B0oGJ;A6BvoGE;EAKE,cArBa;EAsBb,uB5B2IW;E4B1IX,mB5B0IW;AD2/Ff;A6BnoGI;ElB7FE,4CARW;AX2uGjB;A6B5nGE;EAEE,Y5B4HW;E4B3HX,6BAAA;A7B6nGJ;;A4BxqGA;EACE,gB3BwY4B;E2BvY5B,c3BuEc;E2BtEd,qB3BuP0B;ADo7F5B;A4BzqGE;EACE,c3BqPwB;E2BpPxB,qB3BqPwB;ADs7F5B;A4BxqGE;EACE,qB3BiPwB;ADy7F5B;A4BvqGE;EAEE,c3BzEO;ADivGX;;A4B7pGA;ECuBE,kBAAA;EzBsKI,cALI;EE7QN,wBAAA;ANwvGJ;;A4B/pGA;ECmBE,iBAAA;EzBsKI,kBALI;EE7QN,sBAAA;AN8vGJ;;A8BjxGA;EVgBM,gCUfJ;A9BoxGF;AoBjwGM;EUpBN;IVqBQ,gBAAA;EpBowGN;AACF;A8BvxGE;EACE,UAAA;A9ByxGJ;;A8BnxGE;EACE,aAAA;A9BsxGJ;;A8BlxGA;EACE,SAAA;EACA,gBAAA;EVDI,6BUEJ;A9BqxGF;AoBnxGM;EULN;IVMQ,gBAAA;EpBsxGN;AACF;;A+B3yGA;;;;EAIE,kBAAA;A/B8yGF;;A+B3yGA;EACE,mBAAA;A/B8yGF;AgCzxGI;EACE,qBAAA;EACA,oB3BwWwB;E2BvWxB,uB3BsWwB;E2BrWxB,WAAA;EAhCJ,uBAAA;EACA,qCAAA;EACA,gBAAA;EACA,oCAAA;AhC4zGF;AgCvwGI;EACE,cAAA;AhCywGN;;A+BpzGA;EACE,kBAAA;EACA,a1Bu3BkC;E0Bt3BlC,aAAA;EACA,gB1B48BkC;E0B38BlC,iBAAA;EACA,SAAA;E3B+QI,mBALI;E2BxQR,c9BHS;E8BIT,gBAAA;EACA,gBAAA;EACA,yB9BbS;E8BcT,4BAAA;EACA,mCAAA;EzBVE,wBAAA;EKLE,iHARW;AXg1GjB;A+BrzGE;EACE,SAAA;EACA,OAAA;EACA,oB1B+7BgC;ALw3EpC;;A+B3yGI;EACE,oBAAA;A/B8yGN;A+B5yGM;EACE,WAAA;EACA,OAAA;A/B8yGR;;A+B1yGI;EACE,kBAAA;A/B6yGN;A+B3yGM;EACE,QAAA;EACA,UAAA;A/B6yGR;;Ac5yGI;EiBfA;IACE,oBAAA;E/B+zGJ;E+B7zGI;IACE,WAAA;IACA,OAAA;E/B+zGN;E+B3zGE;IACE,kBAAA;E/B6zGJ;E+B3zGI;IACE,QAAA;IACA,UAAA;E/B6zGN;AACF;Ac7zGI;EiBfA;IACE,oBAAA;E/B+0GJ;E+B70GI;IACE,WAAA;IACA,OAAA;E/B+0GN;E+B30GE;IACE,kBAAA;E/B60GJ;E+B30GI;IACE,QAAA;IACA,UAAA;E/B60GN;AACF;Ac70GI;EiBfA;IACE,oBAAA;E/B+1GJ;E+B71GI;IACE,WAAA;IACA,OAAA;E/B+1GN;E+B31GE;IACE,kBAAA;E/B61GJ;E+B31GI;IACE,QAAA;IACA,UAAA;E/B61GN;AACF;Ac71GI;EiBfA;IACE,oBAAA;E/B+2GJ;E+B72GI;IACE,WAAA;IACA,OAAA;E/B+2GN;E+B32GE;IACE,kBAAA;E/B62GJ;E+B32GI;IACE,QAAA;IACA,UAAA;E/B62GN;AACF;A+Bp2GE;EACE,SAAA;EACA,YAAA;EACA,aAAA;EACA,uB1Bu5BgC;AL+8EpC;AgCp5GI;EACE,qBAAA;EACA,oB3BwWwB;E2BvWxB,uB3BsWwB;E2BrWxB,WAAA;EAzBJ,aAAA;EACA,qCAAA;EACA,0BAAA;EACA,oCAAA;AhCg7GF;AgCl4GI;EACE,cAAA;AhCo4GN;;A+B12GE;EACE,MAAA;EACA,WAAA;EACA,UAAA;EACA,aAAA;EACA,qB1By4BgC;ALo+EpC;AgCz6GI;EACE,qBAAA;EACA,oB3BwWwB;E2BvWxB,uB3BsWwB;E2BrWxB,WAAA;EAlBJ,mCAAA;EACA,eAAA;EACA,sCAAA;EACA,wBAAA;AhC87GF;AgCv5GI;EACE,cAAA;AhCy5GN;A+Br3GI;EACE,iBAAA;A/Bu3GN;;A+Bj3GE;EACE,MAAA;EACA,WAAA;EACA,UAAA;EACA,aAAA;EACA,sB1Bw3BgC;AL4/EpC;AgCj8GI;EACE,qBAAA;EACA,oB3BwWwB;E2BvWxB,uB3BsWwB;E2BrWxB,WAAA;AhCm8GN;AgCx7GM;EACE,aAAA;AhC07GR;AgCv7GM;EACE,qBAAA;EACA,qB3BqVsB;E2BpVtB,uB3BmVsB;E2BlVtB,WAAA;EA9BN,mCAAA;EACA,yBAAA;EACA,sCAAA;AhCw9GF;AgCv7GI;EACE,cAAA;AhCy7GN;A+Bp4GI;EACE,iBAAA;A/Bs4GN;;A+B/3GA;EACE,SAAA;EACA,gBAAA;EACA,gBAAA;EACA,yCAAA;A/Bk4GF;;A+B53GA;EACE,cAAA;EACA,WAAA;EACA,qBAAA;EACA,WAAA;EACA,gB9B+U4B;E8B9U5B,c9BjHS;E8BkHT,mBAAA;EAEA,mBAAA;EACA,6BAAA;EACA,SAAA;A/B83GF;A+Bh3GE;EAEE,c1Bm1BgC;EgB5+BlC,yBpBYS;AD+/GX;A+B72GE;EAEE,c9BtJO;E8BuJP,qBAAA;EVjKF,yBpBkJc;AD83GhB;A+B32GE;EAEE,c9BxJO;E8ByJP,oBAAA;EACA,6BAAA;A/B42GJ;;A+Bt2GA;EACE,cAAA;A/By2GF;;A+Br2GA;EACE,cAAA;EACA,oB1Bk0BkC;E0Bj0BlC,gBAAA;E3B0GI,0BALI;E2BnGR,c9BzKS;E8B0KT,mBAAA;A/Bw2GF;;A+Bp2GA;EACE,cAAA;EACA,qBAAA;EACA,c9B9KS;ADqhHX;;A+Bn2GA;EACE,c9BzLS;E8B0LT,yB9BrLS;E8BsLT,iC9BojBkC;ADkzFpC;A+Bn2GE;EACE,c9B/LO;ADoiHX;A+Bn2GI;EAEE,c9BtMK;EoBVT,2ChBmgCkC;ALkjFpC;A+Bj2GI;EAEE,c9B5MK;EoBVT,yBpBkJc;ADu6GhB;A+B/1GI;EAEE,c9B7MK;AD6iHX;A+B51GE;EACE,iC9B2hBgC;ADm0FpC;A+B31GE;EACE,c9BxNO;ADqjHX;A+B11GE;EACE,c9B1NO;ADsjHX;;AiCxkHA;;EAEE,kBAAA;EACA,oBAAA;EACA,sBAAA;AjC2kHF;AiCzkHE;;EACE,kBAAA;EACA,cAAA;AjC4kHJ;AiCvkHE;;;;;;;;;;;;EAME,UAAA;AjC+kHJ;;AiC1kHA;EACE,aAAA;EACA,eAAA;EACA,2BAAA;AjC6kHF;AiC3kHE;EACE,WAAA;AjC6kHJ;;AiCvkHE;;EAEE,iBAAA;AjC0kHJ;AiCtkHE;;E3BRE,0BAAA;EACA,6BAAA;ANklHJ;AiClkHE;;;E3BHE,yBAAA;EACA,4BAAA;AN0kHJ;;AiCrjHA;EACE,mBAAA;EACA,kBAAA;AjCwjHF;AiCtjHE;EAGE,cAAA;AjCsjHJ;AiCnjHE;EACE,eAAA;AjCqjHJ;;AiCjjHA;EACE,sBAAA;EACA,qBAAA;AjCojHF;;AiCjjHA;EACE,mBAAA;EACA,kBAAA;AjCojHF;;AiC9iHA;EtBrFM,gBARW;AX+oHjB;AiC9iHE;EtBzFI,gBARW;AXkpHjB;;AiCviHA;EACE,sBAAA;EACA,uBAAA;EACA,uBAAA;AjC0iHF;AiCxiHE;;EAEE,WAAA;AjC0iHJ;AiCviHE;;EAEE,gBAAA;AjCyiHJ;AiCriHE;;E3BvFE,6BAAA;EACA,4BAAA;ANgoHJ;AiCriHE;;E3B1GE,yBAAA;EACA,0BAAA;ANmpHJ;;A0B5qHA;EACE,kBAAA;EACA,aAAA;EACA,eAAA;EACA,oBAAA;EACA,WAAA;A1B+qHF;A0B7qHE;;EAEE,kBAAA;EACA,cAAA;EACA,SAAA;EACA,YAAA;A1B+qHJ;A0B3qHE;;EAEE,UAAA;A1B6qHJ;A0BvqHE;EACE,kBAAA;EACA,UAAA;A1ByqHJ;A0BvqHI;EACE,UAAA;A1ByqHN;;A0B9pHA;EACE,aAAA;EACA,mBAAA;EACA,sBAAA;EtBsPI,mBALI;EsB/OR,gBzBqa4B;EyBpa5B,qBzB2a6B;EyB1a7B,czBhCS;EyBiCT,kBAAA;EACA,mBAAA;EACA,6BzB7B2B;EyB8B3B,yBAAA;EpBpCE,sBAAA;ANssHJ;;A0BxpHA;;;;EAIE,sBAAA;EtBgOI,mBALI;EE7QN,wBAAA;AN+sHJ;;A0BxpHA;;;;EAIE,uBAAA;EtBuNI,kBALI;EE7QN,wBAAA;ANwtHJ;;A0BxpHA;;EAEE,qBAAA;A1B2pHF;;A0B9oHI;;EpB/DA,0BAAA;EACA,6BAAA;ANktHJ;A0B7oHI;;EpBtEA,0BAAA;EACA,6BAAA;ANutHJ;A0BvoHE;EACE,iBAAA;EpBpEA,yBAAA;EACA,4BAAA;AN8sHJ;;AkC3vHA;EACE,aAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;AlC8vHF;;AkC3vHA;EACE,cAAA;EACA,oBAAA;EAGA,cjCGS;EmBLL,uGcIJ;AlC2vHF;AoB3vHM;EcPN;IdQQ,gBAAA;EpB8vHN;AACF;AkC9vHE;EAEE,cjCgTwB;AD+8G5B;AkC1vHE;EACE,cjCVO;EiCWP,oBAAA;EACA,eAAA;AlC4vHJ;;AkCpvHA;EACE,sCAAA;AlCuvHF;AkCrvHE;EACE,yBAAA;EACA,gBAAA;EACA,mCAAA;E5BlBA,+BAAA;EACA,gCAAA;AN0wHJ;AkCtvHI;EAEE,qC7Bg3B8B;E6B92B9B,kBAAA;AlCsvHN;AkCnvHI;EACE,cjCrCK;EiCsCL,6BAAA;EACA,yBAAA;AlCqvHN;AkCjvHE;;EAEE,cjC5CO;EiC6CP,yBjCiHyB;EiChHzB,qC7Bm2BgC;ALg5FpC;AkChvHE;EAEE,sBAAA;E5B5CA,yBAAA;EACA,0BAAA;AN8xHJ;;AkCvuHE;EACE,gBAAA;EACA,SAAA;E5BnEA,sBAAA;AN8yHJ;AkCvuHE;;EAEE,yBjC8rBgC;EoBtxBlC,yBpBkJc;ADgrHhB;;AkC/tHE;;EAEE,cAAA;EACA,kBAAA;AlCkuHJ;;AkC7tHE;;EAEE,aAAA;EACA,YAAA;EACA,kBAAA;AlCguHJ;;AkC1tHE;;EACE,WAAA;AlC8tHJ;;AkCptHE;EACE,aAAA;AlCutHJ;AkCrtHE;EACE,cAAA;AlCutHJ;;AmC/0HA;EACE,kBAAA;EACA,aAAA;EACA,eAAA;EACA,mBAAA;EACA,8BAAA;EACA,qBlC2wBkC;EkC1wBlC,wBlC2wBkC;EkC1wBlC,wBlCywBkC;EkCxwBlC,uBlCywBkC;ADykGpC;AmC50HE;;EACE,aAAA;EACA,kBAAA;EACA,mBAAA;EACA,8BAAA;AnC+0HJ;AmC3zHA;EACE,yB9Bk4BkC;E8Bj4BlC,4B9Bi4BkC;E8Bh4BlC,kB9Bi4BkC;EDtpB9B,qBALI;E+BnOR,mBAAA;AnC4zHF;AmC/yHA;EACE,aAAA;EACA,sBAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;AnCizHF;AmC/yHE;EACE,gBAAA;EACA,eAAA;AnCizHJ;AmC9yHE;EACE,gBAAA;AnCgzHJ;;AmCvyHA;EACE,mBlCwqBkC;EkCvqBlC,sBlCuqBkC;ADmoGpC;;AmC9xHA;EACE,gBAAA;EACA,YAAA;EAGA,mBAAA;AnC+xHF;;AmC3xHA;EACE,wBAAA;E/B6KI,qBALI;E+BtKR,cAAA;EACA,6BAAA;EACA,mCAAA;E7BzGE,sBAAA;EcHE,wCe8GJ;AnC8xHF;AoBx4HM;EemGN;IflGQ,gBAAA;EpB24HN;AACF;AmCjyHE;EACE,qBAAA;AnCmyHJ;AmChyHE;EACE,qBAAA;EACA,UAAA;EACA,mBAAA;AnCkyHJ;;AmC5xHA;EACE,qBAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,4BAAA;EACA,2BAAA;EACA,qBAAA;AnC+xHF;;AmC5xHA;EACE,gBAAA;EAAA,yCAAA;EACA,gBAAA;AnC+xHF;;Acz3HI;EqBsGA;IAEI,iBAAA;IACA,2BAAA;EnCsxHN;EmCpxHM;IACE,mBAAA;EnCsxHR;EmCpxHQ;IACE,kBAAA;EnCsxHV;EmCnxHQ;IACE,mBlCknBwB;IkCjnBxB,kBlCinBwB;EDoqGlC;EmCjxHM;IACE,iBAAA;EnCmxHR;EmChxHM;IACE,wBAAA;IACA,gBAAA;EnCkxHR;EmC/wHM;IACE,aAAA;EnCixHR;AACF;Acp5HI;EqBsGA;IAEI,iBAAA;IACA,2BAAA;EnCgzHN;EmC9yHM;IACE,mBAAA;EnCgzHR;EmC9yHQ;IACE,kBAAA;EnCgzHV;EmC7yHQ;IACE,mBlCknBwB;IkCjnBxB,kBlCinBwB;ED8rGlC;EmC3yHM;IACE,iBAAA;EnC6yHR;EmC1yHM;IACE,wBAAA;IACA,gBAAA;EnC4yHR;EmCzyHM;IACE,aAAA;EnC2yHR;AACF;Ac96HI;EqBsGA;IAEI,iBAAA;IACA,2BAAA;EnC00HN;EmCx0HM;IACE,mBAAA;EnC00HR;EmCx0HQ;IACE,kBAAA;EnC00HV;EmCv0HQ;IACE,mBlCknBwB;IkCjnBxB,kBlCinBwB;EDwtGlC;EmCr0HM;IACE,iBAAA;EnCu0HR;EmCp0HM;IACE,wBAAA;IACA,gBAAA;EnCs0HR;EmCn0HM;IACE,aAAA;EnCq0HR;AACF;Acx8HI;EqBsGA;IAEI,iBAAA;IACA,2BAAA;EnCo2HN;EmCl2HM;IACE,mBAAA;EnCo2HR;EmCl2HQ;IACE,kBAAA;EnCo2HV;EmCj2HQ;IACE,mBlCknBwB;IkCjnBxB,kBlCinBwB;EDkvGlC;EmC/1HM;IACE,iBAAA;EnCi2HR;EmC91HM;IACE,wBAAA;IACA,gBAAA;EnCg2HR;EmC71HM;IACE,aAAA;EnC+1HR;AACF;AmC53HI;EAEI,iBAAA;EACA,2BAAA;AnC63HR;AmC33HQ;EACE,mBAAA;AnC63HV;AmC33HU;EACE,kBAAA;AnC63HZ;AmC13HU;EACE,mBlCknBwB;EkCjnBxB,kBlCinBwB;AD2wGpC;AmCx3HQ;EACE,iBAAA;AnC03HV;AmCv3HQ;EACE,wBAAA;EACA,gBAAA;AnCy3HV;AmCt3HQ;EACE,aAAA;AnCw3HV;;AmCz2HE;EACE,yBlC6mBgC;AD+vGpC;AmC12HI;EAEE,yBlCymB8B;ADkwGpC;AmCt2HI;EACE,yBlCimB8B;ADuwGpC;AmCt2HM;EAEE,yBlC8lB4B;ADywGpC;AmCp2HM;EACE,yBlC4lB4B;AD0wGpC;AmCl2HI;;EAEE,yBlCqlB8B;AD+wGpC;AmCh2HE;EACE,yBlC8kBgC;EkC7kBhC,yBlCklBgC;ADgxGpC;AmC/1HE;EACE,yDAAA;AnCi2HJ;AmC91HE;EACE,yBlCqkBgC;AD2xGpC;AmC91HI;;;EAGE,yBlCkkB8B;AD8xGpC;;AmCz1HE;EACE,gClCijBgC;AD2yGpC;AmC11HI;EAEE,gClC6iB8B;AD8yGpC;AmCt1HI;EACE,gClCqiB8B;ADmzGpC;AmCt1HM;EAEE,gClCkiB4B;ADqzGpC;AmCp1HM;EACE,gClCgiB4B;ADszGpC;AmCl1HI;;EAEE,gClCyhB8B;AD2zGpC;AmCh1HE;EACE,gClCkhBgC;EkCjhBhC,yBlCqhBgC;AD6zGpC;AmC/0HE;EACE,0DAAA;AnCi1HJ;AmC90HE;EACE,gClCygBgC;ADu0GpC;AmC/0HI;;;EAGE,gClCugB8B;AD00GpC;;AoC3nIA;EACE,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;EAEA,qBAAA;EACA,yBnCGS;EmCFT,2BAAA;EACA,2CAAA;E9BME,wBAAA;ANwnIJ;AoC3nIE;EACE,eAAA;EACA,cAAA;ApC6nIJ;AoC1nIE;EACE,mBAAA;EACA,sBAAA;ApC4nIJ;AoC1nII;EACE,mBAAA;E9BEF,mDAAA;EACA,oDAAA;AN2nIJ;AoC1nII;EACE,sBAAA;E9BWF,uDAAA;EACA,sDAAA;ANknIJ;AoCvnIE;;EAEE,aAAA;ApCynIJ;;AoCrnIA;EAGE,cAAA;EACA,uBAAA;ApCsnIF;;AoClnIA;EACE,qB/BwgCkC;AL6mGpC;;AoClnIA;EACE,oBAAA;EACA,gBAAA;ApCqnIF;;AoClnIA;EACE,gBAAA;ApCqnIF;;AoCjnIE;EACE,qBAAA;ApConIJ;AoCjnIE;EACE,mBnC43BgC;ADuvGpC;;AoC3mIA;EACE,wBAAA;EACA,gBAAA;EAEA,yBnCpES;EmCqET,kDAAA;ApC6mIF;AoC3mIE;E9BnEE,0EAAA;ANirIJ;;AoCzmIA;EACE,wBAAA;EAEA,yBnC/ES;EmCgFT,+CAAA;ApC2mIF;AoCzmIE;E9B9EE,0EAAA;AN0rIJ;;AoClmIA;EACE,sBAAA;EACA,wBAAA;EACA,qBAAA;EACA,gBAAA;ApCqmIF;AoClmII;EACE,yBnCrGK;EmCsGL,4BnCtGK;AD0sIX;;AoC/lIA;EACE,sBAAA;EACA,qBAAA;ApCkmIF;;AoC9lIA;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,gBnCs0BkC;EKx7BhC,0CAAA;ANotIJ;;AoC9lIA;;;EAGE,WAAA;ApCimIF;;AoC9lIA;;E9BnHI,mDAAA;EACA,oDAAA;ANstIJ;;AoC/lIA;;E9B1GI,uDAAA;EACA,sDAAA;AN8sIJ;;AoCxlIE;EACE,sB/Bw6BgC;ALmrGpC;Ac9rII;EsB+FJ;IAQI,aAAA;IACA,mBAAA;EpC2lIF;EoCxlIE;IAEE,SAAA;IACA,gBAAA;EpCylIJ;EoCvlII;IACE,cAAA;IACA,cAAA;EpCylIN;EoCplIM;I9BnJJ,0BAAA;IACA,6BAAA;EN0uIF;EoCrlIQ;;IAGE,0BAAA;EpCslIV;EoCplIQ;;IAGE,6BAAA;EpCqlIV;EoCjlIM;I9BpJJ,yBAAA;IACA,4BAAA;ENwuIF;EoCllIQ;;IAGE,yBAAA;EpCmlIV;EoCjlIQ;;IAGE,4BAAA;EpCklIV;AACF;;AqCnyIA;EACE,aAAA;EACA,eAAA;EACA,YAAA;EACA,mBhC60CkC;EgC30ClC,gBAAA;EACA,yBpCwKqB;AD6nIvB;;AqC/xIE;EACE,oBhCk0CgC;ALg+FpC;AqChyII;EACE,WAAA;EACA,qBhC8zC8B;EgC7zC9B,cpCLK;EoCML,yDAAA;EAAA,uFAAA;ArCkyIN;AqC9xIE;EACE,cpCXO;AD2yIX;;AsCzzIA;EACE,aAAA;E9BGA,eAAA;EACA,gBAAA;AR0zIF;;AsC1zIA;EACE,kBAAA;EACA,cAAA;EACA,crCMS;EqCJT,6BrCk6BkC;EqCj6BlC,+BAAA;ElBKI,qIkBJJ;AtC4zIF;AoBpzIM;EkBfN;IlBgBQ,gBAAA;EpBuzIN;AACF;AsC/zIE;EACE,UAAA;EACA,crCIO;EqCFP,yBrCDO;EqCEP,qBrCFO;ADk0IX;AsC7zIE;EACE,UAAA;EACA,crCgTwB;EqC/SxB,yBrCTO;EqCUP,UjCygCgC;EiCxgChC,gBrC4iB0B;ADmxH9B;;AsC1zIE;EACE,uBjC4/BgC;ALi0GpC;AsC1zIE;EACE,UAAA;EACA,crCxBO;EoBVT,yBpBkJc;EqC9GZ,qBrC8GY;AD8sIhB;AsCzzIE;EACE,crCxBO;EqCyBP,oBAAA;EACA,6BrC84BgC;EqC74BhC,qBrC9BO;ADy1IX;;AuCt2IE;EACE,oBAAA;AvCy2IJ;;AuCl2IQ;EjCqCJ,+BAAA;EACA,kCAAA;ANi0IJ;AuCj2IQ;EjCiBJ,gCAAA;EACA,mCAAA;ANm1IJ;;AuCn3IE;EACE,uBAAA;EnCgSE,qBALI;AJ4lIV;AuCh3IQ;EjCqCJ,iCAAA;EACA,oCAAA;AN80IJ;AuC92IQ;EjCiBJ,kCAAA;EACA,qCAAA;ANg2IJ;;AuCh4IE;EACE,uBAAA;EnCgSE,0BALI;AJymIV;AuC73IQ;EjCqCJ,iCAAA;EACA,oCAAA;AN21IJ;AuC33IQ;EjCiBJ,kCAAA;EACA,qCAAA;AN62IJ;;AwC54IA;EACE,qBAAA;EACA,uBAAA;EpC8RI,qBALI;EoCvRR,gBvC+c4B;EuC9c5B,cAAA;EACA,cvCGS;EuCFT,kBAAA;EACA,mBAAA;EACA,wBAAA;ElCKE,sBAAA;AN24IJ;AwC34IE;EACE,aAAA;AxC64IJ;;AwCx4IA;EACE,kBAAA;EACA,SAAA;AxC24IF;;AyCl6IA;EACE,kBAAA;EACA,uBAAA;EACA,mBpCuvC8B;EoCtvC9B,mCAAA;EnCWE,wBAAA;AN25IJ;;AyCj6IA;EAEE,cAAA;AzCm6IF;;AyC/5IA;EACE,gBxCmc4B;AD+9H9B;;AyC15IA;EACE,sBpCwuC8B;ALqrGhC;AyC15IE;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,UAAA;EACA,yBAAA;AzC45IJ;;AyC74IE;EClDA,cD8Cc;EpB5Cd,yBoB0CmB;EC1CnB,qBD2Ce;AzCw5IjB;A0Cj8IE;EACE,cAAA;A1Cm8IJ;;AyCt5IE;EClDA,cD8Cc;EpB5Cd,yBoB0CmB;EC1CnB,qBD2Ce;AzCi6IjB;A0C18IE;EACE,cAAA;A1C48IJ;;AyC/5IE;EClDA,cDgDgB;EpB9ChB,yBoB0CmB;EC1CnB,qBD2Ce;AzC06IjB;A0Cn9IE;EACE,cAAA;A1Cq9IJ;;AyCx6IE;EClDA,cD8Cc;EpB5Cd,yBoB0CmB;EC1CnB,qBD2Ce;AzCm7IjB;A0C59IE;EACE,cAAA;A1C89IJ;;AyCj7IE;EClDA,cD8Cc;EpB5Cd,yBoB0CmB;EC1CnB,qBD2Ce;AzC47IjB;A0Cr+IE;EACE,cAAA;A1Cu+IJ;;AyC17IE;EClDA,cD8Cc;EpB5Cd,yBoB0CmB;EC1CnB,qBD2Ce;AzCq8IjB;A0C9+IE;EACE,cAAA;A1Cg/IJ;;AyCn8IE;EClDA,cD8Cc;EpB5Cd,yBoB0CmB;EC1CnB,qBD2Ce;AzC88IjB;A0Cv/IE;EACE,cAAA;A1Cy/IJ;;AyC58IE;EClDA,cDgDgB;EpB9ChB,uBoB0CmB;EC1CnB,mBD2Ce;AzCu9IjB;A0ChgJE;EACE,cAAA;A1CkgJJ;;AyCr9IE;EClDA,cDgDgB;EpB9ChB,uBoB0CmB;EC1CnB,mBD2Ce;AzCg+IjB;A0CzgJE;EACE,cAAA;A1C2gJJ;;AyC99IE;EClDA,cD8Cc;EpB5Cd,yBoB0CmB;EC1CnB,qBD2Ce;AzCy+IjB;A0ClhJE;EACE,cAAA;A1CohJJ;;AyCv+IE;EClDA,YD8Cc;EpB5Cd,yBoB0CmB;EC1CnB,qBD2Ce;AzCk/IjB;A0C3hJE;EACE,YAAA;A1C6hJJ;;A2ChiJE;EACE;IAAK,6B1Cw/B2B;ED4iHlC;AACF;A2ChiJA;EACE,aAAA;EACA,c1Ci/BkC;E0Ch/BlC,gBAAA;EvCwRI,qBALI;EuCjRR,oC1C++BkC;EK3+BhC,uBAAA;EKLE,8CARW;AX6iJjB;;A2C/hJA;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,gBAAA;EACA,c1CXS;E0CYT,kBAAA;EACA,mBAAA;EACA,yB1C0Hc;EmBtIV,2BuBaJ;A3CkiJF;AoB3iJM;EuBAN;IvBCQ,gBAAA;EpB8iJN;AACF;;A2CpiJA;EtBYE,qMAAA;EsBVA,8BAAA;A3CuiJF;;A2CniJE;EACE,kDAAA;A3CsiJJ;A2CniJM;EAJJ;IAKM,eAAA;E3CsiJN;AACF;;A4C9kJA;EACE,aAAA;EACA,sBAAA;EAGA,eAAA;EACA,gBAAA;EtCSE,sBAAA;ANukJJ;;A4C5kJA;EACE,qBAAA;EACA,sBAAA;A5C+kJF;A4C7kJE;EAEE,oCAAA;EACA,0BAAA;A5C8kJJ;;A4CpkJA;EACE,WAAA;EACA,c3CZS;E2CaT,mBAAA;A5CukJF;A4CpkJE;EAEE,UAAA;EACA,c3CnBO;E2CoBP,qBAAA;EACA,yB3C3BO;ADgmJX;A4ClkJE;EACE,c3CzBO;E2C0BP,yB3C/BO;ADmmJX;;A4C3jJA;EACE,kBAAA;EACA,cAAA;EACA,kBAAA;EACA,c3CrCS;E2CuCT,yB3ChDS;E2CiDT,+BAAA;A5C6jJF;A4C3jJE;EtCrCE,+BAAA;EACA,gCAAA;ANmmJJ;A4C3jJE;EtC3BE,mCAAA;EACA,kCAAA;ANylJJ;A4C3jJE;EAEE,c3CvDO;E2CwDP,oBAAA;EACA,yB3C/DO;AD2nJX;A4CxjJE;EACE,UAAA;EACA,c3CrEO;E2CsEP,yB3CkEY;E2CjEZ,qB3CiEY;ADy/IhB;A4CvjJE;EACE,mBAAA;A5CyjJJ;A4CvjJI;EACE,sBAAA;EACA,2B3CuTwB;ADkwI9B;;A4C3iJI;EACE,mBAAA;A5C8iJN;A4C3iJQ;EtCrCJ,kCAAA;EAZA,0BAAA;ANgmJJ;A4C1iJQ;EtCtDJ,gCAAA;EAYA,4BAAA;ANwlJJ;A4CziJQ;EACE,aAAA;A5C2iJV;A4CxiJQ;EACE,2B3CsRoB;E2CrRpB,oBAAA;A5C0iJV;A4CxiJU;EACE,uBAAA;EACA,4B3CiRkB;ADyxI9B;;Ac9mJI;E8B4CA;IACE,mBAAA;E5CskJJ;E4CnkJM;ItCrCJ,kCAAA;IAZA,0BAAA;ENwnJF;E4ClkJM;ItCtDJ,gCAAA;IAYA,4BAAA;ENgnJF;E4CjkJM;IACE,aAAA;E5CmkJR;E4ChkJM;IACE,2B3CsRoB;I2CrRpB,oBAAA;E5CkkJR;E4ChkJQ;IACE,uBAAA;IACA,4B3CiRkB;EDizI5B;AACF;AcvoJI;E8B4CA;IACE,mBAAA;E5C8lJJ;E4C3lJM;ItCrCJ,kCAAA;IAZA,0BAAA;ENgpJF;E4C1lJM;ItCtDJ,gCAAA;IAYA,4BAAA;ENwoJF;E4CzlJM;IACE,aAAA;E5C2lJR;E4CxlJM;IACE,2B3CsRoB;I2CrRpB,oBAAA;E5C0lJR;E4CxlJQ;IACE,uBAAA;IACA,4B3CiRkB;EDy0I5B;AACF;Ac/pJI;E8B4CA;IACE,mBAAA;E5CsnJJ;E4CnnJM;ItCrCJ,kCAAA;IAZA,0BAAA;ENwqJF;E4ClnJM;ItCtDJ,gCAAA;IAYA,4BAAA;ENgqJF;E4CjnJM;IACE,aAAA;E5CmnJR;E4ChnJM;IACE,2B3CsRoB;I2CrRpB,oBAAA;E5CknJR;E4ChnJQ;IACE,uBAAA;IACA,4B3CiRkB;EDi2I5B;AACF;AcvrJI;E8B4CA;IACE,mBAAA;E5C8oJJ;E4C3oJM;ItCrCJ,kCAAA;IAZA,0BAAA;ENgsJF;E4C1oJM;ItCtDJ,gCAAA;IAYA,4BAAA;ENwrJF;E4CzoJM;IACE,aAAA;E5C2oJR;E4CxoJM;IACE,2B3CsRoB;I2CrRpB,oBAAA;E5C0oJR;E4CxoJQ;IACE,uBAAA;IACA,4B3CiRkB;EDy3I5B;AACF;A4C7nJA;EtC9HI,gBAAA;AN8vJJ;A4C7nJE;EACE,2BAAA;A5C+nJJ;A4C7nJI;EACE,sBAAA;A5C+nJN;;A6CnxJE;EACE,cDiKyB;EChKzB,yBD+JsB;A5CunJ1B;A6CnxJM;EAEE,cD2JqB;EC1JrB,yBAAA;A7CoxJR;A6CjxJM;EACE,c5CFG;E4CGH,yBDqJqB;ECpJrB,qBDoJqB;A5C+nJ7B;;A6CjyJE;EACE,cDiKyB;EChKzB,yBD+JsB;A5CqoJ1B;A6CjyJM;EAEE,cD2JqB;EC1JrB,yBAAA;A7CkyJR;A6C/xJM;EACE,c5CFG;E4CGH,yBDqJqB;ECpJrB,qBDoJqB;A5C6oJ7B;;A6C/yJE;EACE,cDmK2B;EClK3B,yBD+JsB;A5CmpJ1B;A6C/yJM;EAEE,cD6JuB;EC5JvB,yBAAA;A7CgzJR;A6C7yJM;EACE,c5CFG;E4CGH,yBDuJuB;ECtJvB,qBDsJuB;A5CypJ/B;;A6C7zJE;EACE,cDiKyB;EChKzB,yBD+JsB;A5CiqJ1B;A6C7zJM;EAEE,cD2JqB;EC1JrB,yBAAA;A7C8zJR;A6C3zJM;EACE,c5CFG;E4CGH,yBDqJqB;ECpJrB,qBDoJqB;A5CyqJ7B;;A6C30JE;EACE,cDiKyB;EChKzB,yBD+JsB;A5C+qJ1B;A6C30JM;EAEE,cD2JqB;EC1JrB,yBAAA;A7C40JR;A6Cz0JM;EACE,c5CFG;E4CGH,yBDqJqB;ECpJrB,qBDoJqB;A5CurJ7B;;A6Cz1JE;EACE,cDiKyB;EChKzB,yBD+JsB;A5C6rJ1B;A6Cz1JM;EAEE,cD2JqB;EC1JrB,yBAAA;A7C01JR;A6Cv1JM;EACE,c5CFG;E4CGH,yBDqJqB;ECpJrB,qBDoJqB;A5CqsJ7B;;A6Cv2JE;EACE,cDiKyB;EChKzB,yBD+JsB;A5C2sJ1B;A6Cv2JM;EAEE,cD2JqB;EC1JrB,yBAAA;A7Cw2JR;A6Cr2JM;EACE,c5CFG;E4CGH,yBDqJqB;ECpJrB,qBDoJqB;A5CmtJ7B;;A6Cr3JE;EACE,cDmK2B;EClK3B,uBD+JsB;A5CytJ1B;A6Cr3JM;EAEE,cD6JuB;EC5JvB,yBAAA;A7Cs3JR;A6Cn3JM;EACE,c5CFG;E4CGH,yBDuJuB;ECtJvB,qBDsJuB;A5C+tJ/B;;A6Cn4JE;EACE,cDmK2B;EClK3B,uBD+JsB;A5CuuJ1B;A6Cn4JM;EAEE,cD6JuB;EC5JvB,yBAAA;A7Co4JR;A6Cj4JM;EACE,c5CFG;E4CGH,yBDuJuB;ECtJvB,qBDsJuB;A5C6uJ/B;;A6Cj5JE;EACE,cDiKyB;EChKzB,yBD+JsB;A5CqvJ1B;A6Cj5JM;EAEE,cD2JqB;EC1JrB,yBAAA;A7Ck5JR;A6C/4JM;EACE,c5CFG;E4CGH,yBDqJqB;ECpJrB,qBDoJqB;A5C6vJ7B;;A6C/5JE;EACE,YDiKyB;EChKzB,yBD+JsB;A5CmwJ1B;A6C/5JM;EAEE,YD2JqB;EC1JrB,yBAAA;A7Cg6JR;A6C75JM;EACE,c5CFG;E4CGH,uBDqJqB;ECpJrB,mBDoJqB;A5C2wJ7B;;A8C56JA;EACE,uBAAA;EACA,UzC04C2B;EyCz4C3B,WzCy4C2B;EyCx4C3B,sBAAA;EACA,c7CsDM;E6CrDN,0FAAA;EACA,SAAA;ExCOE,sBAAA;EwCLF,YzC04C2B;ALqiH7B;A8C56JE;EACE,c7C8CI;E6C7CJ,qBAAA;EACA,azCq4CyB;ALyiH7B;A8C36JE;EACE,UAAA;EACA,gB7C8iB0B;E6C7iB1B,UzCg4CyB;AL6iH7B;A8C16JE;EAEE,oBAAA;EACA,yBAAA;UAAA,iBAAA;EACA,azC03CyB;ALijH7B;;A8Cv6JA;EACE,kDzCs3C2B;ALojH7B;;A+C/8JA;EACE,kBAAA;EACA,a1C64BkC;E0C54BlC,cAAA;EACA,S9Cy9BkC;E+C79BlC,kC/Ckc4B;E+Chc5B,kBAAA;EACA,gB/Ckd4B;E+Cjd5B,gB3Ckb4B;E2Cjb5B,gBAAA;EACA,iBAAA;EACA,qBAAA;EACA,iBAAA;EACA,oBAAA;EACA,sBAAA;EACA,kBAAA;EACA,oBAAA;EACA,mBAAA;EACA,gBAAA;E5CsRI,0BALI;E2CrRR,qBAAA;EACA,UAAA;A/C49JF;A+C19JE;EAAS,Y9C68ByB;ADghIpC;A+C39JE;EACE,kBAAA;EACA,cAAA;EACA,a9C68BgC;E8C58BhC,c9C68BgC;ADghIpC;A+C39JI;EACE,kBAAA;EACA,WAAA;EACA,yBAAA;EACA,mBAAA;A/C69JN;;A+Cx9JA;EACE,iBAAA;A/C29JF;A+Cz9JE;EACE,SAAA;A/C29JJ;A+Cz9JI;EACE,SAAA;EACA,6BAAA;EACA,yB9C1BK;ADq/JX;;A+Ct9JA;EACE,iBAAA;A/Cy9JF;A+Cv9JE;EACE,OAAA;EACA,a9C+6BgC;E8C96BhC,c9C66BgC;AD4iIpC;A+Cv9JI;EACE,WAAA;EACA,oCAAA;EACA,2B9C1CK;ADmgKX;;A+Cp9JA;EACE,iBAAA;A/Cu9JF;A+Cr9JE;EACE,MAAA;A/Cu9JJ;A+Cr9JI;EACE,YAAA;EACA,6BAAA;EACA,4B9CxDK;AD+gKX;;A+Cl9JA;EACE,iBAAA;A/Cq9JF;A+Cn9JE;EACE,QAAA;EACA,a9Ci5BgC;E8Ch5BhC,c9C+4BgC;ADskIpC;A+Cn9JI;EACE,UAAA;EACA,oCAAA;EACA,0B9CxEK;AD6hKX;;A+Ch8JA;EACE,gB9C22BkC;E8C12BlC,uBAAA;EACA,c9C9CM;E8C+CN,kBAAA;EACA,yB9ClGS;EKKP,sBAAA;ANiiKJ;;AiDpjKA;EACE,kBAAA;EACA,MAAA;EACA,wBAAA;EACA,a5C24BkC;E4C14BlC,cAAA;EACA,gBhDm3BkC;E+Cx3BlC,kC/Ckc4B;E+Chc5B,kBAAA;EACA,gB/Ckd4B;E+Cjd5B,gB3Ckb4B;E2Cjb5B,gBAAA;EACA,iBAAA;EACA,qBAAA;EACA,iBAAA;EACA,oBAAA;EACA,sBAAA;EACA,kBAAA;EACA,oBAAA;EACA,mBAAA;EACA,gBAAA;E5CsRI,0BALI;E6CpRR,qBAAA;EACA,yBhDCS;EgDAT,4BAAA;EACA,qCAAA;E3CIE,wBAAA;EKLE,kDARW;AX4kKjB;AiD/jKE;EACE,kBAAA;EACA,cAAA;EACA,ahDk3BgC;EgDj3BhC,ehDk3BgC;AD+sIpC;AiD/jKI;EAEE,kBAAA;EACA,cAAA;EACA,WAAA;EACA,yBAAA;EACA,mBAAA;AjDgkKN;;AiD1jKE;EACE,4BAAA;AjD6jKJ;AiD3jKI;EACE,SAAA;EACA,+BAAA;EACA,6BhDi2B8B;AD4tIpC;AiD1jKI;EACE,WhD20B8B;EgD10B9B,+BAAA;EACA,yBhDnCK;AD+lKX;;AiDtjKE;EACE,0BAAA;EACA,chDg1BgC;EgD/0BhC,chD80BgC;AD2uIpC;AiDvjKI;EACE,OAAA;EACA,uCAAA;EACA,+BhD60B8B;AD4uIpC;AiDtjKI;EACE,ShDuzB8B;EgDtzB9B,uCAAA;EACA,2BhDvDK;AD+mKX;;AiDljKE;EACE,yBAAA;AjDqjKJ;AiDnjKI;EACE,MAAA;EACA,uCAAA;EACA,gChD2zB8B;AD0vIpC;AiDljKI;EACE,QhDqyB8B;EgDpyB9B,uCAAA;EACA,4BhDzEK;AD6nKX;AiD/iKE;EACE,kBAAA;EACA,MAAA;EACA,SAAA;EACA,cAAA;EACA,ahDuyBgC;EgDtyBhC,qBAAA;EACA,WAAA;EACA,gCAAA;AjDijKJ;;AiD5iKE;EACE,2BAAA;EACA,chD8xBgC;EgD7xBhC,chD4xBgC;ADmxIpC;AiD7iKI;EACE,QAAA;EACA,uCAAA;EACA,8BhD2xB8B;ADoxIpC;AiD5iKI;EACE,UhDqwB8B;EgDpwB9B,uCAAA;EACA,0BhDzGK;ADupKX;;AiDzhKA;EACE,wBAAA;EACA,gBAAA;E7CuJI,mBALI;E6ChJR,chD1HS;EgD2HT,yBhDnIS;EgDoIT,4CAAA;E3CtHE,6CAAA;EACA,8CAAA;ANmpKJ;AiD3hKE;EACE,aAAA;AjD6hKJ;;AiDzhKA;EACE,wBAAA;EACA,chDvIS;ADmqKX;;AkD3qKA;EACE,kBAAA;AlD8qKF;;AkD3qKA;EACE,mBAAA;AlD8qKF;;AkD3qKA;EACE,kBAAA;EACA,WAAA;EACA,gBAAA;AlD8qKF;AmDpsKE;EACE,cAAA;EACA,WAAA;EACA,WAAA;AnDssKJ;;AkD/qKA;EACE,kBAAA;EACA,aAAA;EACA,WAAA;EACA,WAAA;EACA,mBAAA;EACA,2BAAA;E9BlBI,sC8BmBJ;AlDkrKF;AoBjsKM;E8BQN;I9BPQ,gBAAA;EpBosKN;AACF;;AkDprKA;;;EAGE,cAAA;AlDurKF;;AkDprKA,qBAAA;AACA;;EAEE,2BAAA;AlDurKF;;AkDprKA;;EAEE,4BAAA;AlDurKF;;AkDprKA,mBAAA;AAQE;EACE,UAAA;EACA,4BAAA;EACA,eAAA;AlDgrKJ;AkD7qKE;;;EAGE,UAAA;EACA,UAAA;AlD+qKJ;AkD5qKE;;EAEE,UAAA;EACA,UAAA;E9B/DE,2B8BgEF;AlD8qKJ;AoB1uKM;E8BwDJ;;I9BvDM,gBAAA;EpB8uKN;AACF;;AkD3qKA;;EAEE,kBAAA;EACA,MAAA;EACA,SAAA;EACA,UAAA;EAEA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,U7C2vCmC;E6C1vCnC,UAAA;EACA,cjDvFS;EiDwFT,kBAAA;EACA,gBAAA;EACA,SAAA;EACA,Y7CsvCmC;Ee/0C/B,8B8B0FJ;AlD6qKF;AoBnwKM;E8BqEN;;I9BpEQ,gBAAA;EpBuwKN;AACF;AkDhrKE;;;EAEE,cjDjGO;EiDkGP,qBAAA;EACA,UAAA;EACA,Y7C8uCiC;ALq8HrC;;AkDhrKA;EACE,OAAA;AlDmrKF;;AkDhrKA;EACE,QAAA;AlDmrKF;;AkD9qKA;;EAEE,qBAAA;EACA,W7C+uCmC;E6C9uCnC,Y7C8uCmC;E6C7uCnC,4BAAA;EACA,wBAAA;EACA,0BAAA;AlDirKF;;AkD9qKA;;;;;;;GAAA;AAQA;EACE,0DAAA;AlDirKF;;AkD/qKA;EACE,0DAAA;AlDkrKF;;AkD1qKA;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,UAAA;EACA,aAAA;EACA,uBAAA;EACA,UAAA;EAEA,iB7CurCmC;E6CtrCnC,mBAAA;EACA,gB7CqrCmC;E6CprCnC,gBAAA;AlD4qKF;AkD1qKE;EACE,uBAAA;EACA,cAAA;EACA,W7CorCiC;E6CnrCjC,W7CorCiC;E6CnrCjC,UAAA;EACA,iB7CorCiC;E6CnrCjC,gB7CmrCiC;E6ClrCjC,mBAAA;EACA,eAAA;EACA,yBjDxKO;EiDyKP,4BAAA;EACA,SAAA;EAEA,kCAAA;EACA,qCAAA;EACA,Y7C2qCiC;Eev1C/B,6B8B6KF;AlD2qKJ;AoBp1KM;E8BwJJ;I9BvJM,gBAAA;EpBu1KN;AACF;AkD7qKE;EACE,U7CwqCiC;ALugIrC;;AkDtqKA;EACE,kBAAA;EACA,UAAA;EACA,e7CkqCmC;E6CjqCnC,SAAA;EACA,oB7C+pCmC;E6C9pCnC,uB7C8pCmC;E6C7pCnC,cjDnMS;EiDoMT,kBAAA;AlDyqKF;;AkDnqKE;;EAEE,gC7CiqCiC;ALqgIrC;AkDnqKE;EACE,yBjD9JI;ADm0KR;AkDlqKE;EACE,cjDlKI;ADs0KR;;AoDt4KA;;;;;EAAA;ADEE;EACE,cAAA;EACA,WAAA;EACA,WAAA;AnD64KJ;;AqDj5KE;EACE,cpDiPW;ADmqKf;AqDj5KM;EAEE,cAAA;ArDk5KR;;AqDx5KE;EACE,cpDiPW;AD0qKf;AqDx5KM;EAEE,cAAA;ArDy5KR;;AqD/5KE;EACE,cpDiPW;ADirKf;AqD/5KM;EAEE,cAAA;ArDg6KR;;AqDt6KE;EACE,cpDiPW;ADwrKf;AqDt6KM;EAEE,cAAA;ArDu6KR;;AqD76KE;EACE,cpDiPW;AD+rKf;AqD76KM;EAEE,cAAA;ArD86KR;;AqDp7KE;EACE,cpDiPW;ADssKf;AqDp7KM;EAEE,cAAA;ArDq7KR;;AqD37KE;EACE,cpDiPW;AD6sKf;AqD37KM;EAEE,cAAA;ArD47KR;;AqDl8KE;EACE,cpDiPW;ADotKf;AqDl8KM;EAEE,YAAA;ArDm8KR;;AqDz8KE;EACE,cpDiPW;AD2tKf;AqDz8KM;EAEE,YAAA;ArD08KR;;AqDh9KE;EACE,cpDiPW;ADkuKf;AqDh9KM;EAEE,cAAA;ArDi9KR;;AqDv9KE;EACE,YpDiPW;ADyuKf;AqDv9KM;EAEE,YAAA;ArDw9KR;;AsD79KA;EACE,kBAAA;EACA,WAAA;AtDg+KF;AsD99KE;EACE,cAAA;EACA,mCAAA;EACA,WAAA;AtDg+KJ;AsD79KE;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;AtD+9KJ;;AsD19KE;EACE,uBAAA;AtD69KJ;;AsD99KE;EACE,sBAAA;AtDi+KJ;;AsDl+KE;EACE,yBAAA;AtDq+KJ;;AsDt+KE;EACE,iCAAA;AtDy+KJ;;AuD9/KA;EACE,eAAA;EACA,MAAA;EACA,QAAA;EACA,OAAA;EACA,alDo4BkC;AL6nJpC;;AuD9/KA;EACE,eAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,alD43BkC;ALqoJpC;;AuDz/KI;EACE,gBAAA;EACA,MAAA;EACA,alDg3B8B;AL4oJpC;;Acv9KI;EyCxCA;IACE,gBAAA;IACA,MAAA;IACA,alDg3B8B;ELmpJlC;AACF;Ac/9KI;EyCxCA;IACE,gBAAA;IACA,MAAA;IACA,alDg3B8B;EL0pJlC;AACF;Act+KI;EyCxCA;IACE,gBAAA;IACA,MAAA;IACA,alDg3B8B;ELiqJlC;AACF;Ac7+KI;EyCxCA;IACE,gBAAA;IACA,MAAA;IACA,alDg3B8B;ELwqJlC;AACF;AwD/iLA;;ECIE,6BAAA;EACA,qBAAA;EACA,sBAAA;EACA,qBAAA;EACA,uBAAA;EACA,2BAAA;EACA,iCAAA;EACA,8BAAA;EACA,oBAAA;AzD+iLF;;A0D1jLE;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,UrD2RsC;EqD1RtC,WAAA;A1D6jLJ;;A2DrkLA;ECAE,gBAAA;EACA,uBAAA;EACA,mBAAA;A5DykLF;;A6D9hLM;EAEI,mCAAA;A7DgiLV;;A6DliLM;EAEI,8BAAA;A7DoiLV;;A6DtiLM;EAEI,iCAAA;A7DwiLV;;A6D1iLM;EAEI,iCAAA;A7D4iLV;;A6D9iLM;EAEI,sCAAA;A7DgjLV;;A6DljLM;EAEI,mCAAA;A7DojLV;;A6DtjLM;EAEI,sBAAA;A7DwjLV;;A6D1jLM;EAEI,uBAAA;A7D4jLV;;A6D9jLM;EAEI,sBAAA;A7DgkLV;;A6DlkLM;EAEI,yBAAA;A7DokLV;;A6DtkLM;EAEI,2BAAA;A7DwkLV;;A6D1kLM;EAEI,4BAAA;A7D4kLV;;A6D9kLM;EAEI,2BAAA;A7DglLV;;A6DllLM;EAEI,0BAAA;A7DolLV;;A6DtlLM;EAEI,gCAAA;A7DwlLV;;A6D1lLM;EAEI,yBAAA;A7D4lLV;;A6D9lLM;EAEI,wBAAA;A7DgmLV;;A6DlmLM;EAEI,yBAAA;A7DomLV;;A6DtmLM;EAEI,6BAAA;A7DwmLV;;A6D1mLM;EAEI,8BAAA;A7D4mLV;;A6D9mLM;EAEI,wBAAA;A7DgnLV;;A6DlnLM;EAEI,+BAAA;A7DonLV;;A6DtnLM;EAEI,wBAAA;A7DwnLV;;A6D1nLM;EAEI,wDAAA;A7D4nLV;;A6D9nLM;EAEI,8DAAA;A7DgoLV;;A6DloLM;EAEI,uDAAA;A7DooLV;;A6DtoLM;EAEI,2BAAA;A7DwoLV;;A6D1oLM;EAEI,2BAAA;A7D4oLV;;A6D9oLM;EAEI,6BAAA;A7DgpLV;;A6DlpLM;EAEI,6BAAA;A7DopLV;;A6DtpLM;EAEI,0BAAA;A7DwpLV;;A6D1pLM;EAEI,2BAAA;A7D4pLV;;A6D9pLM;EAEI,iBAAA;A7DgqLV;;A6DlqLM;EAEI,mBAAA;A7DoqLV;;A6DtqLM;EAEI,oBAAA;A7DwqLV;;A6D1qLM;EAEI,oBAAA;A7D4qLV;;A6D9qLM;EAEI,sBAAA;A7DgrLV;;A6DlrLM;EAEI,uBAAA;A7DorLV;;A6DtrLM;EAEI,kBAAA;A7DwrLV;;A6D1rLM;EAEI,oBAAA;A7D4rLV;;A6D9rLM;EAEI,qBAAA;A7DgsLV;;A6DlsLM;EAEI,mBAAA;A7DosLV;;A6DtsLM;EAEI,qBAAA;A7DwsLV;;A6D1sLM;EAEI,sBAAA;A7D4sLV;;A6D9sLM;EAEI,2CAAA;A7DgtLV;;A6DltLM;EAEI,sCAAA;A7DotLV;;A6DttLM;EAEI,sCAAA;A7DwtLV;;A6D1tLM;EAEI,0CAAA;A7D4tLV;;A6D9tLM;EAEI,oBAAA;A7DguLV;;A6DluLM;EAEI,8CAAA;A7DouLV;;A6DtuLM;EAEI,wBAAA;A7DwuLV;;A6D1uLM;EAEI,gDAAA;A7D4uLV;;A6D9uLM;EAEI,0BAAA;A7DgvLV;;A6DlvLM;EAEI,iDAAA;A7DovLV;;A6DtvLM;EAEI,2BAAA;A7DwvLV;;A6D1vLM;EAEI,+CAAA;A7D4vLV;;A6D9vLM;EAEI,yBAAA;A7DgwLV;;A6DlwLM;EAEI,gCAAA;A7DowLV;;A6DtwLM;EAEI,gCAAA;A7DwwLV;;A6D1wLM;EAEI,gCAAA;A7D4wLV;;A6D9wLM;EAEI,gCAAA;A7DgxLV;;A6DlxLM;EAEI,gCAAA;A7DoxLV;;A6DtxLM;EAEI,gCAAA;A7DwxLV;;A6D1xLM;EAEI,gCAAA;A7D4xLV;;A6D9xLM;EAEI,gCAAA;A7DgyLV;;A6DlyLM;EAEI,gCAAA;A7DoyLV;;A6DtyLM;EAEI,gCAAA;A7DwyLV;;A6D1yLM;EAEI,8BAAA;A7D4yLV;;A6D9yLM;EAEI,4BAAA;A7DgzLV;;A6DlzLM;EAEI,4BAAA;A7DozLV;;A6DtzLM;EAEI,4BAAA;A7DwzLV;;A6D1zLM;EAEI,4BAAA;A7D4zLV;;A6D9zLM;EAEI,4BAAA;A7Dg0LV;;A6Dl0LM;EAEI,qBAAA;A7Do0LV;;A6Dt0LM;EAEI,qBAAA;A7Dw0LV;;A6D10LM;EAEI,qBAAA;A7D40LV;;A6D90LM;EAEI,sBAAA;A7Dg1LV;;A6Dl1LM;EAEI,sBAAA;A7Do1LV;;A6Dt1LM;EAEI,0BAAA;A7Dw1LV;;A6D11LM;EAEI,uBAAA;A7D41LV;;A6D91LM;EAEI,2BAAA;A7Dg2LV;;A6Dl2LM;EAEI,sBAAA;A7Do2LV;;A6Dt2LM;EAEI,sBAAA;A7Dw2LV;;A6D12LM;EAEI,sBAAA;A7D42LV;;A6D92LM;EAEI,uBAAA;A7Dg3LV;;A6Dl3LM;EAEI,uBAAA;A7Do3LV;;A6Dt3LM;EAEI,2BAAA;A7Dw3LV;;A6D13LM;EAEI,wBAAA;A7D43LV;;A6D93LM;EAEI,4BAAA;A7Dg4LV;;A6Dl4LM;EAEI,yBAAA;A7Do4LV;;A6Dt4LM;EAEI,8BAAA;A7Dw4LV;;A6D14LM;EAEI,iCAAA;A7D44LV;;A6D94LM;EAEI,sCAAA;A7Dg5LV;;A6Dl5LM;EAEI,yCAAA;A7Do5LV;;A6Dt5LM;EAEI,uBAAA;A7Dw5LV;;A6D15LM;EAEI,uBAAA;A7D45LV;;A6D95LM;EAEI,yBAAA;A7Dg6LV;;A6Dl6LM;EAEI,yBAAA;A7Do6LV;;A6Dt6LM;EAEI,0BAAA;A7Dw6LV;;A6D16LM;EAEI,4BAAA;A7D46LV;;A6D96LM;EAEI,kCAAA;A7Dg7LV;;A6Dl7LM;EAEI,iBAAA;A7Do7LV;;A6Dt7LM;EAEI,uBAAA;A7Dw7LV;;A6D17LM;EAEI,sBAAA;A7D47LV;;A6D97LM;EAEI,oBAAA;A7Dg8LV;;A6Dl8LM;EAEI,sBAAA;A7Do8LV;;A6Dt8LM;EAEI,oBAAA;A7Dw8LV;;A6D18LM;EAEI,oBAAA;A7D48LV;;A6D98LM;EAEI,oBAAA;A7Dg9LV;;A6Dl9LM;EAEI,oBAAA;A7Do9LV;;A6Dt9LM;EAEI,oBAAA;A7Dw9LV;;A6D19LM;EAEI,sCAAA;A7D49LV;;A6D99LM;EAEI,oCAAA;A7Dg+LV;;A6Dl+LM;EAEI,kCAAA;A7Do+LV;;A6Dt+LM;EAEI,yCAAA;A7Dw+LV;;A6D1+LM;EAEI,wCAAA;A7D4+LV;;A6D9+LM;EAEI,wCAAA;A7Dg/LV;;A6Dl/LM;EAEI,kCAAA;A7Do/LV;;A6Dt/LM;EAEI,gCAAA;A7Dw/LV;;A6D1/LM;EAEI,8BAAA;A7D4/LV;;A6D9/LM;EAEI,gCAAA;A7DggMV;;A6DlgMM;EAEI,+BAAA;A7DogMV;;A6DtgMM;EAEI,oCAAA;A7DwgMV;;A6D1gMM;EAEI,kCAAA;A7D4gMV;;A6D9gMM;EAEI,gCAAA;A7DghMV;;A6DlhMM;EAEI,uCAAA;A7DohMV;;A6DthMM;EAEI,sCAAA;A7DwhMV;;A6D1hMM;EAEI,iCAAA;A7D4hMV;;A6D9hMM;EAEI,2BAAA;A7DgiMV;;A6DliMM;EAEI,iCAAA;A7DoiMV;;A6DtiMM;EAEI,+BAAA;A7DwiMV;;A6D1iMM;EAEI,6BAAA;A7D4iMV;;A6D9iMM;EAEI,+BAAA;A7DgjMV;;A6DljMM;EAEI,8BAAA;A7DojMV;;A6DtjMM;EAEI,oBAAA;A7DwjMV;;A6D1jMM;EAEI,mBAAA;A7D4jMV;;A6D9jMM;EAEI,mBAAA;A7DgkMV;;A6DlkMM;EAEI,mBAAA;A7DokMV;;A6DtkMM;EAEI,mBAAA;A7DwkMV;;A6D1kMM;EAEI,mBAAA;A7D4kMV;;A6D9kMM;EAEI,mBAAA;A7DglMV;;A6DllMM;EAEI,mBAAA;A7DolMV;;A6DtlMM;EAEI,oBAAA;A7DwlMV;;A6D1lMM;EAEI,0BAAA;A7D4lMV;;A6D9lMM;EAEI,yBAAA;A7DgmMV;;A6DlmMM;EAEI,uBAAA;A7DomMV;;A6DtmMM;EAEI,yBAAA;A7DwmMV;;A6D1mMM;EAEI,uBAAA;A7D4mMV;;A6D9mMM;EAEI,uBAAA;A7DgnMV;;A6DlnMM;EAEI,uBAAA;A7DonMV;;A6DtnMM;EAEI,uBAAA;A7DwnMV;;A6D1nMM;EAEI,uBAAA;A7D4nMV;;A6D9nMM;EAEI,uBAAA;A7DgoMV;;A6DloMM;EAEI,0BAAA;EAAA,yBAAA;A7DqoMV;;A6DvoMM;EAEI,gCAAA;EAAA,+BAAA;A7D0oMV;;A6D5oMM;EAEI,+BAAA;EAAA,8BAAA;A7D+oMV;;A6DjpMM;EAEI,6BAAA;EAAA,4BAAA;A7DopMV;;A6DtpMM;EAEI,+BAAA;EAAA,8BAAA;A7DypMV;;A6D3pMM;EAEI,6BAAA;EAAA,4BAAA;A7D8pMV;;A6DhqMM;EAEI,6BAAA;EAAA,4BAAA;A7DmqMV;;A6DrqMM;EAEI,6BAAA;EAAA,4BAAA;A7DwqMV;;A6D1qMM;EAEI,6BAAA;EAAA,4BAAA;A7D6qMV;;A6D/qMM;EAEI,6BAAA;EAAA,4BAAA;A7DkrMV;;A6DprMM;EAEI,6BAAA;EAAA,4BAAA;A7DurMV;;A6DzrMM;EAEI,wBAAA;EAAA,2BAAA;A7D4rMV;;A6D9rMM;EAEI,8BAAA;EAAA,iCAAA;A7DisMV;;A6DnsMM;EAEI,6BAAA;EAAA,gCAAA;A7DssMV;;A6DxsMM;EAEI,2BAAA;EAAA,8BAAA;A7D2sMV;;A6D7sMM;EAEI,6BAAA;EAAA,gCAAA;A7DgtMV;;A6DltMM;EAEI,2BAAA;EAAA,8BAAA;A7DqtMV;;A6DvtMM;EAEI,2BAAA;EAAA,8BAAA;A7D0tMV;;A6D5tMM;EAEI,2BAAA;EAAA,8BAAA;A7D+tMV;;A6DjuMM;EAEI,2BAAA;EAAA,8BAAA;A7DouMV;;A6DtuMM;EAEI,2BAAA;EAAA,8BAAA;A7DyuMV;;A6D3uMM;EAEI,2BAAA;EAAA,8BAAA;A7D8uMV;;A6DhvMM;EAEI,wBAAA;A7DkvMV;;A6DpvMM;EAEI,8BAAA;A7DsvMV;;A6DxvMM;EAEI,6BAAA;A7D0vMV;;A6D5vMM;EAEI,2BAAA;A7D8vMV;;A6DhwMM;EAEI,6BAAA;A7DkwMV;;A6DpwMM;EAEI,2BAAA;A7DswMV;;A6DxwMM;EAEI,2BAAA;A7D0wMV;;A6D5wMM;EAEI,2BAAA;A7D8wMV;;A6DhxMM;EAEI,2BAAA;A7DkxMV;;A6DpxMM;EAEI,2BAAA;A7DsxMV;;A6DxxMM;EAEI,2BAAA;A7D0xMV;;A6D5xMM;EAEI,0BAAA;A7D8xMV;;A6DhyMM;EAEI,gCAAA;A7DkyMV;;A6DpyMM;EAEI,+BAAA;A7DsyMV;;A6DxyMM;EAEI,6BAAA;A7D0yMV;;A6D5yMM;EAEI,+BAAA;A7D8yMV;;A6DhzMM;EAEI,6BAAA;A7DkzMV;;A6DpzMM;EAEI,6BAAA;A7DszMV;;A6DxzMM;EAEI,6BAAA;A7D0zMV;;A6D5zMM;EAEI,6BAAA;A7D8zMV;;A6Dh0MM;EAEI,6BAAA;A7Dk0MV;;A6Dp0MM;EAEI,6BAAA;A7Ds0MV;;A6Dx0MM;EAEI,2BAAA;A7D00MV;;A6D50MM;EAEI,iCAAA;A7D80MV;;A6Dh1MM;EAEI,gCAAA;A7Dk1MV;;A6Dp1MM;EAEI,8BAAA;A7Ds1MV;;A6Dx1MM;EAEI,gCAAA;A7D01MV;;A6D51MM;EAEI,8BAAA;A7D81MV;;A6Dh2MM;EAEI,8BAAA;A7Dk2MV;;A6Dp2MM;EAEI,8BAAA;A7Ds2MV;;A6Dx2MM;EAEI,8BAAA;A7D02MV;;A6D52MM;EAEI,8BAAA;A7D82MV;;A6Dh3MM;EAEI,8BAAA;A7Dk3MV;;A6Dp3MM;EAEI,yBAAA;A7Ds3MV;;A6Dx3MM;EAEI,+BAAA;A7D03MV;;A6D53MM;EAEI,8BAAA;A7D83MV;;A6Dh4MM;EAEI,4BAAA;A7Dk4MV;;A6Dp4MM;EAEI,8BAAA;A7Ds4MV;;A6Dx4MM;EAEI,4BAAA;A7D04MV;;A6D54MM;EAEI,4BAAA;A7D84MV;;A6Dh5MM;EAEI,4BAAA;A7Dk5MV;;A6Dp5MM;EAEI,4BAAA;A7Ds5MV;;A6Dx5MM;EAEI,4BAAA;A7D05MV;;A6D55MM;EAEI,4BAAA;A7D85MV;;A6Dh6MM;EAEI,qBAAA;A7Dk6MV;;A6Dp6MM;EAEI,2BAAA;A7Ds6MV;;A6Dx6MM;EAEI,0BAAA;A7D06MV;;A6D56MM;EAEI,wBAAA;A7D86MV;;A6Dh7MM;EAEI,0BAAA;A7Dk7MV;;A6Dp7MM;EAEI,wBAAA;A7Ds7MV;;A6Dx7MM;EAEI,wBAAA;A7D07MV;;A6D57MM;EAEI,wBAAA;A7D87MV;;A6Dh8MM;EAEI,wBAAA;A7Dk8MV;;A6Dp8MM;EAEI,wBAAA;A7Ds8MV;;A6Dx8MM;EAEI,2BAAA;EAAA,0BAAA;A7D28MV;;A6D78MM;EAEI,iCAAA;EAAA,gCAAA;A7Dg9MV;;A6Dl9MM;EAEI,gCAAA;EAAA,+BAAA;A7Dq9MV;;A6Dv9MM;EAEI,8BAAA;EAAA,6BAAA;A7D09MV;;A6D59MM;EAEI,gCAAA;EAAA,+BAAA;A7D+9MV;;A6Dj+MM;EAEI,8BAAA;EAAA,6BAAA;A7Do+MV;;A6Dt+MM;EAEI,8BAAA;EAAA,6BAAA;A7Dy+MV;;A6D3+MM;EAEI,8BAAA;EAAA,6BAAA;A7D8+MV;;A6Dh/MM;EAEI,8BAAA;EAAA,6BAAA;A7Dm/MV;;A6Dr/MM;EAEI,8BAAA;EAAA,6BAAA;A7Dw/MV;;A6D1/MM;EAEI,yBAAA;EAAA,4BAAA;A7D6/MV;;A6D//MM;EAEI,+BAAA;EAAA,kCAAA;A7DkgNV;;A6DpgNM;EAEI,8BAAA;EAAA,iCAAA;A7DugNV;;A6DzgNM;EAEI,4BAAA;EAAA,+BAAA;A7D4gNV;;A6D9gNM;EAEI,8BAAA;EAAA,iCAAA;A7DihNV;;A6DnhNM;EAEI,4BAAA;EAAA,+BAAA;A7DshNV;;A6DxhNM;EAEI,4BAAA;EAAA,+BAAA;A7D2hNV;;A6D7hNM;EAEI,4BAAA;EAAA,+BAAA;A7DgiNV;;A6DliNM;EAEI,4BAAA;EAAA,+BAAA;A7DqiNV;;A6DviNM;EAEI,4BAAA;EAAA,+BAAA;A7D0iNV;;A6D5iNM;EAEI,yBAAA;A7D8iNV;;A6DhjNM;EAEI,+BAAA;A7DkjNV;;A6DpjNM;EAEI,8BAAA;A7DsjNV;;A6DxjNM;EAEI,4BAAA;A7D0jNV;;A6D5jNM;EAEI,8BAAA;A7D8jNV;;A6DhkNM;EAEI,4BAAA;A7DkkNV;;A6DpkNM;EAEI,4BAAA;A7DskNV;;A6DxkNM;EAEI,4BAAA;A7D0kNV;;A6D5kNM;EAEI,4BAAA;A7D8kNV;;A6DhlNM;EAEI,4BAAA;A7DklNV;;A6DplNM;EAEI,2BAAA;A7DslNV;;A6DxlNM;EAEI,iCAAA;A7D0lNV;;A6D5lNM;EAEI,gCAAA;A7D8lNV;;A6DhmNM;EAEI,8BAAA;A7DkmNV;;A6DpmNM;EAEI,gCAAA;A7DsmNV;;A6DxmNM;EAEI,8BAAA;A7D0mNV;;A6D5mNM;EAEI,8BAAA;A7D8mNV;;A6DhnNM;EAEI,8BAAA;A7DknNV;;A6DpnNM;EAEI,8BAAA;A7DsnNV;;A6DxnNM;EAEI,8BAAA;A7D0nNV;;A6D5nNM;EAEI,4BAAA;A7D8nNV;;A6DhoNM;EAEI,kCAAA;A7DkoNV;;A6DpoNM;EAEI,iCAAA;A7DsoNV;;A6DxoNM;EAEI,+BAAA;A7D0oNV;;A6D5oNM;EAEI,iCAAA;A7D8oNV;;A6DhpNM;EAEI,+BAAA;A7DkpNV;;A6DppNM;EAEI,+BAAA;A7DspNV;;A6DxpNM;EAEI,+BAAA;A7D0pNV;;A6D5pNM;EAEI,+BAAA;A7D8pNV;;A6DhqNM;EAEI,+BAAA;A7DkqNV;;A6DpqNM;EAEI,0BAAA;A7DsqNV;;A6DxqNM;EAEI,gCAAA;A7D0qNV;;A6D5qNM;EAEI,+BAAA;A7D8qNV;;A6DhrNM;EAEI,6BAAA;A7DkrNV;;A6DprNM;EAEI,+BAAA;A7DsrNV;;A6DxrNM;EAEI,6BAAA;A7D0rNV;;A6D5rNM;EAEI,6BAAA;A7D8rNV;;A6DhsNM;EAEI,6BAAA;A7DksNV;;A6DpsNM;EAEI,6BAAA;A7DssNV;;A6DxsNM;EAEI,6BAAA;A7D0sNV;;A6D5sNM;EAEI,4GAAA;EAAA,gDAAA;A7D8sNV;;A6DhtNM;EAEI,4DAAA;A7DktNV;;A6DptNM;EAEI,0DAAA;A7DstNV;;A6DxtNM;EAEI,0DAAA;A7D0tNV;;A6D5tNM;EAEI,qCAAA;A7D8tNV;;A6DhuNM;EAEI,oCAAA;A7DkuNV;;A6DpuNM;EAEI,mCAAA;A7DsuNV;;A6DxuNM;EAEI,6BAAA;A7D0uNV;;A6D5uNM;EAEI,6BAAA;A7D8uNV;;A6DhvNM;EAEI,2BAAA;A7DkvNV;;A6DpvNM;EAEI,+BAAA;A7DsvNV;;A6DxvNM;EAEI,2BAAA;A7D0vNV;;A6D5vNM;EAEI,2BAAA;A7D8vNV;;A6DhwNM;EAEI,8BAAA;A7DkwNV;;A6DpwNM;EAEI,yBAAA;A7DswNV;;A6DxwNM;EAEI,2BAAA;A7D0wNV;;A6D5wNM;EAEI,2BAAA;A7D8wNV;;A6DhxNM;EAEI,gCAAA;A7DkxNV;;A6DpxNM;EAEI,2BAAA;A7DsxNV;;A6DxxNM;EAEI,4BAAA;A7D0xNV;;A6D5xNM;EAEI,6BAAA;A7D8xNV;;A6DhyNM;EAEI,gCAAA;A7DkyNV;;A6DpyNM;EAEI,qCAAA;A7DsyNV;;A6DxyNM;EAEI,wCAAA;A7D0yNV;;A6D5yNM;EAEI,oCAAA;A7D8yNV;;A6DhzNM;EAEI,oCAAA;A7DkzNV;;A6DpzNM;EAEI,qCAAA;A7DszNV;;A6DxzNM;EAEI,8BAAA;A7D0zNV;;A6D5zNM;EAEI,8BAAA;A7D8zNV;;A6Dl0NQ,qBAAA;AAEF;EAEI,gCAAA;EAAA,iCAAA;A7Do0NV;;A6DxzNQ,mBAAA;AAdF;EAEI,yBAAA;A7Dy0NV;;A6D30NM;EAEI,yBAAA;A7D60NV;;A6D/0NM;EAEI,yBAAA;A7Di1NV;;A6Dn1NM;EAEI,yBAAA;A7Dq1NV;;A6Dv1NM;EAEI,yBAAA;A7Dy1NV;;A6D31NM;EAEI,yBAAA;A7D61NV;;A6D/1NM;EAEI,yBAAA;A7Di2NV;;A6Dn2NM;EAEI,yBAAA;A7Dq2NV;;A6Dv2NM;EAEI,yBAAA;A7Dy2NV;;A6D32NM;EAEI,yBAAA;A7D62NV;;A6D/2NM;EAEI,uBAAA;A7Di3NV;;A6Dn3NM;EAEI,yBAAA;A7Dq3NV;;A6Dv3NM;EAEI,yBAAA;A7Dy3NV;;A6D33NM;EAEI,oCAAA;A7D63NV;;A6D/3NM;EAEI,0CAAA;A7Di4NV;;A6Dn4NM;EAEI,yBAAA;A7Dq4NV;;A6Dv4NM;EAEI,oCAAA;A7Dy4NV;;A6D34NM;EAEI,oCAAA;A7D64NV;;A6D/4NM;EAEI,oCAAA;A7Di5NV;;A6Dn5NM;EAEI,oCAAA;A7Dq5NV;;A6Dv5NM;EAEI,oCAAA;A7Dy5NV;;A6D35NM;EAEI,oCAAA;A7D65NV;;A6D/5NM;EAEI,oCAAA;A7Di6NV;;A6Dn6NM;EAEI,oCAAA;A7Dq6NV;;A6Dv6NM;EAEI,oCAAA;A7Dy6NV;;A6D36NM;EAEI,oCAAA;A7D66NV;;A6D/6NM;EAEI,kCAAA;A7Di7NV;;A6Dn7NM;EAEI,oCAAA;A7Dq7NV;;A6Dv7NM;EAEI,wCAAA;A7Dy7NV;;A6D37NM;EAEI,uGAAA;EAAA,+CAAA;A7D67NV;;A6D/7NM;EAEI,mCAAA;UAAA,2BAAA;A7Di8NV;;A6Dn8NM;EAEI,oCAAA;UAAA,4BAAA;A7Dq8NV;;A6Dv8NM;EAEI,oCAAA;UAAA,4BAAA;A7Dy8NV;;A6D38NM;EAEI,+BAAA;A7D68NV;;A6D/8NM;EAEI,+BAAA;A7Di9NV;;A6Dn9NM;EAEI,iCAAA;A7Dq9NV;;A6Dv9NM;EAEI,2BAAA;A7Dy9NV;;A6D39NM;EAEI,mCAAA;A7D69NV;;A6D/9NM;EAEI,iCAAA;A7Di+NV;;A6Dn+NM;EAEI,mCAAA;A7Dq+NV;;A6Dv+NM;EAEI,6BAAA;A7Dy+NV;;A6D3+NM;EAEI,+BAAA;A7D6+NV;;A6D/+NM;EAEI,0CAAA;EAAA,2CAAA;A7Dk/NV;;A6Dp/NM;EAEI,2CAAA;EAAA,8CAAA;A7Du/NV;;A6Dz/NM;EAEI,8CAAA;EAAA,6CAAA;A7D4/NV;;A6D9/NM;EAEI,6CAAA;EAAA,0CAAA;A7DigOV;;A6DngOM;EAEI,8BAAA;A7DqgOV;;A6DvgOM;EAEI,6BAAA;A7DygOV;;Ac7/NI;E+CdE;IAEI,sBAAA;E7D8gOR;E6DhhOI;IAEI,uBAAA;E7DihOR;E6DnhOI;IAEI,sBAAA;E7DohOR;E6DthOI;IAEI,0BAAA;E7DuhOR;E6DzhOI;IAEI,gCAAA;E7D0hOR;E6D5hOI;IAEI,yBAAA;E7D6hOR;E6D/hOI;IAEI,wBAAA;E7DgiOR;E6DliOI;IAEI,yBAAA;E7DmiOR;E6DriOI;IAEI,6BAAA;E7DsiOR;E6DxiOI;IAEI,8BAAA;E7DyiOR;E6D3iOI;IAEI,wBAAA;E7D4iOR;E6D9iOI;IAEI,+BAAA;E7D+iOR;E6DjjOI;IAEI,wBAAA;E7DkjOR;E6DpjOI;IAEI,yBAAA;E7DqjOR;E6DvjOI;IAEI,8BAAA;E7DwjOR;E6D1jOI;IAEI,iCAAA;E7D2jOR;E6D7jOI;IAEI,sCAAA;E7D8jOR;E6DhkOI;IAEI,yCAAA;E7DikOR;E6DnkOI;IAEI,uBAAA;E7DokOR;E6DtkOI;IAEI,uBAAA;E7DukOR;E6DzkOI;IAEI,yBAAA;E7D0kOR;E6D5kOI;IAEI,yBAAA;E7D6kOR;E6D/kOI;IAEI,0BAAA;E7DglOR;E6DllOI;IAEI,4BAAA;E7DmlOR;E6DrlOI;IAEI,kCAAA;E7DslOR;E6DxlOI;IAEI,iBAAA;E7DylOR;E6D3lOI;IAEI,uBAAA;E7D4lOR;E6D9lOI;IAEI,sBAAA;E7D+lOR;E6DjmOI;IAEI,oBAAA;E7DkmOR;E6DpmOI;IAEI,sBAAA;E7DqmOR;E6DvmOI;IAEI,oBAAA;E7DwmOR;E6D1mOI;IAEI,oBAAA;E7D2mOR;E6D7mOI;IAEI,oBAAA;E7D8mOR;E6DhnOI;IAEI,oBAAA;E7DinOR;E6DnnOI;IAEI,oBAAA;E7DonOR;E6DtnOI;IAEI,sCAAA;E7DunOR;E6DznOI;IAEI,oCAAA;E7D0nOR;E6D5nOI;IAEI,kCAAA;E7D6nOR;E6D/nOI;IAEI,yCAAA;E7DgoOR;E6DloOI;IAEI,wCAAA;E7DmoOR;E6DroOI;IAEI,wCAAA;E7DsoOR;E6DxoOI;IAEI,kCAAA;E7DyoOR;E6D3oOI;IAEI,gCAAA;E7D4oOR;E6D9oOI;IAEI,8BAAA;E7D+oOR;E6DjpOI;IAEI,gCAAA;E7DkpOR;E6DppOI;IAEI,+BAAA;E7DqpOR;E6DvpOI;IAEI,oCAAA;E7DwpOR;E6D1pOI;IAEI,kCAAA;E7D2pOR;E6D7pOI;IAEI,gCAAA;E7D8pOR;E6DhqOI;IAEI,uCAAA;E7DiqOR;E6DnqOI;IAEI,sCAAA;E7DoqOR;E6DtqOI;IAEI,iCAAA;E7DuqOR;E6DzqOI;IAEI,2BAAA;E7D0qOR;E6D5qOI;IAEI,iCAAA;E7D6qOR;E6D/qOI;IAEI,+BAAA;E7DgrOR;E6DlrOI;IAEI,6BAAA;E7DmrOR;E6DrrOI;IAEI,+BAAA;E7DsrOR;E6DxrOI;IAEI,8BAAA;E7DyrOR;E6D3rOI;IAEI,oBAAA;E7D4rOR;E6D9rOI;IAEI,mBAAA;E7D+rOR;E6DjsOI;IAEI,mBAAA;E7DksOR;E6DpsOI;IAEI,mBAAA;E7DqsOR;E6DvsOI;IAEI,mBAAA;E7DwsOR;E6D1sOI;IAEI,mBAAA;E7D2sOR;E6D7sOI;IAEI,mBAAA;E7D8sOR;E6DhtOI;IAEI,mBAAA;E7DitOR;E6DntOI;IAEI,oBAAA;E7DotOR;E6DttOI;IAEI,0BAAA;E7DutOR;E6DztOI;IAEI,yBAAA;E7D0tOR;E6D5tOI;IAEI,uBAAA;E7D6tOR;E6D/tOI;IAEI,yBAAA;E7DguOR;E6DluOI;IAEI,uBAAA;E7DmuOR;E6DruOI;IAEI,uBAAA;E7DsuOR;E6DxuOI;IAEI,uBAAA;E7DyuOR;E6D3uOI;IAEI,uBAAA;E7D4uOR;E6D9uOI;IAEI,uBAAA;E7D+uOR;E6DjvOI;IAEI,uBAAA;E7DkvOR;E6DpvOI;IAEI,0BAAA;IAAA,yBAAA;E7DsvOR;E6DxvOI;IAEI,gCAAA;IAAA,+BAAA;E7D0vOR;E6D5vOI;IAEI,+BAAA;IAAA,8BAAA;E7D8vOR;E6DhwOI;IAEI,6BAAA;IAAA,4BAAA;E7DkwOR;E6DpwOI;IAEI,+BAAA;IAAA,8BAAA;E7DswOR;E6DxwOI;IAEI,6BAAA;IAAA,4BAAA;E7D0wOR;E6D5wOI;IAEI,6BAAA;IAAA,4BAAA;E7D8wOR;E6DhxOI;IAEI,6BAAA;IAAA,4BAAA;E7DkxOR;E6DpxOI;IAEI,6BAAA;IAAA,4BAAA;E7DsxOR;E6DxxOI;IAEI,6BAAA;IAAA,4BAAA;E7D0xOR;E6D5xOI;IAEI,6BAAA;IAAA,4BAAA;E7D8xOR;E6DhyOI;IAEI,wBAAA;IAAA,2BAAA;E7DkyOR;E6DpyOI;IAEI,8BAAA;IAAA,iCAAA;E7DsyOR;E6DxyOI;IAEI,6BAAA;IAAA,gCAAA;E7D0yOR;E6D5yOI;IAEI,2BAAA;IAAA,8BAAA;E7D8yOR;E6DhzOI;IAEI,6BAAA;IAAA,gCAAA;E7DkzOR;E6DpzOI;IAEI,2BAAA;IAAA,8BAAA;E7DszOR;E6DxzOI;IAEI,2BAAA;IAAA,8BAAA;E7D0zOR;E6D5zOI;IAEI,2BAAA;IAAA,8BAAA;E7D8zOR;E6Dh0OI;IAEI,2BAAA;IAAA,8BAAA;E7Dk0OR;E6Dp0OI;IAEI,2BAAA;IAAA,8BAAA;E7Ds0OR;E6Dx0OI;IAEI,2BAAA;IAAA,8BAAA;E7D00OR;E6D50OI;IAEI,wBAAA;E7D60OR;E6D/0OI;IAEI,8BAAA;E7Dg1OR;E6Dl1OI;IAEI,6BAAA;E7Dm1OR;E6Dr1OI;IAEI,2BAAA;E7Ds1OR;E6Dx1OI;IAEI,6BAAA;E7Dy1OR;E6D31OI;IAEI,2BAAA;E7D41OR;E6D91OI;IAEI,2BAAA;E7D+1OR;E6Dj2OI;IAEI,2BAAA;E7Dk2OR;E6Dp2OI;IAEI,2BAAA;E7Dq2OR;E6Dv2OI;IAEI,2BAAA;E7Dw2OR;E6D12OI;IAEI,2BAAA;E7D22OR;E6D72OI;IAEI,0BAAA;E7D82OR;E6Dh3OI;IAEI,gCAAA;E7Di3OR;E6Dn3OI;IAEI,+BAAA;E7Do3OR;E6Dt3OI;IAEI,6BAAA;E7Du3OR;E6Dz3OI;IAEI,+BAAA;E7D03OR;E6D53OI;IAEI,6BAAA;E7D63OR;E6D/3OI;IAEI,6BAAA;E7Dg4OR;E6Dl4OI;IAEI,6BAAA;E7Dm4OR;E6Dr4OI;IAEI,6BAAA;E7Ds4OR;E6Dx4OI;IAEI,6BAAA;E7Dy4OR;E6D34OI;IAEI,6BAAA;E7D44OR;E6D94OI;IAEI,2BAAA;E7D+4OR;E6Dj5OI;IAEI,iCAAA;E7Dk5OR;E6Dp5OI;IAEI,gCAAA;E7Dq5OR;E6Dv5OI;IAEI,8BAAA;E7Dw5OR;E6D15OI;IAEI,gCAAA;E7D25OR;E6D75OI;IAEI,8BAAA;E7D85OR;E6Dh6OI;IAEI,8BAAA;E7Di6OR;E6Dn6OI;IAEI,8BAAA;E7Do6OR;E6Dt6OI;IAEI,8BAAA;E7Du6OR;E6Dz6OI;IAEI,8BAAA;E7D06OR;E6D56OI;IAEI,8BAAA;E7D66OR;E6D/6OI;IAEI,yBAAA;E7Dg7OR;E6Dl7OI;IAEI,+BAAA;E7Dm7OR;E6Dr7OI;IAEI,8BAAA;E7Ds7OR;E6Dx7OI;IAEI,4BAAA;E7Dy7OR;E6D37OI;IAEI,8BAAA;E7D47OR;E6D97OI;IAEI,4BAAA;E7D+7OR;E6Dj8OI;IAEI,4BAAA;E7Dk8OR;E6Dp8OI;IAEI,4BAAA;E7Dq8OR;E6Dv8OI;IAEI,4BAAA;E7Dw8OR;E6D18OI;IAEI,4BAAA;E7D28OR;E6D78OI;IAEI,4BAAA;E7D88OR;E6Dh9OI;IAEI,qBAAA;E7Di9OR;E6Dn9OI;IAEI,2BAAA;E7Do9OR;E6Dt9OI;IAEI,0BAAA;E7Du9OR;E6Dz9OI;IAEI,wBAAA;E7D09OR;E6D59OI;IAEI,0BAAA;E7D69OR;E6D/9OI;IAEI,wBAAA;E7Dg+OR;E6Dl+OI;IAEI,wBAAA;E7Dm+OR;E6Dr+OI;IAEI,wBAAA;E7Ds+OR;E6Dx+OI;IAEI,wBAAA;E7Dy+OR;E6D3+OI;IAEI,wBAAA;E7D4+OR;E6D9+OI;IAEI,2BAAA;IAAA,0BAAA;E7Dg/OR;E6Dl/OI;IAEI,iCAAA;IAAA,gCAAA;E7Do/OR;E6Dt/OI;IAEI,gCAAA;IAAA,+BAAA;E7Dw/OR;E6D1/OI;IAEI,8BAAA;IAAA,6BAAA;E7D4/OR;E6D9/OI;IAEI,gCAAA;IAAA,+BAAA;E7DggPR;E6DlgPI;IAEI,8BAAA;IAAA,6BAAA;E7DogPR;E6DtgPI;IAEI,8BAAA;IAAA,6BAAA;E7DwgPR;E6D1gPI;IAEI,8BAAA;IAAA,6BAAA;E7D4gPR;E6D9gPI;IAEI,8BAAA;IAAA,6BAAA;E7DghPR;E6DlhPI;IAEI,8BAAA;IAAA,6BAAA;E7DohPR;E6DthPI;IAEI,yBAAA;IAAA,4BAAA;E7DwhPR;E6D1hPI;IAEI,+BAAA;IAAA,kCAAA;E7D4hPR;E6D9hPI;IAEI,8BAAA;IAAA,iCAAA;E7DgiPR;E6DliPI;IAEI,4BAAA;IAAA,+BAAA;E7DoiPR;E6DtiPI;IAEI,8BAAA;IAAA,iCAAA;E7DwiPR;E6D1iPI;IAEI,4BAAA;IAAA,+BAAA;E7D4iPR;E6D9iPI;IAEI,4BAAA;IAAA,+BAAA;E7DgjPR;E6DljPI;IAEI,4BAAA;IAAA,+BAAA;E7DojPR;E6DtjPI;IAEI,4BAAA;IAAA,+BAAA;E7DwjPR;E6D1jPI;IAEI,4BAAA;IAAA,+BAAA;E7D4jPR;E6D9jPI;IAEI,yBAAA;E7D+jPR;E6DjkPI;IAEI,+BAAA;E7DkkPR;E6DpkPI;IAEI,8BAAA;E7DqkPR;E6DvkPI;IAEI,4BAAA;E7DwkPR;E6D1kPI;IAEI,8BAAA;E7D2kPR;E6D7kPI;IAEI,4BAAA;E7D8kPR;E6DhlPI;IAEI,4BAAA;E7DilPR;E6DnlPI;IAEI,4BAAA;E7DolPR;E6DtlPI;IAEI,4BAAA;E7DulPR;E6DzlPI;IAEI,4BAAA;E7D0lPR;E6D5lPI;IAEI,2BAAA;E7D6lPR;E6D/lPI;IAEI,iCAAA;E7DgmPR;E6DlmPI;IAEI,gCAAA;E7DmmPR;E6DrmPI;IAEI,8BAAA;E7DsmPR;E6DxmPI;IAEI,gCAAA;E7DymPR;E6D3mPI;IAEI,8BAAA;E7D4mPR;E6D9mPI;IAEI,8BAAA;E7D+mPR;E6DjnPI;IAEI,8BAAA;E7DknPR;E6DpnPI;IAEI,8BAAA;E7DqnPR;E6DvnPI;IAEI,8BAAA;E7DwnPR;E6D1nPI;IAEI,4BAAA;E7D2nPR;E6D7nPI;IAEI,kCAAA;E7D8nPR;E6DhoPI;IAEI,iCAAA;E7DioPR;E6DnoPI;IAEI,+BAAA;E7DooPR;E6DtoPI;IAEI,iCAAA;E7DuoPR;E6DzoPI;IAEI,+BAAA;E7D0oPR;E6D5oPI;IAEI,+BAAA;E7D6oPR;E6D/oPI;IAEI,+BAAA;E7DgpPR;E6DlpPI;IAEI,+BAAA;E7DmpPR;E6DrpPI;IAEI,+BAAA;E7DspPR;E6DxpPI;IAEI,0BAAA;E7DypPR;E6D3pPI;IAEI,gCAAA;E7D4pPR;E6D9pPI;IAEI,+BAAA;E7D+pPR;E6DjqPI;IAEI,6BAAA;E7DkqPR;E6DpqPI;IAEI,+BAAA;E7DqqPR;E6DvqPI;IAEI,6BAAA;E7DwqPR;E6D1qPI;IAEI,6BAAA;E7D2qPR;E6D7qPI;IAEI,6BAAA;E7D8qPR;E6DhrPI;IAEI,6BAAA;E7DirPR;E6DnrPI;IAEI,6BAAA;E7DorPR;E6DtrPI;IAEI,2BAAA;E7DurPR;E6DzrPI;IAEI,4BAAA;E7D0rPR;E6D5rPI;IAEI,6BAAA;E7D6rPR;AACF;AclrPI;E+CdE;IAEI,sBAAA;E7DksPR;E6DpsPI;IAEI,uBAAA;E7DqsPR;E6DvsPI;IAEI,sBAAA;E7DwsPR;E6D1sPI;IAEI,0BAAA;E7D2sPR;E6D7sPI;IAEI,gCAAA;E7D8sPR;E6DhtPI;IAEI,yBAAA;E7DitPR;E6DntPI;IAEI,wBAAA;E7DotPR;E6DttPI;IAEI,yBAAA;E7DutPR;E6DztPI;IAEI,6BAAA;E7D0tPR;E6D5tPI;IAEI,8BAAA;E7D6tPR;E6D/tPI;IAEI,wBAAA;E7DguPR;E6DluPI;IAEI,+BAAA;E7DmuPR;E6DruPI;IAEI,wBAAA;E7DsuPR;E6DxuPI;IAEI,yBAAA;E7DyuPR;E6D3uPI;IAEI,8BAAA;E7D4uPR;E6D9uPI;IAEI,iCAAA;E7D+uPR;E6DjvPI;IAEI,sCAAA;E7DkvPR;E6DpvPI;IAEI,yCAAA;E7DqvPR;E6DvvPI;IAEI,uBAAA;E7DwvPR;E6D1vPI;IAEI,uBAAA;E7D2vPR;E6D7vPI;IAEI,yBAAA;E7D8vPR;E6DhwPI;IAEI,yBAAA;E7DiwPR;E6DnwPI;IAEI,0BAAA;E7DowPR;E6DtwPI;IAEI,4BAAA;E7DuwPR;E6DzwPI;IAEI,kCAAA;E7D0wPR;E6D5wPI;IAEI,iBAAA;E7D6wPR;E6D/wPI;IAEI,uBAAA;E7DgxPR;E6DlxPI;IAEI,sBAAA;E7DmxPR;E6DrxPI;IAEI,oBAAA;E7DsxPR;E6DxxPI;IAEI,sBAAA;E7DyxPR;E6D3xPI;IAEI,oBAAA;E7D4xPR;E6D9xPI;IAEI,oBAAA;E7D+xPR;E6DjyPI;IAEI,oBAAA;E7DkyPR;E6DpyPI;IAEI,oBAAA;E7DqyPR;E6DvyPI;IAEI,oBAAA;E7DwyPR;E6D1yPI;IAEI,sCAAA;E7D2yPR;E6D7yPI;IAEI,oCAAA;E7D8yPR;E6DhzPI;IAEI,kCAAA;E7DizPR;E6DnzPI;IAEI,yCAAA;E7DozPR;E6DtzPI;IAEI,wCAAA;E7DuzPR;E6DzzPI;IAEI,wCAAA;E7D0zPR;E6D5zPI;IAEI,kCAAA;E7D6zPR;E6D/zPI;IAEI,gCAAA;E7Dg0PR;E6Dl0PI;IAEI,8BAAA;E7Dm0PR;E6Dr0PI;IAEI,gCAAA;E7Ds0PR;E6Dx0PI;IAEI,+BAAA;E7Dy0PR;E6D30PI;IAEI,oCAAA;E7D40PR;E6D90PI;IAEI,kCAAA;E7D+0PR;E6Dj1PI;IAEI,gCAAA;E7Dk1PR;E6Dp1PI;IAEI,uCAAA;E7Dq1PR;E6Dv1PI;IAEI,sCAAA;E7Dw1PR;E6D11PI;IAEI,iCAAA;E7D21PR;E6D71PI;IAEI,2BAAA;E7D81PR;E6Dh2PI;IAEI,iCAAA;E7Di2PR;E6Dn2PI;IAEI,+BAAA;E7Do2PR;E6Dt2PI;IAEI,6BAAA;E7Du2PR;E6Dz2PI;IAEI,+BAAA;E7D02PR;E6D52PI;IAEI,8BAAA;E7D62PR;E6D/2PI;IAEI,oBAAA;E7Dg3PR;E6Dl3PI;IAEI,mBAAA;E7Dm3PR;E6Dr3PI;IAEI,mBAAA;E7Ds3PR;E6Dx3PI;IAEI,mBAAA;E7Dy3PR;E6D33PI;IAEI,mBAAA;E7D43PR;E6D93PI;IAEI,mBAAA;E7D+3PR;E6Dj4PI;IAEI,mBAAA;E7Dk4PR;E6Dp4PI;IAEI,mBAAA;E7Dq4PR;E6Dv4PI;IAEI,oBAAA;E7Dw4PR;E6D14PI;IAEI,0BAAA;E7D24PR;E6D74PI;IAEI,yBAAA;E7D84PR;E6Dh5PI;IAEI,uBAAA;E7Di5PR;E6Dn5PI;IAEI,yBAAA;E7Do5PR;E6Dt5PI;IAEI,uBAAA;E7Du5PR;E6Dz5PI;IAEI,uBAAA;E7D05PR;E6D55PI;IAEI,uBAAA;E7D65PR;E6D/5PI;IAEI,uBAAA;E7Dg6PR;E6Dl6PI;IAEI,uBAAA;E7Dm6PR;E6Dr6PI;IAEI,uBAAA;E7Ds6PR;E6Dx6PI;IAEI,0BAAA;IAAA,yBAAA;E7D06PR;E6D56PI;IAEI,gCAAA;IAAA,+BAAA;E7D86PR;E6Dh7PI;IAEI,+BAAA;IAAA,8BAAA;E7Dk7PR;E6Dp7PI;IAEI,6BAAA;IAAA,4BAAA;E7Ds7PR;E6Dx7PI;IAEI,+BAAA;IAAA,8BAAA;E7D07PR;E6D57PI;IAEI,6BAAA;IAAA,4BAAA;E7D87PR;E6Dh8PI;IAEI,6BAAA;IAAA,4BAAA;E7Dk8PR;E6Dp8PI;IAEI,6BAAA;IAAA,4BAAA;E7Ds8PR;E6Dx8PI;IAEI,6BAAA;IAAA,4BAAA;E7D08PR;E6D58PI;IAEI,6BAAA;IAAA,4BAAA;E7D88PR;E6Dh9PI;IAEI,6BAAA;IAAA,4BAAA;E7Dk9PR;E6Dp9PI;IAEI,wBAAA;IAAA,2BAAA;E7Ds9PR;E6Dx9PI;IAEI,8BAAA;IAAA,iCAAA;E7D09PR;E6D59PI;IAEI,6BAAA;IAAA,gCAAA;E7D89PR;E6Dh+PI;IAEI,2BAAA;IAAA,8BAAA;E7Dk+PR;E6Dp+PI;IAEI,6BAAA;IAAA,gCAAA;E7Ds+PR;E6Dx+PI;IAEI,2BAAA;IAAA,8BAAA;E7D0+PR;E6D5+PI;IAEI,2BAAA;IAAA,8BAAA;E7D8+PR;E6Dh/PI;IAEI,2BAAA;IAAA,8BAAA;E7Dk/PR;E6Dp/PI;IAEI,2BAAA;IAAA,8BAAA;E7Ds/PR;E6Dx/PI;IAEI,2BAAA;IAAA,8BAAA;E7D0/PR;E6D5/PI;IAEI,2BAAA;IAAA,8BAAA;E7D8/PR;E6DhgQI;IAEI,wBAAA;E7DigQR;E6DngQI;IAEI,8BAAA;E7DogQR;E6DtgQI;IAEI,6BAAA;E7DugQR;E6DzgQI;IAEI,2BAAA;E7D0gQR;E6D5gQI;IAEI,6BAAA;E7D6gQR;E6D/gQI;IAEI,2BAAA;E7DghQR;E6DlhQI;IAEI,2BAAA;E7DmhQR;E6DrhQI;IAEI,2BAAA;E7DshQR;E6DxhQI;IAEI,2BAAA;E7DyhQR;E6D3hQI;IAEI,2BAAA;E7D4hQR;E6D9hQI;IAEI,2BAAA;E7D+hQR;E6DjiQI;IAEI,0BAAA;E7DkiQR;E6DpiQI;IAEI,gCAAA;E7DqiQR;E6DviQI;IAEI,+BAAA;E7DwiQR;E6D1iQI;IAEI,6BAAA;E7D2iQR;E6D7iQI;IAEI,+BAAA;E7D8iQR;E6DhjQI;IAEI,6BAAA;E7DijQR;E6DnjQI;IAEI,6BAAA;E7DojQR;E6DtjQI;IAEI,6BAAA;E7DujQR;E6DzjQI;IAEI,6BAAA;E7D0jQR;E6D5jQI;IAEI,6BAAA;E7D6jQR;E6D/jQI;IAEI,6BAAA;E7DgkQR;E6DlkQI;IAEI,2BAAA;E7DmkQR;E6DrkQI;IAEI,iCAAA;E7DskQR;E6DxkQI;IAEI,gCAAA;E7DykQR;E6D3kQI;IAEI,8BAAA;E7D4kQR;E6D9kQI;IAEI,gCAAA;E7D+kQR;E6DjlQI;IAEI,8BAAA;E7DklQR;E6DplQI;IAEI,8BAAA;E7DqlQR;E6DvlQI;IAEI,8BAAA;E7DwlQR;E6D1lQI;IAEI,8BAAA;E7D2lQR;E6D7lQI;IAEI,8BAAA;E7D8lQR;E6DhmQI;IAEI,8BAAA;E7DimQR;E6DnmQI;IAEI,yBAAA;E7DomQR;E6DtmQI;IAEI,+BAAA;E7DumQR;E6DzmQI;IAEI,8BAAA;E7D0mQR;E6D5mQI;IAEI,4BAAA;E7D6mQR;E6D/mQI;IAEI,8BAAA;E7DgnQR;E6DlnQI;IAEI,4BAAA;E7DmnQR;E6DrnQI;IAEI,4BAAA;E7DsnQR;E6DxnQI;IAEI,4BAAA;E7DynQR;E6D3nQI;IAEI,4BAAA;E7D4nQR;E6D9nQI;IAEI,4BAAA;E7D+nQR;E6DjoQI;IAEI,4BAAA;E7DkoQR;E6DpoQI;IAEI,qBAAA;E7DqoQR;E6DvoQI;IAEI,2BAAA;E7DwoQR;E6D1oQI;IAEI,0BAAA;E7D2oQR;E6D7oQI;IAEI,wBAAA;E7D8oQR;E6DhpQI;IAEI,0BAAA;E7DipQR;E6DnpQI;IAEI,wBAAA;E7DopQR;E6DtpQI;IAEI,wBAAA;E7DupQR;E6DzpQI;IAEI,wBAAA;E7D0pQR;E6D5pQI;IAEI,wBAAA;E7D6pQR;E6D/pQI;IAEI,wBAAA;E7DgqQR;E6DlqQI;IAEI,2BAAA;IAAA,0BAAA;E7DoqQR;E6DtqQI;IAEI,iCAAA;IAAA,gCAAA;E7DwqQR;E6D1qQI;IAEI,gCAAA;IAAA,+BAAA;E7D4qQR;E6D9qQI;IAEI,8BAAA;IAAA,6BAAA;E7DgrQR;E6DlrQI;IAEI,gCAAA;IAAA,+BAAA;E7DorQR;E6DtrQI;IAEI,8BAAA;IAAA,6BAAA;E7DwrQR;E6D1rQI;IAEI,8BAAA;IAAA,6BAAA;E7D4rQR;E6D9rQI;IAEI,8BAAA;IAAA,6BAAA;E7DgsQR;E6DlsQI;IAEI,8BAAA;IAAA,6BAAA;E7DosQR;E6DtsQI;IAEI,8BAAA;IAAA,6BAAA;E7DwsQR;E6D1sQI;IAEI,yBAAA;IAAA,4BAAA;E7D4sQR;E6D9sQI;IAEI,+BAAA;IAAA,kCAAA;E7DgtQR;E6DltQI;IAEI,8BAAA;IAAA,iCAAA;E7DotQR;E6DttQI;IAEI,4BAAA;IAAA,+BAAA;E7DwtQR;E6D1tQI;IAEI,8BAAA;IAAA,iCAAA;E7D4tQR;E6D9tQI;IAEI,4BAAA;IAAA,+BAAA;E7DguQR;E6DluQI;IAEI,4BAAA;IAAA,+BAAA;E7DouQR;E6DtuQI;IAEI,4BAAA;IAAA,+BAAA;E7DwuQR;E6D1uQI;IAEI,4BAAA;IAAA,+BAAA;E7D4uQR;E6D9uQI;IAEI,4BAAA;IAAA,+BAAA;E7DgvQR;E6DlvQI;IAEI,yBAAA;E7DmvQR;E6DrvQI;IAEI,+BAAA;E7DsvQR;E6DxvQI;IAEI,8BAAA;E7DyvQR;E6D3vQI;IAEI,4BAAA;E7D4vQR;E6D9vQI;IAEI,8BAAA;E7D+vQR;E6DjwQI;IAEI,4BAAA;E7DkwQR;E6DpwQI;IAEI,4BAAA;E7DqwQR;E6DvwQI;IAEI,4BAAA;E7DwwQR;E6D1wQI;IAEI,4BAAA;E7D2wQR;E6D7wQI;IAEI,4BAAA;E7D8wQR;E6DhxQI;IAEI,2BAAA;E7DixQR;E6DnxQI;IAEI,iCAAA;E7DoxQR;E6DtxQI;IAEI,gCAAA;E7DuxQR;E6DzxQI;IAEI,8BAAA;E7D0xQR;E6D5xQI;IAEI,gCAAA;E7D6xQR;E6D/xQI;IAEI,8BAAA;E7DgyQR;E6DlyQI;IAEI,8BAAA;E7DmyQR;E6DryQI;IAEI,8BAAA;E7DsyQR;E6DxyQI;IAEI,8BAAA;E7DyyQR;E6D3yQI;IAEI,8BAAA;E7D4yQR;E6D9yQI;IAEI,4BAAA;E7D+yQR;E6DjzQI;IAEI,kCAAA;E7DkzQR;E6DpzQI;IAEI,iCAAA;E7DqzQR;E6DvzQI;IAEI,+BAAA;E7DwzQR;E6D1zQI;IAEI,iCAAA;E7D2zQR;E6D7zQI;IAEI,+BAAA;E7D8zQR;E6Dh0QI;IAEI,+BAAA;E7Di0QR;E6Dn0QI;IAEI,+BAAA;E7Do0QR;E6Dt0QI;IAEI,+BAAA;E7Du0QR;E6Dz0QI;IAEI,+BAAA;E7D00QR;E6D50QI;IAEI,0BAAA;E7D60QR;E6D/0QI;IAEI,gCAAA;E7Dg1QR;E6Dl1QI;IAEI,+BAAA;E7Dm1QR;E6Dr1QI;IAEI,6BAAA;E7Ds1QR;E6Dx1QI;IAEI,+BAAA;E7Dy1QR;E6D31QI;IAEI,6BAAA;E7D41QR;E6D91QI;IAEI,6BAAA;E7D+1QR;E6Dj2QI;IAEI,6BAAA;E7Dk2QR;E6Dp2QI;IAEI,6BAAA;E7Dq2QR;E6Dv2QI;IAEI,6BAAA;E7Dw2QR;E6D12QI;IAEI,2BAAA;E7D22QR;E6D72QI;IAEI,4BAAA;E7D82QR;E6Dh3QI;IAEI,6BAAA;E7Di3QR;AACF;Act2QI;E+CdE;IAEI,sBAAA;E7Ds3QR;E6Dx3QI;IAEI,uBAAA;E7Dy3QR;E6D33QI;IAEI,sBAAA;E7D43QR;E6D93QI;IAEI,0BAAA;E7D+3QR;E6Dj4QI;IAEI,gCAAA;E7Dk4QR;E6Dp4QI;IAEI,yBAAA;E7Dq4QR;E6Dv4QI;IAEI,wBAAA;E7Dw4QR;E6D14QI;IAEI,yBAAA;E7D24QR;E6D74QI;IAEI,6BAAA;E7D84QR;E6Dh5QI;IAEI,8BAAA;E7Di5QR;E6Dn5QI;IAEI,wBAAA;E7Do5QR;E6Dt5QI;IAEI,+BAAA;E7Du5QR;E6Dz5QI;IAEI,wBAAA;E7D05QR;E6D55QI;IAEI,yBAAA;E7D65QR;E6D/5QI;IAEI,8BAAA;E7Dg6QR;E6Dl6QI;IAEI,iCAAA;E7Dm6QR;E6Dr6QI;IAEI,sCAAA;E7Ds6QR;E6Dx6QI;IAEI,yCAAA;E7Dy6QR;E6D36QI;IAEI,uBAAA;E7D46QR;E6D96QI;IAEI,uBAAA;E7D+6QR;E6Dj7QI;IAEI,yBAAA;E7Dk7QR;E6Dp7QI;IAEI,yBAAA;E7Dq7QR;E6Dv7QI;IAEI,0BAAA;E7Dw7QR;E6D17QI;IAEI,4BAAA;E7D27QR;E6D77QI;IAEI,kCAAA;E7D87QR;E6Dh8QI;IAEI,iBAAA;E7Di8QR;E6Dn8QI;IAEI,uBAAA;E7Do8QR;E6Dt8QI;IAEI,sBAAA;E7Du8QR;E6Dz8QI;IAEI,oBAAA;E7D08QR;E6D58QI;IAEI,sBAAA;E7D68QR;E6D/8QI;IAEI,oBAAA;E7Dg9QR;E6Dl9QI;IAEI,oBAAA;E7Dm9QR;E6Dr9QI;IAEI,oBAAA;E7Ds9QR;E6Dx9QI;IAEI,oBAAA;E7Dy9QR;E6D39QI;IAEI,oBAAA;E7D49QR;E6D99QI;IAEI,sCAAA;E7D+9QR;E6Dj+QI;IAEI,oCAAA;E7Dk+QR;E6Dp+QI;IAEI,kCAAA;E7Dq+QR;E6Dv+QI;IAEI,yCAAA;E7Dw+QR;E6D1+QI;IAEI,wCAAA;E7D2+QR;E6D7+QI;IAEI,wCAAA;E7D8+QR;E6Dh/QI;IAEI,kCAAA;E7Di/QR;E6Dn/QI;IAEI,gCAAA;E7Do/QR;E6Dt/QI;IAEI,8BAAA;E7Du/QR;E6Dz/QI;IAEI,gCAAA;E7D0/QR;E6D5/QI;IAEI,+BAAA;E7D6/QR;E6D//QI;IAEI,oCAAA;E7DggRR;E6DlgRI;IAEI,kCAAA;E7DmgRR;E6DrgRI;IAEI,gCAAA;E7DsgRR;E6DxgRI;IAEI,uCAAA;E7DygRR;E6D3gRI;IAEI,sCAAA;E7D4gRR;E6D9gRI;IAEI,iCAAA;E7D+gRR;E6DjhRI;IAEI,2BAAA;E7DkhRR;E6DphRI;IAEI,iCAAA;E7DqhRR;E6DvhRI;IAEI,+BAAA;E7DwhRR;E6D1hRI;IAEI,6BAAA;E7D2hRR;E6D7hRI;IAEI,+BAAA;E7D8hRR;E6DhiRI;IAEI,8BAAA;E7DiiRR;E6DniRI;IAEI,oBAAA;E7DoiRR;E6DtiRI;IAEI,mBAAA;E7DuiRR;E6DziRI;IAEI,mBAAA;E7D0iRR;E6D5iRI;IAEI,mBAAA;E7D6iRR;E6D/iRI;IAEI,mBAAA;E7DgjRR;E6DljRI;IAEI,mBAAA;E7DmjRR;E6DrjRI;IAEI,mBAAA;E7DsjRR;E6DxjRI;IAEI,mBAAA;E7DyjRR;E6D3jRI;IAEI,oBAAA;E7D4jRR;E6D9jRI;IAEI,0BAAA;E7D+jRR;E6DjkRI;IAEI,yBAAA;E7DkkRR;E6DpkRI;IAEI,uBAAA;E7DqkRR;E6DvkRI;IAEI,yBAAA;E7DwkRR;E6D1kRI;IAEI,uBAAA;E7D2kRR;E6D7kRI;IAEI,uBAAA;E7D8kRR;E6DhlRI;IAEI,uBAAA;E7DilRR;E6DnlRI;IAEI,uBAAA;E7DolRR;E6DtlRI;IAEI,uBAAA;E7DulRR;E6DzlRI;IAEI,uBAAA;E7D0lRR;E6D5lRI;IAEI,0BAAA;IAAA,yBAAA;E7D8lRR;E6DhmRI;IAEI,gCAAA;IAAA,+BAAA;E7DkmRR;E6DpmRI;IAEI,+BAAA;IAAA,8BAAA;E7DsmRR;E6DxmRI;IAEI,6BAAA;IAAA,4BAAA;E7D0mRR;E6D5mRI;IAEI,+BAAA;IAAA,8BAAA;E7D8mRR;E6DhnRI;IAEI,6BAAA;IAAA,4BAAA;E7DknRR;E6DpnRI;IAEI,6BAAA;IAAA,4BAAA;E7DsnRR;E6DxnRI;IAEI,6BAAA;IAAA,4BAAA;E7D0nRR;E6D5nRI;IAEI,6BAAA;IAAA,4BAAA;E7D8nRR;E6DhoRI;IAEI,6BAAA;IAAA,4BAAA;E7DkoRR;E6DpoRI;IAEI,6BAAA;IAAA,4BAAA;E7DsoRR;E6DxoRI;IAEI,wBAAA;IAAA,2BAAA;E7D0oRR;E6D5oRI;IAEI,8BAAA;IAAA,iCAAA;E7D8oRR;E6DhpRI;IAEI,6BAAA;IAAA,gCAAA;E7DkpRR;E6DppRI;IAEI,2BAAA;IAAA,8BAAA;E7DspRR;E6DxpRI;IAEI,6BAAA;IAAA,gCAAA;E7D0pRR;E6D5pRI;IAEI,2BAAA;IAAA,8BAAA;E7D8pRR;E6DhqRI;IAEI,2BAAA;IAAA,8BAAA;E7DkqRR;E6DpqRI;IAEI,2BAAA;IAAA,8BAAA;E7DsqRR;E6DxqRI;IAEI,2BAAA;IAAA,8BAAA;E7D0qRR;E6D5qRI;IAEI,2BAAA;IAAA,8BAAA;E7D8qRR;E6DhrRI;IAEI,2BAAA;IAAA,8BAAA;E7DkrRR;E6DprRI;IAEI,wBAAA;E7DqrRR;E6DvrRI;IAEI,8BAAA;E7DwrRR;E6D1rRI;IAEI,6BAAA;E7D2rRR;E6D7rRI;IAEI,2BAAA;E7D8rRR;E6DhsRI;IAEI,6BAAA;E7DisRR;E6DnsRI;IAEI,2BAAA;E7DosRR;E6DtsRI;IAEI,2BAAA;E7DusRR;E6DzsRI;IAEI,2BAAA;E7D0sRR;E6D5sRI;IAEI,2BAAA;E7D6sRR;E6D/sRI;IAEI,2BAAA;E7DgtRR;E6DltRI;IAEI,2BAAA;E7DmtRR;E6DrtRI;IAEI,0BAAA;E7DstRR;E6DxtRI;IAEI,gCAAA;E7DytRR;E6D3tRI;IAEI,+BAAA;E7D4tRR;E6D9tRI;IAEI,6BAAA;E7D+tRR;E6DjuRI;IAEI,+BAAA;E7DkuRR;E6DpuRI;IAEI,6BAAA;E7DquRR;E6DvuRI;IAEI,6BAAA;E7DwuRR;E6D1uRI;IAEI,6BAAA;E7D2uRR;E6D7uRI;IAEI,6BAAA;E7D8uRR;E6DhvRI;IAEI,6BAAA;E7DivRR;E6DnvRI;IAEI,6BAAA;E7DovRR;E6DtvRI;IAEI,2BAAA;E7DuvRR;E6DzvRI;IAEI,iCAAA;E7D0vRR;E6D5vRI;IAEI,gCAAA;E7D6vRR;E6D/vRI;IAEI,8BAAA;E7DgwRR;E6DlwRI;IAEI,gCAAA;E7DmwRR;E6DrwRI;IAEI,8BAAA;E7DswRR;E6DxwRI;IAEI,8BAAA;E7DywRR;E6D3wRI;IAEI,8BAAA;E7D4wRR;E6D9wRI;IAEI,8BAAA;E7D+wRR;E6DjxRI;IAEI,8BAAA;E7DkxRR;E6DpxRI;IAEI,8BAAA;E7DqxRR;E6DvxRI;IAEI,yBAAA;E7DwxRR;E6D1xRI;IAEI,+BAAA;E7D2xRR;E6D7xRI;IAEI,8BAAA;E7D8xRR;E6DhyRI;IAEI,4BAAA;E7DiyRR;E6DnyRI;IAEI,8BAAA;E7DoyRR;E6DtyRI;IAEI,4BAAA;E7DuyRR;E6DzyRI;IAEI,4BAAA;E7D0yRR;E6D5yRI;IAEI,4BAAA;E7D6yRR;E6D/yRI;IAEI,4BAAA;E7DgzRR;E6DlzRI;IAEI,4BAAA;E7DmzRR;E6DrzRI;IAEI,4BAAA;E7DszRR;E6DxzRI;IAEI,qBAAA;E7DyzRR;E6D3zRI;IAEI,2BAAA;E7D4zRR;E6D9zRI;IAEI,0BAAA;E7D+zRR;E6Dj0RI;IAEI,wBAAA;E7Dk0RR;E6Dp0RI;IAEI,0BAAA;E7Dq0RR;E6Dv0RI;IAEI,wBAAA;E7Dw0RR;E6D10RI;IAEI,wBAAA;E7D20RR;E6D70RI;IAEI,wBAAA;E7D80RR;E6Dh1RI;IAEI,wBAAA;E7Di1RR;E6Dn1RI;IAEI,wBAAA;E7Do1RR;E6Dt1RI;IAEI,2BAAA;IAAA,0BAAA;E7Dw1RR;E6D11RI;IAEI,iCAAA;IAAA,gCAAA;E7D41RR;E6D91RI;IAEI,gCAAA;IAAA,+BAAA;E7Dg2RR;E6Dl2RI;IAEI,8BAAA;IAAA,6BAAA;E7Do2RR;E6Dt2RI;IAEI,gCAAA;IAAA,+BAAA;E7Dw2RR;E6D12RI;IAEI,8BAAA;IAAA,6BAAA;E7D42RR;E6D92RI;IAEI,8BAAA;IAAA,6BAAA;E7Dg3RR;E6Dl3RI;IAEI,8BAAA;IAAA,6BAAA;E7Do3RR;E6Dt3RI;IAEI,8BAAA;IAAA,6BAAA;E7Dw3RR;E6D13RI;IAEI,8BAAA;IAAA,6BAAA;E7D43RR;E6D93RI;IAEI,yBAAA;IAAA,4BAAA;E7Dg4RR;E6Dl4RI;IAEI,+BAAA;IAAA,kCAAA;E7Do4RR;E6Dt4RI;IAEI,8BAAA;IAAA,iCAAA;E7Dw4RR;E6D14RI;IAEI,4BAAA;IAAA,+BAAA;E7D44RR;E6D94RI;IAEI,8BAAA;IAAA,iCAAA;E7Dg5RR;E6Dl5RI;IAEI,4BAAA;IAAA,+BAAA;E7Do5RR;E6Dt5RI;IAEI,4BAAA;IAAA,+BAAA;E7Dw5RR;E6D15RI;IAEI,4BAAA;IAAA,+BAAA;E7D45RR;E6D95RI;IAEI,4BAAA;IAAA,+BAAA;E7Dg6RR;E6Dl6RI;IAEI,4BAAA;IAAA,+BAAA;E7Do6RR;E6Dt6RI;IAEI,yBAAA;E7Du6RR;E6Dz6RI;IAEI,+BAAA;E7D06RR;E6D56RI;IAEI,8BAAA;E7D66RR;E6D/6RI;IAEI,4BAAA;E7Dg7RR;E6Dl7RI;IAEI,8BAAA;E7Dm7RR;E6Dr7RI;IAEI,4BAAA;E7Ds7RR;E6Dx7RI;IAEI,4BAAA;E7Dy7RR;E6D37RI;IAEI,4BAAA;E7D47RR;E6D97RI;IAEI,4BAAA;E7D+7RR;E6Dj8RI;IAEI,4BAAA;E7Dk8RR;E6Dp8RI;IAEI,2BAAA;E7Dq8RR;E6Dv8RI;IAEI,iCAAA;E7Dw8RR;E6D18RI;IAEI,gCAAA;E7D28RR;E6D78RI;IAEI,8BAAA;E7D88RR;E6Dh9RI;IAEI,gCAAA;E7Di9RR;E6Dn9RI;IAEI,8BAAA;E7Do9RR;E6Dt9RI;IAEI,8BAAA;E7Du9RR;E6Dz9RI;IAEI,8BAAA;E7D09RR;E6D59RI;IAEI,8BAAA;E7D69RR;E6D/9RI;IAEI,8BAAA;E7Dg+RR;E6Dl+RI;IAEI,4BAAA;E7Dm+RR;E6Dr+RI;IAEI,kCAAA;E7Ds+RR;E6Dx+RI;IAEI,iCAAA;E7Dy+RR;E6D3+RI;IAEI,+BAAA;E7D4+RR;E6D9+RI;IAEI,iCAAA;E7D++RR;E6Dj/RI;IAEI,+BAAA;E7Dk/RR;E6Dp/RI;IAEI,+BAAA;E7Dq/RR;E6Dv/RI;IAEI,+BAAA;E7Dw/RR;E6D1/RI;IAEI,+BAAA;E7D2/RR;E6D7/RI;IAEI,+BAAA;E7D8/RR;E6DhgSI;IAEI,0BAAA;E7DigSR;E6DngSI;IAEI,gCAAA;E7DogSR;E6DtgSI;IAEI,+BAAA;E7DugSR;E6DzgSI;IAEI,6BAAA;E7D0gSR;E6D5gSI;IAEI,+BAAA;E7D6gSR;E6D/gSI;IAEI,6BAAA;E7DghSR;E6DlhSI;IAEI,6BAAA;E7DmhSR;E6DrhSI;IAEI,6BAAA;E7DshSR;E6DxhSI;IAEI,6BAAA;E7DyhSR;E6D3hSI;IAEI,6BAAA;E7D4hSR;E6D9hSI;IAEI,2BAAA;E7D+hSR;E6DjiSI;IAEI,4BAAA;E7DkiSR;E6DpiSI;IAEI,6BAAA;E7DqiSR;AACF;Ac1hSI;E+CdE;IAEI,sBAAA;E7D0iSR;E6D5iSI;IAEI,uBAAA;E7D6iSR;E6D/iSI;IAEI,sBAAA;E7DgjSR;E6DljSI;IAEI,0BAAA;E7DmjSR;E6DrjSI;IAEI,gCAAA;E7DsjSR;E6DxjSI;IAEI,yBAAA;E7DyjSR;E6D3jSI;IAEI,wBAAA;E7D4jSR;E6D9jSI;IAEI,yBAAA;E7D+jSR;E6DjkSI;IAEI,6BAAA;E7DkkSR;E6DpkSI;IAEI,8BAAA;E7DqkSR;E6DvkSI;IAEI,wBAAA;E7DwkSR;E6D1kSI;IAEI,+BAAA;E7D2kSR;E6D7kSI;IAEI,wBAAA;E7D8kSR;E6DhlSI;IAEI,yBAAA;E7DilSR;E6DnlSI;IAEI,8BAAA;E7DolSR;E6DtlSI;IAEI,iCAAA;E7DulSR;E6DzlSI;IAEI,sCAAA;E7D0lSR;E6D5lSI;IAEI,yCAAA;E7D6lSR;E6D/lSI;IAEI,uBAAA;E7DgmSR;E6DlmSI;IAEI,uBAAA;E7DmmSR;E6DrmSI;IAEI,yBAAA;E7DsmSR;E6DxmSI;IAEI,yBAAA;E7DymSR;E6D3mSI;IAEI,0BAAA;E7D4mSR;E6D9mSI;IAEI,4BAAA;E7D+mSR;E6DjnSI;IAEI,kCAAA;E7DknSR;E6DpnSI;IAEI,iBAAA;E7DqnSR;E6DvnSI;IAEI,uBAAA;E7DwnSR;E6D1nSI;IAEI,sBAAA;E7D2nSR;E6D7nSI;IAEI,oBAAA;E7D8nSR;E6DhoSI;IAEI,sBAAA;E7DioSR;E6DnoSI;IAEI,oBAAA;E7DooSR;E6DtoSI;IAEI,oBAAA;E7DuoSR;E6DzoSI;IAEI,oBAAA;E7D0oSR;E6D5oSI;IAEI,oBAAA;E7D6oSR;E6D/oSI;IAEI,oBAAA;E7DgpSR;E6DlpSI;IAEI,sCAAA;E7DmpSR;E6DrpSI;IAEI,oCAAA;E7DspSR;E6DxpSI;IAEI,kCAAA;E7DypSR;E6D3pSI;IAEI,yCAAA;E7D4pSR;E6D9pSI;IAEI,wCAAA;E7D+pSR;E6DjqSI;IAEI,wCAAA;E7DkqSR;E6DpqSI;IAEI,kCAAA;E7DqqSR;E6DvqSI;IAEI,gCAAA;E7DwqSR;E6D1qSI;IAEI,8BAAA;E7D2qSR;E6D7qSI;IAEI,gCAAA;E7D8qSR;E6DhrSI;IAEI,+BAAA;E7DirSR;E6DnrSI;IAEI,oCAAA;E7DorSR;E6DtrSI;IAEI,kCAAA;E7DurSR;E6DzrSI;IAEI,gCAAA;E7D0rSR;E6D5rSI;IAEI,uCAAA;E7D6rSR;E6D/rSI;IAEI,sCAAA;E7DgsSR;E6DlsSI;IAEI,iCAAA;E7DmsSR;E6DrsSI;IAEI,2BAAA;E7DssSR;E6DxsSI;IAEI,iCAAA;E7DysSR;E6D3sSI;IAEI,+BAAA;E7D4sSR;E6D9sSI;IAEI,6BAAA;E7D+sSR;E6DjtSI;IAEI,+BAAA;E7DktSR;E6DptSI;IAEI,8BAAA;E7DqtSR;E6DvtSI;IAEI,oBAAA;E7DwtSR;E6D1tSI;IAEI,mBAAA;E7D2tSR;E6D7tSI;IAEI,mBAAA;E7D8tSR;E6DhuSI;IAEI,mBAAA;E7DiuSR;E6DnuSI;IAEI,mBAAA;E7DouSR;E6DtuSI;IAEI,mBAAA;E7DuuSR;E6DzuSI;IAEI,mBAAA;E7D0uSR;E6D5uSI;IAEI,mBAAA;E7D6uSR;E6D/uSI;IAEI,oBAAA;E7DgvSR;E6DlvSI;IAEI,0BAAA;E7DmvSR;E6DrvSI;IAEI,yBAAA;E7DsvSR;E6DxvSI;IAEI,uBAAA;E7DyvSR;E6D3vSI;IAEI,yBAAA;E7D4vSR;E6D9vSI;IAEI,uBAAA;E7D+vSR;E6DjwSI;IAEI,uBAAA;E7DkwSR;E6DpwSI;IAEI,uBAAA;E7DqwSR;E6DvwSI;IAEI,uBAAA;E7DwwSR;E6D1wSI;IAEI,uBAAA;E7D2wSR;E6D7wSI;IAEI,uBAAA;E7D8wSR;E6DhxSI;IAEI,0BAAA;IAAA,yBAAA;E7DkxSR;E6DpxSI;IAEI,gCAAA;IAAA,+BAAA;E7DsxSR;E6DxxSI;IAEI,+BAAA;IAAA,8BAAA;E7D0xSR;E6D5xSI;IAEI,6BAAA;IAAA,4BAAA;E7D8xSR;E6DhySI;IAEI,+BAAA;IAAA,8BAAA;E7DkySR;E6DpySI;IAEI,6BAAA;IAAA,4BAAA;E7DsySR;E6DxySI;IAEI,6BAAA;IAAA,4BAAA;E7D0ySR;E6D5ySI;IAEI,6BAAA;IAAA,4BAAA;E7D8ySR;E6DhzSI;IAEI,6BAAA;IAAA,4BAAA;E7DkzSR;E6DpzSI;IAEI,6BAAA;IAAA,4BAAA;E7DszSR;E6DxzSI;IAEI,6BAAA;IAAA,4BAAA;E7D0zSR;E6D5zSI;IAEI,wBAAA;IAAA,2BAAA;E7D8zSR;E6Dh0SI;IAEI,8BAAA;IAAA,iCAAA;E7Dk0SR;E6Dp0SI;IAEI,6BAAA;IAAA,gCAAA;E7Ds0SR;E6Dx0SI;IAEI,2BAAA;IAAA,8BAAA;E7D00SR;E6D50SI;IAEI,6BAAA;IAAA,gCAAA;E7D80SR;E6Dh1SI;IAEI,2BAAA;IAAA,8BAAA;E7Dk1SR;E6Dp1SI;IAEI,2BAAA;IAAA,8BAAA;E7Ds1SR;E6Dx1SI;IAEI,2BAAA;IAAA,8BAAA;E7D01SR;E6D51SI;IAEI,2BAAA;IAAA,8BAAA;E7D81SR;E6Dh2SI;IAEI,2BAAA;IAAA,8BAAA;E7Dk2SR;E6Dp2SI;IAEI,2BAAA;IAAA,8BAAA;E7Ds2SR;E6Dx2SI;IAEI,wBAAA;E7Dy2SR;E6D32SI;IAEI,8BAAA;E7D42SR;E6D92SI;IAEI,6BAAA;E7D+2SR;E6Dj3SI;IAEI,2BAAA;E7Dk3SR;E6Dp3SI;IAEI,6BAAA;E7Dq3SR;E6Dv3SI;IAEI,2BAAA;E7Dw3SR;E6D13SI;IAEI,2BAAA;E7D23SR;E6D73SI;IAEI,2BAAA;E7D83SR;E6Dh4SI;IAEI,2BAAA;E7Di4SR;E6Dn4SI;IAEI,2BAAA;E7Do4SR;E6Dt4SI;IAEI,2BAAA;E7Du4SR;E6Dz4SI;IAEI,0BAAA;E7D04SR;E6D54SI;IAEI,gCAAA;E7D64SR;E6D/4SI;IAEI,+BAAA;E7Dg5SR;E6Dl5SI;IAEI,6BAAA;E7Dm5SR;E6Dr5SI;IAEI,+BAAA;E7Ds5SR;E6Dx5SI;IAEI,6BAAA;E7Dy5SR;E6D35SI;IAEI,6BAAA;E7D45SR;E6D95SI;IAEI,6BAAA;E7D+5SR;E6Dj6SI;IAEI,6BAAA;E7Dk6SR;E6Dp6SI;IAEI,6BAAA;E7Dq6SR;E6Dv6SI;IAEI,6BAAA;E7Dw6SR;E6D16SI;IAEI,2BAAA;E7D26SR;E6D76SI;IAEI,iCAAA;E7D86SR;E6Dh7SI;IAEI,gCAAA;E7Di7SR;E6Dn7SI;IAEI,8BAAA;E7Do7SR;E6Dt7SI;IAEI,gCAAA;E7Du7SR;E6Dz7SI;IAEI,8BAAA;E7D07SR;E6D57SI;IAEI,8BAAA;E7D67SR;E6D/7SI;IAEI,8BAAA;E7Dg8SR;E6Dl8SI;IAEI,8BAAA;E7Dm8SR;E6Dr8SI;IAEI,8BAAA;E7Ds8SR;E6Dx8SI;IAEI,8BAAA;E7Dy8SR;E6D38SI;IAEI,yBAAA;E7D48SR;E6D98SI;IAEI,+BAAA;E7D+8SR;E6Dj9SI;IAEI,8BAAA;E7Dk9SR;E6Dp9SI;IAEI,4BAAA;E7Dq9SR;E6Dv9SI;IAEI,8BAAA;E7Dw9SR;E6D19SI;IAEI,4BAAA;E7D29SR;E6D79SI;IAEI,4BAAA;E7D89SR;E6Dh+SI;IAEI,4BAAA;E7Di+SR;E6Dn+SI;IAEI,4BAAA;E7Do+SR;E6Dt+SI;IAEI,4BAAA;E7Du+SR;E6Dz+SI;IAEI,4BAAA;E7D0+SR;E6D5+SI;IAEI,qBAAA;E7D6+SR;E6D/+SI;IAEI,2BAAA;E7Dg/SR;E6Dl/SI;IAEI,0BAAA;E7Dm/SR;E6Dr/SI;IAEI,wBAAA;E7Ds/SR;E6Dx/SI;IAEI,0BAAA;E7Dy/SR;E6D3/SI;IAEI,wBAAA;E7D4/SR;E6D9/SI;IAEI,wBAAA;E7D+/SR;E6DjgTI;IAEI,wBAAA;E7DkgTR;E6DpgTI;IAEI,wBAAA;E7DqgTR;E6DvgTI;IAEI,wBAAA;E7DwgTR;E6D1gTI;IAEI,2BAAA;IAAA,0BAAA;E7D4gTR;E6D9gTI;IAEI,iCAAA;IAAA,gCAAA;E7DghTR;E6DlhTI;IAEI,gCAAA;IAAA,+BAAA;E7DohTR;E6DthTI;IAEI,8BAAA;IAAA,6BAAA;E7DwhTR;E6D1hTI;IAEI,gCAAA;IAAA,+BAAA;E7D4hTR;E6D9hTI;IAEI,8BAAA;IAAA,6BAAA;E7DgiTR;E6DliTI;IAEI,8BAAA;IAAA,6BAAA;E7DoiTR;E6DtiTI;IAEI,8BAAA;IAAA,6BAAA;E7DwiTR;E6D1iTI;IAEI,8BAAA;IAAA,6BAAA;E7D4iTR;E6D9iTI;IAEI,8BAAA;IAAA,6BAAA;E7DgjTR;E6DljTI;IAEI,yBAAA;IAAA,4BAAA;E7DojTR;E6DtjTI;IAEI,+BAAA;IAAA,kCAAA;E7DwjTR;E6D1jTI;IAEI,8BAAA;IAAA,iCAAA;E7D4jTR;E6D9jTI;IAEI,4BAAA;IAAA,+BAAA;E7DgkTR;E6DlkTI;IAEI,8BAAA;IAAA,iCAAA;E7DokTR;E6DtkTI;IAEI,4BAAA;IAAA,+BAAA;E7DwkTR;E6D1kTI;IAEI,4BAAA;IAAA,+BAAA;E7D4kTR;E6D9kTI;IAEI,4BAAA;IAAA,+BAAA;E7DglTR;E6DllTI;IAEI,4BAAA;IAAA,+BAAA;E7DolTR;E6DtlTI;IAEI,4BAAA;IAAA,+BAAA;E7DwlTR;E6D1lTI;IAEI,yBAAA;E7D2lTR;E6D7lTI;IAEI,+BAAA;E7D8lTR;E6DhmTI;IAEI,8BAAA;E7DimTR;E6DnmTI;IAEI,4BAAA;E7DomTR;E6DtmTI;IAEI,8BAAA;E7DumTR;E6DzmTI;IAEI,4BAAA;E7D0mTR;E6D5mTI;IAEI,4BAAA;E7D6mTR;E6D/mTI;IAEI,4BAAA;E7DgnTR;E6DlnTI;IAEI,4BAAA;E7DmnTR;E6DrnTI;IAEI,4BAAA;E7DsnTR;E6DxnTI;IAEI,2BAAA;E7DynTR;E6D3nTI;IAEI,iCAAA;E7D4nTR;E6D9nTI;IAEI,gCAAA;E7D+nTR;E6DjoTI;IAEI,8BAAA;E7DkoTR;E6DpoTI;IAEI,gCAAA;E7DqoTR;E6DvoTI;IAEI,8BAAA;E7DwoTR;E6D1oTI;IAEI,8BAAA;E7D2oTR;E6D7oTI;IAEI,8BAAA;E7D8oTR;E6DhpTI;IAEI,8BAAA;E7DipTR;E6DnpTI;IAEI,8BAAA;E7DopTR;E6DtpTI;IAEI,4BAAA;E7DupTR;E6DzpTI;IAEI,kCAAA;E7D0pTR;E6D5pTI;IAEI,iCAAA;E7D6pTR;E6D/pTI;IAEI,+BAAA;E7DgqTR;E6DlqTI;IAEI,iCAAA;E7DmqTR;E6DrqTI;IAEI,+BAAA;E7DsqTR;E6DxqTI;IAEI,+BAAA;E7DyqTR;E6D3qTI;IAEI,+BAAA;E7D4qTR;E6D9qTI;IAEI,+BAAA;E7D+qTR;E6DjrTI;IAEI,+BAAA;E7DkrTR;E6DprTI;IAEI,0BAAA;E7DqrTR;E6DvrTI;IAEI,gCAAA;E7DwrTR;E6D1rTI;IAEI,+BAAA;E7D2rTR;E6D7rTI;IAEI,6BAAA;E7D8rTR;E6DhsTI;IAEI,+BAAA;E7DisTR;E6DnsTI;IAEI,6BAAA;E7DosTR;E6DtsTI;IAEI,6BAAA;E7DusTR;E6DzsTI;IAEI,6BAAA;E7D0sTR;E6D5sTI;IAEI,6BAAA;E7D6sTR;E6D/sTI;IAEI,6BAAA;E7DgtTR;E6DltTI;IAEI,2BAAA;E7DmtTR;E6DrtTI;IAEI,4BAAA;E7DstTR;E6DxtTI;IAEI,6BAAA;E7DytTR;AACF;A8D1vTA;ED8BM;IAEI,qCAAA;E7D8tTR;E6DhuTI;IAEI,oCAAA;E7DiuTR;E6DnuTI;IAEI,oCAAA;E7DouTR;AACF;A8DlvTA;EDWM;IAEI,0BAAA;E7DyuTR;E6D3uTI;IAEI,gCAAA;E7D4uTR;E6D9uTI;IAEI,yBAAA;E7D+uTR;E6DjvTI;IAEI,wBAAA;E7DkvTR;E6DpvTI;IAEI,yBAAA;E7DqvTR;E6DvvTI;IAEI,6BAAA;E7DwvTR;E6D1vTI;IAEI,8BAAA;E7D2vTR;E6D7vTI;IAEI,wBAAA;E7D8vTR;E6DhwTI;IAEI,+BAAA;E7DiwTR;E6DnwTI;IAEI,wBAAA;E7DowTR;AACF;A+DxzTA;EACI,SAAA;EACA,c9DYO;AD8yTX;A+DxzTI;EACE,c9DSK;ADizTX;A+DvzTI;EACE,yBAAA;A/DyzTN;A+DtzTI;;EAEI,e9D4cuB;AD42S/B;A+DrzTI;EACI,c9DJG;E8DKH,YAAA;EACA,iBAAA;EACA,cAAA;EACA,UAAA;A/DuzTR;A+DtzTQ;EACE,qBAAA;EACA,yCAAA;EACA,sBAAA;EACA,WAAA;EACA,oBAAA;EACA,mCAAA;EACA,eAAA;EACA,gBAAA;A/DwzTV;A+DtzTQ;EACE,wBAAA;A/DwzTV;A+DpzTI;EACE,eAAA;EACA,cAAA;EACA,UAAA;EACA,kBAAA;EACA,QAAA;EACA,iBAAA;A/DszTN;A+DnzTI;EACE,kBAAA;EACA,WAAA;EACA,QAAA;EACA,iBAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;A/DqzTN;A+DlzTI;EACI,cAAA;EACA,cAAA;A/DozTR;A+DjzTI;EACI,kBAAA;A/DmzTR;;A+D/yTA;EACI,sBAAA;A/DkzTJ;A+DjzTI;EASQ,SAAA;EACA,aAAA;A/D2yTZ;A+DnzTQ;EAEI,+BAAA;EACA,qBAAA;A/DozTZ;A+D5yTQ;EACI,iBAAA;EACA,6BAAA;EACA,+BAAA;A/D8yTZ;A+DzyTY;EACI,6BAAA;EACA,+BAAA;A/D2yThB;A+DvyTI;EACE,aAAA;A/DyyTN;A+DxyTM;EACE,WAAA;A/D0yTR;;AgE74TA;EACE,gBAAA;AhEg5TF;;AiEj5TA;;EAEI,iBhEiZyB;EgEhZzB,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,wBhEkZ0B;EgEjZ1B,eAAA;ECkBF,mBjE2Hc;EiEvHd,4EAAA;EACA,0BAAA;EACA,8BAAA;EC9BE,yBlEmJY;EkElJZ,0BAAA;EACA,gBAAA;EAwII,clE9HG;ADy5TX;AmEl6TI;;EACE,gCAAA;EACA,4BAAA;AnEq6TN;AmEl6TI;;;;;;;;;EASI,oCAAA;EACA,uFAAA;EAGA,4FAAA;EACA,clEVG;EkEWH,gBAAA;AnEo6TR;AmEj6TI;;EACE,2BAAA;EACA,qCAAA;EACA,0BAAA;AnEo6TN;AmEj6TI;;EAEI,0CAAA;EACA,2BAAA;EACA,mCAAA;AnEm6TR;AmE55TQ;;;;;;;;;;;;;;;;;;;;;;;;;EAMI,yBlEkGI;EkEjGJ,qBlEiGI;ADg1ThB;AmEt1TI;;EACI,clEKQ;EkEJR,qBlEIQ;EkEHR,uBlEzHqB;ADk9T7B;AmEv1TQ;;;;;EAII,clEHI;EkEIJ,qBlEJI;EkEKJ,wCAAA;EACA,iCAAA;EACA,gBAAA;AnE01TZ;AmEv1TQ;;EACE,gCAAA;AnE01TV;AmEz1TU;;;;;EAII,clEvJH;EkEwJG,qBlEjBE;EkEkBF,uFAAA;EAGA,4FAAA;EACA,oCAAA;EACA,gBAAA;AnE41Td;AmEv1TI;;EACI,clE7BQ;ADu3ThB;AmEz1TQ;;;;EAGI,wCAAA;EACA,iCAAA;EACA,yBAAA;EACA,qBAAA;EACA,gBAAA;AnE41TZ;AiE1gUI;;;EGTF,UHWuB;EGRvB,0BAAA;EHSM,qBAAA;AjE8gUR;AiE5gUI;;;;EtDHE,gBARW;EsDeR,qBAAA;AjE+gUT;AiE5gUI;;EACE,SAAA;AjE+gUN;AiE5gUI;;EAEI,gBhEggBoB;EgE/fpB,mBhE+foB;EgE9fpB,ehE8foB;EgE7fpB,UAAA;EACA,oBhE6foB;EgE5fpB,gBAAA;EACA,kBAAA;EACA,mBAAA;AjE8gUR;AiE5gUQ;;EACI,UAAA;AjE+gUZ;AiE5gUQ;;EACI,gBhEqfgB;EgEpfhB,mBhEofgB;EgEnfhB,ehEmfgB;AD4hT5B;AiE7gUY;;;;;;;;;;;EAII,oBhE4eY;AD0iT5B;AiElhUQ;;EACI,chE0egB;EgEzehB,iBhEyegB;EgExehB,ahEwegB;AD6iT5B;AiEnhUY;;;;;;;;;;;EAII,mBhEieY;AD2jT5B;AiExhUQ;;;;;EAII,kBAAA;EACA,cAAA;EACA,QAAA;EACA,SAAA;EACA,kCAAA;EACA,sBAAA;EACA,WAAA;AjE2hUZ;AiEthUI;;EACI,kBAAA;EACA,QAAA;AjEyhUR;AiEthUI;;EACE,kBAAA;EACA,cAAA;AjEyhUN;AiEthUE;;EACE,chE3BQ;ADojUZ;AiEthUE;;EACE,4BAAA;AjEyhUJ;;AiEnhUA;EC/EE,mBjE4Hc;EiExHd,4EAAA;EACA,0BAAA;EACA,8BAAA;EC9BE,yBlEoJY;EkEnJZ,0BAAA;EACA,gBAAA;EAwII,clE9HG;AD4nUX;AmEroUI;EACE,gCAAA;EACA,4BAAA;AnEuoUN;AmEpoUI;EASI,oCAAA;EACA,uFAAA;EAGA,4FAAA;EACA,clEVG;EkEWH,gBAAA;AnE8nUR;AmE3nUI;EACE,2BAAA;EACA,qCAAA;EACA,0BAAA;AnE6nUN;AmE1nUI;EAEI,0CAAA;EACA,2BAAA;EACA,mCAAA;AnE2nUR;AmEpnUQ;EAMI,yBlEmGI;EkElGJ,qBlEkGI;AD+gUhB;AmEthUI;EACI,clEMQ;EkELR,qBlEKQ;EkEJR,uBlEzHqB;ADipU7B;AmEthUQ;EAII,clEFI;EkEGJ,qBlEHI;EkEIJ,wCAAA;EACA,iCAAA;EACA,gBAAA;AnEqhUZ;AmElhUQ;EACE,gCAAA;AnEohUV;AmEnhUU;EAII,clEvJH;EkEwJG,qBlEhBE;EkEiBF,uFAAA;EAGA,4FAAA;EACA,oCAAA;EACA,gBAAA;AnEkhUd;AmE7gUI;EACI,clE5BQ;AD2iUhB;AmE9gUQ;EAGI,wCAAA;EACA,iCAAA;EACA,yBAAA;EACA,qBAAA;EACA,gBAAA;AnE8gUZ;;AiE5lUA;EClFE,mBjE8Hc;EiE1Hd,4EAAA;EACA,0BAAA;EACA,8BAAA;EC9BE,yBlEsJY;EkErJZ,0BAAA;EACA,gBAAA;EAwII,clE9HG;ADwsUX;AmEjtUI;EACE,gCAAA;EACA,4BAAA;AnEmtUN;AmEhtUI;EASI,oCAAA;EACA,uFAAA;EAGA,4FAAA;EACA,clEVG;EkEWH,gBAAA;AnE0sUR;AmEvsUI;EACE,2BAAA;EACA,qCAAA;EACA,0BAAA;AnEysUN;AmEtsUI;EAEI,0CAAA;EACA,2BAAA;EACA,mCAAA;AnEusUR;AmEhsUQ;EAMI,yBlEqGI;EkEpGJ,qBlEoGI;ADylUhB;AmElmUI;EACI,clEQQ;EkEPR,qBlEOQ;EkENR,uBlEzHqB;AD6tU7B;AmElmUQ;EAII,cAAA;EACA,qBlEDI;EkEEJ,wCAAA;EACA,iCAAA;EACA,gBAAA;AnEimUZ;AmE9lUQ;EACE,gCAAA;AnEgmUV;AmE/lUU;EAII,clEvJH;EkEwJG,qBlEdE;EkEeF,uFAAA;EAGA,4FAAA;EACA,oCAAA;EACA,gBAAA;AnE8lUd;AmEzlUI;EACI,clE1BQ;ADqnUhB;AmE1lUQ;EAGI,wCAAA;EACA,iCAAA;EACA,yBAAA;EACA,qBAAA;EACA,gBAAA;AnE0lUZ;;AiErqUA;ECrFE,mBjE+Hc;EiE3Hd,4EAAA;EACA,0BAAA;EACA,8BAAA;EC9BE,yBlEuJY;EkEtJZ,0BAAA;EACA,gBAAA;EAwII,clE9HG;ADoxUX;AmE7xUI;EACE,gCAAA;EACA,4BAAA;AnE+xUN;AmE5xUI;EASI,oCAAA;EACA,uFAAA;EAGA,4FAAA;EACA,clEVG;EkEWH,gBAAA;AnEsxUR;AmEnxUI;EACE,2BAAA;EACA,qCAAA;EACA,0BAAA;AnEqxUN;AmElxUI;EAEI,0CAAA;EACA,2BAAA;EACA,mCAAA;AnEmxUR;AmE5wUQ;EAMI,yBlEsGI;EkErGJ,qBlEqGI;ADoqUhB;AmE9qUI;EACI,clESQ;EkERR,qBlEQQ;EkEPR,uBlEzHqB;ADyyU7B;AmE9qUQ;EAII,clECI;EkEAJ,qBAAA;EACA,wCAAA;EACA,iCAAA;EACA,gBAAA;AnE6qUZ;AmE1qUQ;EACE,gCAAA;AnE4qUV;AmE3qUU;EAII,clEvJH;EkEwJG,qBlEbE;EkEcF,uFAAA;EAGA,4FAAA;EACA,oCAAA;EACA,gBAAA;AnE0qUd;AmErqUI;EACI,clEzBQ;ADgsUhB;AmEtqUQ;EAGI,wCAAA;EACA,iCAAA;EACA,yBAAA;EACA,qBAAA;EACA,gBAAA;AnEsqUZ;;AiE9uUA;ECxFE,mBjEgIc;EiE5Hd,4EAAA;EACA,0BAAA;EACA,8BAAA;EC9BE,yBlEwJY;EkEvJZ,0BAAA;EACA,gBAAA;EAwII,clE9HG;ADg2UX;AmEz2UI;EACE,gCAAA;EACA,4BAAA;AnE22UN;AmEx2UI;EASI,oCAAA;EACA,uFAAA;EAGA,4FAAA;EACA,clEVG;EkEWH,gBAAA;AnEk2UR;AmE/1UI;EACE,2BAAA;EACA,qCAAA;EACA,0BAAA;AnEi2UN;AmE91UI;EAEI,0CAAA;EACA,2BAAA;EACA,mCAAA;AnE+1UR;AmEx1UQ;EAMI,yBlEuGI;EkEtGJ,qBlEsGI;AD+uUhB;AmE1vUI;EACI,clEUQ;EkETR,qBlESQ;EkERR,uBlEzHqB;ADq3U7B;AmE1vUQ;EAII,clEEI;EkEDJ,qBlECI;EkEAJ,wCAAA;EACA,iCAAA;EACA,gBAAA;AnEyvUZ;AmEtvUQ;EACE,gCAAA;AnEwvUV;AmEvvUU;EAII,clEvJH;EkEwJG,qBlEZE;EkEaF,uFAAA;EAGA,4FAAA;EACA,oCAAA;EACA,gBAAA;AnEsvUd;AmEjvUI;EACI,clExBQ;AD2wUhB;AmElvUQ;EAGI,wCAAA;EACA,iCAAA;EACA,yBAAA;EACA,qBAAA;EACA,gBAAA;AnEkvUZ;AiEzzUgB;EACE,chEtGP;ADi6UX;;AiExzUA;EC7FE,mBjEiIc;EiE7Hd,4EAAA;EACA,0BAAA;EACA,8BAAA;EC9BE,yBlEyJY;EkExJZ,0BAAA;EACA,gBAAA;EAwII,clE9HG;AD+6UX;AmEx7UI;EACE,gCAAA;EACA,4BAAA;AnE07UN;AmEv7UI;EASI,oCAAA;EACA,uFAAA;EAGA,4FAAA;EACA,clEVG;EkEWH,gBAAA;AnEi7UR;AmE96UI;EACE,2BAAA;EACA,qCAAA;EACA,0BAAA;AnEg7UN;AmE76UI;EAEI,0CAAA;EACA,2BAAA;EACA,mCAAA;AnE86UR;AmEv6UQ;EAMI,yBlEwGI;EkEvGJ,qBlEuGI;AD6zUhB;AmEz0UI;EACI,clEWQ;EkEVR,qBlEUQ;EkETR,uBlEzHqB;ADo8U7B;AmEz0UQ;EAII,clEGI;EkEFJ,qBlEEI;EkEDJ,wCAAA;EACA,iCAAA;EACA,gBAAA;AnEw0UZ;AmEr0UQ;EACE,gCAAA;AnEu0UV;AmEt0UU;EAII,clEvJH;EkEwJG,qBlEXE;EkEYF,uFAAA;EAGA,4FAAA;EACA,oCAAA;EACA,gBAAA;AnEq0Ud;AmEh0UI;EACI,clEvBQ;ADy1UhB;AmEj0UQ;EAGI,wCAAA;EACA,iCAAA;EACA,yBAAA;EACA,qBAAA;EACA,gBAAA;AnEi0UZ;;AiEj4UA;EChGE,mBjEZS;EiEgBT,4EAAA;EACA,0BAAA;EACA,8BAAA;EC9BE,yBlEYO;EkEXP,0BAAA;EACA,gBAAA;EAsDI,clE4FQ;ADm3UhB;AmEpgVI;EACE,gCAAA;EACA,4BAAA;AnEsgVN;AmEngVI;EASI,oCAAA;EACA,uFAAA;EAGA,4FAAA;EACA,clEVG;EkEWH,gBAAA;AnE6/UR;AmE1/UI;EACE,2BAAA;EACA,qCAAA;EACA,0BAAA;AnE4/UN;AmEz/UI;EAEI,0CAAA;EACA,2BAAA;EACA,mCAAA;AnE0/UR;AmEn/UQ;EAMI,yBlErCD;EkEsCC,qBlEtCD;ADshVX;AmEx+UQ;EACI,clE8FI;AD44UhB;AmEx+UY;EAII,clE2GO;AD43UvB;AmEn+UQ;EACI,clEiFI;ADo5UhB;AmEn+UY;EAII,clE8FO;ADo4UvB;AmE99UQ;EACI,clEuEI;ADy5UhB;AmE99UY;EAII,clEoFO;ADy4UvB;AmEz9UQ;EACI,clE0DI;ADi6UhB;AmEz9UY;EAII,clEuEO;ADi5UvB;AmEp9UQ;EACI,clE4CI;AD06UhB;AmEp9UY;EAII,clE0DO;ADy5UvB;AmE/8UQ;EASI,yBlE9GD;EkE+GC,clE6CW;EkE5CX,gBAAA;AnEy8UZ;AmEt8UQ;EAEI,clEuCW;ADg6UvB;AmEr8UY;EACI,gBAAA;AnEu8UhB;AmE97UI;EACI,clElIG;EkEmIH,qBlEnIG;EkEoIH,uBlEzHqB;ADyjV7B;AmE97UQ;EAII,clE1ID;EkE2IC,qBlE3ID;EkE4IC,wCAAA;EACA,iCAAA;EACA,gBAAA;AnE67UZ;AmE17UQ;EACE,gCAAA;AnE47UV;AmE37UU;EAII,clEvJH;EkEwJG,qBlExJH;EkEyJG,uFAAA;EAGA,4FAAA;EACA,oCAAA;EACA,gBAAA;AnE07Ud;AmEr7UI;EACI,clEpKG;AD2lVX;AmEt7UQ;EAGI,wCAAA;EACA,iCAAA;EACA,yBAAA;EACA,qBAAA;EACA,gBAAA;AnEs7UZ;;AiEn/UK;EG1HH,YH6HuB;EG1HvB,yBAAA;EH2HM,oBAAA;AjEq/UR;;AiEl/UA;EACI,iBhEyR4B;EgExR5B,qBhEeY;EgEdZ,gBAAA;EACA,kBAAA;EACA,6BhEhHyB;ADqmV7B;;AiE5+UQ;;;;;;;;;;;;;;;;;;;;;;;;;EAMI,uBhE/HiB;ADioV7B;;AiE7/UA;EACE,0CAAA;AjEggVF;;AiE9/UA;EACI,ShEgPyB;EgE/OzB,gBAAA;EACA,sBAAA;EACA,uBhE3IyB;EgE4IzB,chEpJO;EgEqJP,gBhEiT0B;ADgtU9B;AiE//UE;EACE,2BAAA;EACA,0BAAA;AjEigVJ;;AiE7/UA;EEgHG,mBlEwK2B;EkEvK3B,wBlE0H2B;EkEzH3B,kBAAA;AnEi5UH;AmE/4UG;EACI,kBAAA;AnEi5UP;;AiEngVA;EE6GG,mBlEwK2B;EkEvK3B,wBlE2H2B;EkE1H3B,iBAAA;AnE05UH;AmEx5UG;EACI,iBAAA;AnE05UP;;AiExgVA;EACI,gBAAA;AjE2gVJ;;AiEzgVA;EACI,WAAA;AjE4gVJ;;AiExgVE;EACE,0CAAA;EACA,2BAAA;EACA,mCAAA;AjE2gVJ;;AiEtgVA;EACI,gBAAA;AjEygVJ;;AiEvgVA;EACI,kBAAA;EACA,QAAA;EACA,gBAAA;EACA,UAAA;AjE0gVJ;;AiEvgVA;EACI,0CAAA;EACA,2BAAA;EACA,mCAAA;AjE0gVJ;;AiEvgVA;EACI,iBhE4LyB;EgE3LzB,mBhE8Z0B;AD4mU9B;AiExgVI;EACI,kBAAA;AjE0gVR;;AiErgVE;EACE,aAAA;AjEwgVJ;;AiEpgVA;;;EAGI,chEzNO;ADguVX;;AiEpgVA;EACI,wBAAA;EACA,gCAAA;AjEugVJ;;AiEpgVA;EACE,gBAAA;AjEugVF;;AqEvvVA;EACI,SAAA;EACA,gDAAA;EACA,wBpEwZ0B;EiErY1B,4BAAA;AlE4uVJ;AqE3vVM;EACE,UAAA;EACA,WAAA;ArE6vVR;AqEzvVI;EACE,gEAAA;EACA,yBAAA;ArE2vVN;AqE1vVM;EACE,+BAAA;ArE4vVR;AqEzvVM;EACE,qBpEgIQ;AD2nVhB;AqExvVM;EACE,cpEuCA;EoEtCA,UAAA;ArE0vVR;AqEvvVM;EACE,qBAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,UAAA;EACA,sBAAA;EACA,WAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;EACA,cpE6GQ;EoE5GR,0BAAA;EACA,qCAAA;EACA,oCAAA;ArEyvVR;AqErvVQ;EACE,UAAA;EACA,WAAA;ArEuvVV;AqElvVQ;EACE,cpEwHa;EoEvHb,UAAA;ArEovVV;AqEjvVQ;EACE,qBAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,sBAAA;EACA,WAAA;EACA,SAAA;EACA,YAAA;EACA,WAAA;EACA,UAAA;EACA,cpE3CmB;EoE4CnB,uBAAA;EACA,qCAAA;EACA,oCAAA;EACA,mBAAA;EACA,UAAA;ArEmvVV;AqE9uVI;EACI,iBAAA;EACA,kBAAA;EACA,QAAA;ArEgvVR;AqE7uVI;EACI,kBAAA;EACA,kBAAA;EACA,QAAA;EACA,eAAA;EACA,gBAAA;EACA,YAAA;ArE+uVR;AqE3uVQ;EAEI,cAAA;ArE4uVZ;AqEvuVQ;EACI,aAAA;ArEyuVZ;AqEtuVQ;EACE,qBAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,sBAAA;EACA,WAAA;EACA,SAAA;EACA,YAAA;EACA,WAAA;EACA,UAAA;EACA,cpExGC;EoEyGD,uBAAA;EACA,qCAAA;EACA,oCAAA;EACA,mBAAA;ArEwuVV;AqEpuVU;EACE,WAAA;EACA,UAAA;ArEsuVZ;AqE/tVI;EACE,qBAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,sBAAA;EACA,WAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;EACA,cpEnIK;EoEoIL,0BAAA;EACA,qCAAA;EACA,oCAAA;ArEiuVN;AqE5tVI;EACE,mBAAA;EACA,qBAAA;ArE8tVN;AqE3tVI;EAEE,0BpE2SwB;EoE1SxB,mBAAA;EACA,sBAAA;EACA,eAAA;EH7IF,4BAAA;AlE82VJ;AqE9tVM;EAEE,0CpExFqB;ADuzV7B;AqE5tVM;EAEE,+BpEqBe;ADwsVvB;AqE3tVQ;EAEE,6BAAA;EACA,gBAAA;ArE4tVV;AqEttVI;EACI,0CpExGqB;ADg0V7B;AqErtVI;EACI,+BpEKe;EoEJf,qBpE8QsB;EoE7QtB,yBAAA;EACA,gBpEuRsB;ADg8U9B;AqEptVI;EClMA,yBDmM6B;ArEstVjC;AsEv5VI;EACI,cDgMyB;ArEytVjC;AsEt5VI;EACI,+BrE+EqB;ADy0V7B;AsEr5VI;EACI,crEEG;ADq5VX;AsEr5VQ;EAEI,0CrE4EiB;AD00V7B;AsEl5VI;EACI,0CrEuEqB;AD60V7B;AqEluVI;ECtMA,yBDuM6B;ArEouVjC;AsEz6VI;EACI,cDoMyB;ArEuuVjC;AsEx6VI;EACI,+BrE+EqB;AD21V7B;AsEv6VI;EACI,crEEG;ADu6VX;AsEv6VQ;EAEI,0CrE4EiB;AD41V7B;AsEp6VI;EACI,0CrEuEqB;AD+1V7B;AqEhvVI;EC1MA,yBD2M6B;ArEkvVjC;AsE37VI;EACI,cDwMyB;ArEqvVjC;AsE17VI;EACI,+BrE+EqB;AD62V7B;AsEz7VI;EACI,crEEG;ADy7VX;AsEz7VQ;EAEI,0CrE4EiB;AD82V7B;AsEt7VI;EACI,0CrEuEqB;ADi3V7B;AqE9vVI;EC9MA,yBD+M6B;ArEgwVjC;AsE78VI;EACI,cD4MyB;ArEmwVjC;AsE58VI;EACI,+BrE+EqB;AD+3V7B;AsE38VI;EACI,crEEG;AD28VX;AsE38VQ;EAEI,0CrE4EiB;ADg4V7B;AsEx8VI;EACI,0CrEuEqB;ADm4V7B;AqE5wVI;EClNA,yBDmN6B;ArE8wVjC;AsE/9VI;EACI,cDgNyB;ArEixVjC;AsE99VI;EACI,+BrE+EqB;ADi5V7B;AsE79VI;EACI,crEEG;AD69VX;AsE79VQ;EAEI,0CrE4EiB;ADk5V7B;AsE19VI;EACI,0CrEuEqB;ADq5V7B;AqE1xVI;EH/JG,8CAAA;EGoKC,kBAAA;EACA,cAAA;ED1NN,UC2NuB;EDxNvB,wBAAA;ECyNM,oBAAA;ArE8xVR;AqE3xVI;EH1KG,8CAAA;EG4KD,kBAAA;EACA,cAAA;EDlOJ,UCmOqB;EDhOrB,wBAAA;ApEkgWF;AqE/xVI;EHjLG,8CAAA;AlEu9VP;AqEjyVI;EHtLG,6CAAA;AlE89VP;AqEpyVI;EH1LG,6CAAA;EG4LC,oBAAA;EACA,YAAA;ArE0yVR;AqEvyVI;EDrPF,UC2PuB;EDxPvB,0BAAA;ECyPM,mBAAA;EHvMD,4CAAA;AlEi/VP;AqEtyVI;EH3MG,4CAAA;AlEw/VP;AqExyVI;EHhNG,6CAAA;AlE+/VP;AqE3yVI;EACE,WAAA;ArE6yVN;AqE5yVM;EACE,UAAA;EACA,WAAA;ArE8yVR;;AqEvyVA;EACI,eAAA;ArE0yVJ;AqExyVI;EACI,aAAA;EACA,SAAA;EACA,kBAAA;ArE0yVR;AqExyVQ;EACE,WAAA;EACA,gBAAA;ArE0yVV;AqEryVI;EACE,aAAA;ArEuyVN;AqEnyVM;EACE,YAAA;EACA,UAAA;EACA,iBAAA;ArEqyVR;;AqEhyVA;EAEE,eAAA;EAAA,gBAAA;ArEkyVF;;AqE9xVA;;;EAGG,gBAAA;ArEiyVH;;AqE3xVA;EACI,gBAAA;EACA,iBpEqF0B;ADysV9B;;AqE3xVA;EACI,gBAAA;EACA,wBpEgF0B;AD8sV9B;;AqE3xVA;EACI,gBAAA;EACA,wBpE2E0B;ADmtV9B;;AqE3xVA;EACE;IACE,qBAAA;IACA,QAAA;IACA,SAAA;IACA,oBAAA;IACA,uBAAA;IACA,WAAA;IACA,uBAAA;IACA,qCAAA;IACA,gBAAA;IACA,oCAAA;ErE8xVF;AACF;AqEzxVA;EACE;IACI,cpEhSM;ED2jWV;AACF;AuEhoWA;EACI,0BAAA;AvEkoWJ;AuEhoWI;EACE,UAAA;AvEkoWN;AuE/nWI;EACI,qBAAA;EACA,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;AvEioWR;AuE9nWI;EACE,qBAAA;AvEgoWN;AuE9nWM;EACE,eAAA;AvEgoWR;AuE5nWI;EACE,ctEVK;EsEWL,iBAAA;EACA,0BtEibwB;EsEhbxB,yBAAA;EACA,qBAAA;AvE8nWN;AuE5nWM;EACI,qBAAA;AvE8nWV;AuExnWI;EACI,0BtEqasB;EsEpatB,gBAAA;EACA,ctE1BG;ADopWX;AuEvnWI;EACI,cAAA;EACA,WAAA;EACA,YAAA;AvEynWR;;AuEpnWA;EACE;IACE,iBAAA;EvEunWF;EuErnWE;IACE,iBAAA;IACA,kBAAA;EvEunWJ;AACF;AuEnnWA;EAEI;IACE,YAAA;IACA,mBAAA;EvEonWJ;AACF;AuEhnWA;EAEI;IACE,cAAA;IACA,kBAAA;IACA,WAAA;EvEinWJ;AACF;AuE7mWA;EACE;IACE,kBAAA;EvE+mWF;EuE9mWE;IACE,kBAAA;EvEgnWJ;EuE7mWE;IACE,WAAA;IACA,eAAA;EvE+mWJ;AACF;AwE1sWA,kBAAA;ACKG;EACI,cDL2B;EJEhC,UKIsB;ELDtB,0BAAA;ApE0sWF;;AyEvsWG;EACI,cDT2B;EJEhC,UKQsB;ELLtB,0BAAA;ApEgtWF;;AyEzsWG;EACI,cDb2B;EJEhC,UKYsB;ELTtB,0BAAA;ApEstWF;;AyE3sWG;EACI,cDjB2B;EJEhC,UKgBsB;ELbtB,0BAAA;ApE4tWF;;AwE/tWA;EACE,qBAAA;EACA,wBvEoZ4B;EuEnZ5B,0BvEqc4B;EiE7W1B,oGAAA;AlE+oWJ;AwEnuWE;EACE,qBvE2IY;EuE1IZ,6BvEayB;EUXvB,gBARW;AX4uWjB;AwEnuWI;EAII,yBAAA;EACA,iBAAA;EACA,6BvEIqB;AD8tW7B;AwE9tWE;E7DXI,gBARW;AXovWjB;AwExtWM;EAEI,sBAAA;AxEytWV;AwErtWE;EACI,wBvEgXwB;EuE/WxB,gBAAA;EACA,kBAAA;EACA,WAAA;EACA,QAAA;EACA,sBAAA;AxEutWN;AwEptWE;EACI,sCAAA;EACA,gCvE1BuB;ADgvW7B;AwEntWE;EAEI,yBvE1CK;AD8vWX;;AwE/sWA;;;EAGI,qBAAA;AxEktWJ;;AwE/sWA;;;EAGE,qBAAA;AxEktWF;;AwE/sWA;;;;;EAKI,qBAAA;EACA,cvE+FmB;EuE9FnB,0CAAA;AxEktWJ;AwEhtWI;;;;;EACI,6BvE1DqB;ADgxW7B;;AwEhtWI;;EACI,qBAAA;EACA,gBAAA;EACA,qBAAA;EACA,kBAAA;EACA,WAAA;EACA,SAAA;EACA,cvEwDQ;EuEvDR,eAAA;AxEotWR;AwEhtWM;;EACE,eAAA;EACA,SAAA;AxEmtWR;AwE9sWM;;EACE,SAAA;AxEitWR;AwE5sWI;;EACE,wBAAA;AxE+sWN;AwE5sWI;;EACE,cvEiCU;AD8qWhB;;AwE1sWE;EACE,gBAAA;EACA,cvEgDmB;AD6pWvB;AwE1sWE;EACE,cvE4CmB;ADgqWvB;;A0E90WA;EACI,eAAA;EACA,wBzEwZ0B;ADy7V9B;;A0E/0WA;EACI,gDzEgauB;ADk7V3B;;A2Ep1WA;EACE,SAAA;A3Eu1WF;A2El1WE;EACE,mBAAA;A3Eo1WJ;A2El1WI;EACI,kBAAA;EACA,WAAA;EACA,SAAA;EACA,UAAA;EACA,aAAA;EACA,8BAAA;A3Eo1WR;A2El1WI;EACI,c1E2CA;E0E1CA,eAAA;EACA,gBAAA;A3Eo1WR;A2Ej1WI;EACE,c1EqCE;AD8yWR;A2Eh1WI;EACE,eAAA;A3Ek1WN;A2E30WE;EACE,gBAAA;A3E60WJ;A2E30WI;EACE,c1EsBE;ADuzWR;A2Ez0WE;EACE,aAAA,EACA,gBAAA;EACA,8BAAA;A3E20WJ;A2Ez0WI;EACE,SAAA;EACA,kBAAA;EACA,mBAAA;EACA,WAAA;A3E20WN;A2Ez0WM;EACE,iBAAA;EACA,kBAAA;EACA,kBAAA;EACA,UAAA;A3E20WR;A2Et0WE;EACE,cAAA;A3Ew0WJ;;A2Er0WA;EACE,8BAAA;A3Ew0WF;;A4E94WI;EACI,yB3EYG;E2EXH,c3E6DA;ADo1WR;A4E94WI;EACE,+BAAA;A5Eg5WN;AyEl5WG;EACI,+BA+H+B;ELlIpC,UKIsB;ELDtB,0BAAA;ApEs5WF;AyEn5WG;EACI,+BA2H+B;ELlIpC,UKQsB;ELLtB,0BAAA;ApE25WF;AyEp5WG;EACI,+BAuH+B;ELlIpC,UKYsB;ELTtB,0BAAA;ApEg6WF;AyEr5WG;EACI,+BAmH+B;ELlIpC,UKgBsB;ELbtB,0BAAA;ApEq6WF;AyEpyWI;EACI,sCxEnDqB;EwEoDrB,cxE3HG;ADi6WX;AyEpyWQ;EACI,qBxE9HD;EwE+HC,6BxEpHiB;EwEqHjB,cxEhID;ADs6WX;AyEhyWQ;;EACI,cxEvID;AD06WX;AyE9xWQ;EACI,6BxElIiB;ADk6W7B;AyE5xWI;EACE,eAAA;AzE8xWN;AyE3xWI;;EAEI,uCAAA;EACA,sCxEjFqB;EwEkFrB,cxEzJG;ADs7WX;AyEvxWQ;;EAEI,uCAAA;EACA,qBxElKD;EwEmKC,cxEnKD;AD47WX;AyEnxWQ;;EACI,uCAAA;EACA,cxE3KD;ADi8WX;AyEpxWY;;;;EAGI,uCAAA;EACA,cxEjLL;ADw8WX;AyEnxWQ;;;;EAEI,uCAAA;AzEuxWZ;AyErxWY;;;;;;;;;;EAGI,uCAAA;EACA,cxE7LL;AD29WX;AyExxWgB;;;EAEI,uCAAA;EACA,cxEtMT;ADi+WX;AyEtxWQ;;;;EAEI,uCAAA;EACA,YAAA;EACA,cxE/MD;ADy+WX;AyEtxWY;;;;EAEI,uCAAA;EACA,cxEtNL;ADg/WX;A4E7/WI;EACI,yB3EoJQ;E2EnJR,c3EWG;ADo/WX;A4E5/WI;EACE,+BAAA;A5E8/WN;AyEhgXG;EACI,+BA+H+B;ELlIpC,UKIsB;ELDtB,0BAAA;ApEogXF;AyEjgXG;EACI,+BA2H+B;ELlIpC,UKQsB;ELLtB,0BAAA;ApEygXF;AyElgXG;EACI,+BAuH+B;ELlIpC,UKYsB;ELTtB,0BAAA;ApE8gXF;AyEngXG;EACI,+BAmH+B;ELlIpC,UKgBsB;ELbtB,0BAAA;ApEmhXF;AyEl5WI;EACI,sCxEnDqB;EwEoDrB,cxE3HG;AD+gXX;AyEl5WQ;EACI,qBxE9HD;EwE+HC,6BxEpHiB;EwEqHjB,cxEhID;ADohXX;AyE94WQ;;EACI,cxEvID;ADwhXX;AyE54WQ;EACI,6BxElIiB;ADghX7B;AyE14WI;EACE,eAAA;AzE44WN;AyEz4WI;;EAEI,uCAAA;EACA,sCxEjFqB;EwEkFrB,cxEzJG;ADoiXX;AyEr4WQ;;EAEI,uCAAA;EACA,qBxElKD;EwEmKC,cxEnKD;AD0iXX;AyEj4WQ;;EACI,uCAAA;EACA,cxE3KD;AD+iXX;AyEl4WY;;;;EAGI,uCAAA;EACA,cxEjLL;ADsjXX;AyEj4WQ;;;;EAEI,uCAAA;AzEq4WZ;AyEn4WY;;;;;;;;;;EAGI,uCAAA;EACA,cxE7LL;ADykXX;AyEt4WgB;;;EAEI,uCAAA;EACA,cxEtMT;AD+kXX;AyEp4WQ;;;;EAEI,uCAAA;EACA,YAAA;EACA,cxE/MD;ADulXX;AyEp4WY;;;;EAEI,uCAAA;EACA,cxEtNL;AD8lXX;A4E3mXI;EACI,yB3EyJQ;E2ExJR,c3EWG;ADkmXX;A4E1mXI;EACE,+BAAA;A5E4mXN;AyE9mXG;EACI,+BA+H+B;ELlIpC,UKIsB;ELDtB,0BAAA;ApEknXF;AyE/mXG;EACI,+BA2H+B;ELlIpC,UKQsB;ELLtB,0BAAA;ApEunXF;AyEhnXG;EACI,+BAuH+B;ELlIpC,UKYsB;ELTtB,0BAAA;ApE4nXF;AyEjnXG;EACI,+BAmH+B;ELlIpC,UKgBsB;ELbtB,0BAAA;ApEioXF;AyEhgXI;EACI,sCxEnDqB;EwEoDrB,cxE3HG;AD6nXX;AyEhgXQ;EACI,qBxE9HD;EwE+HC,6BxEpHiB;EwEqHjB,cxEhID;ADkoXX;AyE5/WQ;;EACI,cxEvID;ADsoXX;AyE1/WQ;EACI,6BxElIiB;AD8nX7B;AyEx/WI;EACE,eAAA;AzE0/WN;AyEv/WI;;EAEI,uCAAA;EACA,sCxEjFqB;EwEkFrB,cxEzJG;ADkpXX;AyEn/WQ;;EAEI,uCAAA;EACA,qBxElKD;EwEmKC,cxEnKD;ADwpXX;AyE/+WQ;;EACI,uCAAA;EACA,cxE3KD;AD6pXX;AyEh/WY;;;;EAGI,uCAAA;EACA,cxEjLL;ADoqXX;AyE/+WQ;;;;EAEI,uCAAA;AzEm/WZ;AyEj/WY;;;;;;;;;;EAGI,uCAAA;EACA,cxE7LL;ADurXX;AyEp/WgB;;;EAEI,uCAAA;EACA,cxEtMT;AD6rXX;AyEl/WQ;;;;EAEI,uCAAA;EACA,YAAA;EACA,cxE/MD;ADqsXX;AyEl/WY;;;;EAEI,uCAAA;EACA,cxEtNL;AD4sXX;A4EztXI;EACI,yB3EwJQ;E2EvJR,c3EWG;ADgtXX;A4ExtXI;EACE,+BAAA;A5E0tXN;AyE5tXG;EACI,+BA+H+B;ELlIpC,UKIsB;ELDtB,0BAAA;ApEguXF;AyE7tXG;EACI,+BA2H+B;ELlIpC,UKQsB;ELLtB,0BAAA;ApEquXF;AyE9tXG;EACI,+BAuH+B;ELlIpC,UKYsB;ELTtB,0BAAA;ApE0uXF;AyE/tXG;EACI,+BAmH+B;ELlIpC,UKgBsB;ELbtB,0BAAA;ApE+uXF;AyE9mXI;EACI,sCxEnDqB;EwEoDrB,cxE3HG;AD2uXX;AyE9mXQ;EACI,qBxE9HD;EwE+HC,6BxEpHiB;EwEqHjB,cxEhID;ADgvXX;AyE1mXQ;;EACI,cxEvID;ADovXX;AyExmXQ;EACI,6BxElIiB;AD4uX7B;AyEtmXI;EACE,eAAA;AzEwmXN;AyErmXI;;EAEI,uCAAA;EACA,sCxEjFqB;EwEkFrB,cxEzJG;ADgwXX;AyEjmXQ;;EAEI,uCAAA;EACA,qBxElKD;EwEmKC,cxEnKD;ADswXX;AyE7lXQ;;EACI,uCAAA;EACA,cxE3KD;AD2wXX;AyE9lXY;;;;EAGI,uCAAA;EACA,cxEjLL;ADkxXX;AyE7lXQ;;;;EAEI,uCAAA;AzEimXZ;AyE/lXY;;;;;;;;;;EAGI,uCAAA;EACA,cxE7LL;ADqyXX;AyElmXgB;;;EAEI,uCAAA;EACA,cxEtMT;AD2yXX;AyEhmXQ;;;;EAEI,uCAAA;EACA,YAAA;EACA,cxE/MD;ADmzXX;AyEhmXY;;;;EAEI,uCAAA;EACA,cxEtNL;AD0zXX;A4Ev0XI;EACI,yB3EsJQ;E2ErJR,c3EWG;AD8zXX;A4Et0XI;EACE,+BAAA;A5Ew0XN;AyE10XG;EACI,+BA+H+B;ELlIpC,UKIsB;ELDtB,0BAAA;ApE80XF;AyE30XG;EACI,+BA2H+B;ELlIpC,UKQsB;ELLtB,0BAAA;ApEm1XF;AyE50XG;EACI,+BAuH+B;ELlIpC,UKYsB;ELTtB,0BAAA;ApEw1XF;AyE70XG;EACI,+BAmH+B;ELlIpC,UKgBsB;ELbtB,0BAAA;ApE61XF;AyE5tXI;EACI,sCxEnDqB;EwEoDrB,cxE3HG;ADy1XX;AyE5tXQ;EACI,qBxE9HD;EwE+HC,6BxEpHiB;EwEqHjB,cxEhID;AD81XX;AyExtXQ;;EACI,cxEvID;ADk2XX;AyEttXQ;EACI,6BxElIiB;AD01X7B;AyEptXI;EACE,eAAA;AzEstXN;AyEntXI;;EAEI,uCAAA;EACA,sCxEjFqB;EwEkFrB,cxEzJG;AD82XX;AyE/sXQ;;EAEI,uCAAA;EACA,qBxElKD;EwEmKC,cxEnKD;ADo3XX;AyE3sXQ;;EACI,uCAAA;EACA,cxE3KD;ADy3XX;AyE5sXY;;;;EAGI,uCAAA;EACA,cxEjLL;ADg4XX;AyE3sXQ;;;;EAEI,uCAAA;AzE+sXZ;AyE7sXY;;;;;;;;;;EAGI,uCAAA;EACA,cxE7LL;ADm5XX;AyEhtXgB;;;EAEI,uCAAA;EACA,cxEtMT;ADy5XX;AyE9sXQ;;;;EAEI,uCAAA;EACA,YAAA;EACA,cxE/MD;ADi6XX;AyE9sXY;;;;EAEI,uCAAA;EACA,cxEtNL;ADw6XX;A4Er7XI;EACI,yB3EuJQ;E2EtJR,c3EWG;AD46XX;A4Ep7XI;EACE,+BAAA;A5Es7XN;AyEx7XG;EACI,+BA+H+B;ELlIpC,UKIsB;ELDtB,0BAAA;ApE47XF;AyEz7XG;EACI,+BA2H+B;ELlIpC,UKQsB;ELLtB,0BAAA;ApEi8XF;AyE17XG;EACI,+BAuH+B;ELlIpC,UKYsB;ELTtB,0BAAA;ApEs8XF;AyE37XG;EACI,+BAmH+B;ELlIpC,UKgBsB;ELbtB,0BAAA;ApE28XF;AyE10XI;EACI,sCxEnDqB;EwEoDrB,cxE3HG;ADu8XX;AyE10XQ;EACI,qBxE9HD;EwE+HC,6BxEpHiB;EwEqHjB,cxEhID;AD48XX;AyEt0XQ;;EACI,cxEvID;ADg9XX;AyEp0XQ;EACI,6BxElIiB;ADw8X7B;AyEl0XI;EACE,eAAA;AzEo0XN;AyEj0XI;;EAEI,uCAAA;EACA,sCxEjFqB;EwEkFrB,cxEzJG;AD49XX;AyE7zXQ;;EAEI,uCAAA;EACA,qBxElKD;EwEmKC,cxEnKD;ADk+XX;AyEzzXQ;;EACI,uCAAA;EACA,cxE3KD;ADu+XX;AyE1zXY;;;;EAGI,uCAAA;EACA,cxEjLL;AD8+XX;AyEzzXQ;;;;EAEI,uCAAA;AzE6zXZ;AyE3zXY;;;;;;;;;;EAGI,uCAAA;EACA,cxE7LL;ADigYX;AyE9zXgB;;;EAEI,uCAAA;EACA,cxEtMT;ADugYX;AyE5zXQ;;;;EAEI,uCAAA;EACA,YAAA;EACA,cxE/MD;AD+gYX;AyE5zXY;;;;EAEI,uCAAA;EACA,cxEtNL;ADshYX;A2Eh8XI;EACI,c1EsDQ;E0ErDR,iBAAA;A3Ek8XR;A2Eh8XQ;EAEI,UAAA;A3Ei8XZ;A2E57XM;EACE,gEAAA;EACA,+BAAA;A3E87XR;A2E57XU;EACE,+BAAA;A3E87XZ;A2E17XU;EACE,+BAAA;A3E47XZ;A2Ex7XM;EACE,c1EhHG;AD0iYX;;A2Ep7XE;EACE,iBAAA;EACA,gBAAA;A3Eu7XJ;A2Et7XI;EACE,YAAA;EACA,eAAA;EACA,gBAAA;A3Ew7XN;A2Et7XI;EACE,eAAA;EACA,c1EiEuB;ADu3X7B;A2Ep7XI;EACE,aAAA;A3Es7XN;A2El7XE;EACE,c1E7HyB;E0E8HzB,oBAAA;A3Eo7XJ;A2Ej7XE;EACE,6BAAA;EACA,qBAAA;A3Em7XJ;;A6EjlYA;EACE,4BAAA;EACA,WAAA;EACA,aAAA;EACA,mB5E2yBkC;ADyyWpC;A6EllYE;EACE,qBAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,sBAAA;EACA,gBAAA;A7EolYJ;A6EnlYM;EACE,WAAA;A7EqlYR;A6EjlYE;EACE,aAAA;EACA,mBAAA;A7EmlYJ;A6EhlYE;EACE,c5EVO;AD4lYX;A6E/kYE;EACE,oBAAA;A7EilYJ;A6E9kYE;EACE,kBAAA;EACA,aAAA;A7EglYJ;A6E5kYE;EACE,kCAAA;A7E8kYJ;A6ExkYQ;EACE,c5EmBF;ADujYR;A6EtkYM;EACE,8BAAA;EACA,kBAAA;A7EwkYR;A6ErkYM;EACE,yBAAA;A7EukYR;A6EtkYQ;EACE,c5EOF;ADikYR;A6ElkYI;EACE,cAAA;A7EokYN;A6EjkYI;EACE,yBAAA;A7EmkYN;A6EhkYI;EACE,yBAAA;A7EkkYN;A6E7jYE;EACE,8BAAA;A7E+jYJ;A6E5jYE;EACE,oCAAA;A7E8jYJ;A6E3jYE;EACE,oCAAA;A7E6jYJ;A6E1jYE;EACE,oCAAA;A7E4jYJ;A6EzjYE;EACE,oCAAA;A7E2jYJ;A6ExjYE;EACE,oCAAA;A7E0jYJ;A6EvjYE;EACE,eAAA;EACA,sBAAA;EACA,yBAAA;EACA,c5E3FO;E4E4FP,iBAAA;EACA,eAAA;EACA,yBAAA;EACA,e5E6W2B;AD4sX/B;A6EtjYE;EACE,aAAA;A7EwjYJ;;A6EnjYA;EACE,WAAA;A7EsjYF;;A6EnjYA;EACC,eAAA;EACC,iBAAA;EACA,gBAAA;EACD,qBAAA;EACA,YAAA;EACA,WAAA;EACA,UAAA;EACA,qBAAA;A7EsjYD;A6EpjYE;EACC,eAAA;A7EsjYH;;A6EjjYA;EACE,mB5EgBc;E4Eff,c5E9HU;E4E+HV,uB5E2Q6B;E4E1Q7B,WAAA;EACA,UAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACC,SAAA;EACA,WAAA;EACD,yBAAA;A7EojYD;;A6EjjYA;EACE,eAAA;A7EojYF;A6EnjYE;EACE,c5E9IO;ADmsYX;A6EnjYE;EACE,sBAAA;EACA,eAAA;A7EqjYJ;;A6EjjYA;EAEM;IACI,mBAAA;IACA,kBAAA;E7EmjYR;E6E/iYM;IACE,SAAA;IACA,eAAA;E7EijYR;E6E3iYM;IACE,iBAAA;IACA,aAAA;E7E6iYR;E6E3iYQ;IACE,kBAAA;E7E6iYV;E6E1iYQ;IACE,SAAA;IACA,yBAAA;IACA,gBAAA;E7E4iYV;E6E1iYU;IAKE,yBAAA;E7EwiYZ;E6EliYU;IACE,UAAA;IACA,gBAAA;IACA,iBAAA;E7EoiYZ;E6EliYU;IACE,qBAAA;IACA,yBAAA;IACA,gBAAA;E7EoiYZ;E6EhiYQ;IACE,eAAA;E7EkiYV;E6EhiYQ;IACE,aAAA;E7EkiYV;E6EjiYU;IACE,iBAAA;E7EmiYZ;E6EhiYY;IACE,aAAA;IACA,kBAAA;E7EkiYd;E6E5hYI;IACI,cAAA;E7E8hYR;E6E1hYI;IACI,aAAA;E7E4hYR;E6E3hYQ;IACE,c5EjLJ;ED8sYN;E6EzhYI;;IAEI,6BAAA;IACA,SAAA;IACA,gBAAA;IAEA,gBAAA;IACA,WAAA;IACA,gBAAA;IACA,eAAA;E7E2hYR;E6EzhYQ;;IACI,aAAA;E7E4hYZ;E6ExhYI;;IAEI,c5EzPC;EDmxYT;E6EvhYI;IAEI,c5EvHM;ED+oYd;E6ErhYI;IACE,cAAA;E7EuhYN;E6EphYI;IACI,cAAA;IACA,kBAAA;IACA,WAAA;IACA,WAAA;IACA,kBAAA;IACA,mB5E3QC;EDiyYT;E6EphYQ;IACE,WAAA;IACA,UAAA;IACA,kBAAA;IACA,kBAAA;E7EshYV;E6EnhYQ;IACI,eAAA;E7EqhYZ;E6ElhYQ;IACI,eAAA;E7EohYZ;E6EjhYQ;IACI,WAAA;IACA,6BAAA;E7EmhYZ;E6E/gYI;IACI,yB5E5JM;ED6qYd;E6E9gYI;IACI,WAAA;E7EghYR;E6E9gYQ;IACI,eAAA;E7EghYZ;E6E5gYI;IACE,iBAAA;IACA,kBAAA;E7E8gYN;E6ExgYQ;;IAEI,YAAA;E7E0gYZ;E6ErgYA;;;IAGE,8BAAA;E7EugYF;E6ErgYA;IACE,QAAA;IX3SC,+BAAA;IAGA,6BAAA;ElEqzYH;E6E1gYA;IACE,UAAA;E7E4gYF;E6E1gYA;IACE,WAAA;IXlTC,kCAAA;IAGA,6BAAA;ElEi0YH;E6E/gYA;IACE,QAAA;IXtTC,4BAAA;IAGA,6BAAA;ElE00YH;E6EphYA;IACE,UAAA;E7EshYF;E6EphYA;IACE,WAAA;IX7TC,+BAAA;IAGA,6BAAA;ElEs1YH;EkE7xYE;IACE;MAAI,QAAA;MAAU,uBAAA;IlEiyYhB;IkEhyYE;MAAK,QAAA;MAAU,yBAAA;IlEoyYjB;IkEnyYE;MAAK,yBAAA;IlEsyYP;IkEryYE;MAAM,yBAAA;IlEwyYR;EACF;EkExxYE;IACE;MAAK,QAAA;MAAU,yBAAA;IlE4zYjB;IkE3zYE;MAAM,yBAAA;IlE8zYR;IkE7zYE;MAAM,uBAAA;IlEg0YR;IkE/zYE;MAAO,QAAA;MAAU,oBAAA;IlEm0YnB;EACF;EkEjzYE;IACE;MAAI,WAAA;MAAa,uBAAA;IlEq1YnB;IkEp1YE;MAAK,WAAA;MAAa,0BAAA;IlEw1YpB;IkEv1YE;MAAK,0BAAA;IlE01YP;IkEz1YE;MAAM,0BAAA;IlE41YR;EACF;EkE50YE;IACE;MAAK,WAAA;MAAY,0BAAA;IlEg3YnB;IkE/2YE;MAAM,wBAAA;IlEk3YR;IkEj3YE;MAAM,wBAAA;IlEo3YR;IkEn3YE;MAAO,WAAA;MAAY,oBAAA;IlEu3YrB;EACF;E6E3qYA;IACE;MAAI,UAAA;I7E8tYJ;I6E7tYA;MAAM,UAAA;I7EguYN;EACF;AACF;A6E7tYA;EACE;IACE,2BAAA;E7E+tYF;E6E5tYA;IACE,aAAA;E7E8tYF;E6EztYI;IACE,UAAA;IACA,kBAAA;E7E2tYN;E6ErtYE;IACE,kBAAA;IACA,SAAA;IACA,QAAA;IACA,cAAA;E7EutYJ;E6EptYE;IACE,qBAAA;IACA,oBAAA;E7EstYJ;AACF;A6EntYA;EACE;IACI,cAAA;IACA,eAAA;E7EqtYJ;E6EltYE;IACE,kBAAA;E7EotYJ;E6EhtYE;IACE,WAAA;IACA,kBAAA;IACA,WAAA;IAAA,cAAA;IACA,kBAAA;E7EktYJ;E6E7sYI;IACE,YAAA;IACA,kBAAA;IACA,UAAA;IAAA,aAAA;IACA,kBAAA;E7E+sYN;AACF;A8EnoZA;EACE,kCAAA;EACA,mCAAA;A9EqoZF;;A8EloZA;;EAEE,gB7E2d4B;AD0qY9B;;A8EloZA;EACE,gB7E0c4B;AD2rY9B;;A8EloZA;;;;;EAKI,kC7Egb0B;ADqtY9B;;A8EloZE;EACE,+B7EgEyB;ADqkZ7B;;A8EloZA;EACI,gB7E2b0B;E6E1b1B,+B7E2DyB;AD0kZ7B;;A8EloZA;EACI,c7E0ImB;E6EzInB,gB7Eob0B;ADitY9B;A8EpoZI;EAEI,c7EkHQ;ADmhZhB;;A8EloZA;EACI,iBAAA;EACA,mBAAA;A9EqoZJ;A8EnoZI;EACI,gB7E2asB;E6E1atB,yBAAA;EACA,YAAA;A9EqoZR;;A8EjoZA;EACI,mBAAA;EACA,gBAAA;A9EooZJ;;A8EjoZA;EACI,mBAAA;EACA,kBAAA;A9EooZJ;;A8EloZA;EACI,mBAAA;EACA,mB7EiU2B;ADo0Y/B;A8EnoZI;EAEI,iBAAA;A9EooZR;;A8EjoZA;EACI,kBAAA;EACA,mBAAA;A9EooZJ;;A8EloZA;EACI,yBAAA;EACA,gB7E6Y0B;ADwvY9B;;A8EnoZA;EACI,+B7EUyB;E6ETzB,kBAAA;A9EsoZJ;A8EpoZI;EACI,iBAAA;A9EsoZR;;A8EjoZA;EACI,gB7EgY0B;E6E/X1B,eAAA;A9EooZJ;A8EnoZI;EACI,yBAAA;A9EqoZR;A8EnoZQ;EACI,c7E7BJ;E6E8BI,qBAAA;A9EqoZZ;A8EloZI;EACI,iBAAA;A9EooZR;;A8EhoZA;;;;EAII,c7EtCQ;E6EuCR,gB7E0W0B;ADyxY9B;;A8EjoZA;;EAEI,0BAAA;EACA,gB7EsW0B;E6ErW1B,+BAAA;EACA,0B7EyV0B;AD2yY9B;;A8EjoZA;EACI,0B7EqV0B;AD+yY9B;;A8EjoZA;EACI,iBAAA;EACA,yBAAA;EACA,aAAA;EACA,oB7E8Y0B;E6E7Y1B,gBAAA;A9EooZJ;A8EloZI;EACI,c7EoBQ;E6EnBR,0B7EyUsB;E6ExUtB,yBAAA;A9EooZR;A8EjoZI;EACI,qB7EeQ;E6EdR,c7EcQ;ADqnZhB;A8EjoZQ;EACI,c7EWI;ADwnZhB;A8E/nZI;EACI,qB7EWQ;E6EVR,c7EUQ;ADunZhB;A8E/nZQ;EACI,c7EOI;AD0nZhB;A8E7nZI;EACI,sC7ElEqB;E6EmErB,c7E5IG;AD2wZX;A8E7nZQ;EACI,+B7EtEiB;ADqsZ7B;;A8E1nZA;EACE,c7ErJS;ADkxZX;;A8E1nZA;EACE,+B7EhF2B;AD6sZ7B;;A8E1nZA;EACE,wCAAA;EACA,gB7EoLO;E6EnLP,mB7EmLO;AD08YT;;A+EzyZE;EACE,0CAAA;A/E4yZJ;A+E1yZI;EACE,YAAA;EACA,WAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;A/E4yZN;A+E1yZM;EACE,WAAA;A/E4yZR;A+EvyZE;EACE,yBAAA;A/EyyZJ;A+EtyZE;EACE,yB9EmIY;ADqqZhB;A+EryZE;EACE,yB9E4HY;AD2qZhB;A+EpyZE;EACE,yB9E4HY;AD0qZhB;A+EpyZE;EACE,yB9E0HY;AD4qZhB;A+EnyZI;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;A/EqyZN;A+ElyZI;EACE,eAAA;EACA,WAAA;A/EoyZN;A+EjyZI;EACI,SAAA;EACA,eAAA;A/EmyZR;A+EjyZQ;EAEI,UAAA;EACA,SAAA;A/EkyZZ;A+E9xZI;EACI,SAAA;A/EgyZR;A+E7xZI;EACE,gBAAA;A/E+xZN;A+E5xZI;EACI,gBAAA;A/E8xZR;A+E5xZQ;;;;;;EAMI,gBAAA;EACA,mBAAA;A/E8xZZ;A+E1xZG;EACI,wBAAA;EACA,eAAA;EACA,yBAAA;EACA,gB9EkYuB;E8EjYvB,SAAA;EACA,+BAAA;A/E4xZP;A+EzxZG;;EAEI,aAAA;EACA,gBAAA;EACA,UAAA;EACA,WAAA;A/E2xZP;A+EzxZO;;EACI,kBAAA;A/E4xZX;A+ExxZY;;;EAEI,UAAA;EACA,UAAA;A/E2xZhB;A+EvxZG;;;;;;EAMI,sCAAA;EACA,iBAAA;EACA,sBAAA;A/EyxZP;A+EtxZG;EACG,YAAA;A/EwxZN;A+ErxZG;EACI,gBAAA;A/EuxZP;A+ErxZG;EACI,eAAA;EACA,gB9EmVuB;E8ElVvB,eAAA;EACA,kBAAA;EACA,QAAA;EACA,iBAAA;A/EuxZP;A+ErxZG;EACK,gB9E8UsB;E8E7UtB,yB9EwUsB;E8EvUtB,iBAAA;EACA,iBAAA;A/EuxZR;A+EpxZG;EACC,WAAA;A/EsxZJ;A+EnxZI;EACI,kBAAA;A/EqxZR;A+ElxZI;EACE,6BAAA;EACA,yBAAA;A/EoxZN;;A+EhxZA;EACE,cAAA;EACA,oBAAA;A/EmxZF;;A+EhxZA;EACI,mBAAA;A/EmxZJ;;AgFt7ZA;EACC,kBAAA;EACA,eAAA;AhFy7ZD;;AgFt7ZA;EACE,qBAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EAKA,6BAAA;AhFy7ZF;;AgFv7ZA;EACI,kBAAA;AhF07ZJ;;AgFv7ZA;EACE,iBAAA;EACA,kBAAA;AhF07ZF;;AgFv7ZA;;EAEE,YAAA;EACA,qBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,OAAA;EACA,eAAA;EACA,kBAAA;EACA,MAAA;EACA,yBAAA;EAKA,+BAAA;AhF07ZF;;AgFv7ZA;;EAEE,YAAA;EACA,yB/EqGc;ADq1ZhB;;AgFv7ZC;EACC,qBAAA;EACA,gBAAA;EACA,QAAA;EACA,kBAAA;EACA,eAAA;EACA,UAAA;EACA,c/E7CS;E+E8CT,gB/E2Z4B;E+E1Z5B,SAAA;EACA,yBAAA;AhF07ZF;;AgFv7ZA;;EAEI,c/ECQ;E+EAR,YAAA;EACA,mBAAA;AhF07ZJ;;AgFv7ZA;;EAEE,UAAA;EACA,kBAAA;EACA,kBAAA;AhF07ZF;;AgFx7ZA;EACE,UAAA;EACA,eAAA;EACA,aAAA;AhF27ZF;;AgFv7ZA;EACE,UAAA;EACA,eAAA;EACA,aAAA;AhF07ZF;;AgFv7ZA;;EAEI,mBAAA;AhF07ZJ;;AgFv7ZA;;EAEI,oBAAA;AhF07ZJ;;AgFv7ZA;EACE,gBAAA;AhF07ZF;;AgFx7ZA;;EAEE,YAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,yBAAA;EACA,qBAAA;EACA,kBAAA;EACA,SAAA;EACA,QAAA;EACA,YAAA;EAKA,+BAAA;AhF27ZF;;AgFx7ZA;;EAEI,UAAA;AhF27ZJ;;AgFz7ZA;EACI,UAAA;EACA,WAAA;EACA,yB/EoBY;E+EnBZ,qB/EmBY;E+ElBZ,QAAA;EACA,SAAA;EACA,UAAA;AhF47ZJ;;AgFz7ZA;EACE,qB/EYc;ADg7ZhB;;AgFx7ZA;EACI,UAAA;AhF27ZJ;;AgFx7ZA;EACE,c/E/EU;AD0gaZ;;AgFx7ZA;;EAEE,c/EpFU;AD+gaZ;;AiFnlaA;EACI,eAAA;EACA,QAAA;EACA,WAAA;EACA,8BAAA;EACA,aAAA;EACA,0BAAA;EACA,kBAAA;EACA,UAAA;AjFslaJ;AiFplaI;;EAEI,qBAAA;EACA,6BAAA;EACA,0BAAA;AjFslaR;AiFnlaI;EACI,chFJG;EgFKH,aAAA;EACA,0BAAA;EACA,WAAA;AjFqlaR;AiFllaI;EACI,WAAA;EACA,qBAAA;EACA,qBAAA;EACA,YAAA;EACA,wBAAA;EACA,eAAA;EACA,6CAAA;AjFolaR;AiFjlaI;EACE,QAAA;AjFmlaN;AiFhlaI;;EAEI,WAAA;EACA,iBAAA;EACA,UAAA;AjFklaR;AiF/kaI;EACI,chFhCG;ADinaX;AiF9kaI;EACI,chF+JqB;ADi7Z7B;AiF7kaI;;;EAGI,chFqJqB;EgFpJrB,kBAAA;AjF+kaR;AiF5kaI;EACI,gBAAA;EACA,WAAA;EACA,aAAA;EACA,cAAA;AjF8kaR;AiF3kaI;;EAEI,gBAAA;AjF6kaR;AiF1kaI;EACI,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,qBAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,WAAA;AjF4kaR;AiFzkaI;;EAEI,qBhF0Fe;ADi/ZvB;AiFxkaI;EACE,SAAA;EACA,yBAAA;AjF0kaN;AiFzkaM;EACE,yBAAA;AjF2kaR;AiFvkaI;EACE,mBhFnFK;AD4paX;AiFxkaM;EACE,mBhFrFG;AD+paX;AiFtkaI;EACE,mBhFxCE;ADgnaR;AiFvkaM;EACE,mBhF1CA;ADmnaR;AiFrkaI;EACE,YAAA;AjFukaN;AiFpkaI;EACI,cAAA;EACA,iBAAA;EACA,UAAA;EACA,WAAA;AjFskaR;AiFnkaI;;;EAGI,WAAA;EACA,YAAA;EACA,mBAAA;AjFqkaR;AiFlkaI;EACI,YAAA;AjFokaR;AiFlkaQ;EACI,kBAAA;AjFokaZ;AiFhkaI;EACI,kBAAA;EACA,eAAA;EACA,YAAA;AjFkkaR;AiF/jaI;EACI,chFlIG;EgFmIH,YAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,yBAAA;AjFikaR;AiF5jaQ;EACI,kBAAA;AjF8jaZ;AiF5jaY;EACI,kBAAA;EACA,SAAA;AjF8jahB;AiF3jaY;;EAEI,kBAAA;AjF6jahB;AiFzjaQ;EACI,kBAAA;AjF2jaZ;AiFzjaY;EACE,kBAAA;EACA,WAAA;EACA,qBhF6RgB;EgF5RhB,chFlKH;AD6taX;AiFzjac;EACE,UAAA;AjF2jahB;AiFvjaY;EACI,eAAA;AjFyjahB;AiFrjaQ;EACE,kBAAA;EACA,SAAA;EACA,qBhF6QoB;EgF5QpB,chFlLC;ADyuaX;AiFpjaQ;EACM,gBAAA;EACA,eAAA;EACA,6BAAA;EACA,gBAAA;EACA,SAAA;AjFsjad;AiF9iaY;EACM,ehFyQa;EgFxQb,kBAAA;EACA,mBAAA;EACA,yBhFtMP;EgFuMO,yBAAA;EACA,eAAA;EACA,gBAAA;EACA,UAAA;EACA,eAAA;EACA,cAAA;EACA,iBAAA;EACA,gBAAA;EACA,UAAA;AjFgjalB;AiF9iakB;EACG,gBAAA;AjFgjarB;AiF5iaY;EAEI,6BAAA;AjF6iahB;AiFxiagB;EACI,qCAAA;AjF0iapB;AiFriaQ;;EAEI,qBhFlCiB;EgFmCjB,yBhFtOD;AD6waX;AiFliaI;EACI,UAAA;EACA,cAAA;EACA,UAAA;EACA,WAAA;EACA,gBAAA;AjFoiaR;AiFhiaQ;EACI,iBAAA;AjFkiaZ;AiF/haQ;EACI,gBAAA;AjFiiaZ;AiF5haQ;EAKK,2BAAA;EACA,SAAA;EACA,UAAA;EAEA,qBAAA;AjF6hab;AiF3haa;EACI,2CAAA;EACA,2CAAA;EACA,wCAAA;EACA,YAAA;EACA,SAAA;AjF6hajB;AiF1haa;EACI,2CAAA;EACA,gCAAA;EACA,wCAAA;EACA,YAAA;AjF4hajB;AiFzhaa;EAEI,WAAA;EACA,qBAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;EACA,2BAAA;EACA,mCAAA;EACA,gCAAA;AjF0hajB;AiFthaQ;EACK,UAAA;EAMA,2BAAA;EAEA,qBAAA;AjFshab;AiFlhaI;EACI,SAAA;AjFohaR;;AkFr1aA;EACE,kBAAA;EACA,MAAA;EACA,aAAA;AlFw1aF;AkFt1aE;EACE,iBAAA;EACA,YAAA;AlFw1aJ;;AkFp1aA;;;EAIE,iBAAA;AlFs1aF;;AkFn1aA;;EhB0CI,mBjE8GmB;EiE1GnB,2DAAA;EgB3CF,0BAAA;EACA,YAAA;EACA,eAAA;EACA,MAAA;EACA,OAAA;EACA,UAAA;EACA,sBAAA;EACA,kCAAA;EACA,cAAA;EACA,+CAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EAoZA,sDAAA;AlFu8ZF;AkFz1aE;;EACE,WjF8xBgC;EiF7xBhC,gBAAA;EACA,+BAAA;EACA,UAAA;EACA,kBAAA;EACA,cAAA;AlF41aJ;AkF11aI;;EACE,wBAAA;AlF61aN;AkF11aI;;EACE,YAAA;AlF61aN;AkFv1aQ;;;;EACE,qBAAA;AlF41aV;AkFx1aQ;;;;EACE,SAAA;EACA,kBAAA;EACA,0BAAA;EACA,UAAA;EACA,mBAAA;EACA,cAAA;EACA,iBAAA;EACA,UAAA;EACA,+BjFmBmB;AD00a7B;AkF11aQ;;;;EACE,yBAAA;EACA,WAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,WAAA;EACA,UAAA;EACA,gBAAA;EACA,iBAAA;EACA,+BjFGmB;AD41a7B;AkF51aQ;;;;EACE,eAAA;EACA,iBAAA;EACA,WAAA;AlFi2aV;AkFz1aM;;;EACE,cjFrFG;ADk7aX;AkFx1aI;;EACE,UAAA;AlF21aN;AkFr1aE;;EACE,kBAAA;EACA,WAAA;EACA,QAAA;EACA,UAAA;AlFw1aJ;AkFp1aE;;EACE,kBAAA;EACA,sBAAA;EACA,cAAA;EACA,YAAA;EACA,WAAA;EACA,WAAA;EACA,gBAAA;AlFu1aJ;AkFr1aI;;EACE,WAAA;EACA,YAAA;AlFw1aN;AkFp1aE;;EACE,gBAAA;EACA,cAAA;AlFu1aJ;AkFr1aI;;EACE,SAAA;EACA,kBAAA;EACA,WAAA;AlFw1aN;AkFp1aM;;EACE,eAAA;AlFu1aR;AkFt1aQ;;EACE,eAAA;EACA,gBAAA;AlFy1aV;AkFr1aM;;EACE,mBAAA;EACA,mBjF0dsB;EiFzdtB,cjF9IG;EiF+IH,cAAA;EACA,qBAAA;EACA,kBAAA;EACA,yBAAA;EACA,eAAA;EACA,qBjF0SsB;EiFzStB,iBAAA;EACA,qBjFzFsB;ADi7a9B;AkFr1aM;;EACE,cAAA;AlFw1aR;AkFl1aQ;;;;;EACE,cjFjKC;ADy/aX;AkFp1aM;;;EAEE,cjFvKG;AD8/aX;AkFp1aM;;EACE,uBAAA;AlFu1aR;AkFr1aQ;;;EACE,YAAA;AlFy1aV;AkFt1aQ;;EACE,YAAA;EACA,kBAAA;EACA,WAAA;EACA,UAAA;EACA,SAAA;EACA,UAAA;EACA,mBjFxLC;EiFyLD,kBAAA;AlFy1aV;AkFr1aM;;EACE,uBAAA;EACA,gBAAA;EACA,cjFhMG;ADwhbX;AkFt1aQ;;EACE,cjFnMC;AD4hbX;AkFt1aQ;;EAEE,gBAAA;AlFw1aV;AkFv1aU;;;EACE,cjF1MD;EiF2MC,gBjF6PkB;AD8la9B;AkFx1aU;;EACE,YAAA;EACA,kBAAA;EACA,WAAA;EACA,UAAA;EACA,SAAA;EACA,UAAA;EACA,mBjFrND;EiFsNC,kBAAA;AlF21aZ;AkFx1aQ;;EACE,YAAA;EACA,kBAAA;EACA,WAAA;EACA,UAAA;EACA,SAAA;EACA,UAAA;EACA,oCAAA;EACA,kBAAA;AlF21aV;AkFt1aI;;EACE,SAAA;EACA,iBAAA;EACA,kBAAA;EACA,cAAA;EACA,YAAA;EACA,mBAAA;AlFy1aN;AkFr1aI;;EACE,eAAA;EACA,WAAA;EACA,kBAAA;EACA,iBAAA;EACA,WAAA;EACA,kBAAA;EACA,+BjF9KuB;EiF+KvB,kBAAA;AlFw1aN;AkFp1aE;;EACE,kBAAA;EACA,sBAAA;EACA,UAAA;AlFu1aJ;AkFh1aI;;EACE,UAAA;EACA,WAAA;EACA,WAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;AlFm1aN;AkFl1aM;;EACE,kBAAA;EACA,WAAA;AlFq1aR;AkFj1aI;;EACE,cAAA;EACA,UAAA;EhB7RE,iCAAA;AlEsnbR;AkFr1aI;;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;EACA,WAAA;EACA,wBAAA;EACA,oCjFzNuB;ADijb7B;AkFp1aI;;EACE,WAAA;EACA,eAAA;EACA,iBAAA;EACA,cjFxSK;EiFySL,iBAAA;EACA,2DAAA;AlFu1aN;AkFp1aI;;EACE,yBAAA;EACA,iBAAA;EACA,cAAA;EACA,mBAAA;EAEA,cjFnTK;EiFoTL,qBAAA;EACA,gBjFmJwB;EiFlJxB,iBAAA;EACA,gBAAA;AlFs1aN;AkFl1aE;;EACE,kBAAA;EACA,sBAAA;EACA,cAAA;EACA,YAAA;EACA,WAAA;EACA,WAAA;EACA,gBAAA;AlFq1aJ;AkFn1aI;;EACE,WAAA;EACA,YAAA;AlFs1aN;AkFl1aI;;EhB5RA,mBjEwHyB;EiEpHzB,2DAAA;AlEknbJ;AkFt1aI;;EhBhSA,mBjEsHwB;EiElHxB,2DAAA;AlE0nbJ;AkF11aI;;EhBpSA,mBjE0HwB;EiEtHxB,2DAAA;AlEkobJ;AkF91aI;;EhBxSA,mBjE4HwB;EiExHxB,2DAAA;AlE0obJ;AkFl2aI;;EhB5SA,mBjE8HwB;EiE1HxB,2DAAA;AlEkpbJ;AkFt2aI;;EhBhTA,mBjEgIwB;EiE5HxB,2DAAA;AlE0pbJ;AkF12aI;;EhBpTA,mBjEkIwB;EiE9HxB,2DAAA;AlEkqbJ;AkF92aI;;EhBxTA,mBjEwHyB;EiEpHzB,2DAAA;AlE0qbJ;AkFl3aE;;EACE,oBAAA;EACA,mBAAA;EACA,kBAAA;AlFq3aJ;AkFn3aI;;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;EACA,WAAA;EACA,wBAAA;EACA,oCjF/SuB;ADqqb7B;AkFn3aI;;EACE,WAAA;EACA,YAAA;EACA,gBAAA;EACA,WAAA;EACA,UAAA;EACA,kBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gDjFqBqB;ADi2a3B;AkFn3aM;;EACE,WjF8a4B;ADw8ZpC;AkFl3aI;;EACE,cjF3YK;EiF4YL,qBAAA;EACA,oBAAA;EACA,mBAAA;AlFq3aN;AkFh3aM;;EACE,cAAA;EACA,iBAAA;AlFm3aR;AkFj3aQ;;EAEE,cAAA;EACA,kBAAA;EACA,UAAA;AlFm3aV;AkF/2aM;;EACE,kBAAA;EACA,QAAA;EACA,WAAA;AlFk3aR;;AkFx2aA;EACE,gCAAA;AlF22aF;;AkFz2aA;EACE,wBAAA;AlF42aF;;AkFv2aI;;EAEE,cjFvbK;ADiybX;AkFv2aI;EACE,oCAAA;AlFy2aN;;AkFn2aA;EACE,kBAAA;EACA,YAAA;EACA,WjFgXkC;EiF/WlC,iBAAA;EACA,6BAAA;EACA,6CAAA;EhB/bE,0DAAA;AlE0ybJ;AkFv2aE;EACE,6BAAA;AlFy2aJ;AkFt2aE;EACE,6BAAA;AlFw2aJ;AkFr2aE;EACE,6BAAA;AlFu2aJ;AkFp2aE;EACE,6BAAA;EACA,8BAAA;AlFs2aJ;AkFn2aE;EACE,gBAAA;AlFq2aJ;AkFj2aE;EACE,mBAAA;AlFm2aJ;;AkF71aE;EACE,YAAA;EACA,gBAAA;AlFg2aJ;;AkF51aA;;;EAGE,iCAAA;AlF+1aF;;AkF51aA;EACE;;;IAIE,uCAAA;IAEA,sCAAA;IAEA,gDAAA;ElF+1aF;EkF31aE;IACE,wBAAA;ElF61aJ;EkF31aE;IACE,gCAAA;ElF61aJ;EkF11aE;IACE,WAAA;ElF41aJ;EkF11aI;IACE,sBAAA;ElF41aN;EkFv1aE;IACE,cAAA;IACA,aAAA;IACA,iFjF3HqB;EDo9azB;EkFt1aM;IACE,UAAA;IhBhiBF,mCAAA;ElE63bN;EkFv1aM;;;;IhBtiBA,mCAAA;IgB2iBE,UAAA;ElF61aR;EkFz1aI;IACE,UAAA;ElF21aN;EkFv1aE;IACE,YAAA;ElFy1aJ;EkFt1aM;IACE,UAAA;IhBzjBF,+BAAA;ElEs5bN;EkFv1aI;IACE,UAAA;ElFy1aN;EkFv1aI;IACE,YAAA;ElFy1aN;EkFv1aM;;;;IhBrkBA,iCAAA;IgB0kBE,UAAA;ElF61aR;EkFz1aI;IACE,UAAA;ElF21aN;EkFn1aI;IACE,mBAAA;ElFq1aN;EkFj1aE;IACE,mBAAA;ElFm1aJ;EkF90aE;IACE,iBAAA;ElFg1aJ;EkF/0aI;IACE,cjF7lBG;IiF8lBH,eAAA;ElFi1aN;AACF;AkF30aA;EACE,aAAA;EACA,iBAAA;EACA,oBAAA;EACA,mBAAA,EAAA,8BAAA;EAEA,4EAAA;EACA,kBAAA;EACA,gBAAA;AlF60aF;AkF10aI;EACE,cjFjnBK;AD67bX;AkF10aI;EACE,gBAAA;EACA,+BjF9iBuB;EiF+iBvB,cAAA;EACA,eAAA;AlF40aN;AkF10aM;EACE,cjF1nBG;ADs8bX;;AkFt0aA;EACE,aAAA;AlFy0aF;;AkFt0aA;EACE,aAAA;AlFy0aF;;AkFt0aA;EACE;IACE,eAAA;IACA,cAAA;IACA,MAAA;IACA,YAAA;IACA,YAAA;IACA,WAAA;IACA,OAAA;IACA,SAAA;IACA,gBAAA;IACA,aAAA;IACA,mBAAA;IACA,mBAAA;IACA,UAAA;I9DppBE,sD8DqpBF;IhB/pBI,oCAAA;ElE6+bN;AACF;AoBh+bM;E8DmoBJ;I9DloBM,gBAAA;EpBm+bN;AACF;AkFn2aA;EAmBE;I9DzpBI,uD8D0pBF;ElFm1aF;AACF;AoB1+bM;E8DqpBJ;I9DppBM,gBAAA;EpB6+bN;AACF;AkF72aA;EAuBE;IACE,WAAA;ElFy1aF;EkFx1aE;IACE,kBAAA;ElF01aJ;EkFr1aE;IACE,QAAA;IhBhrBE,mCAAA;ElE4gcN;EkFx1aE;I9D1qBE,sD8D4qBA;IhBtrBE,iCAAA;ElEohcN;AACF;AoBvgcM;E8DsqBF;I9DrqBI,gBAAA;EpB0gcN;AACF;AkF14aA;EAwCM;IACE,eAAA;IAAA,gBAAA;ElFq2aN;EkFj2aE;IACE,kBAAA;IACA,kBAAA;ElFm2aJ;EkF91aI;IhBpsBE,oCAAA;ElEyicN;EkFj2aI;;IhBxsBE,iCAAA;ElEijcN;EkFp2aI;IACE,YAAA;IACA,UAAA;ElFs2aN;EkFn2aE;IACE,aAAA;ElFq2aJ;EkFh2aE;IACE,UAAA;IACA,QAAA;IhB1tBE,mCAAA;ElEikcN;EkFl2aA;IACE,YAAA;IACA,WAAA;IACA,eAAA;IACA,UAAA;IACA,MAAA;IACA,QAAA;IACA,WAAA;IACA,WAAA;IACA,aAAA;IACA,kBAAA;IACA,6BAAA;I9DhuBE,uD8DiuBF;ElFo2aF;AACF;AoBlkcM;E8DitBJ;I9DhtBM,gBAAA;EpBqkcN;AACF;AkFr8aA;EA6FE;IACE,2BAAA;ElF22aF;AACF;AkFv2aA;EAEE;IACE,kBAAA;IACA,mBAAA;ElFw2aF;AACF;AmFrmcA,eAAA;AACA;;;;;;;;;;;;;;;;;;;;;;;;;;EjBoBI,6BAAA;AlEincJ;;AmFtncA;;EjBKI,6BAAA;AlE0ncJ;;AmF1ncA;;;;EjBuBI,gEAAA;EAGA,yBAAA;AlE0mcJ;;AmF7ncA;EACE,QAAA;EACA,SAAA;EACA,sBAAA;EACA,sBAAA;EACA,mCAAA;EACA,kCAAA;EACA,gBAAA;EACA,kBAAA;EACA,SAAA;EACA,gBAAA;AnFgocF;;AmF7ncA;EACE,WAAA;AnFgocF;;AmF9ncA;EACE,YAAA;AnFiocF;;AmFzncI;EACE,mBAAA;AnF4ncN;;AmFtncE;EACE,clFhDO;ADyqcX;AmFrncI;;EAEE,wBAAA;AnFuncN;;AmF9mcE;EACE,cAAA;AnFincJ;AmF7mcE;EACE,clFnBI;ADkocR;AmF3mcE;EACE,+BAAA;AnF6mcJ;AmF3mcE;EACE,6CAAA;AnF6mcJ;AmFzmcE;EACE,gBAAA;AnF2mcJ;AmFzmcI;EACE,0CAAA;AnF2mcN;AmFrmcI;EACE,aAAA;AnFumcN;AmFrmcI;EACE,qBAAA;AnFumcN;AmFpmcI;EACE,clFnGK;ADyscX;AmFnmcI;EACA,4BAAA;AnFqmcJ;AmFhmcM;EACE,clFpGG;ADsscX;AmF9lcI;EACE,+BAAA;AnFgmcN;AmF5lcE;;EAEE,6BAAA;AnF8lcJ;AmF3lcE;;EAEE,6BAAA;AnF6lcJ;AmF1lcE;EACE,gBAAA;AnF4lcJ;AmFvlcI;;EACE,6BAAA;AnF0lcN;AmFvlcI;;;;;;;;;;;;;;EAEE,6BAAA;AnFqmcN;AmFjmcM;;;;EACE,clFTQ;AD+mchB;AmFjmcI;;EACE,clFfU;ADmnchB;AmF/lcI;EACE,qBAAA;AnFimcN;;AmF7lcA;EAEE,4BAAA;AnFgmcF;;AmF7lcA;EACE,clFvIQ;ADuucV;;AmF7lcA;EACI;IACI,iBAAA;EnFgmcN;EmF7lcE;IACI,aAAA;EnF+lcN;EmF5lcE;IACE,YAAA;EnF8lcJ;EmF3lcE;IACI,aAAA;EnF6lcN;AACF;AmFxlcA;EAEI;IACI,cAAA;IACA,mBAAA;EnFylcN;AACF;AmFrlcA;EAEQ;IACI,UAAA;EnFslcV;EmFllcE;IACE,mBAAA;IACA,cAAA;EnFolcJ;EmFnlcI;IACE,eAAA;EnFqlcN;AACF;AoFrzcE;;EAEE,QAAA;EACA,UAAA;EACA,kBAAA;EACA,cAAA;ApFuzcJ;AoFpzcQ;;EACE,YAAA;EACA,iBAAA;EACA,eAAA;ApFuzcV;AoFpzcQ;;EACE,kBAAA;EACA,iBAAA;ApFuzcV;AoFpzcQ;;EACE,UAAA;EACA,WAAA;ApFuzcV;AoFlzcQ;;EACE,YAAA;EACA,kBAAA;EACA,iBAAA;ApFqzcV;AoFlzcQ;;EACE,iBAAA;ApFqzcV;AoFjzcI;;;;EAEE,YAAA;EACA,iBAAA;EACA,eAAA;ApFqzcN;AoFlzcI;;;;EAEE,iBAAA;ApFszcN;AoFnzcI;;EACE,WAAA;EACA,UAAA;ApFszcN;AoFlzcE;EACE,6BAAA;ApFozcJ;AoFjzcE;EACE,0BAAA;ApFmzcJ;AoFhzcE;EACE,qBAAA;EACA,cAAA;ApFkzcJ;AoF/ycE;EACE,wBAAA;EACA,UAAA;ApFizcJ;AoF/ycI;EACE,WAAA;EACA,UAAA;ApFizcN;AoF7ycE;EACE,UAAA;EACA,WAAA;ApF+ycJ;AoF5ycE;EACE,WAAA;EACA,OAAA;ApF8ycJ;AoF1ycE;EACE,YAAA;ApF4ycJ;AoFzycE;EACE,OAAA;EACA,cAAA;EACA,eAAA;ApF2ycJ;AoF1ycM;EACE,qBAAA;EACA,sBAAA;ApF4ycR;AoFzycM;EACE,WAAA;EACA,UAAA;ApF2ycR;AoFtycM;EACE,mBAAA;EACA,kBAAA;ApFwycR;AoFrycM;EACE,WAAA;EACA,UAAA;ApFuycR;AoFnycE;EACE,cAAA;ApFqycJ;AoFlycE;EACE,kBAAA;EACA,UAAA;ApFoycJ;AoFhycE;EACE;IACE,oBAAA;IACA,kBAAA;EpFkycJ;EoF/xcE;IACE,oBAAA;IACA,kBAAA;EpFiycJ;EoF9xcE;IACE,kBAAA;EpFgycJ;AACF;AoF3xcE;EAEE;IACE,eAAA;EpF4xcJ;EoF1xcE;IACE,mBAAA;EpF4xcJ;EoFzxcE;IACE,YAAA;IACA,UAAA;EpF2xcJ;EoFxxcE;IACE,mBAAA;EpF0xcJ;AACF;AoFtxcI;EACE,gBAAA;ApFwxcN;AoFvxcM;EACE,iBAAA;ApFyxcR;AoFxxcQ;EACE,iBAAA;ApF0xcV;AoFtxcM;EACE,eAAA;EACA,UAAA;ApFwxcR;AoFvxcQ;EACE,gBAAA;EACA,iBAAA;ApFyxcV;AoFrxcM;EACE,kBAAA;ApFuxcR;AoFlxcE;EACE,sBAAA;EACA,OAAA;ApFoxcJ;AoFjxcE;EACE,eAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;ApFmxcJ;AoFjxcE;EACE,0BAAA;EACA,OAAA;EACA,WAAA;EAAA,cAAA;ApFmxcJ;AoFlxcI;EACE,qBAAA;EACA,sBAAA;ApFoxcN;AoFnxcM;EACE,UAAA;EACA,kBAAA;EACA,WAAA;ApFqxcR;AoFnxcM;EACE,WAAA;EAAA,cAAA;EACA,WAAA;EACA,cAAA;EAAA,oBAAA;EACA,4CAAA;ApFqxcR;AoFnxcM;EACE,WAAA;EAAA,cAAA;EACA,WAAA;EACA,cAAA;EAAA,oBAAA;EACA,iCAAA;ApFqxcR;AoFjxcE;EACE,UAAA;EAAA,aAAA;EACA,WAAA;ApFmxcJ;;AoF9wcA;EAEE;IACE,kBAAA;IACA,mBAAA;EpFgxcF;AACF;AqFlgdA;;EAEE,cpF4KqB;ADw1cvB;;AqFhgdA;;EAEE,cpFgJc;ADm3chB;;AyEl+cQ;;EACI,yBAAA;AzEs+cZ;AyEn+cQ;;EACI,kBAAA;AzEs+cZ;AyEp+cY;;;EAEI,yBAAA;AzEu+chB;;AyE99cQ;;EACI,kBAAA;EACA,YAAA;AzEk+cZ;AyEh+cY;;;EAEI,yBAAA;AzEm+chB;AyE/9cQ;;;;EAEI,yBAAA;AzEm+cZ;AyEj+cY;;;;EACI,4BAAA;AzEs+chB;;AyE39cQ;;EACI,kBAAA;AzE+9cZ;AyE79cY;;;EAEI,yBAAA;AzEg+chB;AyE59cQ;;;;EAEI,yBAAA;AzEg+cZ;;AyE19cQ;;EACI,4BAAA;AzE89cZ;AyE59cY;;;EAEI,yBAAA;AzE+9chB;AyE39cQ;;;;EAEI,yBAAA;AzE+9cZ;AyE79cY;;;;;;;EAEI,4BAAA;AzEo+chB;;AqFzkdI;;;;;;EAII,yBAAA;EACA,mBAAA;ArF8kdR;AqF7kdQ;;;;;;;;;;;;;;;;EAGI,mBAAA;EACA,yBAAA;ArF4ldZ;AqFtldY;;;EAEI,yBAAA;ArFyldhB;AqFpldI;;;;EAEI,yBAAA;EACA,YAAA;ArFwldR;;AqFnldI;EACI,cpF8He;ADw9cvB;;AqFlldI;EACI,cpFmGQ;ADk/chB;;AqFjldA;;EAEI,6BAAA;EACA,yBAAA;EACA,wBpF4V0B;EoF3V1B,cpFhDO;EiEgFP,oGAAA;AlEyjdJ;AqFvldI;;EACE,YAAA;ArF0ldN;AqFrldI;;EACI,6BpF9CqB;ADsod7B;AqFrldI;;EACI,6BpFlDqB;AD0od7B;AqFtldI;;EACI,cpFgGe;ADy/cvB;AqFvldI;;EACI,cpFuEQ;ADmhdhB;AqFvldI;;;EZnFA,uBAAA;EYsFI,kBAAA;ArF0ldR;AqFvldI;;EACI,WAAA;ArF0ldR;;AqFtldA;;;EAGI,6BAAA;EACA,yBAAA;EACA,wBpFqT0B;EoFpT1B,cpFvFO;EoFwFP,SAAA;ArFyldJ;;AqFtldA;EACE,iBAAA;ArFyldF;;AqFvldA;EACE,kBAAA;ArF0ldF;;AqFtldI;;EAEI,yBpFrGG;EoFsGH,qBpFkCQ;EoFjCR,6BpF5FqB;EoF6FrB,qBpFgCQ;ADyjdhB;AqFrldQ;;EAEI,yBAAA;ArFuldZ;;AqFlldA;;EAEI,mBAAA;EACA,kBAAA;ArFqldJ;AqFnldI;;EACI,eAAA;ArFsldR;;AqFjldI;;EAEI,yBpF2DqB;ADyhd7B;;AqFhldA;EACI,wBpFsQ0B;EoFrQ1B,yBAAA;EACA,4BAAA;EACA,mBAAA;ArFmldJ;;AqFhldA;;;EAGI,oBAAA;ArFmldJ;;AqFjldA;;;EAGI,mBAAA;ArFoldJ;;AqFlldA;EACI,yBpFWmB;EoFVnB,cpFhBY;EoFiBZ,mBAAA;ArFqldJ;;AqFlldA;EACI,iBpFwOyB;EoFvOzB,oBAAA;ArFqldJ;;AqFnldA;EACI,qBpF4ByB;AD0jd7B;;AqFnldA;EACI,cAAA;ArFsldJ;;AqFnldA;EACI,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,YAAA;EACA,cAAA;ArFsldJ;;AqFhldI;;;EAEI,mBAAA;ArFoldR;;AqFhldA;EACI,WAAA;EACA,UAAA;EACA,gBAAA;EACA,eAAA;ArFmldJ;;AqFhldA;EACI,eAAA;ArFmldJ;;AqF/kdA;EACE,UAAA;EACA,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;ArFkldF;;AqF/kdA;EACI,0BpF4O0B;EoF3O1B,+BAAA;ArFkldJ;;AqF/kdA;EACI,UAAA;EACA,kBAAA;EACA,cAAA;EACA,gBAAA;ArFkldJ;AqFhldI;EACE,4BAAA;ArFkldN;;AqF7kdI;;EAEI,wBAAA;EACA,iBAAA;EACA,gBAAA;ArFgldR;AqF7kdI;EACI,mBAAA;ArF+kdR;AqF7kdQ;EACG,eAAA;ArF+kdX;AqF3kdI;EACI,gBAAA;EACA,wBAAA;ArF6kdR;AqF1kdI;EACI,eAAA;ArF4kdR;AqF3kdQ;EACE,oBAAA;ArF6kdV;;AqFxkdA;EACI,iBpFiH2B;AD09c/B;AqF1kdM;EACE,SAAA;ArF4kdR;AqF1kdO;EACI,mBAAA;EACA,UAAA;EACA,gBAAA;EACA,YAAA;EACA,kBAAA;ArF4kdX;AqF3kdW;EACG,aAAA;EACC,uBAAA;EACA,YAAA;EACA,+BAAA;ArF6kdf;AqFzkdW;EACI,eAAA;EACA,cpFlRJ;EoFmRI,wBAAA;ArF2kdf;AqFzkdW;EACI,uBAAA;EACA,uBAAA;EACA,gBAAA;EACA,wBAAA;EACA,eAAA;EACA,YAAA;ArF2kdf;AqF1kde;EACI,uBAAA;ArF4kdnB;AqFzkdW;EACI,UAAA;EACA,cpFlSJ;AD62dX;AqF1kde;EACE,YAAA;ArF4kdjB;;AqFtkdG;EACE,iBAAA;EACA,iBAAA;ArFykdL;AqFxkdK;EACE,YAAA;EACA,cpF7PC;ADu0dR;AqFzkdO;EACE,cpF/PD;AD00dR;;AqFtkdA;EACE,eAAA;ArFykdF;;AqFrkdE;;EACE,epFgJ2B;ADy7c/B;;AsFn5dA;;EAAA;AAGA;EACE,2BAAA;EACA,qBAAA;EACA,wBAAA;EACA,kBAAA;EACA,sBAAA;AtFs5dF;;AsFn5dA;;EAAA;AAGA;EACE,aAAA;EACA,UAAA;EACA,6DAAA;EACA,qEAAA;EACA,YAAA;EACA,mDAAA;EACA,WAAA;EACA,mCAAA;EACA,kBAAA;AtFs5dF;;AsFn5dA;EACE,aAAA;EACA,UAAA;EACA,6DAAA;EACA,qEAAA;EACA,WAAA;EACA,mDAAA;EACA,QAAA;EACA,mCAAA;EACA,kBAAA;AtFs5dF;;AsFn5dA;;EAEE,cAAA;EACA,6BAAA;AtFs5dF;;AsFn5dA;;;;;;EAME,YAAA;AtFs5dF;;AsFn5dA;;;;;;EAME,sBAAA;EACA,YAAA;AtFs5dF;;AsFn5dA;;EAAA;AAGA;EACE,sBAAA;EACA,kBAAA;EACA,iEAAA;EACA,yEAAA;EACA,WAAA;EACA,2CAAA;EACA,WAAA;EACA,mCAAA;EACA,kBAAA;AtFs5dF;;AsFn5dA;EACE,sBAAA;EACA,kBAAA;EACA,gEAAA;EACA,wEAAA;EACA,UAAA;EACA,0CAAA;EACA,UAAA;EACA,mCAAA;EACA,kBAAA;AtFs5dF;;AsFn5dA;;;EAGE,sBAAA;EACA,YAAA;AtFs5dF;;AsFn5dA;;;EAGE,sBAAA;EACA,WAAA;AtFs5dF;;AsFn5dA,gBAAA;AACA;EACE;IACE,yBAAA;EtFs5dF;AACF;AsFn5dA;EACE;IACE,yBAAA;EtFq5dF;AACF;AuFvgeA;EACE,aAAA;EACA,eAAA;AvFygeF;;AwF3geA;EAEE,mBvFwB2B;ADq/d7B;AwF3geE;EACE,cvF0KmB;ADm2dvB;AwF1geE;EACE,mBvFsKmB;ADs2dvB;AwF1geE;EACI,cvFmKiB;ADy2dvB;AwF3geM;EACE,cvFiKe;AD42dvB;AwFzgeE;EACE,cvF4JmB;AD+2dvB;AwFxgeE;EACE,cvFwJmB;ADk3dvB;AwFxgeE;EACE,cvF2HY;AD+4dhB;AwFzgeI;EACE,cvFwCM;ADm+dZ;AwFvgeE;EACE,6EAAA;AxFygeJ;AwFxgeI;EACE,+BvFoDuB;ADs9d7B;AwFtgeE;EACE,mBvFdyB;ADshe7B;AwFrgeE;EACE,cvFmImB;ADo4dvB;AwFpgeE;EACE,cvFgBI;ADs/dR;AwFngeE;EACE,2EAAA;AxFqgeJ;AwFlgeE;EACE,yBAAA;AxFogeJ;AyEvjeG;EACI,yBeuD6B;EpB1DlC,UKIsB;ELDtB,0BAAA;ApE2jeF;AyExjeG;EACI,yBemD6B;EpB1DlC,UKQsB;ELLtB,0BAAA;ApEgkeF;AyEzjeG;EACI,yBe+C6B;EpB1DlC,UKYsB;ELTtB,0BAAA;ApEqkeF;AyE1jeG;EACI,yBe2C6B;EpB1DlC,UKgBsB;ELbtB,0BAAA;ApE0keF;AwFjheM;EACE,qBvF8Ge;ADq6dvB;AwF/geI;EACE,mCAAA;EACA,cvFyGiB;ADw6dvB;AwF9geI;EACE,cvFVE;EuFWF,mCAAA;AxFgheN;AwF/geM;EACE,qBvFyEQ;ADw8dhB;AwF3geM;;;;;;;;;;EAKI,0CvFRmB;AD0he7B;AwFjheU;;;;;;;;;;;;;;;;;;;;;;;;;;;;EAGI,0CvFXe;ADuje7B;AwFtiec;;;EAGI,6BvF5EW;ADone7B;AwF/heM;;EAEI,yBvFhDF;ADileR;AwF7heE;EACE,mBvFoFyB;EuFnFzB,mCAAA;AxF+heJ;AwF3heM;;;EAGE,qBvFyBQ;ADogehB;AwFzheU;;EAGI,0CvFnDe;AD6ke7B;AwFtheE;EACI,kBAAA;AxFwheN;AwFrheE;EACI,iBAAA;AxFuheN;AwFpheE;EACE,qBvF6BmB;ADy/dvB;AwFnheE;EACE,qBAAA;AxFqheJ;AwFjheI;EACE,yBAAA;AxFmheN;AwF/geE;EACE,2EAAA;AxFiheJ;AwF9geE;EACE,mBvFrJO;EuFsJP,kDAAA;AxFgheJ;AwF/geI;EACE,cvFtGE;ADuneR;AwFhheM;EACE,cvFxGA;AD0neR;AwF/geI;EACE,cvFGiB;AD8gevB;AwF7geM;EACE,cvFFe;ADihevB;AwF1geI;EACE,cvFlCU;AD8iehB;AwFxgeK;EACG,cvFkBqB;EuFjBrB,uCAAA;AxF0geR;AwFzgeQ;EACE,iCAAA;AxF2geV;AwFzgeQ;EACE,cvFpLC;AD+reX;AwFtgeI;EACI,cvFMqB;ADkge7B;AwFpgeI;EACE,gBAAA;AxFsgeN;AwFngeI;EACE,uBvFxLuB;EuFyLvB,gBAAA;AxFqgeN;AwFhgeQ;EACE,4BAAA;AxFkgeV;AwFjgeU;EACE,cvF1JJ;AD6peR;AwF1/dM;EACE,oCAAA;AxF4/dR;AwFx/dI;;;;;;EAMI,gCAAA;EACA,iBAAA;EACA,sBAAA;AxF0/dR;AwFv/dI;EACE,yBAAA;AxFy/dN;AwFr/dE;EACE,cvF1EmB;ADikevB;AwFp/dE;EACE,cvF9EmB;ADokevB;AwFl/dM;EACE,8BAAA;EACA,wCAAA;AxFo/dR;AwFn/dQ;EACE,cvFhHM;ADqmehB;AwFj/dM;EACE,cvF3Fe;AD8kevB;AwF/+dG;EACE,mBvFrPwB;ADsue7B;AwF/+dK;EACE,cvFnGgB;ADolevB;AwF9+dK;EACE,cvFlNK;ADkseZ;AwF7+dK;EACE,cvF3GgB;AD0levB;AwF5+dK;EACE,cvF/GgB;AD6levB;AwF1+dG;EACE,mBAAA;EACA,cvFrHkB;ADimevB;AwF3+dK;EACE,mBAAA;AxF6+dP;;AyFnxeA;EACI,mBxFy8BgC;EwFx8BhC,SAAA;EACA,kBAAA;EACA,mBAAA;EACA,6CxFiauB;ADq3d3B;AyFnxeI;EACE,+BAAA;AzFqxeN;AyFlxeI;EACE,sBAAA;AzFoxeN;AyFjxeI;EACE,aAAA;AzFmxeN;AyFjxeM;EACE,eAAA;EACA,gBAAA;AzFmxeR;AyFhxeM;EACE,cxFXG;EwFYH,uBAAA;EACA,gBxF0bsB;EwFzbtB,sBAAA;AzFkxeR;AyF/weM;EACE,+BAAA;AzFixeR;AyF5weI;EAIE,oBAAA;EACA,SAAA;EACA,+BAAA;AzF2weN;AyFhxeM;EACE,6BAAA;AzFkxeR;AyF5weM;EACI,cxFhCC;EwFiCD,gBAAA;AzF8weV;AyF3weM;EACE,cxFiBI;EwFhBJ,kBAAA;EACA,gBAAA;AzF6weR;AyFzweI;EACI,wBxFgWsB;AD26d9B;AyFzweQ;EACE,aAAA;AzF2weV;AyFvweI;EACE,mBxFpDK;AD6zeX;AyFvweM;EACE,cxFLA;AD8weR;AyFvweM;EACE,cxFoIqB;ADqoe7B;AyE50eG;EACI,yBgBuEiC;ErB1EtC,UKIsB;ELDtB,0BAAA;ApEg1eF;AyE70eG;EACI,yBgBmEiC;ErB1EtC,UKQsB;ELLtB,0BAAA;ApEq1eF;AyE90eG;EACI,yBgB+DiC;ErB1EtC,UKYsB;ELTtB,0BAAA;ApE01eF;AyE/0eG;EACI,yBgB2DiC;ErB1EtC,UKgBsB;ELbtB,0BAAA;ApE+1eF;AyFtxeU;EACE,qBxF8FW;AD0revB;AyFpxeQ;EACE,mCAAA;EACA,cxFyFa;AD6revB;AyFnxeQ;EACE,cxF1BF;EwF2BE,mCAAA;AzFqxeV;AyFpxeU;EACE,qBxFyDI;AD6tehB;AyFnxeQ;EACE,cxFoDM;ADiuehB;AyFhxeU;;;;;;;;;;EAKE,0CxF3BiB;ADkze7B;AyFtxec;;;;;;;;;;;;;;;;;;;;;;;;;;;;EAGE,0CxF9Ba;AD+0e7B;AyF3yekB;;;EAEE,6BxF9FS;AD44e7B;AyFryeU;;EAEI,yBxFlEN;ADy2eR;AyFnyeM;EACE,mBxFkEqB;EwFjErB,mCAAA;AzFqyeR;AyFjyeU;;;EAGE,yBxFjID;EwFkIC,qBxFMI;AD6xehB;AyF/xec;;EAGI,0CxFtEW;ADs2e7B;AyF5xeM;EACI,kBAAA;AzF8xeV;AyF3xeM;EACI,iBAAA;AzF6xeV;AyF1xeM;EACE,qBxFUe;ADkxevB;AyFzxeM;EACE,qBAAA;AzF2xeR;AyFtxeI;EACE,uBAAA;EACA,gBAAA;AzFwxeN;AyFrxeI;EACI,gBAAA;EACA,aAAA;EACA,kBAAA;AzFuxeR;AyFpxeI;EACI,WAAA;EACA,YAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;AzFsxeR;AyFnxeI;EACI,0BxF0QsB;EwFzQtB,kBAAA;AzFqxeR;AyFjxeI;EACI,6BAAA;EACA,SAAA;EACA,aAAA;AzFmxeR;AyF/weY;EACI,iBAAA;EACA,kBAAA;AzFixehB;AyF5weQ;EACE,gBAAA;EACA,cAAA;AzF8weV;;AyFzweA;EACE,gBxFsuBkC;ADsidpC;;Ac55eI;E2EqJA;IACE,mBAAA;IACA,SAAA;EzF2weJ;AACF;A0F/+eA;EACE,gBAAA;A1Fi/eF;A0F9+eM;EACE,eAAA;EACA,iBAAA;EACA,kBAAA;A1Fg/eR;A0F7+eI;EACE,kBAAA;A1F++eN;A0F5+eI;EACE,iBAAA;EACA,kBAAA;A1F8+eN;A0F7+eM;EACE,UAAA;A1F++eR;A0F5+eE;EACE,gBAAA;A1F8+eJ;A0F5+eI;EACE,gBAAA;EACA,iDAAA;A1F8+eN;A0F1+eE;EACE,gBAAA;EACA,eAAA;A1F4+eJ;A0Fz+eE;EACE,aAAA;EACA,WAAA;A1F2+eJ;A0Fz+eE;EACE,gBAAA;A1F2+eJ;A0Fz+eI;EACE,czFyBM;ADk9eZ;A0Fv+eE;EACE,kBAAA;EACA,WAAA;EACA,SAAA;A1Fy+eJ;A0Fv+eI;EACE,SAAA;A1Fy+eN;A0Fp+eI;EACE,oBAAA;EACA,YAAA;A1Fs+eN;A0Fn+eI;EACE,mBAAA;A1Fq+eN;A0Fp+eM;EACE,eAAA;A1Fs+eR;;A2FxifA;EACE,aAAA;A3F2ifF;;A4F5ifA;EACE,gBAAA;A5F+ifF;A4F9ifI;EACI,aAAA;A5FgjfR;A4F7ifI;EACI,kBAAA;EACA,oBAAA;EACA,gBAAA;A5F+ifR;A4F7ifQ;EACI,gBAAA;A5F+ifZ;A4F5ifQ;EACE,kBAAA;EACA,aAAA;EACA,YAAA;A5F8ifV;A4F7ifU;E1BiDN,oC0BhDuC;E1BoDvC,+FAAA;EAkHF,iEAAA;EAKA,yBAAA;E0BzKU,iBAAA;EACA,kBAAA;A5FwjfZ;A4FrjfU;E1B0CN,oC0BzCuC;E1B6CvC,+FAAA;EAkHF,iEAAA;EAKA,wBAAA;E0BlKU,iBAAA;EACA,mBAAA;A5FgkfZ;A4F7jfU;E1BmCN,oC0BlCuC;E1BsCvC,+FAAA;EAkHF,iEAAA;EAKA,yBAAA;E0B3JU,iBAAA;EACA,YAAA;A5FwkfZ;A4FpkfU;E1B2BN,oC0B1BuC;E1B8BvC,+FAAA;EAkHF,iEAAA;EAKA,yBAAA;E0BnJU,iBAAA;EACA,YAAA;A5F+kfZ;A4FzkfI;EACE,YAAA;EACA,aAAA;EACA,yBAAA;EACA,gC3F9BuB;E2F+BvB,6B3F/BuB;E2FgCvB,kBAAA;A5F2kfN;A4FxkfI;EACI,iBAAA;A5F0kfR;A4FvkfI;EACI,gBAAA;A5FykfR;A4FtkfI;EACI,kBAAA;EACA,kBAAA;A5FwkfR;A4FrkfI;EACE,gBAAA;A5FukfN;;A6FjpfA;EACE,aAAA;A7FopfF;A6FlpfE;EACE,iBAAA;EACA,kBAAA;A7FopfJ;A6FhpfI;EACE,kBAAA;EACA,gB5F2cwB;ADuse9B;A6F/ofI;EACE,YAAA;EACA,cAAA;A7FipfN;A6F5ofI;EACE,c5F8CM;E4F7CN,gBAAA;A7F8ofN;A6F7ofM;EACE,c5FXG;AD0pfX;;A8FxqfA;EACE,uBAAA;EACA,gBAAA;A9F2qfF;A8FzqfE;;EAEE,cAAA;EACA,eAAA;EACA,6BAAA;A9F2qfJ;A8FxqfE;EACI,eAAA;EACA,gBAAA;A9F0qfN;;A+FvrfA;EACG,WAAA;A/F0rfH","sourcesContent":["/*\n =========================================================\n * Black Dashboard React v1.2.0 based on Black Dashboard - v1.2.0\n =========================================================\n\n * Product Page: https://www.creative-tim.com/product/black-dashboard-react\n * Copyright 2023 Creative Tim (https://www.creative-tim.com)\n * Licensed under MIT (https://github.com/creativetimofficial/black-dashboard-react/blob/master/LICENSE.md)\n\n * Coded by Creative Tim\n\n =========================================================\n\n * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.\n\n */\n\n// Core\n\n@import \"black-dashboard-react/custom/functions\";\n@import \"../../../node_modules/bootstrap/scss/functions\";\n\n@import \"black-dashboard-react/custom/variables\";\n@import \"../../../node_modules/bootstrap/scss/variables\";\n\n@import \"black-dashboard-react/custom/mixins\";\n@import \"../../../node_modules/bootstrap/scss/mixins\";\n\n// Bootstrap components\n\n@import \"../../../node_modules/bootstrap/scss/root\";\n@import \"../../../node_modules/bootstrap/scss/reboot\";\n@import \"../../../node_modules/bootstrap/scss/type\";\n@import \"../../../node_modules/bootstrap/scss/images\";\n\n@import \"../../../node_modules/bootstrap/scss/grid\";\n@import \"../../../node_modules/bootstrap/scss/tables\";\n@import \"../../../node_modules/bootstrap/scss/forms\";\n@import \"../../../node_modules/bootstrap/scss/buttons\";\n@import \"../../../node_modules/bootstrap/scss/transitions\";\n@import \"../../../node_modules/bootstrap/scss/dropdown\";\n@import \"../../../node_modules/bootstrap/scss/button-group\";\n@import \"../../../node_modules/bootstrap/scss/forms/input-group\";\n@import \"../../../node_modules/bootstrap/scss/nav\";\n@import \"../../../node_modules/bootstrap/scss/navbar\";\n@import \"../../../node_modules/bootstrap/scss/card\";\n@import \"../../../node_modules/bootstrap/scss/breadcrumb\";\n@import \"../../../node_modules/bootstrap/scss/pagination\";\n@import \"../../../node_modules/bootstrap/scss/badge\";\n@import \"../../../node_modules/bootstrap/scss/alert\";\n@import \"../../../node_modules/bootstrap/scss/progress\";\n@import \"../../../node_modules/bootstrap/scss/list-group\";\n@import \"../../../node_modules/bootstrap/scss/close\";\n@import \"../../../node_modules/bootstrap/scss/tooltip\";\n@import \"../../../node_modules/bootstrap/scss/popover\";\n@import \"../../../node_modules/bootstrap/scss/carousel\";\n@import \"../../../node_modules/bootstrap/scss/utilities\";\n@import \"../../../node_modules/bootstrap/scss/bootstrap-utilities\";\n\n\n// Custom components\n\n@import \"black-dashboard-react/custom/alerts.scss\";\n@import \"black-dashboard-react/custom/badges.scss\";\n@import \"black-dashboard-react/custom/buttons.scss\";\n@import \"black-dashboard-react/custom/dropdown.scss\";\n@import \"black-dashboard-react/custom/footer.scss\";\n@import \"black-dashboard-react/custom/forms.scss\";\n@import \"black-dashboard-react/custom/images.scss\";\n@import \"black-dashboard-react/custom/modal.scss\";\n@import \"black-dashboard-react/custom/navbar.scss\";\n@import \"black-dashboard-react/custom/type.scss\";\n@import \"black-dashboard-react/custom/tables\";\n@import \"black-dashboard-react/custom/checkboxes-radio\";\n@import \"black-dashboard-react/custom/fixed-plugin\";\n@import \"black-dashboard-react/custom/sidebar-and-main-panel.scss\";\n@import \"black-dashboard-react/custom/misc.scss\";\n@import \"black-dashboard-react/custom/rtl.scss\";\n@import \"black-dashboard-react/custom/input-group.scss\";\n\n// Vendor / Plugins\n\n@import \"black-dashboard-react/custom/vendor/plugin-perfect-scrollbar.scss\";\n@import \"black-dashboard-react/custom/vendor/plugin-react-notification-alert.scss\";\n\n// light mode\n\n@import \"black-dashboard-react/custom/white-content.scss\";\n\n// Cards\n\n@import \"black-dashboard-react/custom/card\";\n@import \"black-dashboard-react/custom/cards/card-chart\";\n@import \"black-dashboard-react/custom/cards/card-map\";\n@import \"black-dashboard-react/custom/cards/card-user\";\n@import \"black-dashboard-react/custom/cards/card-task\";\n@import \"black-dashboard-react/custom/cards/card-plain\";\n\n// React differences\n@import \"black-dashboard-react/react-differences/react-differences\";\n","\n// Global settings\n\n$enable-caret:              true !default;\n$enable-rounded:            true !default;\n$enable-shadows:            true !default;\n$enable-gradients:          false !default;\n$enable-transitions:        true !default;\n$enable-grid-classes:       true !default;\n$enable-print-styles:       true !default;\n\n\n// Color system\n\n$white:    #ffffff !default;\n$gray-100: #f6f9fc !default;\n$gray-200: #e9ecef !default;\n$gray-300: #e3e3e3 !default;\n$gray-400: #ced4da !default;\n$gray-500: #adb5bd !default;\n$gray-600: #6c757d !default;   // Line footer color\n$gray-700: #525f7f !default;   // Line p color\n$gray-800: #32325d !default;   // Line heading color\n$gray-900: #212529 !default;\n$link-disabled:              #666666 !default;\n$transparent-bg:             transparent !default;\n$light-bg:                   #f5f6fa !default;\n$dark-background:            #555555 !default;\n\n\n$grays: () !default;\n$grays: map-merge((\n  \"100\": $gray-100,\n  \"200\": $gray-200,\n  \"300\": $gray-300,\n  \"400\": $gray-400,\n  \"500\": $gray-500,\n  \"600\": $gray-600,\n  \"700\": $gray-700,\n  \"800\": $gray-800,\n  \"900\": $gray-900\n), $grays);\n\n$blue:    #5e72e4 !default;\n$indigo:  #5603ad !default;\n$purple:  #8965e0 !default;\n$pink:    #f3a4b5 !default;\n$red:     #f5365c !default;\n$orange:  #fb6340 !default;\n$yellow:  #ffd600 !default;\n$green:   #2dce89 !default;\n$teal:    #11cdef !default;\n$cyan:    #2bffc6 !default;\n$capri:   #00BFFF !default;\n$chinese-silver: #CCCCCC !default;\n$ghost-white: #d7e0eb !default;\n$tea-green: #DCF8C6 !default;\n$light-moss-green: #B2D8B2 !default;\n$lavender-blue: #C8D8FA !default;\n$light-steel-blue: #A8B8DA !default;\n$davy-grey: #555555 !default;\n$chinese-white: #e0e0e0 !default;\n$azure: #007bff !default;\n$purple-pizzazz: #e14eca !default;\n$black: #000000 !default;\n$bright-gray: #EEEEEE !default;\n$anti-flash-white: #F0F0F0 !default;\n$slate-gray: #68869a !default;\n$dark-gray: #AAAAAA !default;\n$azureish-white: #d7e0eb !default;\n$dark-charcoal: #333333 !default;\n$apple: #4CAF50 !default;\n$may-green: #45a049 !default;\n$crayola: #0056b3 !default;\n\n$line-height-lg:              1.625rem !default;\n$line-height-sm:              1.5 !default;\n$line-height:                 1.35em         !default;\n\n\n$opacity-gray-3:             rgba(222,222,222, .3) !default;\n$opacity-gray-5:             rgba(222,222,222, .5) !default;\n$opacity-gray-8:             rgba(222,222,222, .8) !default;\n\n\n$opacity-5:                  rgba(255,255,255, .5) !default;\n$opacity-6:                  rgba(255,255,255, .6) !default;\n$opacity-8:                  rgba(255,255,255, .8) !default;\n\n\n\n$opacity-1:                  rgba(255,255,255, .1) !default;\n$opacity-2:                  rgba(255,255,255, .2) !default;\n\n\n// end beniamin\n\n$colors: () !default;\n$colors: map-merge((\n  \"blue\":       $blue,\n  \"indigo\":     $indigo,\n  \"purple\":     $purple,\n  \"pink\":       $pink,\n  \"red\":        $red,\n  \"orange\":     $orange,\n  \"yellow\":     $yellow,\n  \"green\":      $green,\n  \"teal\":       $teal,\n  \"cyan\":       $cyan,\n  \"white\":      $white,\n  \"gray\":       $gray-600,\n  \"light\":      $gray-400,\n  \"lighter\":    $gray-200,\n  \"gray-dark\":  $gray-800,\n  \"capri\": $capri,\n  \"chinese-silver\": $chinese-silver,\n  \"ghost-white\": $ghost-white,\n  \"tea-green\": $tea-green,\n  \"light-moss-green\": $light-moss-green,\n  \"lavender-blue\": $lavender-blue,\n  \"light-steel-blue\": $light-steel-blue,\n  \"davy-grey\": $davy-grey,\n  \"chinese-white\" : $chinese-white,\n  \"azure\": $azure,\n  \"purple-pizzazz\" : $purple-pizzazz,\n  \"black\": $black,\n  \"bright-gray\": $bright-gray,\n  \"anti-flash-white\": $anti-flash-white,\n  \"slate-gray\": $slate-gray,\n  \"dark-gray\": $dark-gray,\n  \"azureish-white\": $azureish-white,\n  \"dark-charcoal\": $dark-charcoal,\n  \"apple\": $apple,\n  \"may-green\": $may-green,\n  \"crayola\": $crayola\n), $colors);\n\n$default-color-opacity:      rgba(182, 182, 182, .6) !default;\n$orange-color:               #f96332 !default;\n\n/*\n$default:       #d7e0eb !default;\n$primary:       #011e31 !default;\n$secondary:     #68869a !default;\n$success:       #0c4160 !default;\n$info:          #dad9d6 !default;\n$warning:       #68869a !default;\n*/\n\n$default:       #011e31 !default;\n$primary:       #68869a !default;\n$secondary:     #d7e0eb !default;\n$success:       #68869a !default;\n$info:          #0c4160 !default;\n$warning:       #0c4160 !default;\n$danger:        #0c4160 !default;\n$black:         #0c4160 !default;\n/*\n$default:       #344675 !default;\n$primary:       #e14eca !default;\n$secondary:     #f4f5f7 !default;\n$success:       #00f2c3 !default;\n$info:          #1d8cf8 !default;\n$warning:       #ff8d72 !default;\n$danger:        #fd5d93 !default;\n$black:         #222a42 !default;*/\n\n\n// gradient\n$default-states:       #263148 !default;\n$primary-states:       #ba54f5 !default;\n$success-states:       #0098f0 !default;\n$info-states:          #3358f4 !default;\n$warning-states:       #ff6491 !default;\n$danger-states:        #ec250d !default;\n$black-states:         #1d253b !default;\n\n$background-blue:           #0c4160 !default;\n$background-states-blue:    #3358f4 !default;\n$background-black:           #1e1e24 !default;\n$background-states-black:    #1e1e6f !default;\n$background-green:          #1c6430 !default;   // vibrant green\n$background-states-green:   #28a745 !default;   // darker green for hover/active\n$background-red:            #7f1f27 !default;   // vibrant red\n$background-states-red:     #dc3545 !default;   // darker red for hover/active\n$background-orange:         #a84b0a !default;   // deep orange\n$background-states-orange:  #fd7e14 !default;   // darker orange\n$background-purple:         #47278a !default;   // rich purple\n$background-states-purple:  #6f42c1 !default;   // darker purple\n$background-teal:           #147a62 !default;   // turquoise/teal\n$background-states-teal:    #20c997 !default;   // darker teal\n\n\n// opacity\n$default-opacity:      rgba(182, 182, 182, .6) !default;\n$primary-opacity:      rgba(249, 99, 50, .3) !default;\n$success-opacity:      rgba(24, 206, 15, .3) !default;\n$info-opacity:         rgba(44, 168, 255, .3) !default;\n$warning-opacity:      rgba(255, 178, 54, .3) !default;\n$danger-opacity:       rgba(255, 54, 54, .3) !default;\n\n$light-gray:                 #E3E3E3 !default;\n$medium-gray:                #DDDDDD !default;\n$dark-gray:                  #9A9A9A !default;\n$card-stats-gray:            #808080 !default;\n$active-gray:                #777777 !default;\n$nav-gray:                   #444444 !default;\n$search-gray:                #b7b7b7 !default;\n$calendar-gray:              #9499a7 !default;\n$active-blue:                #00bbff !default;\n\n\n\n$light:         $gray-500 !default;\n$dark:          $gray-900 !default;\n$darker:        darken($gray-900, 15%) !default;\n\n$facebook:              #3b5998 !default;\n$facebook-states:       darken($facebook, 5%) !default;\n$twitter:               #55acee !default;\n$twitter-states:        darken($twitter, 5%) !default;\n$google-plus:           #dd4b39 !default;\n$google-plus-states:    darken($google-plus, 5%) !default;\n$instagram:             #125688 !default;\n$instagram-states:      lighten($instagram, 6%) !default;\n$linkedin:              #0077B5 !default;\n$linkedin-states:       darken($linkedin, 5%) !default;\n$pinterest:             #cc2127 !default;\n$pinterest-states:      lighten($pinterest, 6%) !default;\n$youtube:               #e52d27 !default;\n$youtube-states:        lighten($youtube, 6%) !default;\n$dribbble:              #ea4c89 !default;\n$dribbble-states:       lighten($dribbble, 6%) !default;\n$github:                #333333 !default;\n$github-states:         #ccc !default;\n$reddit:                #ff4500 !default;\n$reddit-states:         lighten($reddit, 6%) !default;\n$tumblr:                #35465c !default;\n$tumblr-states:         lighten($tumblr, 6%) !default;\n$behance:               #1769ff !default;\n$behance-states:        lighten($behance, 6%) !default;\n\n$theme-colors: () !default;\n$theme-colors: map-merge((\n  \"default\":      $default,\n  \"primary\":      $primary,\n  \"secondary\":    $secondary,\n  \"success\":      $success,\n  \"info\":         $info,\n  \"warning\":      $warning,\n  \"danger\":       $danger,\n  \"white\":        $white,\n  \"neutral\":      $white,\n  \"dark\":         $dark,\n  \"darker\":       $darker\n), $theme-colors);\n\n$brand-colors: () !default;\n$brand-colors: map-merge((\n  \"facebook\":     $facebook,\n  \"twitter\":      $twitter,\n  \"google-plus\":  $google-plus,\n  \"instagram\":    $instagram,\n  \"pinterest\":    $pinterest,\n  \"youtube\":      $youtube,\n  \"dribbble\":     $dribbble,\n  \"github\":       $github,\n  \"reddit\":       $reddit,\n  \"behance\":      $behance,\n  \"tumblr\":       $tumblr,\n  \"linkedin\":     $linkedin,\n), $brand-colors);\n\n\n/*     brand Colors              */\n$brand-primary:              $primary !default;\n$brand-info:                 $info !default;\n$brand-success:              $success !default;\n$brand-warning:              $warning !default;\n$brand-danger:               $danger !default;\n$brand-inverse:              $black !default;\n\n$topbar-x:             topbar-x !default;\n$topbar-back:          topbar-back !default;\n$bottombar-x:          bottombar-x !default;\n$bottombar-back:       bottombar-back !default;\n\n// Set a specific jump point for requesting color jumps\n$theme-color-interval:      8% !default;\n\n// The yiq lightness value that determines when the lightness of color changes from \"dark\" to \"light\". Acceptable values are between 0 and 255.\n$yiq-contrasted-threshold:  200 !default;\n\n// Customize the light and dark text colors for use in our YIQ color contrast function.\n$yiq-text-dark:             $gray-900 !default;\n$yiq-text-light:            $white !default;\n\n// Action colors\n\n$star-rating-color: $gray-400 !default;\n$star-rating-color-active: $yellow !default;\n\n$favorite-color: $yellow !default;\n$like-color: $blue !default;\n$love-color: $red !default;\n\n\n// Body\n\n$body-bg: $background-black !default;\n$body-color: $gray-700 !default;\n\n\n// Sections\n\n$section-colors: () !default;\n$section-colors: map-merge((\n  \"primary\":      $body-bg,\n  \"secondary\":    $secondary,\n  \"light\":        $gray-400,\n  \"dark\":         $dark,\n  \"darker\":       $darker\n), $section-colors);\n\n// Links\n\n$link-color:                $primary !default;\n$link-decoration:           none !default;\n$link-hover-color:          darken($link-color, 15%);\n$link-hover-decoration:     none !default;\n\n// Grid breakpoints\n\n$grid-breakpoints: (\n  xs: 0,\n  sm: 576px,\n  md: 768px,\n  lg: 992px,\n  xl: 1200px\n);\n\n@include _assert-ascending($grid-breakpoints, \"$grid-breakpoints\");\n@include _assert-starts-at-zero($grid-breakpoints);\n\n\n// Grid containers\n//\n// Define the maximum width of `.container` for different screen sizes.\n\n\n// Spacing\n\n$spacer: 1rem !default;\n$spacers: () !default;\n$spacers: map-merge((\n  0: 0,\n  1: ($spacer * .25),\n  2: ($spacer * .5),\n  3: $spacer,\n  4: ($spacer * 1.5),\n  5: ($spacer * 3),\n  'sm': ($spacer * 2),\n  'md': ($spacer * 4),\n  'lg': ($spacer * 6),\n  'xl': ($spacer * 8)\n), $spacers);\n\n$padding-base-vertical:        .5rem !default;\n$padding-base-horizontal:      .7rem !default;\n\n$padding-btn-vertical:         11px !default;\n$padding-btn-horizontal:       40px !default;\n\n$padding-round-horizontal:     23px !default;\n\n$padding-lg-vertical:       15px !default;\n\n$padding-input-vertical:        11px !default;\n$padding-input-horizontal:      19px !default;\n\n\n$margin-lg-vertical:           30px !default;\n$margin-base-vertical:         15px !default;\n\n// This variable affects the `.h-*` and `.w-*` classes.\n\n$sizes: () !default;\n$sizes: map-merge((\n  25: 25%,\n  50: 50%,\n  75: 75%,\n  100: 100%\n), $sizes);\n\n// Components\n\n$shape-height-xl:              1.5 !default;\n$shape-height-lg:              1.5 !default;\n$shape-height-sm:              1.5 !default;\n\n// border\n$none:                       0   !default;\n$border-thin:                1px !default;\n$border-thick:               2px !default;\n$border-width:                .0625rem !default;\n$border-color:                $gray-200 !default;\n\n$border-radius:               .25rem !default;\n$border-radius-xl:            0.875rem !default;\n$border-radius-lg:            0.4285rem !default;\n$border-radius-sm:            0.2857rem !default;\n$border-radius-xs:            0.1428rem !default;\n\n$margin-bottom:                 10px        !default;\n$border:                        1px solid   !default;\n\n$box-shadow-sm:               0 .125rem .25rem rgba($black, .075);\n$box-shadow:                  0 15px 35px rgba(50,50,93,.1), 0 5px 15px rgba(0,0,0,.07);\n$box-shadow-lg:               0 1rem 3rem rgba($black, .175);\n\n$dropdown-shadow:          1px 2px 3px 0px rgba(0, 0, 0, 0.125);\n$box-shadow-raised:        0px 10px 25px 0px rgba(0, 0, 0, 0.3);\n$box-shadow:               0 1px 20px 0px rgba(0, 0, 0, 0.1);\n$sidebar-box-shadow:       0px 2px 22px 0 rgba(0, 0, 0,.20), 0px 2px 30px 0 rgba(0, 0, 0,.35);\n\n$component-active-color:        $white !default;\n$component-active-bg:           $primary !default;\n$component-active-border-color: $primary !default;\n\n$component-hover-color:        $gray-300 !default;\n$component-hover-bg:           $gray-300 !default;\n$component-hover-border-color: $gray-300 !default;\n\n$caret-width:                 .3em !default;\n\n$transition-base:             all .15s ease !default;\n$transition-fade:             opacity .15s linear !default;\n$transition-collapse:         height .35s ease !default;\n\n$fast-transition-time:           150ms       !default;\n\n$transition-linear:         linear           !default;\n$transition-bezier:         cubic-bezier(0.34, 1.61, 0.7, 1) !default;\n$transition-ease:           ease 0s;\n\n$select-coordinates:          50% -40px       !default;\n$general-transition-time:     300ms             !default;\n\n\n// Fonts\n\n$font-family-base:            'Poppins', sans-serif !default;\n$font-family-alt:             'Poppins', sans-serif !default;\n\n$font-size-dash:              .875rem !default;\n\n$font-size-base:              $font-size-dash !default; // Assumes the browser default, typically `16px`\n$font-size-xl:                ($font-size-base * 1.428);\n$font-size-lg:                ($font-size-base * 1.142);\n$font-size-sm:                ($font-size-base * .85714286);\n$font-size-xs:                ($font-size-base * .714);\n\n$h1-font-size:                $font-size-base * 2.35714285 !default;  //2.1875rem\n$h2-font-size:                $font-size-base * 1.9285714 !default;\n$h3-font-size:                $font-size-base * 1.642857 !default;\n$h4-font-size:                $font-size-base * 1.2142857 !default;\n$h5-font-size:                $font-size-base * 0.9285714 !default;\n$h6-font-size:                $font-size-base * 0.8571428 !default;\n\n$font-weight-light:           300 !default;\n$font-weight-normal:          400 !default;\n$font-weight-bold:            600 !default;\n$font-weight-extra-bold:      700 !default;\n\n$font-paragraph:               1rem          !default;\n\n$font-weight-base:            $font-weight-normal !default;\n$shape-height-base:            1.428571 !default;\n\n$headings-margin-bottom:      calc($spacer / 2);\n$headings-font-family:        inherit !default;\n$headings-font-weight:        $font-weight-normal !default;\n$headings-line-height:        1.2 !default;\n$headings-color:              $gray-800 !default;\n\n$heading-letter-spacing:      .025em !default;\n$heading-font-size:           .95rem !default;\n$heading-text-transform:      uppercase !default;\n$heading-font-weight:         $headings-font-weight !default;\n\n$heading-title-letter-spacing:      .025em !default;\n$heading-title-font-size:           1.375rem !default;\n$heading-title-font-weight:         $font-weight-bold !default;\n$heading-title-text-transform:      uppercase !default;\n\n$heading-section-letter-spacing:      .025em !default;\n$heading-section-font-size:           1.375rem !default;\n$heading-section-font-weight:         $font-weight-bold !default;\n$heading-section-text-transform:      uppercase !default;\n\n$display1-size:               3.3rem !default;\n$display2-size:               2.75rem !default;\n$display3-size:               2.1875rem !default;\n$display4-size:               1.6275rem !default;\n\n$display1-weight:             $font-weight-bold !default;\n$display2-weight:             $font-weight-bold !default;\n$display3-weight:             $font-weight-bold !default;\n$display4-weight:             $font-weight-bold !default;\n$display-line-height:         $headings-line-height !default;\n\n$paragraph-font-size:         0.625rem !default;\n$paragraph-font-weight:       300 !default;\n$paragraph-line-height:       1.7 !default;\n\n$lead-font-size:              ($paragraph-font-size * 1.25);\n$lead-font-weight:            300 !default;\n\n$small-font-size:             80% !default;\n\n$text-muted:                  $gray-600 !default;\n\n$blockquote-small-color:      $gray-600 !default;\n$blockquote-font-size:        ($font-size-base * 1.1);\n\n$hr-border-color:             rgba($black, .1);\n$hr-border-width:             $border-width !default;\n\n$mark-padding:                .2em !default;\n\n$dt-font-weight:              $font-weight-bold !default;\n\n$list-inline-padding:         .5rem !default;\n\n$mark-bg:                     #fcf8e3 !default;\n\n$hr-margin-y:                 $spacer * 2 !default;\n\n\n// Icons\n\n$icon-size:                 auto       !default;\n$icon-size-regular:         2.375rem      !default;\n$icon-font-size-regular:    0.9375rem     !default;\n$icon-font-size-sm:         0.6875rem      !default;\n$icon-size-sm:              1.875rem     !default;\n$icon-font-size-lg:         1.325rem     !default;\n$icon-size-lg:              3.6rem         !default;\n$icon-size-xl:              5rem !default;\n\n\n// Tables\n\n$table-cell-padding:          1rem !default;\n$table-cell-padding-sm:       .3rem !default;\n\n$table-bg:                    transparent !default;\n// $table-accent-bg:             rgba($black, .05);\n$table-hover-bg:              rgba($black, .075);\n$table-active-bg:             $table-hover-bg !default;\n\n$table-border-width:          $border-width !default;\n$table-border-color:          $gray-300 !default;\n\n$table-head-bg:               $gray-200 !default;\n$table-head-color:            $gray-700 !default;\n\n$table-dark-bg:               $gray-900 !default;\n$table-dark-accent-bg:        rgba($white, .05);\n$table-dark-hover-bg:         rgba($white, .075);\n$table-dark-border-color:     lighten($gray-900, 7.5%);\n$table-dark-color:            $body-bg !default;\n\n\n// Buttons + Forms\n\n$input-btn-padding-y:         .5rem !default;\n$input-btn-padding-x:         .7rem !default;\n$input-btn-line-height:       $shape-height-base !default;\n\n$input-btn-focus-width:       0 !default;\n$input-btn-focus-color:       rgba($component-active-bg, 1);\n//$input-btn-focus-box-shadow:  0 4px 10px 0 rgba(0, 0, 0, 0.04);\n$input-btn-focus-box-shadow:  none !default;\n\n$input-btn-padding-y-sm:      .25rem !default;\n$input-btn-padding-x-sm:      .5rem !default;\n$input-btn-line-height-sm:    1.35 !default;\n\n$input-btn-padding-y-lg:      .875rem !default;\n$input-btn-padding-x-lg:      1rem !default;\n$input-btn-line-height-lg:    1.35 !default;\n\n$input-btn-border-width:      1px !default;\n\n$input-btn-font-size-sm:      .75rem !default;\n$input-btn-font-size:         .875rem !default;\n$input-btn-font-size-lg:         .875rem !default;\n\n$input-padding-vertical:        11px !default;\n$input-padding-horizontal:      19px !default;\n\n// Buttons\n\n$btn-padding-y:               11px !default;\n$btn-padding-x:               40px !default;\n$btn-line-height:             $line-height !default;\n\n$btn-padding-y-sm:            5px !default;\n$btn-padding-x-sm:            15px !default;\n$btn-line-height-sm:          $input-btn-line-height-sm !default;\n\n$btn-padding-y-lg:            15px !default;\n$btn-padding-x-lg:            48px !default;\n$btn-line-height-lg:          $input-btn-line-height-lg !default;\n\n$btn-border-width:            $input-btn-border-width !default;\n\n$btn-font-size-lg:            1em !default;\n$btn-font-weight:             600 !default;\n$btn-text-transform:          uppercase !default;\n$btn-letter-spacing:          .025em !default;\n$btn-box-shadow:              0 4px 6px rgba(50,50,93,.11), 0 1px 3px rgba(0,0,0,.08);\n$btn-hover-box-shadow:        0 7px 14px rgba(50,50,93,.1), 0 3px 6px rgba(0,0,0,.08);\n$btn-focus-box-shadow:        $btn-hover-box-shadow !default;\n$btn-focus-width:             $input-btn-focus-width !default;\n\n\n$btn-active-box-shadow:       none !default;\n$btn-round-radius:            30px         !default;\n\n\n\n// Forms\n\n$input-padding-y:                       $input-btn-padding-y !default;\n$input-padding-x:                       $input-btn-padding-x !default;\n$input-line-height:                     $input-btn-line-height !default;\n\n$input-padding-y-sm:                    $input-btn-padding-y-sm !default;\n$input-padding-x-sm:                    $input-btn-padding-x-sm !default;\n$input-line-height-sm:                  $input-btn-line-height-sm !default;\n\n$input-padding-y-lg:                    $input-btn-padding-y-lg !default;\n$input-padding-x-lg:                    $input-btn-padding-x-lg !default;\n$input-line-height-lg:                  $input-btn-line-height-lg !default;\n\n$input-border-radius:                   $border-radius !default;\n$input-border-radius-xl:                $border-radius-xl !default;\n$input-border-radius-lg:                $border-radius-lg !default;\n$input-border-radius-sm:                $border-radius-sm !default;\n\n$input-bg:                              $transparent-bg !default;\n$input-disabled-bg:                     $gray-200 !default;\n\n$input-muted-bg:                        #EDF0F5 !default;\n\n$input-alternative-box-shadow:          0 1px 3px rgba(50,50,93,.15), 0 1px 0 rgba(0,0,0,.02);\n$input-focus-alternative-box-shadow:    0 4px 6px rgba(50,50,93,.11),0 1px 3px rgba(0,0,0,.08);\n\n$input-color:                           $opacity-8 !default;\n$input-border-color:                    #cad1d7 !default;\n$input-border-width:                    $input-btn-border-width !default;\n$input-box-shadow:                      none !default; // 0 1px 3px 0 $gray-400 !default;\n\n$input-focus-bg:                        $white !default;\n$input-focus-border-color:              rgba(50,151,211,.25);\n$input-focus-color:                     $input-color !default;\n$input-focus-width:                     0 !default;\n$input-focus-box-shadow:                none !default; //0 1px 3px 0 $gray-500 !default;\n\n$input-placeholder-color:               $gray-500 !default;\n$input-focus-placeholder-color:         $gray-500 !default;\n\n$input-height-border:                   $input-border-width * 2 !default;\n$input-height-inner:                    ($font-size-base * $input-btn-line-height) + ($input-btn-padding-y * 2) !default;\n$input-height:                          calc(#{$input-height-inner} + #{$input-height-border}) !default;\n\n$input-transition:                      all .2s cubic-bezier(0.68, -0.55, 0.265, 1.55);\n\n\n// Input groups\n\n$input-group-addon-color:               $input-placeholder-color !default;\n$input-group-addon-bg:                  $input-bg !default;\n$input-group-addon-border-color:        $input-border-color !default;\n\n$input-group-addon-focus-color:               $input-focus-color !default;\n$input-group-addon-focus-bg:                  $input-focus-bg !default;\n$input-group-addon-focus-border-color:        $input-focus-border-color !default;\n\n\n// Custom forms\n\n$custom-control-gutter:                 1.75rem !default;\n$custom-control-spacer-x:               1rem !default;\n$custom-control-indicator-size:         1.25rem !default;\n\n$custom-control-indicator-bg:                   $input-bg !default;\n$custom-control-indicator-border-width:         1px !default;\n$custom-control-indicator-border-color:         $input-border-color !default;\n$custom-control-indicator-box-shadow:           none !default;\n\n$custom-control-indicator-focus-box-shadow:     $custom-control-indicator-box-shadow !default;\n\n$custom-control-indicator-hover-color:         $component-hover-color !default;\n$custom-control-indicator-hover-bg:            $component-hover-bg !default;\n$custom-control-indicator-hover-border-color:  $component-hover-border-color !default;\n\n$custom-control-indicator-active-color:         $component-active-color !default;\n$custom-control-indicator-active-bg:            $component-active-bg !default;\n$custom-control-indicator-active-border-color:  $component-active-border-color !default;\n$custom-control-indicator-active-box-shadow:    $custom-control-indicator-box-shadow !default;\n\n$custom-control-indicator-checked-color:        $component-active-color !default;\n$custom-control-indicator-checked-bg:           $component-active-bg !default;\n$custom-control-indicator-checked-border-color: $component-active-border-color !default;\n$custom-control-indicator-checked-box-shadow:   $custom-control-indicator-box-shadow !default;\n$custom-control-indicator-checked-disabled-bg:  rgba($primary, .5);\n\n$custom-control-indicator-disabled-bg:          $gray-200 !default;\n$custom-control-label-disabled-color:           $gray-600 !default;\n\n$custom-checkbox-indicator-border-radius:       $border-radius-sm !default;\n//$custom-checkbox-indicator-icon-checked:        str-replace(url(\"data:image/svg+xml !default;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'%3E%3Cpath fill='%23fff' d='M6.564.75l-3.59 3.612-1.538-1.55L0 4.26 2.974 7.25 8 2.193z'/%3E%3C/svg%3E\"), \"#\", \"%23\") !default;\n\n$custom-toggle-slider-bg:   #ddd !default;\n$custom-toggle-checked-bg:  $primary !default;\n\n// Form validation\n\n$form-feedback-valid-bg:         lighten($success, 15%);\n$form-feedback-valid-color:      $success !default;\n$form-feedback-invalid-bg:       lighten($warning, 15%);\n$form-feedback-invalid-color:    $warning !default;\n\n\n// Allows for customizing button radius independently from global border radius\n\n$btn-border-radius:           $input-border-radius !default;\n$btn-border-radius-xl:        $input-border-radius-xl !default;\n$btn-border-radius-lg:        $input-border-radius-lg !default;\n$btn-border-radius-sm:        $input-border-radius !default;\n\n\n// No UI Slider\n\n$noui-target-bg:                  #eceeef !default;\n$noui-target-thickness:           5px !default;\n$noui-target-border-radius:       5px !default;\n$noui-target-border-color:        0 !default;\n$noui-target-box-shadow:          inset 0 1px 2px rgba(90,97,105,.1);\n\n$noui-slider-connect-bg:          $primary !default;\n$noui-slider-connect-disabled-bg: #b2b2b2 !default;\n\n$noui-handle-width:               15px !default;\n$noui-handle-bg:                  $primary !default;\n$noui-handle-border:              0 !default;\n$noui-handle-border-radius:       100% !default;\n\n$noui-origin-border-radius:       2px !default;\n\n\n// Dropdown\n\n$dropdown-bg:                       $white !default;\n$dropdown-border-width:             0 !default;\n$dropdown-border-color:             rgba($black, .15);\n$dropdown-border-radius:            $border-radius-xs !default;\n$dropdown-box-shadow:               0 50px 100px rgba(50, 50, 93, .1), 0 15px 35px rgba(50, 50, 93, .15), 0 5px 15px rgba(0, 0, 0, .1);\n\n$dropdown-link-active-color:        $component-active-color !default;\n$dropdown-link-active-bg:           $component-active-bg !default;\n\n// Navs\n\n$nav-link-padding-y:                .5rem !default;\n$nav-link-padding-x:                1rem !default;\n$nav-link-color:                    $gray-700 !default;\n$nav-link-disabled-color:           $gray-600 !default;\n\n$nav-pills-padding-y:               .75rem !default;\n$nav-pills-padding-x:               1rem !default;\n\n$nav-pills-space-x:                 1rem !default;\n\n$nav-pills-bg:                      $white;\n$nav-pills-border-width:            1px !default;\n$nav-pills-border-color:            $primary !default;\n$nav-pills-border-radius:           $border-radius !default;\n\n$nav-pills-link-color:              $primary !default;\n$nav-pills-link-hover-color:        darken($primary, 5%);\n$nav-pills-link-active-color:       color-yiq($primary);\n$nav-pills-link-active-bg:          $primary !default;\n$nav-pills-box-shadow:              $btn-box-shadow !default;\n\n// Navbar\n\n$navbar-transition:                 all .15s linear !default;\n$navbar-padding-y:                  .625rem !default;\n$navbar-padding-x:                  .9375rem !default;\n\n$navbar-nav-link-padding-x:         1rem !default;\n$navbar-nav-link-padding-y:         1rem !default;\n\n$navbar-nav-link-font-family:       $font-family-alt !default;\n$navbar-nav-link-font-size:         .9rem !default;\n$navbar-nav-link-font-weight:       400 !default;\n$navbar-nav-link-text-transform:    normal !default;\n$navbar-nav-link-letter-spacing:    0 !default;\n$navbar-nav-link-border-radius:     $border-radius !default;\n\n/* navbar color */\n$navbar-color:                      #1a1e34 !default;\n$navbar-dark-bg:                    transparent !default;\n$navbar-dark-hover-bg:              rgba(255, 255, 255, .1);\n$navbar-dark-active-bg:             rgba(255, 255, 255, .1);\n$navbar-dark-color:                 rgba($white, .95);\n$navbar-dark-hover-color:           rgba($white, .65);\n$navbar-dark-active-color:          rgba($white, .65);\n$navbar-dark-disabled-color:        rgba($white, .25);\n$navbar-dark-toggler-border-color:  transparent !default;\n\n$navbar-light-bg:                   transparent !default;\n$navbar-light-hover-bg:             rgba(0, 0, 0, .1);\n$navbar-light-active-bg:            rgba(0, 0, 0, .1);\n$navbar-light-color:                rgba($black, .5);\n$navbar-light-hover-color:          rgba($black, .7);\n$navbar-light-active-color:         rgba($black, .9);\n$navbar-light-disabled-color:       rgba($black, .3);\n$navbar-light-toggler-icon-bg:      str-replace(url(\"data:image/svg+xml !default;charset=utf8,%3Csvg viewBox='0 0 30 30' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath stroke='#{$navbar-light-color}' stroke-width='2' stroke-linecap='round' stroke-miterlimit='10' d='M4 7h22M4 15h22M4 23h22'/%3E%3C/svg%3E\"), \"#\", \"%23\") !default;\n$navbar-light-toggler-border-color: transparent !default;\n$full-width:                        100% !default;\n$navbar-padding:                    10px 15px !default;\n\n\n// Alerts\n\n$alert-padding-y: .9rem !default;\n$alert-padding-x: 1.25rem !default;\n$alert-border-radius: $border-radius-sm !default;\n\n$alert-bg-level: -2 !default;\n$alert-border-level: -2 !default;\n$alert-color-level: 0 !default;\n\n\n// List group\n\n$list-group-bg:                     $white !default;\n$list-group-border-color:           $border-color !default; //rgba($black, .125);\n$list-group-border-width:           $border-width !default;\n$list-group-border-radius:          $border-radius !default;\n\n$list-group-item-padding-y:         1rem !default;\n$list-group-item-padding-x:         1rem !default;\n\n$list-group-hover-bg:               $gray-100 !default;\n$list-group-active-color:           $component-active-color !default;\n$list-group-active-bg:              $component-active-bg !default;\n$list-group-active-border-color:    $list-group-active-bg !default;\n\n$list-group-disabled-color:         $gray-600 !default;\n$list-group-disabled-bg:            $list-group-bg !default;\n\n$list-group-action-color:           $gray-700 !default;\n$list-group-action-hover-color:     $list-group-action-color !default;\n\n$list-group-action-active-color:    $list-group-action-color !default;\n$list-group-action-active-bg:       $gray-200 !default;\n\n\n// Close\n\n$close-font-size:                   $font-size-base * 1.5 !default;\n$close-font-weight:                 $font-weight-bold !default;\n$close-bg:                          transparent !default;\n$close-hover-bg:                    transparent !default;\n$close-color:                       rgba(0, 0, 0, .6);\n$close-hover-color:                 rgba(0, 0, 0, .9);\n$close-text-shadow:                 none !default;\n\n\n// Popovers\n\n$popover-font-size:                 $font-size-sm !default;\n$popover-bg:                        $white !default;\n$popover-max-width:                 276px !default;\n$popover-border-width:              1px !default;\n$popover-border-color:              rgba($black, .05);\n$popover-border-radius:             $border-radius-lg !default;\n$popover-box-shadow:                0px .5rem 2rem 0px rgba($black, .2);\n\n$popover-header-bg:                 $popover-bg !default;\n$popover-header-color:              $headings-color !default;\n$popover-header-padding-y:          .75rem !default;\n$popover-header-padding-x:          .75rem !default;\n\n$popover-body-color:                $body-color !default;\n$popover-body-padding-y:            $popover-header-padding-y !default;\n$popover-body-padding-x:            $popover-header-padding-x !default;\n\n$popover-arrow-width:               1.5rem !default;\n$popover-arrow-height:              .75rem !default;\n$popover-arrow-color:               $popover-bg !default;\n\n$popover-arrow-outer-color:         transparent !default;\n\n// Breadcrumbs\n\n$breadcrumb-bg:                     $black-states !default;\n$breadcrumb-divider-color:          $white !default;\n$breadcrumb-active-color:           $white !default;\n\n\n\n\n// Badges\n\n$badge-font-size:                   $font-size-xs !default;\n$badge-font-weight:                 $font-weight-extra-bold !default;\n$badge-padding-y:                   .25rem !default;\n$badge-padding-x:                   .5rem !default;\n$badge-border-radius:               $border-radius !default;\n$badge-text-transfom:               uppercase;\n\n$badge-pill-padding-x:              .875em !default;\n$badge-pill-border-radius:          $border-radius-xl !default;\n\n$badge-circle-size:                 2rem;\n\n// Pagination\n\n$pagination-padding-y:                0 !default;\n$pagination-padding-x:                .6875rem !default;\n\n\n$pagination-color:                  $white !default;\n$pagination-bg:                     transparent  !default;\n$pagination-border-width:           $border-width !default;\n$pagination-border-color:           $gray-300 !default;\n\n//$pagination-focus-box-shadow:       $btn-hover-box-shadow !default;\n\n$pagination-hover-color:            $gray-600 !default;\n$pagination-hover-bg:               $gray-300 !default;\n$pagination-hover-border-color:     $gray-300 !default;\n\n$pagination-active-color:           $component-active-color !default;\n$pagination-active-bg:              $component-active-bg !default;\n$pagination-active-border-color:    $pagination-active-bg !default;\n$pagination-active-box-shadow:      $btn-hover-box-shadow !default;\n\n$pagination-disabled-color:         $gray-600 !default;\n$pagination-disabled-bg:            transparent !default;\n$pagination-disabled-border-color:  $gray-300 !default;\n\n\n// Cards\n\n$card-spacer-y:                     1.25rem !default;\n$card-spacer-x:                     1.5rem !default;\n$card-border-width:                 $border-width !default;\n$card-border-radius:                $border-radius-sm !default;\n$card-border-color:                 rgba($black, .05);\n$card-inner-border-radius:          calc(#{$card-border-radius} - #{$card-border-width});\n$card-cap-bg:                       $gray-100 !default;\n$card-bg:                           $white !default;\n$card-black-background:             #27293d !default;\n$card-img-overlay-padding:          1.25rem !default;\n\n//$card-group-margin:                 ($grid-gutter-width / 2);\n//$card-deck-margin:                  $card-group-margin !default;\n\n$card-columns-count:                3 !default;\n$card-columns-gap:                  1.25rem !default;\n$card-columns-margin:               $card-spacer-y !default;\n\n// Tooltips\n\n$tooltip-font-size:                 $font-size-sm !default;\n$tooltip-max-width:                 200px !default;\n$tooltip-color:                     $black !default;\n$tooltip-bg:                        $white !default;\n$tooltip-border-radius:             $border-radius !default;\n$tooltip-opacity:                   .9 !default;\n$tooltip-padding-y:                 .25rem !default;\n$tooltip-padding-x:                 .5rem !default;\n$tooltip-margin:                    0 !default;\n\n$tooltip-arrow-width:               .8rem !default;\n$tooltip-arrow-height:              .4rem !default;\n$tooltip-arrow-color:               $tooltip-bg !default;\n\n// Modals\n\n$modal-inner-padding:               24px 24px 16px 24px !default;\n\n$modal-lg:                          800px !default;\n$modal-md:                          500px !default;\n$modal-sm:                          380px !default;\n$modal-title-line-height:           1.1;\n$modal-content-bg:               $white !default;\n$modal-content-border-color:     rgba($black, .2);\n$modal-content-border-width:     1px !default;\n$modal-content-border-radius:    $border-radius-sm !default;\n$modal-content-box-shadow-xs:    0px 10px 50px 0px rgba(0, 0, 0, 0.5);\n$modal-content-box-shadow-sm-up: 0 15px 35px rgba(50,50,93,.2), 0 5px 15px rgba(0,0,0,.17);\n\n$modal-backdrop-bg:           $black !default;\n$modal-backdrop-opacity:      .16 !default;\n$modal-header-border-color:   $gray-200 !default;\n$modal-footer-border-color:   $modal-header-border-color !default;\n$modal-header-border-width:   $modal-content-border-width !default;\n$modal-footer-border-width:   $modal-header-border-width !default;\n$modal-header-padding:        24px 24px 0 24px !default;\n\n// Progress bars\n\n$progress-height:                   .5rem !default;\n$progress-bg:                       rgba(0, 0, 0, 0.3) !default;\n$progress-border-radius:            $border-radius-xl !default;\n$progress-box-shadow:               0px 0px 0px 3px rgba(0, 0, 0, 0.3) !default;\n$progress-bar-color:                $white !default;\n\n// Datepicker\n\n$datepicker-border-radius: $card-border-radius !default;\n$datepicker-dropdown-padding: 20px 22px !default;\n\n$datepicker-cell-transition: $transition-base !default;\n$datepicker-cell-hover-background: lighten($gray-400, 55%);\n$datepicker-cell-border-radius: 50% !default;\n$datepicker-cell-width: 36px !default;\n$datepicker-cell-height: 36px !default;\n\n$datepicker-disabled-cell-color: $gray-300 !default;\n$datepicker-disabled-old-new-color: $gray-500 !default;\n\n$datepicker-header-cell-border-radius: $border-radius !default;\n\n$datepicker-active-color: $white !default;\n$datepicker-active-background: $primary !default;\n$datepicker-active-box-shadow:      none !default;\n\n$datepicker-range-background: $primary !default;\n$datepicker-range-cell-focused-background: darken($datepicker-range-background, 5%);\n$datepicker-range-color: $white !default;\n$datepicker-range-highlighted-bg: $gray-200 !default;\n\n$datepicker-dropdown-border: lighten($gray-400, 40%);\n$datepicker-dropdown-bg: $white !default;\n$datepicker-highlighted-bg: $datepicker-active-background !default;\n\n\n// Footer\n\n$footer-link-font-size: .85rem !default;\n$footer-bg: $secondary !default;\n$footer-color: $gray-600 !default;\n$footer-link-color: $gray-600 !default;\n$footer-link-hover-color: $gray-700 !default;\n$footer-heading-color: $gray-600 !default;\n$footer-heading-font-size: $font-size-sm !default;\n",":root {\n  // Custom variable values only support SassScript inside `#{}`.\n  @each $color, $value in $colors {\n    --#{$variable-prefix}#{$color}: #{$value};\n  }\n\n  @each $color, $value in $theme-colors {\n    --#{$variable-prefix}#{$color}: #{$value};\n  }\n\n  // Use `inspect` for lists so that quoted items keep the quotes.\n  // See https://github.com/sass/sass/issues/2383#issuecomment-336349172\n  --#{$variable-prefix}font-sans-serif: #{inspect($font-family-sans-serif)};\n  --#{$variable-prefix}font-monospace: #{inspect($font-family-monospace)};\n  --#{$variable-prefix}gradient: #{$gradient};\n}\n","// stylelint-disable declaration-no-important, selector-no-qualifying-type, property-no-vendor-prefix\n\n\n// Reboot\n//\n// Normalization of HTML elements, manually forked from Normalize.css to remove\n// styles targeting irrelevant browsers while applying new styles.\n//\n// Normalize is licensed MIT. https://github.com/necolas/normalize.css\n\n\n// Document\n//\n// Change from `box-sizing: content-box` so that `width` is not affected by `padding` or `border`.\n\n*,\n*::before,\n*::after {\n  box-sizing: border-box;\n}\n\n\n// Root\n//\n// Ability to the value of the root font sizes, affecting the value of `rem`.\n// null by default, thus nothing is generated.\n\n:root {\n  font-size: $font-size-root;\n\n  @if $enable-smooth-scroll {\n    @media (prefers-reduced-motion: no-preference) {\n      scroll-behavior: smooth;\n    }\n  }\n}\n\n\n// Body\n//\n// 1. Remove the margin in all browsers.\n// 2. As a best practice, apply a default `background-color`.\n// 3. Prevent adjustments of font size after orientation changes in iOS.\n// 4. Change the default tap highlight to be completely transparent in iOS.\n\nbody {\n  margin: 0; // 1\n  font-family: $font-family-base;\n  @include font-size($font-size-base);\n  font-weight: $font-weight-base;\n  line-height: $line-height-base;\n  color: $body-color;\n  text-align: $body-text-align;\n  background-color: $body-bg; // 2\n  -webkit-text-size-adjust: 100%; // 3\n  -webkit-tap-highlight-color: rgba($black, 0); // 4\n}\n\n\n// Content grouping\n//\n// 1. Reset Firefox's gray color\n// 2. Set correct height and prevent the `size` attribute to make the `hr` look like an input field\n\nhr {\n  margin: $hr-margin-y 0;\n  color: $hr-color; // 1\n  background-color: currentColor;\n  border: 0;\n  opacity: $hr-opacity;\n}\n\nhr:not([size]) {\n  height: $hr-height; // 2\n}\n\n\n// Typography\n//\n// 1. Remove top margins from headings\n//    By default, `<h1>`-`<h6>` all receive top and bottom margins. We nuke the top\n//    margin for easier control within type scales as it avoids margin collapsing.\n\n%heading {\n  margin-top: 0; // 1\n  margin-bottom: $headings-margin-bottom;\n  font-family: $headings-font-family;\n  font-style: $headings-font-style;\n  font-weight: $headings-font-weight;\n  line-height: $headings-line-height;\n  color: $headings-color;\n}\n\nh1 {\n  @extend %heading;\n  @include font-size($h1-font-size);\n}\n\nh2 {\n  @extend %heading;\n  @include font-size($h2-font-size);\n}\n\nh3 {\n  @extend %heading;\n  @include font-size($h3-font-size);\n}\n\nh4 {\n  @extend %heading;\n  @include font-size($h4-font-size);\n}\n\nh5 {\n  @extend %heading;\n  @include font-size($h5-font-size);\n}\n\nh6 {\n  @extend %heading;\n  @include font-size($h6-font-size);\n}\n\n\n// Reset margins on paragraphs\n//\n// Similarly, the top margin on `<p>`s get reset. However, we also reset the\n// bottom margin to use `rem` units instead of `em`.\n\np {\n  margin-top: 0;\n  margin-bottom: $paragraph-margin-bottom;\n}\n\n\n// Abbreviations\n//\n// 1. Duplicate behavior to the data-bs-* attribute for our tooltip plugin\n// 2. Add the correct text decoration in Chrome, Edge, Opera, and Safari.\n// 3. Add explicit cursor to indicate changed behavior.\n// 4. Prevent the text-decoration to be skipped.\n\nabbr[title],\nabbr[data-bs-original-title] { // 1\n  text-decoration: underline dotted; // 2\n  cursor: help; // 3\n  text-decoration-skip-ink: none; // 4\n}\n\n\n// Address\n\naddress {\n  margin-bottom: 1rem;\n  font-style: normal;\n  line-height: inherit;\n}\n\n\n// Lists\n\nol,\nul {\n  padding-left: 2rem;\n}\n\nol,\nul,\ndl {\n  margin-top: 0;\n  margin-bottom: 1rem;\n}\n\nol ol,\nul ul,\nol ul,\nul ol {\n  margin-bottom: 0;\n}\n\ndt {\n  font-weight: $dt-font-weight;\n}\n\n// 1. Undo browser default\n\ndd {\n  margin-bottom: .5rem;\n  margin-left: 0; // 1\n}\n\n\n// Blockquote\n\nblockquote {\n  margin: 0 0 1rem;\n}\n\n\n// Strong\n//\n// Add the correct font weight in Chrome, Edge, and Safari\n\nb,\nstrong {\n  font-weight: $font-weight-bolder;\n}\n\n\n// Small\n//\n// Add the correct font size in all browsers\n\nsmall {\n  @include font-size($small-font-size);\n}\n\n\n// Mark\n\nmark {\n  padding: $mark-padding;\n  background-color: $mark-bg;\n}\n\n\n// Sub and Sup\n//\n// Prevent `sub` and `sup` elements from affecting the line height in\n// all browsers.\n\nsub,\nsup {\n  position: relative;\n  @include font-size($sub-sup-font-size);\n  line-height: 0;\n  vertical-align: baseline;\n}\n\nsub { bottom: -.25em; }\nsup { top: -.5em; }\n\n\n// Links\n\na {\n  color: $link-color;\n  text-decoration: $link-decoration;\n\n  &:hover {\n    color: $link-hover-color;\n    text-decoration: $link-hover-decoration;\n  }\n}\n\n// And undo these styles for placeholder links/named anchors (without href).\n// It would be more straightforward to just use a[href] in previous block, but that\n// causes specificity issues in many other styles that are too complex to fix.\n// See https://github.com/twbs/bootstrap/issues/19402\n\na:not([href]):not([class]) {\n  &,\n  &:hover {\n    color: inherit;\n    text-decoration: none;\n  }\n}\n\n\n// Code\n\npre,\ncode,\nkbd,\nsamp {\n  font-family: $font-family-code;\n  @include font-size(1em); // Correct the odd `em` font sizing in all browsers.\n  direction: ltr #{\"/* rtl:ignore */\"};\n  unicode-bidi: bidi-override;\n}\n\n// 1. Remove browser default top margin\n// 2. Reset browser default of `1em` to use `rem`s\n// 3. Don't allow content to break outside\n\npre {\n  display: block;\n  margin-top: 0; // 1\n  margin-bottom: 1rem; // 2\n  overflow: auto; // 3\n  @include font-size($code-font-size);\n  color: $pre-color;\n\n  // Account for some code outputs that place code tags in pre tags\n  code {\n    @include font-size(inherit);\n    color: inherit;\n    word-break: normal;\n  }\n}\n\ncode {\n  @include font-size($code-font-size);\n  color: $code-color;\n  word-wrap: break-word;\n\n  // Streamline the style when inside anchors to avoid broken underline and more\n  a > & {\n    color: inherit;\n  }\n}\n\nkbd {\n  padding: $kbd-padding-y $kbd-padding-x;\n  @include font-size($kbd-font-size);\n  color: $kbd-color;\n  background-color: $kbd-bg;\n  @include border-radius($border-radius-sm);\n\n  kbd {\n    padding: 0;\n    @include font-size(1em);\n    font-weight: $nested-kbd-font-weight;\n  }\n}\n\n\n// Figures\n//\n// Apply a consistent margin strategy (matches our type styles).\n\nfigure {\n  margin: 0 0 1rem;\n}\n\n\n// Images and content\n\nimg,\nsvg {\n  vertical-align: middle;\n}\n\n\n// Tables\n//\n// Prevent double borders\n\ntable {\n  caption-side: bottom;\n  border-collapse: collapse;\n}\n\ncaption {\n  padding-top: $table-cell-padding-y;\n  padding-bottom: $table-cell-padding-y;\n  color: $table-caption-color;\n  text-align: left;\n}\n\n// 1. Removes font-weight bold by inheriting\n// 2. Matches default `<td>` alignment by inheriting `text-align`.\n// 3. Fix alignment for Safari\n\nth {\n  font-weight: $table-th-font-weight; // 1\n  text-align: inherit; // 2\n  text-align: -webkit-match-parent; // 3\n}\n\nthead,\ntbody,\ntfoot,\ntr,\ntd,\nth {\n  border-color: inherit;\n  border-style: solid;\n  border-width: 0;\n}\n\n\n// Forms\n//\n// 1. Allow labels to use `margin` for spacing.\n\nlabel {\n  display: inline-block; // 1\n}\n\n// Remove the default `border-radius` that macOS Chrome adds.\n// See https://github.com/twbs/bootstrap/issues/24093\n\nbutton {\n  // stylelint-disable-next-line property-disallowed-list\n  border-radius: 0;\n}\n\n// Explicitly remove focus outline in Chromium when it shouldn't be\n// visible (e.g. as result of mouse click or touch tap). It already\n// should be doing this automatically, but seems to currently be\n// confused and applies its very visible two-tone outline anyway.\n\nbutton:focus:not(:focus-visible) {\n  outline: 0;\n}\n\n// 1. Remove the margin in Firefox and Safari\n\ninput,\nbutton,\nselect,\noptgroup,\ntextarea {\n  margin: 0; // 1\n  font-family: inherit;\n  @include font-size(inherit);\n  line-height: inherit;\n}\n\n// Remove the inheritance of text transform in Firefox\nbutton,\nselect {\n  text-transform: none;\n}\n// Set the cursor for non-`<button>` buttons\n//\n// Details at https://github.com/twbs/bootstrap/pull/30562\n[role=\"button\"] {\n  cursor: pointer;\n}\n\nselect {\n  // Remove the inheritance of word-wrap in Safari.\n  // See https://github.com/twbs/bootstrap/issues/24990\n  word-wrap: normal;\n\n  // Undo the opacity change from Chrome\n  &:disabled {\n    opacity: 1;\n  }\n}\n\n// Remove the dropdown arrow in Chrome from inputs built with datalists.\n// See https://stackoverflow.com/a/54997118\n\n[list]::-webkit-calendar-picker-indicator {\n  display: none;\n}\n\n// 1. Prevent a WebKit bug where (2) destroys native `audio` and `video`\n//    controls in Android 4.\n// 2. Correct the inability to style clickable types in iOS and Safari.\n// 3. Opinionated: add \"hand\" cursor to non-disabled button elements.\n\nbutton,\n[type=\"button\"], // 1\n[type=\"reset\"],\n[type=\"submit\"] {\n  -webkit-appearance: button; // 2\n\n  @if $enable-button-pointers {\n    &:not(:disabled) {\n      cursor: pointer; // 3\n    }\n  }\n}\n\n// Remove inner border and padding from Firefox, but don't restore the outline like Normalize.\n\n::-moz-focus-inner {\n  padding: 0;\n  border-style: none;\n}\n\n// 1. Textareas should really only resize vertically so they don't break their (horizontal) containers.\n\ntextarea {\n  resize: vertical; // 1\n}\n\n// 1. Browsers set a default `min-width: min-content;` on fieldsets,\n//    unlike e.g. `<div>`s, which have `min-width: 0;` by default.\n//    So we reset that to ensure fieldsets behave more like a standard block element.\n//    See https://github.com/twbs/bootstrap/issues/12359\n//    and https://html.spec.whatwg.org/multipage/#the-fieldset-and-legend-elements\n// 2. Reset the default outline behavior of fieldsets so they don't affect page layout.\n\nfieldset {\n  min-width: 0; // 1\n  padding: 0; // 2\n  margin: 0; // 2\n  border: 0; // 2\n}\n\n// 1. By using `float: left`, the legend will behave like a block element.\n//    This way the border of a fieldset wraps around the legend if present.\n// 2. Fix wrapping bug.\n//    See https://github.com/twbs/bootstrap/issues/29712\n\nlegend {\n  float: left; // 1\n  width: 100%;\n  padding: 0;\n  margin-bottom: $legend-margin-bottom;\n  @include font-size($legend-font-size);\n  font-weight: $legend-font-weight;\n  line-height: inherit;\n\n  + * {\n    clear: left; // 2\n  }\n}\n\n// Fix height of inputs with a type of datetime-local, date, month, week, or time\n// See https://github.com/twbs/bootstrap/issues/18842\n\n::-webkit-datetime-edit-fields-wrapper,\n::-webkit-datetime-edit-text,\n::-webkit-datetime-edit-minute,\n::-webkit-datetime-edit-hour-field,\n::-webkit-datetime-edit-day-field,\n::-webkit-datetime-edit-month-field,\n::-webkit-datetime-edit-year-field {\n  padding: 0;\n}\n\n::-webkit-inner-spin-button {\n  height: auto;\n}\n\n// 1. Correct the outline style in Safari.\n// 2. This overrides the extra rounded corners on search inputs in iOS so that our\n//    `.form-control` class can properly style them. Note that this cannot simply\n//    be added to `.form-control` as it's not specific enough. For details, see\n//    https://github.com/twbs/bootstrap/issues/11586.\n\n[type=\"search\"] {\n  outline-offset: -2px; // 1\n  -webkit-appearance: textfield; // 2\n}\n\n// 1. A few input types should stay LTR\n// See https://rtlstyling.com/posts/rtl-styling#form-inputs\n// 2. RTL only output\n// See https://rtlcss.com/learn/usage-guide/control-directives/#raw\n\n/* rtl:raw:\n[type=\"tel\"],\n[type=\"url\"],\n[type=\"email\"],\n[type=\"number\"] {\n  direction: ltr;\n}\n*/\n\n// Remove the inner padding in Chrome and Safari on macOS.\n\n::-webkit-search-decoration {\n  -webkit-appearance: none;\n}\n\n// Remove padding around color pickers in webkit browsers\n\n::-webkit-color-swatch-wrapper {\n  padding: 0;\n}\n\n\n// Inherit font family and line height for file input buttons\n\n::file-selector-button {\n  font: inherit;\n}\n\n// 1. Change font properties to `inherit`\n// 2. Correct the inability to style clickable types in iOS and Safari.\n\n::-webkit-file-upload-button {\n  font: inherit; // 1\n  -webkit-appearance: button; // 2\n}\n\n// Correct element displays\n\noutput {\n  display: inline-block;\n}\n\n// Remove border from iframe\n\niframe {\n  border: 0;\n}\n\n// Summary\n//\n// 1. Add the correct display in all browsers\n\nsummary {\n  display: list-item; // 1\n  cursor: pointer;\n}\n\n\n// Progress\n//\n// Add the correct vertical alignment in Chrome, Firefox, and Opera.\n\nprogress {\n  vertical-align: baseline;\n}\n\n\n// Hidden attribute\n//\n// Always hide an element with the `hidden` HTML attribute.\n\n[hidden] {\n  display: none !important;\n}\n","// stylelint-disable property-blacklist, scss/dollar-variable-default\n\n// SCSS RFS mixin\n//\n// Automated responsive values for font sizes, paddings, margins and much more\n//\n// Licensed under MIT (https://github.com/twbs/rfs/blob/main/LICENSE)\n\n// Configuration\n\n// Base value\n$rfs-base-value: 1.25rem !default;\n$rfs-unit: rem !default;\n\n@if $rfs-unit != rem and $rfs-unit != px {\n  @error \"`#{$rfs-unit}` is not a valid unit for $rfs-unit. Use `px` or `rem`.\";\n}\n\n// Breakpoint at where values start decreasing if screen width is smaller\n$rfs-breakpoint: 1200px !default;\n$rfs-breakpoint-unit: px !default;\n\n@if $rfs-breakpoint-unit != px and $rfs-breakpoint-unit != em and $rfs-breakpoint-unit != rem {\n  @error \"`#{$rfs-breakpoint-unit}` is not a valid unit for $rfs-breakpoint-unit. Use `px`, `em` or `rem`.\";\n}\n\n// Resize values based on screen height and width\n$rfs-two-dimensional: false !default;\n\n// Factor of decrease\n$rfs-factor: 10 !default;\n\n@if type-of($rfs-factor) != number or $rfs-factor <= 1 {\n  @error \"`#{$rfs-factor}` is not a valid  $rfs-factor, it must be greater than 1.\";\n}\n\n// Mode. Possibilities: \"min-media-query\", \"max-media-query\"\n$rfs-mode: min-media-query !default;\n\n// Generate enable or disable classes. Possibilities: false, \"enable\" or \"disable\"\n$rfs-class: false !default;\n\n// 1 rem = $rfs-rem-value px\n$rfs-rem-value: 16 !default;\n\n// Safari iframe resize bug: https://github.com/twbs/rfs/issues/14\n$rfs-safari-iframe-resize-bug-fix: false !default;\n\n// Disable RFS by setting $enable-rfs to false\n$enable-rfs: true !default;\n\n// Cache $rfs-base-value unit\n$rfs-base-value-unit: unit($rfs-base-value);\n\n@function divide($dividend, $divisor, $precision: 10) {\n  $sign: if($dividend > 0 and $divisor > 0 or $dividend < 0 and $divisor < 0, 1, -1);\n  $dividend: abs($dividend);\n  $divisor: abs($divisor);\n  @if $dividend == 0 {\n    @return 0;\n  }\n  @if $divisor == 0 {\n    @error \"Cannot divide by 0\";\n  }\n  $remainder: $dividend;\n  $result: 0;\n  $factor: 10;\n  @while ($remainder > 0 and $precision >= 0) {\n    $quotient: 0;\n    @while ($remainder >= $divisor) {\n      $remainder: $remainder - $divisor;\n      $quotient: $quotient + 1;\n    }\n    $result: $result * 10 + $quotient;\n    $factor: $factor * .1;\n    $remainder: $remainder * 10;\n    $precision: $precision - 1;\n    @if ($precision < 0 and $remainder >= $divisor * 5) {\n      $result: $result + 1;\n    }\n  }\n  $result: $result * $factor * $sign;\n  $dividend-unit: unit($dividend);\n  $divisor-unit: unit($divisor);\n  $unit-map: (\n    \"px\": 1px,\n    \"rem\": 1rem,\n    \"em\": 1em,\n    \"%\": 1%\n  );\n  @if ($dividend-unit != $divisor-unit and map-has-key($unit-map, $dividend-unit)) {\n    $result: $result * map-get($unit-map, $dividend-unit);\n  }\n  @return $result;\n}\n\n// Remove px-unit from $rfs-base-value for calculations\n@if $rfs-base-value-unit == px {\n  $rfs-base-value: divide($rfs-base-value, $rfs-base-value * 0 + 1);\n}\n@else if $rfs-base-value-unit == rem {\n  $rfs-base-value: divide($rfs-base-value, divide($rfs-base-value * 0 + 1, $rfs-rem-value));\n}\n\n// Cache $rfs-breakpoint unit to prevent multiple calls\n$rfs-breakpoint-unit-cache: unit($rfs-breakpoint);\n\n// Remove unit from $rfs-breakpoint for calculations\n@if $rfs-breakpoint-unit-cache == px {\n  $rfs-breakpoint: divide($rfs-breakpoint, $rfs-breakpoint * 0 + 1);\n}\n@else if $rfs-breakpoint-unit-cache == rem or $rfs-breakpoint-unit-cache == \"em\" {\n  $rfs-breakpoint: divide($rfs-breakpoint, divide($rfs-breakpoint * 0 + 1, $rfs-rem-value));\n}\n\n// Calculate the media query value\n$rfs-mq-value: if($rfs-breakpoint-unit == px, #{$rfs-breakpoint}px, #{divide($rfs-breakpoint, $rfs-rem-value)}#{$rfs-breakpoint-unit});\n$rfs-mq-property-width: if($rfs-mode == max-media-query, max-width, min-width);\n$rfs-mq-property-height: if($rfs-mode == max-media-query, max-height, min-height);\n\n// Internal mixin used to determine which media query needs to be used\n@mixin _rfs-media-query {\n  @if $rfs-two-dimensional {\n    @if $rfs-mode == max-media-query {\n      @media (#{$rfs-mq-property-width}: #{$rfs-mq-value}), (#{$rfs-mq-property-height}: #{$rfs-mq-value}) {\n        @content;\n      }\n    }\n    @else {\n      @media (#{$rfs-mq-property-width}: #{$rfs-mq-value}) and (#{$rfs-mq-property-height}: #{$rfs-mq-value}) {\n        @content;\n      }\n    }\n  }\n  @else {\n    @media (#{$rfs-mq-property-width}: #{$rfs-mq-value}) {\n      @content;\n    }\n  }\n}\n\n// Internal mixin that adds disable classes to the selector if needed.\n@mixin _rfs-rule {\n  @if $rfs-class == disable and $rfs-mode == max-media-query {\n    // Adding an extra class increases specificity, which prevents the media query to override the property\n    &,\n    .disable-rfs &,\n    &.disable-rfs {\n      @content;\n    }\n  }\n  @else if $rfs-class == enable and $rfs-mode == min-media-query {\n    .enable-rfs &,\n    &.enable-rfs {\n      @content;\n    }\n  }\n  @else {\n    @content;\n  }\n}\n\n// Internal mixin that adds enable classes to the selector if needed.\n@mixin _rfs-media-query-rule {\n\n  @if $rfs-class == enable {\n    @if $rfs-mode == min-media-query {\n      @content;\n    }\n\n    @include _rfs-media-query {\n      .enable-rfs &,\n      &.enable-rfs {\n        @content;\n      }\n    }\n  }\n  @else {\n    @if $rfs-class == disable and $rfs-mode == min-media-query {\n      .disable-rfs &,\n      &.disable-rfs {\n        @content;\n      }\n    }\n    @include _rfs-media-query {\n      @content;\n    }\n  }\n}\n\n// Helper function to get the formatted non-responsive value\n@function rfs-value($values) {\n  // Convert to list\n  $values: if(type-of($values) != list, ($values,), $values);\n\n  $val: '';\n\n  // Loop over each value and calculate value\n  @each $value in $values {\n    @if $value == 0 {\n      $val: $val + ' 0';\n    }\n    @else {\n      // Cache $value unit\n      $unit: if(type-of($value) == \"number\", unit($value), false);\n\n      @if $unit == px {\n        // Convert to rem if needed\n        $val: $val + ' ' + if($rfs-unit == rem, #{divide($value, $value * 0 + $rfs-rem-value)}rem, $value);\n      }\n      @else if $unit == rem {\n        // Convert to px if needed\n        $val: $val + ' ' + if($rfs-unit == px, #{divide($value, $value * 0 + 1) * $rfs-rem-value}px, $value);\n      }\n      @else {\n        // If $value isn't a number (like inherit) or $value has a unit (not px or rem, like 1.5em) or $ is 0, just print the value\n        $val: $val + ' ' + $value;\n      }\n    }\n  }\n\n  // Remove first space\n  @return unquote(str-slice($val, 2));\n}\n\n// Helper function to get the responsive value calculated by RFS\n@function rfs-fluid-value($values) {\n  // Convert to list\n  $values: if(type-of($values) != list, ($values,), $values);\n\n  $val: '';\n\n  // Loop over each value and calculate value\n  @each $value in $values {\n    @if $value == 0 {\n      $val: $val + ' 0';\n    }\n\n    @else {\n      // Cache $value unit\n      $unit: if(type-of($value) == \"number\", unit($value), false);\n\n      // If $value isn't a number (like inherit) or $value has a unit (not px or rem, like 1.5em) or $ is 0, just print the value\n      @if not $unit or $unit != px and $unit != rem {\n        $val: $val + ' ' + $value;\n      }\n\n      @else {\n        // Remove unit from $value for calculations\n        $value: divide($value, $value * 0 + if($unit == px, 1, divide(1, $rfs-rem-value)));\n\n        // Only add the media query if the value is greater than the minimum value\n        @if abs($value) <= $rfs-base-value or not $enable-rfs {\n          $val: $val + ' ' +  if($rfs-unit == rem, #{divide($value, $rfs-rem-value)}rem, #{$value}px);\n        }\n        @else {\n          // Calculate the minimum value\n          $value-min: $rfs-base-value + divide(abs($value) - $rfs-base-value, $rfs-factor);\n\n          // Calculate difference between $value and the minimum value\n          $value-diff: abs($value) - $value-min;\n\n          // Base value formatting\n          $min-width: if($rfs-unit == rem, #{divide($value-min, $rfs-rem-value)}rem, #{$value-min}px);\n\n          // Use negative value if needed\n          $min-width: if($value < 0, -$min-width, $min-width);\n\n          // Use `vmin` if two-dimensional is enabled\n          $variable-unit: if($rfs-two-dimensional, vmin, vw);\n\n          // Calculate the variable width between 0 and $rfs-breakpoint\n          $variable-width: #{divide($value-diff * 100, $rfs-breakpoint)}#{$variable-unit};\n\n          // Return the calculated value\n          $val: $val + ' calc(' + $min-width + if($value < 0, ' - ', ' + ') + $variable-width + ')';\n        }\n      }\n    }\n  }\n\n  // Remove first space\n  @return unquote(str-slice($val, 2));\n}\n\n// RFS mixin\n@mixin rfs($values, $property: font-size) {\n  @if $values != null {\n    $val: rfs-value($values);\n    $fluidVal: rfs-fluid-value($values);\n\n    // Do not print the media query if responsive & non-responsive values are the same\n    @if $val == $fluidVal {\n      #{$property}: $val;\n    }\n    @else {\n      @include _rfs-rule {\n        #{$property}: if($rfs-mode == max-media-query, $val, $fluidVal);\n\n        // Include safari iframe resize fix if needed\n        min-width: if($rfs-safari-iframe-resize-bug-fix, (0 * 1vw), null);\n      }\n\n      @include _rfs-media-query-rule {\n        #{$property}: if($rfs-mode == max-media-query, $fluidVal, $val);\n      }\n    }\n  }\n}\n\n// Shorthand helper mixins\n@mixin font-size($value) {\n  @include rfs($value);\n}\n\n@mixin padding($value) {\n  @include rfs($value, padding);\n}\n\n@mixin padding-top($value) {\n  @include rfs($value, padding-top);\n}\n\n@mixin padding-right($value) {\n  @include rfs($value, padding-right);\n}\n\n@mixin padding-bottom($value) {\n  @include rfs($value, padding-bottom);\n}\n\n@mixin padding-left($value) {\n  @include rfs($value, padding-left);\n}\n\n@mixin margin($value) {\n  @include rfs($value, margin);\n}\n\n@mixin margin-top($value) {\n  @include rfs($value, margin-top);\n}\n\n@mixin margin-right($value) {\n  @include rfs($value, margin-right);\n}\n\n@mixin margin-bottom($value) {\n  @include rfs($value, margin-bottom);\n}\n\n@mixin margin-left($value) {\n  @include rfs($value, margin-left);\n}\n","// Variables\n//\n// Variables should follow the `$component-state-property-size` formula for\n// consistent naming. Ex: $nav-link-disabled-color and $modal-content-box-shadow-xs.\n\n// Color system\n\n// scss-docs-start gray-color-variables\n$white:    #fff !default;\n$gray-100: #f8f9fa !default;\n$gray-200: #e9ecef !default;\n$gray-300: #dee2e6 !default;\n$gray-400: #ced4da !default;\n$gray-500: #adb5bd !default;\n$gray-600: #6c757d !default;\n$gray-700: #495057 !default;\n$gray-800: #343a40 !default;\n$gray-900: #212529 !default;\n$black:    #000 !default;\n// scss-docs-end gray-color-variables\n\n// fusv-disable\n// scss-docs-start gray-colors-map\n$grays: (\n  \"100\": $gray-100,\n  \"200\": $gray-200,\n  \"300\": $gray-300,\n  \"400\": $gray-400,\n  \"500\": $gray-500,\n  \"600\": $gray-600,\n  \"700\": $gray-700,\n  \"800\": $gray-800,\n  \"900\": $gray-900\n) !default;\n// scss-docs-end gray-colors-map\n// fusv-enable\n\n// scss-docs-start color-variables\n$blue:    #0d6efd !default;\n$indigo:  #6610f2 !default;\n$purple:  #6f42c1 !default;\n$pink:    #d63384 !default;\n$red:     #dc3545 !default;\n$orange:  #fd7e14 !default;\n$yellow:  #ffc107 !default;\n$green:   #198754 !default;\n$teal:    #20c997 !default;\n$cyan:    #0dcaf0 !default;\n// scss-docs-end color-variables\n\n// scss-docs-start colors-map\n$colors: (\n  \"blue\":       $blue,\n  \"indigo\":     $indigo,\n  \"purple\":     $purple,\n  \"pink\":       $pink,\n  \"red\":        $red,\n  \"orange\":     $orange,\n  \"yellow\":     $yellow,\n  \"green\":      $green,\n  \"teal\":       $teal,\n  \"cyan\":       $cyan,\n  \"white\":      $white,\n  \"gray\":       $gray-600,\n  \"gray-dark\":  $gray-800\n) !default;\n// scss-docs-end colors-map\n\n// scss-docs-start theme-color-variables\n$primary:       $blue !default;\n$secondary:     $gray-600 !default;\n$success:       $green !default;\n$info:          $cyan !default;\n$warning:       $yellow !default;\n$danger:        $red !default;\n$light:         $gray-100 !default;\n$dark:          $gray-900 !default;\n// scss-docs-end theme-color-variables\n\n// scss-docs-start theme-colors-map\n$theme-colors: (\n  \"primary\":    $primary,\n  \"secondary\":  $secondary,\n  \"success\":    $success,\n  \"info\":       $info,\n  \"warning\":    $warning,\n  \"danger\":     $danger,\n  \"light\":      $light,\n  \"dark\":       $dark\n) !default;\n// scss-docs-end theme-colors-map\n\n// The contrast ratio to reach against white, to determine if color changes from \"light\" to \"dark\". Acceptable values for WCAG 2.0 are 3, 4.5 and 7.\n// See https://www.w3.org/TR/WCAG20/#visual-audio-contrast-contrast\n$min-contrast-ratio:   4.5 !default;\n\n// Customize the light and dark text colors for use in our color contrast function.\n$color-contrast-dark:      $black !default;\n$color-contrast-light:     $white !default;\n\n// fusv-disable\n$blue-100: tint-color($blue, 80%) !default;\n$blue-200: tint-color($blue, 60%) !default;\n$blue-300: tint-color($blue, 40%) !default;\n$blue-400: tint-color($blue, 20%) !default;\n$blue-500: $blue !default;\n$blue-600: shade-color($blue, 20%) !default;\n$blue-700: shade-color($blue, 40%) !default;\n$blue-800: shade-color($blue, 60%) !default;\n$blue-900: shade-color($blue, 80%) !default;\n\n$indigo-100: tint-color($indigo, 80%) !default;\n$indigo-200: tint-color($indigo, 60%) !default;\n$indigo-300: tint-color($indigo, 40%) !default;\n$indigo-400: tint-color($indigo, 20%) !default;\n$indigo-500: $indigo !default;\n$indigo-600: shade-color($indigo, 20%) !default;\n$indigo-700: shade-color($indigo, 40%) !default;\n$indigo-800: shade-color($indigo, 60%) !default;\n$indigo-900: shade-color($indigo, 80%) !default;\n\n$purple-100: tint-color($purple, 80%) !default;\n$purple-200: tint-color($purple, 60%) !default;\n$purple-300: tint-color($purple, 40%) !default;\n$purple-400: tint-color($purple, 20%) !default;\n$purple-500: $purple !default;\n$purple-600: shade-color($purple, 20%) !default;\n$purple-700: shade-color($purple, 40%) !default;\n$purple-800: shade-color($purple, 60%) !default;\n$purple-900: shade-color($purple, 80%) !default;\n\n$pink-100: tint-color($pink, 80%) !default;\n$pink-200: tint-color($pink, 60%) !default;\n$pink-300: tint-color($pink, 40%) !default;\n$pink-400: tint-color($pink, 20%) !default;\n$pink-500: $pink !default;\n$pink-600: shade-color($pink, 20%) !default;\n$pink-700: shade-color($pink, 40%) !default;\n$pink-800: shade-color($pink, 60%) !default;\n$pink-900: shade-color($pink, 80%) !default;\n\n$red-100: tint-color($red, 80%) !default;\n$red-200: tint-color($red, 60%) !default;\n$red-300: tint-color($red, 40%) !default;\n$red-400: tint-color($red, 20%) !default;\n$red-500: $red !default;\n$red-600: shade-color($red, 20%) !default;\n$red-700: shade-color($red, 40%) !default;\n$red-800: shade-color($red, 60%) !default;\n$red-900: shade-color($red, 80%) !default;\n\n$orange-100: tint-color($orange, 80%) !default;\n$orange-200: tint-color($orange, 60%) !default;\n$orange-300: tint-color($orange, 40%) !default;\n$orange-400: tint-color($orange, 20%) !default;\n$orange-500: $orange !default;\n$orange-600: shade-color($orange, 20%) !default;\n$orange-700: shade-color($orange, 40%) !default;\n$orange-800: shade-color($orange, 60%) !default;\n$orange-900: shade-color($orange, 80%) !default;\n\n$yellow-100: tint-color($yellow, 80%) !default;\n$yellow-200: tint-color($yellow, 60%) !default;\n$yellow-300: tint-color($yellow, 40%) !default;\n$yellow-400: tint-color($yellow, 20%) !default;\n$yellow-500: $yellow !default;\n$yellow-600: shade-color($yellow, 20%) !default;\n$yellow-700: shade-color($yellow, 40%) !default;\n$yellow-800: shade-color($yellow, 60%) !default;\n$yellow-900: shade-color($yellow, 80%) !default;\n\n$green-100: tint-color($green, 80%) !default;\n$green-200: tint-color($green, 60%) !default;\n$green-300: tint-color($green, 40%) !default;\n$green-400: tint-color($green, 20%) !default;\n$green-500: $green !default;\n$green-600: shade-color($green, 20%) !default;\n$green-700: shade-color($green, 40%) !default;\n$green-800: shade-color($green, 60%) !default;\n$green-900: shade-color($green, 80%) !default;\n\n$teal-100: tint-color($teal, 80%) !default;\n$teal-200: tint-color($teal, 60%) !default;\n$teal-300: tint-color($teal, 40%) !default;\n$teal-400: tint-color($teal, 20%) !default;\n$teal-500: $teal !default;\n$teal-600: shade-color($teal, 20%) !default;\n$teal-700: shade-color($teal, 40%) !default;\n$teal-800: shade-color($teal, 60%) !default;\n$teal-900: shade-color($teal, 80%) !default;\n\n$cyan-100: tint-color($cyan, 80%) !default;\n$cyan-200: tint-color($cyan, 60%) !default;\n$cyan-300: tint-color($cyan, 40%) !default;\n$cyan-400: tint-color($cyan, 20%) !default;\n$cyan-500: $cyan !default;\n$cyan-600: shade-color($cyan, 20%) !default;\n$cyan-700: shade-color($cyan, 40%) !default;\n$cyan-800: shade-color($cyan, 60%) !default;\n$cyan-900: shade-color($cyan, 80%) !default;\n// fusv-enable\n\n// Characters which are escaped by the escape-svg function\n$escaped-characters: (\n  (\"<\", \"%3c\"),\n  (\">\", \"%3e\"),\n  (\"#\", \"%23\"),\n  (\"(\", \"%28\"),\n  (\")\", \"%29\"),\n) !default;\n\n// Options\n//\n// Quickly modify global styling by enabling or disabling optional features.\n\n$enable-caret:                true !default;\n$enable-rounded:              true !default;\n$enable-shadows:              false !default;\n$enable-gradients:            false !default;\n$enable-transitions:          true !default;\n$enable-reduced-motion:       true !default;\n$enable-smooth-scroll:        true !default;\n$enable-grid-classes:         true !default;\n$enable-button-pointers:      true !default;\n$enable-rfs:                  true !default;\n$enable-validation-icons:     true !default;\n$enable-negative-margins:     false !default;\n$enable-deprecation-messages: true !default;\n$enable-important-utilities:  true !default;\n\n// Prefix for :root CSS variables\n\n$variable-prefix:             bs- !default;\n\n// Gradient\n//\n// The gradient which is added to components if `$enable-gradients` is `true`\n// This gradient is also added to elements with `.bg-gradient`\n// scss-docs-start variable-gradient\n$gradient: linear-gradient(180deg, rgba($white, .15), rgba($white, 0)) !default;\n// scss-docs-end variable-gradient\n\n// Spacing\n//\n// Control the default styling of most Bootstrap elements by modifying these\n// variables. Mostly focused on spacing.\n// You can add more entries to the $spacers map, should you need more variation.\n\n// scss-docs-start spacer-variables-maps\n$spacer: 1rem !default;\n$spacers: (\n  0: 0,\n  1: $spacer * .25,\n  2: $spacer * .5,\n  3: $spacer,\n  4: $spacer * 1.5,\n  5: $spacer * 3,\n) !default;\n\n$negative-spacers: if($enable-negative-margins, negativify-map($spacers), null) !default;\n// scss-docs-end spacer-variables-maps\n\n// Position\n//\n// Define the edge positioning anchors of the position utilities.\n\n// scss-docs-start position-map\n$position-values: (\n  0: 0,\n  50: 50%,\n  100: 100%\n) !default;\n// scss-docs-end position-map\n\n// Body\n//\n// Settings for the `<body>` element.\n\n$body-bg:                   $white !default;\n$body-color:                $gray-900 !default;\n$body-text-align:           null !default;\n\n\n// Links\n//\n// Style anchor elements.\n\n$link-color:                              $primary !default;\n$link-decoration:                         underline !default;\n$link-shade-percentage:                   20% !default;\n$link-hover-color:                        shift-color($link-color, $link-shade-percentage) !default;\n$link-hover-decoration:                   null !default;\n\n$stretched-link-pseudo-element:           after !default;\n$stretched-link-z-index:                  1 !default;\n\n// Paragraphs\n//\n// Style p element.\n\n$paragraph-margin-bottom:   1rem !default;\n\n\n// Grid breakpoints\n//\n// Define the minimum dimensions at which your layout will change,\n// adapting to different screen sizes, for use in media queries.\n\n// scss-docs-start grid-breakpoints\n$grid-breakpoints: (\n  xs: 0,\n  sm: 576px,\n  md: 768px,\n  lg: 992px,\n  xl: 1200px,\n  xxl: 1400px\n) !default;\n// scss-docs-end grid-breakpoints\n\n@include _assert-ascending($grid-breakpoints, \"$grid-breakpoints\");\n@include _assert-starts-at-zero($grid-breakpoints, \"$grid-breakpoints\");\n\n\n// Grid containers\n//\n// Define the maximum width of `.container` for different screen sizes.\n\n// scss-docs-start container-max-widths\n$container-max-widths: (\n  sm: 540px,\n  md: 720px,\n  lg: 960px,\n  xl: 1140px,\n  xxl: 1320px\n) !default;\n// scss-docs-end container-max-widths\n\n@include _assert-ascending($container-max-widths, \"$container-max-widths\");\n\n\n// Grid columns\n//\n// Set the number of columns and specify the width of the gutters.\n\n$grid-columns:                12 !default;\n$grid-gutter-width:           1.5rem !default;\n$grid-row-columns:            6 !default;\n\n$gutters: $spacers !default;\n\n// Container padding\n\n$container-padding-x: $grid-gutter-width * .5 !default;\n\n\n// Components\n//\n// Define common padding and border radius sizes and more.\n\n// scss-docs-start border-variables\n$border-width:                1px !default;\n$border-widths: (\n  1: 1px,\n  2: 2px,\n  3: 3px,\n  4: 4px,\n  5: 5px\n) !default;\n\n$border-color:                $gray-300 !default;\n// scss-docs-end border-variables\n\n// scss-docs-start border-radius-variables\n$border-radius:               .25rem !default;\n$border-radius-sm:            .2rem !default;\n$border-radius-lg:            .3rem !default;\n$border-radius-pill:          50rem !default;\n// scss-docs-end border-radius-variables\n\n// scss-docs-start box-shadow-variables\n$box-shadow:                  0 .5rem 1rem rgba($black, .15) !default;\n$box-shadow-sm:               0 .125rem .25rem rgba($black, .075) !default;\n$box-shadow-lg:               0 1rem 3rem rgba($black, .175) !default;\n$box-shadow-inset:            inset 0 1px 2px rgba($black, .075) !default;\n// scss-docs-end box-shadow-variables\n\n$component-active-color:      $white !default;\n$component-active-bg:         $primary !default;\n\n// scss-docs-start caret-variables\n$caret-width:                 .3em !default;\n$caret-vertical-align:        $caret-width * .85 !default;\n$caret-spacing:               $caret-width * .85 !default;\n// scss-docs-end caret-variables\n\n$transition-base:             all .2s ease-in-out !default;\n$transition-fade:             opacity .15s linear !default;\n// scss-docs-start collapse-transition\n$transition-collapse:         height .35s ease !default;\n// scss-docs-end collapse-transition\n\n// stylelint-disable function-disallowed-list\n// scss-docs-start aspect-ratios\n$aspect-ratios: (\n  \"1x1\": 100%,\n  \"4x3\": calc(3 / 4 * 100%),\n  \"16x9\": calc(9 / 16 * 100%),\n  \"21x9\": calc(9 / 21 * 100%)\n) !default;\n// scss-docs-end aspect-ratios\n// stylelint-enable function-disallowed-list\n\n// Typography\n//\n// Font, line-height, and color for body text, headings, and more.\n\n// scss-docs-start font-variables\n// stylelint-disable value-keyword-case\n$font-family-sans-serif:      system-ui, -apple-system, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, \"Noto Sans\", \"Liberation Sans\", sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\" !default;\n$font-family-monospace:       SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\", \"Courier New\", monospace !default;\n// stylelint-enable value-keyword-case\n$font-family-base:            var(--#{$variable-prefix}font-sans-serif) !default;\n$font-family-code:            var(--#{$variable-prefix}font-monospace) !default;\n\n// $font-size-root affects the value of `rem`, which is used for as well font sizes, paddings, and margins\n// $font-size-base affects the font size of the body text\n$font-size-root:              null !default;\n$font-size-base:              1rem !default; // Assumes the browser default, typically `16px`\n$font-size-sm:                $font-size-base * .875 !default;\n$font-size-lg:                $font-size-base * 1.25 !default;\n\n$font-weight-lighter:         lighter !default;\n$font-weight-light:           300 !default;\n$font-weight-normal:          400 !default;\n$font-weight-bold:            700 !default;\n$font-weight-bolder:          bolder !default;\n\n$font-weight-base:            $font-weight-normal !default;\n\n$line-height-base:            1.5 !default;\n$line-height-sm:              1.25 !default;\n$line-height-lg:              2 !default;\n\n$h1-font-size:                $font-size-base * 2.5 !default;\n$h2-font-size:                $font-size-base * 2 !default;\n$h3-font-size:                $font-size-base * 1.75 !default;\n$h4-font-size:                $font-size-base * 1.5 !default;\n$h5-font-size:                $font-size-base * 1.25 !default;\n$h6-font-size:                $font-size-base !default;\n// scss-docs-end font-variables\n\n// scss-docs-start font-sizes\n$font-sizes: (\n  1: $h1-font-size,\n  2: $h2-font-size,\n  3: $h3-font-size,\n  4: $h4-font-size,\n  5: $h5-font-size,\n  6: $h6-font-size\n) !default;\n// scss-docs-end font-sizes\n\n// scss-docs-start headings-variables\n$headings-margin-bottom:      $spacer * .5 !default;\n$headings-font-family:        null !default;\n$headings-font-style:         null !default;\n$headings-font-weight:        500 !default;\n$headings-line-height:        1.2 !default;\n$headings-color:              null !default;\n// scss-docs-end headings-variables\n\n// scss-docs-start display-headings\n$display-font-sizes: (\n  1: 5rem,\n  2: 4.5rem,\n  3: 4rem,\n  4: 3.5rem,\n  5: 3rem,\n  6: 2.5rem\n) !default;\n\n$display-font-weight: 300 !default;\n$display-line-height: $headings-line-height !default;\n// scss-docs-end display-headings\n\n// scss-docs-start type-variables\n$lead-font-size:              $font-size-base * 1.25 !default;\n$lead-font-weight:            300 !default;\n\n$small-font-size:             .875em !default;\n\n$sub-sup-font-size:           .75em !default;\n\n$text-muted:                  $gray-600 !default;\n\n$initialism-font-size:        $small-font-size !default;\n\n$blockquote-margin-y:         $spacer !default;\n$blockquote-font-size:        $font-size-base * 1.25 !default;\n$blockquote-footer-color:     $gray-600 !default;\n$blockquote-footer-font-size: $small-font-size !default;\n\n$hr-margin-y:                 $spacer !default;\n$hr-color:                    inherit !default;\n$hr-height:                   $border-width !default;\n$hr-opacity:                  .25 !default;\n\n$legend-margin-bottom:        .5rem !default;\n$legend-font-size:            1.5rem !default;\n$legend-font-weight:          null !default;\n\n$mark-padding:                .2em !default;\n\n$dt-font-weight:              $font-weight-bold !default;\n\n$nested-kbd-font-weight:      $font-weight-bold !default;\n\n$list-inline-padding:         .5rem !default;\n\n$mark-bg:                     #fcf8e3 !default;\n// scss-docs-end type-variables\n\n\n// Tables\n//\n// Customizes the `.table` component with basic values, each used across all table variations.\n\n// scss-docs-start table-variables\n$table-cell-padding-y:        .5rem !default;\n$table-cell-padding-x:        .5rem !default;\n$table-cell-padding-y-sm:     .25rem !default;\n$table-cell-padding-x-sm:     .25rem !default;\n\n$table-cell-vertical-align:   top !default;\n\n$table-color:                 $body-color !default;\n$table-bg:                    transparent !default;\n$table-accent-bg:             transparent !default;\n\n$table-th-font-weight:        null !default;\n\n$table-striped-color:         $table-color !default;\n$table-striped-bg-factor:     .05 !default;\n$table-striped-bg:            rgba($black, $table-striped-bg-factor) !default;\n\n$table-active-color:          $table-color !default;\n$table-active-bg-factor:      .1 !default;\n$table-active-bg:             rgba($black, $table-active-bg-factor) !default;\n\n$table-hover-color:           $table-color !default;\n$table-hover-bg-factor:       .075 !default;\n$table-hover-bg:              rgba($black, $table-hover-bg-factor) !default;\n\n$table-border-factor:         .1 !default;\n$table-border-width:          $border-width !default;\n$table-border-color:          $border-color !default;\n\n$table-striped-order:         odd !default;\n\n$table-group-separator-color: currentColor !default;\n\n$table-caption-color:         $text-muted !default;\n\n$table-bg-scale:              -80% !default;\n// scss-docs-end table-variables\n\n// scss-docs-start table-loop\n$table-variants: (\n  \"primary\":    shift-color($primary, $table-bg-scale),\n  \"secondary\":  shift-color($secondary, $table-bg-scale),\n  \"success\":    shift-color($success, $table-bg-scale),\n  \"info\":       shift-color($info, $table-bg-scale),\n  \"warning\":    shift-color($warning, $table-bg-scale),\n  \"danger\":     shift-color($danger, $table-bg-scale),\n  \"light\":      $light,\n  \"dark\":       $dark,\n) !default;\n// scss-docs-end table-loop\n\n\n// Buttons + Forms\n//\n// Shared variables that are reassigned to `$input-` and `$btn-` specific variables.\n\n// scss-docs-start input-btn-variables\n$input-btn-padding-y:         .375rem !default;\n$input-btn-padding-x:         .75rem !default;\n$input-btn-font-family:       null !default;\n$input-btn-font-size:         $font-size-base !default;\n$input-btn-line-height:       $line-height-base !default;\n\n$input-btn-focus-width:         .25rem !default;\n$input-btn-focus-color-opacity: .25 !default;\n$input-btn-focus-color:         rgba($component-active-bg, $input-btn-focus-color-opacity) !default;\n$input-btn-focus-blur:          0 !default;\n$input-btn-focus-box-shadow:    0 0 $input-btn-focus-blur $input-btn-focus-width $input-btn-focus-color !default;\n\n$input-btn-padding-y-sm:      .25rem !default;\n$input-btn-padding-x-sm:      .5rem !default;\n$input-btn-font-size-sm:      $font-size-sm !default;\n\n$input-btn-padding-y-lg:      .5rem !default;\n$input-btn-padding-x-lg:      1rem !default;\n$input-btn-font-size-lg:      $font-size-lg !default;\n\n$input-btn-border-width:      $border-width !default;\n// scss-docs-end input-btn-variables\n\n\n// Buttons\n//\n// For each of Bootstrap's buttons, define text, background, and border color.\n\n// scss-docs-start btn-variables\n$btn-padding-y:               $input-btn-padding-y !default;\n$btn-padding-x:               $input-btn-padding-x !default;\n$btn-font-family:             $input-btn-font-family !default;\n$btn-font-size:               $input-btn-font-size !default;\n$btn-line-height:             $input-btn-line-height !default;\n$btn-white-space:             null !default; // Set to `nowrap` to prevent text wrapping\n\n$btn-padding-y-sm:            $input-btn-padding-y-sm !default;\n$btn-padding-x-sm:            $input-btn-padding-x-sm !default;\n$btn-font-size-sm:            $input-btn-font-size-sm !default;\n\n$btn-padding-y-lg:            $input-btn-padding-y-lg !default;\n$btn-padding-x-lg:            $input-btn-padding-x-lg !default;\n$btn-font-size-lg:            $input-btn-font-size-lg !default;\n\n$btn-border-width:            $input-btn-border-width !default;\n\n$btn-font-weight:             $font-weight-normal !default;\n$btn-box-shadow:              inset 0 1px 0 rgba($white, .15), 0 1px 1px rgba($black, .075) !default;\n$btn-focus-width:             $input-btn-focus-width !default;\n$btn-focus-box-shadow:        $input-btn-focus-box-shadow !default;\n$btn-disabled-opacity:        .65 !default;\n$btn-active-box-shadow:       inset 0 3px 5px rgba($black, .125) !default;\n\n$btn-link-color:              $link-color !default;\n$btn-link-hover-color:        $link-hover-color !default;\n$btn-link-disabled-color:     $gray-600 !default;\n\n// Allows for customizing button radius independently from global border radius\n$btn-border-radius:           $border-radius !default;\n$btn-border-radius-sm:        $border-radius-sm !default;\n$btn-border-radius-lg:        $border-radius-lg !default;\n\n$btn-transition:              color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\n\n$btn-hover-bg-shade-amount:       15% !default;\n$btn-hover-bg-tint-amount:        15% !default;\n$btn-hover-border-shade-amount:   20% !default;\n$btn-hover-border-tint-amount:    10% !default;\n$btn-active-bg-shade-amount:      20% !default;\n$btn-active-bg-tint-amount:       20% !default;\n$btn-active-border-shade-amount:  25% !default;\n$btn-active-border-tint-amount:   10% !default;\n// scss-docs-end btn-variables\n\n\n// Forms\n\n// scss-docs-start form-text-variables\n$form-text-margin-top:                  .25rem !default;\n$form-text-font-size:                   $small-font-size !default;\n$form-text-font-style:                  null !default;\n$form-text-font-weight:                 null !default;\n$form-text-color:                       $text-muted !default;\n// scss-docs-end form-text-variables\n\n// scss-docs-start form-label-variables\n$form-label-margin-bottom:              .5rem !default;\n$form-label-font-size:                  null !default;\n$form-label-font-style:                 null !default;\n$form-label-font-weight:                null !default;\n$form-label-color:                      null !default;\n// scss-docs-end form-label-variables\n\n// scss-docs-start form-input-variables\n$input-padding-y:                       $input-btn-padding-y !default;\n$input-padding-x:                       $input-btn-padding-x !default;\n$input-font-family:                     $input-btn-font-family !default;\n$input-font-size:                       $input-btn-font-size !default;\n$input-font-weight:                     $font-weight-base !default;\n$input-line-height:                     $input-btn-line-height !default;\n\n$input-padding-y-sm:                    $input-btn-padding-y-sm !default;\n$input-padding-x-sm:                    $input-btn-padding-x-sm !default;\n$input-font-size-sm:                    $input-btn-font-size-sm !default;\n\n$input-padding-y-lg:                    $input-btn-padding-y-lg !default;\n$input-padding-x-lg:                    $input-btn-padding-x-lg !default;\n$input-font-size-lg:                    $input-btn-font-size-lg !default;\n\n$input-bg:                              $white !default;\n$input-disabled-bg:                     $gray-200 !default;\n$input-disabled-border-color:           null !default;\n\n$input-color:                           $body-color !default;\n$input-border-color:                    $gray-400 !default;\n$input-border-width:                    $input-btn-border-width !default;\n$input-box-shadow:                      $box-shadow-inset !default;\n\n$input-border-radius:                   $border-radius !default;\n$input-border-radius-sm:                $border-radius-sm !default;\n$input-border-radius-lg:                $border-radius-lg !default;\n\n$input-focus-bg:                        $input-bg !default;\n$input-focus-border-color:              tint-color($component-active-bg, 50%) !default;\n$input-focus-color:                     $input-color !default;\n$input-focus-width:                     $input-btn-focus-width !default;\n$input-focus-box-shadow:                $input-btn-focus-box-shadow !default;\n\n$input-placeholder-color:               $gray-600 !default;\n$input-plaintext-color:                 $body-color !default;\n\n$input-height-border:                   $input-border-width * 2 !default;\n\n$input-height-inner:                    add($input-line-height * 1em, $input-padding-y * 2) !default;\n$input-height-inner-half:               add($input-line-height * .5em, $input-padding-y) !default;\n$input-height-inner-quarter:            add($input-line-height * .25em, $input-padding-y * .5) !default;\n\n$input-height:                          add($input-line-height * 1em, add($input-padding-y * 2, $input-height-border, false)) !default;\n$input-height-sm:                       add($input-line-height * 1em, add($input-padding-y-sm * 2, $input-height-border, false)) !default;\n$input-height-lg:                       add($input-line-height * 1em, add($input-padding-y-lg * 2, $input-height-border, false)) !default;\n\n$input-transition:                      border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\n// scss-docs-end form-input-variables\n\n// scss-docs-start form-check-variables\n$form-check-input-width:                  1em !default;\n$form-check-min-height:                   $font-size-base * $line-height-base !default;\n$form-check-padding-start:                $form-check-input-width + .5em !default;\n$form-check-margin-bottom:                .125rem !default;\n$form-check-label-color:                  null !default;\n$form-check-label-cursor:                 null !default;\n$form-check-transition:                   null !default;\n\n$form-check-input-active-filter:          brightness(90%) !default;\n\n$form-check-input-bg:                     $input-bg !default;\n$form-check-input-border:                 1px solid rgba($black, .25) !default;\n$form-check-input-border-radius:          .25em !default;\n$form-check-radio-border-radius:          50% !default;\n$form-check-input-focus-border:           $input-focus-border-color !default;\n$form-check-input-focus-box-shadow:       $input-btn-focus-box-shadow !default;\n\n$form-check-input-checked-color:          $component-active-color !default;\n$form-check-input-checked-bg-color:       $component-active-bg !default;\n$form-check-input-checked-border-color:   $form-check-input-checked-bg-color !default;\n$form-check-input-checked-bg-image:       url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'><path fill='none' stroke='#{$form-check-input-checked-color}' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='M6 10l3 3l6-6'/></svg>\") !default;\n$form-check-radio-checked-bg-image:       url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='2' fill='#{$form-check-input-checked-color}'/></svg>\") !default;\n\n$form-check-input-indeterminate-color:          $component-active-color !default;\n$form-check-input-indeterminate-bg-color:       $component-active-bg !default;\n$form-check-input-indeterminate-border-color:   $form-check-input-indeterminate-bg-color !default;\n$form-check-input-indeterminate-bg-image:       url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'><path fill='none' stroke='#{$form-check-input-indeterminate-color}' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='M6 10h8'/></svg>\") !default;\n\n$form-check-input-disabled-opacity:        .5 !default;\n$form-check-label-disabled-opacity:        $form-check-input-disabled-opacity !default;\n$form-check-btn-check-disabled-opacity:    $btn-disabled-opacity !default;\n\n$form-check-inline-margin-end:    1rem !default;\n// scss-docs-end form-check-variables\n\n// scss-docs-start form-switch-variables\n$form-switch-color:               rgba(0, 0, 0, .25) !default;\n$form-switch-width:               2em !default;\n$form-switch-padding-start:       $form-switch-width + .5em !default;\n$form-switch-bg-image:            url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='3' fill='#{$form-switch-color}'/></svg>\") !default;\n$form-switch-border-radius:       $form-switch-width !default;\n$form-switch-transition:          background-position .15s ease-in-out !default;\n\n$form-switch-focus-color:         $input-focus-border-color !default;\n$form-switch-focus-bg-image:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='3' fill='#{$form-switch-focus-color}'/></svg>\") !default;\n\n$form-switch-checked-color:       $component-active-color !default;\n$form-switch-checked-bg-image:    url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='3' fill='#{$form-switch-checked-color}'/></svg>\") !default;\n$form-switch-checked-bg-position: right center !default;\n// scss-docs-end form-switch-variables\n\n// scss-docs-start input-group-variables\n$input-group-addon-padding-y:           $input-padding-y !default;\n$input-group-addon-padding-x:           $input-padding-x !default;\n$input-group-addon-font-weight:         $input-font-weight !default;\n$input-group-addon-color:               $input-color !default;\n$input-group-addon-bg:                  $gray-200 !default;\n$input-group-addon-border-color:        $input-border-color !default;\n// scss-docs-end input-group-variables\n\n// scss-docs-start form-select-variables\n$form-select-padding-y:             $input-padding-y !default;\n$form-select-padding-x:             $input-padding-x !default;\n$form-select-font-family:           $input-font-family !default;\n$form-select-font-size:             $input-font-size !default;\n$form-select-indicator-padding:     $form-select-padding-x * 3 !default; // Extra padding for background-image\n$form-select-font-weight:           $input-font-weight !default;\n$form-select-line-height:           $input-line-height !default;\n$form-select-color:                 $input-color !default;\n$form-select-bg:                    $input-bg !default;\n$form-select-disabled-color:        null !default;\n$form-select-disabled-bg:           $gray-200 !default;\n$form-select-disabled-border-color: $input-disabled-border-color !default;\n$form-select-bg-position:           right $form-select-padding-x center !default;\n$form-select-bg-size:               16px 12px !default; // In pixels because image dimensions\n$form-select-indicator-color:       $gray-800 !default;\n$form-select-indicator:             url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'><path fill='none' stroke='#{$form-select-indicator-color}' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M2 5l6 6 6-6'/></svg>\") !default;\n\n$form-select-feedback-icon-padding-end: $form-select-padding-x * 2.5 + $form-select-indicator-padding !default;\n$form-select-feedback-icon-position:    center right $form-select-indicator-padding !default;\n$form-select-feedback-icon-size:        $input-height-inner-half $input-height-inner-half !default;\n\n$form-select-border-width:        $input-border-width !default;\n$form-select-border-color:        $input-border-color !default;\n$form-select-border-radius:       $border-radius !default;\n$form-select-box-shadow:          $box-shadow-inset !default;\n\n$form-select-focus-border-color:  $input-focus-border-color !default;\n$form-select-focus-width:         $input-focus-width !default;\n$form-select-focus-box-shadow:    0 0 0 $form-select-focus-width $input-btn-focus-color !default;\n\n$form-select-padding-y-sm:        $input-padding-y-sm !default;\n$form-select-padding-x-sm:        $input-padding-x-sm !default;\n$form-select-font-size-sm:        $input-font-size-sm !default;\n\n$form-select-padding-y-lg:        $input-padding-y-lg !default;\n$form-select-padding-x-lg:        $input-padding-x-lg !default;\n$form-select-font-size-lg:        $input-font-size-lg !default;\n\n$form-select-transition:          $input-transition !default;\n// scss-docs-end form-select-variables\n\n// scss-docs-start form-range-variables\n$form-range-track-width:          100% !default;\n$form-range-track-height:         .5rem !default;\n$form-range-track-cursor:         pointer !default;\n$form-range-track-bg:             $gray-300 !default;\n$form-range-track-border-radius:  1rem !default;\n$form-range-track-box-shadow:     $box-shadow-inset !default;\n\n$form-range-thumb-width:                   1rem !default;\n$form-range-thumb-height:                  $form-range-thumb-width !default;\n$form-range-thumb-bg:                      $component-active-bg !default;\n$form-range-thumb-border:                  0 !default;\n$form-range-thumb-border-radius:           1rem !default;\n$form-range-thumb-box-shadow:              0 .1rem .25rem rgba($black, .1) !default;\n$form-range-thumb-focus-box-shadow:        0 0 0 1px $body-bg, $input-focus-box-shadow !default;\n$form-range-thumb-focus-box-shadow-width:  $input-focus-width !default; // For focus box shadow issue in Edge\n$form-range-thumb-active-bg:               tint-color($component-active-bg, 70%) !default;\n$form-range-thumb-disabled-bg:             $gray-500 !default;\n$form-range-thumb-transition:              background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\n// scss-docs-end form-range-variables\n\n// scss-docs-start form-file-variables\n$form-file-button-color:          $input-color !default;\n$form-file-button-bg:             $input-group-addon-bg !default;\n$form-file-button-hover-bg:       shade-color($form-file-button-bg, 5%) !default;\n// scss-docs-end form-file-variables\n\n// scss-docs-start form-floating-variables\n$form-floating-height:            add(3.5rem, $input-height-border) !default;\n$form-floating-line-height:       1.25 !default;\n$form-floating-padding-x:         $input-padding-x !default;\n$form-floating-padding-y:         1rem !default;\n$form-floating-input-padding-t:   1.625rem !default;\n$form-floating-input-padding-b:   .625rem !default;\n$form-floating-label-opacity:     .65 !default;\n$form-floating-label-transform:   scale(.85) translateY(-.5rem) translateX(.15rem) !default;\n$form-floating-transition:        opacity .1s ease-in-out, transform .1s ease-in-out !default;\n// scss-docs-end form-floating-variables\n\n// Form validation\n\n// scss-docs-start form-feedback-variables\n$form-feedback-margin-top:          $form-text-margin-top !default;\n$form-feedback-font-size:           $form-text-font-size !default;\n$form-feedback-font-style:          $form-text-font-style !default;\n$form-feedback-valid-color:         $success !default;\n$form-feedback-invalid-color:       $danger !default;\n\n$form-feedback-icon-valid-color:    $form-feedback-valid-color !default;\n$form-feedback-icon-valid:          url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'><path fill='#{$form-feedback-icon-valid-color}' d='M2.3 6.73L.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z'/></svg>\") !default;\n$form-feedback-icon-invalid-color:  $form-feedback-invalid-color !default;\n$form-feedback-icon-invalid:        url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 12 12' width='12' height='12' fill='none' stroke='#{$form-feedback-icon-invalid-color}'><circle cx='6' cy='6' r='4.5'/><path stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/><circle cx='6' cy='8.2' r='.6' fill='#{$form-feedback-icon-invalid-color}' stroke='none'/></svg>\") !default;\n// scss-docs-end form-feedback-variables\n\n// scss-docs-start form-validation-states\n$form-validation-states: (\n  \"valid\": (\n    \"color\": $form-feedback-valid-color,\n    \"icon\": $form-feedback-icon-valid\n  ),\n  \"invalid\": (\n    \"color\": $form-feedback-invalid-color,\n    \"icon\": $form-feedback-icon-invalid\n  )\n) !default;\n// scss-docs-end form-validation-states\n\n// Z-index master list\n//\n// Warning: Avoid customizing these values. They're used for a bird's eye view\n// of components dependent on the z-axis and are designed to all work together.\n\n// scss-docs-start zindex-stack\n$zindex-dropdown:                   1000 !default;\n$zindex-sticky:                     1020 !default;\n$zindex-fixed:                      1030 !default;\n$zindex-modal-backdrop:             1040 !default;\n$zindex-offcanvas:                  1050 !default;\n$zindex-modal:                      1060 !default;\n$zindex-popover:                    1070 !default;\n$zindex-tooltip:                    1080 !default;\n// scss-docs-end zindex-stack\n\n\n// Navs\n\n// scss-docs-start nav-variables\n$nav-link-padding-y:                .5rem !default;\n$nav-link-padding-x:                1rem !default;\n$nav-link-font-size:                null !default;\n$nav-link-font-weight:              null !default;\n$nav-link-color:                    $link-color !default;\n$nav-link-hover-color:              $link-hover-color !default;\n$nav-link-transition:               color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out !default;\n$nav-link-disabled-color:           $gray-600 !default;\n\n$nav-tabs-border-color:             $gray-300 !default;\n$nav-tabs-border-width:             $border-width !default;\n$nav-tabs-border-radius:            $border-radius !default;\n$nav-tabs-link-hover-border-color:  $gray-200 $gray-200 $nav-tabs-border-color !default;\n$nav-tabs-link-active-color:        $gray-700 !default;\n$nav-tabs-link-active-bg:           $body-bg !default;\n$nav-tabs-link-active-border-color: $gray-300 $gray-300 $nav-tabs-link-active-bg !default;\n\n$nav-pills-border-radius:           $border-radius !default;\n$nav-pills-link-active-color:       $component-active-color !default;\n$nav-pills-link-active-bg:          $component-active-bg !default;\n// scss-docs-end nav-variables\n\n\n// Navbar\n\n// scss-docs-start navbar-variables\n$navbar-padding-y:                  $spacer * .5 !default;\n$navbar-padding-x:                  null !default;\n\n$navbar-nav-link-padding-x:         .5rem !default;\n\n$navbar-brand-font-size:            $font-size-lg !default;\n// Compute the navbar-brand padding-y so the navbar-brand will have the same height as navbar-text and nav-link\n$nav-link-height:                   $font-size-base * $line-height-base + $nav-link-padding-y * 2 !default;\n$navbar-brand-height:               $navbar-brand-font-size * $line-height-base !default;\n$navbar-brand-padding-y:            ($nav-link-height - $navbar-brand-height) * .5 !default;\n$navbar-brand-margin-end:           1rem !default;\n\n$navbar-toggler-padding-y:          .25rem !default;\n$navbar-toggler-padding-x:          .75rem !default;\n$navbar-toggler-font-size:          $font-size-lg !default;\n$navbar-toggler-border-radius:      $btn-border-radius !default;\n$navbar-toggler-focus-width:        $btn-focus-width !default;\n$navbar-toggler-transition:         box-shadow .15s ease-in-out !default;\n// scss-docs-end navbar-variables\n\n// scss-docs-start navbar-theme-variables\n$navbar-dark-color:                 rgba($white, .55) !default;\n$navbar-dark-hover-color:           rgba($white, .75) !default;\n$navbar-dark-active-color:          $white !default;\n$navbar-dark-disabled-color:        rgba($white, .25) !default;\n$navbar-dark-toggler-icon-bg:       url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'><path stroke='#{$navbar-dark-color}' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/></svg>\") !default;\n$navbar-dark-toggler-border-color:  rgba($white, .1) !default;\n\n$navbar-light-color:                rgba($black, .55) !default;\n$navbar-light-hover-color:          rgba($black, .7) !default;\n$navbar-light-active-color:         rgba($black, .9) !default;\n$navbar-light-disabled-color:       rgba($black, .3) !default;\n$navbar-light-toggler-icon-bg:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'><path stroke='#{$navbar-light-color}' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/></svg>\") !default;\n$navbar-light-toggler-border-color: rgba($black, .1) !default;\n\n$navbar-light-brand-color:                $navbar-light-active-color !default;\n$navbar-light-brand-hover-color:          $navbar-light-active-color !default;\n$navbar-dark-brand-color:                 $navbar-dark-active-color !default;\n$navbar-dark-brand-hover-color:           $navbar-dark-active-color !default;\n// scss-docs-end navbar-theme-variables\n\n\n// Dropdowns\n//\n// Dropdown menu container and contents.\n\n// scss-docs-start dropdown-variables\n$dropdown-min-width:                10rem !default;\n$dropdown-padding-x:                0 !default;\n$dropdown-padding-y:                .5rem !default;\n$dropdown-spacer:                   .125rem !default;\n$dropdown-font-size:                $font-size-base !default;\n$dropdown-color:                    $body-color !default;\n$dropdown-bg:                       $white !default;\n$dropdown-border-color:             rgba($black, .15) !default;\n$dropdown-border-radius:            $border-radius !default;\n$dropdown-border-width:             $border-width !default;\n$dropdown-inner-border-radius:      subtract($dropdown-border-radius, $dropdown-border-width) !default;\n$dropdown-divider-bg:               $dropdown-border-color !default;\n$dropdown-divider-margin-y:         $spacer * .5 !default;\n$dropdown-box-shadow:               $box-shadow !default;\n\n$dropdown-link-color:               $gray-900 !default;\n$dropdown-link-hover-color:         shade-color($gray-900, 10%) !default;\n$dropdown-link-hover-bg:            $gray-200 !default;\n\n$dropdown-link-active-color:        $component-active-color !default;\n$dropdown-link-active-bg:           $component-active-bg !default;\n\n$dropdown-link-disabled-color:      $gray-500 !default;\n\n$dropdown-item-padding-y:           $spacer * .25 !default;\n$dropdown-item-padding-x:           $spacer !default;\n\n$dropdown-header-color:             $gray-600 !default;\n$dropdown-header-padding:           $dropdown-padding-y $dropdown-item-padding-x !default;\n// scss-docs-end dropdown-variables\n\n// scss-docs-start dropdown-dark-variables\n$dropdown-dark-color:               $gray-300 !default;\n$dropdown-dark-bg:                  $gray-800 !default;\n$dropdown-dark-border-color:        $dropdown-border-color !default;\n$dropdown-dark-divider-bg:          $dropdown-divider-bg !default;\n$dropdown-dark-box-shadow:          null !default;\n$dropdown-dark-link-color:          $dropdown-dark-color !default;\n$dropdown-dark-link-hover-color:    $white !default;\n$dropdown-dark-link-hover-bg:       rgba($white, .15) !default;\n$dropdown-dark-link-active-color:   $dropdown-link-active-color !default;\n$dropdown-dark-link-active-bg:      $dropdown-link-active-bg !default;\n$dropdown-dark-link-disabled-color: $gray-500 !default;\n$dropdown-dark-header-color:        $gray-500 !default;\n// scss-docs-end dropdown-dark-variables\n\n\n// Pagination\n\n// scss-docs-start pagination-variables\n$pagination-padding-y:              .375rem !default;\n$pagination-padding-x:              .75rem !default;\n$pagination-padding-y-sm:           .25rem !default;\n$pagination-padding-x-sm:           .5rem !default;\n$pagination-padding-y-lg:           .75rem !default;\n$pagination-padding-x-lg:           1.5rem !default;\n\n$pagination-color:                  $link-color !default;\n$pagination-bg:                     $white !default;\n$pagination-border-width:           $border-width !default;\n$pagination-border-radius:          $border-radius !default;\n$pagination-margin-start:           -$pagination-border-width !default;\n$pagination-border-color:           $gray-300 !default;\n\n$pagination-focus-color:            $link-hover-color !default;\n$pagination-focus-bg:               $gray-200 !default;\n$pagination-focus-box-shadow:       $input-btn-focus-box-shadow !default;\n$pagination-focus-outline:          0 !default;\n\n$pagination-hover-color:            $link-hover-color !default;\n$pagination-hover-bg:               $gray-200 !default;\n$pagination-hover-border-color:     $gray-300 !default;\n\n$pagination-active-color:           $component-active-color !default;\n$pagination-active-bg:              $component-active-bg !default;\n$pagination-active-border-color:    $pagination-active-bg !default;\n\n$pagination-disabled-color:         $gray-600 !default;\n$pagination-disabled-bg:            $white !default;\n$pagination-disabled-border-color:  $gray-300 !default;\n\n$pagination-transition:              color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\n\n$pagination-border-radius-sm:       $border-radius-sm !default;\n$pagination-border-radius-lg:       $border-radius-lg !default;\n// scss-docs-end pagination-variables\n\n\n// Cards\n\n// scss-docs-start card-variables\n$card-spacer-y:                     $spacer !default;\n$card-spacer-x:                     $spacer !default;\n$card-title-spacer-y:               $spacer * .5 !default;\n$card-border-width:                 $border-width !default;\n$card-border-radius:                $border-radius !default;\n$card-border-color:                 rgba($black, .125) !default;\n$card-inner-border-radius:          subtract($card-border-radius, $card-border-width) !default;\n$card-cap-padding-y:                $card-spacer-y * .5 !default;\n$card-cap-padding-x:                $card-spacer-x !default;\n$card-cap-bg:                       rgba($black, .03) !default;\n$card-cap-color:                    null !default;\n$card-height:                       null !default;\n$card-color:                        null !default;\n$card-bg:                           $white !default;\n$card-img-overlay-padding:          $spacer !default;\n$card-group-margin:                 $grid-gutter-width * .5 !default;\n// scss-docs-end card-variables\n\n// Accordion\n\n// scss-docs-start accordion-variables\n$accordion-padding-y:                     1rem !default;\n$accordion-padding-x:                     1.25rem !default;\n$accordion-color:                         $body-color !default;\n$accordion-bg:                            $body-bg !default;\n$accordion-border-width:                  $border-width !default;\n$accordion-border-color:                  rgba($black, .125) !default;\n$accordion-border-radius:                 $border-radius !default;\n$accordion-inner-border-radius:           subtract($accordion-border-radius, $accordion-border-width) !default;\n\n$accordion-body-padding-y:                $accordion-padding-y !default;\n$accordion-body-padding-x:                $accordion-padding-x !default;\n\n$accordion-button-padding-y:              $accordion-padding-y !default;\n$accordion-button-padding-x:              $accordion-padding-x !default;\n$accordion-button-color:                  $accordion-color !default;\n$accordion-button-bg:                     $accordion-bg !default;\n$accordion-transition:                    $btn-transition, border-radius .15s ease !default;\n$accordion-button-active-bg:              tint-color($component-active-bg, 90%) !default;\n$accordion-button-active-color:           shade-color($primary, 10%) !default;\n\n$accordion-button-focus-border-color:     $input-focus-border-color !default;\n$accordion-button-focus-box-shadow:       $btn-focus-box-shadow !default;\n\n$accordion-icon-width:                    1.25rem !default;\n$accordion-icon-color:                    $accordion-color !default;\n$accordion-icon-active-color:             $accordion-button-active-color !default;\n$accordion-icon-transition:               transform .2s ease-in-out !default;\n$accordion-icon-transform:                rotate(-180deg) !default;\n\n$accordion-button-icon:         url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$accordion-icon-color}'><path fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/></svg>\") !default;\n$accordion-button-active-icon:  url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$accordion-icon-active-color}'><path fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/></svg>\") !default;\n// scss-docs-end accordion-variables\n\n// Tooltips\n\n// scss-docs-start tooltip-variables\n$tooltip-font-size:                 $font-size-sm !default;\n$tooltip-max-width:                 200px !default;\n$tooltip-color:                     $white !default;\n$tooltip-bg:                        $black !default;\n$tooltip-border-radius:             $border-radius !default;\n$tooltip-opacity:                   .9 !default;\n$tooltip-padding-y:                 $spacer * .25 !default;\n$tooltip-padding-x:                 $spacer * .5 !default;\n$tooltip-margin:                    0 !default;\n\n$tooltip-arrow-width:               .8rem !default;\n$tooltip-arrow-height:              .4rem !default;\n$tooltip-arrow-color:               $tooltip-bg !default;\n// scss-docs-end tooltip-variables\n\n// Form tooltips must come after regular tooltips\n// scss-docs-start tooltip-feedback-variables\n$form-feedback-tooltip-padding-y:     $tooltip-padding-y !default;\n$form-feedback-tooltip-padding-x:     $tooltip-padding-x !default;\n$form-feedback-tooltip-font-size:     $tooltip-font-size !default;\n$form-feedback-tooltip-line-height:   null !default;\n$form-feedback-tooltip-opacity:       $tooltip-opacity !default;\n$form-feedback-tooltip-border-radius: $tooltip-border-radius !default;\n// scss-docs-end tooltip-feedback-variables\n\n\n// Popovers\n\n// scss-docs-start popover-variables\n$popover-font-size:                 $font-size-sm !default;\n$popover-bg:                        $white !default;\n$popover-max-width:                 276px !default;\n$popover-border-width:              $border-width !default;\n$popover-border-color:              rgba($black, .2) !default;\n$popover-border-radius:             $border-radius-lg !default;\n$popover-inner-border-radius:       subtract($popover-border-radius, $popover-border-width) !default;\n$popover-box-shadow:                $box-shadow !default;\n\n$popover-header-bg:                 shade-color($popover-bg, 6%) !default;\n$popover-header-color:              $headings-color !default;\n$popover-header-padding-y:          .5rem !default;\n$popover-header-padding-x:          $spacer !default;\n\n$popover-body-color:                $body-color !default;\n$popover-body-padding-y:            $spacer !default;\n$popover-body-padding-x:            $spacer !default;\n\n$popover-arrow-width:               1rem !default;\n$popover-arrow-height:              .5rem !default;\n$popover-arrow-color:               $popover-bg !default;\n\n$popover-arrow-outer-color:         fade-in($popover-border-color, .05) !default;\n// scss-docs-end popover-variables\n\n\n// Toasts\n\n// scss-docs-start toast-variables\n$toast-max-width:                   350px !default;\n$toast-padding-x:                   .75rem !default;\n$toast-padding-y:                   .5rem !default;\n$toast-font-size:                   .875rem !default;\n$toast-color:                       null !default;\n$toast-background-color:            rgba($white, .85) !default;\n$toast-border-width:                1px !default;\n$toast-border-color:                rgba(0, 0, 0, .1) !default;\n$toast-border-radius:               $border-radius !default;\n$toast-box-shadow:                  $box-shadow !default;\n$toast-spacing:                     $container-padding-x !default;\n\n$toast-header-color:                $gray-600 !default;\n$toast-header-background-color:     rgba($white, .85) !default;\n$toast-header-border-color:         rgba(0, 0, 0, .05) !default;\n// scss-docs-end toast-variables\n\n\n// Badges\n\n// scss-docs-start badge-variables\n$badge-font-size:                   .75em !default;\n$badge-font-weight:                 $font-weight-bold !default;\n$badge-color:                       $white !default;\n$badge-padding-y:                   .35em !default;\n$badge-padding-x:                   .65em !default;\n$badge-border-radius:               $border-radius !default;\n// scss-docs-end badge-variables\n\n\n// Modals\n\n// scss-docs-start modal-variables\n$modal-inner-padding:               $spacer !default;\n\n$modal-footer-margin-between:       .5rem !default;\n\n$modal-dialog-margin:               .5rem !default;\n$modal-dialog-margin-y-sm-up:       1.75rem !default;\n\n$modal-title-line-height:           $line-height-base !default;\n\n$modal-content-color:               null !default;\n$modal-content-bg:                  $white !default;\n$modal-content-border-color:        rgba($black, .2) !default;\n$modal-content-border-width:        $border-width !default;\n$modal-content-border-radius:       $border-radius-lg !default;\n$modal-content-inner-border-radius: subtract($modal-content-border-radius, $modal-content-border-width) !default;\n$modal-content-box-shadow-xs:       $box-shadow-sm !default;\n$modal-content-box-shadow-sm-up:    $box-shadow !default;\n\n$modal-backdrop-bg:                 $black !default;\n$modal-backdrop-opacity:            .5 !default;\n$modal-header-border-color:         $border-color !default;\n$modal-footer-border-color:         $modal-header-border-color !default;\n$modal-header-border-width:         $modal-content-border-width !default;\n$modal-footer-border-width:         $modal-header-border-width !default;\n$modal-header-padding-y:            $modal-inner-padding !default;\n$modal-header-padding-x:            $modal-inner-padding !default;\n$modal-header-padding:              $modal-header-padding-y $modal-header-padding-x !default; // Keep this for backwards compatibility\n\n$modal-sm:                          300px !default;\n$modal-md:                          500px !default;\n$modal-lg:                          800px !default;\n$modal-xl:                          1140px !default;\n\n$modal-fade-transform:              translate(0, -50px) !default;\n$modal-show-transform:              none !default;\n$modal-transition:                  transform .3s ease-out !default;\n$modal-scale-transform:             scale(1.02) !default;\n// scss-docs-end modal-variables\n\n\n// Alerts\n//\n// Define alert colors, border radius, and padding.\n\n// scss-docs-start alert-variables\n$alert-padding-y:               $spacer !default;\n$alert-padding-x:               $spacer !default;\n$alert-margin-bottom:           1rem !default;\n$alert-border-radius:           $border-radius !default;\n$alert-link-font-weight:        $font-weight-bold !default;\n$alert-border-width:            $border-width !default;\n$alert-bg-scale:                -80% !default;\n$alert-border-scale:            -70% !default;\n$alert-color-scale:             40% !default;\n$alert-dismissible-padding-r:   $alert-padding-x * 3 !default; // 3x covers width of x plus default padding on either side\n// scss-docs-end alert-variables\n\n\n// Progress bars\n\n// scss-docs-start progress-variables\n$progress-height:                   1rem !default;\n$progress-font-size:                $font-size-base * .75 !default;\n$progress-bg:                       $gray-200 !default;\n$progress-border-radius:            $border-radius !default;\n$progress-box-shadow:               $box-shadow-inset !default;\n$progress-bar-color:                $white !default;\n$progress-bar-bg:                   $primary !default;\n$progress-bar-animation-timing:     1s linear infinite !default;\n$progress-bar-transition:           width .6s ease !default;\n// scss-docs-end progress-variables\n\n\n// List group\n\n// scss-docs-start list-group-variables\n$list-group-color:                  $gray-900 !default;\n$list-group-bg:                     $white !default;\n$list-group-border-color:           rgba($black, .125) !default;\n$list-group-border-width:           $border-width !default;\n$list-group-border-radius:          $border-radius !default;\n\n$list-group-item-padding-y:         $spacer * .5 !default;\n$list-group-item-padding-x:         $spacer !default;\n$list-group-item-bg-scale:          -80% !default;\n$list-group-item-color-scale:       40% !default;\n\n$list-group-hover-bg:               $gray-100 !default;\n$list-group-active-color:           $component-active-color !default;\n$list-group-active-bg:              $component-active-bg !default;\n$list-group-active-border-color:    $list-group-active-bg !default;\n\n$list-group-disabled-color:         $gray-600 !default;\n$list-group-disabled-bg:            $list-group-bg !default;\n\n$list-group-action-color:           $gray-700 !default;\n$list-group-action-hover-color:     $list-group-action-color !default;\n\n$list-group-action-active-color:    $body-color !default;\n$list-group-action-active-bg:       $gray-200 !default;\n// scss-docs-end list-group-variables\n\n\n// Image thumbnails\n\n// scss-docs-start thumbnail-variables\n$thumbnail-padding:                 .25rem !default;\n$thumbnail-bg:                      $body-bg !default;\n$thumbnail-border-width:            $border-width !default;\n$thumbnail-border-color:            $gray-300 !default;\n$thumbnail-border-radius:           $border-radius !default;\n$thumbnail-box-shadow:              $box-shadow-sm !default;\n// scss-docs-end thumbnail-variables\n\n\n// Figures\n\n// scss-docs-start figure-variables\n$figure-caption-font-size:          $small-font-size !default;\n$figure-caption-color:              $gray-600 !default;\n// scss-docs-end figure-variables\n\n\n// Breadcrumbs\n\n// scss-docs-start breadcrumb-variables\n$breadcrumb-font-size:              null !default;\n$breadcrumb-padding-y:              0 !default;\n$breadcrumb-padding-x:              0 !default;\n$breadcrumb-item-padding-x:         .5rem !default;\n$breadcrumb-margin-bottom:          1rem !default;\n$breadcrumb-bg:                     null !default;\n$breadcrumb-divider-color:          $gray-600 !default;\n$breadcrumb-active-color:           $gray-600 !default;\n$breadcrumb-divider:                quote(\"/\") !default;\n$breadcrumb-divider-flipped:        $breadcrumb-divider !default;\n$breadcrumb-border-radius:          null !default;\n// scss-docs-end breadcrumb-variables\n\n// Carousel\n\n// scss-docs-start carousel-variables\n$carousel-control-color:             $white !default;\n$carousel-control-width:             15% !default;\n$carousel-control-opacity:           .5 !default;\n$carousel-control-hover-opacity:     .9 !default;\n$carousel-control-transition:        opacity .15s ease !default;\n\n$carousel-indicator-width:           30px !default;\n$carousel-indicator-height:          3px !default;\n$carousel-indicator-hit-area-height: 10px !default;\n$carousel-indicator-spacer:          3px !default;\n$carousel-indicator-opacity:         .5 !default;\n$carousel-indicator-active-bg:       $white !default;\n$carousel-indicator-active-opacity:  1 !default;\n$carousel-indicator-transition:      opacity .6s ease !default;\n\n$carousel-caption-width:             70% !default;\n$carousel-caption-color:             $white !default;\n$carousel-caption-padding-y:         1.25rem !default;\n$carousel-caption-spacer:            1.25rem !default;\n\n$carousel-control-icon-width:        2rem !default;\n\n$carousel-control-prev-icon-bg:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$carousel-control-color}'><path d='M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z'/></svg>\") !default;\n$carousel-control-next-icon-bg:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$carousel-control-color}'><path d='M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z'/></svg>\") !default;\n\n$carousel-transition-duration:       .6s !default;\n$carousel-transition:                transform $carousel-transition-duration ease-in-out !default; // Define transform transition first if using multiple transitions (e.g., `transform 2s ease, opacity .5s ease-out`)\n\n$carousel-dark-indicator-active-bg:  $black !default;\n$carousel-dark-caption-color:        $black !default;\n$carousel-dark-control-icon-filter:  invert(1) grayscale(100) !default;\n// scss-docs-end carousel-variables\n\n\n// Spinners\n\n// scss-docs-start spinner-variables\n$spinner-width:           2rem !default;\n$spinner-height:          $spinner-width !default;\n$spinner-vertical-align:  -.125em !default;\n$spinner-border-width:    .25em !default;\n$spinner-animation-speed: .75s !default;\n\n$spinner-width-sm:        1rem !default;\n$spinner-height-sm:       $spinner-width-sm !default;\n$spinner-border-width-sm: .2em !default;\n// scss-docs-end spinner-variables\n\n\n// Close\n\n// scss-docs-start close-variables\n$btn-close-width:            1em !default;\n$btn-close-height:           $btn-close-width !default;\n$btn-close-padding-x:        .25em !default;\n$btn-close-padding-y:        $btn-close-padding-x !default;\n$btn-close-color:            $black !default;\n$btn-close-bg:               url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$btn-close-color}'><path d='M.293.293a1 1 0 011.414 0L8 6.586 14.293.293a1 1 0 111.414 1.414L9.414 8l6.293 6.293a1 1 0 01-1.414 1.414L8 9.414l-6.293 6.293a1 1 0 01-1.414-1.414L6.586 8 .293 1.707a1 1 0 010-1.414z'/></svg>\") !default;\n$btn-close-focus-shadow:     $input-btn-focus-box-shadow !default;\n$btn-close-opacity:          .5 !default;\n$btn-close-hover-opacity:    .75 !default;\n$btn-close-focus-opacity:    1 !default;\n$btn-close-disabled-opacity: .25 !default;\n$btn-close-white-filter:     invert(1) grayscale(100%) brightness(200%) !default;\n// scss-docs-end close-variables\n\n\n// Offcanvas\n\n// scss-docs-start offcanvas-variables\n$offcanvas-padding-y:               $modal-inner-padding !default;\n$offcanvas-padding-x:               $modal-inner-padding !default;\n$offcanvas-horizontal-width:        400px !default;\n$offcanvas-vertical-height:         30vh !default;\n$offcanvas-transition-duration:     .3s !default;\n$offcanvas-border-color:            $modal-content-border-color !default;\n$offcanvas-border-width:            $modal-content-border-width !default;\n$offcanvas-title-line-height:       $modal-title-line-height !default;\n$offcanvas-bg-color:                $modal-content-bg !default;\n$offcanvas-color:                   $modal-content-color !default;\n$offcanvas-box-shadow:              $modal-content-box-shadow-xs !default;\n// scss-docs-end offcanvas-variables\n\n// Code\n\n$code-font-size:                    $small-font-size !default;\n$code-color:                        $pink !default;\n\n$kbd-padding-y:                     .2rem !default;\n$kbd-padding-x:                     .4rem !default;\n$kbd-font-size:                     $code-font-size !default;\n$kbd-color:                         $white !default;\n$kbd-bg:                            $gray-900 !default;\n\n$pre-color:                         null !default;\n","// stylelint-disable property-disallowed-list\n// Single side border-radius\n\n// Helper function to replace negative values with 0\n@function valid-radius($radius) {\n  $return: ();\n  @each $value in $radius {\n    @if type-of($value) == number {\n      $return: append($return, max($value, 0));\n    } @else {\n      $return: append($return, $value);\n    }\n  }\n  @return $return;\n}\n\n// scss-docs-start border-radius-mixins\n@mixin border-radius($radius: $border-radius, $fallback-border-radius: false) {\n  @if $enable-rounded {\n    border-radius: valid-radius($radius);\n  }\n  @else if $fallback-border-radius != false {\n    border-radius: $fallback-border-radius;\n  }\n}\n\n@mixin border-top-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-top-left-radius: valid-radius($radius);\n    border-top-right-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-end-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-top-right-radius: valid-radius($radius);\n    border-bottom-right-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-bottom-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-bottom-right-radius: valid-radius($radius);\n    border-bottom-left-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-start-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-top-left-radius: valid-radius($radius);\n    border-bottom-left-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-top-start-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-top-left-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-top-end-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-top-right-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-bottom-end-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-bottom-right-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-bottom-start-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-bottom-left-radius: valid-radius($radius);\n  }\n}\n// scss-docs-end border-radius-mixins\n","//\n// Headings\n//\n.h1 {\n  @extend h1;\n}\n\n.h2 {\n  @extend h2;\n}\n\n.h3 {\n  @extend h3;\n}\n\n.h4 {\n  @extend h4;\n}\n\n.h5 {\n  @extend h5;\n}\n\n.h6 {\n  @extend h6;\n}\n\n\n.lead {\n  @include font-size($lead-font-size);\n  font-weight: $lead-font-weight;\n}\n\n// Type display classes\n@each $display, $font-size in $display-font-sizes {\n  .display-#{$display} {\n    @include font-size($font-size);\n    font-weight: $display-font-weight;\n    line-height: $display-line-height;\n  }\n}\n\n//\n// Emphasis\n//\n.small {\n  @extend small;\n}\n\n.mark {\n  @extend mark;\n}\n\n//\n// Lists\n//\n\n.list-unstyled {\n  @include list-unstyled();\n}\n\n// Inline turns list items into inline-block\n.list-inline {\n  @include list-unstyled();\n}\n.list-inline-item {\n  display: inline-block;\n\n  &:not(:last-child) {\n    margin-right: $list-inline-padding;\n  }\n}\n\n\n//\n// Misc\n//\n\n// Builds on `abbr`\n.initialism {\n  @include font-size($initialism-font-size);\n  text-transform: uppercase;\n}\n\n// Blockquotes\n.blockquote {\n  margin-bottom: $blockquote-margin-y;\n  @include font-size($blockquote-font-size);\n\n  > :last-child {\n    margin-bottom: 0;\n  }\n}\n\n.blockquote-footer {\n  margin-top: -$blockquote-margin-y;\n  margin-bottom: $blockquote-margin-y;\n  @include font-size($blockquote-footer-font-size);\n  color: $blockquote-footer-color;\n\n  &::before {\n    content: \"\\2014\\00A0\"; // em dash, nbsp\n  }\n}\n","// Lists\n\n// Unstyled keeps list items block level, just removes default browser padding and list-style\n@mixin list-unstyled {\n  padding-left: 0;\n  list-style: none;\n}\n","// Responsive images (ensure images don't scale beyond their parents)\n//\n// This is purposefully opt-in via an explicit class rather than being the default for all `<img>`s.\n// We previously tried the \"images are responsive by default\" approach in Bootstrap v2,\n// and abandoned it in Bootstrap v3 because it breaks lots of third-party widgets (including Google Maps)\n// which weren't expecting the images within themselves to be involuntarily resized.\n// See also https://github.com/twbs/bootstrap/issues/18178\n.img-fluid {\n  @include img-fluid();\n}\n\n\n// Image thumbnails\n.img-thumbnail {\n  padding: $thumbnail-padding;\n  background-color: $thumbnail-bg;\n  border: $thumbnail-border-width solid $thumbnail-border-color;\n  @include border-radius($thumbnail-border-radius);\n  @include box-shadow($thumbnail-box-shadow);\n\n  // Keep them at most 100% wide\n  @include img-fluid();\n}\n\n//\n// Figures\n//\n\n.figure {\n  // Ensures the caption's text aligns with the image.\n  display: inline-block;\n}\n\n.figure-img {\n  margin-bottom: $spacer * .5;\n  line-height: 1;\n}\n\n.figure-caption {\n  @include font-size($figure-caption-font-size);\n  color: $figure-caption-color;\n}\n","// Image Mixins\n// - Responsive image\n// - Retina image\n\n\n// Responsive image\n//\n// Keep images from scaling beyond the width of their parents.\n\n@mixin img-fluid {\n  // Part 1: Set a maximum relative to the parent\n  max-width: 100%;\n  // Part 2: Override the height to auto, otherwise images will be stretched\n  // when setting a width and height attribute on the img element.\n  height: auto;\n}\n","@mixin box-shadow($shadow...) {\n  @if $enable-shadows {\n    $result: ();\n\n    @each $value in $shadow {\n      @if $value != null {\n        $result: append($result, $value, \"comma\");\n      }\n      @if $value == none and length($shadow) > 1 {\n        @warn \"The keyword 'none' must be used as a single argument.\";\n      }\n    }\n\n    @if (length($result) > 0) {\n      box-shadow: $result;\n    }\n  }\n}\n","// Row\n//\n// Rows contain your columns.\n\n@if $enable-grid-classes {\n  .row {\n    @include make-row();\n\n    > * {\n      @include make-col-ready();\n    }\n  }\n}\n\n\n// Columns\n//\n// Common styles for small and large grid columns\n\n@if $enable-grid-classes {\n  @include make-grid-columns();\n}\n","// Grid system\n//\n// Generate semantic grid columns with these mixins.\n\n@mixin make-row($gutter: $grid-gutter-width) {\n  --#{$variable-prefix}gutter-x: #{$gutter};\n  --#{$variable-prefix}gutter-y: 0;\n  display: flex;\n  flex-wrap: wrap;\n  margin-top: calc(var(--#{$variable-prefix}gutter-y) * -1); // stylelint-disable-line function-disallowed-list\n  margin-right: calc(var(--#{$variable-prefix}gutter-x) * -.5); // stylelint-disable-line function-disallowed-list\n  margin-left: calc(var(--#{$variable-prefix}gutter-x) * -.5); // stylelint-disable-line function-disallowed-list\n}\n\n@mixin make-col-ready($gutter: $grid-gutter-width) {\n  // Add box sizing if only the grid is loaded\n  box-sizing: if(variable-exists(include-column-box-sizing) and $include-column-box-sizing, border-box, null);\n  // Prevent columns from becoming too narrow when at smaller grid tiers by\n  // always setting `width: 100%;`. This works because we set the width\n  // later on to override this initial width.\n  flex-shrink: 0;\n  width: 100%;\n  max-width: 100%; // Prevent `.col-auto`, `.col` (& responsive variants) from breaking out the grid\n  padding-right: calc(var(--#{$variable-prefix}gutter-x) * .5); // stylelint-disable-line function-disallowed-list\n  padding-left: calc(var(--#{$variable-prefix}gutter-x) * .5); // stylelint-disable-line function-disallowed-list\n  margin-top: var(--#{$variable-prefix}gutter-y);\n}\n\n@mixin make-col($size: false, $columns: $grid-columns) {\n  @if $size {\n    flex: 0 0 auto;\n    width: percentage(divide($size, $columns));\n\n  } @else {\n    flex: 1 1 0;\n    max-width: 100%;\n  }\n}\n\n@mixin make-col-auto() {\n  flex: 0 0 auto;\n  width: auto;\n}\n\n@mixin make-col-offset($size, $columns: $grid-columns) {\n  $num: divide($size, $columns);\n  margin-left: if($num == 0, 0, percentage($num));\n}\n\n// Row columns\n//\n// Specify on a parent element(e.g., .row) to force immediate children into NN\n// numberof columns. Supports wrapping to new lines, but does not do a Masonry\n// style grid.\n@mixin row-cols($count) {\n  > * {\n    flex: 0 0 auto;\n    width: divide(100%, $count);\n  }\n}\n\n// Framework grid generation\n//\n// Used only by Bootstrap to generate the correct number of grid classes given\n// any value of `$grid-columns`.\n\n@mixin make-grid-columns($columns: $grid-columns, $gutter: $grid-gutter-width, $breakpoints: $grid-breakpoints) {\n  @each $breakpoint in map-keys($breakpoints) {\n    // .row-cols defaults must all appear before .col overrides so they can be overridden.\n    $infix: breakpoint-infix($breakpoint, $breakpoints);\n    @include media-breakpoint-up($breakpoint, $breakpoints) {\n      // Provide basic `.col-{bp}` classes for equal-width flexbox columns\n      .col#{$infix} {\n        flex: 1 0 0%; // Flexbugs #4: https://github.com/philipwalton/flexbugs#flexbug-4\n      }\n\n      .row-cols#{$infix}-auto > * {\n        @include make-col-auto();\n      }\n\n      @if $grid-row-columns > 0 {\n        @for $i from 1 through $grid-row-columns {\n          .row-cols#{$infix}-#{$i} {\n            @include row-cols($i);\n          }\n        }\n      }\n    }\n  }\n\n  @each $breakpoint in map-keys($breakpoints) {\n    $infix: breakpoint-infix($breakpoint, $breakpoints);\n\n    @include media-breakpoint-up($breakpoint, $breakpoints) {\n      .col#{$infix}-auto {\n        @include make-col-auto();\n      }\n\n      @if $columns > 0 {\n        @for $i from 1 through $columns {\n          .col#{$infix}-#{$i} {\n            @include make-col($i, $columns);\n          }\n        }\n\n        // `$columns - 1` because offsetting by the width of an entire row isn't possible\n        @for $i from 0 through ($columns - 1) {\n          @if not ($infix == \"\" and $i == 0) { // Avoid emitting useless .offset-0\n            .offset#{$infix}-#{$i} {\n              @include make-col-offset($i, $columns);\n            }\n          }\n        }\n      }\n\n      // Gutters\n      //\n      // Make use of `.g-*`, `.gx-*` or `.gy-*` utilities to change spacing between the columns.\n      @each $key, $value in $gutters {\n        .g#{$infix}-#{$key},\n        .gx#{$infix}-#{$key} {\n          --#{$variable-prefix}gutter-x: #{$value};\n        }\n\n        .g#{$infix}-#{$key},\n        .gy#{$infix}-#{$key} {\n          --#{$variable-prefix}gutter-y: #{$value};\n        }\n      }\n    }\n  }\n}\n","// Breakpoint viewport sizes and media queries.\n//\n// Breakpoints are defined as a map of (name: minimum width), order from small to large:\n//\n//    (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px)\n//\n// The map defined in the `$grid-breakpoints` global variable is used as the `$breakpoints` argument by default.\n\n// Name of the next breakpoint, or null for the last breakpoint.\n//\n//    >> breakpoint-next(sm)\n//    md\n//    >> breakpoint-next(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px))\n//    md\n//    >> breakpoint-next(sm, $breakpoint-names: (xs sm md lg xl))\n//    md\n@function breakpoint-next($name, $breakpoints: $grid-breakpoints, $breakpoint-names: map-keys($breakpoints)) {\n  $n: index($breakpoint-names, $name);\n  @if not $n {\n    @error \"breakpoint `#{$name}` not found in `#{$breakpoints}`\";\n  }\n  @return if($n < length($breakpoint-names), nth($breakpoint-names, $n + 1), null);\n}\n\n// Minimum breakpoint width. Null for the smallest (first) breakpoint.\n//\n//    >> breakpoint-min(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px))\n//    576px\n@function breakpoint-min($name, $breakpoints: $grid-breakpoints) {\n  $min: map-get($breakpoints, $name);\n  @return if($min != 0, $min, null);\n}\n\n// Maximum breakpoint width.\n// The maximum value is reduced by 0.02px to work around the limitations of\n// `min-` and `max-` prefixes and viewports with fractional widths.\n// See https://www.w3.org/TR/mediaqueries-4/#mq-min-max\n// Uses 0.02px rather than 0.01px to work around a current rounding bug in Safari.\n// See https://bugs.webkit.org/show_bug.cgi?id=178261\n//\n//    >> breakpoint-max(md, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px))\n//    767.98px\n@function breakpoint-max($name, $breakpoints: $grid-breakpoints) {\n  $max: map-get($breakpoints, $name);\n  @return if($max and $max > 0, $max - .02, null);\n}\n\n// Returns a blank string if smallest breakpoint, otherwise returns the name with a dash in front.\n// Useful for making responsive utilities.\n//\n//    >> breakpoint-infix(xs, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px))\n//    \"\"  (Returns a blank string)\n//    >> breakpoint-infix(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px))\n//    \"-sm\"\n@function breakpoint-infix($name, $breakpoints: $grid-breakpoints) {\n  @return if(breakpoint-min($name, $breakpoints) == null, \"\", \"-#{$name}\");\n}\n\n// Media of at least the minimum breakpoint width. No query for the smallest breakpoint.\n// Makes the @content apply to the given breakpoint and wider.\n@mixin media-breakpoint-up($name, $breakpoints: $grid-breakpoints) {\n  $min: breakpoint-min($name, $breakpoints);\n  @if $min {\n    @media (min-width: $min) {\n      @content;\n    }\n  } @else {\n    @content;\n  }\n}\n\n// Media of at most the maximum breakpoint width. No query for the largest breakpoint.\n// Makes the @content apply to the given breakpoint and narrower.\n@mixin media-breakpoint-down($name, $breakpoints: $grid-breakpoints) {\n  $max: breakpoint-max($name, $breakpoints);\n  @if $max {\n    @media (max-width: $max) {\n      @content;\n    }\n  } @else {\n    @content;\n  }\n}\n\n// Media that spans multiple breakpoint widths.\n// Makes the @content apply between the min and max breakpoints\n@mixin media-breakpoint-between($lower, $upper, $breakpoints: $grid-breakpoints) {\n  $min: breakpoint-min($lower, $breakpoints);\n  $max: breakpoint-max($upper, $breakpoints);\n\n  @if $min != null and $max != null {\n    @media (min-width: $min) and (max-width: $max) {\n      @content;\n    }\n  } @else if $max == null {\n    @include media-breakpoint-up($lower, $breakpoints) {\n      @content;\n    }\n  } @else if $min == null {\n    @include media-breakpoint-down($upper, $breakpoints) {\n      @content;\n    }\n  }\n}\n\n// Media between the breakpoint's minimum and maximum widths.\n// No minimum for the smallest breakpoint, and no maximum for the largest one.\n// Makes the @content apply only to the given breakpoint, not viewports any wider or narrower.\n@mixin media-breakpoint-only($name, $breakpoints: $grid-breakpoints) {\n  $min:  breakpoint-min($name, $breakpoints);\n  $next: breakpoint-next($name, $breakpoints);\n  $max:  breakpoint-max($next);\n\n  @if $min != null and $max != null {\n    @media (min-width: $min) and (max-width: $max) {\n      @content;\n    }\n  } @else if $max == null {\n    @include media-breakpoint-up($name, $breakpoints) {\n      @content;\n    }\n  } @else if $min == null {\n    @include media-breakpoint-down($next, $breakpoints) {\n      @content;\n    }\n  }\n}\n","//\n// Basic Bootstrap table\n//\n\n.table {\n  --#{$variable-prefix}table-bg: #{$table-bg};\n  --#{$variable-prefix}table-accent-bg: #{$table-accent-bg};\n  --#{$variable-prefix}table-striped-color: #{$table-striped-color};\n  --#{$variable-prefix}table-striped-bg: #{$table-striped-bg};\n  --#{$variable-prefix}table-active-color: #{$table-active-color};\n  --#{$variable-prefix}table-active-bg: #{$table-active-bg};\n  --#{$variable-prefix}table-hover-color: #{$table-hover-color};\n  --#{$variable-prefix}table-hover-bg: #{$table-hover-bg};\n\n  width: 100%;\n  margin-bottom: $spacer;\n  color: $table-color;\n  vertical-align: $table-cell-vertical-align;\n  border-color: $table-border-color;\n\n  // Target th & td\n  // We need the child combinator to prevent styles leaking to nested tables which doesn't have a `.table` class.\n  // We use the universal selectors here to simplify the selector (else we would need 6 different selectors).\n  // Another advantage is that this generates less code and makes the selector less specific making it easier to override.\n  // stylelint-disable-next-line selector-max-universal\n  > :not(caption) > * > * {\n    padding: $table-cell-padding-y $table-cell-padding-x;\n    background-color: var(--#{$variable-prefix}table-bg);\n    border-bottom-width: $table-border-width;\n    box-shadow: inset 0 0 0 9999px var(--#{$variable-prefix}table-accent-bg);\n  }\n\n  > tbody {\n    vertical-align: inherit;\n  }\n\n  > thead {\n    vertical-align: bottom;\n  }\n\n  // Highlight border color between thead, tbody and tfoot.\n  > :not(:last-child) > :last-child > * {\n    border-bottom-color: $table-group-separator-color;\n  }\n}\n\n\n//\n// Change placement of captions with a class\n//\n\n.caption-top {\n  caption-side: top;\n}\n\n\n//\n// Condensed table w/ half padding\n//\n\n.table-sm {\n  // stylelint-disable-next-line selector-max-universal\n  > :not(caption) > * > * {\n    padding: $table-cell-padding-y-sm $table-cell-padding-x-sm;\n  }\n}\n\n\n// Border versions\n//\n// Add or remove borders all around the table and between all the columns.\n//\n// When borders are added on all sides of the cells, the corners can render odd when\n// these borders do not have the same color or if they are semi-transparent.\n// Therefor we add top and border bottoms to the `tr`s and left and right borders\n// to the `td`s or `th`s\n\n.table-bordered {\n  > :not(caption) > * {\n    border-width: $table-border-width 0;\n\n    // stylelint-disable-next-line selector-max-universal\n    > * {\n      border-width: 0 $table-border-width;\n    }\n  }\n}\n\n.table-borderless {\n  // stylelint-disable-next-line selector-max-universal\n  > :not(caption) > * > * {\n    border-bottom-width: 0;\n  }\n}\n\n// Zebra-striping\n//\n// Default zebra-stripe styles (alternating gray and transparent backgrounds)\n\n.table-striped {\n  > tbody > tr:nth-of-type(#{$table-striped-order}) {\n    --#{$variable-prefix}table-accent-bg: var(--#{$variable-prefix}table-striped-bg);\n    color: var(--#{$variable-prefix}table-striped-color);\n  }\n}\n\n// Active table\n//\n// The `.table-active` class can be added to highlight rows or cells\n\n.table-active {\n  --#{$variable-prefix}table-accent-bg: var(--#{$variable-prefix}table-active-bg);\n  color: var(--#{$variable-prefix}table-active-color);\n}\n\n// Hover effect\n//\n// Placed here since it has to come after the potential zebra striping\n\n.table-hover {\n  > tbody > tr:hover {\n    --#{$variable-prefix}table-accent-bg: var(--#{$variable-prefix}table-hover-bg);\n    color: var(--#{$variable-prefix}table-hover-color);\n  }\n}\n\n\n// Table variants\n//\n// Table variants set the table cell backgrounds, border colors\n// and the colors of the striped, hovered & active tables\n\n@each $color, $value in $table-variants {\n  @include table-variant($color, $value);\n}\n\n// Responsive tables\n//\n// Generate series of `.table-responsive-*` classes for configuring the screen\n// size of where your table will overflow.\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n  @include media-breakpoint-down($breakpoint) {\n    .table-responsive#{$infix} {\n      overflow-x: auto;\n      -webkit-overflow-scrolling: touch;\n    }\n  }\n}\n","// scss-docs-start table-variant\n@mixin table-variant($state, $background) {\n  .table-#{$state} {\n    $color: color-contrast(opaque($body-bg, $background));\n    $hover-bg: mix($color, $background, percentage($table-hover-bg-factor));\n    $striped-bg: mix($color, $background, percentage($table-striped-bg-factor));\n    $active-bg: mix($color, $background, percentage($table-active-bg-factor));\n\n    --#{$variable-prefix}table-bg: #{$background};\n    --#{$variable-prefix}table-striped-bg: #{$striped-bg};\n    --#{$variable-prefix}table-striped-color: #{color-contrast($striped-bg)};\n    --#{$variable-prefix}table-active-bg: #{$active-bg};\n    --#{$variable-prefix}table-active-color: #{color-contrast($active-bg)};\n    --#{$variable-prefix}table-hover-bg: #{$hover-bg};\n    --#{$variable-prefix}table-hover-color: #{color-contrast($hover-bg)};\n\n    color: $color;\n    border-color: mix($color, $background, percentage($table-border-factor));\n  }\n}\n// scss-docs-end table-variant\n","//\n// Labels\n//\n\n.form-label {\n  margin-bottom: $form-label-margin-bottom;\n  @include font-size($form-label-font-size);\n  font-style: $form-label-font-style;\n  font-weight: $form-label-font-weight;\n  color: $form-label-color;\n}\n\n// For use with horizontal and inline forms, when you need the label (or legend)\n// text to align with the form controls.\n.col-form-label {\n  padding-top: add($input-padding-y, $input-border-width);\n  padding-bottom: add($input-padding-y, $input-border-width);\n  margin-bottom: 0; // Override the `<legend>` default\n  @include font-size(inherit); // Override the `<legend>` default\n  font-style: $form-label-font-style;\n  font-weight: $form-label-font-weight;\n  line-height: $input-line-height;\n  color: $form-label-color;\n}\n\n.col-form-label-lg {\n  padding-top: add($input-padding-y-lg, $input-border-width);\n  padding-bottom: add($input-padding-y-lg, $input-border-width);\n  @include font-size($input-font-size-lg);\n}\n\n.col-form-label-sm {\n  padding-top: add($input-padding-y-sm, $input-border-width);\n  padding-bottom: add($input-padding-y-sm, $input-border-width);\n  @include font-size($input-font-size-sm);\n}\n","//\n// Form text\n//\n\n.form-text {\n  margin-top: $form-text-margin-top;\n  @include font-size($form-text-font-size);\n  font-style: $form-text-font-style;\n  font-weight: $form-text-font-weight;\n  color: $form-text-color;\n}\n","//\n// General form controls (plus a few specific high-level interventions)\n//\n\n.form-control {\n  display: block;\n  width: 100%;\n  padding: $input-padding-y $input-padding-x;\n  font-family: $input-font-family;\n  @include font-size($input-font-size);\n  font-weight: $input-font-weight;\n  line-height: $input-line-height;\n  color: $input-color;\n  background-color: $input-bg;\n  background-clip: padding-box;\n  border: $input-border-width solid $input-border-color;\n  appearance: none; // Fix appearance for date inputs in Safari\n\n  // Note: This has no effect on <select>s in some browsers, due to the limited stylability of `<select>`s in CSS.\n  @include border-radius($input-border-radius, 0);\n\n  @include box-shadow($input-box-shadow);\n  @include transition($input-transition);\n\n  &[type=\"file\"] {\n    overflow: hidden; // prevent pseudo element button overlap\n\n    &:not(:disabled):not([readonly]) {\n      cursor: pointer;\n    }\n  }\n\n  // Customize the `:focus` state to imitate native WebKit styles.\n  &:focus {\n    color: $input-focus-color;\n    background-color: $input-focus-bg;\n    border-color: $input-focus-border-color;\n    outline: 0;\n    @if $enable-shadows {\n      @include box-shadow($input-box-shadow, $input-focus-box-shadow);\n    } @else {\n      // Avoid using mixin so we can pass custom focus shadow properly\n      box-shadow: $input-focus-box-shadow;\n    }\n  }\n\n  // Add some height to date inputs on iOS\n  // https://github.com/twbs/bootstrap/issues/23307\n  // TODO: we can remove this workaround once https://bugs.webkit.org/show_bug.cgi?id=198959 is resolved\n  &::-webkit-date-and-time-value {\n    // Multiply line-height by 1em if it has no unit\n    height: if(unit($input-line-height) == \"\", $input-line-height * 1em, $input-line-height);\n  }\n\n  // Placeholder\n  &::placeholder {\n    color: $input-placeholder-color;\n    // Override Firefox's unusual default opacity; see https://github.com/twbs/bootstrap/pull/11526.\n    opacity: 1;\n  }\n\n  // Disabled and read-only inputs\n  //\n  // HTML5 says that controls under a fieldset > legend:first-child won't be\n  // disabled if the fieldset is disabled. Due to implementation difficulty, we\n  // don't honor that edge case; we style them as disabled anyway.\n  &:disabled,\n  &[readonly] {\n    background-color: $input-disabled-bg;\n    border-color: $input-disabled-border-color;\n    // iOS fix for unreadable disabled content; see https://github.com/twbs/bootstrap/issues/11655.\n    opacity: 1;\n  }\n\n  // File input buttons theming\n  &::file-selector-button {\n    padding: $input-padding-y $input-padding-x;\n    margin: (-$input-padding-y) (-$input-padding-x);\n    margin-inline-end: $input-padding-x;\n    color: $form-file-button-color;\n    @include gradient-bg($form-file-button-bg);\n    pointer-events: none;\n    border-color: inherit;\n    border-style: solid;\n    border-width: 0;\n    border-inline-end-width: $input-border-width;\n    border-radius: 0; // stylelint-disable-line property-disallowed-list\n    @include transition($btn-transition);\n  }\n\n  &:hover:not(:disabled):not([readonly])::file-selector-button {\n    background-color: $form-file-button-hover-bg;\n  }\n\n  &::-webkit-file-upload-button {\n    padding: $input-padding-y $input-padding-x;\n    margin: (-$input-padding-y) (-$input-padding-x);\n    margin-inline-end: $input-padding-x;\n    color: $form-file-button-color;\n    @include gradient-bg($form-file-button-bg);\n    pointer-events: none;\n    border-color: inherit;\n    border-style: solid;\n    border-width: 0;\n    border-inline-end-width: $input-border-width;\n    border-radius: 0; // stylelint-disable-line property-disallowed-list\n    @include transition($btn-transition);\n  }\n\n  &:hover:not(:disabled):not([readonly])::-webkit-file-upload-button {\n    background-color: $form-file-button-hover-bg;\n  }\n}\n\n// Readonly controls as plain text\n//\n// Apply class to a readonly input to make it appear like regular plain\n// text (without any border, background color, focus indicator)\n\n.form-control-plaintext {\n  display: block;\n  width: 100%;\n  padding: $input-padding-y 0;\n  margin-bottom: 0; // match inputs if this class comes on inputs with default margins\n  line-height: $input-line-height;\n  color: $input-plaintext-color;\n  background-color: transparent;\n  border: solid transparent;\n  border-width: $input-border-width 0;\n\n  &.form-control-sm,\n  &.form-control-lg {\n    padding-right: 0;\n    padding-left: 0;\n  }\n}\n\n// Form control sizing\n//\n// Build on `.form-control` with modifier classes to decrease or increase the\n// height and font-size of form controls.\n//\n// Repeated in `_input_group.scss` to avoid Sass extend issues.\n\n.form-control-sm {\n  min-height: $input-height-sm;\n  padding: $input-padding-y-sm $input-padding-x-sm;\n  @include font-size($input-font-size-sm);\n  @include border-radius($input-border-radius-sm);\n\n  &::file-selector-button {\n    padding: $input-padding-y-sm $input-padding-x-sm;\n    margin: (-$input-padding-y-sm) (-$input-padding-x-sm);\n    margin-inline-end: $input-padding-x-sm;\n  }\n\n  &::-webkit-file-upload-button {\n    padding: $input-padding-y-sm $input-padding-x-sm;\n    margin: (-$input-padding-y-sm) (-$input-padding-x-sm);\n    margin-inline-end: $input-padding-x-sm;\n  }\n}\n\n.form-control-lg {\n  min-height: $input-height-lg;\n  padding: $input-padding-y-lg $input-padding-x-lg;\n  @include font-size($input-font-size-lg);\n  @include border-radius($input-border-radius-lg);\n\n  &::file-selector-button {\n    padding: $input-padding-y-lg $input-padding-x-lg;\n    margin: (-$input-padding-y-lg) (-$input-padding-x-lg);\n    margin-inline-end: $input-padding-x-lg;\n  }\n\n  &::-webkit-file-upload-button {\n    padding: $input-padding-y-lg $input-padding-x-lg;\n    margin: (-$input-padding-y-lg) (-$input-padding-x-lg);\n    margin-inline-end: $input-padding-x-lg;\n  }\n}\n\n// Make sure textareas don't shrink too much when resized\n// https://github.com/twbs/bootstrap/pull/29124\n// stylelint-disable selector-no-qualifying-type\ntextarea {\n  &.form-control {\n    min-height: $input-height;\n  }\n\n  &.form-control-sm {\n    min-height: $input-height-sm;\n  }\n\n  &.form-control-lg {\n    min-height: $input-height-lg;\n  }\n}\n// stylelint-enable selector-no-qualifying-type\n\n.form-control-color {\n  max-width: 3rem;\n  height: auto; // Override fixed browser height\n  padding: $input-padding-y;\n\n  &:not(:disabled):not([readonly]) {\n    cursor: pointer;\n  }\n\n  &::-moz-color-swatch {\n    height: if(unit($input-line-height) == \"\", $input-line-height * 1em, $input-line-height);\n    @include border-radius($input-border-radius);\n  }\n\n  &::-webkit-color-swatch {\n    height: if(unit($input-line-height) == \"\", $input-line-height * 1em, $input-line-height);\n    @include border-radius($input-border-radius);\n  }\n}\n","// stylelint-disable property-disallowed-list\n@mixin transition($transition...) {\n  @if length($transition) == 0 {\n    $transition: $transition-base;\n  }\n\n  @if length($transition) > 1 {\n    @each $value in $transition {\n      @if $value == null or $value == none {\n        @warn \"The keyword 'none' or 'null' must be used as a single argument.\";\n      }\n    }\n  }\n\n  @if $enable-transitions {\n    @if nth($transition, 1) != null {\n      transition: $transition;\n    }\n\n    @if $enable-reduced-motion and nth($transition, 1) != null and nth($transition, 1) != none {\n      @media (prefers-reduced-motion: reduce) {\n        transition: none;\n      }\n    }\n  }\n}\n","// Gradients\n\n// scss-docs-start gradient-bg-mixin\n@mixin gradient-bg($color: null) {\n  background-color: $color;\n\n  @if $enable-gradients {\n    background-image: var(--#{$variable-prefix}gradient);\n  }\n}\n// scss-docs-end gradient-bg-mixin\n\n// scss-docs-start gradient-mixins\n// Horizontal gradient, from left to right\n//\n// Creates two color stops, start and end, by specifying a color and position for each color stop.\n@mixin gradient-x($start-color: $gray-700, $end-color: $gray-800, $start-percent: 0%, $end-percent: 100%) {\n  background-image: linear-gradient(to right, $start-color $start-percent, $end-color $end-percent);\n}\n\n// Vertical gradient, from top to bottom\n//\n// Creates two color stops, start and end, by specifying a color and position for each color stop.\n@mixin gradient-y($start-color: $gray-700, $end-color: $gray-800, $start-percent: null, $end-percent: null) {\n  background-image: linear-gradient(to bottom, $start-color $start-percent, $end-color $end-percent);\n}\n\n@mixin gradient-directional($start-color: $gray-700, $end-color: $gray-800, $deg: 45deg) {\n  background-image: linear-gradient($deg, $start-color, $end-color);\n}\n\n@mixin gradient-x-three-colors($start-color: $blue, $mid-color: $purple, $color-stop: 50%, $end-color: $red) {\n  background-image: linear-gradient(to right, $start-color, $mid-color $color-stop, $end-color);\n}\n\n@mixin gradient-y-three-colors($start-color: $blue, $mid-color: $purple, $color-stop: 50%, $end-color: $red) {\n  background-image: linear-gradient($start-color, $mid-color $color-stop, $end-color);\n}\n\n@mixin gradient-radial($inner-color: $gray-700, $outer-color: $gray-800) {\n  background-image: radial-gradient(circle, $inner-color, $outer-color);\n}\n\n@mixin gradient-striped($color: rgba($white, .15), $angle: 45deg) {\n  background-image: linear-gradient($angle, $color 25%, transparent 25%, transparent 50%, $color 50%, $color 75%, transparent 75%, transparent);\n}\n// scss-docs-end gradient-mixins\n","// Select\n//\n// Replaces the browser default select with a custom one, mostly pulled from\n// https://primer.github.io/.\n\n.form-select {\n  display: block;\n  width: 100%;\n  padding: $form-select-padding-y $form-select-indicator-padding $form-select-padding-y $form-select-padding-x;\n  // stylelint-disable-next-line property-no-vendor-prefix\n  -moz-padding-start: subtract($form-select-padding-x, 3px); // See https://github.com/twbs/bootstrap/issues/32636\n  font-family: $form-select-font-family;\n  @include font-size($form-select-font-size);\n  font-weight: $form-select-font-weight;\n  line-height: $form-select-line-height;\n  color: $form-select-color;\n  background-color: $form-select-bg;\n  background-image: escape-svg($form-select-indicator);\n  background-repeat: no-repeat;\n  background-position: $form-select-bg-position;\n  background-size: $form-select-bg-size;\n  border: $form-select-border-width solid $form-select-border-color;\n  @include border-radius($form-select-border-radius, 0);\n  @include box-shadow($form-select-box-shadow);\n  @include transition($form-select-transition);\n  appearance: none;\n\n  &:focus {\n    border-color: $form-select-focus-border-color;\n    outline: 0;\n    @if $enable-shadows {\n      @include box-shadow($form-select-box-shadow, $form-select-focus-box-shadow);\n    } @else {\n      // Avoid using mixin so we can pass custom focus shadow properly\n      box-shadow: $form-select-focus-box-shadow;\n    }\n  }\n\n  &[multiple],\n  &[size]:not([size=\"1\"]) {\n    padding-right: $form-select-padding-x;\n    background-image: none;\n  }\n\n  &:disabled {\n    color: $form-select-disabled-color;\n    background-color: $form-select-disabled-bg;\n    border-color: $form-select-disabled-border-color;\n  }\n\n  // Remove outline from select box in FF\n  &:-moz-focusring {\n    color: transparent;\n    text-shadow: 0 0 0 $form-select-color;\n  }\n}\n\n.form-select-sm {\n  padding-top: $form-select-padding-y-sm;\n  padding-bottom: $form-select-padding-y-sm;\n  padding-left: $form-select-padding-x-sm;\n  @include font-size($form-select-font-size-sm);\n}\n\n.form-select-lg {\n  padding-top: $form-select-padding-y-lg;\n  padding-bottom: $form-select-padding-y-lg;\n  padding-left: $form-select-padding-x-lg;\n  @include font-size($form-select-font-size-lg);\n}\n","//\n// Check/radio\n//\n\n.form-check {\n  display: block;\n  min-height: $form-check-min-height;\n  padding-left: $form-check-padding-start;\n  margin-bottom: $form-check-margin-bottom;\n\n  .form-check-input {\n    float: left;\n    margin-left: $form-check-padding-start * -1;\n  }\n}\n\n.form-check-input {\n  width: $form-check-input-width;\n  height: $form-check-input-width;\n  margin-top: ($line-height-base - $form-check-input-width) * .5; // line-height minus check height\n  vertical-align: top;\n  background-color: $form-check-input-bg;\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: contain;\n  border: $form-check-input-border;\n  appearance: none;\n  color-adjust: exact; // Keep themed appearance for print\n  @include transition($form-check-transition);\n\n  &[type=\"checkbox\"] {\n    @include border-radius($form-check-input-border-radius);\n  }\n\n  &[type=\"radio\"] {\n    // stylelint-disable-next-line property-disallowed-list\n    border-radius: $form-check-radio-border-radius;\n  }\n\n  &:active {\n    filter: $form-check-input-active-filter;\n  }\n\n  &:focus {\n    border-color: $form-check-input-focus-border;\n    outline: 0;\n    box-shadow: $form-check-input-focus-box-shadow;\n  }\n\n  &:checked {\n    background-color: $form-check-input-checked-bg-color;\n    border-color: $form-check-input-checked-border-color;\n\n    &[type=\"checkbox\"] {\n      @if $enable-gradients {\n        background-image: escape-svg($form-check-input-checked-bg-image), var(--#{$variable-prefix}gradient);\n      } @else {\n        background-image: escape-svg($form-check-input-checked-bg-image);\n      }\n    }\n\n    &[type=\"radio\"] {\n      @if $enable-gradients {\n        background-image: escape-svg($form-check-radio-checked-bg-image), var(--#{$variable-prefix}gradient);\n      } @else {\n        background-image: escape-svg($form-check-radio-checked-bg-image);\n      }\n    }\n  }\n\n  &[type=\"checkbox\"]:indeterminate {\n    background-color: $form-check-input-indeterminate-bg-color;\n    border-color: $form-check-input-indeterminate-border-color;\n\n    @if $enable-gradients {\n      background-image: escape-svg($form-check-input-indeterminate-bg-image), var(--#{$variable-prefix}gradient);\n    } @else {\n      background-image: escape-svg($form-check-input-indeterminate-bg-image);\n    }\n  }\n\n  &:disabled {\n    pointer-events: none;\n    filter: none;\n    opacity: $form-check-input-disabled-opacity;\n  }\n\n  // Use disabled attribute in addition of :disabled pseudo-class\n  // See: https://github.com/twbs/bootstrap/issues/28247\n  &[disabled],\n  &:disabled {\n    ~ .form-check-label {\n      opacity: $form-check-label-disabled-opacity;\n    }\n  }\n}\n\n.form-check-label {\n  color: $form-check-label-color;\n  cursor: $form-check-label-cursor;\n}\n\n//\n// Switch\n//\n\n.form-switch {\n  padding-left: $form-switch-padding-start;\n\n  .form-check-input {\n    width: $form-switch-width;\n    margin-left: $form-switch-padding-start * -1;\n    background-image: escape-svg($form-switch-bg-image);\n    background-position: left center;\n    @include border-radius($form-switch-border-radius);\n    @include transition($form-switch-transition);\n\n    &:focus {\n      background-image: escape-svg($form-switch-focus-bg-image);\n    }\n\n    &:checked {\n      background-position: $form-switch-checked-bg-position;\n\n      @if $enable-gradients {\n        background-image: escape-svg($form-switch-checked-bg-image), var(--#{$variable-prefix}gradient);\n      } @else {\n        background-image: escape-svg($form-switch-checked-bg-image);\n      }\n    }\n  }\n}\n\n.form-check-inline {\n  display: inline-block;\n  margin-right: $form-check-inline-margin-end;\n}\n\n.btn-check {\n  position: absolute;\n  clip: rect(0, 0, 0, 0);\n  pointer-events: none;\n\n  &[disabled],\n  &:disabled {\n    + .btn {\n      pointer-events: none;\n      filter: none;\n      opacity: $form-check-btn-check-disabled-opacity;\n    }\n  }\n}\n","// Range\n//\n// Style range inputs the same across browsers. Vendor-specific rules for pseudo\n// elements cannot be mixed. As such, there are no shared styles for focus or\n// active states on prefixed selectors.\n\n.form-range {\n  width: 100%;\n  height: add($form-range-thumb-height, $form-range-thumb-focus-box-shadow-width * 2);\n  padding: 0; // Need to reset padding\n  background-color: transparent;\n  appearance: none;\n\n  &:focus {\n    outline: 0;\n\n    // Pseudo-elements must be split across multiple rulesets to have an effect.\n    // No box-shadow() mixin for focus accessibility.\n    &::-webkit-slider-thumb { box-shadow: $form-range-thumb-focus-box-shadow; }\n    &::-moz-range-thumb     { box-shadow: $form-range-thumb-focus-box-shadow; }\n  }\n\n  &::-moz-focus-outer {\n    border: 0;\n  }\n\n  &::-webkit-slider-thumb {\n    width: $form-range-thumb-width;\n    height: $form-range-thumb-height;\n    margin-top: ($form-range-track-height - $form-range-thumb-height) * .5; // Webkit specific\n    @include gradient-bg($form-range-thumb-bg);\n    border: $form-range-thumb-border;\n    @include border-radius($form-range-thumb-border-radius);\n    @include box-shadow($form-range-thumb-box-shadow);\n    @include transition($form-range-thumb-transition);\n    appearance: none;\n\n    &:active {\n      @include gradient-bg($form-range-thumb-active-bg);\n    }\n  }\n\n  &::-webkit-slider-runnable-track {\n    width: $form-range-track-width;\n    height: $form-range-track-height;\n    color: transparent; // Why?\n    cursor: $form-range-track-cursor;\n    background-color: $form-range-track-bg;\n    border-color: transparent;\n    @include border-radius($form-range-track-border-radius);\n    @include box-shadow($form-range-track-box-shadow);\n  }\n\n  &::-moz-range-thumb {\n    width: $form-range-thumb-width;\n    height: $form-range-thumb-height;\n    @include gradient-bg($form-range-thumb-bg);\n    border: $form-range-thumb-border;\n    @include border-radius($form-range-thumb-border-radius);\n    @include box-shadow($form-range-thumb-box-shadow);\n    @include transition($form-range-thumb-transition);\n    appearance: none;\n\n    &:active {\n      @include gradient-bg($form-range-thumb-active-bg);\n    }\n  }\n\n  &::-moz-range-track {\n    width: $form-range-track-width;\n    height: $form-range-track-height;\n    color: transparent;\n    cursor: $form-range-track-cursor;\n    background-color: $form-range-track-bg;\n    border-color: transparent; // Firefox specific?\n    @include border-radius($form-range-track-border-radius);\n    @include box-shadow($form-range-track-box-shadow);\n  }\n\n  &:disabled {\n    pointer-events: none;\n\n    &::-webkit-slider-thumb {\n      background-color: $form-range-thumb-disabled-bg;\n    }\n\n    &::-moz-range-thumb {\n      background-color: $form-range-thumb-disabled-bg;\n    }\n  }\n}\n",".form-floating {\n  position: relative;\n\n  > .form-control,\n  > .form-select {\n    height: $form-floating-height;\n    line-height: $form-floating-line-height;\n  }\n\n  > label {\n    position: absolute;\n    top: 0;\n    left: 0;\n    height: 100%; // allow textareas\n    padding: $form-floating-padding-y $form-floating-padding-x;\n    pointer-events: none;\n    border: $input-border-width solid transparent; // Required for aligning label's text with the input as it affects inner box model\n    transform-origin: 0 0;\n    @include transition($form-floating-transition);\n  }\n\n  // stylelint-disable no-duplicate-selectors\n  > .form-control {\n    padding: $form-floating-padding-y $form-floating-padding-x;\n\n    &::placeholder {\n      color: transparent;\n    }\n\n    &:focus,\n    &:not(:placeholder-shown) {\n      padding-top: $form-floating-input-padding-t;\n      padding-bottom: $form-floating-input-padding-b;\n    }\n    // Duplicated because `:-webkit-autofill` invalidates other selectors when grouped\n    &:-webkit-autofill {\n      padding-top: $form-floating-input-padding-t;\n      padding-bottom: $form-floating-input-padding-b;\n    }\n  }\n\n  > .form-select {\n    padding-top: $form-floating-input-padding-t;\n    padding-bottom: $form-floating-input-padding-b;\n  }\n\n  > .form-control:focus,\n  > .form-control:not(:placeholder-shown),\n  > .form-select {\n    ~ label {\n      opacity: $form-floating-label-opacity;\n      transform: $form-floating-label-transform;\n    }\n  }\n  // Duplicated because `:-webkit-autofill` invalidates other selectors when grouped\n  > .form-control:-webkit-autofill {\n    ~ label {\n      opacity: $form-floating-label-opacity;\n      transform: $form-floating-label-transform;\n    }\n  }\n  // stylelint-enable no-duplicate-selectors\n}\n","//\n// Base styles\n//\n\n.input-group {\n  position: relative;\n  display: flex;\n  flex-wrap: wrap; // For form validation feedback\n  align-items: stretch;\n  width: 100%;\n\n  > .form-control,\n  > .form-select {\n    position: relative; // For focus state's z-index\n    flex: 1 1 auto;\n    width: 1%;\n    min-width: 0; // https://stackoverflow.com/questions/36247140/why-dont-flex-items-shrink-past-content-size\n  }\n\n  // Bring the \"active\" form control to the top of surrounding elements\n  > .form-control:focus,\n  > .form-select:focus {\n    z-index: 3;\n  }\n\n  // Ensure buttons are always above inputs for more visually pleasing borders.\n  // This isn't needed for `.input-group-text` since it shares the same border-color\n  // as our inputs.\n  .btn {\n    position: relative;\n    z-index: 2;\n\n    &:focus {\n      z-index: 3;\n    }\n  }\n}\n\n\n// Textual addons\n//\n// Serves as a catch-all element for any text or radio/checkbox input you wish\n// to prepend or append to an input.\n\n.input-group-text {\n  display: flex;\n  align-items: center;\n  padding: $input-group-addon-padding-y $input-group-addon-padding-x;\n  @include font-size($input-font-size); // Match inputs\n  font-weight: $input-group-addon-font-weight;\n  line-height: $input-line-height;\n  color: $input-group-addon-color;\n  text-align: center;\n  white-space: nowrap;\n  background-color: $input-group-addon-bg;\n  border: $input-border-width solid $input-group-addon-border-color;\n  @include border-radius($input-border-radius);\n}\n\n\n// Sizing\n//\n// Remix the default form control sizing classes into new ones for easier\n// manipulation.\n\n.input-group-lg > .form-control,\n.input-group-lg > .form-select,\n.input-group-lg > .input-group-text,\n.input-group-lg > .btn {\n  padding: $input-padding-y-lg $input-padding-x-lg;\n  @include font-size($input-font-size-lg);\n  @include border-radius($input-border-radius-lg);\n}\n\n.input-group-sm > .form-control,\n.input-group-sm > .form-select,\n.input-group-sm > .input-group-text,\n.input-group-sm > .btn {\n  padding: $input-padding-y-sm $input-padding-x-sm;\n  @include font-size($input-font-size-sm);\n  @include border-radius($input-border-radius-sm);\n}\n\n.input-group-lg > .form-select,\n.input-group-sm > .form-select {\n  padding-right: $form-select-padding-x + $form-select-indicator-padding;\n}\n\n\n// Rounded corners\n//\n// These rulesets must come after the sizing ones to properly override sm and lg\n// border-radius values when extending. They're more specific than we'd like\n// with the `.input-group >` part, but without it, we cannot override the sizing.\n\n// stylelint-disable-next-line no-duplicate-selectors\n.input-group {\n  &:not(.has-validation) {\n    > :not(:last-child):not(.dropdown-toggle):not(.dropdown-menu),\n    > .dropdown-toggle:nth-last-child(n + 3) {\n      @include border-end-radius(0);\n    }\n  }\n\n  &.has-validation {\n    > :nth-last-child(n + 3):not(.dropdown-toggle):not(.dropdown-menu),\n    > .dropdown-toggle:nth-last-child(n + 4) {\n      @include border-end-radius(0);\n    }\n  }\n\n  $validation-messages: \"\";\n  @each $state in map-keys($form-validation-states) {\n    $validation-messages: $validation-messages + \":not(.\" + unquote($state) + \"-tooltip)\" + \":not(.\" + unquote($state) + \"-feedback)\";\n  }\n\n  > :not(:first-child):not(.dropdown-menu)#{$validation-messages} {\n    margin-left: -$input-border-width;\n    @include border-start-radius(0);\n  }\n}\n","// This mixin uses an `if()` technique to be compatible with Dart Sass\n// See https://github.com/sass/sass/issues/1873#issuecomment-152293725 for more details\n\n// scss-docs-start form-validation-mixins\n@mixin form-validation-state-selector($state) {\n  @if ($state == \"valid\" or $state == \"invalid\") {\n    .was-validated #{if(&, \"&\", \"\")}:#{$state},\n    #{if(&, \"&\", \"\")}.is-#{$state} {\n      @content;\n    }\n  } @else {\n    #{if(&, \"&\", \"\")}.is-#{$state} {\n      @content;\n    }\n  }\n}\n\n@mixin form-validation-state(\n  $state,\n  $color,\n  $icon,\n  $tooltip-color: color-contrast($color),\n  $tooltip-bg-color: rgba($color, $form-feedback-tooltip-opacity),\n  $focus-box-shadow: 0 0 $input-btn-focus-blur $input-focus-width rgba($color, $input-btn-focus-color-opacity)\n) {\n  .#{$state}-feedback {\n    display: none;\n    width: 100%;\n    margin-top: $form-feedback-margin-top;\n    @include font-size($form-feedback-font-size);\n    font-style: $form-feedback-font-style;\n    color: $color;\n  }\n\n  .#{$state}-tooltip {\n    position: absolute;\n    top: 100%;\n    z-index: 5;\n    display: none;\n    max-width: 100%; // Contain to parent when possible\n    padding: $form-feedback-tooltip-padding-y $form-feedback-tooltip-padding-x;\n    margin-top: .1rem;\n    @include font-size($form-feedback-tooltip-font-size);\n    line-height: $form-feedback-tooltip-line-height;\n    color: $tooltip-color;\n    background-color: $tooltip-bg-color;\n    @include border-radius($form-feedback-tooltip-border-radius);\n  }\n\n  @include form-validation-state-selector($state) {\n    ~ .#{$state}-feedback,\n    ~ .#{$state}-tooltip {\n      display: block;\n    }\n  }\n\n  .form-control {\n    @include form-validation-state-selector($state) {\n      border-color: $color;\n\n      @if $enable-validation-icons {\n        padding-right: $input-height-inner;\n        background-image: escape-svg($icon);\n        background-repeat: no-repeat;\n        background-position: right $input-height-inner-quarter center;\n        background-size: $input-height-inner-half $input-height-inner-half;\n      }\n\n      &:focus {\n        border-color: $color;\n        box-shadow: $focus-box-shadow;\n      }\n    }\n  }\n\n  // stylelint-disable-next-line selector-no-qualifying-type\n  textarea.form-control {\n    @include form-validation-state-selector($state) {\n      @if $enable-validation-icons {\n        padding-right: $input-height-inner;\n        background-position: top $input-height-inner-quarter right $input-height-inner-quarter;\n      }\n    }\n  }\n\n  .form-select {\n    @include form-validation-state-selector($state) {\n      border-color: $color;\n\n      @if $enable-validation-icons {\n        &:not([multiple]):not([size]),\n        &:not([multiple])[size=\"1\"] {\n          padding-right: $form-select-feedback-icon-padding-end;\n          background-image: escape-svg($form-select-indicator), escape-svg($icon);\n          background-position: $form-select-bg-position, $form-select-feedback-icon-position;\n          background-size: $form-select-bg-size, $form-select-feedback-icon-size;\n        }\n      }\n\n      &:focus {\n        border-color: $color;\n        box-shadow: $focus-box-shadow;\n      }\n    }\n  }\n\n  .form-check-input {\n    @include form-validation-state-selector($state) {\n      border-color: $color;\n\n      &:checked {\n        background-color: $color;\n      }\n\n      &:focus {\n        box-shadow: $focus-box-shadow;\n      }\n\n      ~ .form-check-label {\n        color: $color;\n      }\n    }\n  }\n  .form-check-inline .form-check-input {\n    ~ .#{$state}-feedback {\n      margin-left: .5em;\n    }\n  }\n\n  .input-group .form-control,\n  .input-group .form-select {\n    @include form-validation-state-selector($state) {\n      @if $state == \"valid\" {\n        z-index: 1;\n      } @else if $state == \"invalid\" {\n        z-index: 2;\n      }\n      &:focus {\n        z-index: 3;\n      }\n    }\n  }\n}\n// scss-docs-end form-validation-mixins\n","//\n// Base styles\n//\n\n.btn {\n  display: inline-block;\n  font-family: $btn-font-family;\n  font-weight: $btn-font-weight;\n  line-height: $btn-line-height;\n  color: $body-color;\n  text-align: center;\n  text-decoration: if($link-decoration == none, null, none);\n  white-space: $btn-white-space;\n  vertical-align: middle;\n  cursor: if($enable-button-pointers, pointer, null);\n  user-select: none;\n  background-color: transparent;\n  border: $btn-border-width solid transparent;\n  @include button-size($btn-padding-y, $btn-padding-x, $btn-font-size, $btn-border-radius);\n  @include transition($btn-transition);\n\n  &:hover {\n    color: $body-color;\n    text-decoration: if($link-hover-decoration == underline, none, null);\n  }\n\n  .btn-check:focus + &,\n  &:focus {\n    outline: 0;\n    box-shadow: $btn-focus-box-shadow;\n  }\n\n  .btn-check:checked + &,\n  .btn-check:active + &,\n  &:active,\n  &.active {\n    @include box-shadow($btn-active-box-shadow);\n\n    &:focus {\n      @include box-shadow($btn-focus-box-shadow, $btn-active-box-shadow);\n    }\n  }\n\n  &:disabled,\n  &.disabled,\n  fieldset:disabled & {\n    pointer-events: none;\n    opacity: $btn-disabled-opacity;\n    @include box-shadow(none);\n  }\n}\n\n\n//\n// Alternate buttons\n//\n\n// scss-docs-start btn-variant-loops\n@each $color, $value in $theme-colors {\n  .btn-#{$color} {\n    @include button-variant($value, $value);\n  }\n}\n\n@each $color, $value in $theme-colors {\n  .btn-outline-#{$color} {\n    @include button-outline-variant($value);\n  }\n}\n// scss-docs-end btn-variant-loops\n\n\n//\n// Link buttons\n//\n\n// Make a button look and behave like a link\n.btn-link {\n  font-weight: $font-weight-normal;\n  color: $btn-link-color;\n  text-decoration: $link-decoration;\n\n  &:hover {\n    color: $btn-link-hover-color;\n    text-decoration: $link-hover-decoration;\n  }\n\n  &:focus {\n    text-decoration: $link-hover-decoration;\n  }\n\n  &:disabled,\n  &.disabled {\n    color: $btn-link-disabled-color;\n  }\n\n  // No need for an active state here\n}\n\n\n//\n// Button Sizes\n//\n\n.btn-lg {\n  @include button-size($btn-padding-y-lg, $btn-padding-x-lg, $btn-font-size-lg, $btn-border-radius-lg);\n}\n\n.btn-sm {\n  @include button-size($btn-padding-y-sm, $btn-padding-x-sm, $btn-font-size-sm, $btn-border-radius-sm);\n}\n","// Button variants\n//\n// Easily pump out default styles, as well as :hover, :focus, :active,\n// and disabled options for all buttons\n\n// scss-docs-start btn-variant-mixin\n@mixin button-variant(\n  $background,\n  $border,\n  $color: color-contrast($background),\n  $hover-background: if($color == $color-contrast-light, shade-color($background, $btn-hover-bg-shade-amount), tint-color($background, $btn-hover-bg-tint-amount)),\n  $hover-border: if($color == $color-contrast-light, shade-color($border, $btn-hover-border-shade-amount), tint-color($border, $btn-hover-border-tint-amount)),\n  $hover-color: color-contrast($hover-background),\n  $active-background: if($color == $color-contrast-light, shade-color($background, $btn-active-bg-shade-amount), tint-color($background, $btn-active-bg-tint-amount)),\n  $active-border: if($color == $color-contrast-light, shade-color($border, $btn-active-border-shade-amount), tint-color($border, $btn-active-border-tint-amount)),\n  $active-color: color-contrast($active-background),\n  $disabled-background: $background,\n  $disabled-border: $border,\n  $disabled-color: color-contrast($disabled-background)\n) {\n  color: $color;\n  @include gradient-bg($background);\n  border-color: $border;\n  @include box-shadow($btn-box-shadow);\n\n  &:hover {\n    color: $hover-color;\n    @include gradient-bg($hover-background);\n    border-color: $hover-border;\n  }\n\n  .btn-check:focus + &,\n  &:focus {\n    color: $hover-color;\n    @include gradient-bg($hover-background);\n    border-color: $hover-border;\n    @if $enable-shadows {\n      @include box-shadow($btn-box-shadow, 0 0 0 $btn-focus-width rgba(mix($color, $border, 15%), .5));\n    } @else {\n      // Avoid using mixin so we can pass custom focus shadow properly\n      box-shadow: 0 0 0 $btn-focus-width rgba(mix($color, $border, 15%), .5);\n    }\n  }\n\n  .btn-check:checked + &,\n  .btn-check:active + &,\n  &:active,\n  &.active,\n  .show > &.dropdown-toggle {\n    color: $active-color;\n    background-color: $active-background;\n    // Remove CSS gradients if they're enabled\n    background-image: if($enable-gradients, none, null);\n    border-color: $active-border;\n\n    &:focus {\n      @if $enable-shadows {\n        @include box-shadow($btn-active-box-shadow, 0 0 0 $btn-focus-width rgba(mix($color, $border, 15%), .5));\n      } @else {\n        // Avoid using mixin so we can pass custom focus shadow properly\n        box-shadow: 0 0 0 $btn-focus-width rgba(mix($color, $border, 15%), .5);\n      }\n    }\n  }\n\n  &:disabled,\n  &.disabled {\n    color: $disabled-color;\n    background-color: $disabled-background;\n    // Remove CSS gradients if they're enabled\n    background-image: if($enable-gradients, none, null);\n    border-color: $disabled-border;\n  }\n}\n// scss-docs-end btn-variant-mixin\n\n// scss-docs-start btn-outline-variant-mixin\n@mixin button-outline-variant(\n  $color,\n  $color-hover: color-contrast($color),\n  $active-background: $color,\n  $active-border: $color,\n  $active-color: color-contrast($active-background)\n) {\n  color: $color;\n  border-color: $color;\n\n  &:hover {\n    color: $color-hover;\n    background-color: $active-background;\n    border-color: $active-border;\n  }\n\n  .btn-check:focus + &,\n  &:focus {\n    box-shadow: 0 0 0 $btn-focus-width rgba($color, .5);\n  }\n\n  .btn-check:checked + &,\n  .btn-check:active + &,\n  &:active,\n  &.active,\n  &.dropdown-toggle.show {\n    color: $active-color;\n    background-color: $active-background;\n    border-color: $active-border;\n\n    &:focus {\n      @if $enable-shadows {\n        @include box-shadow($btn-active-box-shadow, 0 0 0 $btn-focus-width rgba($color, .5));\n      } @else {\n        // Avoid using mixin so we can pass custom focus shadow properly\n        box-shadow: 0 0 0 $btn-focus-width rgba($color, .5);\n      }\n    }\n  }\n\n  &:disabled,\n  &.disabled {\n    color: $color;\n    background-color: transparent;\n  }\n}\n// scss-docs-end btn-outline-variant-mixin\n\n// scss-docs-start btn-size-mixin\n@mixin button-size($padding-y, $padding-x, $font-size, $border-radius) {\n  padding: $padding-y $padding-x;\n  @include font-size($font-size);\n  // Manually declare to provide an override to the browser default\n  @include border-radius($border-radius, 0);\n}\n// scss-docs-end btn-size-mixin\n",".fade {\n  @include transition($transition-fade);\n\n  &:not(.show) {\n    opacity: 0;\n  }\n}\n\n// scss-docs-start collapse-classes\n.collapse {\n  &:not(.show) {\n    display: none;\n  }\n}\n\n.collapsing {\n  height: 0;\n  overflow: hidden;\n  @include transition($transition-collapse);\n}\n// scss-docs-end collapse-classes\n","// The dropdown wrapper (`<div>`)\n.dropup,\n.dropend,\n.dropdown,\n.dropstart {\n  position: relative;\n}\n\n.dropdown-toggle {\n  white-space: nowrap;\n\n  // Generate the caret automatically\n  @include caret();\n}\n\n// The dropdown menu\n.dropdown-menu {\n  position: absolute;\n  z-index: $zindex-dropdown;\n  display: none; // none by default, but block on \"open\" of the menu\n  min-width: $dropdown-min-width;\n  padding: $dropdown-padding-y $dropdown-padding-x;\n  margin: 0; // Override default margin of ul\n  @include font-size($dropdown-font-size);\n  color: $dropdown-color;\n  text-align: left; // Ensures proper alignment if parent has it changed (e.g., modal footer)\n  list-style: none;\n  background-color: $dropdown-bg;\n  background-clip: padding-box;\n  border: $dropdown-border-width solid $dropdown-border-color;\n  @include border-radius($dropdown-border-radius);\n  @include box-shadow($dropdown-box-shadow);\n\n  &[data-bs-popper] {\n    top: 100%;\n    left: 0;\n    margin-top: $dropdown-spacer;\n  }\n}\n\n// scss-docs-start responsive-breakpoints\n// We deliberately hardcode the `bs-` prefix because we check\n// this custom property in JS to determine Popper's positioning\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    .dropdown-menu#{$infix}-start {\n      --bs-position: start;\n\n      &[data-bs-popper] {\n        right: auto;\n        left: 0;\n      }\n    }\n\n    .dropdown-menu#{$infix}-end {\n      --bs-position: end;\n\n      &[data-bs-popper] {\n        right: 0;\n        left: auto;\n      }\n    }\n  }\n}\n// scss-docs-end responsive-breakpoints\n\n// Allow for dropdowns to go bottom up (aka, dropup-menu)\n// Just add .dropup after the standard .dropdown class and you're set.\n.dropup {\n  .dropdown-menu[data-bs-popper] {\n    top: auto;\n    bottom: 100%;\n    margin-top: 0;\n    margin-bottom: $dropdown-spacer;\n  }\n\n  .dropdown-toggle {\n    @include caret(up);\n  }\n}\n\n.dropend {\n  .dropdown-menu[data-bs-popper] {\n    top: 0;\n    right: auto;\n    left: 100%;\n    margin-top: 0;\n    margin-left: $dropdown-spacer;\n  }\n\n  .dropdown-toggle {\n    @include caret(end);\n    &::after {\n      vertical-align: 0;\n    }\n  }\n}\n\n.dropstart {\n  .dropdown-menu[data-bs-popper] {\n    top: 0;\n    right: 100%;\n    left: auto;\n    margin-top: 0;\n    margin-right: $dropdown-spacer;\n  }\n\n  .dropdown-toggle {\n    @include caret(start);\n    &::before {\n      vertical-align: 0;\n    }\n  }\n}\n\n\n// Dividers (basically an `<hr>`) within the dropdown\n.dropdown-divider {\n  height: 0;\n  margin: $dropdown-divider-margin-y 0;\n  overflow: hidden;\n  border-top: 1px solid $dropdown-divider-bg;\n}\n\n// Links, buttons, and more within the dropdown menu\n//\n// `<button>`-specific styles are denoted with `// For <button>s`\n.dropdown-item {\n  display: block;\n  width: 100%; // For `<button>`s\n  padding: $dropdown-item-padding-y $dropdown-item-padding-x;\n  clear: both;\n  font-weight: $font-weight-normal;\n  color: $dropdown-link-color;\n  text-align: inherit; // For `<button>`s\n  text-decoration: if($link-decoration == none, null, none);\n  white-space: nowrap; // prevent links from randomly breaking onto new lines\n  background-color: transparent; // For `<button>`s\n  border: 0; // For `<button>`s\n\n  // Prevent dropdown overflow if there's no padding\n  // See https://github.com/twbs/bootstrap/pull/27703\n  @if $dropdown-padding-y == 0 {\n    &:first-child {\n      @include border-top-radius($dropdown-inner-border-radius);\n    }\n\n    &:last-child {\n      @include border-bottom-radius($dropdown-inner-border-radius);\n    }\n  }\n\n  &:hover,\n  &:focus {\n    color: $dropdown-link-hover-color;\n    text-decoration: if($link-hover-decoration == underline, none, null);\n    @include gradient-bg($dropdown-link-hover-bg);\n  }\n\n  &.active,\n  &:active {\n    color: $dropdown-link-active-color;\n    text-decoration: none;\n    @include gradient-bg($dropdown-link-active-bg);\n  }\n\n  &.disabled,\n  &:disabled {\n    color: $dropdown-link-disabled-color;\n    pointer-events: none;\n    background-color: transparent;\n    // Remove CSS gradients if they're enabled\n    background-image: if($enable-gradients, none, null);\n  }\n}\n\n.dropdown-menu.show {\n  display: block;\n}\n\n// Dropdown section headers\n.dropdown-header {\n  display: block;\n  padding: $dropdown-header-padding;\n  margin-bottom: 0; // for use with heading elements\n  @include font-size($font-size-sm);\n  color: $dropdown-header-color;\n  white-space: nowrap; // as with > li > a\n}\n\n// Dropdown text\n.dropdown-item-text {\n  display: block;\n  padding: $dropdown-item-padding-y $dropdown-item-padding-x;\n  color: $dropdown-link-color;\n}\n\n// Dark dropdowns\n.dropdown-menu-dark {\n  color: $dropdown-dark-color;\n  background-color: $dropdown-dark-bg;\n  border-color: $dropdown-dark-border-color;\n  @include box-shadow($dropdown-dark-box-shadow);\n\n  .dropdown-item {\n    color: $dropdown-dark-link-color;\n\n    &:hover,\n    &:focus {\n      color: $dropdown-dark-link-hover-color;\n      @include gradient-bg($dropdown-dark-link-hover-bg);\n    }\n\n    &.active,\n    &:active {\n      color: $dropdown-dark-link-active-color;\n      @include gradient-bg($dropdown-dark-link-active-bg);\n    }\n\n    &.disabled,\n    &:disabled {\n      color: $dropdown-dark-link-disabled-color;\n    }\n  }\n\n  .dropdown-divider {\n    border-color: $dropdown-dark-divider-bg;\n  }\n\n  .dropdown-item-text {\n    color: $dropdown-dark-link-color;\n  }\n\n  .dropdown-header {\n    color: $dropdown-dark-header-color;\n  }\n}\n","// scss-docs-start caret-mixins\n@mixin caret-down {\n  border-top: $caret-width solid;\n  border-right: $caret-width solid transparent;\n  border-bottom: 0;\n  border-left: $caret-width solid transparent;\n}\n\n@mixin caret-up {\n  border-top: 0;\n  border-right: $caret-width solid transparent;\n  border-bottom: $caret-width solid;\n  border-left: $caret-width solid transparent;\n}\n\n@mixin caret-end {\n  border-top: $caret-width solid transparent;\n  border-right: 0;\n  border-bottom: $caret-width solid transparent;\n  border-left: $caret-width solid;\n}\n\n@mixin caret-start {\n  border-top: $caret-width solid transparent;\n  border-right: $caret-width solid;\n  border-bottom: $caret-width solid transparent;\n}\n\n@mixin caret($direction: down) {\n  @if $enable-caret {\n    &::after {\n      display: inline-block;\n      margin-left: $caret-spacing;\n      vertical-align: $caret-vertical-align;\n      content: \"\";\n      @if $direction == down {\n        @include caret-down();\n      } @else if $direction == up {\n        @include caret-up();\n      } @else if $direction == end {\n        @include caret-end();\n      }\n    }\n\n    @if $direction == start {\n      &::after {\n        display: none;\n      }\n\n      &::before {\n        display: inline-block;\n        margin-right: $caret-spacing;\n        vertical-align: $caret-vertical-align;\n        content: \"\";\n        @include caret-start();\n      }\n    }\n\n    &:empty::after {\n      margin-left: 0;\n    }\n  }\n}\n// scss-docs-end caret-mixins\n","// Make the div behave like a button\n.btn-group,\n.btn-group-vertical {\n  position: relative;\n  display: inline-flex;\n  vertical-align: middle; // match .btn alignment given font-size hack above\n\n  > .btn {\n    position: relative;\n    flex: 1 1 auto;\n  }\n\n  // Bring the hover, focused, and \"active\" buttons to the front to overlay\n  // the borders properly\n  > .btn-check:checked + .btn,\n  > .btn-check:focus + .btn,\n  > .btn:hover,\n  > .btn:focus,\n  > .btn:active,\n  > .btn.active {\n    z-index: 1;\n  }\n}\n\n// Optional: Group multiple button groups together for a toolbar\n.btn-toolbar {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: flex-start;\n\n  .input-group {\n    width: auto;\n  }\n}\n\n.btn-group {\n  // Prevent double borders when buttons are next to each other\n  > .btn:not(:first-child),\n  > .btn-group:not(:first-child) {\n    margin-left: -$btn-border-width;\n  }\n\n  // Reset rounded corners\n  > .btn:not(:last-child):not(.dropdown-toggle),\n  > .btn-group:not(:last-child) > .btn {\n    @include border-end-radius(0);\n  }\n\n  // The left radius should be 0 if the button is:\n  // - the \"third or more\" child\n  // - the second child and the previous element isn't `.btn-check` (making it the first child visually)\n  // - part of a btn-group which isn't the first child\n  > .btn:nth-child(n + 3),\n  > :not(.btn-check) + .btn,\n  > .btn-group:not(:first-child) > .btn {\n    @include border-start-radius(0);\n  }\n}\n\n// Sizing\n//\n// Remix the default button sizing classes into new ones for easier manipulation.\n\n.btn-group-sm > .btn { @extend .btn-sm; }\n.btn-group-lg > .btn { @extend .btn-lg; }\n\n\n//\n// Split button dropdowns\n//\n\n.dropdown-toggle-split {\n  padding-right: $btn-padding-x * .75;\n  padding-left: $btn-padding-x * .75;\n\n  &::after,\n  .dropup &::after,\n  .dropend &::after {\n    margin-left: 0;\n  }\n\n  .dropstart &::before {\n    margin-right: 0;\n  }\n}\n\n.btn-sm + .dropdown-toggle-split {\n  padding-right: $btn-padding-x-sm * .75;\n  padding-left: $btn-padding-x-sm * .75;\n}\n\n.btn-lg + .dropdown-toggle-split {\n  padding-right: $btn-padding-x-lg * .75;\n  padding-left: $btn-padding-x-lg * .75;\n}\n\n\n// The clickable button for toggling the menu\n// Set the same inset shadow as the :active state\n.btn-group.show .dropdown-toggle {\n  @include box-shadow($btn-active-box-shadow);\n\n  // Show no shadow for `.btn-link` since it has no other button styles.\n  &.btn-link {\n    @include box-shadow(none);\n  }\n}\n\n\n//\n// Vertical button groups\n//\n\n.btn-group-vertical {\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: center;\n\n  > .btn,\n  > .btn-group {\n    width: 100%;\n  }\n\n  > .btn:not(:first-child),\n  > .btn-group:not(:first-child) {\n    margin-top: -$btn-border-width;\n  }\n\n  // Reset rounded corners\n  > .btn:not(:last-child):not(.dropdown-toggle),\n  > .btn-group:not(:last-child) > .btn {\n    @include border-bottom-radius(0);\n  }\n\n  > .btn ~ .btn,\n  > .btn-group:not(:first-child) > .btn {\n    @include border-top-radius(0);\n  }\n}\n","// Base class\n//\n// Kickstart any navigation component with a set of style resets. Works with\n// `<nav>`s, `<ul>`s or `<ol>`s.\n\n.nav {\n  display: flex;\n  flex-wrap: wrap;\n  padding-left: 0;\n  margin-bottom: 0;\n  list-style: none;\n}\n\n.nav-link {\n  display: block;\n  padding: $nav-link-padding-y $nav-link-padding-x;\n  @include font-size($nav-link-font-size);\n  font-weight: $nav-link-font-weight;\n  color: $nav-link-color;\n  text-decoration: if($link-decoration == none, null, none);\n  @include transition($nav-link-transition);\n\n  &:hover,\n  &:focus {\n    color: $nav-link-hover-color;\n    text-decoration: if($link-hover-decoration == underline, none, null);\n  }\n\n  // Disabled state lightens text\n  &.disabled {\n    color: $nav-link-disabled-color;\n    pointer-events: none;\n    cursor: default;\n  }\n}\n\n//\n// Tabs\n//\n\n.nav-tabs {\n  border-bottom: $nav-tabs-border-width solid $nav-tabs-border-color;\n\n  .nav-link {\n    margin-bottom: -$nav-tabs-border-width;\n    background: none;\n    border: $nav-tabs-border-width solid transparent;\n    @include border-top-radius($nav-tabs-border-radius);\n\n    &:hover,\n    &:focus {\n      border-color: $nav-tabs-link-hover-border-color;\n      // Prevents active .nav-link tab overlapping focus outline of previous/next .nav-link\n      isolation: isolate;\n    }\n\n    &.disabled {\n      color: $nav-link-disabled-color;\n      background-color: transparent;\n      border-color: transparent;\n    }\n  }\n\n  .nav-link.active,\n  .nav-item.show .nav-link {\n    color: $nav-tabs-link-active-color;\n    background-color: $nav-tabs-link-active-bg;\n    border-color: $nav-tabs-link-active-border-color;\n  }\n\n  .dropdown-menu {\n    // Make dropdown border overlap tab border\n    margin-top: -$nav-tabs-border-width;\n    // Remove the top rounded corners here since there is a hard edge above the menu\n    @include border-top-radius(0);\n  }\n}\n\n\n//\n// Pills\n//\n\n.nav-pills {\n  .nav-link {\n    background: none;\n    border: 0;\n    @include border-radius($nav-pills-border-radius);\n  }\n\n  .nav-link.active,\n  .show > .nav-link {\n    color: $nav-pills-link-active-color;\n    @include gradient-bg($nav-pills-link-active-bg);\n  }\n}\n\n\n//\n// Justified variants\n//\n\n.nav-fill {\n  > .nav-link,\n  .nav-item {\n    flex: 1 1 auto;\n    text-align: center;\n  }\n}\n\n.nav-justified {\n  > .nav-link,\n  .nav-item {\n    flex-basis: 0;\n    flex-grow: 1;\n    text-align: center;\n  }\n}\n\n.nav-fill,\n.nav-justified {\n  .nav-item .nav-link {\n    width: 100%; // Make sure button will grow\n  }\n}\n\n\n// Tabbable tabs\n//\n// Hide tabbable panes to start, show them when `.active`\n\n.tab-content {\n  > .tab-pane {\n    display: none;\n  }\n  > .active {\n    display: block;\n  }\n}\n","// Contents\n//\n// Navbar\n// Navbar brand\n// Navbar nav\n// Navbar text\n// Responsive navbar\n// Navbar position\n// Navbar themes\n\n\n// Navbar\n//\n// Provide a static navbar from which we expand to create full-width, fixed, and\n// other navbar variations.\n\n.navbar {\n  position: relative;\n  display: flex;\n  flex-wrap: wrap; // allow us to do the line break for collapsing content\n  align-items: center;\n  justify-content: space-between; // space out brand from logo\n  padding-top: $navbar-padding-y;\n  padding-right: $navbar-padding-x; // default: null\n  padding-bottom: $navbar-padding-y;\n  padding-left: $navbar-padding-x; // default: null\n  @include gradient-bg();\n\n  // Because flex properties aren't inherited, we need to redeclare these first\n  // few properties so that content nested within behave properly.\n  // The `flex-wrap` property is inherited to simplify the expanded navbars\n  %container-flex-properties {\n    display: flex;\n    flex-wrap: inherit;\n    align-items: center;\n    justify-content: space-between;\n  }\n\n  > .container,\n  > .container-fluid {\n    @extend %container-flex-properties;\n  }\n\n  @each $breakpoint, $container-max-width in $container-max-widths {\n    > .container#{breakpoint-infix($breakpoint, $container-max-widths)} {\n      @extend %container-flex-properties;\n    }\n  }\n}\n\n\n// Navbar brand\n//\n// Used for brand, project, or site names.\n\n.navbar-brand {\n  padding-top: $navbar-brand-padding-y;\n  padding-bottom: $navbar-brand-padding-y;\n  margin-right: $navbar-brand-margin-end;\n  @include font-size($navbar-brand-font-size);\n  text-decoration: if($link-decoration == none, null, none);\n  white-space: nowrap;\n\n  &:hover,\n  &:focus {\n    text-decoration: if($link-hover-decoration == underline, none, null);\n  }\n}\n\n\n// Navbar nav\n//\n// Custom navbar navigation (doesn't require `.nav`, but does make use of `.nav-link`).\n\n.navbar-nav {\n  display: flex;\n  flex-direction: column; // cannot use `inherit` to get the `.navbar`s value\n  padding-left: 0;\n  margin-bottom: 0;\n  list-style: none;\n\n  .nav-link {\n    padding-right: 0;\n    padding-left: 0;\n  }\n\n  .dropdown-menu {\n    position: static;\n  }\n}\n\n\n// Navbar text\n//\n//\n\n.navbar-text {\n  padding-top: $nav-link-padding-y;\n  padding-bottom: $nav-link-padding-y;\n}\n\n\n// Responsive navbar\n//\n// Custom styles for responsive collapsing and toggling of navbar contents.\n// Powered by the collapse Bootstrap JavaScript plugin.\n\n// When collapsed, prevent the toggleable navbar contents from appearing in\n// the default flexbox row orientation. Requires the use of `flex-wrap: wrap`\n// on the `.navbar` parent.\n.navbar-collapse {\n  flex-basis: 100%;\n  flex-grow: 1;\n  // For always expanded or extra full navbars, ensure content aligns itself\n  // properly vertically. Can be easily overridden with flex utilities.\n  align-items: center;\n}\n\n// Button for toggling the navbar when in its collapsed state\n.navbar-toggler {\n  padding: $navbar-toggler-padding-y $navbar-toggler-padding-x;\n  @include font-size($navbar-toggler-font-size);\n  line-height: 1;\n  background-color: transparent; // remove default button style\n  border: $border-width solid transparent; // remove default button style\n  @include border-radius($navbar-toggler-border-radius);\n  @include transition($navbar-toggler-transition);\n\n  &:hover {\n    text-decoration: none;\n  }\n\n  &:focus {\n    text-decoration: none;\n    outline: 0;\n    box-shadow: 0 0 0 $navbar-toggler-focus-width;\n  }\n}\n\n// Keep as a separate element so folks can easily override it with another icon\n// or image file as needed.\n.navbar-toggler-icon {\n  display: inline-block;\n  width: 1.5em;\n  height: 1.5em;\n  vertical-align: middle;\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: 100%;\n}\n\n.navbar-nav-scroll {\n  max-height: var(--#{$variable-prefix}scroll-height, 75vh);\n  overflow-y: auto;\n}\n\n// scss-docs-start navbar-expand-loop\n// Generate series of `.navbar-expand-*` responsive classes for configuring\n// where your navbar collapses.\n.navbar-expand {\n  @each $breakpoint in map-keys($grid-breakpoints) {\n    $next: breakpoint-next($breakpoint, $grid-breakpoints);\n    $infix: breakpoint-infix($next, $grid-breakpoints);\n\n    // stylelint-disable-next-line scss/selector-no-union-class-name\n    &#{$infix} {\n      @include media-breakpoint-up($next) {\n        flex-wrap: nowrap;\n        justify-content: flex-start;\n\n        .navbar-nav {\n          flex-direction: row;\n\n          .dropdown-menu {\n            position: absolute;\n          }\n\n          .nav-link {\n            padding-right: $navbar-nav-link-padding-x;\n            padding-left: $navbar-nav-link-padding-x;\n          }\n        }\n\n        .navbar-nav-scroll {\n          overflow: visible;\n        }\n\n        .navbar-collapse {\n          display: flex !important; // stylelint-disable-line declaration-no-important\n          flex-basis: auto;\n        }\n\n        .navbar-toggler {\n          display: none;\n        }\n      }\n    }\n  }\n}\n// scss-docs-end navbar-expand-loop\n\n\n// Navbar themes\n//\n// Styles for switching between navbars with light or dark background.\n\n// Dark links against a light background\n.navbar-light {\n  .navbar-brand {\n    color: $navbar-light-brand-color;\n\n    &:hover,\n    &:focus {\n      color: $navbar-light-brand-hover-color;\n    }\n  }\n\n  .navbar-nav {\n    .nav-link {\n      color: $navbar-light-color;\n\n      &:hover,\n      &:focus {\n        color: $navbar-light-hover-color;\n      }\n\n      &.disabled {\n        color: $navbar-light-disabled-color;\n      }\n    }\n\n    .show > .nav-link,\n    .nav-link.active {\n      color: $navbar-light-active-color;\n    }\n  }\n\n  .navbar-toggler {\n    color: $navbar-light-color;\n    border-color: $navbar-light-toggler-border-color;\n  }\n\n  .navbar-toggler-icon {\n    background-image: escape-svg($navbar-light-toggler-icon-bg);\n  }\n\n  .navbar-text {\n    color: $navbar-light-color;\n\n    a,\n    a:hover,\n    a:focus  {\n      color: $navbar-light-active-color;\n    }\n  }\n}\n\n// White links against a dark background\n.navbar-dark {\n  .navbar-brand {\n    color: $navbar-dark-brand-color;\n\n    &:hover,\n    &:focus {\n      color: $navbar-dark-brand-hover-color;\n    }\n  }\n\n  .navbar-nav {\n    .nav-link {\n      color: $navbar-dark-color;\n\n      &:hover,\n      &:focus {\n        color: $navbar-dark-hover-color;\n      }\n\n      &.disabled {\n        color: $navbar-dark-disabled-color;\n      }\n    }\n\n    .show > .nav-link,\n    .nav-link.active {\n      color: $navbar-dark-active-color;\n    }\n  }\n\n  .navbar-toggler {\n    color: $navbar-dark-color;\n    border-color: $navbar-dark-toggler-border-color;\n  }\n\n  .navbar-toggler-icon {\n    background-image: escape-svg($navbar-dark-toggler-icon-bg);\n  }\n\n  .navbar-text {\n    color: $navbar-dark-color;\n    a,\n    a:hover,\n    a:focus {\n      color: $navbar-dark-active-color;\n    }\n  }\n}\n","//\n// Base styles\n//\n\n.card {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  min-width: 0; // See https://github.com/twbs/bootstrap/pull/22740#issuecomment-305868106\n  height: $card-height;\n  word-wrap: break-word;\n  background-color: $card-bg;\n  background-clip: border-box;\n  border: $card-border-width solid $card-border-color;\n  @include border-radius($card-border-radius);\n\n  > hr {\n    margin-right: 0;\n    margin-left: 0;\n  }\n\n  > .list-group {\n    border-top: inherit;\n    border-bottom: inherit;\n\n    &:first-child {\n      border-top-width: 0;\n      @include border-top-radius($card-inner-border-radius);\n    }\n\n    &:last-child  {\n      border-bottom-width: 0;\n      @include border-bottom-radius($card-inner-border-radius);\n    }\n  }\n\n  // Due to specificity of the above selector (`.card > .list-group`), we must\n  // use a child selector here to prevent double borders.\n  > .card-header + .list-group,\n  > .list-group + .card-footer {\n    border-top: 0;\n  }\n}\n\n.card-body {\n  // Enable `flex-grow: 1` for decks and groups so that card blocks take up\n  // as much space as possible, ensuring footers are aligned to the bottom.\n  flex: 1 1 auto;\n  padding: $card-spacer-y $card-spacer-x;\n  color: $card-color;\n}\n\n.card-title {\n  margin-bottom: $card-title-spacer-y;\n}\n\n.card-subtitle {\n  margin-top: -$card-title-spacer-y * .5;\n  margin-bottom: 0;\n}\n\n.card-text:last-child {\n  margin-bottom: 0;\n}\n\n.card-link {\n  &:hover {\n    text-decoration: none;\n  }\n\n  + .card-link {\n    margin-left: $card-spacer-x;\n  }\n}\n\n//\n// Optional textual caps\n//\n\n.card-header {\n  padding: $card-cap-padding-y $card-cap-padding-x;\n  margin-bottom: 0; // Removes the default margin-bottom of <hN>\n  color: $card-cap-color;\n  background-color: $card-cap-bg;\n  border-bottom: $card-border-width solid $card-border-color;\n\n  &:first-child {\n    @include border-radius($card-inner-border-radius $card-inner-border-radius 0 0);\n  }\n}\n\n.card-footer {\n  padding: $card-cap-padding-y $card-cap-padding-x;\n  color: $card-cap-color;\n  background-color: $card-cap-bg;\n  border-top: $card-border-width solid $card-border-color;\n\n  &:last-child {\n    @include border-radius(0 0 $card-inner-border-radius $card-inner-border-radius);\n  }\n}\n\n\n//\n// Header navs\n//\n\n.card-header-tabs {\n  margin-right: -$card-cap-padding-x * .5;\n  margin-bottom: -$card-cap-padding-y;\n  margin-left: -$card-cap-padding-x * .5;\n  border-bottom: 0;\n\n  @if $nav-tabs-link-active-bg != $card-bg {\n    .nav-link.active {\n      background-color: $card-bg;\n      border-bottom-color: $card-bg;\n    }\n  }\n}\n\n.card-header-pills {\n  margin-right: -$card-cap-padding-x * .5;\n  margin-left: -$card-cap-padding-x * .5;\n}\n\n// Card image\n.card-img-overlay {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  padding: $card-img-overlay-padding;\n  @include border-radius($card-inner-border-radius);\n}\n\n.card-img,\n.card-img-top,\n.card-img-bottom {\n  width: 100%; // Required because we use flexbox and this inherently applies align-self: stretch\n}\n\n.card-img,\n.card-img-top {\n  @include border-top-radius($card-inner-border-radius);\n}\n\n.card-img,\n.card-img-bottom {\n  @include border-bottom-radius($card-inner-border-radius);\n}\n\n\n//\n// Card groups\n//\n\n.card-group {\n  // The child selector allows nested `.card` within `.card-group`\n  // to display properly.\n  > .card {\n    margin-bottom: $card-group-margin;\n  }\n\n  @include media-breakpoint-up(sm) {\n    display: flex;\n    flex-flow: row wrap;\n    // The child selector allows nested `.card` within `.card-group`\n    // to display properly.\n    > .card {\n      // Flexbugs #4: https://github.com/philipwalton/flexbugs#flexbug-4\n      flex: 1 0 0%;\n      margin-bottom: 0;\n\n      + .card {\n        margin-left: 0;\n        border-left: 0;\n      }\n\n      // Handle rounded corners\n      @if $enable-rounded {\n        &:not(:last-child) {\n          @include border-end-radius(0);\n\n          .card-img-top,\n          .card-header {\n            // stylelint-disable-next-line property-disallowed-list\n            border-top-right-radius: 0;\n          }\n          .card-img-bottom,\n          .card-footer {\n            // stylelint-disable-next-line property-disallowed-list\n            border-bottom-right-radius: 0;\n          }\n        }\n\n        &:not(:first-child) {\n          @include border-start-radius(0);\n\n          .card-img-top,\n          .card-header {\n            // stylelint-disable-next-line property-disallowed-list\n            border-top-left-radius: 0;\n          }\n          .card-img-bottom,\n          .card-footer {\n            // stylelint-disable-next-line property-disallowed-list\n            border-bottom-left-radius: 0;\n          }\n        }\n      }\n    }\n  }\n}\n",".breadcrumb {\n  display: flex;\n  flex-wrap: wrap;\n  padding: $breadcrumb-padding-y $breadcrumb-padding-x;\n  margin-bottom: $breadcrumb-margin-bottom;\n  @include font-size($breadcrumb-font-size);\n  list-style: none;\n  background-color: $breadcrumb-bg;\n  @include border-radius($breadcrumb-border-radius);\n}\n\n.breadcrumb-item {\n  // The separator between breadcrumbs (by default, a forward-slash: \"/\")\n  + .breadcrumb-item {\n    padding-left: $breadcrumb-item-padding-x;\n\n    &::before {\n      float: left; // Suppress inline spacings and underlining of the separator\n      padding-right: $breadcrumb-item-padding-x;\n      color: $breadcrumb-divider-color;\n      content: var(--#{$variable-prefix}breadcrumb-divider, escape-svg($breadcrumb-divider)) #{\"/* rtl:\"} var(--#{$variable-prefix}breadcrumb-divider, escape-svg($breadcrumb-divider-flipped)) #{\"*/\"};\n    }\n  }\n\n  &.active {\n    color: $breadcrumb-active-color;\n  }\n}\n",".pagination {\n  display: flex;\n  @include list-unstyled();\n}\n\n.page-link {\n  position: relative;\n  display: block;\n  color: $pagination-color;\n  text-decoration: if($link-decoration == none, null, none);\n  background-color: $pagination-bg;\n  border: $pagination-border-width solid $pagination-border-color;\n  @include transition($pagination-transition);\n\n  &:hover {\n    z-index: 2;\n    color: $pagination-hover-color;\n    text-decoration: if($link-hover-decoration == underline, none, null);\n    background-color: $pagination-hover-bg;\n    border-color: $pagination-hover-border-color;\n  }\n\n  &:focus {\n    z-index: 3;\n    color: $pagination-focus-color;\n    background-color: $pagination-focus-bg;\n    outline: $pagination-focus-outline;\n    box-shadow: $pagination-focus-box-shadow;\n  }\n}\n\n.page-item {\n  &:not(:first-child) .page-link {\n    margin-left: $pagination-margin-start;\n  }\n\n  &.active .page-link {\n    z-index: 3;\n    color: $pagination-active-color;\n    @include gradient-bg($pagination-active-bg);\n    border-color: $pagination-active-border-color;\n  }\n\n  &.disabled .page-link {\n    color: $pagination-disabled-color;\n    pointer-events: none;\n    background-color: $pagination-disabled-bg;\n    border-color: $pagination-disabled-border-color;\n  }\n}\n\n\n//\n// Sizing\n//\n@include pagination-size($pagination-padding-y, $pagination-padding-x, null, $pagination-border-radius);\n\n.pagination-lg {\n  @include pagination-size($pagination-padding-y-lg, $pagination-padding-x-lg, $font-size-lg, $pagination-border-radius-lg);\n}\n\n.pagination-sm {\n  @include pagination-size($pagination-padding-y-sm, $pagination-padding-x-sm, $font-size-sm, $pagination-border-radius-sm);\n}\n","// Pagination\n\n// scss-docs-start pagination-mixin\n@mixin pagination-size($padding-y, $padding-x, $font-size, $border-radius) {\n  .page-link {\n    padding: $padding-y $padding-x;\n    @include font-size($font-size);\n  }\n\n  .page-item {\n    @if $pagination-margin-start == (-$pagination-border-width) {\n      &:first-child {\n        .page-link {\n          @include border-start-radius($border-radius);\n        }\n      }\n\n      &:last-child {\n        .page-link {\n          @include border-end-radius($border-radius);\n        }\n      }\n    } @else {\n      //Add border-radius to all pageLinks in case they have left margin\n      .page-link {\n        @include border-radius($border-radius);\n      }\n    }\n  }\n}\n// scss-docs-end pagination-mixin\n","// Base class\n//\n// Requires one of the contextual, color modifier classes for `color` and\n// `background-color`.\n\n.badge {\n  display: inline-block;\n  padding: $badge-padding-y $badge-padding-x;\n  @include font-size($badge-font-size);\n  font-weight: $badge-font-weight;\n  line-height: 1;\n  color: $badge-color;\n  text-align: center;\n  white-space: nowrap;\n  vertical-align: baseline;\n  @include border-radius($badge-border-radius);\n  @include gradient-bg();\n\n  // Empty badges collapse automatically\n  &:empty {\n    display: none;\n  }\n}\n\n// Quick fix for badges in buttons\n.btn .badge {\n  position: relative;\n  top: -1px;\n}\n","//\n// Base styles\n//\n\n.alert {\n  position: relative;\n  padding: $alert-padding-y $alert-padding-x;\n  margin-bottom: $alert-margin-bottom;\n  border: $alert-border-width solid transparent;\n  @include border-radius($alert-border-radius);\n}\n\n// Headings for larger alerts\n.alert-heading {\n  // Specified to prevent conflicts of changing $headings-color\n  color: inherit;\n}\n\n// Provide class for links that match alerts\n.alert-link {\n  font-weight: $alert-link-font-weight;\n}\n\n\n// Dismissible alerts\n//\n// Expand the right padding and account for the close button's positioning.\n\n.alert-dismissible {\n  padding-right: $alert-dismissible-padding-r;\n\n  // Adjust close link position\n  .btn-close {\n    position: absolute;\n    top: 0;\n    right: 0;\n    z-index: $stretched-link-z-index + 1;\n    padding: $alert-padding-y * 1.25 $alert-padding-x;\n  }\n}\n\n\n// scss-docs-start alert-modifiers\n// Generate contextual modifier classes for colorizing the alert.\n\n@each $state, $value in $theme-colors {\n  $alert-background: shift-color($value, $alert-bg-scale);\n  $alert-border: shift-color($value, $alert-border-scale);\n  $alert-color: shift-color($value, $alert-color-scale);\n  @if (contrast-ratio($alert-background, $alert-color) < $min-contrast-ratio) {\n    $alert-color: mix($value, color-contrast($alert-background), abs($alert-color-scale));\n  }\n  .alert-#{$state} {\n    @include alert-variant($alert-background, $alert-border, $alert-color);\n  }\n}\n// scss-docs-end alert-modifiers\n","// scss-docs-start alert-variant-mixin\n@mixin alert-variant($background, $border, $color) {\n  color: $color;\n  @include gradient-bg($background);\n  border-color: $border;\n\n  .alert-link {\n    color: shade-color($color, 20%);\n  }\n}\n// scss-docs-end alert-variant-mixin\n","// Disable animation if transitions are disabled\n\n// scss-docs-start progress-keyframes\n@if $enable-transitions {\n  @keyframes progress-bar-stripes {\n    0% { background-position-x: $progress-height; }\n  }\n}\n// scss-docs-end progress-keyframes\n\n.progress {\n  display: flex;\n  height: $progress-height;\n  overflow: hidden; // force rounded corners by cropping it\n  @include font-size($progress-font-size);\n  background-color: $progress-bg;\n  @include border-radius($progress-border-radius);\n  @include box-shadow($progress-box-shadow);\n}\n\n.progress-bar {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  overflow: hidden;\n  color: $progress-bar-color;\n  text-align: center;\n  white-space: nowrap;\n  background-color: $progress-bar-bg;\n  @include transition($progress-bar-transition);\n}\n\n.progress-bar-striped {\n  @include gradient-striped();\n  background-size: $progress-height $progress-height;\n}\n\n@if $enable-transitions {\n  .progress-bar-animated {\n    animation: $progress-bar-animation-timing progress-bar-stripes;\n\n    @if $enable-reduced-motion {\n      @media (prefers-reduced-motion: reduce) {\n        animation: none;\n      }\n    }\n  }\n}\n","// Base class\n//\n// Easily usable on <ul>, <ol>, or <div>.\n\n.list-group {\n  display: flex;\n  flex-direction: column;\n\n  // No need to set list-style: none; since .list-group-item is block level\n  padding-left: 0; // reset padding because ul and ol\n  margin-bottom: 0;\n  @include border-radius($list-group-border-radius);\n}\n\n.list-group-numbered {\n  list-style-type: none;\n  counter-reset: section;\n\n  > li::before {\n    // Increments only this instance of the section counter\n    content: counters(section, \".\") \". \";\n    counter-increment: section;\n  }\n}\n\n\n// Interactive list items\n//\n// Use anchor or button elements instead of `li`s or `div`s to create interactive\n// list items. Includes an extra `.active` modifier class for selected items.\n\n.list-group-item-action {\n  width: 100%; // For `<button>`s (anchors become 100% by default though)\n  color: $list-group-action-color;\n  text-align: inherit; // For `<button>`s (anchors inherit)\n\n  // Hover state\n  &:hover,\n  &:focus {\n    z-index: 1; // Place hover/focus items above their siblings for proper border styling\n    color: $list-group-action-hover-color;\n    text-decoration: none;\n    background-color: $list-group-hover-bg;\n  }\n\n  &:active {\n    color: $list-group-action-active-color;\n    background-color: $list-group-action-active-bg;\n  }\n}\n\n\n// Individual list items\n//\n// Use on `li`s or `div`s within the `.list-group` parent.\n\n.list-group-item {\n  position: relative;\n  display: block;\n  padding: $list-group-item-padding-y $list-group-item-padding-x;\n  color: $list-group-color;\n  text-decoration: if($link-decoration == none, null, none);\n  background-color: $list-group-bg;\n  border: $list-group-border-width solid $list-group-border-color;\n\n  &:first-child {\n    @include border-top-radius(inherit);\n  }\n\n  &:last-child {\n    @include border-bottom-radius(inherit);\n  }\n\n  &.disabled,\n  &:disabled {\n    color: $list-group-disabled-color;\n    pointer-events: none;\n    background-color: $list-group-disabled-bg;\n  }\n\n  // Include both here for `<a>`s and `<button>`s\n  &.active {\n    z-index: 2; // Place active items above their siblings for proper border styling\n    color: $list-group-active-color;\n    background-color: $list-group-active-bg;\n    border-color: $list-group-active-border-color;\n  }\n\n  & + & {\n    border-top-width: 0;\n\n    &.active {\n      margin-top: -$list-group-border-width;\n      border-top-width: $list-group-border-width;\n    }\n  }\n}\n\n\n// Horizontal\n//\n// Change the layout of list group items from vertical (default) to horizontal.\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    .list-group-horizontal#{$infix} {\n      flex-direction: row;\n\n      > .list-group-item {\n        &:first-child {\n          @include border-bottom-start-radius($list-group-border-radius);\n          @include border-top-end-radius(0);\n        }\n\n        &:last-child {\n          @include border-top-end-radius($list-group-border-radius);\n          @include border-bottom-start-radius(0);\n        }\n\n        &.active {\n          margin-top: 0;\n        }\n\n        + .list-group-item {\n          border-top-width: $list-group-border-width;\n          border-left-width: 0;\n\n          &.active {\n            margin-left: -$list-group-border-width;\n            border-left-width: $list-group-border-width;\n          }\n        }\n      }\n    }\n  }\n}\n\n\n// Flush list items\n//\n// Remove borders and border-radius to keep list group items edge-to-edge. Most\n// useful within other components (e.g., cards).\n\n.list-group-flush {\n  @include border-radius(0);\n\n  > .list-group-item {\n    border-width: 0 0 $list-group-border-width;\n\n    &:last-child {\n      border-bottom-width: 0;\n    }\n  }\n}\n\n\n// scss-docs-start list-group-modifiers\n// List group contextual variants\n//\n// Add modifier classes to change text and background color on individual items.\n// Organizationally, this must come after the `:hover` states.\n\n@each $state, $value in $theme-colors {\n  $list-group-variant-bg: shift-color($value, $list-group-item-bg-scale);\n  $list-group-variant-color: shift-color($value, $list-group-item-color-scale);\n  @if (contrast-ratio($list-group-variant-bg, $list-group-variant-color) < $min-contrast-ratio) {\n    $list-group-variant-color: mix($value, color-contrast($list-group-variant-bg), abs($list-group-item-color-scale));\n  }\n\n  @include list-group-item-variant($state, $list-group-variant-bg, $list-group-variant-color);\n}\n// scss-docs-end list-group-modifiers\n","// List Groups\n\n// scss-docs-start list-group-mixin\n@mixin list-group-item-variant($state, $background, $color) {\n  .list-group-item-#{$state} {\n    color: $color;\n    background-color: $background;\n\n    &.list-group-item-action {\n      &:hover,\n      &:focus {\n        color: $color;\n        background-color: shade-color($background, 10%);\n      }\n\n      &.active {\n        color: $white;\n        background-color: $color;\n        border-color: $color;\n      }\n    }\n  }\n}\n// scss-docs-end list-group-mixin\n","// transparent background and border properties included for button version.\n// iOS requires the button element instead of an anchor tag.\n// If you want the anchor version, it requires `href=\"#\"`.\n// See https://developer.mozilla.org/en-US/docs/Web/Events/click#Safari_Mobile\n\n.btn-close {\n  box-sizing: content-box;\n  width: $btn-close-width;\n  height: $btn-close-height;\n  padding: $btn-close-padding-y $btn-close-padding-x;\n  color: $btn-close-color;\n  background: transparent escape-svg($btn-close-bg) center / $btn-close-width auto no-repeat; // include transparent for button elements\n  border: 0; // for button elements\n  @include border-radius();\n  opacity: $btn-close-opacity;\n\n  // Override <a>'s hover style\n  &:hover {\n    color: $btn-close-color;\n    text-decoration: none;\n    opacity: $btn-close-hover-opacity;\n  }\n\n  &:focus {\n    outline: 0;\n    box-shadow: $btn-close-focus-shadow;\n    opacity: $btn-close-focus-opacity;\n  }\n\n  &:disabled,\n  &.disabled {\n    pointer-events: none;\n    user-select: none;\n    opacity: $btn-close-disabled-opacity;\n  }\n}\n\n.btn-close-white {\n  filter: $btn-close-white-filter;\n}\n","// Base class\n.tooltip {\n  position: absolute;\n  z-index: $zindex-tooltip;\n  display: block;\n  margin: $tooltip-margin;\n  // Our parent element can be arbitrary since tooltips are by default inserted as a sibling of their target element.\n  // So reset our font and text properties to avoid inheriting weird values.\n  @include reset-text();\n  @include font-size($tooltip-font-size);\n  // Allow breaking very long words so they don't overflow the tooltip's bounds\n  word-wrap: break-word;\n  opacity: 0;\n\n  &.show { opacity: $tooltip-opacity; }\n\n  .tooltip-arrow {\n    position: absolute;\n    display: block;\n    width: $tooltip-arrow-width;\n    height: $tooltip-arrow-height;\n\n    &::before {\n      position: absolute;\n      content: \"\";\n      border-color: transparent;\n      border-style: solid;\n    }\n  }\n}\n\n.bs-tooltip-top {\n  padding: $tooltip-arrow-height 0;\n\n  .tooltip-arrow {\n    bottom: 0;\n\n    &::before {\n      top: -1px;\n      border-width: $tooltip-arrow-height ($tooltip-arrow-width * .5) 0;\n      border-top-color: $tooltip-arrow-color;\n    }\n  }\n}\n\n.bs-tooltip-end {\n  padding: 0 $tooltip-arrow-height;\n\n  .tooltip-arrow {\n    left: 0;\n    width: $tooltip-arrow-height;\n    height: $tooltip-arrow-width;\n\n    &::before {\n      right: -1px;\n      border-width: ($tooltip-arrow-width * .5) $tooltip-arrow-height ($tooltip-arrow-width * .5) 0;\n      border-right-color: $tooltip-arrow-color;\n    }\n  }\n}\n\n.bs-tooltip-bottom {\n  padding: $tooltip-arrow-height 0;\n\n  .tooltip-arrow {\n    top: 0;\n\n    &::before {\n      bottom: -1px;\n      border-width: 0 ($tooltip-arrow-width * .5) $tooltip-arrow-height;\n      border-bottom-color: $tooltip-arrow-color;\n    }\n  }\n}\n\n.bs-tooltip-start {\n  padding: 0 $tooltip-arrow-height;\n\n  .tooltip-arrow {\n    right: 0;\n    width: $tooltip-arrow-height;\n    height: $tooltip-arrow-width;\n\n    &::before {\n      left: -1px;\n      border-width: ($tooltip-arrow-width * .5) 0 ($tooltip-arrow-width * .5) $tooltip-arrow-height;\n      border-left-color: $tooltip-arrow-color;\n    }\n  }\n}\n\n.bs-tooltip-auto {\n  &[data-popper-placement^=\"top\"] {\n    @extend .bs-tooltip-top;\n  }\n  &[data-popper-placement^=\"right\"] {\n    @extend .bs-tooltip-end;\n  }\n  &[data-popper-placement^=\"bottom\"] {\n    @extend .bs-tooltip-bottom;\n  }\n  &[data-popper-placement^=\"left\"] {\n    @extend .bs-tooltip-start;\n  }\n}\n\n// Wrapper for the tooltip content\n.tooltip-inner {\n  max-width: $tooltip-max-width;\n  padding: $tooltip-padding-y $tooltip-padding-x;\n  color: $tooltip-color;\n  text-align: center;\n  background-color: $tooltip-bg;\n  @include border-radius($tooltip-border-radius);\n}\n","@mixin reset-text {\n  font-family: $font-family-base;\n  // We deliberately do NOT reset font-size or overflow-wrap / word-wrap.\n  font-style: normal;\n  font-weight: $font-weight-normal;\n  line-height: $line-height-base;\n  text-align: left; // Fallback for where `start` is not supported\n  text-align: start;\n  text-decoration: none;\n  text-shadow: none;\n  text-transform: none;\n  letter-spacing: normal;\n  word-break: normal;\n  word-spacing: normal;\n  white-space: normal;\n  line-break: auto;\n}\n",".popover {\n  position: absolute;\n  top: 0;\n  left: 0 #{\"/* rtl:ignore */\"};\n  z-index: $zindex-popover;\n  display: block;\n  max-width: $popover-max-width;\n  // Our parent element can be arbitrary since tooltips are by default inserted as a sibling of their target element.\n  // So reset our font and text properties to avoid inheriting weird values.\n  @include reset-text();\n  @include font-size($popover-font-size);\n  // Allow breaking very long words so they don't overflow the popover's bounds\n  word-wrap: break-word;\n  background-color: $popover-bg;\n  background-clip: padding-box;\n  border: $popover-border-width solid $popover-border-color;\n  @include border-radius($popover-border-radius);\n  @include box-shadow($popover-box-shadow);\n\n  .popover-arrow {\n    position: absolute;\n    display: block;\n    width: $popover-arrow-width;\n    height: $popover-arrow-height;\n\n    &::before,\n    &::after {\n      position: absolute;\n      display: block;\n      content: \"\";\n      border-color: transparent;\n      border-style: solid;\n    }\n  }\n}\n\n.bs-popover-top {\n  > .popover-arrow {\n    bottom: subtract(-$popover-arrow-height, $popover-border-width);\n\n    &::before {\n      bottom: 0;\n      border-width: $popover-arrow-height ($popover-arrow-width * .5) 0;\n      border-top-color: $popover-arrow-outer-color;\n    }\n\n    &::after {\n      bottom: $popover-border-width;\n      border-width: $popover-arrow-height ($popover-arrow-width * .5) 0;\n      border-top-color: $popover-arrow-color;\n    }\n  }\n}\n\n.bs-popover-end {\n  > .popover-arrow {\n    left: subtract(-$popover-arrow-height, $popover-border-width);\n    width: $popover-arrow-height;\n    height: $popover-arrow-width;\n\n    &::before {\n      left: 0;\n      border-width: ($popover-arrow-width * .5) $popover-arrow-height ($popover-arrow-width * .5) 0;\n      border-right-color: $popover-arrow-outer-color;\n    }\n\n    &::after {\n      left: $popover-border-width;\n      border-width: ($popover-arrow-width * .5) $popover-arrow-height ($popover-arrow-width * .5) 0;\n      border-right-color: $popover-arrow-color;\n    }\n  }\n}\n\n.bs-popover-bottom {\n  > .popover-arrow {\n    top: subtract(-$popover-arrow-height, $popover-border-width);\n\n    &::before {\n      top: 0;\n      border-width: 0 ($popover-arrow-width * .5) $popover-arrow-height ($popover-arrow-width * .5);\n      border-bottom-color: $popover-arrow-outer-color;\n    }\n\n    &::after {\n      top: $popover-border-width;\n      border-width: 0 ($popover-arrow-width * .5) $popover-arrow-height ($popover-arrow-width * .5);\n      border-bottom-color: $popover-arrow-color;\n    }\n  }\n\n  // This will remove the popover-header's border just below the arrow\n  .popover-header::before {\n    position: absolute;\n    top: 0;\n    left: 50%;\n    display: block;\n    width: $popover-arrow-width;\n    margin-left: -$popover-arrow-width * .5;\n    content: \"\";\n    border-bottom: $popover-border-width solid $popover-header-bg;\n  }\n}\n\n.bs-popover-start {\n  > .popover-arrow {\n    right: subtract(-$popover-arrow-height, $popover-border-width);\n    width: $popover-arrow-height;\n    height: $popover-arrow-width;\n\n    &::before {\n      right: 0;\n      border-width: ($popover-arrow-width * .5) 0 ($popover-arrow-width * .5) $popover-arrow-height;\n      border-left-color: $popover-arrow-outer-color;\n    }\n\n    &::after {\n      right: $popover-border-width;\n      border-width: ($popover-arrow-width * .5) 0 ($popover-arrow-width * .5) $popover-arrow-height;\n      border-left-color: $popover-arrow-color;\n    }\n  }\n}\n\n.bs-popover-auto {\n  &[data-popper-placement^=\"top\"] {\n    @extend .bs-popover-top;\n  }\n  &[data-popper-placement^=\"right\"] {\n    @extend .bs-popover-end;\n  }\n  &[data-popper-placement^=\"bottom\"] {\n    @extend .bs-popover-bottom;\n  }\n  &[data-popper-placement^=\"left\"] {\n    @extend .bs-popover-start;\n  }\n}\n\n// Offset the popover to account for the popover arrow\n.popover-header {\n  padding: $popover-header-padding-y $popover-header-padding-x;\n  margin-bottom: 0; // Reset the default from Reboot\n  @include font-size($font-size-base);\n  color: $popover-header-color;\n  background-color: $popover-header-bg;\n  border-bottom: $popover-border-width solid $popover-border-color;\n  @include border-top-radius($popover-inner-border-radius);\n\n  &:empty {\n    display: none;\n  }\n}\n\n.popover-body {\n  padding: $popover-body-padding-y $popover-body-padding-x;\n  color: $popover-body-color;\n}\n","// Notes on the classes:\n//\n// 1. .carousel.pointer-event should ideally be pan-y (to allow for users to scroll vertically)\n//    even when their scroll action started on a carousel, but for compatibility (with Firefox)\n//    we're preventing all actions instead\n// 2. The .carousel-item-start and .carousel-item-end is used to indicate where\n//    the active slide is heading.\n// 3. .active.carousel-item is the current slide.\n// 4. .active.carousel-item-start and .active.carousel-item-end is the current\n//    slide in its in-transition state. Only one of these occurs at a time.\n// 5. .carousel-item-next.carousel-item-start and .carousel-item-prev.carousel-item-end\n//    is the upcoming slide in transition.\n\n.carousel {\n  position: relative;\n}\n\n.carousel.pointer-event {\n  touch-action: pan-y;\n}\n\n.carousel-inner {\n  position: relative;\n  width: 100%;\n  overflow: hidden;\n  @include clearfix();\n}\n\n.carousel-item {\n  position: relative;\n  display: none;\n  float: left;\n  width: 100%;\n  margin-right: -100%;\n  backface-visibility: hidden;\n  @include transition($carousel-transition);\n}\n\n.carousel-item.active,\n.carousel-item-next,\n.carousel-item-prev {\n  display: block;\n}\n\n/* rtl:begin:ignore */\n.carousel-item-next:not(.carousel-item-start),\n.active.carousel-item-end {\n  transform: translateX(100%);\n}\n\n.carousel-item-prev:not(.carousel-item-end),\n.active.carousel-item-start {\n  transform: translateX(-100%);\n}\n\n/* rtl:end:ignore */\n\n\n//\n// Alternate transitions\n//\n\n.carousel-fade {\n  .carousel-item {\n    opacity: 0;\n    transition-property: opacity;\n    transform: none;\n  }\n\n  .carousel-item.active,\n  .carousel-item-next.carousel-item-start,\n  .carousel-item-prev.carousel-item-end {\n    z-index: 1;\n    opacity: 1;\n  }\n\n  .active.carousel-item-start,\n  .active.carousel-item-end {\n    z-index: 0;\n    opacity: 0;\n    @include transition(opacity 0s $carousel-transition-duration);\n  }\n}\n\n\n//\n// Left/right controls for nav\n//\n\n.carousel-control-prev,\n.carousel-control-next {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  z-index: 1;\n  // Use flex for alignment (1-3)\n  display: flex; // 1. allow flex styles\n  align-items: center; // 2. vertically center contents\n  justify-content: center; // 3. horizontally center contents\n  width: $carousel-control-width;\n  padding: 0;\n  color: $carousel-control-color;\n  text-align: center;\n  background: none;\n  border: 0;\n  opacity: $carousel-control-opacity;\n  @include transition($carousel-control-transition);\n\n  // Hover/focus state\n  &:hover,\n  &:focus {\n    color: $carousel-control-color;\n    text-decoration: none;\n    outline: 0;\n    opacity: $carousel-control-hover-opacity;\n  }\n}\n.carousel-control-prev {\n  left: 0;\n  background-image: if($enable-gradients, linear-gradient(90deg, rgba($black, .25), rgba($black, .001)), null);\n}\n.carousel-control-next {\n  right: 0;\n  background-image: if($enable-gradients, linear-gradient(270deg, rgba($black, .25), rgba($black, .001)), null);\n}\n\n// Icons for within\n.carousel-control-prev-icon,\n.carousel-control-next-icon {\n  display: inline-block;\n  width: $carousel-control-icon-width;\n  height: $carousel-control-icon-width;\n  background-repeat: no-repeat;\n  background-position: 50%;\n  background-size: 100% 100%;\n}\n\n/* rtl:options: {\n  \"autoRename\": true,\n  \"stringMap\":[ {\n    \"name\"    : \"prev-next\",\n    \"search\"  : \"prev\",\n    \"replace\" : \"next\"\n  } ]\n} */\n.carousel-control-prev-icon {\n  background-image: escape-svg($carousel-control-prev-icon-bg);\n}\n.carousel-control-next-icon {\n  background-image: escape-svg($carousel-control-next-icon-bg);\n}\n\n// Optional indicator pips/controls\n//\n// Add a container (such as a list) with the following class and add an item (ideally a focusable control,\n// like a button) with data-bs-target for each slide your carousel holds.\n\n.carousel-indicators {\n  position: absolute;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 2;\n  display: flex;\n  justify-content: center;\n  padding: 0;\n  // Use the .carousel-control's width as margin so we don't overlay those\n  margin-right: $carousel-control-width;\n  margin-bottom: 1rem;\n  margin-left: $carousel-control-width;\n  list-style: none;\n\n  [data-bs-target] {\n    box-sizing: content-box;\n    flex: 0 1 auto;\n    width: $carousel-indicator-width;\n    height: $carousel-indicator-height;\n    padding: 0;\n    margin-right: $carousel-indicator-spacer;\n    margin-left: $carousel-indicator-spacer;\n    text-indent: -999px;\n    cursor: pointer;\n    background-color: $carousel-indicator-active-bg;\n    background-clip: padding-box;\n    border: 0;\n    // Use transparent borders to increase the hit area by 10px on top and bottom.\n    border-top: $carousel-indicator-hit-area-height solid transparent;\n    border-bottom: $carousel-indicator-hit-area-height solid transparent;\n    opacity: $carousel-indicator-opacity;\n    @include transition($carousel-indicator-transition);\n  }\n\n  .active {\n    opacity: $carousel-indicator-active-opacity;\n  }\n}\n\n\n// Optional captions\n//\n//\n\n.carousel-caption {\n  position: absolute;\n  right: (100% - $carousel-caption-width) * .5;\n  bottom: $carousel-caption-spacer;\n  left: (100% - $carousel-caption-width) * .5;\n  padding-top: $carousel-caption-padding-y;\n  padding-bottom: $carousel-caption-padding-y;\n  color: $carousel-caption-color;\n  text-align: center;\n}\n\n// Dark mode carousel\n\n.carousel-dark {\n  .carousel-control-prev-icon,\n  .carousel-control-next-icon {\n    filter: $carousel-dark-control-icon-filter;\n  }\n\n  .carousel-indicators [data-bs-target] {\n    background-color: $carousel-dark-indicator-active-bg;\n  }\n\n  .carousel-caption {\n    color: $carousel-dark-caption-color;\n  }\n}\n","// scss-docs-start clearfix\n@mixin clearfix() {\n  &::after {\n    display: block;\n    clear: both;\n    content: \"\";\n  }\n}\n// scss-docs-end clearfix\n","/*!\n * Bootstrap Utilities v5.0.2 (https://getbootstrap.com/)\n * Copyright 2011-2021 The Bootstrap Authors\n * Copyright 2011-2021 Twitter, Inc.\n * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)\n */\n\n// Configuration\n@import \"functions\";\n@import \"variables\";\n@import \"mixins\";\n@import \"utilities\";\n\n// Helpers\n@import \"helpers\";\n\n// Utilities\n@import \"utilities/api\";\n","@each $color, $value in $theme-colors {\n  .link-#{$color} {\n    color: $value;\n\n    @if $link-shade-percentage != 0 {\n      &:hover,\n      &:focus {\n        color: if(color-contrast($value) == $color-contrast-light, shade-color($value, $link-shade-percentage), tint-color($value, $link-shade-percentage));\n      }\n    }\n  }\n}\n","// Credit: Nicolas Gallagher and SUIT CSS.\n\n.ratio {\n  position: relative;\n  width: 100%;\n\n  &::before {\n    display: block;\n    padding-top: var(--#{$variable-prefix}aspect-ratio);\n    content: \"\";\n  }\n\n  > * {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n  }\n}\n\n@each $key, $ratio in $aspect-ratios {\n  .ratio-#{$key} {\n    --#{$variable-prefix}aspect-ratio: #{$ratio};\n  }\n}\n","// Shorthand\n\n.fixed-top {\n  position: fixed;\n  top: 0;\n  right: 0;\n  left: 0;\n  z-index: $zindex-fixed;\n}\n\n.fixed-bottom {\n  position: fixed;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: $zindex-fixed;\n}\n\n// Responsive sticky top\n@each $breakpoint in map-keys($grid-breakpoints) {\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    .sticky#{$infix}-top {\n      position: sticky;\n      top: 0;\n      z-index: $zindex-sticky;\n    }\n  }\n}\n","//\n// Visually hidden\n//\n\n.visually-hidden,\n.visually-hidden-focusable:not(:focus):not(:focus-within) {\n  @include visually-hidden();\n}\n","// stylelint-disable declaration-no-important\n\n// Hide content visually while keeping it accessible to assistive technologies\n//\n// See: https://www.a11yproject.com/posts/2013-01-11-how-to-hide-content/\n// See: https://hugogiraudel.com/2016/10/13/css-hide-and-seek/\n\n@mixin visually-hidden() {\n  position: absolute !important;\n  width: 1px !important;\n  height: 1px !important;\n  padding: 0 !important;\n  margin: -1px !important; // Fix for https://github.com/twbs/bootstrap/issues/25686\n  overflow: hidden !important;\n  clip: rect(0, 0, 0, 0) !important;\n  white-space: nowrap !important;\n  border: 0 !important;\n}\n\n// Use to only display content when it's focused, or one of its child elements is focused\n// (i.e. when focus is within the element/container that the class was applied to)\n//\n// Useful for \"Skip to main content\" links; see https://www.w3.org/TR/2013/NOTE-WCAG20-TECHS-20130905/G1\n\n@mixin visually-hidden-focusable() {\n  &:not(:focus):not(:focus-within) {\n    @include visually-hidden();\n  }\n}\n","//\n// Stretched link\n//\n\n.stretched-link {\n  &::#{$stretched-link-pseudo-element} {\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    z-index: $stretched-link-z-index;\n    content: \"\";\n  }\n}\n","//\n// Text truncation\n//\n\n.text-truncate {\n  @include text-truncate();\n}\n","// Text truncate\n// Requires inline-block or block for proper styling\n\n@mixin text-truncate() {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n","// Utility generator\n// Used to generate utilities & print utilities\n@mixin generate-utility($utility, $infix, $is-rfs-media-query: false) {\n  $values: map-get($utility, values);\n\n  // If the values are a list or string, convert it into a map\n  @if type-of($values) == \"string\" or type-of(nth($values, 1)) != \"list\" {\n    $values: zip($values, $values);\n  }\n\n  @each $key, $value in $values {\n    $properties: map-get($utility, property);\n\n    // Multiple properties are possible, for example with vertical or horizontal margins or paddings\n    @if type-of($properties) == \"string\" {\n      $properties: append((), $properties);\n    }\n\n    // Use custom class if present\n    $property-class: if(map-has-key($utility, class), map-get($utility, class), nth($properties, 1));\n    $property-class: if($property-class == null, \"\", $property-class);\n\n    // State params to generate pseudo-classes\n    $state: if(map-has-key($utility, state), map-get($utility, state), ());\n\n    $infix: if($property-class == \"\" and str-slice($infix, 1, 1) == \"-\", str-slice($infix, 2), $infix);\n\n    // Don't prefix if value key is null (eg. with shadow class)\n    $property-class-modifier: if($key, if($property-class == \"\" and $infix == \"\", \"\", \"-\") + $key, \"\");\n\n    @if map-get($utility, rfs) {\n      // Inside the media query\n      @if $is-rfs-media-query {\n        $val: rfs-value($value);\n\n        // Do not render anything if fluid and non fluid values are the same\n        $value: if($val == rfs-fluid-value($value), null, $val);\n      }\n      @else {\n        $value: rfs-fluid-value($value);\n      }\n    }\n\n    $is-rtl: map-get($utility, rtl);\n\n    @if $value != null {\n      @if $is-rtl == false {\n        /* rtl:begin:remove */\n      }\n      .#{$property-class + $infix + $property-class-modifier} {\n        @each $property in $properties {\n          #{$property}: $value if($enable-important-utilities, !important, null);\n        }\n      }\n\n      @each $pseudo in $state {\n        .#{$property-class + $infix + $property-class-modifier}-#{$pseudo}:#{$pseudo} {\n          @each $property in $properties {\n            #{$property}: $value if($enable-important-utilities, !important, null);\n          }\n        }\n      }\n      @if $is-rtl == false {\n        /* rtl:end:remove */\n      }\n    }\n  }\n}\n","// Loop over each breakpoint\n@each $breakpoint in map-keys($grid-breakpoints) {\n\n  // Generate media query if needed\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    // Loop over each utility property\n    @each $key, $utility in $utilities {\n      // The utility can be disabled with `false`, thus check if the utility is a map first\n      // Only proceed if responsive media queries are enabled or if it's the base media query\n      @if type-of($utility) == \"map\" and (map-get($utility, responsive) or $infix == \"\") {\n        @include generate-utility($utility, $infix);\n      }\n    }\n  }\n}\n\n// RFS rescaling\n@media (min-width: $rfs-mq-value) {\n  @each $breakpoint in map-keys($grid-breakpoints) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    @if (map-get($grid-breakpoints, $breakpoint) < $rfs-breakpoint) {\n      // Loop over each utility property\n      @each $key, $utility in $utilities {\n        // The utility can be disabled with `false`, thus check if the utility is a map first\n        // Only proceed if responsive media queries are enabled or if it's the base media query\n        @if type-of($utility) == \"map\" and map-get($utility, rfs) and (map-get($utility, responsive) or $infix == \"\") {\n          @include generate-utility($utility, $infix, true);\n        }\n      }\n    }\n  }\n}\n\n\n// Print utilities\n@media print {\n  @each $key, $utility in $utilities {\n    // The utility can be disabled with `false`, thus check if the utility is a map first\n    // Then check if the utility needs print styles\n    @if type-of($utility) == \"map\" and map-get($utility, print) == true {\n      @include generate-utility($utility, \"-print\");\n    }\n  }\n}\n",".alert{\n    border: 0;\n    color: $white;\n\n    .alert-link{\n      color: $white;\n    }\n\n    &.alert-success{\n      background-color: darken($success, 10%);\n    }\n\n    i.fa,\n    i.tim-icons{\n        font-size: $font-paragraph;\n    }\n\n    .close{\n        color: $white;\n        opacity: .9;\n        text-shadow: none;\n        line-height: 0;\n        outline: 0;\n        &::after{\n          display: inline-block;\n          font: normal normal normal 1em/1 'Nucleo';\n          vertical-align: middle;\n          speak: none;\n          text-transform: none;\n          -webkit-font-smoothing: antialiased;\n          font-size: 1rem;\n          content: \"\\ea48\"\n        }\n        span {\n          display: none !important;\n        }\n    }\n\n    span[data-notify=\"icon\"]{\n      font-size: 22px;\n      display: block;\n      left: 19px;\n      position: absolute;\n      top: 50%;\n      margin-top: -11px;\n    }\n\n    button.close{\n      position: absolute;\n      right: 15px;\n      top: 50%;\n      margin-top: -13px;\n      width: 25px;\n      height: 25px;\n      padding: 3px;\n    }\n\n    .close ~ span{\n        display: block;\n        max-width: 89%;\n    }\n\n    &.alert-with-icon{\n        padding-left: 65px;\n    }\n}\n\n.alert-dismissible {\n    padding-right: 1.25rem;\n    .close {\n\n        &:hover,\n        &:focus {\n            color: rgba($white, .9);\n            opacity: 1 !important;\n        }\n\n        @include media-breakpoint-down(xs) {\n            top: 1rem;\n            right: .5rem;\n        }\n\n        &>span:not(.sr-only) {\n            font-size: 1.5rem;\n            background-color: transparent;\n            color: rgba($white, .6);\n        }\n\n        &:hover,\n        &:focus {\n            &>span:not(.sr-only) {\n                background-color: transparent;\n                color: rgba($white, .9);\n            }\n        }\n    }\n    &.animated {\n      z-index: 9999;\n      .close {\n        right: 10px;\n      }\n    }\n}\n",".badge + .badge {\n  margin-left: 5px;\n}\n",".btn,\n.navbar .navbar-nav > a.btn{\n    border-width: $border-thick;\n    border: none;\n    position: relative;\n    overflow: hidden;\n    margin:4px 1px;\n    border-radius: $border-radius-lg;\n    cursor: pointer;\n\n    @include btn-styles($default, $default-states);\n\n    &:hover,\n    &:focus{\n        @include opacity(1);\n        outline: 0 !important;\n    }\n    &:active,\n    &.active,\n    .open > &.dropdown-toggle {\n         @include box-shadow(none);\n         outline: 0 !important;\n    }\n\n    .badge{\n      margin: 0;\n    }\n\n    &.btn-icon {\n        // see above for color variations\n        height: $icon-size-regular;\n        min-width: $icon-size-regular;\n        width: $icon-size-regular;\n        padding: 0;\n        font-size: $icon-font-size-regular;\n        overflow: hidden;\n        position: relative;\n        line-height: normal;\n\n        &.btn-simple{\n            padding: 0;\n        }\n\n        &.btn-sm{\n            height: $icon-size-sm;\n            min-width: $icon-size-sm;\n            width: $icon-size-sm;\n\n            .fa,\n            .far,\n            .fas,\n            .tim-icons{\n                font-size: $icon-font-size-sm;\n            }\n        }\n\n        &.btn-lg{\n            height: $icon-size-lg;\n            min-width: $icon-size-lg;\n            width: $icon-size-lg;\n\n            .fa,\n            .far,\n            .fas,\n            .tim-icons{\n                font-size: $icon-font-size-lg;\n            }\n        }\n\n        &:not(.btn-footer) .tim-icons,\n        &:not(.btn-footer) .fa,\n        &:not(.btn-footer) .far,\n        &:not(.btn-footer) .fas{\n            position: absolute;\n            font-size: 1em;\n            top: 50%;\n            left: 50%;\n            transform: translate(-12px, -12px);\n            line-height: 1.5626rem;\n            width: 24px;\n        }\n\n    }\n\n    &:not(.btn-icon) .tim-icons{\n        position: relative;\n        top: 1px;\n    }\n\n    span{\n      position: relative;\n      display: block;\n    }\n\n  &.btn-link.dropdown-toggle {\n    color: $dark-gray;\n  }\n\n  &.dropdown-toggle:after {\n    margin-left: 30px !important;\n  }\n}\n\n// Apply the mixin to the buttons\n// .btn-default { @include btn-styles($default-color, $default-states-color); }\n.btn-primary { @include btn-styles($primary, $primary-states);\n\n              }\n.btn-success { @include btn-styles($success, $success-states);\n\n              }\n.btn-info    { @include btn-styles($info, $info-states);\n\n              }\n.btn-warning { @include btn-styles($warning, $warning-states);\n                &:not(:disabled):not(.disabled):active{\n                  color: $white;\n                }\n              }\n.btn-danger  { @include btn-styles($danger, $danger-states);\n\n              }\n.btn-neutral { @include btn-styles($white, $white); }\n\n.btn{\n     &:disabled,\n     &[disabled],\n     &.disabled{\n        @include opacity(.5);\n        pointer-events: none;\n    }\n}\n.btn-simple{\n    border: $border;\n    border-color: $default;\n    box-shadow: none;\n    padding: $padding-btn-vertical - 1 $padding-round-horizontal - 1;\n    background-color: $transparent-bg;\n}\n\n.btn-simple,\n.btn-link{\n    &.disabled,\n    &:disabled,\n    &[disabled],\n    fieldset[disabled] & {\n        &,\n        &:hover,\n        &:focus,\n        &.focus,\n        &:active,\n        &.active {\n            background: $transparent-bg;\n        }\n    }\n}\n\n.btn:not(:disabled):not(.disabled):active, .btn:not(:disabled):not(.disabled).active{\n  box-shadow: 2px 2px 6px rgba(0,0,0,.4);\n}\n.btn-link{\n    border: $none;\n    box-shadow: none;\n    padding: $padding-base-vertical $padding-base-horizontal;\n    background: $transparent-bg;\n    color: $gray-300;\n    font-weight: $font-weight-bold;\n\n  &:hover {\n    box-shadow: none !important;\n    transform: none !important;\n  }\n}\n\n.btn-lg{\n   @include btn-size($btn-padding-y-lg, $btn-padding-x-lg, $font-size-base, $border-radius-lg);\n}\n.btn-sm{\n    @include btn-size($btn-padding-y-sm, $btn-padding-x-sm, $font-size-base, $border-radius-sm);\n}\n\n.btn-wd {\n    min-width: 140px;\n}\n.btn-group.select{\n    width: 100%;\n}\n\n.btn-group {\n  .btn.active {\n    box-shadow: 2px 2px 6px rgba(0,0,0,.4);\n    transform: translateY(-1px);\n    -webkit-transform: translateY(-1px);\n  }\n}\n\n\n.btn-group.select .btn{\n    text-align: left;\n}\n.btn-group.select .caret{\n    position: absolute;\n    top: 50%;\n    margin-top: -1px;\n    right: 8px;\n}\n\n.btn-group .btn.active {\n    box-shadow: 2px 2px 6px rgba(0,0,0,.4);\n    transform: translateY(-1px);\n    -webkit-transform: translateY(-1px);\n}\n\n.btn-round{\n    border-width: $border-thin;\n    border-radius: $btn-round-radius;\n\n    &.btn-simple{\n        padding: $padding-btn-vertical - 1  $padding-round-horizontal - 1;\n    }\n}\n\n.no-caret {\n  &.dropdown-toggle::after {\n    display: none;\n  }\n}\n\n.btn-secondary:not(:disabled):not(.disabled):active,\n.btn-secondary:not(:disabled):not(.disabled).active,\n.show > .btn-secondary.dropdown-toggle {\n    color: $white;\n}\n\n.btn-group label.btn.active {\n    transform: translateY(0);\n    -webkit-transform: translateY(0);\n}\n\n.btn + .btn {\n  margin-left: 5px;\n}\n","\n@mixin transform-translate-x($value){\n     -webkit-transform:  translate3d($value, 0, 0);\n        -moz-transform: translate3d($value, 0, 0);\n        -o-transform: translate3d($value, 0, 0);\n        -ms-transform: translate3d($value, 0, 0);\n        transform: translate3d($value, 0, 0);\n}\n\n@mixin transform-translate-y($value){\n     -webkit-transform:  translate3d(0,$value,0);\n        -moz-transform: translate3d(0,$value,0);\n        -o-transform: translate3d(0,$value,0);\n        -ms-transform: translate3d(0,$value,0);\n        transform: translate3d(0,$value,0);\n}\n\n@mixin transitions($time, $type){\n    -webkit-transition: all $time $type;\n    -moz-transition: all $time $type;\n    -o-transition: all $time $type;\n    -ms-transition: all $time $type;\n    transition: all $time $type;\n}\n\n@mixin diagonal-gradient($start-color, $end-color){\n  background: $start-color;\n  background-image: -webkit-linear-gradient(to bottom left, $start-color, $end-color, $start-color);\n  background-image: -o-linear-gradient(to bottom left, $start-color, $end-color, $start-color);\n  background-image: -moz-linear-gradient(to bottom left, $start-color, $end-color, $start-color);\n  background-image: linear-gradient(to bottom left, $start-color, $end-color, $start-color);\n  background-size: 210% 210%;\n  background-position: top right;\n}\n\n@mixin bar-animation($type){\n     -webkit-animation: $type 500ms linear 0s;\n     -moz-animation: $type 500ms linear 0s;\n     animation: $type 500ms 0s;\n     -webkit-animation-fill-mode: forwards;\n     -moz-animation-fill-mode: forwards;\n     animation-fill-mode: forwards;\n}\n\n@mixin rotate-180(){\n    filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=2);\n    -webkit-transform: rotate(180deg);\n    -ms-transform: rotate(180deg);\n    transform: rotate(180deg);\n}\n\n@mixin transform-translate-y-dropdown($value) {\n    -webkit-transform:  translate3d(0,$value,0) !important;\n       -moz-transform: translate3d(0,$value,0) !important;\n       -o-transform: translate3d(0,$value,0) !important;\n       -ms-transform: translate3d(0,$value,0) !important;\n       transform: translate3d(0,$value,0) !important;\n}\n\n@mixin linear-gradient($color, $states-color){\n    background: $color;\n    background: -webkit-linear-gradient(0deg, $color 0%, $states-color 100%);\n    background: -o-linear-gradient(0deg, $color 0%, $states-color 100%);\n    background: -moz-linear-gradient(0deg, $color 0%, $states-color 100%);\n    background: linear-gradient(0deg, $color 0%, $states-color 100%);\n}\n\n@mixin linear-gradient-right($color, $states-color){\n    background: $color;\n    background: -webkit-linear-gradient(to right, $color 0%, $states-color 100%);\n    background: -o-linear-gradient(to right, $color 0%, $states-color 100%);\n    background: -moz-linear-gradient(to right, $color 0%, $states-color 100%);\n    background: linear-gradient(to right, $color 0%, $states-color 100%);\n}\n\n@mixin sidebar-color($color){\n  &:after{\n    background: $color;\n  }\n\n  .nav li.active > a{\n    color: $color;\n\n    i{\n      color: $color;\n    }\n  }\n}\n\n@mixin transition-input-focus-color() {\n    -webkit-transition: color 0.3s ease-in-out, border-color 0.3s ease-in-out, background-color 0.3s ease-in-out;\n    -moz-transition: color 0.3s ease-in-out, border-color 0.3s ease-in-out, background-color 0.3s ease-in-out;\n    -o-transition: color 0.3s ease-in-out, border-color 0.3s ease-in-out, background-color 0.3s ease-in-out;\n    -ms-transition: color 0.3s ease-in-out, border-color 0.3s ease-in-out, background-color 0.3s ease-in-out;\n    transition: color 0.3s ease-in-out, border-color 0.3s ease-in-out, background-color 0.3s ease-in-out;\n}\n\n@mixin topbar-x-rotation(){\n    @keyframes topbar-x {\n      0% {top: 0px; transform: rotate(0deg); }\n      45% {top: 6px; transform: rotate(145deg); }\n      75% {transform: rotate(130deg); }\n      100% {transform: rotate(135deg); }\n    }\n    @-webkit-keyframes topbar-x {\n      0% {top: 0px; -webkit-transform: rotate(0deg); }\n      45% {top: 6px; -webkit-transform: rotate(145deg); }\n      75% {-webkit-transform: rotate(130deg); }\n      100% { -webkit-transform: rotate(135deg); }\n    }\n    @-moz-keyframes topbar-x {\n      0% {top: 0px; -moz-transform: rotate(0deg); }\n      45% {top: 6px; -moz-transform: rotate(145deg); }\n      75% {-moz-transform: rotate(130deg); }\n      100% { -moz-transform: rotate(135deg); }\n    }\n}\n\n@mixin topbar-back-rotation(){\n    @keyframes topbar-back {\n      0% { top: 6px; transform: rotate(135deg); }\n      45% { transform: rotate(-10deg); }\n      75% { transform: rotate(5deg); }\n      100% { top: 0px; transform: rotate(0); }\n    }\n\n    @-webkit-keyframes topbar-back {\n      0% { top: 6px; -webkit-transform: rotate(135deg); }\n      45% { -webkit-transform: rotate(-10deg); }\n      75% { -webkit-transform: rotate(5deg); }\n      100% { top: 0px; -webkit-transform: rotate(0); }\n    }\n\n    @-moz-keyframes topbar-back {\n      0% { top: 6px; -moz-transform: rotate(135deg); }\n      45% { -moz-transform: rotate(-10deg); }\n      75% { -moz-transform: rotate(5deg); }\n      100% { top: 0px; -moz-transform: rotate(0); }\n    }\n}\n\n@mixin bottombar-x-rotation(){\n    @keyframes bottombar-x {\n      0% {bottom: 0px; transform: rotate(0deg);}\n      45% {bottom: 6px; transform: rotate(-145deg);}\n      75% {transform: rotate(-130deg);}\n      100% {transform: rotate(-135deg);}\n    }\n    @-webkit-keyframes bottombar-x {\n      0% {bottom: 0px; -webkit-transform: rotate(0deg);}\n      45% {bottom: 6px; -webkit-transform: rotate(-145deg);}\n      75% {-webkit-transform: rotate(-130deg);}\n      100% {-webkit-transform: rotate(-135deg);}\n    }\n    @-moz-keyframes bottombar-x {\n      0% {bottom: 0px; -moz-transform: rotate(0deg);}\n      45% {bottom: 6px; -moz-transform: rotate(-145deg);}\n      75% {-moz-transform: rotate(-130deg);}\n      100% {-moz-transform: rotate(-135deg);}\n    }\n}\n\n@mixin bottombar-back-rotation{\n    @keyframes bottombar-back {\n      0% { bottom: 6px;transform: rotate(-135deg);}\n      45% { transform: rotate(10deg);}\n      75% { transform: rotate(-5deg);}\n      100% { bottom: 0px;transform: rotate(0);}\n    }\n    @-webkit-keyframes bottombar-back {\n      0% {bottom: 6px;-webkit-transform: rotate(-135deg);}\n      45% {-webkit-transform: rotate(10deg);}\n      75% {-webkit-transform: rotate(-5deg);}\n      100% {bottom: 0px;-webkit-transform: rotate(0);}\n    }\n    @-moz-keyframes bottombar-back {\n      0% {bottom: 6px;-moz-transform: rotate(-135deg);}\n      45% {-moz-transform: rotate(10deg);}\n      75% {-moz-transform: rotate(-5deg);}\n      100% {bottom: 0px;-moz-transform: rotate(0);}\n    }\n\n}\n\n\n@mixin nc-rotate($degrees, $rotation) {\n  filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=#{$rotation});\n  -webkit-transform: rotate($degrees);\n  -moz-transform: rotate($degrees);\n  -ms-transform: rotate($degrees);\n  -o-transform: rotate($degrees);\n  transform: rotate($degrees);\n}\n\n@mixin nc-flip($horiz, $vert, $rotation) {\n  filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=#{$rotation});\n  -webkit-transform: scale($horiz, $vert);\n  -moz-transform: scale($horiz, $vert);\n  -ms-transform: scale($horiz, $vert);\n  -o-transform: scale($horiz, $vert);\n  transform: scale($horiz, $vert);\n}\n","@mixin btn-styles($btn-color, $btn-states-color) {\n  @include diagonal-gradient($btn-color, $btn-states-color);\n    background-color: $btn-color;\n    transition: all 0.15s ease;\n    box-shadow: none;\n    &.animation-on-hover:hover{\n      background-position: bottom left;\n      transition:0.3s ease-in-out;\n    }\n\n    &:hover,\n    &:focus,\n    &:active,\n    &.active,\n    &:active:focus,\n    &:active:hover,\n    &.active:focus,\n    &.active:hover\n     {\n        background-color: $btn-states-color !important;\n        background-image: linear-gradient(to bottom left, $btn-color, $btn-states-color, $btn-color) !important;\n        background-image: -webkit-linear-gradient(to bottom left, $btn-color, $btn-states-color, $btn-color) !important;\n        background-image: -o-linear-gradient(to bottom left, $btn-color, $btn-states-color, $btn-color) !important;\n        background-image: -moz-linear-gradient(to bottom left, $btn-color, $btn-states-color, $btn-color) !important;\n        color: $white;\n        box-shadow: none;\n    }\n\n    &:active{\n      box-shadow: none !important;\n      transform: translateY(1px) !important;\n      transition: all .15s ease;\n    }\n\n    &:not([data-action]):hover{\n\n        box-shadow:  2px 2px 6px rgba(0,0,0,0.4);\n        transform: translateY(-1px);\n        -webkit-transform: translateY(-1px);\n    }\n\n    &.disabled,\n    &:disabled,\n    &[disabled],\n    fieldset[disabled] & {\n        &,\n        &:hover,\n        &:focus,\n        &.focus,\n        &:active,\n        &.active {\n            background-color: $btn-color;\n            border-color: $btn-color;\n        }\n    }\n\n    // btn-neutral style\n    @if $btn-color == $white{\n        color: $primary;\n\n        &.btn-danger{\n            color: $danger;\n\n            &:hover,\n            &:focus,\n            &:active,\n            &:active:focus{\n                color: $danger-states;\n            }\n        }\n\n        &.btn-info{\n            color: $info;\n\n            &:hover,\n            &:focus,\n            &:active,\n            &:active:focus{\n                color: $info-states;\n            }\n        }\n\n        &.btn-warning{\n            color: $warning;\n\n            &:hover,\n            &:focus,\n            &:active,\n            &:active:focus{\n                color: $warning-states;\n            }\n        }\n\n        &.btn-success{\n            color: $success;\n\n            &:hover,\n            &:focus,\n            &:active,\n            &:active:focus{\n                color: $success-states;\n            }\n        }\n\n        &.btn-default{\n            color: $default;\n\n            &:hover,\n            &:focus,\n            &:active,\n            &:active:focus{\n                color: $default-states;\n            }\n        }\n\n        &.active,\n        &:active,\n        &:active:focus,\n        &:active:hover,\n        &.active:focus,\n        &.active:hover,\n        .show > &.dropdown-toggle,\n        .show > &.dropdown-toggle:focus,\n        .show > &.dropdown-toggle:hover {\n            background-color: $white;\n            color: $primary-states;\n            box-shadow: none;\n        }\n\n        &:hover,\n        &:focus{\n            color: $primary-states;\n\n            &:not(.nav-link){\n                box-shadow: none;\n            }\n\n        }\n\n    } @else {\n        color: $white;\n    }\n\n    &.btn-simple{\n        color: $btn-color;\n        border-color: $btn-color;\n        background: $transparent-bg;\n\n        &:hover,\n        &:focus,\n        &:active,\n        &:not(:disabled):not(.disabled):active{\n            color: $btn-color;\n            border-color: $btn-color;\n            background-color: $transparent-bg !important;\n            background-image: none !important;\n            box-shadow: none;\n        }\n\n        &.active{\n          border-color: $btn-color !important;\n          &:hover,\n          &:focus,\n          &:active,\n          &:not(:disabled):not(.disabled):active{\n              color: $white;\n              border-color: $btn-color;\n              background-image: linear-gradient(to bottom left, $btn-color, $btn-states-color, $btn-color) !important;\n              background-image: -webkit-linear-gradient(to bottom left, $btn-color, $btn-states-color, $btn-color) !important;\n              background-image: -o-linear-gradient(to bottom left, $btn-color, $btn-states-color, $btn-color) !important;\n              background-image: -moz-linear-gradient(to bottom left, $btn-color, $btn-states-color, $btn-color) !important;\n              background-color: $btn-states-color !important;\n              box-shadow: none;\n          }\n        }\n    }\n\n    &.btn-link{\n        color: $btn-color;\n        &:hover,\n        &:focus,\n        &:active{\n            background-color: $transparent-bg !important;\n            background-image: none !important;\n            color: $white !important;\n            text-decoration: none;\n            box-shadow: none;\n        }\n    }\n}\n\n@mixin button-variant($background, $border, $hover-background: darken($background, 0%), $hover-border: darken($border, 0%), $active-background: darken($background, 10%), $active-border: darken($border, 0%)) {\n    color: color-yiq($background);\n    @include gradient-bg($background);\n    border-color: $border;\n    @include box-shadow($btn-box-shadow);\n\n    @include hover {\n        color: color-yiq($hover-background);\n        @include gradient-bg($hover-background);\n        border-color: $hover-border;\n    }\n\n    &:focus,\n    &.focus {\n        // Avoid using mixin so we can pass custom focus shadow properly\n        @if $enable-shadows {\n            box-shadow: $btn-box-shadow, 0 0 0 $btn-focus-width rgba($border, .5);\n        }\n        @else {\n            box-shadow: 0 0 0 $btn-focus-width rgba($border, .5);\n        }\n    } // Disabled comes first so active can properly restyle\n    &.disabled,\n    &:disabled {\n        color: color-yiq($background);\n        background-color: $background;\n        border-color: $border;\n    }\n\n    &:not(:disabled):not(.disabled):active,\n    &:not(:disabled):not(.disabled).active,\n    .show>&.dropdown-toggle {\n        color: color-yiq($active-background);\n        background-color: $active-background;\n        @if $enable-gradients {\n            background-image: none; // Remove the gradient for the pressed/active state\n        }\n        border-color: $active-border;\n\n        &:focus {\n            // Avoid using mixin so we can pass custom focus shadow properly\n            @if $enable-shadows {\n                box-shadow: $btn-active-box-shadow, 0 0 0 $btn-focus-width rgba($border, .5);\n            }\n            @else {\n                box-shadow: 0 0 0 $btn-focus-width rgba($border, .5);\n            }\n        }\n    }\n}\n\n@mixin button-outline-variant($color, $color-hover: color-yiq($color), $active-background: $color, $active-border: $color) {\n    color: $color;\n    background-color: transparent;\n    background-image: none;\n    border-color: $color;\n\n    &:hover {\n        color: $color-hover;\n        background-color: $active-background;\n        border-color: $active-border;\n    }\n\n    &:focus,\n    &.focus {\n        box-shadow: 0 0 0 $btn-focus-width rgba($color, .5);\n    }\n\n    &.disabled,\n    &:disabled {\n        color: $color;\n        background-color: transparent;\n    }\n\n    &:not(:disabled):not(.disabled):active,\n    &:not(:disabled):not(.disabled).active,\n    .show>&.dropdown-toggle {\n        color: color-yiq($active-background);\n        background-color: $active-background;\n        border-color: $active-border;\n\n        &:focus {\n            // Avoid using mixin so we can pass custom focus shadow properly\n            @if $enable-shadows and $btn-active-box-shadow !=none {\n                box-shadow: $btn-active-box-shadow, 0 0 0 $btn-focus-width rgba($color, .5);\n            }\n            @else {\n                box-shadow: 0 0 0 $btn-focus-width rgba($color, .5);\n            }\n        }\n    }\n}\n\n// Button sizes\n@mixin btn-size($padding-vertical, $padding-horizontal, $font-size, $border){\n   font-size: $font-size;\n   border-radius: $border;\n   padding: $padding-vertical $padding-horizontal;\n\n   &.btn-simple{\n       padding: $padding-vertical - 1 $padding-horizontal - 1;\n   }\n\n}\n\n// for social buttons\n@mixin social-buttons-color ($color, $state-color){\n  @include diagonal-gradient($color, darken($color,20%));\n    //background-color: $color;\n    color: $white;\n    background-size: 210% 210%;\n    background-position: top right;\n    background-repeat: space;\n\n    &:focus,\n    &:active,\n    &:hover{\n        background-color: $state-color;\n        background-image: linear-gradient(to bottom left, $color, darken($color,20%), $color) !important;\n        background-image: -webkit-linear-gradient(to bottom left, $color, darken($color,20%), $color) !important;\n        background-image: -o-linear-gradient(to bottom left, $color, darken($color,20%), $color) !important;\n        background-image: -moz-linear-gradient(to bottom left, $color, darken($color,20%), $color) !important;\n        color: $white;\n    }\n\n    &.btn-simple{\n        color: $state-color;\n        background-color: $transparent-bg;\n        background-image: none !important;\n        box-shadow: none;\n        border-color: $state-color;\n\n        &:hover,\n        &:focus,\n        &:active{\n            color: $state-color;\n            border-color: $state-color;\n        }\n    }\n\n    &.btn-neutral{\n        color: $color;\n        background-color: $white;\n\n\n        &:hover,\n        &:focus,\n        &:active{\n            color: $state-color;\n        }\n    }\n}\n","// Opacity\n\n@mixin opacity($opacity) {\n  opacity: $opacity;\n  // IE8 filter\n  $opacity-ie: ($opacity * 100);\n  filter: #{alpha(opacity=$opacity-ie)};\n}\n",".dropdown-menu {\n    border: 0;\n    box-shadow: 0px 10px 50px 0px rgba(0, 0, 0, 0.2);\n    border-radius: $border-radius-xs;\n    @include transitions($fast-transition-time, $transition-linear);\n\n    &.dropdown-menu-right {\n      &:before, &:after {\n        left:auto;\n        right: 10px;\n      }\n    }\n\n    &.dropdown-black {\n      background: linear-gradient(to bottom, $black 0%, $black-states 100%);\n      border: 1px solid $default;\n      .dropdown-item {\n        color: rgba(255, 255, 255, 0.7);\n      }\n\n      .dropdown-divider {\n        border-color: $default;\n      }\n\n      &:before {\n        color: $black;\n        z-index: 2;\n      }\n\n      &:after {\n        display: inline-block;\n        position: absolute;\n        width: 0;\n        height: 0;\n        z-index: 1;\n        vertical-align: middle;\n        content: \"\";\n        top: -6px;\n        left: 10px;\n        right: auto;\n        color: $default;\n        border-bottom: .4em solid;\n        border-right: .4em solid transparent;\n        border-left: .4em solid transparent;\n      }\n\n      &.dropdown-menu-right {\n        &:after {\n          left: auto;\n          right: 10px;\n        }\n      }\n\n      .dropup & {\n        &:after {\n          color: $black-states;\n          z-index: 2;\n        }\n\n        &:before {\n          display: inline-block;\n          position: absolute;\n          width: 0;\n          height: 0;\n          vertical-align: middle;\n          content: \"\";\n          top: auto;\n          bottom: -6px;\n          right: auto;\n          left: 10px;\n          color: $dark-background;\n          border-top: .4em solid;\n          border-right: .4em solid transparent;\n          border-left: .4em solid transparent;\n          border-bottom: none;\n          z-index: 1;\n        }\n      }\n    }\n\n    i {\n        margin-right: 5px;\n        position: relative;\n        top: 1px;\n    }\n\n    .tim-icons {\n        margin-right: 10px;\n        position: relative;\n        top: 4px;\n        font-size: 18px;\n        margin-top: -5px;\n        opacity: .5;\n    }\n\n    .dropdown-item {\n        &.active,\n        &:active{\n            color: inherit;\n        }\n    }\n\n    .dropup & {\n        &:before {\n            display: none;\n        }\n\n        &:after {\n          display: inline-block;\n          position: absolute;\n          width: 0;\n          height: 0;\n          vertical-align: middle;\n          content: \"\";\n          top: auto;\n          bottom: -5px;\n          right: auto;\n          left: 10px;\n          color: $white;\n          border-top: .4em solid;\n          border-right: .4em solid transparent;\n          border-left: .4em solid transparent;\n          border-bottom: none;\n        }\n\n        &.dropdown-menu-right {\n          &:after, &:before {\n            right: 10px;\n            left: auto;\n          }\n        }\n    }\n\n\n\n    &:before {\n      display: inline-block;\n      position: absolute;\n      width: 0;\n      height: 0;\n      vertical-align: middle;\n      content: \"\";\n      top: -5px;\n      left: 10px;\n      right: auto;\n      color: $white;\n      border-bottom: .4em solid;\n      border-right: .4em solid transparent;\n      border-left: .4em solid transparent;\n    }\n\n\n\n    &.dropdown-menu-right {\n      right: 0 !important;\n      left: auto !important;\n    }\n\n    .dropdown-item,\n    .bootstrap-select &.inner li a {\n      font-size: $font-size-sm;\n      padding-top: .6rem;\n      padding-bottom: .6rem;\n      margin-top: 5px;\n      @include transitions($fast-transition-time, $transition-linear);\n\n      &:hover,\n      &:focus {\n        background-color: $opacity-gray-3;\n      }\n\n      &.disabled,\n      &:disabled {\n        color: $default-opacity;\n\n        &:hover,\n        &:focus {\n          background-color: transparent;\n          box-shadow: none;\n        }\n      }\n    }\n\n\n    .dropdown-divider {\n        background-color: $opacity-gray-5;\n    }\n\n    .dropdown-header:not([href]) {\n        color: $default-opacity;\n        font-size: $font-size-xs;\n        text-transform: uppercase;\n        font-weight: $font-weight-bold;\n    }\n\n    &.dropdown-primary {\n        @include dropdown-colors(darken($primary, 3%),$opacity-8,$white, $opacity-2);\n    }\n\n    &.dropdown-info {\n        @include dropdown-colors(darken($info, 3%),$opacity-8,$white, $opacity-2);\n    }\n\n    &.dropdown-danger {\n        @include dropdown-colors(darken($danger, 3%),$opacity-8,$white, $opacity-2);\n    }\n\n    &.dropdown-success {\n        @include dropdown-colors(darken($success, 3%),$opacity-8,$white, $opacity-2);\n    }\n\n    &.dropdown-warning {\n        @include dropdown-colors(darken($warning, 3%),$opacity-8,$white, $opacity-2);\n    }\n\n    .dropdown &,\n    .dropup:not(.bootstrap-select) &,\n    .bootstrap-select &:not(.inner),\n    &.bootstrap-datetimepicker-widget.bottom {\n        @include transform-translate-y-dropdown(-20px);\n        visibility: hidden;\n        display: block;\n        @include opacity(0);\n        top: 100% !important;\n    }\n\n    &.bootstrap-datetimepicker-widget.top {\n      @include transform-translate-y-dropdown(-20px);\n      visibility: hidden;\n      display: block;\n      @include opacity(0);\n    }\n\n    &.bootstrap-datetimepicker-widget.top,\n    &.bootstrap-datetimepicker-widget.bottom {\n        @include transform-translate-y-dropdown(-20px);\n    }\n\n    .bootstrap-select.dropup &:not(.inner){\n        @include transform-translate-y-dropdown(25px);\n    }\n\n    .dropup:not(.bootstrap-select) &{\n        @include transform-translate-y-dropdown(20px);\n        top: auto !important;\n        bottom: 100%;\n    }\n\n    .dropdown.show &,\n    .bootstrap-select.show &:not(.inner),\n    &.bootstrap-datetimepicker-widget.top.open,\n    &.bootstrap-datetimepicker-widget.bottom.open,\n    .dropup.show:not(.bootstrap-select) &,\n    .navbar .dropdown.show &{\n        @include opacity(1);\n        visibility: visible;\n        @include transform-translate-y-dropdown(1px);\n    }\n\n    &.bootstrap-datetimepicker-widget.top.open,\n    &.bootstrap-datetimepicker-widget.bottom.open{\n        @include transform-translate-y-dropdown(0px);\n    }\n\n    .dropup.show:not(.bootstrap-select) &{\n        @include transform-translate-y-dropdown(-2px);\n    }\n\n    &.dropdown-navbar{\n      left: -80px;\n      &:before, &:after{\n        left: auto;\n        right: 17px;\n      }\n    }\n\n\n}\n\n.btn{\n    cursor: pointer;\n\n    &.dropdown-toggle[data-toggle=\"dropdown\"]{\n        padding:10px;\n        margin: 0;\n        margin-bottom: 5px;\n\n        &:after{\n          content: \"\";\n          margin-left: 5px;\n        }\n\n    }\n\n    span.bs-caret{\n      display: none;\n    }\n\n    &.btn-link{\n      &.dropdown-toggle{\n        height: 22px;\n        padding: 0;\n        margin-right: 5px;\n      }\n    }\n}\n\n.dropdown-toggle:after{\n\n  content: unset;\n\n}\n\n.btn:not(:disabled):not(.disabled).active:focus,\n .btn:not(:disabled):not(.disabled):active:focus,\n .show>.btn.dropdown-toggle:focus{\n   box-shadow: none;\n }\n\n\n// Dropown: Sizes\n\n.dropdown-menu-sm {\n    min-width: 100px;\n    border: $border-radius-lg;\n}\n\n.dropdown-menu-lg {\n    min-width: 260px;\n    border-radius: $border-radius-lg;\n}\n\n.dropdown-menu-xl {\n    min-width: 450px;\n    border-radius: $border-radius-lg;\n}\n\n@media screen and (max-width: 991px){\n  .dropdown-toggle:after{\n    display: inline-block;\n    width: 0;\n    height: 0;\n    margin-left: .255em;\n    vertical-align: .255em;\n    content: \"\";\n    border-top: .3em solid;\n    border-right: .3em solid transparent;\n    border-bottom: 0;\n    border-left: .3em solid transparent;\n  }\n\n}\n\n\n@media screen and (min-width: 992px){\n  .dropdown-menu .dropdown-item{\n      color: $dark-gray;\n  }\n}\n","@mixin dropdown-colors($brand-color, $dropdown-header-color, $dropdown-color, $background-color ) {\n    background-color: $brand-color;\n\n    &:before{\n        color: $brand-color;\n    }\n\n    .dropdown-header:not([href]):not([tabindex]){\n        color: $dropdown-header-color;\n    }\n\n    .dropdown-item{\n        color: $dropdown-color;\n\n        &:hover,\n        &:focus{\n            background-color: $background-color;\n        }\n    }\n\n    .dropdown-divider{\n        background-color: $background-color;\n    }\n\n  \n}\n",".footer{\n    padding: 24px 0 24px 250px;\n\n    [class*=\"container-\"] {\n      padding: 0;\n    }\n\n    .nav{\n        display: inline-block;\n        float: left;\n        margin-bottom: 0;\n        padding-left: 30px;\n        list-style: none;\n    }\n\n    .nav-item{\n      display: inline-block;\n\n      &:first-child a {\n        padding-left: 0;\n      }\n    }\n\n    .nav-link {\n      color: $white;\n      padding: 0 $padding-base-vertical;\n      font-size: $font-size-sm;\n      text-transform: uppercase;\n      text-decoration: none;\n\n      &:hover{\n          text-decoration: none;\n      }\n    }\n\n\n\n    .copyright{\n        font-size: $font-size-sm;\n        line-height: 1.8;\n        color: $white;\n    }\n\n    &:after{\n        display: table;\n        clear: both;\n        content: \" \";\n    }\n}\n\n\n@media screen and (max-width: 991px){\n  .footer {\n    padding-left: 0px;\n\n    .copyright {\n      text-align: right;\n      margin-right: 15px;\n    }\n  }\n}\n\n@media screen and (min-width: 992px){\n  .footer {\n    .copyright {\n      float: right;\n      padding-right: 30px;\n    }\n  }\n}\n\n@media screen and (max-width: 768px){\n  .footer {\n    nav {\n      display: block;\n      margin-bottom: 5px;\n      float: none;\n    }\n  }\n}\n\n@media screen and (max-width: 576px){\n  .footer {\n    text-align: center;\n    .copyright {\n      text-align: center;\n    }\n\n    .nav{\n      float: none;\n      padding-left: 0;\n    }\n  }\n}\n","/* Form controls */\n@include form-control-placeholder(#6c757c, 1);\n\n.form-control{\n  border-color: lighten($black,5%);\n  border-radius: $border-radius-lg;\n  font-size: $font-size-sm;\n  @include transition-input-focus-color();\n\n\n  &:focus{\n    border-color: $primary;\n    background-color: $input-bg;\n    @include box-shadow(none);\n\n    & + .input-group-append .input-group-text,\n    & ~ .input-group-append .input-group-text,\n    & + .input-group-prepend .input-group-text,\n    & ~ .input-group-prepend .input-group-text{\n        border: 1px solid $primary;\n        border-left: none;\n        background-color: $transparent-bg;\n    }\n  }\n\n  .has-success &,\n  .has-error &,\n  .has-success &:focus,\n  .has-error &:focus{\n      @include box-shadow(none);\n  }\n\n  .has-danger &,\n  .has-success &{\n      &.form-control-success,\n      &.form-control-danger{\n          background-image: none;\n      }\n  }\n\n  & + .form-control-feedback{\n      border-radius: $border-radius-lg;\n      margin-top: -7px;\n      position: absolute;\n      right: 10px;\n      top: 50%;\n      vertical-align: middle;\n  }\n\n  .open &{\n      border-radius: $border-radius-lg $border-radius-lg 0 0;\n      border-bottom-color: $transparent-bg;\n  }\n\n  & + .input-group-append .input-group-text,\n  & + .input-group-prepend .input-group-text{\n      background-color: $white;\n  }\n\n}\n\n.has-success .input-group-append .input-group-text,\n.has-success .input-group-prepend .input-group-text,\n.has-success .form-control{\n    border-color: lighten($black,5%);\n}\n\n.has-success .form-control:focus,\n.has-success.input-group-focus .input-group-append .input-group-text,\n.has-success.input-group-focus .input-group-prepend .input-group-text{\n  border-color: darken($success, 10%);\n}\n\n.has-danger .form-control,\n.has-danger .input-group-append .input-group-text,\n.has-danger .input-group-prepend .input-group-text,\n.has-danger.input-group-focus .input-group-prepend .input-group-text,\n.has-danger.input-group-focus .input-group-append .input-group-text{\n    border-color: lighten($danger-states,5%);\n    color: $danger-states;\n    background-color: rgba(222,222,222, .1);\n\n    &:focus{\n        background-color: $transparent-bg;\n    }\n}\n\n.has-success,\n.has-danger{\n    &:after{\n        font-family: 'nucleo';\n        content: \"\\ea1b\";\n        display: inline-block;\n        position: absolute;\n        right: 20px;\n        top: 13px;\n        color: $success;\n        font-size: 11px;\n    }\n\n    &.form-control-lg{\n      &:after{\n        font-size: 13px;\n        top: 24px;\n      }\n    }\n\n    &.has-label{\n      &:after{\n        top: 37px;\n      }\n    }\n\n\n    &.form-check:after{\n      display: none !important;\n    }\n\n    &.form-check .form-check-label{\n      color: $success;\n    }\n}\n\n.has-danger{\n  &:after{\n    content: \"\\ea48\";\n    color: $danger-states;\n  }\n\n  &.form-check .form-check-label{\n    color: $danger-states;\n  }\n}\n","@mixin input-size($padding-vertical, $padding-horizontal){\n    padding: $padding-vertical $padding-horizontal;\n}\n\n@mixin form-control-placeholder($color, $opacity){\n   .form-control::-moz-placeholder{\n       color: $color;\n       @include opacity(1);\n   }\n   .form-control:-moz-placeholder{\n       color: $color;\n       @include opacity(1);\n   }\n   .form-control::-webkit-input-placeholder{\n       color: $color;\n       @include opacity(1);\n   }\n   .form-control:-ms-input-placeholder{\n       color: $color;\n       @include opacity(1);\n   }\n}\n\n@mixin placeholder() {\n  &::-moz-placeholder {@content; } // Firefox\n  &:-ms-input-placeholder {@content; } // Internet Explorer 10+\n  &::-webkit-input-placeholder  {@content; } // Safari and Chrome\n}\n\n@mixin light-form(){\n    border-radius: 0;\n    border:0;\n    padding: 0;\n    background-color: transparent;\n\n}\n\n\n@mixin form-control-lg-padding($padding-vertical, $padding-horizontal) {\n    .form-group.no-border.form-control-lg,\n    .input-group.no-border.form-control-lg{\n        .input-group-append .input-group-text{\n            padding: $padding-vertical 0 $padding-vertical $padding-horizontal;\n        }\n\n        .form-control{\n            padding: $padding-vertical $padding-horizontal;\n\n            & + .input-group-prepend .input-group-text,\n            & + .input-group-append .input-group-text{\n                padding: $padding-vertical $padding-horizontal $padding-vertical 0;\n            }\n\n\n        }\n    }\n\n    .form-group.form-control-lg,\n    .input-group.form-control-lg{\n        .form-control{\n            padding: $padding-vertical - 1 $padding-horizontal - 1;\n            height: 100%;\n\n            & + .input-group-prepend .input-group-text,\n            & + .input-group-append .input-group-text{\n                padding: $padding-vertical - 1 $padding-horizontal - 1 $padding-vertical - 1 0;\n            }\n        }\n\n        .input-group-prepend .input-group-text,\n        .input-group-append .input-group-text{\n            padding: $padding-vertical - 1 0 $padding-vertical $padding-horizontal - 1;\n\n            & + .form-control{\n                padding: $padding-vertical  $padding-horizontal - 1 $padding-vertical $padding-horizontal - 3;\n            }\n        }\n    }\n}\n\n\n\n@mixin input-base-padding($padding-vertical, $padding-horizontal) {\n    .form-group.no-border,\n    .input-group.no-border{\n        .form-control{\n            padding: $padding-vertical $padding-horizontal;\n\n            & + .input-group-prepend .input-group-text,\n            & + .input-group-append .input-group-text{\n                padding: $padding-vertical $padding-horizontal $padding-vertical 0;\n            }\n        }\n\n        .input-group-prepend .input-group-text,\n        .input-group-append .input-group-text{\n            padding: $padding-vertical 0 $padding-vertical $padding-horizontal;\n        }\n    }\n\n    .form-group,\n    .input-group{\n        .form-control{\n            padding: $padding-vertical - 1 $padding-horizontal - 1 $padding-vertical - 1 $padding-horizontal - 1;\n\n            & + .input-group-prepend .input-group-text,\n            & + .input-group-append .input-group-text{\n                padding: $padding-vertical - 1 $padding-horizontal - 1 $padding-vertical - 1 0;\n            }\n        }\n\n        .input-group-prepend .input-group-text,\n        .input-group-append .input-group-text{\n            padding: $padding-vertical - 1 0 $padding-vertical - 1 $padding-horizontal - 1;\n\n            & + .form-control,\n            & ~ .form-control{\n                padding:$padding-vertical - 1 $padding-horizontal $padding-vertical $padding-horizontal - 3;\n            }\n        }\n    }\n}\n\n\n//color1 = $opacity-5\n//color2 = $opacity-8\n//color3 = $white-color\n//color4 = $transparent-bg\n//color5 = $opacity-1\n//color6 = $opacity-2\n\n\n@mixin input-coloured-bg($color1, $color2, $color3, $color4, $color5, $color6) {\n    @include form-control-placeholder(rgba($white, 0.4), 1);\n\n    .form-control{\n        border-color: $color1;\n        color: $color2;\n\n        &:focus{\n            border-color: $color3;\n            background-color: $color4;\n            color: $color3;\n        }\n    }\n\n    .has-success,\n    .has-danger{\n        &:after{\n            color: $color3;\n        }\n    }\n\n    .has-danger{\n        .form-control{\n            background-color: $color4;\n        }\n    }\n\n    .input-group-prepend{\n      margin-right: 0;\n    }\n\n    .input-group-prepend .input-group-text,\n    .input-group-append .input-group-text{\n        background-color: rgba($background-black, 0.2);\n        border-color: $color1;\n        color: $color2;\n\n\n    }\n\n    .input-group-focus{\n        .input-group-prepend .input-group-text,\n        .input-group-append .input-group-text{\n            background-color: rgba($background-black, 0.3);\n            border-color: $color3;\n            color: $color3;\n        }\n    }\n\n    .form-group.no-border,\n    .input-group.no-border{\n        .form-control{\n            background-color: rgba($background-black,0.2);\n            color: $color2;\n\n            &:focus,\n            &:active,\n            &:active{\n                background-color: rgba($background-black,0.3);\n                color: $color3;\n            }\n        }\n\n        .form-control + .input-group-prepend .input-group-text,\n        .form-control + .input-group-append .input-group-text{\n            background-color: rgba($background-black,0.2);;\n\n            &:focus,\n            &:active,\n            &:active{\n                background-color: rgba($background-black,0.3);\n                color: $color3;\n            }\n        }\n\n        .form-control{\n            &:focus{\n                & + .input-group-prepend .input-group-text,\n                & + .input-group-append .input-group-text{\n                    background-color: rgba($background-black, 0.3);\n                    color: $color3;\n                }\n            }\n        }\n\n        .input-group-prepend .input-group-text,\n        .input-group-append .input-group-text{\n            background-color: rgba($background-black, 0.2);\n            border: none;\n            color: $color2;\n        }\n\n        &.input-group-focus{\n            .input-group-prepend .input-group-text,\n            .input-group-append .input-group-text{\n                background-color: rgba($background-black, 0.3);\n                color: $color3;\n            }\n        }\n    }\n\n}\n","img{\n    max-width: 100%;\n    border-radius: $border-radius-sm;\n}\n.img-raised{\n    box-shadow: $box-shadow-raised;\n}\n","// Modals\n// Design element Dialogs\n// --------------------------------------------------\n.modal-content {\n  border: 0;\n\n  // Modal header\n  // Top section of the modal w/ title and dismiss\n\n  .modal-header {\n    border-bottom: none;\n\n    & button {\n        position: absolute;\n        right: 27px;\n        top: 24px;\n        outline: 0;\n        padding: 1rem;\n        margin: -1rem -1rem -1rem auto;\n    }\n    .title{\n        color: $black;\n        margin-top: 5px;\n        margin-bottom: 0;\n    }\n\n    .modal-title{\n      color: $black;\n    }\n\n    i.tim-icons {\n      font-size: 16px;\n    }\n  }\n\n\n  // Modal body\n  // Where all modal content resides (sibling of .modal-header and .modal-footer)\n  .modal-body {\n    line-height: 1.9;\n\n    p{\n      color: $black;\n    }\n  }\n  // Footer (for actions)\n  .modal-footer {\n    border-top: 0;\n    -webkit-justify-content: space-between; /* Safari 6.1+ */\n    justify-content: space-between;\n\n    button {\n      margin: 0;\n      padding-left: 16px;\n      padding-right: 16px;\n      width: auto;\n\n      &.pull-left {\n        padding-left: 5px;\n        padding-right: 5px;\n        position: relative;\n        left: -5px;\n      }\n    }\n\n  }\n  .modal-body + .modal-footer {\n    padding-top: 0;\n  }\n}\n.modal-backdrop {\n  background: rgba(0,0,0,0.3);\n}\n\n.modal{\n\n    &.modal-default{\n        @include modal-colors($white, $black);\n    }\n\n    &.modal-primary{\n        @include modal-colors($primary, $white);\n    }\n\n    &.modal-danger{\n        @include modal-colors($danger, $white);\n    }\n\n    &.modal-warning{\n        @include modal-colors($warning, $white);\n    }\n\n    &.modal-success{\n        @include modal-colors($success, $white);\n    }\n\n    &.modal-info{\n        @include modal-colors($info, $white);\n    }\n\n    .modal-header .close{\n        color: $danger;\n        text-shadow: none;\n\n        &:hover,\n        &:focus{\n            opacity: 1;\n        }\n    }\n\n    &.modal-black{\n      .modal-content{\n        background: linear-gradient(to bottom, $black 0%, $black-states 100%);\n        color: rgba($white, 0.8);\n        .modal-header{\n          .modal-title, .title{\n            color: rgba($white, 0.9);\n          }\n        }\n        .modal-body{\n          p{\n            color: rgba($white, 0.8);\n          }\n        }\n      }\n      h1, h2, h3, h4, h5, h6, p{\n        color: $white;\n      }\n    }\n}\n\n.modal-search{\n  .modal-dialog{\n    margin: 20px auto;\n    max-width: 650px;\n    input{\n      border: none;\n      font-size: 17px;\n      font-weight: 100;\n    }\n    span{\n      font-size: 35px;\n      color: $search-gray;\n    }\n  }\n  .modal-content{\n    .modal-header{\n      padding: 24px;\n    }\n  }\n\n  .modal-header .close{\n    color: $dark-background;\n    top: 30px !important;\n  }\n\n  .modal-footer{\n    border-top: 2px solid #f9f9f9;\n    margin: 0px 25px 20px;\n  }\n}\n","@mixin modal-colors($bg-color, $color) {\n    .modal-content{\n        background-color: $bg-color;\n        color: $color;\n    }\n\n    .modal-body p{\n      color: rgba($white, 0.8);\n    }\n\n    //inputs\n    @include input-coloured-bg($opacity-5, $white, $white, $transparent-bg, $opacity-1, $opacity-2);\n\n\n}\n",".navbar {\n  padding: 10px 30px 10px 15px;\n  width: 100%;\n  z-index: 1050;\n  background: $navbar-color;\n\n  .photo {\n    display: inline-block;\n    height: 30px;\n    width: 30px;\n    border-radius: 50%;\n    vertical-align: middle;\n    overflow: hidden;\n      img{\n        width: 100%;\n      }\n  }\n\n  .navbar-wrapper {\n    display: flex;\n    align-items: center;\n  }\n\n  .navbar-text {\n    color: $white;\n  }\n\n  .btn{\n    margin: 0 5px 0 10px;\n  }\n\n  &.navbar-absolute{\n    position: absolute;\n    z-index: 1050;\n  }\n\n\n  &.navbar-transparent{\n    background: transparent !important;\n  }\n\n  &.bg-white{\n    .navbar-nav{\n      .search-bar.input-group{\n        i{\n          color: $black;\n        }\n      }\n\n      .search-bar.input-group .form-control{\n        background: rgba($black,0.1);\n        border-radius: 4px;\n      }\n\n      a.nav-link{\n        color: $black !important;\n        p{\n          color: $black;\n        }\n      }\n\n    }\n\n    .navbar-text, .navbar-brand{\n      color: $black;\n    }\n\n    .form-control {\n      color: $black !important;\n    }\n\n    .form-control::placeholder {\n      color: $dark-gray !important;\n    }\n\n  }\n\n  &.bg-dark {\n    background: $black !important;\n  }\n\n  &.bg-primary {\n    background-color: $primary !important;\n  }\n\n  &.bg-warning {\n    background-color: $warning !important;\n  }\n\n  &.bg-info {\n    background-color: $info !important;\n  }\n\n  &.bg-success {\n    background-color: darken($success, 10%) !important;\n  }\n\n  &.bg-danger {\n    background-color: $danger !important;\n  }\n\n  .navbar-brand {\n    position: fixed;\n    padding-top: .3125rem;\n    padding-bottom: .3125rem;\n    color: $white;\n    margin-left: 17px;\n    margin-top: 3px;\n    text-transform: uppercase;\n    font-size: $font-paragraph;\n  }\n\n  .navbar-toggle button:focus, .navbar-toggler{\n    outline: none;\n  }\n\n}\n\n.container-fluid {\n  width: 100%;\n}\n\n.navbar-minimize-fixed {\n\tposition: fixed;\n  margin-left: 40px;\n  margin-top: 14px;\n\ttransition: 0.3s ease;\n\tcolor: white;\n\tz-index: 20;\n\topacity: 0;\n\ttransition: 0.2s ease;\n\tbutton{\n\t\ti {\n\t\t\tfont-size: 20px;\n\t\t}\n\t}\n}\n\n.notification {\n  background: $danger;\n\tcolor: $white;\n\tborder-radius: $border-radius-xl;\n\theight: 6px;\n\twidth: 6px;\n\tposition: absolute;\n\ttext-align: center;\n\tfont-size: 12px;\n\tfont-weight: 800;\n  top: 10px;\n  right: 10px;\n\tborder: 1px solid $danger;\n}\n\n.navbar-nav li{\n  padding: 0 10px;\n  a{\n    color: $white;\n  }\n  i{\n    vertical-align: middle;\n    font-size: 20px;\n  }\n}\n\n@media screen and (max-width: 991px){\n  .navbar{\n      .container-fluid{\n          padding-right: 15px;\n          padding-left: 15px;\n      }\n\n      .navbar-collapse{\n        .input-group{\n          margin: 0;\n          margin-top: 5px;\n        }\n      }\n\n      .navbar-nav{\n\n        .btn{\n          margin-left: -3px;\n          display: flex;\n\n          i {\n            margin-right: 12px;\n          }\n\n          span {\n            margin: 0;\n            text-transform: uppercase;\n            font-weight: 300;\n\n            &,\n            &:hover,\n            &:focus,\n            &:active,\n            &:active:focus {\n              color: $black !important;\n            }\n          }\n        }\n\n          a.nav-link{\n            i{\n              opacity: 1;\n              margin-left: 4px;\n              margin-right: 5px;\n            }\n            p{\n              display: inline-block;\n              text-transform: uppercase;\n              margin-left: 7px;\n            }\n          }\n\n          .modal-search .modal-dialog{\n            padding: 0 40px;\n          }\n          .dropdown{\n            margin: 5px 0;\n            .nav-link{\n              padding-bottom: 0;\n            }\n            .dropdown-menu{\n              .dropdown-item{\n                margin-top: 0;\n                padding-left: 24px;\n              }\n            }\n          }\n      }\n\n      .dropdown.show .dropdown-menu{\n          display: block;\n\n      }\n\n      .dropdown .dropdown-menu{\n          display: none;\n          li a{\n            color: $black;\n          }\n      }\n\n      .dropdown.show .dropdown-menu,\n      .dropdown .dropdown-menu{\n          background-color: transparent;\n          border: 0;\n          transition: none;\n          -webkit-box-shadow: none;\n          box-shadow: none;\n          width: auto;\n          margin: 0px 1rem;\n          margin-top: 0px;\n\n          &:before{\n              display: none;\n          }\n      }\n\n      .dropdown-menu .dropdown-item:focus,\n      .dropdown-menu .dropdown-item:hover{\n          color: $white;\n      }\n\n      &.bg-white .dropdown-menu .dropdown-item:focus,\n      &.bg-white .dropdown-menu .dropdown-item:hover{\n          color: $default;\n      }\n\n      button.navbar-toggler[data-target=\"#navigation\"]{\n        padding-top: 0;\n      }\n\n      .navbar-toggler-bar{\n          display: block;\n          position: relative;\n          width: 22px;\n          height: 1px;\n          border-radius: 1px;\n          background: $white;\n\n          &.navbar-kebab{\n            height: 4px;\n            width: 4px;\n            margin-bottom: 3px;\n            border-radius: 50%;\n          }\n\n          & + .navbar-toggler-bar{\n              margin-top: 7px;\n          }\n\n          & + .navbar-toggler-bar.navbar-kebab{\n              margin-top: 0px;\n          }\n\n          &.bar2{\n              width: 17px;\n              transition: width .2s linear;\n          }\n      }\n\n      &.bg-white:not(.navbar-transparent) .navbar-toggler-bar{\n          background-color: $default;\n      }\n\n      & .toggled .navbar-toggler-bar{\n          width: 24px;\n\n          & + .navbar-toggler-bar{\n              margin-top: 5px;\n          }\n      }\n\n      .navbar-brand{\n        margin-left: 20px;\n        position: relative;\n      }\n  }\n\n  .navbar-nav{\n      .nav-link{\n          i.fa,\n          i.tim-icons{\n              opacity: .5;\n          }\n      }\n  }\n\n  .bar1,\n  .bar2,\n  .bar3 {\n    outline: 1px solid transparent;\n  }\n  .bar1 {\n    top: 0px;\n    @include bar-animation($topbar-back);\n  }\n  .bar2 {\n    opacity: 1;\n  }\n  .bar3 {\n    bottom: 0px;\n    @include bar-animation($bottombar-back);\n  }\n  .toggled .bar1 {\n    top: 6px;\n    @include bar-animation($topbar-x);\n  }\n  .toggled .bar2 {\n    opacity: 0;\n  }\n  .toggled .bar3 {\n    bottom: 6px;\n    @include bar-animation($bottombar-x);\n  }\n\n  @include topbar-x-rotation();\n  @include topbar-back-rotation();\n  @include bottombar-x-rotation();\n  @include bottombar-back-rotation();\n\n  @-webkit-keyframes fadeIn {\n    0% {opacity: 0;}\n    100% {opacity: 1;}\n  }\n  @-moz-keyframes fadeIn {\n    0% {opacity: 0;}\n    100% {opacity: 1;}\n  }\n  @keyframes fadeIn {\n    0% {opacity: 0;}\n    100% {opacity: 1;}\n  }\n\n}\n\n@media screen and (min-width: 992px) {\n  .navbar-collapse {\n    background: none !important;\n  }\n\n  .navbar .navbar-toggle {\n    display: none;\n  }\n\n  .navbar-nav {\n    .nav-link {\n      &.profile-photo {\n        padding: 0;\n        margin: 7px $padding-base-horizontal;\n      }\n    }\n  }\n\n  .navbar {\n    .caret {\n      position: absolute;\n      left: 80%;\n      top: 55%;\n      margin-left: 0;\n    }\n  }\n    .navbar-expand-lg .navbar-nav .nav-link {\n      padding-right: 0.5rem;\n      padding-left: 0.5rem;\n  }\n}\n\n@media screen and (max-width: 576px){\n  .navbar[class*='navbar-toggleable-'] .container{\n      margin-left: 0;\n      margin-right: 0;\n  }\n  .navbar .navbar-wrapper {\n    .navbar-toggle{\n      transition: all 1s;\n    }\n  }\n  .navbar .navbar-wrapper {\n    .navbar-toggle.toggled{\n      left: -20px;\n      position: relative;\n      right: unset;\n      transition: all 1s;\n    }\n  }\n  .rtl {\n    .navbar .navbar-wrapper {\n      .navbar-toggle.toggled{\n        right: -35px;\n        position: relative;\n        left: unset;\n        transition: all 1s;\n      }\n    }\n  }\n}\n","body {\n  -moz-osx-font-smoothing: grayscale;\n  -webkit-font-smoothing: antialiased;\n}\n\nh1, h2, h3, h4, h5, h6,\n.h1, .h2, .h3, .h4, .h5, .h6 {\n  line-height: $headings-line-height;\n\n}\np{\n  font-weight: $font-weight-light;\n}\n\nbutton,\ninput,\noptgroup,\nselect,\ntextarea{\n    font-family: $font-family-base;\n}\n.card{\n  h1,h2,h3,h4,h5,h6,p{\n    color: $opacity-8;\n  }\n}\nh1,h2,h3,h4,h5,h6{\n    font-weight: $font-weight-normal;\n    color: $opacity-8;\n}\n\na{\n    color: $primary-states;\n    font-weight: $font-weight-light;\n    &:hover,\n    &:focus{\n        color: $primary;\n    }\n}\nh1, .h1 {\n    line-height: 1.05;\n    margin-bottom: $margin-base-vertical * 2;\n\n    small{\n        font-weight: $font-weight-bold;\n        text-transform: uppercase;\n        opacity: .8;\n    }\n\n}\nh2, .h2{\n    margin-bottom: $margin-base-vertical * 2;\n    line-height: 1.2;\n\n}\nh3, .h3{\n    margin-bottom: $margin-base-vertical * 2;\n    line-height: 1.4em;\n}\nh4, .h4{\n    line-height: 1.45em;\n    margin-bottom: $margin-base-vertical;\n\n    & + .category,\n    &.title + .category{\n        margin-top: -10px;\n    }\n}\nh5, .h5 {\n    line-height: 1.4em;\n    margin-bottom: 15px;\n}\nh6, .h6{\n    text-transform: uppercase;\n    font-weight: $font-weight-bold;\n}\np{\n    color: $opacity-8;\n    margin-bottom: 5px;\n\n    &.description{\n        font-size: 1.14em;\n    }\n}\n\n\n.title{\n    font-weight: $font-weight-bold;\n    cursor: default;\n    &.title-up{\n        text-transform: uppercase;\n\n        a{\n            color: $black;\n            text-decoration: none;\n        }\n    }\n    & + .category{\n        margin-top: -10px;\n    }\n}\n\n.description,\n.card-description,\n.footer-big p,\n.card .footer .stats{\n    color: $dark-gray;\n    font-weight: $font-weight-light;\n}\n.category,\n.card-category{\n    text-transform: capitalize;\n    font-weight: $font-weight-normal;\n    color: rgba($white, 0.6);\n    font-size: $font-size-sm;\n}\n\n.card-category{\n    font-size: $font-size-sm;\n}\n\n.blockquote{\n    border-left: none;\n    border: 1px solid $default;\n    padding: 20px;\n    font-size: $blockquote-font-size;\n    line-height: 1.8;\n\n    small{\n        color: $default;\n        font-size: $font-size-sm;\n        text-transform: uppercase;\n    }\n\n    &.blockquote-primary{\n        border-color: $primary;\n        color: $primary;\n\n        small{\n            color: $primary;\n        }\n    }\n\n    &.blockquote-danger{\n        border-color: $danger;\n        color: $danger;\n\n        small{\n            color: $danger;\n        }\n    }\n\n    &.blockquote-white{\n        border-color: $opacity-8;\n        color: $white;\n\n        small{\n            color: $opacity-8;\n        }\n    }\n}\n\nul li, ol li{\n  color: $white;\n}\n\npre{\n  color: $opacity-8;\n}\n\nhr{\n  border-top: 1px solid rgba(0,0,0,0.1);\n  margin-top: $spacer;\n  margin-bottom: $spacer;\n}\n",".table{\n  > tbody > tr > td {\n    color: rgba(255, 255, 255, 0.7) !important;\n\n    .photo {\n      height: 30px;\n      width: 30px;\n      border-radius: 50%;\n      overflow: hidden;\n      margin: 0 auto;\n\n      img {\n        width: 100%;\n      }\n    }\n  }\n\n  > tbody > tr.table-success > td{\n    background-color: darken($success,10%);\n  }\n\n  > tbody > tr.table-info > td{\n    background-color: $info;\n  }\n\n  > tbody > tr.table-primary > td{\n    background-color: $primary;\n  }\n\n  > tbody > tr.table-warning > td{\n    background-color: $warning;\n  }\n  > tbody > tr.table-danger > td{\n    background-color: $danger;\n  }\n\n    .img-wrapper{\n      width: 40px;\n      height: 40px;\n      border-radius: 50%;\n      overflow: hidden;\n      margin: 0 auto;\n    }\n\n    .img-row{\n      max-width: 60px;\n      width: 60px;\n    }\n\n    .form-check{\n        margin: 0;\n        margin-top: 5px;\n\n        & label .form-check-sign::before,\n        & label .form-check-sign::after{\n            top: -17px;\n            left: 4px;\n        }\n    }\n\n    .btn{\n        margin: 0;\n    }\n\n    small,.small{\n      font-weight: 300;\n    }\n\n    .card-tasks .card-body &{\n        margin-bottom: 0;\n\n        > thead > tr > th,\n        > tbody > tr > th,\n        > tfoot > tr > th,\n        > thead > tr > td,\n        > tbody > tr > td,\n        > tfoot > tr > td{\n            padding-top: 5px;\n            padding-bottom: 5px;\n        }\n    }\n\n   > thead > tr > th{\n       border-bottom-width: 1px;\n       font-size: 12px;\n       text-transform: uppercase;\n       font-weight: $font-weight-extra-bold;\n       border: 0;\n       color: rgba($white, 0.7);\n   }\n\n   .radio,\n   .checkbox{\n       margin-top: 0;\n       margin-bottom: 0;\n       padding: 0;\n       width: 15px;\n\n       .icons{\n           position: relative;\n       }\n\n        label{\n            &:after,\n            &:before{\n                top: -17px;\n                left: -3px;\n            }\n        }\n   }\n   > thead > tr > th,\n   > tbody > tr > th,\n   > tfoot > tr > th,\n   > thead > tr > td,\n   > tbody > tr > td,\n   > tfoot > tr > td{\n       border-color: rgba(255, 255, 255, 0.1);\n       padding: 12px 7px;\n       vertical-align: middle;\n   }\n\n   &.table-shopping tbody tr:last-child td{\n      border: none;\n   }\n\n   .th-description{\n       max-width: 150px;\n   }\n   .td-price{\n       font-size: 26px;\n       font-weight: $font-weight-light;\n       margin-top: 5px;\n       position: relative;\n       top: 4px;\n       text-align: right;\n   }\n   .td-total{\n        font-weight: $font-weight-bold;\n        font-size: $h5-font-size;\n        padding-top: 20px;\n        text-align: right;\n    }\n\n   .td-actions .btn{\n    margin: 0px;\n    }\n\n    > tbody > tr{\n        position: relative;\n    }\n\n    > tfoot > tr {\n      color: hsla(0,0%,100%,.7);\n      text-transform: uppercase;\n    }\n}\n\n.table-responsive{\n  overflow: auto;\n  padding-bottom: 10px;\n}\n\n#tables .table-responsive{\n    margin-bottom: 30px;\n}\n",".form-check{\n margin-top: .5rem;\n padding-left: 0;\n}\n\n.form-check .form-check-label{\n  display: inline-block;\n  position: relative;\n  cursor: pointer;\n  padding-left: 25px;\n  line-height: 18px;\n  margin-bottom: 0;\n  -webkit-transition: color 0.3s linear;\n  -moz-transition: color 0.3s linear;\n  -o-transition: color 0.3s linear;\n  -ms-transition: color 0.3s linear;\n  transition: color 0.3s linear;\n}\n.radio .form-check-sign{\n    padding-left: 28px;\n}\n\n.form-check-radio.form-check-inline .form-check-label {\n  padding-left: 5px;\n  margin-right: 10px;\n}\n\n.form-check .form-check-sign::before,\n.form-check .form-check-sign::after{\n  content: \" \";\n  display: inline-block;\n  position: absolute;\n  width: 17px;\n  height: 17px;\n  left: 0;\n  cursor: pointer;\n  border-radius: 3px;\n  top: 0;\n  border: 1px solid darken($dark-gray,10%);\n  -webkit-transition: opacity 0.3s linear;\n  -moz-transition: opacity 0.3s linear;\n  -o-transition: opacity 0.3s linear;\n  -ms-transition: opacity 0.3s linear;\n  transition: opacity 0.3s linear;\n}\n\n.form-check input[type=\"checkbox\"]:checked + .form-check-sign::before,\n.form-check input[type=\"checkbox\"]:checked + .form-check-sign::before{\n  border: none;\n  background-color: $primary;\n}\n\n .form-check .form-check-sign::after{\n  font-family: 'nucleo';\n  content: \"\\ea1b\";\n  top: 0px;\n  text-align: center;\n  font-size: 14px;\n  opacity: 0;\n  color: $white;\n  font-weight: $font-weight-bold;\n  border: 0;\n  background-color: inherit;\n}\n\n.form-check.disabled .form-check-label,\n.form-check.disabled .form-check-label {\n    color: $dark-gray;\n    opacity: .5;\n    cursor: not-allowed;\n}\n\n.form-check input[type=\"checkbox\"],\n.radio input[type=\"radio\"]{\n  opacity: 0;\n  position: absolute;\n  visibility: hidden;\n}\n.form-check input[type=\"checkbox\"]:checked + .form-check-sign::after{\n  opacity: 1;\n  font-size: 10px;\n  margin-top: 0;\n}\n\n\n.form-check input[type=\"checkbox\"]+ .form-check-sign::after{\n  opacity: 0;\n  font-size: 10px;\n  margin-top: 0;\n}\n\n.form-control input[type=\"checkbox\"]:disabled + .form-check-sign::before,\n.checkbox input[type=\"checkbox\"]:disabled + .form-check-sign::after{\n    cursor: not-allowed;\n}\n\n.form-check input[type=\"checkbox\"]:disabled + .form-check-sign,\n.form-check input[type=\"radio\"]:disabled + .form-check-sign{\n    pointer-events: none;\n}\n\n.form-check-radio .form-check-label{\n  padding-top: 3px;\n}\n.form-check-radio .form-check-sign::before,\n.form-check-radio .form-check-sign::after{\n  content: \" \";\n  width: 18px;\n  height: 18px;\n  border-radius: 50%;\n  border: 1px solid darken($dark-gray,10%);\n  display: inline-block;\n  position: absolute;\n  left: 0px;\n  top: 3px;\n  padding: 1px;\n  -webkit-transition: opacity 0.3s linear;\n  -moz-transition: opacity 0.3s linear;\n  -o-transition: opacity 0.3s linear;\n  -ms-transition: opacity 0.3s linear;\n  transition: opacity 0.3s linear;\n}\n\n.form-check-radio input[type=\"radio\"] + .form-check-sign:after,\n.form-check-radio input[type=\"radio\"] {\n    opacity: 0;\n}\n.form-check-radio input[type=\"radio\"]:checked + .form-check-sign::after {\n    width: 6px;\n    height: 6px;\n    background-color: $primary;\n    border-color: $primary;\n    top: 9px;\n    left: 6px;\n    opacity: 1;\n}\n\n.form-check-radio input[type=\"radio\"]:checked + .form-check-sign::before {\n  border-color: $primary;\n}\n\n\n.form-check-radio input[type=\"radio\"]:checked + .form-check-sign::after{\n    opacity: 1;\n}\n\n.form-check-radio input[type=\"radio\"]:disabled + .form-check-sign {\n  color: $dark-gray;\n}\n\n.form-check-radio input[type=\"radio\"]:disabled + .form-check-sign::before,\n.form-check-radio input[type=\"radio\"]:disabled + .form-check-sign::after {\n  color: $dark-gray;\n}\n",".fixed-plugin{\n    position: fixed;\n    right: 0;\n    width: 64px;\n    background: rgba(0,0,0,.3);\n    z-index: 1031;\n    border-radius: 8px 0 0 8px;\n    text-align: center;\n    top: 130px;\n\n    li > a,\n    .badge{\n        transition: all .34s;\n        -webkit-transition: all .34s;\n        -moz-transition: all .34s;\n    }\n\n    .fa-cog{\n        color: $white;\n        padding: 10px;\n        border-radius: 0 0 6px 6px;\n        width: auto;\n    }\n\n    .dropdown-menu{\n        right: 80px;\n        left: auto !important;\n        top: -52px !important;\n        width: 290px;\n        border-radius: 0.1875rem;\n        padding: 0 10px;\n        background: linear-gradient($black, $black-states);\n    }\n\n    .dropdown .dropdown-menu .tim-icons{\n      top: 5px;\n    }\n\n    .dropdown-menu:after,\n    .dropdown-menu:before{\n        right: 10px;\n        margin-left: auto;\n        left: auto;\n    }\n\n    .fa-circle-thin{\n        color: $white;\n    }\n\n    .active .fa-circle-thin{\n        color: $active-blue;\n    }\n\n    .dropdown-menu > .active > a,\n    .dropdown-menu > .active > a:hover,\n    .dropdown-menu > .active > a:focus{\n        color: $active-gray;\n        text-align: center;\n    }\n\n    img{\n        border-radius: 0;\n        width: 100%;\n        height: 100px;\n        margin: 0 auto;\n    }\n\n    .dropdown-menu li > a:hover,\n    .dropdown-menu li > a:focus{\n        box-shadow: none;\n    }\n\n    .badge{\n        border: 2px solid $white;\n        border-radius: 50%;\n        cursor: pointer;\n        display: inline-block;\n        height: 23px;\n        margin-right: 5px;\n        position: relative;\n        width: 23px;\n    }\n\n    .badge.active,\n    .badge:hover{\n        border-color: $black-states;\n    }\n\n    .light-badge, .dark-badge{\n      margin:0;\n      border: 1px solid $info;\n      &:hover{\n        border: 1px solid $info;\n      }\n    }\n\n    .light-badge{\n      background: $white;\n      &:hover{\n        background: $white;\n      }\n    }\n\n    .dark-badge{\n      background: $black;\n      &:hover{\n        background: $black;\n      }\n    }\n\n    h5{\n      margin: 10px;\n    }\n\n    .dropdown-menu li{\n        display: block;\n        padding: 18px 2px;\n        width: 25%;\n        float: left;\n    }\n\n    li.adjustments-line,\n    li.header-title,\n    li.button-container{\n        width: 100%;\n        height: 50px;\n        min-height: inherit;\n    }\n\n    li.button-container{\n        height: auto;\n\n        div{\n            margin-bottom: 5px;\n        }\n    }\n\n    #sharrreTitle{\n        text-align: center;\n        padding: 10px 0;\n        height: 50px;\n    }\n\n    li.header-title{\n        color: $white;\n        height: 30px;\n        line-height: 25px;\n        font-size: 12px;\n        font-weight: 600;\n        text-align: center;\n        text-transform: uppercase;\n    }\n\n    .adjustments-line{\n\n        a{\n            color: transparent;\n\n            .badge-colors{\n                position: relative;\n                top: -2px;\n            }\n\n            a:hover,\n            a:focus{\n                color: transparent;\n            }\n        }\n\n        .togglebutton{\n            text-align: center;\n\n            .label-switch{\n              position: relative;\n              left: -10px;\n              font-size: $font-size-xs;\n              color: $white;\n\n              &.label-right{\n                left: 10px;\n              }\n            }\n\n            .toggle{\n                margin-right: 0;\n            }\n        }\n\n        .color-label{\n          position: relative;\n          top: -7px;\n          font-size: $font-size-xs;\n          color: $white;\n        }\n\n        .dropdown-menu > li.adjustments-line > a{\n              padding-right: 0;\n              padding-left: 0;\n              border-bottom: 1px solid #ddd;\n              border-radius: 0;\n              margin: 0;\n        }\n    }\n\n\n\n    .dropdown-menu{\n        > li{\n            & > a.img-holder{\n                  font-size: $font-paragraph;\n                  text-align: center;\n                  border-radius: 10px;\n                  background-color: $white;\n                  border: 3px solid $white;\n                  padding-left: 0;\n                  padding-right: 0;\n                  opacity: 1;\n                  cursor: pointer;\n                  display: block;\n                  max-height: 100px;\n                  overflow: hidden;\n                  padding: 0;\n\n                  img{\n                     margin-top: auto;\n                  }\n            }\n\n            a.switch-trigger:hover,\n            & > a.switch-trigger:focus{\n                background-color: transparent;\n            }\n\n            &:hover,\n            &:focus{\n                > a.img-holder{\n                    border-color: rgba(0, 187, 255, 0.53);;\n                }\n            }\n        }\n\n        > .active > a.img-holder,\n        > .active > a.img-holder{\n            border-color: $active-blue;\n            background-color: $white;\n        }\n\n    }\n\n    .btn-social{\n        width: 50%;\n        display: block;\n        width: 48%;\n        float: left;\n        font-weight: 600;\n    }\n\n    .btn-social{\n        i{\n            margin-right: 5px;\n        }\n\n        &:first-child{\n            margin-right: 2%;\n        }\n    }\n\n    .dropdown{\n        .dropdown-menu{\n             -webkit-transform: translateY(-15%);\n             -moz-transform: translateY(-15%);\n             -o-transform: translateY(-15%);\n             -ms-transform: translateY(-15%);\n             transform: translateY(-15%);\n             top: 27px;\n             opacity: 0;\n\n             transform-origin: 0 0;\n\n             &:before{\n                 border-bottom: .4em solid rgba(0, 0, 0, 0);\n                 border-left: .4em solid rgba(0,0,0,0.2);\n                 border-top: .4em solid rgba(0,0,0,0);\n                 right: -16px;\n                 top: 46px;\n             }\n\n             &:after{\n                 border-bottom: .4em solid rgba(0, 0, 0, 0);\n                 border-left: .4em solid $black;\n                 border-top: .4em solid rgba(0,0,0,0);\n                 right: -16px;\n             }\n\n             &:before,\n             &:after{\n                 content: \"\";\n                 display: inline-block;\n                 position: absolute;\n                 top: 74px;\n                 width: 16px;\n                 transform: translateY(-50%);\n                 -webkit-transform: translateY(-50%);\n                 -moz-transform: translateY(-50%);\n             }\n        }\n\n        &.show .dropdown-menu{\n             opacity: 1;\n\n             -webkit-transform: translateY(-13%);\n             -moz-transform: translateY(-13%);\n             -o-transform: translateY(-13%);\n             -ms-transform: translateY(-13%);\n             transform: translateY(-13%);\n\n             transform-origin: 0 0;\n        }\n    }\n\n    .bootstrap-switch{\n        margin:0;\n    }\n}\n",".wrapper{\n  position: relative;\n  top: 0;\n  height: 100vh;\n\n  &.wrapper-full-page{\n    min-height: 100vh;\n    height: auto;\n  }\n}\n\n.sidebar-wrapper ul li div.collapse ul li div.collapse ul li a,\n.sidebar-wrapper ul li div.collapse ul li div.collapsing ul li a,\n.sidebar-wrapper ul li div.collapsing ul li div.collapse ul li a{\n\n  margin-left: 25px;\n\n}\n.sidebar,\n.off-canvas-sidebar{\n  @include linear-gradient($primary-states, $primary);\n  height: calc(100vh - 90px);\n  width: 230px;\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: 1;\n  background-size: cover;\n  background-position: center center;\n  display: block;\n  box-shadow: 0px 0px 45px 0px rgba(0,0,0,0.6);\n  margin-top: 80px;\n  margin-left: 20px;\n  border-radius: 5px;\n\n  .sidebar-wrapper{\n    width: $full-width;\n    min-height: 100%;\n    max-height: calc(100vh - 705px);\n    z-index: 4;\n    position: relative;\n    overflow: auto;\n\n    .dropdown .dropdown-backdrop{\n      display: none !important;\n    }\n\n    .navbar-form{\n      border: none;\n    }\n\n    > .nav,\n    .user .info{\n      [data-toggle=\"collapse\"] ~ div > ul > li > a{\n        span{\n          display: inline-block;\n          // @extend .animation-transition-general;\n        }\n\n        .sidebar-normal{\n          margin: 0;\n          position: relative;\n          transform: translateX(0px);\n          opacity: 1;\n          white-space: nowrap;\n          display: block;\n          line-height: 23px;\n          z-index: 1;\n          color: $opacity-8;\n        }\n\n        .sidebar-mini-icon{\n          text-transform: uppercase;\n          width: 34px;\n          margin-right: 10px;\n          margin-left: 0px;\n          font-size: 12px;\n          text-align: center;\n          line-height: 25px;\n          position: relative;\n          float: left;\n          z-index: 1;\n          display: inherit;\n          line-height: 24px;\n          color: $opacity-8;\n        }\n\n        i{\n          font-size: 17px;\n          line-height: 20px;\n          width: 26px;\n        }\n      }\n    }\n\n\n\n    [data-toggle=\"collapse\"] ~ div > ul > li:hover > a{\n      .sidebar-mini-icon, .sidebar-normal{\n        color: $white;\n      }\n\n    }\n\n    .nav [data-toggle=\"collapse\"] ~ div > ul > li > a .sidebar-mini-icon{\n      opacity: 0;\n    }\n\n\n  }\n\n  .navbar-minimize{\n    position: absolute;\n    right: 20px;\n    top: 2px;\n    opacity: 1;\n\n    // @extend .animation-transition-general;\n  }\n  .logo-tim{\n    border-radius: 50%;\n    border: 1px solid #333;\n    display: block;\n    height: 61px;\n    width: 61px;\n    float: left;\n    overflow: hidden;\n\n    img{\n      width: 60px;\n      height: 60px;\n    }\n  }\n\n  .nav{\n    margin-top: 20px;\n    display: block;\n\n    .caret{\n      top: 14px;\n      position: absolute;\n      right: 10px;\n    }\n\n    li{\n      > a + div .nav{\n        margin-top: 5px;\n        li > a{\n          margin-top: 0px;\n          padding: 8px 8px;\n        }\n      }\n\n      > a{\n        margin: 10px 15px 0;\n        border-radius: $btn-round-radius;\n        color: $white;\n        display: block;\n        text-decoration: none;\n        position: relative;\n        text-transform: uppercase;\n        cursor: pointer;\n        font-size: $font-size-xs;\n        padding: 10px 8px;\n        line-height: $line-height-lg;\n      }\n\n      &:first-child > a{\n        margin: 0 15px;\n\n      }\n\n      &:hover:not(.active) > a,\n      &:focus:not(.active) > a{\n        p,i{\n          color: $white;\n        }\n      }\n\n      &:hover:not(.active) > a i,\n      &:focus:not(.active) > a i{\n        color: $white;\n      }\n\n      &.active > a:not([data-toggle=\"collapse\"]){\n        background: transparent;\n\n        i,p{\n          color: white;\n        }\n\n        &:before{\n          content: \" \";\n          position: absolute;\n          height: 6px;\n          width: 6px;\n          top: 22px;\n          left: -4px;\n          background: $white;\n          border-radius: 50%;\n        }\n      }\n\n      &.active > a[data-toggle=\"collapse\"]{\n        background: transparent;\n        box-shadow: none;\n        color: $white;\n\n        i{\n          color: $white;\n        }\n\n        & + div .nav .active a{\n\n          box-shadow: none;\n          .sidebar-mini-icon, .sidebar-normal{\n            color: $white;\n            font-weight: $font-weight-normal;\n          }\n\n          &:before{\n            content: \" \";\n            position: absolute;\n            height: 6px;\n            width: 6px;\n            top: 17px;\n            left: -4px;\n            background: $white;\n            border-radius: 50%;\n          }\n        }\n        &:before{\n          content: \" \";\n          position: absolute;\n          height: 6px;\n          width: 6px;\n          top: 22px;\n          left: -4px;\n          background: rgba($white,0.6);\n          border-radius: 50%;\n        }\n      }\n    }\n\n    p{\n      margin: 0;\n      line-height: 30px;\n      position: relative;\n      display: block;\n      height: auto;\n      white-space: nowrap;\n      @extend .animation-transition-general;\n    }\n\n    i{\n      font-size: 20px;\n      float: left;\n      margin-right: 12px;\n      line-height: 30px;\n      width: 34px;\n      text-align: center;\n      color: $opacity-8;\n      position: relative;\n    }\n  }\n\n  .logo{\n    position: relative;\n    padding: $padding-base-vertical $padding-base-horizontal;\n    z-index: 4;\n\n    a.logo-mini,\n    a.logo-normal{\n      @extend .animation-transition-general;\n    }\n\n    a.logo-mini{\n      opacity: 1;\n      float: left;\n      width: 34px;\n      text-align: center;\n      margin-left: 12px;\n      margin-right: 12px;\n      img {\n        border-radius: 10%;\n        width: 30px;\n      }\n    }\n\n    a.logo-normal{\n      display: block;\n      opacity: 1;\n      @include transform-translate-x(0px);\n    }\n\n    &:after{\n      content: '';\n      position: absolute;\n      bottom: 0;\n      right: 15px;\n      height: 1px;\n      width: calc(100% - 30px);\n      background: $opacity-5;\n\n    }\n\n    p{\n      float: left;\n      font-size: 20px;\n      margin: 10px 10px;\n      color: $white;\n      line-height: 20px;\n      font-family: \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n    }\n\n    .simple-text{\n      text-transform: uppercase;\n      padding: $padding-base-vertical 0;\n      display: block;\n      white-space: nowrap;\n      // font-size: $font-size-base;\n      color: $white;\n      text-decoration: none;\n      font-weight: $font-weight-normal;\n      line-height: 30px;\n      overflow: hidden;\n    }\n  }\n\n  .logo-tim{\n    border-radius: 50%;\n    border: 1px solid #333;\n    display: block;\n    height: 61px;\n    width: 61px;\n    float: left;\n    overflow: hidden;\n\n    img{\n      width: 60px;\n      height: 60px;\n    }\n  }\n\n    &[data=\"black\"]{\n        @include linear-gradient($background-states-black, $background-black);\n    }\n\n    &[data=\"blue\"] {\n        @include linear-gradient($background-states-blue, $background-blue);\n    }\n\n    &[data=\"green\"] {\n        @include linear-gradient($background-states-green, $background-green);\n    }\n\n    &[data=\"red\"] {\n        @include linear-gradient($background-states-red, $background-red);\n    }\n\n    &[data=\"orange\"] {\n        @include linear-gradient($background-states-orange, $background-orange);\n    }\n\n    &[data=\"purple\"] {\n        @include linear-gradient($background-states-purple, $background-purple);\n    }\n\n    &[data=\"teal\"] {\n        @include linear-gradient($background-states-teal, $background-teal);\n    }\n\n    &[data=\"black\"] {\n        @include linear-gradient($background-states-black, $background-black);\n    }\n\n  .user{\n    padding-bottom: 20px;\n    margin:20px auto 0;\n    position: relative;\n\n    &:after{\n      content: '';\n      position: absolute;\n      bottom: 0;\n      right: 15px;\n      height: 1px;\n      width: calc(100% - 30px);\n      background: $opacity-5;\n    }\n\n    .photo{\n      width: 34px;\n      height: 34px;\n      overflow: hidden;\n      float: left;\n      z-index: 5;\n      margin-right: 10px;\n      border-radius: 50%;\n      margin-left: 23px;\n      box-shadow: $box-shadow-raised;\n      @extend .animation-transition-general;\n\n      img{\n        width: $full-width;\n      }\n    }\n\n    a{\n      color: $white;\n      text-decoration: none;\n      padding: $padding-base-vertical 15px;\n      white-space: nowrap;\n      @extend .animation-transition-general;\n    }\n\n    .info{\n      > a{\n        display: block;\n        line-height: 18px;\n\n        > span{\n          @extend .animation-transition-general;\n          display: block;\n          position: relative;\n          opacity: 1;\n        }\n      }\n\n      .caret{\n        position: absolute;\n        top: 8px;\n        right: 18px;\n      }\n    }\n  }\n\n  transition: 0.5s cubic-bezier(0.685, 0.0473, 0.346, 1);\n\n}\n\n\n.visible-on-sidebar-regular{\n  display: inline-block !important;\n}\n.visible-on-sidebar-mini{\n  display: none !important;\n}\n\n.off-canvas-sidebar{\n  .nav {\n    > li > a,\n    > li > a:hover{\n      color: $white;\n    }\n\n    > li > a:focus{\n      background: rgba(200, 200, 200, 0.2);\n    }\n  }\n}\n\n\n.main-panel {\n  position: relative;\n  float: right;\n  width: $full-width;\n  min-height: 100vh;\n  border-top: 2px solid $primary;\n  background: linear-gradient($background-black, $background-states-black);\n\n  @include transitions (0.50s, cubic-bezier(0.685, 0.0473, 0.346, 1));\n\n  &[data=\"blue\"]{\n    border-top: 2px solid $info;\n  }\n\n  &[data=\"green\"]{\n    border-top: 2px solid $success;\n  }\n\n  &[data=\"primary\"]{\n    border-top: 2px solid $primary;\n  }\n\n  > .content {\n    padding: 78px 30px 30px 280px;\n    min-height: calc(100vh - 70px);\n  }\n\n  > .navbar {\n    margin-bottom: 0;\n  }\n\n\n  .header {\n    margin-bottom: 50px;\n  }\n}\n\n\n.perfect-scrollbar-on{\n  .main-panel{\n    height: 100%;\n    max-height: 100%;\n  }\n}\n\n.sidebar,\n.main-panel,\n.sidebar-wrapper{\n  -webkit-overflow-scrolling: touch;\n}\n\n@media (min-width: 991px) {\n  .sidebar,\n  .main-panel,\n  .sidebar-wrapper{\n    -webkit-transition-property: top,bottom,width;\n    transition-property: top,bottom, width;\n    -webkit-transition-duration: .2s,.2s, .35s;\n    transition-duration: .2s,.2s, .35s;\n    -webkit-transition-timing-function: linear,linear,ease;\n    transition-timing-function: linear,linear,ease;\n  }\n\n  .sidebar-mini{\n    .visible-on-sidebar-regular{\n      display: none !important;\n    }\n    .visible-on-sidebar-mini{\n      display: inline-block !important;\n    }\n\n    .sidebar{\n      width: 80px;\n\n      .sidebar-wrapper{\n        width: 100% !important;\n      }\n    }\n\n\n    .sidebar{\n      display: block;\n      z-index: 1030;\n      box-shadow: $sidebar-box-shadow;\n\n      .logo{\n        a.logo-normal{\n          opacity: 0;\n          @include transform-translate-x(-25px);\n        }\n      }\n\n      .sidebar-wrapper{\n        > .nav [data-toggle=\"collapse\"] ~ div > ul > li > a .sidebar-normal,\n        .user .info [data-toggle=\"collapse\"] ~ div > ul > li > a .sidebar-normal,\n        .user .info > a > span,\n        > .nav li > a p{\n          @include transform-translate-x(-25px);\n          opacity: 0;\n        }\n      }\n\n      .nav [data-toggle=\"collapse\"] ~ div > ul > li > a .sidebar-mini-icon{\n        opacity: 1;\n      }\n    }\n\n    .sidebar:hover {\n      width: 260px;\n\n      .logo {\n        a.logo-normal {\n          opacity: 1;\n          @include transform-translate-x(0);\n        }\n\n      }\n\n      .navbar-minimize{\n        opacity: 1;\n      }\n      .sidebar-wrapper{\n        width: 260px;\n\n        > .nav li > a p,\n        > .nav [data-toggle=\"collapse\"] ~ div > ul > li > a .sidebar-normal,\n        .user .info [data-toggle=\"collapse\"] ~ div > ul > li > a .sidebar-normal,\n        .user .info > a > span{\n          @include transform-translate-x(0px);\n          opacity: 1;\n        }\n      }\n\n      .nav [data-toggle=\"collapse\"] ~ div > ul > li > a .sidebar-mini-icon{\n        opacity: 0;\n      }\n\n\n\n    }\n\n    .main-panel{\n      > .content{\n        padding-left: 130px;\n      }\n    }\n\n    footer{\n      padding-left: 130px;\n    }\n  }\n\n  .navbar-minimize{\n    button {\n      margin-left: 10px;\n      i{\n        color: $white;\n        font-size: 20px;\n      }\n    }\n  }\n\n}\n\n.panel-header {\n  height: 260px;\n  padding-top: 80px;\n  padding-bottom: 45px;\n  background: #141E30;  /* fallback for old browsers */\n  background: -webkit-gradient(linear, left top, right top, from(#0c2646), color-stop(60%, #204065), to(#2a5788));\n  background: linear-gradient(to right, #0c2646 0%, #204065 60%, #2a5788 100%);\n  position: relative;\n  overflow: hidden;\n\n  .header{\n    .title{\n      color: $white;\n    }\n    .category{\n      max-width: 600px;\n      color: $opacity-5;\n      margin: 0 auto;\n      font-size: 13px;\n\n      a{\n        color: $white;\n      }\n    }\n  }\n}\n\n.panel-header-sm{\n  height: 135px;\n}\n\n.panel-header-lg{\n  height: 380px\n}\n\n@media screen and (max-width: 991px){\n  .sidebar{\n    position: fixed;\n    display: block;\n    top: 0;\n    height: 100%;\n    width: 260px;\n    right: auto;\n    left: 0;\n    margin: 0;\n    border-radius: 0;\n    z-index: 1032;\n    visibility: visible;\n    overflow-y: visible;\n    padding: 0;\n    @include transition(0.5s cubic-bezier(0.685, 0.0473, 0.346, 1));\n    @include transform-translate-x(-260px);\n  }\n\n  .wrapper{\n    @include transition (0.50s, cubic-bezier(0.685, 0.0473, 0.346, 1));\n  }\n\n  .main-panel {\n    width: 100%;\n    .content {\n      padding-left: 30px;\n    }\n  }\n\n  .nav-open{\n    .main-panel{\n      right: 0;\n      @include transform-translate-x(260px);\n    }\n\n    .sidebar{\n\n      @include transition(0.5s cubic-bezier(0.685, 0.0473, 0.346, 1));\n      @include transform-translate-x(0px);\n      &:before{\n        content: unset;\n      }\n    }\n\n    body{\n      position: relative;\n      overflow-x: hidden;\n    }\n\n    .menu-on-right{\n\n      .main-panel{\n        @include transform-translate-x(-260px);\n      }\n\n      .navbar-collapse,\n      .sidebar{\n        @include transform-translate-x(0px);\n      }\n\n      #bodyClick{\n        right: 260px;\n        left: auto;\n      }\n    }\n    .fixed-plugin {\n      display: none;\n    }\n  }\n\n  .menu-on-right{\n    .sidebar{\n      left: auto;\n      right: 0;\n      @include transform-translate-x(260px);\n    }\n  }\n\n  #bodyClick{\n    height: 100%;\n    width: 100%;\n    position: fixed;\n    opacity: 1;\n    top: 0;\n    right: 0;\n    left: 260px;\n    content: \"\";\n    z-index: 9999;\n    overflow-x: hidden;\n    background-color: transparent;\n    @include transition (0.50s, cubic-bezier(0.685, 0.0473, 0.346, 1));\n  }\n  .navbar .dropdown-menu{\n    position: static !important;\n  }\n\n}\n\n@media screen and (max-width: 768px){\n\n  .main-panel .content {\n    padding-left: 15px;\n    padding-right: 15px;\n  }\n\n}\n","\n/* Animations */\n.nav-pills .nav-link,\n.navbar,\n.nav-tabs .nav-link,\n.sidebar .nav a,\n.sidebar .nav a i,\n.sidebar .nav p,\n.navbar-collapse .navbar-nav .nav-link,\n.animation-transition-general,\n.tag,\n.tag [data-role=\"remove\"],\n.animation-transition-general{\n    @include transitions($general-transition-time, $transition-ease);\n}\n\n//transition for dropdown caret\n.bootstrap-switch-label:before,\n.caret{\n    @include transitions($fast-transition-time, $transition-ease);\n}\n\n.dropdown-toggle[aria-expanded=\"true\"]:after,\na[data-toggle=\"collapse\"][aria-expanded=\"true\"] .caret,\n.card-collapse .card a[data-toggle=\"collapse\"][aria-expanded=\"true\"] i,\n.card-collapse .card a[data-toggle=\"collapse\"].expanded i{\n    @include rotate-180();\n}\n\n.caret{\n  width: 0;\n  height: 0;\n  vertical-align: middle;\n  border-top: 4px dashed;\n  border-right: 4px solid transparent;\n  border-left: 4px solid transparent;\n  margin-top: -5px;\n  position: absolute;\n  top: 30px;\n  margin-left: 5px;\n}\n\n.pull-left{\n  float: left;\n}\n.pull-right{\n  float: right;\n}\n\n\n// card user profile page\n\n.card {\n  form {\n    label + .form-control {\n      margin-bottom: 20px;\n    }\n  }\n}\n\n.card {\n  .map-title {\n    color: $white;\n  }\n\n  &.card-chart {\n    .gmnoprint,\n    .gm-style-cc {\n      display: none !important;\n    }\n  }\n}\n\n// documentation\n\n.bd-docs {\n\n  h1,h2,h3,h4,h5,h6,p,ul li,ol li{\n    color:#2c2c2c;\n  }\n\n\n  .bd-content>table>thead>tr>th {\n    color: $black;\n\n  }\n\n  .blockquote, .blockquote p, .card p{\n    color: rgba($white,0.8);\n  }\n  .bd-example {\n    background: linear-gradient(#1e1e2f,#1e1e24);\n\n  }\n\n  .navbar {\n    border-top: none;\n\n    .navbar-nav .nav-link {\n      color: rgba(255,255,255,.8) !important;\n    }\n  }\n\n  .bd-example {\n\n    .btn{\n      margin: 4px 0;\n    }\n    .btn .badge {\n      display: inline-block;\n    }\n\n    .tim-icons{\n      color: $white;\n    }\n\n    .popover .popover-header {\n    color: hsla(0,0%,71%,.6);\n  }\n\n\n    .popover-body {\n      p {\n        color: $gray-900;\n      }\n    }\n\n    &.tooltip-demo p{\n      color: rgba($white,.8);\n    }\n  }\n\n  .card.card-body,\n  .card .card-body {\n    color: hsla(0,0%,100%,.8);\n  }\n\n  label,\n  .form-check {\n    color: hsla(0,0%,100%,.8);\n  }\n\n  .form-check + .btn {\n    margin-top: 20px;\n  }\n\n  .bd-example,\n  table {\n    thead th {\n      color: hsla(0,0%,100%,.8);\n    }\n\n    h1, h2, h3, h4, h5, h6,\n    .h1, .h2, .h3, .h4, .h5, .h6 {\n      color: hsla(0,0%,100%,.8);\n    }\n\n    .datepicker{\n      thead th, table thead th,.tim-icons{\n        color: $primary;\n      }\n\n    }\n\n    .picker-switch .tim-icons{\n      color: $primary;\n    }\n  }\n\n  .footer {\n    .container-fluid > nav {\n      display: inline-block;\n    }\n  }\n}\n.modal.show .modal-dialog {\n  -webkit-transform: translate(0,30%);\n  transform: translate(0,30%);\n}\n\ncode {\n  color: $pink;\n}\n\n@media screen and (max-width: 991px){\n    .profile-photo .profile-photo-small{\n        margin-left: -2px;\n    }\n\n    .button-dropdown{\n        display: none;\n    }\n\n    #searchModal .modal-dialog{\n      margin: 20px;\n    }\n\n    #minimizeSidebar{\n        display: none;\n    }\n\n}\n\n\n@media screen and (max-width: 768px){\n\n    .landing-page .section-story-overview .image-container:nth-child(2){\n        margin-left: 0;\n        margin-bottom: 30px;\n    }\n\n}\n\n@media screen and (max-width: 576px){\n    .page-header{\n        .container h6.category-absolute{\n            width: 90%;\n        }\n    }\n\n    .form-horizontal .col-form-label, .form-horizontal .label-on-right{\n      text-align: inherit;\n      padding-top: 0;\n      code{\n        padding: 0 10px;\n      }\n    }\n\n}\n",".rtl {\n  .sidebar,\n  .bootstrap-navbar{\n    right: 0;\n    left: auto;\n    margin-right: 20px;\n    margin-left: 0;\n\n    .nav{\n        i{\n          float: right;\n          margin-left: 15px;\n          margin-right: 0;\n        }\n\n        p{\n          margin-right: 45px;\n          text-align: right;\n        }\n\n        .caret{\n          left: 11px;\n          right: auto;\n        }\n    }\n\n    .logo{\n        a.logo-mini{\n          float: right;\n          margin-right: 20px;\n          margin-left: 10px;\n        }\n\n        .simple-text{\n          text-align: right;\n        }\n    }\n\n    .sidebar-wrapper .nav [data-toggle=\"collapse\"] ~ div > ul > li > a .sidebar-mini-icon,\n    .sidebar-wrapper .user .info [data-toggle=\"collapse\"] ~ div > ul > li > a .sidebar-mini-icon{\n      float: right;\n      margin-left: 15px;\n      margin-right: 0;\n    }\n\n    .sidebar-wrapper > .nav [data-toggle=\"collapse\"] ~ div > ul > li > a .sidebar-normal,\n    .sidebar-wrapper .user .info [data-toggle=\"collapse\"] ~ div > ul > li > a .sidebar-normal{\n      text-align: right;\n    }\n\n    &:before{\n      right: 30px;\n      left: auto;\n    }\n  }\n\n  .main-panel .content{\n    padding: 80px 280px 30px 30px;\n  }\n\n  .footer{\n    padding: 24px 300px 24px 0;\n  }\n\n  .dropdown-toggle:after{\n    margin-right: .255em;\n    margin-left: 0;\n  }\n\n  .dropdown-menu.dropdown-menu-right.dropdown-navbar{\n    right: -220px !important;\n    left: auto;\n\n    &:before{\n      right: auto;\n      left: 35px;\n    }\n  }\n\n  .notification{\n    left: 40px;\n    right: auto;\n  }\n\n  .dropdown-menu{\n    right: auto;\n    left: 0;\n  }\n\n\n  .minimize-sidebar{\n    float: right;\n  }\n\n  .alert{\n    left: 0;\n    margin-left: 0;\n    margin-right: 0;\n      button.close{\n        left: 10px !important;\n        right: auto !important;\n      }\n\n      span[data-notify=\"icon\"]{\n        right: 15px;\n        left: auto;\n      }\n\n\n\n      &.alert-with-icon{\n        padding-right: 65px;\n        padding-left: 15px;\n      }\n\n      &.alert-with-icon i[data-notify=\"icon\"]{\n        right: 15px;\n        left: auto;\n      }\n  }\n\n  .search-bar{\n    margin-left: 0;\n  }\n\n  .modal-search .modal-header .close{\n    margin-right: auto;\n    left: 10px;\n  }\n\n\n  @media (min-width: 991px){\n    &.sidebar-mini .main-panel .content {\n      padding-right: 130px;\n      padding-left: 50px;\n    }\n\n    &.sidebar-mini footer{\n      padding-right: 130px;\n      padding-left: 50px;\n    }\n\n    .navbar-minimize button{\n      margin-right: -5px;\n    }\n  }\n\n\n\n  @media screen and (max-width: 991px){\n\n    .sidebar{\n      margin-right: 0;\n    }\n    .main-panel .content{\n      padding-right: 50px;\n    }\n\n    #bodyClick{\n      right: 260px;\n      left: auto;\n    }\n\n    .footer{\n      padding-right: 15px;\n    }\n  }\n\n  .navbar {\n    .navbar-nav {\n      padding-right: 0;\n      a.nav-link {\n        text-align: right;\n        p{\n          margin-right: 7px;\n        }\n      }\n\n      .btn {\n        margin-right: 0;\n        padding: 0;\n        i{\n          margin-left: 4px;\n          margin-right: 5px;\n        }\n      }\n\n      .search-bar span{\n        margin-right: 10px;\n      }\n    }\n  }\n\n  .ps__rail-y {\n    right: auto !important;\n    left: 0;\n  }\n\n  .main-panel {\n    position: fixed;\n    height: 100%;\n    overflow-y: scroll;\n    overflow-x: hidden;\n  }\n  .fixed-plugin {\n    border-radius: 0 8px 8px 0;\n    left: 0;\n    right: unset;\n    .dropdown-menu {\n      left: 80px !important;\n      right: auto !important;\n      &:before,&:after {\n        left: 10px;\n        margin-right: auto;\n        right: auto;\n      }\n      &:before {\n        right: unset;\n        left: -16px;\n        border-left: unset;\n        border-right: .4em solid rgba(0,0,0,.2);\n      }\n      &:after {\n        right: unset;\n        left: -16px;\n        border-left: unset;\n        border-right: .4em solid $black;\n      }\n    }\n  }\n  .sidebar .nav li.active > a:not([data-toggle=\"collapse\"]):before, .off-canvas-sidebar .nav li.active > a:not([data-toggle=\"collapse\"]):before{\n    left: unset;\n    right: -4px;\n  }\n}\n\n\n@media screen and (max-width: 768px){\n\n  .rtl .main-panel .content{\n    padding-left: 15px;\n    padding-right: 15px;\n  }\n\n}\n",".form-group.has-danger .error,\n.input-group.has-danger .error {\n  color: $danger-states;\n}\n\n\n.form-group.has-success .error,\n.input-group.has-success .error {\n  color: $success;\n}\n\n@include form-control-lg-padding($padding-lg-vertical, $padding-input-horizontal);\n@include input-base-padding($padding-input-vertical, $padding-input-horizontal);\n\n.form-group.no-border,\n.input-group.no-border{\n    .form-control,\n    .form-control + .input-group-prepend .input-group-text,\n    .form-control + .input-group-append .input-group-text{\n\n        background-color: lighten($black,1%);\n        border: medium none;\n        &:focus,\n        &:active,\n        &:active{\n            border: medium none;\n            background-color: lighten($black,2%);\n        }\n    }\n\n    .form-control{\n        &:focus{\n            & + .input-group-prepend .input-group-text,\n            & + .input-group-append .input-group-text{\n                background-color: lighten($black,2%);\n            }\n        }\n    }\n\n    .input-group-prepend .input-group-text,\n    .input-group-append .input-group-text{\n        background-color: lighten($black,1%);;\n        border: none;\n    }\n}\n\n.has-error{\n    .form-control-feedback, .control-label{\n        color: $danger-states;\n    }\n}\n.has-success{\n    .form-control-feedback, .control-label{\n        color: $success;\n    }\n}\n\n.input-group-append .input-group-text,\n.input-group-prepend .input-group-text {\n    background-color: transparent;\n    border: 1px solid lighten($black,5%);\n    border-radius: $border-radius-lg;\n    color: $white;\n\n    & i{\n      opacity: .5;\n    }\n\n    @include transition-input-focus-color();\n\n    .has-danger.input-group-focus &{\n        background-color: $transparent-bg;\n    }\n\n    .has-success &{\n        background-color: $transparent-bg;\n    }\n    .has-danger .form-control:focus + &{\n        color: $danger-states;\n    }\n    .has-success .form-control:focus + &{\n        color: $success;\n    }\n\n    & + .form-control,\n    & ~ .form-control{\n        @include input-size($padding-base-vertical - 1, $padding-base-horizontal);\n        padding-left: 18px;\n    }\n\n    i{\n        width: 17px;\n    }\n}\n\n.input-group-append,\n.input-group-prepend .input-group-text,\n.input-group-prepend .input-group-text {\n    background-color: transparent;\n    border: 1px solid lighten($black,5%);\n    border-radius: $border-radius-lg;\n    color: $white;\n    margin: 0;\n}\n\n.input-group-append .input-group-text{\n  border-left: none;\n}\n.input-group-prepend .input-group-text{\n  border-right: none;\n}\n\n.input-group-focus{\n    .input-group-prepend .input-group-text,\n    .input-group-append .input-group-text{\n        background-color: $white;\n        border-color: $primary;\n        background-color: $transparent-bg;\n        border-color: $primary;\n    }\n\n    &.no-border{\n        .input-group-prepend .input-group-text,\n        .input-group-append .input-group-text{\n            background-color: lighten($black,2%);\n        }\n    }\n}\n\n.input-group,\n.form-group{\n    margin-bottom: 10px;\n    position: relative;\n\n    .form-control-static{\n        margin-top: 9px;\n    }\n}\n\n.input-group[disabled]{\n    .input-group-prepend .input-group-text,\n    .input-group-append .input-group-text{\n        background-color: $light-gray;\n    }\n}\n\n.input-group .form-control:not(:first-child):not(:last-child), .input-group-btn:not(:first-child):not(:last-child){\n    border-radius: $border-radius-lg;\n    border-top-left-radius: 0;\n    border-bottom-left-radius: 0;\n    border-left: 0 none;\n}\n\n.input-group .form-control:first-child,\n.input-group-btn:first-child > .dropdown-toggle,\n.input-group-btn:last-child > .btn:not(:last-child):not(.dropdown-toggle) {\n    border-right: 0 none;\n}\n.input-group .form-control:last-child,\n.input-group-btn:last-child > .dropdown-toggle,\n.input-group-btn:first-child > .btn:not(:first-child) {\n    border-left: 0 none;\n}\n.form-control[disabled], .form-control[readonly], fieldset[disabled] .form-control {\n    background-color: $black-states;\n    color: $default;\n    cursor: not-allowed;\n}\n\n.input-group-btn .btn{\n    border-width: $border-thin;\n    padding: $padding-btn-vertical  $padding-base-horizontal;\n}\n.input-group-btn .btn-default:not(.btn-fill){\n    border-color: $medium-gray;\n}\n\n.input-group-btn:last-child > .btn{\n    margin-left: 0;\n}\n\ntextarea.form-control{\n    max-width: 100%;\n    max-height: 80px;\n    padding: 10px 10px 0 0;\n    resize: none;\n    line-height: 2;\n}\n\n.has-success,\n.has-danger{\n\n    &.form-group .form-control,\n    &.form-group.no-border .form-control{\n        padding-right: $input-padding-horizontal + 21;\n    }\n}\n\n.form.form-newsletter .form-group{\n    float: left;\n    width: 78%;\n    margin-right: 2%;\n    margin-top: 9px;\n}\n\n.input-group .input-group-btn{\n    padding: 0 12px;\n}\n\n// Input files - hide actual input - requires specific markup in the sample.\n.form-group input[type=file] {\n  opacity: 0;\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  z-index: 100;\n}\n\n.form-text{\n    font-size: $font-size-sm;\n    color: rgba($white,0.8);\n}\n\n.form-control-lg{\n    padding: 0;\n    font-size: inherit;\n    line-height: 0;\n    border-radius: 0;\n\n    .form-control {\n      height: calc(2.875rem + 2px);\n    }\n}\n\n.form-horizontal{\n    .col-form-label,\n    .label-on-right{\n        padding: 10px 5px 0 15px;\n        text-align: right;\n        max-width: 180px;\n    }\n\n    .checkbox-radios{\n        margin-bottom: 15px;\n\n        .form-check:first-child{\n           margin-top: 8px;\n       }\n    }\n\n    .label-on-right{\n        text-align: left;\n        padding: 10px 15px 0 5px;\n    }\n\n    .form-check-inline{\n        margin-top: 6px;\n        .form-check-label{\n          margin-right: 1.5rem;\n        }\n    }\n}\n\n.search-bar{\n    margin-left: $margin-lg-vertical;\n      .btn{\n        margin: 0;\n      }\n       &.input-group{\n           border-radius: 25px;\n           z-index: 4;\n           margin-bottom: 0;\n           height: 43px;\n           padding-right: 5px;\n           .input-group-addon{\n              padding: 10px;\n               background: transparent;\n               border: none;\n               color: rgba(255, 255, 255, 0.7);\n\n           }\n\n           i{\n               font-size: 20px;\n               color: $white;\n               margin-top: 0 !important;\n           }\n           input{\n               background: transparent;\n               border:none !important;\n               border-radius: 0;\n               padding: 12px !important;\n               font-size: 12px;\n               opacity: 0.5;\n               &:focus{\n                   background: transparent;\n               }\n           }\n           .form-control{\n               opacity: 1;\n               color: $white;\n               &::placeholder{\n                 color: white;\n               }\n           }\n       }\n   }\n\n   .modal-search .modal-dialog{\n     max-width: 1000px;\n     margin: 20px auto;\n     .form-control{\n       border: none;\n       color: $black;\n       &::placeholder{\n         color: $black;\n       }\n     }\n   }\n\n.input-group-prepend{\n  margin-right: 0;\n}\n.input-group-prepend,\n.input-group-append {\n  .tim-icons {\n    font-size: $font-paragraph;\n  }\n}\n","/*\n * Container style\n */\n.ps {\n  overflow: hidden !important;\n  overflow-anchor: none;\n  -ms-overflow-style: none;\n  touch-action: auto;\n  -ms-touch-action: auto;\n}\n\n/*\n * Scrollbar rail styles\n */\n.ps__rail-x {\n  display: none;\n  opacity: 0;\n  transition: background-color .2s linear, opacity .2s linear;\n  -webkit-transition: background-color .2s linear, opacity .2s linear;\n  height: 15px;\n  /* there must be 'bottom' or 'top' for ps__rail-x */\n  bottom: 0px;\n  /* please don't change 'position' */\n  position: absolute;\n}\n\n.ps__rail-y {\n  display: none;\n  opacity: 0;\n  transition: background-color .2s linear, opacity .2s linear;\n  -webkit-transition: background-color .2s linear, opacity .2s linear;\n  width: 15px;\n  /* there must be 'right' or 'left' for ps__rail-y */\n  right: 0;\n  /* please don't change 'position' */\n  position: absolute;\n}\n\n.ps--active-x > .ps__rail-x,\n.ps--active-y > .ps__rail-y {\n  display: block;\n  background-color: transparent;\n}\n\n.ps:hover > .ps__rail-x,\n.ps:hover > .ps__rail-y,\n.ps--focus > .ps__rail-x,\n.ps--focus > .ps__rail-y,\n.ps--scrolling-x > .ps__rail-x,\n.ps--scrolling-y > .ps__rail-y {\n  opacity: 0.6;\n}\n\n.ps .ps__rail-x:hover,\n.ps .ps__rail-y:hover,\n.ps .ps__rail-x:focus,\n.ps .ps__rail-y:focus,\n.ps .ps__rail-x.ps--clicking,\n.ps .ps__rail-y.ps--clicking {\n  background-color: #eee;\n  opacity: 0.9;\n}\n\n/*\n * Scrollbar thumb styles\n */\n.ps__thumb-x {\n  background-color: #aaa;\n  border-radius: 6px;\n  transition: background-color .2s linear, height .2s ease-in-out;\n  -webkit-transition: background-color .2s linear, height .2s ease-in-out;\n  height: 6px;\n  /* there must be 'bottom' for ps__thumb-x */\n  bottom: 2px;\n  /* please don't change 'position' */\n  position: absolute;\n}\n\n.ps__thumb-y {\n  background-color: #aaa;\n  border-radius: 6px;\n  transition: background-color .2s linear, width .2s ease-in-out;\n  -webkit-transition: background-color .2s linear, width .2s ease-in-out;\n  width: 6px;\n  /* there must be 'right' for ps__thumb-y */\n  right: 2px;\n  /* please don't change 'position' */\n  position: absolute;\n}\n\n.ps__rail-x:hover > .ps__thumb-x,\n.ps__rail-x:focus > .ps__thumb-x,\n.ps__rail-x.ps--clicking .ps__thumb-x {\n  background-color: #999;\n  height: 11px;\n}\n\n.ps__rail-y:hover > .ps__thumb-y,\n.ps__rail-y:focus > .ps__thumb-y,\n.ps__rail-y.ps--clicking .ps__thumb-y {\n  background-color: #999;\n  width: 11px;\n}\n\n/* MS supports */\n@supports (-ms-overflow-style: none) {\n  .ps {\n    overflow: auto !important;\n  }\n}\n\n@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {\n  .ps {\n    overflow: auto !important;\n  }\n}\n",".react-notification-alert-container{\n  z-index: 1051;\n  position: fixed;\n}\n",".white-content{\n\n  background: $light-bg;\n\n  .navbar.navbar-transparent .navbar-brand{\n    color: $black-states;\n  }\n\n  .navbar.navbar-transparent .navbar-toggler-bar{\n    background: $black-states;\n  }\n  .navbar.navbar-transparent .navbar-nav li a:not(.dropdown-item){\n      color: $black-states;\n      & i{\n        color: $black-states;\n      }\n  }\n\n  .navbar.navbar-transparent .navbar-minimize button i{\n    color: $black-states;\n  }\n\n  .navbar.navbar-transparent .search-bar.input-group i{\n    color: $black-states;\n  }\n  .navbar.navbar-transparent .search-bar.input-group .form-control{\n    color: $default;\n    &::placeholder{\n      color: $dark-gray;\n    }\n  }\n\n  .sidebar{\n    box-shadow: 0 2px 22px 0 rgba(0,0,0,.1), 0 4px 20px 0 rgba(0,0,0,.15);\n    p{\n      color: $opacity-8;\n    }\n  }\n\n  .main-panel{\n    background: $light-bg;\n  }\n\n  h1, h2, h3, h4, h5, h6, p, ol li, ul li, pre {\n    color: $black-states;\n  }\n\n  .font-icon-detail i{\n    color: $black;\n  }\n\n  .btn:not([data-action]):hover{\n    box-shadow:  0 4px 6px rgba(50,50,93,.11), 0 1px 3px rgba(0,0,0,.08);\n  }\n\n  .btn-neutral.btn-link{\n    color: rgba($black, 0.7);\n  }\n\n  //style for inputs\n\n  @include form-control-placeholder(rgba($black,0.4), 1);\n    .has-danger{\n      .form-control, .input-group-prepend .input-group-text{\n        border-color: $danger-states;\n      }\n    }\n\n    .input-group-prepend .input-group-text{\n      border-color: rgba($black-states,0.5);\n      color: $black-states;\n    }\n\n    .form-control{\n      color: $black;\n      border-color: rgba($black-states,0.5);\n      &:focus{\n        border-color: $primary;\n      }\n    }\n\n  .form-group.no-border,\n  .input-group.no-border{\n      .form-control,\n      .form-control + .input-group-prepend .input-group-text,\n      .form-control + .input-group-append .input-group-text,\n      .input-group-prepend .input-group-text,\n      .input-group-append .input-group-text{\n          background-color: $opacity-gray-3;\n          &:focus,\n          &:active,\n          &:active{\n              background-color: $opacity-gray-5;\n          }\n      }\n\n      .form-control{\n          &:focus{\n              & + .input-group-prepend .input-group-text,\n              & + .input-group-append .input-group-text{\n\n                  background-color: $transparent-bg;\n              }\n          }\n      }\n\n\n  }\n\n  .input-group[disabled]{\n      .input-group-prepend .input-group-text,\n      .input-group-append .input-group-text{\n          background-color: $black;\n      }\n  }\n\n  .form-control[disabled], .form-control[readonly], fieldset[disabled] .form-control{\n    background: $light-gray;\n    border-color: rgba($black-states,0.3);\n  }\n\n  .input-group-focus{\n      .input-group-prepend .input-group-text,\n      .input-group-append .input-group-text,\n      .form-control{\n        border-color: $primary;\n      }\n\n      &.no-border{\n          .input-group-prepend .input-group-text,\n          .input-group-append .input-group-text{\n\n              background-color: $opacity-gray-5;\n          }\n      }\n  }\n  .input-group-prepend .input-group-text {\n      border-right: none;\n  }\n\n  .input-group-append .input-group-text {\n      border-left: none;\n  }\n\n  .has-danger .form-control:focus, .has-success.input-group-focus .input-group-append .input-group-text, .has-success.input-group-focus .input-group-prepend .input-group-text {\n    border-color: $danger-states;\n  }\n\n  .has-success .form-control:focus, .has-success.input-group-focus .input-group-append .input-group-text, .has-success.input-group-focus .input-group-prepend .input-group-text {\n    border-color: darken($success, 10%);\n  }\n\n  .btn.btn-link{\n    &:hover,&:active, &:focus{\n      color: $dark-gray !important;\n    }\n  }\n\n  .btn-group .btn.active{\n    box-shadow: 0 4px 6px rgba(50,50,93,.11), 0 1px 3px rgba(0,0,0,.08);\n  }\n\n  .card:not(.card-white){\n    background: $white;\n    box-shadow: 0 1px 15px 0 rgba(123, 123, 123, 0.05);\n    .card-header{\n      color: $black;\n      a[data-toggle=\"collapse\"]{\n        color: $black;\n      }\n    }\n    .card-header .card-title, .card-body .card-title{\n      color: $black-states;\n    }\n\n    .card-body{\n      .card-category, .card-description{\n        color: $black-states;\n      }\n    }\n\n\n    label:not(.btn){\n      color: $default;\n    }\n\n\n     &.nav-pills .nav-item .nav-link {\n        color: $nav-gray;\n        background-color: hsla(0,0%,87%,.3);\n        &:not(.active):hover{\n          background: hsla(0,0%,87%,.5);\n        }\n        &.active{\n          color: $white;\n\n        }\n    }\n\n    .tab-content .tab-pane {\n        color: $nav-gray;\n    }\n\n\n    .card{\n      box-shadow: none;\n    }\n\n    &.card-plain{\n      background: $transparent-bg;\n      box-shadow: none;\n    }\n\n    &.card-tasks{\n      .card-body{\n        i{\n          color: rgba(34,42,66,0.7);\n          &:hover{\n            color: $black;\n          }\n        }\n      }\n    }\n  }\n\n  .table{\n\n      > tbody > tr > td {\n        color: rgba($black, 0.7) !important;\n\n    }\n\n    > thead > tr > th,\n    > tbody > tr > th,\n    > tfoot > tr > th,\n    > thead > tr > td,\n    > tbody > tr > td,\n    > tfoot > tr > td{\n        border-color: rgba($black, 0.2);\n        padding: 12px 7px;\n        vertical-align: middle;\n    }\n\n    > thead > tr > th, button.btn-neutral.btn-link{\n      color: rgba($black, 0.7);\n    }\n  }\n\n  .footer ul li a{\n    color: $black-states;\n  }\n\n  .footer .copyright{\n    color: $black-states;\n  }\n\n  .progress-container, .progress-container.progress.sm{\n      .progress{\n        background: rgba($black,0.1);\n        box-shadow: 0 0 0 3px rgba($black,0.1);\n        .progress-value{\n          color: $default;\n        }\n      }\n\n      .progress-badge{\n        color: $black-states;\n      }\n  }\n\n   .full-page{\n     background: $light-bg;\n\n     h1, h2, h3, h4, h5, h6, p, ol li, ul li, pre {\n       color: $black-states;\n     }\n\n     .description{\n       color: $dark-gray;\n     }\n\n     .footer ul li a{\n       color: $black-states;\n     }\n\n     .footer .copyright{\n       color: $black-states;\n     }\n   }\n\n   .nav-pills .nav-item .nav-link:not(.active){\n     background: darken($light-bg,10%);\n     color: $black-states;\n     &:hover{\n       background: darken($white,20%);\n\n     }\n   }\n}\n",".card{\n    background: $card-black-background;\n    border: 0;\n    position: relative;\n    margin-bottom: 30px;\n    box-shadow: $box-shadow;\n\n\n    label{\n      color: rgba($white, 0.6);\n    }\n\n    .card-title {\n      margin-bottom: .75rem;\n    }\n\n    .card-body{\n      padding: 15px;\n\n      &.table-full-width{\n        padding-left: 0;\n        padding-right: 0;\n      }\n\n      .card-title{\n        color: $white;\n        text-transform: inherit;\n        font-weight: $font-weight-light;\n        margin-bottom: .75rem;\n      }\n\n      .card-description, .card-category{\n        color: rgba($white, 0.6);\n      }\n\n    }\n\n    .card-header{\n      &:not([data-background-color]){\n        background-color: transparent;\n      }\n      padding: 15px 15px 0;\n      border: 0;\n      color: rgba($white,0.8);\n\n      .card-title{\n          color: $white;\n          font-weight: 100;\n      }\n\n      .card-category{\n        color: $dark-gray;\n        margin-bottom: 5px;\n        font-weight: 300;\n      }\n    }\n\n    .map{\n        border-radius: $border-radius-sm;\n\n        &.map-big{\n          height: 420px;\n        }\n    }\n\n    &.card-white{\n      background: $white;\n\n      .card-title{\n        color: $black;\n      }\n      .card-category, .stats{\n        color: $card-stats-gray;\n      }\n\n      //style for inputs\n\n      @include form-control-placeholder(rgba($black,0.4), 1);\n        .has-danger{\n          .form-control, .input-group-prepend .input-group-text{\n            border-color: $danger-states;\n          }\n        }\n\n        .input-group-prepend .input-group-text{\n          border-color: rgba($black-states,0.2);\n          color: $black-states;\n        }\n\n        .form-control{\n          color: $black;\n          border-color: rgba($black-states,0.2);\n          &:focus{\n            border-color: $primary;\n          }\n        }\n        label:not(.btn){\n          color: $default;\n        }\n\n      .form-group.no-border,\n      .input-group.no-border {\n          .form-control,\n          .form-control + .input-group-prepend .input-group-text,\n          .form-control + .input-group-append .input-group-text,\n          .input-group-prepend .input-group-text,\n          .input-group-append .input-group-text{\n            background-color: $opacity-gray-3;\n              &:focus,\n              &:active,\n              &:active{\n                background-color: $opacity-gray-5;\n              }\n          }\n\n          .form-control {\n              &:focus {\n                  & + .input-group-prepend .input-group-text,\n                  & + .input-group-append .input-group-text{\n                    background-color: $transparent-bg;\n                  }\n              }\n          }\n\n\n      }\n\n      .input-group[disabled]{\n          .input-group-prepend .input-group-text,\n          .input-group-append .input-group-text{\n              background-color: $black;\n          }\n      }\n\n      .form-control[disabled], .form-control[readonly], fieldset[disabled] .form-control{\n        background: $light-gray;\n        border-color: rgba($black-states,0.3);\n      }\n\n      .input-group-focus{\n          .input-group-prepend .input-group-text,\n          .input-group-append .input-group-text,\n          .form-control{\n            background-color: $white;\n            border-color: $primary;\n          }\n\n          &.no-border{\n              .input-group-prepend .input-group-text,\n              .input-group-append .input-group-text{\n\n                  background-color: $opacity-gray-5;\n              }\n          }\n      }\n      .input-group-prepend .input-group-text {\n          border-right: none;\n      }\n\n      .input-group-append .input-group-text {\n          border-left: none;\n      }\n\n      .has-danger .form-control:focus, .has-success.input-group-focus .input-group-append .input-group-text, .has-success.input-group-focus .input-group-prepend .input-group-text {\n        border-color: $danger-states;\n      }\n\n      .has-success .form-control:focus, .has-success.input-group-focus .input-group-append .input-group-text, .has-success.input-group-focus .input-group-prepend .input-group-text {\n        border-color: darken($success, 10%);\n      }\n    }\n\n\n    &.card-plain {\n      background: transparent;\n      box-shadow: none;\n    }\n\n    .image{\n        overflow: hidden;\n        height: 200px;\n        position: relative;\n    }\n\n    .avatar{\n        width: 30px;\n        height: 30px;\n        overflow: hidden;\n        border-radius: 50%;\n        margin-bottom: 15px;\n    }\n\n    label{\n        font-size: $font-size-sm;\n        margin-bottom: 5px;\n\n    }\n\n    .card-footer{\n        background-color: transparent;\n        border: 0;\n        padding: 15px;\n\n\n        .stats{\n            i{\n                margin-right: 5px;\n                position: relative;\n\n            }\n        }\n\n        h6{\n          margin-bottom: 0;\n          padding: 7px 0;\n        }\n    }\n}\n\n.card-body{\n  padding: $card-spacer-y;\n}\n\n@include media-breakpoint-down(sm) {\n  .card.card-chart .card-header {\n    .btn-group-toggle .tim-icons {\n      font-size: .875rem;\n      top: -1px;\n    }\n  }\n}\n",".card-chart {\n  overflow: hidden;\n  .card-header{\n    .card-title{\n      i{\n        font-size: 16px;\n        margin-right: 5px;\n        margin-bottom: 3px;\n      }\n    }\n    .card-category{\n      margin-bottom: 5px;\n    }\n  }\n    .card-body{\n      padding-left: 5px;\n      padding-right: 5px;\n      .tab-space{\n        padding: 0;\n      }\n    }\n  .table{\n    margin-bottom: 0;\n\n    td{\n      border-top: none;\n      border-bottom: 1px solid rgba($white,0.1);\n    }\n  }\n\n  .card-progress {\n    margin-top: 30px;\n    padding: 0 10px;\n  }\n\n  .chart-area {\n    height: 220px;\n    width: 100%;\n  }\n  .card-footer {\n    margin-top: 15px;\n\n    .stats{\n      color: $dark-gray;\n    }\n  }\n\n  .dropdown{\n    position: absolute;\n    right: 20px;\n    top: 20px;\n\n    .btn{\n      margin: 0;\n    }\n  }\n\n  &.card-chart-pie{\n    .chart-area{\n      padding: 10px 0 25px;\n      height: auto;\n    }\n\n    .card-title{\n      margin-bottom: 10px;\n      i{\n        font-size: 1rem;\n      }\n    }\n\n  }\n\n}\n",".map {\n  height: 500px;\n}\n",".card-user {\n  overflow: hidden;\n    .image {\n        height: 120px;\n    }\n\n    .author {\n        text-align: center;\n        text-transform: none;\n        margin-top: 25px;\n\n        a +  p.description {\n            margin-top: -7px;\n        }\n\n        .block {\n          position: absolute;\n          height: 100px;\n          width: 250px;\n          &.block-one {\n            @include linear-gradient-right(rgba($primary,0.6), rgba($primary,0));\n            @include nc-rotate(150deg,10);\n            margin-top: -90px;\n            margin-left: -50px;\n          }\n\n          &.block-two {\n            @include linear-gradient-right(rgba($primary,0.6), rgba($primary,0));\n            @include nc-rotate(30deg,10);\n            margin-top: -40px;\n            margin-left: -100px;\n          }\n\n          &.block-three {\n            @include linear-gradient-right(rgba($primary,0.6), rgba($primary,0));\n            @include nc-rotate(170deg,10);\n            margin-top: -70px;\n            right: -45px;\n\n          }\n\n          &.block-four {\n            @include linear-gradient-right(rgba($primary,0.6), rgba($primary,0));\n            @include nc-rotate(150deg,10);\n            margin-top: -25px;\n            right: -45px;\n\n          }\n        }\n    }\n\n    .avatar {\n      width: 124px;\n      height: 124px;\n      border: 5px solid #0f5077;//lighten($black,5%);\n      border-bottom-color: $transparent-bg;\n      background-color: $transparent-bg;\n      position: relative;\n    }\n\n    .card-body {\n        min-height: 240px;\n    }\n\n    hr {\n        margin: 5px 15px;\n    }\n\n    .button-container {\n        margin-bottom: 6px;\n        text-align: center;\n    }\n\n    .card-description {\n      margin-top: 30px;\n    }\n}\n",".card-tasks {\n  height: 473px;\n\n  .table-full-width {\n    max-height: 380px;\n    position: relative;\n  }\n\n  .card-header {\n    .title {\n      margin-right: 20px;\n      font-weight: $font-weight-normal;\n    }\n\n    .dropdown {\n      float: right;\n      color: darken($white, 20%);\n    }\n  }\n\n  .card-body {\n    i {\n      color: $dark-gray;\n      font-size: 1.4em;\n      &:hover {\n        color: $white;\n      }\n    }\n  }\n}\n",".card-plain {\n  background: transparent;\n  box-shadow: none;\n\n  .card-header,\n  .card-footer {\n    margin-left: 0;\n    margin-right: 0;\n    background-color: transparent;\n  }\n\n  &:not(.card-subcategories).card-body {\n      padding-left: 0;\n      padding-right: 0;\n  }\n}\n","select.form-control option {\n   color: #888;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
